import { Modal } from 'bootstrap';
import { LoaderService } from 'src/app/loader.service';
import { error } from 'jquery';
import { AppComponent } from './../../app.component';
import { CommonPatternsService } from 'src/app/common-patterns.service';
import { floatWith2Decimals, groupBy, sumBy, adjustWith2DecimalsForUI } from "../../common-functions";

// import { AppComponent } from './../../app.component';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  NgZone,
  OnInit,
  Renderer2,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { AfterViewInit } from '@angular/core';
import * as Highcharts from 'highcharts';
import HighchartsMore from 'highcharts/highcharts-more';
import HighchartsSolidGauge from 'highcharts/modules/solid-gauge';
import {
  AbstractControl,
  FormGroup,
  FormControl,
  Validators,
  FormBuilder,
  MaxValidator,
} from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { ExcelService } from './../../services/excel.service';
import * as XLSX from 'xlsx';
import { DatePipe, DecimalPipe } from '@angular/common';
import { HeaderComponent } from './../../layouts/header/header.component';
import { EnableDisableDirective } from './../../Directives/enable-disable.directive';
import { ActivatedRoute, Router } from '@angular/router';

import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';

import { PaymentService } from '../../services/payment.service';
import { ReportsComponent } from './../../components/reports/reports.component';
import { PhoneFormatPipe } from '../../pipes/phone-format.pipe';
// import { error } from 'jquery';
import * as moment from 'moment';
import { ConfirmationDialogComponent } from '../../components/confirmation-dialog/confirmation-dialog.component';
import { postServiceWorkerMessage } from 'src/serviceworker/message';
import { WorkerMessageType } from 'src/serviceworker/service/events/message';
import { WorkerUrlPrefetchResult } from 'src/serviceworker/service/prefetch';
import { forkJoin, Observable, startWith, Subject, takeUntil } from 'rxjs';
import { Store } from '@ngrx/store';
import { loadCorporateData, loadCorporateDataSuccess } from 'src/app/state/actions/corporates.actions';
import { selectCorporateData, selectCorporateError, selectCorporateLoading } from 'src/app/state/selectors/corporates.selector';
import { loadLanguageData } from 'src/app/state/actions';
import { selectLanguageData } from 'src/app/state/selectors';
import { loadCorporateSignupConfigData } from 'src/app/state/actions/corporateSignupConfig.actions';
import { selectCorporateSignupConfigData } from 'src/app/state/selectors/corporateSignupConfig.selector';
import { CustomDatePipe } from 'src/app/pipes/customdate.pipe';

declare var $: any;
@Component({
  selector: 'app-gig-to-corp',
  templateUrl: './gig-to-corp.component.html',
  styleUrls: ['./gig-to-corp.component.css'],
  providers: [DatePipe, PhoneFormatPipe, CustomDatePipe, DecimalPipe]
})
export class GigToCorpComponent implements OnInit {
  @ViewChild(ReportsComponent) reportsComponent: ReportsComponent;
  dtOptions: DataTables.Settings = {};
  plansskumain: any[] = [];
  plandetailsobjvalue: any;
  optionstitle: any[] = [];
  optionmessage: any;
  dtTrigger: Subject<any> = new Subject<any>();
  adminName: any;
  role: any;
  isExecutiveCP: boolean;
  filteredEmployeeList: any = []
  serviceCount: any = 0;
  basicTiersCount: any = 1;
  AnnualCount: any = 0;
  adminData: any;
  lengthofstatus: any;
  defaultColor: any;
  applicationStatus: any;
  paidByCompany: Array<any> = [];
  allBrokers: Array<any> = [];
  coveredByCompany: Array<any> = [];
  paidByEmployee: Array<any> = [];
  bulkplans: Array<any> = [];
  payrolldeduction: Array<any> = [];
  uploadEmployeeExcelData: Array<any> = [];
  countryList: any;
  subdomainName: any;
  gigterminationRes: any;
  payrolldedcutionname: any;
  payrollOptions: any;
  planselectedId: any;
  plansDataarray: Array<any> = [];
  planRequestBody: any;
  selectedWalletConfig: any;
  plancheckCoverage: any = false;
  plancheck2Coverage: any = false;
  plancheck3Coverage: any = false;
  block1coverage: any = true;
  block2coverage: any = true;
  block3coverage: any = true;
  provisioning: boolean = false



  public coveredEmployeeShare: any = 0;
  public paidEmployeeShare: any = 0;
  public totalEmployeeShare: any = 0;
  public cartDisplayAmount: any = 0;
  public allPlansAmountTotal: any = 0;
  public allPlansTotal: any = 0;
  public allPlansTotaltax: any = 0;
  public allCPPlansAmountTotal: any = 0;
  public allCCPlansAmountTotal: any = 0;
  public allEPPlansAmountTotal: any = 0;
  public allCPTaxTotal: any = 0;
  public allCCTaxTotal: any = 0;
  public allEPTaxTotal: any = 0;
  public companyPaidTotal: any = 0;
  public companyCoveredTotal: any = 0;
  public paidEmployeedTotal: any = 0;
  public companyCoveredCompanyShareTotal: any = 0;
  public companyCoveredCompanySharePlanAmountTotal: any = 0;
  public companyCoveredCompanyShareTaxTotal: any = 0;
  public companyCoveredEmployeeShareTotal: any = 0;
  public companyCoveredEmployeeSharePlanAmountTotal: any = 0;
  public companyCoveredEmployeeShareTaxTotal: any = 0;
  public effectiveCompanyTotalContibution: any = 0;
  public effectiveEmployeeTotalContibution: any = 0;
  public effectiveCompanyPlansAmountTotal: any = 0;
  public effectiveCompanyTaxTotal: any = 0;

  employeeplancheck: any;
  empCount: any;
  elementid: any;
  block2execid: any;
  defaultAmount: any;
  checkmark = false;
  executiveid: any;
  selectionTiers: any;
  plansNewBlock1: any;
  tierConfigCheck: any;
  walletConfigCheck: any;
  customSelected = false;
  upgradeplanscheck: any;
  showtierbasicplans = false;
  showtieradvplans = false;
  hidementalplans: any = 222;
  hidewaddellplans: any = 222;
  showinputbox: any;
  showinputbox1: any;
  productobj: any;
  basicInfo = true;
  showsearchbox: boolean = true;
  isActive1: boolean = true;
  plansInfo = false;
  showaddadmin = false;
  addadminform = true;
  wallettierInfo = false;
  wallettierInfoandtier = false;
  EmployeeInfo = false;
  datagraphInfo = false;
  showdeletebutton = false;
  showemptywalletConfig = false;

  uploadlogoafter = false;
  nowalletnotierInfo = false;
  upgradeplansselection = false;
  upgradeplansselectiontiers = false;
  employeeplanpurchase = false;
  employeeplanpurchasetiers = false;
  voidcheckuploadafter = false;
  showconfigurebutton = true;

  showvoidcheck = true;
  showimagelogo = true;
  willDownload = false;
  bankDetails = false;
  showstatus = false;
  walletData: any;
  tierWalletConfig: any;
  TierData: any;
  public postalvalue: any;
  public invalidpostalcodeprivince: boolean = false;
  public invalidpostalcodeprivincewaddell: boolean = false;
  public CORP_PAYROLL_NOT_MANDATORY_PACKAGES: any = [2, 8, 9];
  public CORP_PAYROLL_NOT_MANDATORY_PLANLEVELS: any = [19, 20, 21, 23, 25, 26];
  statesInfo: any;
  plansres: any;
  planres2: any;
  plansBlock1: any;
  plansBlock1Tiers: any;
  packageIndex: any;
  imagedisplay: any;
  imagedisplayvoid: any;
  editindex: any;
  groupIndex: any;
  walletConfig: any;
  employeeplanpurchasetierscheck: any;
  upgradertierscheck: any;
  packageIndexblock2: any;
  groupIndexblock2: any;
  corporationclient: any;
  disabledColor: any;
  counter: any;
  selectedplansblock1: any;
  selectedplansblock2: any;
  selectedplansblock3: any;
  configureTierList: any;
  disallowedplans: any;
  disallowedplansTiers: any;
  voidcheckfile: any;
  uploadadminlogoimg: any;
  session: any;
  configprovinceres: any;
  configprovincereslist: any;
  enrollmentDates: any;
  provincialHealthcareUrl: any;
  provincialZipcodes: any;
  provincelistid: any;
  state_id: any;
  statename: any;
  corporateId: any;
  corporateClientId: any;
  maxEmployeeCount: any;
  lengthofemployee: any;
  editadminfirstname: any;
  editadminlastname: any;
  editadminphone: any;
  editadminemail: any;
  editadminrole: any = '';
  editEmployeeId: any;
  selectedPlansTierBlock1: any;
  selectedplansforTier: Array<any> = [];
  dummyAdminData: Array<any> = [];
  tierinfonames: Array<any> = [];
  addedEmployeelist: Array<any> = [];
  tierslist: Array<any> = [];
  finalTiersforGraph: Array<any> = [];
  TierlistforGrapsh: Array<any> = [];
  planssummarymain: Array<any> = [];
  planssummaryopt: Array<any> = [];
  planssummary: Array<any> = [];
  plansresblack2: Array<any> = [];
  plansresblack2Tiers: Array<any> = [];
  plansresblack2final: Array<any> = [];
  plansresblack3: Array<any> = [];
  Newplansresblack3: Array<any> = [];
  planssummary2: Array<any> = [];
  plansNewBlock2: Array<any> = [];
  selectedCoverage: Array<any> = [];
  Newplansresblack3Tiers: Array<any> = [];
  plansNewBlock2Tiers: Array<any> = [];
  plansNewBlock3Tiers: Array<any> = [];
  plansresblack3Tiers: Array<any> = [];
  finalblock2res: Array<any> = [];
  excelempdata: Array<any> = [];
  tierconfig: Array<any> = [];
  EmployeeAddData: Array<any> = [];
  finalemployeekeys: Array<any> = [];
  tierarray: Array<any> = [];
  corpDetails: Array<any> = [];
  SubDomains: Array<any> = [];
  public planssummarymainLife: any = [];
  CorpName: any;
  streetAddress: any;
  streetAddress2: any;
  country: any = '';
  city: any;
  province: any = '';
  postalCode: any;
  policyStartDate: any;
  setupWallet: any = false;
  setUplevelofCoverage: any = false;
  noOfEmployees: any;
  paymentInfo: any;
  waitTime: any;
  useCreditCard: any;
  invoicePayment: any;
  padPayment: any;
  minDate: any;
  maxDate: any;
  filterarray: Array<any> = [];
  packagePlanLevelTiers: any = {};
  displayPackage: Array<boolean> = [];
  selectedPlansInfoTierArray: Array<any> = [];
  selectedPlansInfoTierArrayBlock2: Array<any> = [];
  selectedPlansInfoTierArrayBlock3: Array<any> = [];
  selectedTiers: Array<any> = [];
  TiersArray: Array<any> = [];
  selectedPackagePlansInfoTier: any = {};
  selectedPackagePlansInfoTierBlock2: any = {};
  selectedPackagePlansInfoTierBlock3: any = {};
  selectedPackagePlansInfoTiername: any = {};
  selectedPackagePlansInfoTiernameBlock2: any = {};
  selectedPackagePlansInfoTiernameBlock3: any = {};
  selectedPackagePlansInfoTier2: any = {};
  selectedPackagesassignedTiers: any = {};
  selectedPackagesassignedTiers2: any = {};
  selectedPackagesassignedTiers21: any = {};
  selectedPackagesavailableTiers: any = {};
  selectedPackagesavailableTiers2: any = {};
  selectedPackagesavailableTiers21: any = {};
  selectedPackagesavailableTiers3: any = {};
  selectedPackagesassignedTiers3: any = {};

  selectedPackagePlansInfoTier2Block2: any = {};
  selectedPackagePlansInfoTier3Block3: any = {};
  selectedPackagesassignedTiersBlock2: any = {};
  selectedPackagesassignedTiersBlock3: any = {};
  selectedPackagesassignedTiers2Block2: any = {};
  selectedPackagesassignedTiers2Block21: any = {};
  selectedPackagesassignedTiers3Block3: any = {};
  selectedPackagesassignedTiers3Block31: any = {};
  selectedPackagesavailableTiersBlock2: any = {};
  selectedPackagesavailableTiersBlock3: any = {};
  selectedPackagesavailableTiers2Block2: any = {};
  selectedPackagesavailableTiers2Block21: any = {};
  selectedPackagesavailableTiers3Block3: any = {};
  selectedPackagesavailableTiers3Block31: any = {};
  seelctedplanLevelTierMapping: Array<any> = [];
  seelctedplanLevelTierMapping2: Array<any> = [];
  dateFormat = 'MM-DD-YYYY';

  showinput = true;
  showinput1 = false;

  showinputBlock2 = true;
  showinput1Block2 = false;

  showinputBlock3 = true;
  showinput1Block3 = false;
  seelctedplanLevelTierMappingBlock2: Array<any> = [];
  seelctedplanLevelTierMapping2Block2: Array<any> = [];

  seelctedplanLevelTierMappingBlock3: Array<any> = [];
  seelctedplanLevelTierMapping3Block3: Array<any> = [];
  walletsymbol: any;
  chart: any;
  chart1: any;
  isActive!: boolean;
  showemptytierconfig: any;
  annualincomeCheck = false;
  lengthofServiceCheck = false;
  tiersLevelCheck = false;
  public fieldArray: Array<any> = [];
  public newAttribute: any = {};
  public defaulttiers: Array<any> = [];
  public dynamicArray: Array<any> = [];
  public dynamicArrayService: Array<any> = [];
  public dynamicArrayAnnualIncome: Array<any> = [];
  dropdownList: Array<any> = [];
  selectedItems: Array<any> = [];
  dropdownSettings = {};
  public employeeList: Array<any> = [];
  public newDynamic: any = {};
  public adminError: boolean = false;
  adminStatuslist: Array<any> = [];
  dropDownSelect = false;
  employeedata: any = [];
  employeedata2: any = [];

  finalCompanyPaidCoverages: any = [];
  plansCoveragecheckboxCheck: { [key: string]: boolean } = {};
  getPlanCoverage: { [key: string]: any } = {};
  public mainarray: any = [];
  mainarrayValues: any = [];
  mainarrayFinal: any = []
  public modifiedBlocksCoveredByCompany: any;
  public modifiedBlocksPaidByCompany: any
  public formData: any;
  public allFormData: any = {};
  public companypaidproductid = [];
  public disabledcompanypaidproductid = [];
  public removedisabledcompanypaidproductid = [];
  public adddisabledcompanypaidproductid = [];
  specialpackages: any;
  public packagesInBlocks: any;
  basepackages: any

  @ViewChild('myFileInputwaddel') myFileInputwaddel: ElementRef;

  @ViewChild('multiSelectDropdown') multiSelectDropdown: any;
  clientregform: FormGroup = new FormGroup({
    brokerName: new FormControl(''),
    profile: new FormControl(''),
    corporationName: new FormControl(''),
    PolicyStartDate: new FormControl(''),
    streetAddress: new FormControl(''),
    streetAddress2: new FormControl(''),
    apt_suite: new FormControl(),
    country: new FormControl(''),
    city: new FormControl(''),
    Province: new FormControl(''),
    multiSelectProviance: new FormControl(''),
    postalCode: new FormControl(''),
    waitingPeriod: new FormControl(''),
    waitingPeriodCustom: new FormControl(''),
    waitingPeriodinitialsignup: new FormControl(),
    paymentInfo: new FormControl(''),
    bankCode: new FormControl(''),
    BankTransit: new FormControl(''),
    accounNum: new FormControl(''),
    voidcheck: new FormControl(''),
    corporatelogo: new FormControl(''),
    walletConfig: new FormControl(''),
    tierConfig: new FormControl(''),
    expectednoofEmployees: new FormControl(''),
    ShowEmployer: new FormControl(''),
    autoSelectEmp: new FormControl(''),
  });
  adminform: FormGroup = new FormGroup({
    adminfirstname: new FormControl(''),
    adminlastname: new FormControl(''),
    adminphone: new FormControl(''),
    adminemail: new FormControl(''),
    role: new FormControl(''),
    roleName: new FormControl(''),
  });
  addEmployeeformList: FormGroup = new FormGroup({
    employeeId: new FormControl(''),
    employeeFirstName: new FormControl(''),
    employeeLastName: new FormControl(''),
    employeeEmail: new FormControl(''),
    employeeOccupation: new FormControl(''),
    employeeDateofhire: new FormControl(''),
    employeeDateofbirth: new FormControl(''),
    employeeGender: new FormControl(''),
    employeeCountry: new FormControl(''),
    employeeResidence: new FormControl(''),
    employeefamilyStatus: new FormControl(''),
    employeePhoneno: new FormControl(''),
    employeeStreetAddress: new FormControl(''),
    employeeCity: new FormControl(''),
    employeeProvince: new FormControl(''),
    employeePostalCode: new FormControl(''),
    employeeTier: new FormControl(''),
    empployeeAnnualIncome: new FormControl(''),
  });
  addEmployeeformListwaddell: FormGroup = new FormGroup({
    employeeId: new FormControl(''),
    employeeFirstName: new FormControl(''),
    employeeLastName: new FormControl(''),
    employeeEmail: new FormControl(''),
    employeePhoneno: new FormControl(''),
    employeeStreetAddress: new FormControl(''),
    employeeCountry: new FormControl(''),
    employeeCity: new FormControl(''),
    employeeProvince: new FormControl(''),
    employeePostalCode: new FormControl(''),
  });
  payrolldeductionoption: FormGroup = new FormGroup({
    payrolloption: new FormControl(''),
  });

  effectiveDateForm: FormGroup = new FormGroup({
    effectiveDate: new FormControl(''),

  });

  //ganesh
  tax = 0.13;
  price = {
    'EAP 2.0': 5,
    'Mind & Body': 15,
    'Complete Wellness': 20
  }

  submitted = false;
  // submittedadmin = false;
  @ViewChild('lengthOfServicetrue')
  lengthOfServicetrue!: ElementRef<HTMLElement>;
  @ViewChild('lengthOfServicefalse')
  lengthOfServicefalse!: ElementRef<HTMLElement>;
  @ViewChild('annualIncometrue')
  annualIncometrue!: ElementRef<HTMLElement>;
  @ViewChild('annualIncomefalse')
  annualIncomefalse!: ElementRef<HTMLElement>;

  @ViewChild('nextpage')
  nextpage!: ElementRef<HTMLElement>;

  @ViewChild('nextpage')
  closemodel!: ElementRef<HTMLElement>;
  @ViewChild('upgradeplansfalse')
  upgradeplansfalse!: ElementRef<HTMLElement>;
  @ViewChild('upgradeplanstrue')
  upgradeplanstrue!: ElementRef<HTMLElement>;

  @ViewChild('upgradeplanstiersfalse')
  upgradeplanstiersfalse!: ElementRef<HTMLElement>;
  @ViewChild('upgradeplanstierstrue')
  upgradeplanstierstrue!: ElementRef<HTMLElement>;

  @ViewChild('employeepurchasefalse')
  employeepurchasefalse!: ElementRef<HTMLElement>;
  @ViewChild('employeepurchasetrue')
  employeepurchasetrue!: ElementRef<HTMLElement>;

  @ViewChild('employeepurchaseTiersfalse')
  employeepurchaseTiersfalse!: ElementRef<HTMLElement>;
  @ViewChild('employeepurchaseTierstrue')
  employeepurchaseTierstrue!: ElementRef<HTMLElement>;
  disabledelement: any;
  // @ViewChild(HeaderComponent) headerComponent : HeaderComponent | undefined;
  @ViewChild(HeaderComponent)
  headerComponent!: HeaderComponent;

  selectedOption: any;

  @ViewChild('myFileInput') myFileInput: ElementRef;
  @ViewChild('myFileInputPAd') myFileInputPAd: ElementRef;

  @ViewChild('form') form: ElementRef;
  accessCode: any;
  encRequestRes: any;
  order_no: any = 'qaz234567';
  testAmount: any = '10';
  selectedAddress: any = {
    name: 'testing',
    address: 'test address',
    city: 'test city',
    pincode: '23456',
    state: 'state test',
    phone: '1234567890',
  };
  firstName: any;
  showOtherField: boolean = false;
  groupContactsData: any;
  existingPlans: any;
  coreplantemplateValue: any = null;
  emailAlreadyexist: boolean = false;
  domainExisting: boolean = false;
  postalCodeDisplay: any = 'Postal Code';
  provianceDispaly: any = 'Province';
  allCountrys: any;
  selectedCountry: string;
  multiSelectProviance: any = [];
  multiSelectProviancenames: any = [];
  adminformOthers: any;
  aptSuite: any;
  isCountrySelected: boolean = false;
  multiSlectProviances: any;
  version: string;
  employeeWorkingProviance: any;
  balkPlans: any;
  imagedisplayPad: any = "";
  showdisplayPad: boolean = false;
  corePlans: any;
  showbankInfo: boolean = false;
  showEmployeeValue: any;
  showEmployeeValue1: any
  headCountmiss: boolean = false;
  headCountmiss1: boolean = false;
  showEmployeelist: any = [];
  deletedId: Array<any> = [];

  addemployeefrom: boolean;
  editemployeefrom: boolean;
  editEmployeeindex: any;
  editEmployeefirstname: any;
  editEmployeelastname: any;
  editEmployeephone: any;
  editEmployeeemail: any;
  presentMail: any;
  editEmployeeDateofbirth: string;
  editEmployeeOccupation: any;
  editEmployeefamilyStatus: string;
  editemployeeCountry: any;
  editEmployeeResidenetIn: any;
  editEmployeeeAnnualIncome: any;
  UId: any;
  isBulk: boolean;
  editEmployeeDateofhire: string;
  editEmployeesex: any;
  showinputboxvalue: { [key: string]: boolean } = {}
  showinputboxvalue1: any;
  failedEmployeesList: any;
  // message: any;
  message: string = "";
  brokerProfileslist: Array<any> = [];
  public bulkemployeeList: Array<any> = [];
  waddellExcelKeys: any = [];
  editEmployeeStreeAddress: any;
  editEmployeeCity: any;
  editEmployeeProvicne: any;
  editEmployeeposatlCode: any;
  ExcelProvinceCode: any = '';
  isWaddell: boolean;
  checkboxCheck: { [key: string]: boolean } = {};
  selectedSubGrpId: any = '';
  showHeadCount: { [key: string]: any } = {};
  isCollapsed: { [key: string]: boolean } = {};
  isCollapsedTwo: { [key: string]: boolean } = {};
  isCollapsedThree: { [key: string]: boolean } = {};
  public lang: any = {};
  selectedLanguage: string;
  languageData: any;
  companyPaidCoveragePlanLevels: any;
  loading$: Observable<boolean>;
  error$: Observable<string | null>;
  corporateData$: Observable<any>;
  clientList: any = []
  corporateDetails: any = {}
  corporateDetailsMain:any
  languageData$: Observable<any>;
  private destroy$ = new Subject<void>();
  corporateSignupConfigData$: Observable<any>;
  corporateSignupConfigData: any = {};
  customerData: any;
  customerAsAnEmployee: string;
  paymentMethodCheck: string;
  updatedBrokerId: any;
  brokerProfileslistSearch: any[];
  profileid: any;
  brokerProfileslist1: any;
  gig_customer_id: string;
  waitingPeriodValue: any = 0
  waitingPeriodforintialSignup: any = false
  customerPlans: any;
  CorporateFormData: any;
  payrollCCPlantaxTotal: any;
  empDirectpayPlanamountTotal: any;
  empDirectpayPlantaxTotal: any;
  payrollCCPlansAmountTotal: any;
  payrollCCPlangrandTotal: any;
  empDirectpayPlangrandTotal: any;
  DirectCCpayPlanamountTotal: any;
  DirectCCpayPlantaxTotal: any;
  DirectCCpayPlangrandTotal: any;
  companydealingplansTotal: any;
  companydealingplanstaxTotal: any;
  companydealingplansgrandTotal: any;
  deltaCompanyTax: any;
  public directpayCCplansarr: any = [];
  public payrollCCplansarr: any = [];
  public employeeDealingPlansarr: any = [];
  public companySelectedPlans = [];
  public companyCoveredPlans = [];
  public EmployeeSelectedPlans = [];
  public allSelectedPlans = [];
  public companyDealingPlans = [];

  public alloptinplans = [];
  iafgplansCheck: any = [];
  planobjdata: any = {};
  planobjdataobj: any = {};
  planoptionsValues: any = [];
  planOptionsModel = false;
  continueWithExistingPlans: boolean = true
  samePlansWithCorporate: boolean = true

  constructor(
    private _decimalPipe: DecimalPipe,
    private renderer: Renderer2,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private http: HttpClient,
    public app: AppComponent,
    public router: Router,
    public elementRef: ElementRef,
    private excelService: ExcelService,
    private datePipe: DatePipe,
    private toastrService: ToastrService,
    private ngZone: NgZone,
    private ref: ChangeDetectorRef,
    private PaymentService: PaymentService,
    private phoneNoFormat: PhoneFormatPipe,
    private _LoaderService: LoaderService,
    private _CustomDatePipe: CustomDatePipe,
    private commonPatternsService: CommonPatternsService,
    private store: Store<{ corporateData: [], languageData: [], corporateSignupConfigData: {} }>

  ) {
    this.corporateData$ = store.select(selectCorporateData);
    this.loading$ = store.select(selectCorporateLoading);
    this.error$ = store.select(selectCorporateError);
    this.languageData$ = store.select(selectLanguageData);
    this.corporateSignupConfigData$ = store.select(selectCorporateSignupConfigData);
  }

  ngOnInit(): void {

    // setTimeout(() => {
    //   $('#showeffectiveDate').modal('show');
    // }, 2000);
    this.configprovinceres = [
      {
        "countryId": 1,
        "id": 1,
        "name": "Alberta",
        "provincialHealthcareUrl": "https://www.alberta.ca/ahcip-how-to-apply.aspx",
        "published": true,
        "shortName": "AB",
        "cowanId": "5",
        "zipcodes": "T",
        "fusebillId": "1",
        "equitableId": 1,
        "equitableQuestions": null,
        "smartchoiceId": 1,
        "country_id": 1
      },
      {
        "countryId": 1,
        "id": 2,
        "name": "Quebec",
        "provincialHealthcareUrl": "https://www.ramq.gouv.qc.ca/en/citizens/health-insurance/register",
        "published": true,
        "shortName": "QC",
        "cowanId": "2",
        "zipcodes": "G,H,J",
        "fusebillId": "11",
        "equitableId": 10,
        "equitableQuestions": null,
        "smartchoiceId": 11,
        "country_id": 1
      },
      {
        "countryId": 1,
        "id": 12,
        "name": "Ontario",
        "provincialHealthcareUrl": "https://www.ontario.ca/page/apply-ohip-and-get-health-card",
        "published": true,
        "shortName": "ON",
        "cowanId": "1",
        "zipcodes": "K,L,M,N,P",
        "fusebillId": "9",
        "equitableId": 8,
        "equitableQuestions": null,
        "smartchoiceId": 9,
        "country_id": 1
      },
      {
        "countryId": 1,
        "id": 13,
        "name": "New Brunswick",
        "provincialHealthcareUrl": "https://www2.gnb.ca/content/gnb/en/departments/health/MedicarePrescriptionDrugPlan/content/medicare/ApplyingforaCard.html",
        "published": true,
        "shortName": "NB",
        "cowanId": "8",
        "zipcodes": "E",
        "fusebillId": "4",
        "equitableId": 4,
        "equitableQuestions": null,
        "smartchoiceId": 4,
        "country_id": 1
      },
      {
        "countryId": 1,
        "id": 14,
        "name": "British Columbia",
        "provincialHealthcareUrl": "https://www2.gov.bc.ca/gov/content/health/health-drug-coverage/msp/bc-residents/eligibility-and-enrolment/how-to-enrol",
        "published": true,
        "shortName": "BC",
        "cowanId": "6",
        "zipcodes": "V",
        "fusebillId": "2",
        "equitableId": 2,
        "equitableQuestions": true,
        "smartchoiceId": 2,
        "country_id": 1
      },
      {
        "countryId": 1,
        "id": 15,
        "name": "Saskatchewan",
        "provincialHealthcareUrl": "https://www.ehealthsask.ca/residents/health-cards/Pages/Apply-for-a-Health-Card.aspx",
        "published": true,
        "shortName": "SK",
        "cowanId": "4",
        "zipcodes": "S",
        "fusebillId": "12",
        "equitableId": 11,
        "equitableQuestions": true,
        "smartchoiceId": 12,
        "country_id": 1
      },
      {
        "countryId": 1,
        "id": 16,
        "name": "Nova Scotia",
        "provincialHealthcareUrl": "https://novascotia.ca/dhw/MSI/health_cards.asp",
        "published": true,
        "shortName": "NS",
        "cowanId": "9",
        "zipcodes": "B",
        "fusebillId": "7",
        "equitableId": 7,
        "equitableQuestions": null,
        "smartchoiceId": 6,
        "country_id": 1
      },
      {
        "countryId": 1,
        "id": 17,
        "name": "Prince Edward Island",
        "provincialHealthcareUrl": "https://www.princeedwardisland.ca/en/service/apply-for-pei-health-card-new-residents",
        "published": true,
        "shortName": "PEI",
        "cowanId": "10",
        "zipcodes": "C",
        "fusebillId": "10",
        "equitableId": 9,
        "equitableQuestions": null,
        "smartchoiceId": 10,
        "country_id": 1
      },
      {
        "countryId": 1,
        "id": 18,
        "name": "Newfoundland and Labrador",
        "provincialHealthcareUrl": "https://www.gov.nl.ca/hcs/files/mcp-forms-ben-reg.pdf",
        "published": true,
        "shortName": "NL",
        "cowanId": "7",
        "zipcodes": "A",
        "fusebillId": "5",
        "equitableId": 5,
        "equitableQuestions": null,
        "smartchoiceId": 5,
        "country_id": 1
      },
      {
        "countryId": 1,
        "id": 19,
        "name": "Nunavut",
        "provincialHealthcareUrl": "https://www.gov.nu.ca/health/information/health-care-card",
        "published": true,
        "shortName": "NU",
        "cowanId": "16",
        "zipcodes": "X",
        "fusebillId": "8",
        "equitableId": 13,
        "equitableQuestions": null,
        "smartchoiceId": 8,
        "country_id": 1
      },
      {
        "countryId": 1,
        "id": 20,
        "name": "Yukon",
        "provincialHealthcareUrl": "https://yukon.ca/en/health-care-card",
        "published": true,
        "shortName": "YT",
        "cowanId": "12",
        "zipcodes": "Y",
        "fusebillId": "13",
        "equitableId": 12,
        "equitableQuestions": null,
        "smartchoiceId": 13,
        "country_id": 1
      },
      {
        "countryId": 1,
        "id": 21,
        "name": "Manitoba",
        "provincialHealthcareUrl": "https://www.gov.mb.ca/health/mhsip/forms.html",
        "published": true,
        "shortName": "MB",
        "cowanId": "3",
        "zipcodes": "R",
        "fusebillId": "3",
        "equitableId": 3,
        "equitableQuestions": true,
        "smartchoiceId": 3,
        "country_id": 1
      },
      {
        "countryId": 1,
        "id": 22,
        "name": "Northwest Territories",
        "provincialHealthcareUrl": "https://www.hss.gov.nt.ca/en/services/applying-health-care",
        "published": true,
        "shortName": "NT",
        "cowanId": "13",
        "zipcodes": "X",
        "fusebillId": "6",
        "equitableId": 6,
        "equitableQuestions": null,
        "smartchoiceId": 7,
        "country_id": 1
      },
      {
        "countryId": 2,
        "id": 23,
        "name": "Alabama",
        "provincialHealthcareUrl": null,
        "published": true,
        "shortName": "AL",
        "cowanId": null,
        "zipcodes": "35004-36925",
        "fusebillId": null,
        "equitableId": null,
        "equitableQuestions": null,
        "smartchoiceId": null,
        "country_id": 2
      },
      {
        "countryId": 2,
        "id": 24,
        "name": "Alaska",
        "provincialHealthcareUrl": null,
        "published": true,
        "shortName": "AK",
        "cowanId": null,
        "zipcodes": "99501-99950",
        "fusebillId": null,
        "equitableId": null,
        "equitableQuestions": null,
        "smartchoiceId": null,
        "country_id": 2
      },
      {
        "countryId": 2,
        "id": 25,
        "name": "Arizona",
        "provincialHealthcareUrl": null,
        "published": true,
        "shortName": "AZ",
        "cowanId": null,
        "zipcodes": "85001-86556",
        "fusebillId": null,
        "equitableId": null,
        "equitableQuestions": null,
        "smartchoiceId": null,
        "country_id": 2
      }
    ]

    this.configprovinceres = [...this.configprovinceres].sort(
      (a: any, b: any) => (a.shortName > b.shortName ? 1 : -1)
    );

    this.getLanguageTokens()
    this.gig_customer_id =
      this.selectedOption = this.route.snapshot.params['id'];
    this.accessCode = 'AVMM97HL24AS35MMSA';
    this.version = environment.version;

    this.adminData = [];
    sessionStorage.setItem('adminData', '');

    let adminsstatus = [
      { id: 1, name: 'Enter Address', checked: false, color: 'red' },
      { id: 2, name: 'Select Policy Start Date', checked: false, color: 'red' },
      {
        id: 3,
        name: 'Add Additional Administrator',
        checked: false,
        color: 'red',
      },
      {
        id: 4,
        name: 'Enter Waiting Period For New Employees',
        checked: false,
        color: 'red',
      },
      { id: 5, name: 'Select Payment Method', checked: false, color: 'red' },
      { id: 6, name: 'Add/Update Company logo', checked: false, color: 'red' },
      {
        id: 7,
        name: 'Enable Wallet - Enabled or Disabled',
        checked: false,
        color: 'red',
      },
      {
        id: 8,
        name: 'Enter Tiered Benefits - Enabled or Disabled',
        checked: false,
        color: 'red',
      },
      { id: 9, name: 'Select Benefit Plans', checked: false, color: 'red' },
      {
        id: 10,
        name: 'Add Employees and (Assign tiers if Tiers Selected)',
        checked: false,
        color: 'red',
      },
      { id: 11, name: 'Review Setup', checked: false, color: 'red' },
      {
        id: 12,
        name: 'Send Invite to all employees',
        checked: false,
        color: 'red',
      },
    ];

    this.adminStatuslist = adminsstatus;

    this.adminName = sessionStorage.getItem('adminName');

    this.role = sessionStorage.getItem('role');

    this.walletsymbol = '$';
    this.adminData = JSON.parse(sessionStorage.getItem('adminData') || '[]');
    console.log(this.adminData);
    sessionStorage.setItem('corporateId', '');
    sessionStorage.setItem('corporateClientId', '');

    // console.log(this.adminData)
    this.dropdownSettings = {
      singleSelection: false,
      // closeDropDownOnSelection: true,
      idField: 'id',
      textField: 'shortName',
      selectAllText: this.lang.Select_All,
      unSelectAllText: this.lang.Deselect_All,
      itemsShowLimit: 4,
      allowSearchFilter: true,
    };

    this.selectedItems = [
      { id: 114, name: 'All' },
      { id: 115, name: 'Employee' },
      { id: 116, name: 'Management' },
    ];

    // sessionStorage.setItem('corporateId', '74');
    this.defaultColor = 'black';

    this.clientregform = this.formBuilder.group({
      brokerName: [''],
      profile: [''],
      corporationName: [
        '',
        [
          Validators.required,
          Validators.minLength(2),
          Validators.maxLength(255),
          Validators.pattern('^(?:<[^>]*$|[^<]*>$|^[^<>]*$)')
        ],
      ],
      PolicyStartDate: ['', [Validators.required]],
      streetAddress: ['', [Validators.required]],
      streetAddress2: [''],
      apt_suite: [''],
      country: ['', [Validators.required]],
      city: ['', [Validators.required]],
      Province: ['', [Validators.required]],
      multiSelectProviance: ['', [Validators.required]],
      postalCode: ['', [Validators.required]],
      waitingPeriod: [''],
      waitingPeriodCustom: [''],
      waitingPeriodinitialsignup: ['', [Validators.required]],
      paymentInfo: [''],
      bankCode: [''],
      BankTransit: [''],
      accounNum: [''],
      voidcheck: [''],
      corporatelogo: [''],
      walletConfig: [false, [Validators.required]],
      tierConfig: ['', [Validators.required]],
      expectednoofEmployees: [''],
      ShowEmployer: ['false', [Validators.required]],
      autoSelectEmp: [false, [Validators.required]],
    });
    this.adminform = this.formBuilder.group({
      adminfirstname: [
        '',
        [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(200),
          // Validators.pattern("^(?!\\s)[A-Za-z-'\\s]+$")
        ],
      ],
      adminlastname: [
        '',
        [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(200),
          // Validators.pattern("^(?!\\s)[A-Za-z-'\\s]+$")
        ],
      ],
      adminphone: [
        '',
        Validators.compose([
          Validators.required,
          Validators.minLength(17),
          Validators.maxLength(17),
          Validators.pattern(/^[^A-Za-z@#$%&*{}'";:<>?]+$/),
        ]),
      ],
      adminemail: [
        '',
        [
          Validators.required,
          Validators.
            pattern(this.commonPatternsService.emailPattern),

        ],
      ],
      role: ['', [Validators.required]],
      roleName: [''],
    });
    this.addEmployeeformList = this.formBuilder.group({
      employeeId: [''],
      employeeFirstName: [
        '',
        [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(20),
        ],
      ],
      employeeLastName: [
        '',
        [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(20),
        ],
      ],
      employeeEmail: [
        '',
        [
          Validators.required,
          Validators.pattern(
            this.commonPatternsService.emailPattern
          ),

        ],
      ],

      employeeOccupation: ['', Validators.pattern('^(?!\\s)[A-Za-z0-9\\s]+$')],
      employeeDateofhire: [''],
      employeeDateofbirth: [''],

      employeeGender: [null],
      employeeCountry: ['',],
      employeeResidence: ['',],
      employeePhoneno: ['', Validators.compose([Validators.minLength(17), Validators.maxLength(17), Validators.pattern(/^[^A-Za-z@#$%&*{}'";:<>?]+$/)])],
      employeeStreetAddress: [''],
      employeeCity: [''],
      employeeProvince: [''],
      employeePostalCode: [''],
      employeefamilyStatus: [''],

      employeeTier: [''],
      empployeeAnnualIncome: ['']
    });

    this.addEmployeeformListwaddell = this.formBuilder.group({
      employeeId: [''],
      employeeFirstName: [
        '',
        [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(20),
        ],
      ],
      employeeLastName: [
        '',
        [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(20),
        ],
      ],
      employeeEmail: [
        '',
        [
          Validators.required,
          Validators.pattern(
            this.commonPatternsService.emailPattern
          ),

        ],
      ],
      employeePhoneno: ["",
        Validators.compose([Validators.required, Validators.minLength(17), Validators.maxLength(17), Validators.pattern(/^[^A-Za-z@#$%&*{}'";:<>?]+$/)]),
      ],
      employeeStreetAddress: ['', [Validators.required]],
      employeeCountry: ['', [Validators.required]],
      employeeCity: ['', [Validators.required]],
      employeeProvince: ['', [Validators.required]],
      employeePostalCode: ['', Validators.compose([Validators.required, postalcodeValidatorwaddell])],
    });
    this.payrolldeductionoption = this.formBuilder.group({
      payrolloption: ['', [Validators.required]],
    });
    this.effectiveDateForm = this.formBuilder.group({
      effectiveDate: ['', [Validators.required]],
    });



    this.formConfig();

    // this.dynamicArray.push(
    //   { sno: '1', tierName: 'All', walletAmount: '$1000' },
    // );
    this.dynamicArray.forEach((element: any) => {
      let obj = {
        id: element.sno,
        tierName: this.capitalize(element.tierName),
      };
      this.tierinfonames.push(obj);
    });

    this.removeselectedplans()

    this.store.dispatch(loadCorporateData());
    this.corporateData$ = this.store.select(state => state.corporateData).pipe(
      // startWith([]),
      // takeUntil(this.destroy$)
    );
    this.corporateData$.subscribe(data => {
      if (data) {
        console.log(data)
        if (data?.corporateData == undefined || Object.keys(data.corporateData).length <= 0) {
          console.log('No data to process', new Date().toISOString());
          return;
        }
        if (this.clientList.length > 0) {
          return;
        }

        const role = sessionStorage.getItem('role');
        if (role == 'ADMINISTRATOR') {
          // this.clientList = decompress(data.corporateData)
          this.clientList = data.corporateData
        } else {
          this.clientList = data.corporateData.map(res => {
            return {
              ...res,
              formsLength: res.forms?.length || 0
            }
          })
        }
      } else {
        console.error('Observable returned undefined');
      }
    })
  }

  public getLanguageTokens() {
    // let body = {
    //   "project": "Admin Portal",
    //   "url": "addCorporate"
    // }
    // this.http
    //   .post('https://languageengineapi.aitestpro.com/string/project-url-strings', body, {
    //     headers: {
    //       'Content-Type': 'application/json',
    //     },
    //   })
    //   .subscribe(
    //     (response: any) => {
    //       console.log(response)
    //       this.lang = {};
    //       this.selectedLanguage = sessionStorage.getItem("language")
    //       this.languageData = response.strings
    //       for (let token of response.strings) {
    //         this.lang[token.key] = token[this.selectedLanguage];
    //       }

    //       this.dropdownSettings = {
    //         singleSelection: false,
    //         // closeDropDownOnSelection: true,
    //         idField: 'id',
    //         textField: 'shortName',
    //         selectAllText: this.lang.Select_All,
    //         unSelectAllText: this.lang.Deselect_All,
    //         itemsShowLimit: 4,
    //         allowSearchFilter: true,
    //       };
    //     })

    // this.store.dispatch(loadLanguageData());

    this.languageData$ = this.store.select(state => state.languageData).pipe(
      startWith([]),
      takeUntil(this.destroy$)
    );

    this.languageData$.subscribe(data => {
      if (data) {
        // console.log(data)
        if (data?.languageData == undefined || Object.keys(data.languageData).length <= 0) {
          console.log('No data to process', new Date().toISOString());
          return;
        }
        // if(Object.keys(this.lang).length>0){
        //   return;
        // }
        setTimeout(() => {
          this.lang = {};
          this.languageData = data?.languageData
          this.selectedLanguage = sessionStorage.getItem("language")
          for (let token of data?.languageData) {
            this.lang[token.key] = token[this.selectedLanguage];
          }
          // console.log('this.lang',this.lang)

          this.dropdownSettings = {
            singleSelection: false,
            // closeDropDownOnSelection: true,
            idField: 'id',
            textField: 'shortName',
            selectAllText: this.lang.Select_All,
            unSelectAllText: this.lang.Deselect_All,
            itemsShowLimit: 4,
            allowSearchFilter: true,
          };
        }, 0)
      }
    })
  }




  toggleCollapsee(parentId: string): void {
    this.isCollapsed[parentId] = !this.isCollapsed[parentId];
  }
  toggleCollapseeTwo(parentId: string): void {
    this.isCollapsedTwo[parentId] = !this.isCollapsedTwo[parentId];
  }
  toggleCollapseeThree(parentId: string): void {
    this.isCollapsedThree[parentId] = !this.isCollapsedThree[parentId];
  }

  removeselectedplans() {
    sessionStorage.setItem('summaryBlockBulk', '[]');

    sessionStorage.setItem('summaryBlock1', '[]');
    sessionStorage.setItem('walletConfig', '{}');
    sessionStorage.setItem('selectedPlans', '{}');
    sessionStorage.setItem('summaryBlock1main', '[]');
    sessionStorage.setItem('summaryBlock1opt', '[]');
    // sessionStorage.setItem('selectedBlock1', '{}');
    sessionStorage.setItem('summaryBlock2', '[]');

    sessionStorage.setItem('summaryBlock2main', '[]');
    sessionStorage.setItem('summaryBlock2opt', '[]');
    // sessionStorage.setItem('selectedBlock2', '{}');

    sessionStorage.setItem('summaryBlock3', '[]');

    sessionStorage.setItem('summaryBlock3main', '[]');
    sessionStorage.setItem('summaryBlock3opt', '[]');
    sessionStorage.setItem('selectedBlock3', '{}');
  }
  checkout() {
    let redirect_url = 'http%3A%2F%2Flocalhost%3A3008%2Fhandleresponse';
    let useremail = 'testemail@gmail.com';
    let request = `merchant_id=284414&order_id=${this.order_no}&currency=INR&amount=${this.testAmount}&redirect_url=${redirect_url}&cancel_url=${redirect_url}&language=EN&billing_name=${this.selectedAddress.name}&billing_address=${this.selectedAddress.address}&billing_city=${this.selectedAddress.city}&billing_state=MH&billing_zip=${this.selectedAddress.pincode}&billing_country=India&billing_tel=${this.selectedAddress.phone}&delivery_name=${this.selectedAddress.name}&delivery_address=${this.selectedAddress.address}&delivery_city=${this.selectedAddress.city}&delivery_state=${this.selectedAddress.state}&delivery_zip=${this.selectedAddress.pincode}&delivery_country=India&delivery_tel=${this.selectedAddress.phone}&billing_email=${useremail}`;
    this.encRequestRes = request;
    setTimeout(() => {
      this.form.nativeElement.submit();
    }, 1000);

    // this.PaymentService.encryptdata(request).subscribe(
    //   data => {
    //   console.log('---------------------', data['response'])
    //   this.encRequestRes = data['response'];
    //       setTimeout(()=>{
    //           this.form.nativeElement.submit();
    //       },1000)
    //   }, error => {
    //   console.log(error)
    //   }
    //   );
  }
  // formConfig() {
  //   // var endPoint = '/api/ap/admin/corporateSignup/formConfig';
  //   // var accessToken = sessionStorage.getItem('accessToken');

  //   // this.http
  //   //   .get(environment.apiUrl + endPoint, {
  //   //     headers: {
  //   //       Authorization: 'Bearer ' + accessToken,
  //   //       'Content-Type': 'application/json',
  //   //     },
  //   //   })
  //   //   .subscribe(
  //   //     (response: any) => {
  //   //       if (response['status'] == 200) {
  //   //         this.companyPaidCoveragePlanLevels = response.data.companyPaidCoveragePlanLevels

  //   //         this.statesInfo = response.data.states;
  //   //         this.walletConfig = response.data.walletConfig;
  //   //         this.waddellExcelKeys = response.data.bulkPlanExcelKeys.waddell
  //   //         this.allBrokers = response.data.allBrokersUnique;
  //   //         this.allBrokers = this.allBrokers.sort(
  //   //           (a: any, b: any) => (a.name > b.name ? 1 : -1)
  //   //         );

  //   //         this.payrolldeduction = response.data.payRolldeductionUI;

  //   //         this.countryList = response.data.allCountrys;
  //   //         console.log('this.countryList  :', this.countryList);
  //   //         this.groupContactsData = response.data.groupContactRoles;

  //   //         this.configprovinceres = response.data.states.sort(
  //   //           (a: any, b: any) => (a.shortName > b.shortName ? 1 : -1)
  //   //         );
  //   //         // this.countryList =response.data.countryList;
  //   //         this.multiSlectProviances = response.data.countryList[0].countryStates;
  //   //         this.multiSlectProviances = this.multiSlectProviances.sort(
  //   //           (a: any, b: any) => (a.shortName > b.shortName ? 1 : -1)
  //   //         );
  //   //         console.log(this.multiSlectProviances);
  //   //         response.data.countryList.forEach((element: any) => {
  //   //           if (element.countryStates == '1') {
  //   //             this.multiSlectProviances.push(element);

  //   //           }
  //   //         });
  //   //         this.enrollmentDates = response.data.planEnrollmentDatesFullMonth;

  //   //         console.log(this.allBrokers);
  //   //       } else {
  //   //         Swal.fire({ title: this.lang.Error??'Error', text: response.message });
  //   //       }
  //   //     },
  //   //     (error) => {
  //   //       if (
  //   //         error.status == 400 ||
  //   //         error.status == 401 ||
  //   //         error.status == 402 ||
  //   //         error.status == 403
  //   //       ) {
  //   //         Swal.fire({
  //   //           title: this.lang.Error??'Error',
  //   //           text: error.error.error.message,
  //   //           showCancelButton: false,
  //   //           showDenyButton: false,
  //   //           confirmButtonText: 'Proceed',
  //   //         }).then((result) => {
  //   //           /* Read more about isConfirmed, isDenied below */
  //   //           if (result.isConfirmed) {
  //   //             sessionStorage.clear();
  //   //             this.router.navigate(['/login']);
  //   //           } else {
  //   //             sessionStorage.clear();
  //   //             this.router.navigate(['/login']);
  //   //           }
  //   //         });
  //   //       } else {
  //   //         // Swal.fire(error.error.error.message)
  //   //         Swal.fire({ title: this.lang.Error??'Error', text: error.error.error.message });
  //   //       }
  //   //       // this.toastrService.error("Invalid Credentials", 'Error!');
  //   //     }
  //   //   );

  //   this.store.dispatch(loadCorporateSignupConfigData());
  //   this.corporateSignupConfigData$ = this.store.select(state => state.corporateSignupConfigData).pipe(
  //     // startWith([]),
  //     // takeUntil(this.destroy$)
  //   );
  //   this.corporateSignupConfigData$.subscribe(data => {
  //     if (data) {
  //       console.log(data)
  //     if (data?.corporateSignupConfigData == undefined || Object.keys(data.corporateSignupConfigData).length <= 0) {
  //       console.log('No data to process', new Date().toISOString());
  //       return;
  //     }
  //     if(Object.keys(this.corporateSignupConfigData).length>0){
  //       return;
  //     }
  //     this.corporateSignupConfigData = {...data.corporateSignupConfigData}

  //     this.companyPaidCoveragePlanLevels = this.corporateSignupConfigData.companyPaidCoveragePlanLevels
  //     this.statesInfo = [...this.corporateSignupConfigData.states];
  //     this.walletConfig = this.corporateSignupConfigData.walletConfig;
  //     this.waddellExcelKeys = this.corporateSignupConfigData.bulkPlanExcelKeys.waddell
  //     this.allBrokers = this.corporateSignupConfigData.allBrokersUnique;
  //     this.allBrokers = [...this.allBrokers].sort(
  //       (a: any, b: any) => (a.name > b.name ? 1 : -1)
  //     );

  //     this.payrolldeduction = this.corporateSignupConfigData.payRolldeductionUI;

  //     this.countryList = this.corporateSignupConfigData.allCountrys;
  //     console.log('this.countryList  :', this.countryList);
  //     this.groupContactsData = this.corporateSignupConfigData.groupContactRoles;

  //     this.configprovinceres = [...this.corporateSignupConfigData.states].sort(
  //       (a: any, b: any) => (a.shortName > b.shortName ? 1 : -1)
  //     );
  //     // this.countryList =this.corporateSignupConfigData.countryList;
  //     this.multiSlectProviances = this.corporateSignupConfigData.countryList[0].countryStates;
  //     this.multiSlectProviances = [...this.multiSlectProviances].sort(
  //       (a: any, b: any) => (a.shortName > b.shortName ? 1 : -1)
  //     );
  //     console.log(this.multiSlectProviances);
  //     this.corporateSignupConfigData.countryList.forEach((element: any) => {
  //       if (element.countryStates == '1') {
  //         this.multiSlectProviances.push(element);

  //       }
  //     });
  //     this.enrollmentDates = this.corporateSignupConfigData.planEnrollmentDatesFullMonth;

  //     } else {
  //       console.error('Observable returned undefined');
  //     }
  //   })
  // }

  // getServiceWorkerDetails(CorpId: any) {
  //   var endPoint = '/api/ap/admin/corporate/' + CorpId + '/details';

  //   let prefetchurls = []

  //   let Data = [{
  //     url: environment.apiUrl + endPoint,
  //     // fetch options
  //     options: {

  //       mode: 'cors',
  //       headers: {

  //         Authorization: 'Bearer ' + sessionStorage.getItem('accessToken'),
  //         'Content-Type': 'application/json',
  //       }
  //     }
  //   }]
  //   prefetchurls = Data

  //   postServiceWorkerMessage(WorkerMessageType.Prefetch, prefetchurls).then((results: WorkerUrlPrefetchResult) => {


  //     var endPoint = '/api/ap/admin/corporate/' + CorpId + '/details';
  //     var accessToken = sessionStorage.getItem('accessToken');
  //     this.http
  //       .get(environment.apiUrl + endPoint, {
  //         headers: {
  //           Authorization: 'Bearer ' + accessToken,
  //           'Content-Type': 'application/json',
  //         },
  //       })
  //       .subscribe(
  //         (response: any) => {
  //           if (response['status'] == 200) {
  //             console.log(response);

  //             this.bulkplans = response.data.bulkPlans;

  //             this.employeeList = response.data.employees;
  //             this.addedEmployeelist = response.data.employees;

  //             this.lengthofemployee = this.employeeList.length;
  //           } else {
  //             Swal.fire({ title: this.lang.Error??'Error', text: response.message });
  //           }
  //         },
  //         (error) => {
  //           if (
  //             error.status == 400 ||
  //             error.status == 401 ||
  //             error.status == 402 ||
  //             error.status == 403
  //           ) {
  //             Swal.fire({
  //               title: this.lang.Error??'Error',
  //               text: error.error.error.message,
  //               showCancelButton: false,
  //               showDenyButton: false,
  //               confirmButtonText: 'Proceed',
  //             }).then((result) => {
  //               /* Read more about isConfirmed, isDenied below */
  //               if (result.isConfirmed) {
  //                 sessionStorage.clear();
  //                 this.router.navigate(['/login']);
  //               } else {
  //                 sessionStorage.clear();
  //                 this.router.navigate(['/login']);
  //               }
  //             });
  //           } else {
  //             // Swal.fire(error.error.error.message)
  //             Swal.fire({ title: this.lang.Error??'Error', text: error.error.error.message });
  //           }
  //           // this.toastrService.error("Invalid Credentials", 'Error!');
  //         }
  //       );










  //   })
  // }

  formConfig() {
    // var endPoint = '/api/ap/admin/corporateSignup/formConfig';
    // var accessToken = sessionStorage.getItem('accessToken');

    // this.http
    //   .get(environment.apiUrl + endPoint, {
    //     headers: {
    //       Authorization: 'Bearer ' + accessToken,
    //       'Content-Type': 'application/json',
    //     },
    //   })
    //   .subscribe(
    //     (response: any) => {
    //       if (response['status'] == 200) {
    //         this.companyPaidCoveragePlanLevels = response.data.companyPaidCoveragePlanLevels

    //         this.statesInfo = response.data.states;
    //         this.walletConfig = response.data.walletConfig;
    //         this.waddellExcelKeys = response.data.bulkPlanExcelKeys.waddell
    //         this.allBrokers = response.data.allBrokersUnique;
    //         this.allBrokers = this.allBrokers.sort(
    //           (a: any, b: any) => (a.name > b.name ? 1 : -1)
    //         );

    //         this.payrolldeduction = response.data.payRolldeductionUI;

    //         this.countryList = response.data.allCountrys;
    //         console.log('this.countryList  :', this.countryList);
    //         this.groupContactsData = response.data.groupContactRoles;

    //         this.configprovinceres = response.data.states.sort(
    //           (a: any, b: any) => (a.shortName > b.shortName ? 1 : -1)
    //         );
    //         // this.countryList =response.data.countryList;
    //         this.multiSlectProviances = response.data.countryList[0].countryStates;
    //         this.multiSlectProviances = this.multiSlectProviances.sort(
    //           (a: any, b: any) => (a.shortName > b.shortName ? 1 : -1)
    //         );
    //         console.log(this.multiSlectProviances);
    //         response.data.countryList.forEach((element: any) => {
    //           if (element.countryStates == '1') {
    //             this.multiSlectProviances.push(element);

    //           }
    //         });
    //         this.enrollmentDates = response.data.planEnrollmentDatesFullMonth;

    //         console.log(this.allBrokers);
    //       } else {
    //         Swal.fire({ title: this.lang.Error??'Error', text: response.message });
    //       }
    //     },
    //     (error) => {
    //       if (
    //         error.status == 400 ||
    //         error.status == 401 ||
    //         error.status == 402 ||
    //         error.status == 403
    //       ) {
    //         Swal.fire({
    //           title: this.lang.Error??'Error',
    //           text: error.error.error.message,
    //           showCancelButton: false,
    //           showDenyButton: false,
    //           confirmButtonText: 'Proceed',
    //         }).then((result) => {
    //           /* Read more about isConfirmed, isDenied below */
    //           if (result.isConfirmed) {
    //             sessionStorage.clear();
    //             this.router.navigate(['/login']);
    //           } else {
    //             sessionStorage.clear();
    //             this.router.navigate(['/login']);
    //           }
    //         });
    //       } else {
    //         // Swal.fire(error.error.error.message)
    //         Swal.fire({ title: this.lang.Error??'Error', text: error.error.error.message });
    //       }
    //       // this.toastrService.error("Invalid Credentials", 'Error!');
    //     }
    //   );

    this.store.dispatch(loadCorporateSignupConfigData());
    this.corporateSignupConfigData$ = this.store.select(state => state.corporateSignupConfigData).pipe(
      // startWith([]),
      // takeUntil(this.destroy$)
    );
    this.corporateSignupConfigData$.subscribe(data => {
      if (data) {
        console.log(data)
        if (data?.corporateSignupConfigData == undefined || Object.keys(data.corporateSignupConfigData).length <= 0) {
          console.log('No data to process', new Date().toISOString());
          return;
        }
        if (Object.keys(this.corporateSignupConfigData).length > 0) {
          return;
        }
        this.corporateSignupConfigData = { ...data.corporateSignupConfigData }

        this.companyPaidCoveragePlanLevels = this.corporateSignupConfigData.companyPaidCoveragePlanLevels
        this.statesInfo = [...this.corporateSignupConfigData.states];
        this.walletConfig = this.corporateSignupConfigData.walletConfig;
        this.waddellExcelKeys = this.corporateSignupConfigData.bulkPlanExcelKeys.waddell
        this.allBrokers = this.corporateSignupConfigData.allBrokersUnique;
        this.allBrokers = [...this.allBrokers].sort(
          (a: any, b: any) => (a.name > b.name ? 1 : -1)
        );
        this.getCustomerDetails()
        this.payrolldeduction = this.corporateSignupConfigData.payRolldeductionUI;

        this.countryList = this.corporateSignupConfigData.allCountrys;
        console.log('this.countryList  :', this.countryList);
        this.groupContactsData = this.corporateSignupConfigData.groupContactRoles;

        this.configprovinceres = [...this.corporateSignupConfigData.states].sort(
          (a: any, b: any) => (a.shortName > b.shortName ? 1 : -1)
        );
        // this.countryList =this.corporateSignupConfigData.countryList;
        this.multiSlectProviances = this.corporateSignupConfigData.countryList[0].countryStates;
        this.multiSlectProviances = [...this.multiSlectProviances].sort(
          (a: any, b: any) => (a.shortName > b.shortName ? 1 : -1)
        );
        console.log(this.multiSlectProviances);
        this.corporateSignupConfigData.countryList.forEach((element: any) => {
          if (element.countryStates == '1') {
            this.multiSlectProviances.push(element);

          }
        });
        this.enrollmentDates = this.corporateSignupConfigData.planEnrollmentDatesFullMonth;

      } else {
        console.error('Observable returned undefined');
      }
    })
  }
  // formConfig() {
  //   var endPoint = '/api/ap/admin/corporateSignup/formConfig';
  //   var accessToken = sessionStorage.getItem('accessToken');

  //   this.http
  //     .get(environment.apiUrl + endPoint, {
  //       headers: {
  //         Authorization: 'Bearer ' + accessToken,
  //         'Content-Type': 'application/json',
  //       },
  //     })
  //     .subscribe(
  //       (response: any) => {
  //         if (response['status'] == 200) {
  //           this.getCustomerDetails()
  //           // this.companyPaidCoveragePlanLevels = response.data.companyPaidCoveragePlanLevels

  //           // this.statesInfo = response.data.states;
  //           // this.walletConfig = response.data.walletConfig;
  //           // this.waddellExcelKeys = response.data.bulkPlanExcelKeys.waddell
  //           this.allBrokers = response.data.allBrokersUnique;
  //           this.allBrokers = this.allBrokers.sort(
  //             (a: any, b: any) => (a.name > b.name ? 1 : -1)
  //           );

  //           // this.payrolldeduction = response.data.payRolldeductionUI;

  //           this.countryList = response.data.allCountrys;
  //           console.log('this.countryList  :', this.countryList);
  //           // this.groupContactsData = response.data.groupContactRoles;

  //           this.configprovinceres = response.data.states.sort(
  //             (a: any, b: any) => (a.shortName > b.shortName ? 1 : -1)
  //           );
  //           // this.countryList =response.data.countryList;
  //           this.multiSlectProviances = response.data.countryList[0].countryStates;
  //           this.multiSlectProviances = this.multiSlectProviances.sort(
  //             (a: any, b: any) => (a.shortName > b.shortName ? 1 : -1)
  //           );
  //           console.log(this.multiSlectProviances);
  //           response.data.countryList.forEach((element: any) => {
  //             if (element.countryStates == '1') {
  //               this.multiSlectProviances.push(element);

  //             }
  //           });
  //           this.enrollmentDates = response.data.planEnrollmentDatesFullMonth;

  //           console.log('this.allBrokers', this.allBrokers);
  //           // this.loaderService.HideLoader()
  //         } else {
  //           // this.loaderService.HideLoader()
  //           Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message });
  //         }
  //       },
  //       (error) => {
  //         if (
  //           error.status == 400 ||
  //           error.status == 401 ||
  //           error.status == 402 ||
  //           error.status == 403
  //         ) {
  //           Swal.fire({
  //             title: this.lang.Error ?? 'Error',
  //             text: error.error.error.message,
  //             showCancelButton: false,
  //             showDenyButton: false,
  //             confirmButtonText: 'Proceed',
  //           }).then((result) => {
  //             /* Read more about isConfirmed, isDenied below */
  //             if (result.isConfirmed) {
  //               sessionStorage.clear();
  //               this.router.navigate(['/login']);
  //             } else {
  //               sessionStorage.clear();
  //               this.router.navigate(['/login']);
  //             }
  //           });
  //         } else {
  //           // Swal.fire(error.error.error.message)
  //           Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
  //         }
  //         // this.toastrService.error("Invalid Credentials", 'Error!');
  //       }
  //     );
  // }
  getCustomerDetails() {
    var accessToken = sessionStorage.getItem('accessToken');

    let customerDataEndpoint = '/customer/' + this.gig_customer_id + '/details/first';
    this.http.get(environment.apiUrl + '/api/ap/admin' + customerDataEndpoint, {
      headers: {
        Authorization: 'Bearer ' + accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe(async (response: any) => {
      if (response.status == 200) {
        let provincesArray = []
        this.CorpName = response.data.firstName + " " + response.data.lastName
        this.customerData = response.data;
        this.customerPlans = response.data.customerPlans

        // this.multiSelectProviance = JSON.parse(response.data.province) || "";
        // var numberArray = this.multiSelectProviance.map(str => parseInt(str, 10));
        // this.getprovincelistselection1(this.customerData.country, numberArray);
        this.clientregform.patchValue({
          corporationName: response.data.firstName + " " + response.data.lastName,
          brokerName: this.customerData.advisor.id,
          streetAddress: this.customerData.line1,
          streetAddress2: this.customerData.line2,
          country: this.customerData.country,
          city: this.customerData.city,
          Province: this.customerData.province,
          postalCode: this.customerData.postalCode
        });
        // this.adminform.patchValue({
        //   adminfirstname: this.capitalize(response.data.firstName),
        //   adminlastname: this.capitalize(response.data.lastName),
        //   adminphone: response.data.primaryPhone,
        //   adminemail: response.data.primaryEmail,
        //   role: '',

        // });
        this.multiSlectProviances.forEach((element: any) => {
          if (element.name == this.customerData.province) {
            provincesArray.push(element)
          }
        })

        // console.log(provincesArray)
        this.clientregform.get('PolicyStartDate')?.setValue(this.enrollmentDates[0]);
        this.clientregform.get('multiSelectProviance')?.setValue(provincesArray);

        this.customerAsAnEmployee = "Yes"
        this.getprovincelist1(this.customerData.country)
        this.provincelist1(this.customerData.province)
        this.getBrokerProfiles(this.customerData.advisor.id)

        if (this.customerData.paymentMethod == 'CREDIT_CARD') {
          this.paymentMethodCheck = 'creditcard'

        } else {
          this.paymentMethodCheck = 'pad'
        }
        let obj = {
          firstName: this.capitalize(response.data.firstName),
          lastName: this.capitalize(response.data.lastName),
          phoneNum: response.data.primaryPhone,
          email: response.data.primaryEmail,
          role: 'CORPORATE_PLAN_ADMINISTRATOR',
          roleName: ''
        };
        if (obj.role == 'CORPORATE_OTHERS')
          obj['roleName'] = 'CORPORATE_PLAN_ADMINISTRATOR';

        this.emailAlreadyexist = false;
        for (let admin of this.adminData) {
          if (admin['email'] == obj['email']) {
            await Swal.fire({
              title: 'Info',
              text: 'Email Already exist',
              showDenyButton: false,
              confirmButtonText: 'OK',
            }).then((res) => {
              if (res.isConfirmed) {
                return false;
              }
            });
            this.emailAlreadyexist = true;
            break;
          }
        }
        if (!this.emailAlreadyexist) {
          this.adminData.push(obj);
        }


        this.adminform.reset();
        this.showaddadmin = true;
        this.addadminform = false;
        sessionStorage.setItem('adminData', JSON.stringify(this.adminData));

        // this.adminData= JSON.parse(sessionStorage.getItem("adminData") || "[]")

        $('#basicModal1').modal('hide');
        console.log(this.adminData);
        this.corporateDetails = { ...this.corporateDetails, email: this.adminData[0]?.email }
        console.log('this.corporateDetails email', this.corporateDetails)

      }
    })
  }

  // async getprovincelistselection1(event: any, selectedList: any) {
  //   let uniqueSet = new Set(selectedList);
  //   selectedList = Array.from(uniqueSet);
  //   setTimeout(() => {
  //     this.countryList.forEach((element: any) => {
  //       if (element.name == event) {
  //         this.configprovincereslist1 = element.countryStates;
  //         const stateIdNamePairs: { [key: string]: string } = {};
  //         this.configprovincereslist1.forEach((state: any) => {
  //           // if (selectedList.includes(state.id)) {
  //           //   this._LoggerService.log(state);
  //           // }
  //           for (var i = 0; i < selectedList.length; i++) {
  //             if (selectedList[i] == state.id) {
  //               this.selectedProvinceList.push(state);
  //             }
  //           }
  //           // this._LoggerService.log("this.selectedProvinceList: " + JSON.stringify(this.selectedProvinceList))
  //           stateIdNamePairs[state.id] = state.shortName;
  //         });
  //         // this._LoggerService.log("configprovincereslist1 selected: " + JSON.stringify(this.configprovincereslist1));
  //         this.configprovincereslist1 = this.configprovincereslist1.sort(
  //           (a: any, b: any) => (a.shortName > b.shortName ? 1 : -1)
  //         );
  //         // this._LoggerService.log("configprovincereslist1 after: " + JSON.stringify(this.configprovincereslist1));
  //         const selectedNames = selectedList.map(id => stateIdNamePairs[id]);
  //         // this._LoggerService.log("selectedNames: " + stateIdNamePairs)
  //         this.multiSelectProviancenames = selectedNames;
  //         this.multiProvinceSelectedValues = selectedNames.join(', ');
  //       }
  //     });
  //     // this._LoggerService.log("this.configprovincereslist1: " + JSON.stringify(this.configprovincereslist1))
  //   }, 500);
  // }
  getBrokerProfiles(brokerId: any) {
    var brokerId = brokerId
    this.updatedBrokerId = brokerId;
    var endPoint = '/api/ap/broker/' + brokerId + '/profiles';
    var accessToken = sessionStorage.getItem('accessToken');

    this.http
      .get(environment.apiUrl + endPoint, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe((response: any) => {
        if (response['status'] == 200) {

          this.brokerProfileslistSearch = this.parseAllValuesInArray(response.data.profiles);
          // console.log(this.brokerProfileslist)

          // this.profileid = this.brokerProfileslist1[0]?.originalBrokerId;
          this.profileid = this.brokerProfileslistSearch[0]?.originalBrokerId;
          this.corporateDetails = { ...this.corporateDetails, parentName: this.brokerProfileslist[0]?.additionalData?.brokerFullDetails[0]?.name }
          console.log('this.corporateDetails parentname', this.corporateDetails)
        }
      });
  }
  GetCorpDetails(CorpId: any) {

    return false;
    if (CorpId == '' || CorpId == undefined) {
      this.clientregform.reset();
    } else {
      var endPoint = '/api/ap/admin/corporate/' + CorpId + '/details';
      var accessToken = sessionStorage.getItem('accessToken');
      this.http
        .get(environment.apiUrl + endPoint, {
          headers: {
            Authorization: 'Bearer ' + accessToken,
            'Content-Type': 'application/json',
          },
        })
        .subscribe(
          (response: any) => {
            if (response['status'] == 200) {
              console.log(response);

              this.corpDetails = response.data;

              sessionStorage.setItem(
                'corporateClientId',
                response.data.corporateClientId
              );
              sessionStorage.setItem('corporateId', CorpId);
              this.corpDetails = response.data;
              this.CorpName = response.data.corporationName;
              this.policyStartDate =
                this.datePipe.transform(
                  response.data.policyStartDate,
                  'MM-dd-yyyy'
                ) || '';
              this.domainExisting = response.data.domainExisting;
              this.streetAddress = response.data.streetAddressLine1;
              this.streetAddress2 = response.data.streetAddressLine2;
              this.country = response.data.country;

              this.city = response.data.city;
              this.postalCode = response.data.postalCode;
              this.waitTime = response.data.waitTime;
              this.useCreditCard = response.data.useCreditCard; //true
              this.padPayment = response.data.padPayment; //false
              this.invoicePayment = response.data.invoicePayment; //false
              this.imagedisplay = response.data.logo;
              this.setupWallet = response.data.setupWallet;
              this.setUplevelofCoverage = response.data.setUplevelofCoverage;
              this.adminData = response.data.groupAdmins;
              this.noOfEmployees = response.data.expectedNumberofEmployess;

              this.province = response.data.proviceShortName;
              this.paidByCompany = response.data.plans.paidByCompany;
              this.coveredByCompany = response.data.plans.coveredByCompany;
              this.paidByEmployee = response.data.plans.paidByEmployee;
              this.bulkplans = response.data.bulkPlans;

              this.employeeList = response.data.employees;
              this.addedEmployeelist = response.data.employees;
              this.lengthofemployee = this.employeeList.length;

              this.countryList.forEach((element: any) => {
                if (element.countryId == this.country) {
                  this.configprovincereslist = element.countryStates;
                  this.configprovincereslist = [...this.configprovincereslist].sort(
                    (a: any, b: any) => (a.shortName > b.shortName ? 1 : -1)
                  );

                }
              });
              // this.multiSlectProviances=;

              const dom: HTMLElement = this.elementRef.nativeElement;
              if (this.useCreditCard == true) {
                const element: any = dom.querySelector('#creditpaymentInfo');
                if (element != null) element.click();
              } else if (this.padPayment == true) {
                const element: any = dom.querySelector('#padcreditpaymentInfo');
                if (element != null) element.click();
              } else {
                const element: any = dom.querySelector('#invoicepaymentInfo');
                if (element != null) element.click();
              }
              if (this.waitTime == 0) {
                // alert("Aa")
                const element: any = dom.querySelector('#nowaitingPeriod');
                if (element != null && element != undefined) element.click();
              } else if (this.waitTime == 3) {
                const element: any = dom.querySelector('#threemonths');
                if (element != null && element != undefined) element.click();
              } else if (this.waitTime == 6) {
                const element: any = dom.querySelector('#sixmonths');
                if (element != null && element != undefined) element.click();
              } else {
                const element: any = dom.querySelector('#customselection');
                if (element != null && element != undefined) element.click();
              }

              if (this.policyStartDate && this.policyStartDate.length > 0) {
                this.updateStatus(2);
              }
              if (this.province && this.province.length > 0) {
                this.updateStatus(1);
              }

              if (this.imagedisplay && this.imagedisplay.length > 0) {
                this.showimagelogo = false;
                this.uploadlogoafter = true;
              }

              if (this.adminData.length > 0) {
                sessionStorage.setItem(
                  'adminData',
                  JSON.stringify(this.adminData)
                );
                this.addadminform = false;
                this.showaddadmin = true;
                this.addadminform = false;
                // this.firstName=response.data.groupAdmins;
                for (let admin of this.adminData) {
                  admin['firstName'] = admin['firstName'] ?? '';
                  admin['lastName'] = admin['lastName'] ?? '';
                  admin['phoneNum'] = admin['phoneNum'] ?? '';
                  admin['email'] = admin['email'] ?? '';
                  admin['role'] = admin['role'] ?? '';
                  admin['roleName'] = admin['roleName'] ?? '';
                }
              }
            } else {
              Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message });
            }
          },
          (error) => {
            if (
              error.status == 400 ||
              error.status == 401 ||
              error.status == 402 ||
              error.status == 403
            ) {
              Swal.fire({
                title: this.lang.Error ?? 'Error',
                text: error.error.error.message,
                showCancelButton: false,
                showDenyButton: false,
                confirmButtonText: 'Proceed',
              }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                  sessionStorage.clear();
                  this.router.navigate(['/login']);
                } else {
                  sessionStorage.clear();
                  this.router.navigate(['/login']);
                }
              });
            } else {
              // Swal.fire(error.error.error.message)
              Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
            }
            // this.toastrService.error("Invalid Credentials", 'Error!');
          }
        );
    }
  }

  GetCorpDetails1(CorpId: any) {
    if (CorpId == '' || CorpId == undefined) {
      this.clientregform.reset();
    } else {
      var endPoint = '/api/ap/admin/corporate/' + CorpId + '/details';
      var accessToken = sessionStorage.getItem('accessToken');
      this.http
        .get(environment.apiUrl + endPoint, {
          headers: {
            Authorization: 'Bearer ' + accessToken,
            'Content-Type': 'application/json',
          },
        })
        .subscribe(
          (response: any) => {
            if (response['status'] == 200) {
              console.log(response);

              this.corporateDetailsMain = response.data

              this.bulkplans = response.data.bulkPlans;

              if (response.data.employees.length > 0) {

                // this.employeeList = response.data.employees;
                this.addedEmployeelist = response.data.employees;

                console.log(this.addedEmployeelist)

                this.lengthofemployee = this.employeeList.length;
              }
              this.EmployeeInfo = true;
            } else {
              Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message });
            }
          },
          (error) => {
            if (
              error.status == 400 ||
              error.status == 401 ||
              error.status == 402 ||
              error.status == 403
            ) {
              Swal.fire({
                title: this.lang.Error ?? 'Error',
                text: error.error.error.message,
                showCancelButton: false,
                showDenyButton: false,
                confirmButtonText: 'Proceed',
              }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                  sessionStorage.clear();
                  this.router.navigate(['/login']);
                } else {
                  sessionStorage.clear();
                  this.router.navigate(['/login']);
                }
              });
            } else {
              // Swal.fire(error.error.error.message)
              Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
            }
            // this.toastrService.error("Invalid Credentials", 'Error!');
          }
        );
    }
  }

  ShowCorpDetails(name: any) {
    console.log(name);

    this.clientregform.reset();
    this.CorpName = name;
    this.addadminform = true;
    this.showaddadmin = false;
    this.adminData = '';
  }
  waitingPeriodChange(e: any) {
    if (e.target.value == 'Custom') {
      this.clientregform.get('waitingPeriodCustom').reset();
      this.customSelected = true;
      this.clientregform.get('waitingPeriodCustom').setValidators(Validators.required);
    } else {
      this.customSelected = false;
      this.clientregform.get('waitingPeriodCustom').reset();
      this.clientregform.get('waitingPeriodCustom').clearValidators();
    }
    this.clientregform.get('waitingPeriodCustom').updateValueAndValidity();
  }
  editCorpDetails() {
    // alert("1")
    // $("#fieldsetattr").removeattr
    $('#fieldsetattr').attr('disabled', false);
  }
  onItemSelectTiers(tier: any, planLevel: any) {
    console.log(planLevel);
    console.log(tier.id);

    console.log(tier);

    this.showinput = true;
    this.showinput1 = false;
    // planLevel.tiers.push(tier)   ///check already exit tiers
    // planLevel.tiersidArray.push(tier.id)  //check already exist tierid
    if (planLevel.tiersidArray.includes(tier.id)) {
      planLevel.coverage = ''; //default

      // console.log('default');
    } else {
      // console.log('second');
      planLevel.tiers.push(tier);
      planLevel.tiersidArray.push(tier.id);

      planLevel.tierid = tier.id;
      planLevel.tiername = this.capitalize(tier.name);
      planLevel.coverage = ''; //default
    }

    this.seelctedplanLevelTierMapping.push(planLevel);

    console.log(this.seelctedplanLevelTierMapping);

    //  1.disallowedplans

    // planLevel.disallowedPlanLevels

    //removing all in gold when selecting mind&body

    console.log(planLevel);
    this.unselectPlanLevelTier(
      planLevel.subGroupid,
      planLevel.parentid,
      tier.id,
      planLevel.packageindex,
      planLevel.groupindex,
      planLevel.subgroupindex
    );

    //removing mind & body when selecting all in gold
    if (planLevel.disallowedPlanLevels != null) {
      let disallowed_plans = planLevel.disallowedPlanLevels.split(','); //[1,14,24]
      const dom1: HTMLElement = this.elementRef.nativeElement;

      const disallowed_elements = dom1.querySelectorAll(
        '.plansscreen input.block1tiers'
      );

      for (let i = 0; i < disallowed_elements.length; i++) {
        let elem: any = disallowed_elements[i];
        //id/subgroupid,packageid,parentid,tierid

        if (!elem.attributes.data) {
          continue;
        }

        let plandetails = elem.attributes.data.value;

        let plandetailsobj = plandetails.split('##');

        // console.log('main', plandetailsobj);

        var currentpackageid = plandetailsobj[2];
        var currentparentid = plandetailsobj[3];
        var currentid = plandetailsobj[4];
        var currentpackagename = plandetailsobj[5];

        if (
          disallowed_plans.includes(currentparentid) ||
          disallowed_plans.includes(currentid)
        ) {
          let mappingtiers = this.seelctedplanLevelTierMapping;

          console.log(mappingtiers);

          for (let i = 0; i < mappingtiers.length; i++) {
            if (mappingtiers[i] && mappingtiers[i].subGroupid == currentid) {
              if (mappingtiers[i].tiersidArray.includes(tier.id)) {
                console.log(this.seelctedplanLevelTierMapping[i].tiers);

                this.plansBlock1Tiers[
                  this.seelctedplanLevelTierMapping[i].packageindex
                ]['groups'][this.seelctedplanLevelTierMapping[i].groupindex][
                  'subGroups'
                ][this.seelctedplanLevelTierMapping[i].subgroupindex].checked =
                  false;
                this.plansBlock1Tiers[
                  this.seelctedplanLevelTierMapping[i].packageindex
                ]['groups'][this.seelctedplanLevelTierMapping[i].groupindex][
                  'subGroups'
                ][this.seelctedplanLevelTierMapping[i].subgroupindex].tiers =
                  [];
                console.log(
                  this.selectedPackagePlansInfoTier[currentpackagename]
                );

                console.log(currentid);
                console.log(currentparentid);

                console.log(this.selectedPackagePlansInfoTier);
                let arr = this.selectedPackagePlansInfoTier[currentpackagename];
                let subGroupIdindex;
                for (let i = 0; i < arr.length; i++) {
                  if (arr[i].subGroupid == currentid) {
                    subGroupIdindex = i;
                    break;
                  }
                }

                console.log(subGroupIdindex);

                if (subGroupIdindex > -1) {
                  console.log(subGroupIdindex);
                  this.selectedPackagePlansInfoTier[currentpackagename].splice(
                    subGroupIdindex,
                    1
                  );

                  console.log(this.selectedPackagesassignedTiers2);
                } else {
                  console.log('check1');
                }

                console.log(planLevel.packageId);
                console.log(planLevel.subGroupid);

                this.seelctedplanLevelTierMapping[i] = null;
                //1.remove this tierid from assignedTiers
                //2.Add this tierid to availbleTiers

                console.log(currentpackagename);

                console.log(currentpackageid);
                console.log(this.selectedPackagesassignedTiers2);

                // if(!this.selectedPackagesassignedTiers2[currentpackageid]){
                this.selectedPackagesassignedTiers2[currentpackageid][
                  currentid
                ] = this.selectedPackagesassignedTiers2[currentpackageid][
                  currentid
                ].filter((object) => {
                  console.log(object);
                  return object.id !== tier.id;
                });
                // }

                // let allselectedplans = this.selectedPackagesavailableTiers[currentpackagename]
              }
            }

            // sessionStorage.setItem('plansBlock1Tiers', JSON.stringify(this.plansBlock1Tiers));
          }
        }
      }
    }

    // planid,tierid,selectedplans
    // disallwoed plans --array---eachplan---selectedplans remove

    //  2.availbeltiers ,assigned tiers
    console.log(this.seelctedplanLevelTierMapping);
    console.log(this.selectedPackagePlansInfoTier);
    console.log(this.selectedPackagesassignedTiers2);

    this.seelctedplanLevelTierMapping =
      this.seelctedplanLevelTierMapping.filter((item: any) => item != null);

    console.log(this.seelctedplanLevelTierMapping);

    this.seelctedplanLevelTierMapping = [
      ...new Map(
        this.seelctedplanLevelTierMapping.map((item) => [
          item['subGroupName'],
          item,
        ])
      ).values(),
    ];

    this.seelctedplanLevelTierMapping2 = this.seelctedplanLevelTierMapping;

    if (!this.selectedPackagesavailableTiers[planLevel.packageId]) {
      this.selectedPackagesavailableTiers[planLevel.packageId] =
        this.configureTierList;
    }

    if (!this.selectedPackagesavailableTiers2[planLevel.packageId]) {
      this.selectedPackagesavailableTiers2[planLevel.packageId] = {};
      this.selectedPackagesavailableTiers2[planLevel.packageId][
        planLevel.subGroupid
      ] = this.configureTierList;
    } else {
      if (
        !this.selectedPackagesavailableTiers2[planLevel.packageId][
        planLevel.subGroupid
        ]
      ) {
        this.selectedPackagesavailableTiers2[planLevel.packageId][
          planLevel.subGroupid
        ] = this.configureTierList;
      }
    }

    // console.log(this.selectedPackagesavailableTiers[planLevel.packageName]);
    if (!this.selectedPackagesassignedTiers[planLevel.packageId]) {
      this.selectedPackagesassignedTiers[planLevel.packageId] = [];
    }

    if (!this.selectedPackagesassignedTiers2[planLevel.packageId]) {
      this.selectedPackagesassignedTiers2[planLevel.packageId] = {};
      this.selectedPackagesassignedTiers2[planLevel.packageId][
        planLevel.subGroupid
      ] = [];
    } else {
      if (
        !this.selectedPackagesassignedTiers2[planLevel.packageId][
        planLevel.subGroupid
        ]
      ) {
        this.selectedPackagesassignedTiers2[planLevel.packageId][
          planLevel.subGroupid
        ] = [];
      }
    }

    const exists =
      this.selectedPackagesassignedTiers[planLevel.packageId].findIndex(
        (item) => item.id === tier.id
      ) > -1;
    if (exists) {
      console.log('check');
    } else {
      this.selectedPackagesassignedTiers[planLevel.packageId].push(tier);

      let availablearray = this.selectedPackagesavailableTiers[
        planLevel.packageId
      ].filter((object) => {
        return object.id !== tier.id;
      });

      this.selectedPackagesavailableTiers[planLevel.packageId] = availablearray;
    }

    const exists2 =
      this.selectedPackagesassignedTiers2[planLevel.packageId][
        planLevel.subGroupid
      ].findIndex((item) => item.id === tier.id) > -1;
    if (exists2) {
      console.log('check2');
      let groups = Object.keys(
        this.selectedPackagesavailableTiers2[planLevel.packageId]
      );

      console.log(groups);

      for (let group of groups) {
        if (group == planLevel.subGroupid) {
          continue;
        }
        if (!this.selectedPackagesavailableTiers2[planLevel.packageId][group]) {
          console.log('assigningCOnfigTierlist');
          this.selectedPackagesavailableTiers2[planLevel.packageId][group] =
            this.configureTierList;

          console.log(this.configureTierList);
        } else {
          console.log('alrradyexist');
        }
        let availablearray2 = this.selectedPackagesavailableTiers2[
          planLevel.packageId
        ][group].filter((object) => {
          return object.id !== tier.id;
        });

        console.log(availablearray2);
        this.selectedPackagesavailableTiers2[planLevel.packageId][group] =
          availablearray2; //Here Close
      }
    } else {
      console.log('else check2');

      let assignedarry2 = [];
      assignedarry2 =
        this.selectedPackagesassignedTiers2[planLevel.packageId][
        planLevel.subGroupid
        ];
      assignedarry2.push(tier);

      this.selectedPackagesassignedTiers2[planLevel.packageId][
        planLevel.subGroupid
      ] = assignedarry2;
    }
    // console.log(this.seelctedplanLevelTierMapping);
    // console.log(this.selectedPackagesavailableTiers);
    // console.log(this.selectedPackagesassignedTiers);

    // console.log(this.seelctedplanLevelTierMapping2);
    // console.log(this.selectedPackagesavailableTiers2);
    // console.log(this.selectedPackagesassignedTiers2);

    // sessionStorage.setItem("seelctedplanLevelTierMapping",JSON.stringify(this.seelctedplanLevelTierMapping))
  }

  onItemSelectTiersBlock2(tier: any, planLevel: any) {
    // console.log(planLevel)

    // planLevel.tiers.push(tier)   ///check already exit tiers
    // planLevel.tiersidArray.push(tier.id)  //check already exist tierid

    this.showinputBlock2 = true;
    this.showinput1Block2 = false;

    console.log(this.seelctedplanLevelTierMappingBlock2);

    if (planLevel.tiersidArray.includes(tier.id)) {
      planLevel.coverage = ''; //default
    } else {
      planLevel.tiers.push(tier);
      planLevel.tiersidArray.push(tier.id);

      planLevel.tierid = tier.id;
      planLevel.tiername = this.capitalize(tier.name);
      planLevel.coverage = ''; //default
    }

    this.seelctedplanLevelTierMappingBlock2.push(planLevel);

    console.log(this.seelctedplanLevelTierMappingBlock2);

    //  1.disallowedplans

    // planLevel.disallowedPlanLevels

    //removing all in gold when selecting mind&body

    console.log(planLevel);
    this.unselectPlanLevelTierBlock2(
      planLevel.subGroupid,
      planLevel.parentid,
      tier.id
    );

    //removing mind & body when selecting all in gold
    if (planLevel.disallowedPlanLevels != null) {
      let disallowed_plans = planLevel.disallowedPlanLevels.split(','); //[1,10,14]
      const dom1: HTMLElement = this.elementRef.nativeElement;

      const disallowed_elements = dom1.querySelectorAll(
        '.plansscreen input.block2tiers'
      );

      for (let i = 0; i < disallowed_elements.length; i++) {
        let elem: any = disallowed_elements[i];
        //id/subgroupid,packageid,parentid,tierid

        if (!elem.attributes.data) {
          continue;
        }

        let plandetails = elem.attributes.data.value;

        let plandetailsobj = plandetails.split('##');

        // console.log('main', plandetailsobj);

        var currentpackageid = plandetailsobj[2];
        var currentparentid = plandetailsobj[3];
        var currentid = plandetailsobj[4];
        var currentpackagename = plandetailsobj[5];

        if (
          disallowed_plans.includes(currentparentid) ||
          disallowed_plans.includes(currentid)
        ) {
          let mappingtiers = this.seelctedplanLevelTierMappingBlock2;

          for (let i = 0; i < mappingtiers.length; i++) {
            if (mappingtiers[i] && mappingtiers[i].subGroupid == currentid) {
              if (mappingtiers[i].tiersidArray.includes(tier.id)) {
                // if (mappingtiers[i].tierid==tier.id) {
                //remove this plan from seelctedplanLevelTierMapping

                console.log(this.seelctedplanLevelTierMappingBlock2[i].tiers);

                //  const index = this.seelctedplanLevelTierMapping[i].tiers.findIndex((item) => item.id === tier.id);
                //  if (index !== -1) {
                //   this.seelctedplanLevelTierMapping[i].tiers.splice(index, 1);
                //    return this.seelctedplanLevelTierMapping[i].tiers;
                //  }

                this.plansresblack2Tiers[
                  this.seelctedplanLevelTierMappingBlock2[i].packageindex
                ]['groups'][
                  this.seelctedplanLevelTierMappingBlock2[i].groupindex
                ]['subGroups'][
                  this.seelctedplanLevelTierMappingBlock2[i].subgroupindex
                ].checked = false;
                this.plansresblack2Tiers[
                  this.seelctedplanLevelTierMappingBlock2[i].packageindex
                ]['groups'][
                  this.seelctedplanLevelTierMappingBlock2[i].groupindex
                ]['subGroups'][
                  this.seelctedplanLevelTierMappingBlock2[i].subgroupindex
                ].tiers = [];

                let arr =
                  this.selectedPackagePlansInfoTierBlock2[currentpackagename];
                let subGroupIdindex;
                for (let i = 0; i < arr.length; i++) {
                  if (arr[i].subGroupid == currentid) {
                    subGroupIdindex = i;
                    break;
                  }
                }

                console.log(subGroupIdindex);

                if (subGroupIdindex > -1) {
                  console.log(subGroupIdindex);
                  this.selectedPackagePlansInfoTierBlock2[
                    currentpackagename
                  ].splice(subGroupIdindex, 1);

                  console.log(this.selectedPackagePlansInfoTierBlock2);
                } else {
                  console.log('check1');
                }
                this.seelctedplanLevelTierMappingBlock2[i] = null;
                //1.remove this tierid from assignedTiers
                //2.Add this tierid to availbleTiers

                this.selectedPackagesavailableTiers2Block2[currentpackageid][
                  currentid
                ] = this.selectedPackagesavailableTiers2Block2[
                  currentpackageid
                ][currentid].filter((object) => {
                  console.log(object);
                  return object.id !== tier.id;
                });

                // console.log(
                //   this.selectedPackagesavailableTiersBlock2[currentpackagename]
                // );
                // this.selectedPackagesavailableTiersBlock2[
                //   currentpackagename
                // ].push(tier);

                // let allselectedplans = this.selectedPackagesavailableTiers[currentpackagename]
              }
            }
          }
        }
      }
    }

    // planid,tierid,selectedplans
    // disallwoed plans --array---eachplan---selectedplans remove

    //  2.availbeltiers ,assigned tiers
    console.log(this.seelctedplanLevelTierMappingBlock2);

    this.seelctedplanLevelTierMappingBlock2 =
      this.seelctedplanLevelTierMappingBlock2.filter(
        (item: any) => item != null
      );

    console.log(this.seelctedplanLevelTierMappingBlock2);

    this.seelctedplanLevelTierMappingBlock2 = [
      ...new Map(
        this.seelctedplanLevelTierMappingBlock2.map((item) => [
          item['subGroupName'],
          item,
        ])
      ).values(),
    ];

    this.seelctedplanLevelTierMapping2Block2 =
      this.seelctedplanLevelTierMappingBlock2;
    // console.log(this.seelctedplanLevelTierMapping);

    // for(let i=0;i<this.seelctedplanLevelTierMapping.length;i++){
    //   const dom: HTMLElement = this.elementRef.nativeElement;
    //   const element: any = dom.querySelector("#plancheck" + this.seelctedplanLevelTierMapping[i].subGroupid);

    //     element.click()
    // }

    // this.plansBlock1[planLevel.packageindex]['groups'][planLevel.groupindex][
    //   'subGroups'
    // ][planLevel.subgroupindex].checked = true;

    if (!this.selectedPackagesavailableTiersBlock2[planLevel.packageId]) {
      this.selectedPackagesavailableTiersBlock2[planLevel.packageId] =
        this.configureTierList;
    }
    if (!this.selectedPackagesavailableTiers2Block2[planLevel.packageId]) {
      this.selectedPackagesavailableTiers2Block2[planLevel.packageId] = {};
      this.selectedPackagesavailableTiers2Block2[planLevel.packageId][
        planLevel.subGroupid
      ] = this.configureTierList;
    } else {
      if (
        !this.selectedPackagesavailableTiers2Block2[planLevel.packageId][
        planLevel.subGroupid
        ]
      ) {
        this.selectedPackagesavailableTiers2Block2[planLevel.packageId][
          planLevel.subGroupid
        ] = this.configureTierList;
      }
    }

    // console.log(this.selectedPackagesavailableTiers[planLevel.packageName]);
    if (!this.selectedPackagesassignedTiersBlock2[planLevel.packageId]) {
      this.selectedPackagesassignedTiersBlock2[planLevel.packageId] = [];
    }

    if (!this.selectedPackagesassignedTiers2Block2[planLevel.packageId]) {
      this.selectedPackagesassignedTiers2Block2[planLevel.packageId] = {};
      this.selectedPackagesassignedTiers2Block2[planLevel.packageId][
        planLevel.subGroupid
      ] = [];
    } else {
      if (
        !this.selectedPackagesassignedTiers2Block2[planLevel.packageId][
        planLevel.subGroupid
        ]
      ) {
        this.selectedPackagesassignedTiers2Block2[planLevel.packageId][
          planLevel.subGroupid
        ] = [];
      }
    }

    const exists =
      this.selectedPackagesassignedTiersBlock2[planLevel.packageId].findIndex(
        (item) => item.id === tier.id
      ) > -1;
    if (exists) {
      console.log('check');
    } else {
      // this.selectedPackagesassignedTiersBlock2[planLevel.packageId].push(tier);
      // let availablearray = this.selectedPackagesavailableTiersBlock2[
      //   planLevel.packageId
      // ].filter((object) => {
      //   return object.id !== tier.id;
      // });
      // this.selectedPackagesavailableTiersBlock2[planLevel.packageId] =
      //   availablearray;
    }

    const exists2 =
      this.selectedPackagesassignedTiers2Block2[planLevel.packageId][
        planLevel.subGroupid
      ].findIndex((item) => item.id === tier.id) > -1;
    if (exists2) {
      console.log('check2');
      let groups = Object.keys(
        this.selectedPackagesavailableTiers2Block2[planLevel.packageId]
      );

      console.log(groups);

      for (let group of groups) {
        if (group == planLevel.subGroupid) {
          continue;
        }
        if (
          !this.selectedPackagesavailableTiers2Block2[planLevel.packageId][
          group
          ]
        ) {
          console.log('assigningCOnfigTierlist');
          this.selectedPackagesavailableTiers2Block2[planLevel.packageId][
            group
          ] = this.configureTierList;
        } else {
          console.log('alrradyexist');
        }
        let availablearray2 = this.selectedPackagesavailableTiers2Block2[
          planLevel.packageId
        ][group].filter((object) => {
          return object.id !== tier.id;
        });
        this.selectedPackagesavailableTiers2Block2[planLevel.packageId][group] =
          availablearray2;
      }
    } else {
      console.log('else check2');

      let assignedarry2block2 = [];
      assignedarry2block2 =
        this.selectedPackagesassignedTiers2Block2[planLevel.packageId][
        planLevel.subGroupid
        ];
      assignedarry2block2.push(tier);

      this.selectedPackagesassignedTiers2Block2[planLevel.packageId][
        planLevel.subGroupid
      ] = assignedarry2block2;
    }
    // console.log(this.seelctedplanLevelTierMappingBlock2);
    // console.log(this.selectedPackagesavailableTiersBlock2);
    // console.log(this.selectedPackagesassignedTiersBlock2);

    // console.log(this.seelctedplanLevelTierMapping2Block2);
    // console.log(this.selectedPackagesavailableTiers2Block2);
    // console.log(this.selectedPackagesassignedTiers2Block2);

    // sessionStorage.setItem("seelctedplanLevelTierMapping",JSON.stringify(this.seelctedplanLevelTierMapping))
  }
  onItemSelectTiersBlock3(tier: any, planLevel: any) {
    // console.log('123456789098765432345678', planLevel);

    // planLevel.tiers.push(tier)   ///check already exit tiers
    // planLevel.tiersidArray.push(tier.id)  //check already exist tierid

    this.showinputBlock3 = true;
    this.showinput1Block3 = false;

    if (planLevel.tiersidArray.includes(tier.id)) {
      planLevel.coverage = ''; //default
    } else {
      planLevel.tiers.push(tier);
      planLevel.tiersidArray.push(tier.id);

      planLevel.tierid = tier.id;
      planLevel.tiername = this.capitalize(tier.name);
      planLevel.coverage = ''; //default
    }

    this.seelctedplanLevelTierMappingBlock3.push(planLevel);

    console.log(this.seelctedplanLevelTierMappingBlock3);

    //  1.disallowedplans

    // planLevel.disallowedPlanLevels

    //removing all in gold when selecting mind&body

    console.log(planLevel);
    this.unselectPlanLevelTierBlock3(
      planLevel.subGroupid,
      planLevel.parentid,
      tier.id
    );

    //removing mind & body when selecting all in gold
    if (planLevel.disallowedPlanLevels != null) {
      let disallowed_plans = planLevel.disallowedPlanLevels.split(','); //[1,10,14]
      const dom1: HTMLElement = this.elementRef.nativeElement;

      const disallowed_elements = dom1.querySelectorAll(
        '.plansscreen input.block3tiers'
      );

      for (let i = 0; i < disallowed_elements.length; i++) {
        let elem: any = disallowed_elements[i];
        //id/subgroupid,packageid,parentid,tierid

        if (!elem.attributes.data) {
          continue;
        }

        let plandetails = elem.attributes.data.value;

        let plandetailsobj = plandetails.split('##');

        // console.log('main', plandetailsobj);

        var currentpackageid = plandetailsobj[2];
        var currentparentid = plandetailsobj[3];
        var currentid = plandetailsobj[4];
        var currentpackagename = plandetailsobj[5];

        if (
          disallowed_plans.includes(currentparentid) ||
          disallowed_plans.includes(currentid)
        ) {
          let mappingtiers = this.seelctedplanLevelTierMappingBlock3;

          for (let i = 0; i < mappingtiers.length; i++) {
            if (mappingtiers[i] && mappingtiers[i].subGroupid == currentid) {
              if (mappingtiers[i].tiersidArray.includes(tier.id)) {
                // if (mappingtiers[i].tierid==tier.id) {
                //remove this plan from seelctedplanLevelTierMapping

                console.log(this.seelctedplanLevelTierMappingBlock3[i].tiers);

                //  const index = this.seelctedplanLevelTierMapping[i].tiers.findIndex((item) => item.id === tier.id);
                //  if (index !== -1) {
                //   this.seelctedplanLevelTierMapping[i].tiers.splice(index, 1);
                //    return this.seelctedplanLevelTierMapping[i].tiers;
                //  }

                this.plansresblack3Tiers[
                  this.seelctedplanLevelTierMappingBlock3[i].packageindex
                ]['groups'][
                  this.seelctedplanLevelTierMappingBlock3[i].groupindex
                ]['subGroups'][
                  this.seelctedplanLevelTierMappingBlock3[i].subgroupindex
                ].checked = false;

                this.plansresblack3Tiers[
                  this.seelctedplanLevelTierMappingBlock3[i].packageindex
                ]['groups'][
                  this.seelctedplanLevelTierMappingBlock3[i].groupindex
                ]['subGroups'][
                  this.seelctedplanLevelTierMappingBlock3[i].subgroupindex
                ].tiers = [];
                let arr =
                  this.selectedPackagePlansInfoTierBlock3[currentpackagename];
                let subGroupIdindex;
                for (let i = 0; i < arr.length; i++) {
                  if (arr[i].subGroupid == currentid) {
                    subGroupIdindex = i;
                    break;
                  }
                }

                console.log(subGroupIdindex);

                if (subGroupIdindex > -1) {
                  console.log(subGroupIdindex);
                  this.selectedPackagePlansInfoTierBlock3[
                    currentpackagename
                  ].splice(subGroupIdindex, 1);

                  console.log(this.selectedPackagePlansInfoTierBlock3);
                } else {
                  console.log('check1');
                }

                this.seelctedplanLevelTierMappingBlock3[i] = null;
                //1.remove this tierid from assignedTiers
                //2.Add this tierid to availbleTiers

                this.selectedPackagesavailableTiers3Block3[currentpackageid][
                  currentid
                ] = this.selectedPackagesavailableTiers3Block3[
                  currentpackageid
                ][currentid].filter((object) => {
                  console.log(object);
                  return object.id !== tier.id;
                });

                console.log(
                  this.selectedPackagesavailableTiersBlock3[currentpackagename]
                );
                this.selectedPackagesavailableTiersBlock3[
                  currentpackagename
                ].push(tier);

                // let allselectedplans = this.selectedPackagesavailableTiers[currentpackagename]
              }
            }
          }
        }
      }
    }

    // planid,tierid,selectedplans
    // disallwoed plans --array---eachplan---selectedplans remove

    //  2.availbeltiers ,assigned tiers
    console.log(this.seelctedplanLevelTierMappingBlock3);

    this.seelctedplanLevelTierMappingBlock3 =
      this.seelctedplanLevelTierMappingBlock3.filter(
        (item: any) => item != null
      );

    console.log(this.seelctedplanLevelTierMappingBlock3);

    this.seelctedplanLevelTierMappingBlock3 = [
      ...new Map(
        this.seelctedplanLevelTierMappingBlock3.map((item) => [
          item['subGroupName'],
          item,
        ])
      ).values(),
    ];

    this.seelctedplanLevelTierMapping3Block3 =
      this.seelctedplanLevelTierMappingBlock3;

    if (!this.selectedPackagesavailableTiersBlock3[planLevel.packageId]) {
      this.selectedPackagesavailableTiersBlock3[planLevel.packageId] =
        this.configureTierList;
    }
    if (!this.selectedPackagesavailableTiers3Block3[planLevel.packageId]) {
      this.selectedPackagesavailableTiers3Block3[planLevel.packageId] = {};
      this.selectedPackagesavailableTiers3Block3[planLevel.packageId][
        planLevel.subGroupid
      ] = this.configureTierList;
    } else {
      if (
        !this.selectedPackagesavailableTiers3Block3[planLevel.packageId][
        planLevel.subGroupid
        ]
      ) {
        this.selectedPackagesavailableTiers3Block3[planLevel.packageId][
          planLevel.subGroupid
        ] = this.configureTierList;
      }
    }

    // console.log(this.selectedPackagesavailableTiers[planLevel.packageName]);
    if (!this.selectedPackagesassignedTiersBlock3[planLevel.packageId]) {
      this.selectedPackagesassignedTiersBlock3[planLevel.packageId] = [];
    }
    if (!this.selectedPackagesassignedTiers3Block3[planLevel.packageId]) {
      this.selectedPackagesassignedTiers3Block3[planLevel.packageId] = {};
      this.selectedPackagesassignedTiers3Block3[planLevel.packageId][
        planLevel.subGroupid
      ] = [];
    } else {
      if (
        !this.selectedPackagesassignedTiers3Block3[planLevel.packageId][
        planLevel.subGroupid
        ]
      ) {
        this.selectedPackagesassignedTiers3Block3[planLevel.packageId][
          planLevel.subGroupid
        ] = [];
      }
    }

    const exists =
      this.selectedPackagesassignedTiersBlock3[planLevel.packageId].findIndex(
        (item) => item.id === tier.id
      ) > -1;
    if (exists) {
      console.log('check');
    } else {
      // this.selectedPackagesassignedTiersBlock3[planLevel.packageId].push(tier);
      // let availablearray = this.selectedPackagesavailableTiersBlock3[
      //   planLevel.packageId
      // ].filter((object) => {
      //   return object.id !== tier.id;
      // });
      // this.selectedPackagesavailableTiersBlock3[planLevel.packageId] =
      //   availablearray;
    }

    const exists2 =
      this.selectedPackagesassignedTiers3Block3[planLevel.packageId][
        planLevel.subGroupid
      ].findIndex((item) => item.id === tier.id) > -1;
    if (exists2) {
      console.log('check2');
      let groups = Object.keys(
        this.selectedPackagesavailableTiers3Block3[planLevel.packageId]
      );

      console.log(groups);

      for (let group of groups) {
        if (group == planLevel.subGroupid) {
          continue;
        }
        if (
          !this.selectedPackagesavailableTiers3Block3[planLevel.packageId][
          group
          ]
        ) {
          console.log('assigningCOnfigTierlist');
          this.selectedPackagesavailableTiers3Block3[planLevel.packageId][
            group
          ] = this.configureTierList;
        } else {
          console.log('alrradyexist');
        }
        let availablearray2 = this.selectedPackagesavailableTiers3Block3[
          planLevel.packageId
        ][group].filter((object) => {
          return object.id !== tier.id;
        });
        this.selectedPackagesavailableTiers3Block3[planLevel.packageId][group] =
          availablearray2;
      }
    } else {
      console.log('else check2');

      let assignedarry2block3 = [];
      assignedarry2block3 =
        this.selectedPackagesassignedTiers3Block3[planLevel.packageId][
        planLevel.subGroupid
        ];
      assignedarry2block3.push(tier);

      this.selectedPackagesassignedTiers3Block3[planLevel.packageId][
        planLevel.subGroupid
      ] = assignedarry2block3;
    }
    console.log(this.seelctedplanLevelTierMappingBlock3);
    console.log(this.selectedPackagesavailableTiersBlock3);
    console.log(this.selectedPackagesassignedTiersBlock3);

    console.log(this.seelctedplanLevelTierMapping3Block3);
    console.log(this.selectedPackagesavailableTiers3Block3);
    console.log(this.selectedPackagesassignedTiers3Block3);

    // sessionStorage.setItem("seelctedplanLevelTierMapping",JSON.stringify(this.seelctedplanLevelTierMapping))
  }

  showSlectedPlansTiers() {
    console.log(this.seelctedplanLevelTierMapping);
    const dom: HTMLElement = this.elementRef.nativeElement;
    const elements: any = dom.querySelectorAll('input.block1tiers');

    for (let element of elements) {
      // console.log(element);
      element.checked = false;
    }

    let slectedTierBlcok1 = [];
    for (let i = 0; i < this.seelctedplanLevelTierMapping.length; i++) {
      let selecplanLevel = this.seelctedplanLevelTierMapping[i];
      if (
        this.seelctedplanLevelTierMapping[i].subGroupName ==
        'Complete Executive Care' ||
        this.seelctedplanLevelTierMapping[i].subGroupName == 'Executive Health'
      ) {
        //default
        if (this.seelctedplanLevelTierMapping[i].coverage == '') {
          this.seelctedplanLevelTierMapping[i].coverage = '001';
        }
      }
      const dom: HTMLElement = this.elementRef.nativeElement;
      const element: any = dom.querySelector(
        '#plancheck' + selecplanLevel.subGroupid
      );

      element.checked = true;
      this.plansBlock1Tiers[selecplanLevel.packageindex]['groups'][
        selecplanLevel.groupindex
      ]['subGroups'][selecplanLevel.subgroupindex].checked = true;
      this.plansBlock1Tiers[selecplanLevel.packageindex]['groups'][
        selecplanLevel.groupindex
      ]['subGroups'][selecplanLevel.subgroupindex].tiers = selecplanLevel.tiers;

      let tiersarray = selecplanLevel.tiers;

      for (let j = 0; j < tiersarray.length; j++) {
        slectedTierBlcok1.push(tiersarray[j].name);
      }
    }
  }
  showSlectedPlansTiersBlock2() {
    console.log(this.seelctedplanLevelTierMappingBlock2);
    const dom: HTMLElement = this.elementRef.nativeElement;
    const elements: any = dom.querySelectorAll('input.block2tiers');

    for (let element of elements) {
      // console.log(element);
      element.checked = false;
    }

    let slectedTierBlcok1 = [];
    for (let i = 0; i < this.seelctedplanLevelTierMappingBlock2.length; i++) {
      let selecplanLevel = this.seelctedplanLevelTierMappingBlock2[i];

      if (
        this.seelctedplanLevelTierMappingBlock2[i].subGroupName ==
        'Complete Executive Care' ||
        this.seelctedplanLevelTierMappingBlock2[i].subGroupName ==
        'Executive Health'
      ) {
        //default
        if (this.seelctedplanLevelTierMappingBlock2[i].coverage == '') {
          this.seelctedplanLevelTierMappingBlock2[i].coverage = '001';
        }
      }

      const dom: HTMLElement = this.elementRef.nativeElement;
      const element: any = dom.querySelector(
        '#plancheck2Upgrade' + selecplanLevel.subGroupid
      );

      element.checked = true;
      this.plansresblack2Tiers[selecplanLevel.packageindex]['groups'][
        selecplanLevel.groupindex
      ]['subGroups'][selecplanLevel.subgroupindex].checked = true;
      this.plansresblack2Tiers[selecplanLevel.packageindex]['groups'][
        selecplanLevel.groupindex
      ]['subGroups'][selecplanLevel.subgroupindex].tiers = selecplanLevel.tiers;

      let tiersarray = selecplanLevel.tiers;

      for (let j = 0; j < tiersarray.length; j++) {
        slectedTierBlcok1.push(tiersarray[j].name);
      }
    }
  }
  showSlectedPlansTiersBlock3() {
    console.log(this.seelctedplanLevelTierMappingBlock3);

    const dom: HTMLElement = this.elementRef.nativeElement;
    const elements: any = dom.querySelectorAll('input.block3tiers');

    for (let element of elements) {
      console.log(element);
      element.checked = false;
    }

    let slectedTierBlcok1 = [];
    for (let i = 0; i < this.seelctedplanLevelTierMappingBlock3.length; i++) {
      let selecplanLevel = this.seelctedplanLevelTierMappingBlock3[i];
      if (
        this.seelctedplanLevelTierMappingBlock3[i].subGroupName ==
        'Complete Executive Care' ||
        this.seelctedplanLevelTierMappingBlock3[i].subGroupName ==
        'Executive Health'
      ) {
        //default
        if (this.seelctedplanLevelTierMappingBlock3[i].coverage == '') {
          this.seelctedplanLevelTierMappingBlock3[i].coverage = '001';
        }
      }
      const dom: HTMLElement = this.elementRef.nativeElement;
      const element: any = dom.querySelector(
        '#plancheck3Voluntry' + selecplanLevel.subGroupid
      );

      element.checked = true;
      this.plansresblack3Tiers[selecplanLevel.packageindex]['groups'][
        selecplanLevel.groupindex
      ]['subGroups'][selecplanLevel.subgroupindex].checked = true;
      this.plansresblack3Tiers[selecplanLevel.packageindex]['groups'][
        selecplanLevel.groupindex
      ]['subGroups'][selecplanLevel.subgroupindex].tiers = selecplanLevel.tiers;

      let tiersarray = selecplanLevel.tiers;

      for (let j = 0; j < tiersarray.length; j++) {
        slectedTierBlcok1.push(tiersarray[j].name);
      }
    }
  }
  onItemremoveTiers(tier: any, planLevel: any) {
    // 1.remove tier from selected list ui
    // 2.Remove from assigned tiers
    // 3.Add to Availabel Tiers
    // 4.Remove from Selected Plans

    console.log(tier);
    console.log(planLevel);

    // this.selectedPackagesassignedTiers[planLevel.packageId] =
    //   this.selectedPackagesassignedTiers[planLevel.packageId].filter(
    //     (object) => {
    //       return object.id !== tier.id;
    //     }
    //   );

    console.log(this.selectedPackagesassignedTiers2);
    console.log(this.selectedPackagesavailableTiers2);

    if (!this.selectedPackagesassignedTiers2[planLevel.packageId]) {
      this.selectedPackagesassignedTiers2[planLevel.packageId] =
        this.selectedPackagesassignedTiers2[planLevel.packageId].filter(
          (object) => {
            return object.id !== tier.id;
          }
        );
    }

    let groups = Object.keys(
      this.selectedPackagesavailableTiers2[planLevel.packageId]
    );

    console.log(groups);

    for (let group of groups) {
      console.log(group);
      console.log(planLevel.subGroupid);
      if (group == planLevel.subGroupid) {
        continue;
      }
      if (!this.selectedPackagesavailableTiers2[planLevel.packageId][group]) {
        this.selectedPackagesavailableTiers2[planLevel.packageId][group] = [];
        console.log('CheckingassigningCOnfigTierlist');
      } else {
        console.log('alrradyexist');
      }
      // console.log(this.selectedPackagesassignedTiers2)
      let available2 = [];
      available2 =
        this.selectedPackagesavailableTiers2[planLevel.packageId][group];

      available2.push(tier);
      this.selectedPackagesavailableTiers2[planLevel.packageId][group] =
        available2;
    }

    this.showinput = false;
    this.showinput1 = true;

    console.log(this.selectedPackagesavailableTiers2);

    this.selectedPackagesavailableTiers21 =
      this.selectedPackagesavailableTiers2;
    this.selectedPackagesassignedTiers21 = this.selectedPackagesassignedTiers2;

    let mappingtiers = this.seelctedplanLevelTierMapping;

    for (let i = 0; i < mappingtiers.length; i++) {
      console.log(mappingtiers[i].subGroupid);
      console.log(planLevel.subGroupid);
      if (
        mappingtiers[i] &&
        mappingtiers[i].subGroupid == planLevel.subGroupid
      ) {
        for (let j = 0; j < mappingtiers[i].tiers.length; j++) {
          if (mappingtiers[i].tiers[j].id == tier.id) {
            mappingtiers[i].tiers[j] = null;
            // console.log("checkhere")
          }

          if (mappingtiers[i].tiersidArray.includes(tier.id)) {
            mappingtiers[i].tiersidArray.splice(i, 1);
          }
        }

        if (mappingtiers[i].tiers.length > 0) {
          mappingtiers[i].tiers = mappingtiers[i].tiers.filter(
            (item: any) => item != null
          );
        }
      }
    }

    this.seelctedplanLevelTierMapping = mappingtiers;

    this.seelctedplanLevelTierMapping =
      this.seelctedplanLevelTierMapping.filter((item: any) => item != null);

    console.log(this.seelctedplanLevelTierMapping);
  }

  checkhere() {
    setTimeout(() => {
      console.log(this.selectedPackagesavailableTiers21);
      console.log(this.selectedPackagesassignedTiers21);
    }, 1000);
  }
  onItemremoveTiersBlock2(tier: any, planLevel: any) {
    // 1.remove tier from seelcted list ui
    // 2.Remove from assigned tiers
    // 3.Add to Availabel Tiers
    // 4.Remove from Seelcted Plans

    if (!this.selectedPackagesassignedTiers2Block2[planLevel.packageId]) {
      this.selectedPackagesassignedTiers2Block2[planLevel.packageId] =
        this.selectedPackagesassignedTiers2Block2[planLevel.packageId].filter(
          (object) => {
            return object.id !== tier.id;
          }
        );
    }

    console.log(this.selectedPackagesassignedTiers2Block2);

    // this.selectedPackagesavailableTiersBlock2[planLevel.packageId].push(tier);

    let groups = Object.keys(
      this.selectedPackagesavailableTiers2Block2[planLevel.packageId]
    );

    console.log(groups);

    for (let group of groups) {
      console.log(group);
      console.log(planLevel.subGroupid);
      if (group == planLevel.subGroupid) {
        continue;
      }
      if (
        !this.selectedPackagesavailableTiers2Block2[planLevel.packageId][group]
      ) {
        this.selectedPackagesavailableTiers2Block2[planLevel.packageId][group] =
          [];
        console.log('CheckingassigningCOnfigTierlist');
      } else {
        console.log('alrradyexist');
      }
      // console.log(this.selectedPackagesassignedTiers2)
      let available2 = [];
      available2 =
        this.selectedPackagesavailableTiers2Block2[planLevel.packageId][group];

      available2.push(tier);
      this.selectedPackagesavailableTiers2Block2[planLevel.packageId][group] =
        available2;
    }

    this.showinputBlock2 = false;
    this.showinput1Block2 = true;

    console.log(this.selectedPackagesavailableTiers2Block2);

    this.selectedPackagesavailableTiers2Block21 =
      this.selectedPackagesavailableTiers2Block2;
    this.selectedPackagesassignedTiers2Block21 =
      this.selectedPackagesassignedTiers2Block2;

    let mappingtiers = this.seelctedplanLevelTierMappingBlock2;

    for (let i = 0; i < mappingtiers.length; i++) {
      console.log(mappingtiers[i].subGroupid);
      console.log(planLevel.subGroupid);
      if (
        mappingtiers[i] &&
        mappingtiers[i].subGroupid == planLevel.subGroupid
      ) {
        for (let j = 0; j < mappingtiers[i].tiers.length; j++) {
          if (mappingtiers[i].tiers[j].id == tier.id) {
            mappingtiers[i].tiers[j] = null;
            // console.log("checkhere")
          }
          if (mappingtiers[i].tiersidArray.includes(tier.id)) {
            mappingtiers[i].tiersidArray.splice(i, 1);
          }
        }

        if (mappingtiers[i].tiers.length > 0) {
          mappingtiers[i].tiers = mappingtiers[i].tiers.filter(
            (item: any) => item != null
          );
        }
      }
    }

    this.seelctedplanLevelTierMappingBlock2 = mappingtiers;

    this.seelctedplanLevelTierMappingBlock2 =
      this.seelctedplanLevelTierMappingBlock2.filter(
        (item: any) => item != null
      );

    console.log(this.seelctedplanLevelTierMappingBlock2);
  }
  onItemremoveTiersBlock3(tier: any, planLevel: any) {
    // 1.remove tier from seelcted list ui
    // 2.Remove from assigned tiers
    // 3.Add to Availabel Tiers
    // 4.Remove from Seelcted Plans

    if (!this.selectedPackagesassignedTiers3Block3[planLevel.packageId]) {
      this.selectedPackagesassignedTiers3Block3[planLevel.packageId] =
        this.selectedPackagesassignedTiers3Block3[planLevel.packageId].filter(
          (object) => {
            return object.id !== tier.id;
          }
        );
    }

    console.log(this.selectedPackagesassignedTiers3Block3);

    // this.selectedPackagesavailableTiersBlock3[planLevel.packageId].push(tier);

    let groups = Object.keys(
      this.selectedPackagesavailableTiers3Block3[planLevel.packageId]
    );

    console.log(groups);

    for (let group of groups) {
      console.log(group);
      console.log(planLevel.subGroupid);
      if (group == planLevel.subGroupid) {
        continue;
      }
      if (
        !this.selectedPackagesavailableTiers3Block3[planLevel.packageId][group]
      ) {
        this.selectedPackagesavailableTiers3Block3[planLevel.packageId][group] =
          [];
        console.log('CheckingassigningCOnfigTierlist');
      } else {
        console.log('alrradyexist');
      }
      // console.log(this.selectedPackagesassignedTiers2)
      let available2 = [];
      available2 =
        this.selectedPackagesavailableTiers3Block3[planLevel.packageId][group];

      available2.push(tier);
      this.selectedPackagesavailableTiers3Block3[planLevel.packageId][group] =
        available2;
    }

    this.showinputBlock3 = false;
    this.showinput1Block3 = true;

    console.log(this.selectedPackagesavailableTiers3Block3);

    this.selectedPackagesavailableTiers3Block31 =
      this.selectedPackagesavailableTiers3Block3;
    this.selectedPackagesassignedTiers3Block31 =
      this.selectedPackagesassignedTiers3Block3;

    let mappingtiers = this.seelctedplanLevelTierMappingBlock3;

    for (let i = 0; i < mappingtiers.length; i++) {
      console.log(mappingtiers[i].subGroupid);
      console.log(planLevel.subGroupid);
      if (
        mappingtiers[i] &&
        mappingtiers[i].subGroupid == planLevel.subGroupid
      ) {
        for (let j = 0; j < mappingtiers[i].tiers.length; j++) {
          if (mappingtiers[i].tiers[j].id == tier.id) {
            mappingtiers[i].tiers[j] = null;
            // console.log("checkhere")
          }
          if (mappingtiers[i].tiersidArray.includes(tier.id)) {
            mappingtiers[i].tiersidArray.splice(i, 1);
          }
        }

        if (mappingtiers[i].tiers.length > 0) {
          mappingtiers[i].tiers = mappingtiers[i].tiers.filter(
            (item: any) => item != null
          );
        }

        // if (mappingtiers[i].tiersidArray.includes(tier.id)) {
        //   // if (mappingtiers[i].tierid==tier.id) {
        //   //remove this plan from seelctedplanLevelTierMapping
        //   this.seelctedplanLevelTierMapping[i] = null;
        // }
      }
    }

    this.seelctedplanLevelTierMappingBlock3 = mappingtiers;

    // console.log(this.seelctedplanLevelTierMapping);
    this.seelctedplanLevelTierMappingBlock3 =
      this.seelctedplanLevelTierMappingBlock3.filter(
        (item: any) => item != null
      );

    // console.log(this.selectedPackagesavailableTiers);
    // console.log(this.selectedPackagesassignedTiers);
  }
  onItemSelect(
    item: any,
    packageid: number,
    parentId: number,
    subgroupid: number,
    packageindex: number,
    groupindex: number,
    subgroupindex: number
  ) {
    // console.log(item);
    // console.log(packageid);
    // console.log(parentId);
    // console.log(subgroupid);

    let Mainplanres = JSON.parse(sessionStorage.getItem('planResults'));

    Mainplanres[packageindex]['groups'][groupindex]['subGroups'][subgroupindex][
      'tiers'
    ].push(item);
    // Mainplanres[packageindex]['groups'][groupindex]['subGroups'][subgroupindex]['checked']=true;

    this.plansBlock1 = Mainplanres;
    // console.log(this.plansBlock1)

    sessionStorage.setItem('planResults', JSON.stringify(Mainplanres));
    // this.checkSelectedPlans()
  }

  onSelectAll(
    item: any,
    packageid: number,
    parentId: number,
    subgroupid: number,
    packageindex: number,
    groupindex: number,
    subgroupindex: number
  ) {
    let Mainplanres = JSON.parse(sessionStorage.getItem('planResults'));

    Mainplanres[packageindex]['groups'][groupindex]['subGroups'][subgroupindex][
      'tiers'
    ] = item;
    Mainplanres[packageindex]['groups'][groupindex]['subGroups'][subgroupindex][
      'checked'
    ] = true;

    this.plansBlock1 = Mainplanres;

    sessionStorage.setItem('planResults', JSON.stringify(Mainplanres));
  }
  onItemDeSelect(
    item: any,
    packageid: number,
    parentId: number,
    subgroupid: number,
    packageindex: number,
    groupindex: number,
    subgroupindex: number
  ) {
    let Mainplanres = JSON.parse(sessionStorage.getItem('planResults'));

    let array =
      Mainplanres[packageindex]['groups'][groupindex]['subGroups'][
      subgroupindex
      ]['tiers'];

    array = array.filter(function (obj) {
      return obj.id !== item.id;
    });

    Mainplanres[packageindex]['groups'][groupindex]['subGroups'][subgroupindex][
      'tiers'
    ] = array;
    // Mainplanres[packageindex]['groups'][groupindex]['subGroups'][subgroupindex]['checked'] = true
    this.plansBlock1 = Mainplanres;

    sessionStorage.setItem('planResults', JSON.stringify(Mainplanres));

    // this.checkSelectedPlans()
  }
  onDeSelectAll(
    item: any,
    packageid: number,
    parentId: number,
    subgroupid: number,
    packageindex: number,
    groupindex: number,
    subgroupindex: number
  ) {
    let Mainplanres = JSON.parse(sessionStorage.getItem('planResults'));

    Mainplanres[packageindex]['groups'][groupindex]['subGroups'][subgroupindex][
      'tiers'
    ] = [];
    // Mainplanres[packageindex]['groups'][groupindex]['subGroups'][subgroupindex]['checked']=true;

    this.plansBlock1 = Mainplanres;

    console.log(this.plansBlock1);

    sessionStorage.setItem('planResults', JSON.stringify(Mainplanres));

    // this.checkSelectedPlans()
  }

  multiSelectProvianceItemSelect(event: any) {
    //convert number into string?
    console.log(event);
    this.multiSelectProviance.push(event.id);
    this.multiSelectProviancenames.push(event)

    console.log(this.multiSelectProviance);
  }
  multiSelectProvianceSelectAll(event: any) {
    console.log(event);
    this.multiSelectProviance = [];
    this.multiSelectProviancenames = [];
    event.forEach((proviance: any) => {
      console.log(proviance)
      this.multiSelectProviance.push(proviance.id);
      this.multiSelectProviancenames.push({ "id": proviance.id, "shortName": proviance.shortName });


    });
    this.closemultiSelectProvianceSelectDropdown();
  }

  closemultiSelectProvianceSelectDropdown() {
    if (this.multiSelectDropdown) {
      this.multiSelectDropdown.closeDropdown();
    }
  }

  multiSelectProvianceItemDeSelect(event: any) {
    console.log(event);
    let indexOf = this.multiSelectProviance.indexOf(event.id);
    this.multiSelectProviance.splice(indexOf, 1);
    this.multiSelectProviancenames.splice(indexOf, 1);

    console.log(this.multiSelectProviance);
  }
  multiSelectProvianceItemDeSelectAll(event: any) {
    console.log(event);
    this.multiSelectProviance = [];
    this.multiSelectProviancenames = [];

  }

  checkSelectedPlans() {
    this.planssummary = JSON.parse(sessionStorage.getItem('planResults'));

    this.selectedplansblock1 = JSON.parse(
      sessionStorage.getItem('summaryBlock1')
    );

    if (this.planssummary) {
      // [{"packageid":"2","parentId":"14","subGroupId":"21","orderId":"18","packagename":"Mental Health & Wellness","groupname":"Wellness","subGrpname":"Mind & Body","tiers":[],"packageindex":1,"groupindex":0,"subgroupindex":2}]

      this.planssummary.forEach((plandetails: any, index: number) => {
        plandetails.groups.forEach((groups: any, index1: number) => {
          this.selectedplansblock1.forEach((subgroup: any, index3: number) => {
            var allAvailble =
              this.planssummary[index]['groups'][index1]['subGroups'];

            allAvailble.forEach((element1: any, index2: any) => {
              if (element1 != null) {
                if (element1.id == subgroup.subGroupId) {
                  setTimeout(() => {
                    const dom: HTMLElement = this.elementRef.nativeElement;
                    const element: any = dom.querySelector(
                      '#plancheck' + element1.id
                    );

                    console.log(element);
                    element.click();
                  }, 100);
                }
              }
            });
          });
        });
      });
    }
  }

  closeModal(value: any) {
    value.active = false;
  }
  numberOnly(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  get f() {
    return this.adminform.controls;
  }
  async addadmin() {
    console.log(this.adminData);

    if (this.adminform.invalid) {
      console.log(this.adminform);
      return;
    }
    console.log(JSON.stringify(this.adminform.value, null, 2));

    let obj = {
      firstName: this.capitalize(this.adminform.value.adminfirstname),
      lastName: this.capitalize(this.adminform.value.adminlastname),
      phoneNum: this.adminform.value.adminphone,
      email: this.adminform.value.adminemail,
      role: this.adminform.value.role,
      roleName: ''
    };
    if (obj.role == 'CORPORATE_OTHERS')
      obj['roleName'] = this.adminform.value.roleName;

    this.emailAlreadyexist = false;
    for (let admin of this.adminData) {
      if (admin['email'] == obj['email']) {
        await Swal.fire({
          title: 'Info',
          text: 'Email Already exist',
          showDenyButton: false,
          confirmButtonText: 'OK',
        }).then((res) => {
          if (res.isConfirmed) {
            return false;
          }
        });
        this.emailAlreadyexist = true;
        break;
      }
    }
    if (!this.emailAlreadyexist) {
      this.adminData.push(obj);
    }


    this.adminform.reset();
    this.showaddadmin = true;
    this.addadminform = false;
    sessionStorage.setItem('adminData', JSON.stringify(this.adminData));

    // this.adminData= JSON.parse(sessionStorage.getItem("adminData") || "[]")

    $('#basicModal1').modal('hide');
    console.log(this.adminData);
    this.corporateDetails = { ...this.corporateDetails, email: this.adminData[0]?.email }
    console.log('this.corporateDetails email', this.corporateDetails)
  }

  addadminFinal(CorpId) {
    console.log(this.adminData);

    // if (this.adminform.invalid) {
    //   console.log(this.adminform);
    //   return;
    // }
    console.log(JSON.stringify(this.adminform.value, null, 2));

    ''

    let obj = {
      firstName: this.capitalize(this.customerData.firstName),
      lastName: this.capitalize(this.customerData.lastName),
      phoneNum: this.customerData.primaryPhone,
      email: this.customerData.primaryEmail,
      role: 'CORPORATE_PLAN_ADMINISTRATOR',
      roleName: ''
    };
    obj['roleName'] = obj.role == 'CORPORATE_OTHERS' ? this.adminform.value.roleName : "";
    this.emailAlreadyexist = false;
    // for (let admin of this.adminData) {
    //   if (admin['email'] == obj['email']) {
    //     Swal.fire({
    //       title: this.lang.Info,
    //       text: 'Email Already exist',
    //       showDenyButton: false,
    //       confirmButtonText: 'OK',
    //     }).then((res) => {
    //       if (res.isConfirmed) {
    //         this.emailAlreadyexist = true;
    //         return false;
    //       }
    //     });
    //     this.emailAlreadyexist = true;
    //     break;
    //   }
    // }



    let endPoint = `/api/ap/admin/v2/corporate/${CorpId}/groupAdmin`;
    let accessToken = sessionStorage.getItem('accessToken');
    this.http
      .post(environment.apiUrl + endPoint, obj, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (response: any) => {
          if (response['status'] == 200) {
            // Swal.f
            // Swal.fire({title:this.lang.Info,text:response.message||response.data.message});
            Swal.fire({ title: this.lang.Info, text: response.message || response.data.message }).then((result) => {
              if (result.isConfirmed) {
                // this.clientregform.reset();


              }
            });
          } else {
            Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message });
          }
        },
        (error) => {
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: this.lang.Error ?? 'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: this.lang.Proceed,
            })
          } else {
            Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
          }
          // this.toastrService.error("Invalid Credentials", 'Error!');
        }
      );

    this.adminform.reset();
    this.showaddadmin = true;
    this.addadminform = false;
    $('#basicModal1').modal('hide');
    console.log(this.adminData);
    this.corporateDetails = { ...this.corporateDetails, email: this.adminData[0]?.email ?? this.adminform.value.adminemail }
    console.log('this.corporateDetails email', this.corporateDetails)
  }
  editadminSubmit() {
    if (this.adminform.invalid) {
      console.log(this.adminform);
      return;
    }
    console.log(JSON.stringify(this.adminform.value, null, 2));

    let obj = {
      firstName: this.capitalize(this.adminform.value.adminfirstname),
      lastName: this.capitalize(this.adminform.value.adminlastname),
      phoneNum: this.adminform.value.adminphone,
      email: this.adminform.value.adminemail,
      role: this.adminform.value.role,
      roleName: '',
    };
    if (obj.role == 'CORPORATE_OTHERS')
      //CORPORATE_OTHERS
      obj['roleName'] = this.adminform.value.roleName;

    this.adminData[this.editindex] = obj;

    sessionStorage.setItem('adminData', JSON.stringify(this.adminData));
    this.adminData = JSON.parse(sessionStorage.getItem('adminData') || '[]');

    this.adminform.reset();
    this.showOtherField = false;
    this.adminform.get('roleName').clearValidators();
    this.adminform.updateValueAndValidity();
    this.showaddadmin = true;
    this.addadminform = false;
    $('#basicModaledit').modal('hide');
    // $('#basicModal1').modal('hide');
  }

  deleteadmin(index: any) {
    Swal.fire({
      title: this.lang.Info,
      text: this.lang.Are_you_sure_you_want_to_delete_this_group_contact,
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: this.lang.Proceed,
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        // this.myFileInput.nativeElement.value = '';
        const Data = this.adminData;
        const removed = Data.splice(index, 1); // Mutates fruits and returns array of removed items

        sessionStorage.setItem('adminData', JSON.stringify(this.adminData));
        this.adminData = JSON.parse(
          sessionStorage.getItem('adminData') || '[]'
        );

        console.log(this.adminData);
        this.emailAlreadyexist = false;
        if (this.adminData.length == 0) {
          this.addadminform = true;
          this.showaddadmin = false;
        }
      }
    });
  }
  editadmin(admin: any, index: any) {
    // this.adminform.patchValue(admin);
    console.log(admin);
    this.editindex = index;
    this.editadminfirstname = admin.firstName;
    this.editadminlastname = admin.lastName;
    this.editadminphone = admin.phoneNum;
    this.editadminemail = admin.email;
    this.editadminrole = admin.role;
    if (this.editadminrole == 'CORPORATE_OTHERS') {
      this.showOtherField = true;
      // this.adminform.get('roleName').setValidators(Validators.required);
      this.adminform.get('roleName').updateValueAndValidity();
      this.adminformOthers = admin.roleName;
    } else {
      this.showOtherField = false;
      this.adminform.get('roleName').clearValidators();
      this.adminform.get('roleName').updateValueAndValidity();
    }
    this.emailAlreadyexist = false;
    setTimeout(() => {
      this.f['adminfirstname'].setValue(admin.firstName);
      this.f['adminlastname'].setValue(admin.lastName);
    }, 100);
  }

  changeToFirstlatterUpperCase(controlName: any) {
    let value = this.f[controlName].value;
    value =
      this.f[controlName].value[0].toUpperCase() +
      this.f[controlName].value.slice(1).toLowerCase();
    this.f[controlName].setValue(value);
  }

  hidegrpadmindetails() {
    this.showOtherField = false;
    this.adminform.get('roleName').clearValidators();
    this.adminform.updateValueAndValidity();
    this.editadminfirstname = '';
    this.editadminlastname = '';
    this.editadminphone = '';
    this.editadminemail = '';
    this.editadminrole = '';
    this.adminform.reset();
  }
  uploadadminlogoclear(event1: any) {
    this.showimagelogo = true;
    this.uploadlogoafter = false;
    this.imagedisplay = '';
    this.uploadadminlogoimg = '';
    sessionStorage.setItem('adminlogo', '');
    this.client['corporatelogo'].reset();
    // this.client['corporatelogo'].setValidators([Validators.required]);

    // this.client['corporatelogo'].updateValueAndValidity();
  }

  onPaste(e: any) {
    e.preventDefault();
  }
  uploadadminlogo(event1: any) {
    console.log('test');
    var fileExtension = '.' + event1.target.files[0].name.split('.').pop();

    // alert(event.target.files[0].name.replace(event.target.files[0].name,"void.pdf"))
    this.uploadadminlogoimg = event1.target.files[0];

    var allowedMimes = [
      'image/jpeg',
      'image/pjpeg',
      'image/png',
      // 'application/pdf', want to Allow PDF uncomment this line
    ];
    // var allowedMimes = [
    //   'image/jpeg',
    //   'image/pjpeg',
    //   'image/png',
    // ];

    let error = false;

    let message = '';

    if (allowedMimes.includes(this.uploadadminlogoimg.type)) {
      const maxFileSize = 1024 * 1024 * (environment.fileSize ? +environment.fileSize : 5);

      if (this.uploadadminlogoimg.size <= maxFileSize) {
        //300KB

        error = false;
        var reader = new FileReader();
        reader.readAsDataURL(event1.target.files[0]);

        reader.onload = (_event) => {
          this.showimagelogo = false;
          this.uploadlogoafter = true;
          this.imagedisplay = reader.result;
        };
        sessionStorage.setItem('adminlogo', this.uploadadminlogoimg);
      } else {
        error = true;
        message = `File size is too large,maximum file size is 5 MB`
        // message = this.lang.File_size_is_too_large_maximum_file_size_is_300kb;
        // alert(message);
        Swal.fire({ title: 'Info', text: message })
        this.uploadadminlogoimg = "";
      }
    } else {
      error = true;

      message = this.lang.Invalid_file_type_Only_jpg_png_image_pdf_files_are_allowed
      // alert(message);
      Swal.fire({ title: 'Info', text: message });
      this.uploadadminlogoimg = "";
    }
  }
  uploadadminlogo1(event1: any) {
    var fileExtension = '.' + event1.target.files[0].name.split('.').pop();

    // alert(event.target.files[0].name.replace(event.target.files[0].name,"void.pdf"))
    this.uploadadminlogoimg = event1.target.files[0];

    var allowedMimes = [
      'application/pdf',
    ];
    var allowedMimes = [
      'image/jpeg',
      'image/pjpeg',
      'image/png',
      'application/pdf',
    ];

    let error = false;

    let message = '';

    if (allowedMimes.includes(this.uploadadminlogoimg.type)) {
      const maxFileSize = 1024 * 1024 * (environment.fileSize ? +environment.fileSize : 5);

      if (this.uploadadminlogoimg.size <= maxFileSize) {
        //300KB

        error = false;
        var reader = new FileReader();
        reader.readAsDataURL(event1.target.files[0]);

        reader.onload = (_event) => {
          this.showimagelogo = false;
          this.imagedisplay = reader.result;
        };
        sessionStorage.setItem('adminlogo', this.uploadadminlogoimg);
      } else {
        error = true;
        message = `File size is too large,maximum file size is 5 MB`
        // message = this.lang.File_size_is_too_large_maximum_file_size_is_300kb;
        // alert(message);
        Swal.fire({ title: 'Info', text: message });
        this.uploadadminlogoimg = "";
      }
    } else {
      error = true;

      message = this.lang.Invalid_file_type_Only_jpg_png_image_pdf_files_are_allowed
      // alert(message);
      Swal.fire({ title: 'Info', text: message });
      this.uploadadminlogoimg = "";
    }
    // var reader = new FileReader();
    // reader.readAsDataURL(event1.target.files[0]);

    // reader.onload = (_event) => {
    //   this.showimagelogo = false;
    //   this.imagedisplay = reader.result;
    // };
    // sessionStorage.setItem('adminlogo', this.uploadadminlogoimg);
  }

  coreplantemplate(e) {
    const dom: HTMLElement = this.elementRef.nativeElement;
    this.coreplantemplateValue = e.target.value;
    let summaryBlock1 = JSON.parse(
      sessionStorage.getItem('summaryBlock1') || '[]'
    );

    for (let i = 0; i < summaryBlock1.length; i++) {
      const element: any = dom.querySelector(
        '#plancheck' + summaryBlock1[i].subGroupId
      );
      element.click();
    }

    this.plansNewBlock1 = JSON.parse(
      sessionStorage.getItem('planResults') || '[]'
    );

    this.plansBlock1 = JSON.parse(
      sessionStorage.getItem('planResults') || '[]'
    );

    if (e.target.value == 'starter') {
      const element: any = dom.querySelector('#plancheck' + 19);
      element.click();
      this.defaultAmount = '1000';
      // this.plansNewBlock1.forEach((element:any,index:number) => {

      // if(element.id !=2 && element.id !=8){

      //   const element2: any = dom.querySelector(".collapsed")

      //   if(element2){

      //   }else{
      //      const element1: any = dom.querySelector("#plancheckcollapseone" +element.id)
      //       element1.click()
      //   }

      // }
      // else{

      //   const element2: any = dom.querySelector(".collapsed")

      //   if(element2){
      //     const element1: any = dom.querySelector("#plancheckcollapseone" +element.id)
      //     element1.click()
      //   }else{

      //   }
      // }
      // });
    } else if (e.target.value == 'standard') {
      const element: any = dom.querySelector('#plancheck' + 3);
      element.click();
      const element1: any = dom.querySelector('#plancheck' + 21);
      element1.click();
      this.defaultAmount = '300';
      // this.plansNewBlock1.forEach((element:any,index:number) => {
      //   if(element.id !=1 && element.id !=2 && element.id !=8){
      //      const element1: any = dom.querySelector("#plancheckcollapseone" +element.id)
      //         element1.click()
      //   }
      //   else{
      //     // if(element.id !=2){
      //     //   element.groups.forEach((groups:any,index:number) => {

      //     //     if(groups.id !=1){

      //     //     const element1: any = dom.querySelector("#plancheckcollapseone" +groups.id)
      //     //     element1.click()
      //     //     }

      //     //   });

      //     // }

      //   }

      //         });
    } else if (e.target.value == 'executive') {
      setTimeout(() => {
        const element: any = dom.querySelector('#plancheck' + 9);
        element.click();
      }, 10);

      const element1: any = dom.querySelector('#plancheck' + 18);
      element1.click();
      this.defaultAmount = '2500';
      // this.plansNewBlock1.forEach((element:any,index:number) => {
      //   if(element.id !=1 && element.id !=5 && element.id !=8){
      //      const element1: any = dom.querySelector("#plancheckcollapseone" +element.id)
      //         element1.click()
      //   }
      //   else{
      //     // if(element.id !=5){
      //     //   element.groups.forEach((groups:any,index:number) => {

      //     //     if(groups.id !=6){

      //     //     const element1: any = dom.querySelector("#plancheckcollapseone" +groups.id)
      //     //     element1.click()
      //     //     }

      //     //   });

      //     // }

      //   }

      //         });
    } else if (e.target.value == 'custom') {
      this.defaultAmount = '';
    }
    0;
  }

  public replaceCharacter(string, index, replacement) {
    return string.slice(0, index) + replacement + string.slice(index + 1);
  }

  public getExecCoverage(Single, Couple, Family) {
    var coverage = '000';
    // var coverage='';
    if (Family) {
      coverage = this.replaceCharacter(coverage, 0, '1');
    }
    if (Couple) {
      coverage = this.replaceCharacter(coverage, 1, '1');
    }
    if (Single) {
      coverage = this.replaceCharacter(coverage, 2, '1');
    }

    return coverage;
  }
  executiveplansCoverage(e, packageIndex, grpIndex, subGrpIndex, subgroupid) {
    console.log(e);

    this._LoaderService.ShowLoader()


    setTimeout(() => {
      this._LoaderService.HideLoader()

    }, 1000);
    this.plansNewBlock2 = JSON.parse(
      sessionStorage.getItem('mainresults') || '[]'
    );
    let summaryBlock1 = JSON.parse(
      sessionStorage.getItem('summaryBlock1') || '[]'
    );

    let coverage = this.getExecCoverage($('#executiveplanssingle' + subgroupid).prop('checked'), $('#executiveplanscouple' + subgroupid).prop('checked'), $('#executiveplansfamily' + subgroupid).prop('checked'));

    if (coverage == "000" || coverage == "") {
      setTimeout(() => {
        $("#plancheck" + subgroupid).click()
      }, 100);

    }
    else {
      coverage = coverage
    }

    this.plansNewBlock2[packageIndex]['groups'][grpIndex]['subGroups'][
      subGrpIndex
    ]['coverage'] = coverage;
    summaryBlock1.forEach((element: any) => {
      if (
        element.packageindex == packageIndex &&
        element.groupindex == grpIndex &&
        element.subgroupindex == subGrpIndex
      ) {
        element['coverage'] = coverage;
        // element['coverage'] = e.target.value;
      }
    });
    sessionStorage.setItem('summaryBlock1', JSON.stringify(summaryBlock1));

    sessionStorage.setItem('mainresults', JSON.stringify(this.plansNewBlock2));


    let summaryBlock2 = JSON.parse(
      sessionStorage.getItem('summaryBlock2') || '[]'
    );

    if (summaryBlock2 && summaryBlock2.length > 0) {

      let index = this.getslectedplansblock2(subgroupid)
      if (index > -1) {
        // let coveragercheck = summaryBlock2[index].coverage

        if (coverage == "000" || coverage == "") {
          summaryBlock2[index].coverage = "111"
        }
        else if (coverage == "001") {
          summaryBlock2[index].coverage = "110"
        }
        else if (coverage == "010") {
          summaryBlock2[index].coverage = "100"
        }
        else if (coverage == "011") {
          summaryBlock2[index].coverage = "100"
        }
        else if (coverage == "111") {
          summaryBlock2.splice(index, 1);
        }
        else if (coverage == "101") {
          summaryBlock2.splice(index, 1);
        }
        // summaryBlock2.splice(index, 1);
        sessionStorage.setItem('summaryBlock2', JSON.stringify(summaryBlock2));

      }

    }
    let summaryBlock3 = JSON.parse(
      sessionStorage.getItem('summaryBlock3') || '[]'
    );

    if (summaryBlock3 && summaryBlock3.length > 0) {
      let index = this.getslectedplansblock3(subgroupid)
      if (index > -1) {
        // let coveragercheck = summaryBlock2[index].coverage

        if (coverage == "000" || coverage == "") {
          summaryBlock3[index].coverage = "111"
        }
        else if (coverage == "001") {
          summaryBlock3[index].coverage = "110"
        }
        else if (coverage == "010") {
          summaryBlock3[index].coverage = "100"
        }
        else if (coverage == "011") {
          summaryBlock3[index].coverage = "100"
        }
        else if (coverage == "111") {
          summaryBlock3.splice(index, 1);
        }
        else if (coverage == "101") {
          summaryBlock3.splice(index, 1);
        }
        // summaryBlock2.splice(index, 1);
        sessionStorage.setItem('summaryBlock3', JSON.stringify(summaryBlock3));

      }

    }

    this.checkvalidationblock2()

    this.checkvalidationblock3()

  }

  executiveplansCoverage2(e, packageIndex, grpIndex, subGrpIndex, subgroupid) {

    console.log(packageIndex)
    console.log(grpIndex)
    console.log(subGrpIndex)
    console.log(subgroupid)
    this._LoaderService.ShowLoader()


    setTimeout(() => {
      this._LoaderService.HideLoader()

    }, 1000);

    // [{"packageid":"5","parentId":"15","subGroupId":"18","orderId":"21","packagename":"Executive Benefits","groupname":"Exec","subGrpname":"Complete Executive Care","tiers":[],"packageindex":4,"groupindex":0,"subgroupindex":1}]
    this.Newplansresblack3 = JSON.parse(
      sessionStorage.getItem('block2result') || '[]'
    );
    this.selectedplansblock1 = JSON.parse(
      sessionStorage.getItem('summaryBlock2') || '[]'
    );
    setTimeout(() => {
      let coverage = this.getExecCoverage($('#executiveplansblock2single' + subgroupid).prop('checked'),
        $('#executiveplansblock2couple' + subgroupid).prop('checked'),
        $('#executiveplansblock2family' + subgroupid).prop('checked'));

      // alert(coverage)
      if (coverage == "000" || coverage == "") {
        setTimeout(() => {
          $("#plancheck2Upgrade" + subgroupid).click()
        }, 100);


      }
      else {
        coverage = coverage
      }
      if (this.Newplansresblack3[packageIndex]['groups'][grpIndex]['subGroups'][
        subGrpIndex
      ] != null) {
        this.Newplansresblack3[packageIndex]['groups'][grpIndex]['subGroups'][
          subGrpIndex
        ]['coverage'] = coverage;
      }
      this.selectedplansblock1.forEach((element: any) => {
        if (
          element.packageindex == packageIndex &&
          element.groupindex == grpIndex &&
          element.subgroupindex == subGrpIndex
        ) {


          element['coverage'] = coverage;


        }
      });

      let summaryBlock3 = JSON.parse(
        sessionStorage.getItem('summaryBlock3') || '[]'
      );

      // if(summaryBlock3 && summaryBlock3.length>0){
      //   let index=this.getslectedplansblock3(subgroupid)
      //   if (index > -1) {
      //     summaryBlock3.splice(index, 1);
      //     sessionStorage.setItem('summaryBlock3', JSON.stringify(summaryBlock3));

      //   }

      // }
      if (summaryBlock3 && summaryBlock3.length > 0) {
        let index = this.getslectedplansblock3(subgroupid)
        if (index > -1) {
          // let coveragercheck = summaryBlock2[index].coverage

          if (coverage == "000" || coverage == "") {
            summaryBlock3[index].coverage = "111"
          }
          else if (coverage == "001") {
            summaryBlock3[index].coverage = "110"
          }
          else if (coverage == "010") {
            summaryBlock3[index].coverage = "100"
          }
          else if (coverage == "011") {
            summaryBlock3[index].coverage = "100"
          }
          else if (coverage == "111") {
            summaryBlock3.splice(index, 1);
          }
          else if (coverage == "101") {
            summaryBlock3.splice(index, 1);
          }
          // summaryBlock2.splice(index, 1);
          sessionStorage.setItem('summaryBlock3', JSON.stringify(summaryBlock3));

        }

      }

      sessionStorage.setItem(
        'summaryBlock2',
        JSON.stringify(this.selectedplansblock1)
      );

      sessionStorage.setItem(
        'block2result',
        JSON.stringify(this.Newplansresblack3)
      );

      setTimeout(() => {
        if (this.employeeplanpurchase == true) {
          // let el: HTMLElement = this.employeepurchasefalse.nativeElement;
          // el.click();
          setTimeout(() => {
            let el1: HTMLElement = this.employeepurchasetrue.nativeElement;
            el1.click();
            // this.plansblock3();

          }, 10);
        }
      }, 1000);
    }, 1000);



  }
  executiveplansCoverage3(e, packageIndex, grpIndex, subGrpIndex, subgroupid) {
    // [{"packageid":"5","parentId":"15","subGroupId":"18","orderId":"21","packagename":"Executive Benefits","groupname":"Exec","subGrpname":"Complete Executive Care","tiers":[],"packageindex":4,"groupindex":0,"subgroupindex":1}]

    this._LoaderService.ShowLoader()


    setTimeout(() => {
      this._LoaderService.HideLoader()

    }, 1000);

    this.Newplansresblack3 = JSON.parse(
      sessionStorage.getItem('block3result') || '[]'
    );
    this.selectedplansblock1 = JSON.parse(
      sessionStorage.getItem('summaryBlock3') || '[]'
    );
    console.log(this.Newplansresblack3, this.selectedplansblock1)

    setTimeout(() => {
      let coverage = this.getExecCoverage($('#executiveplansblock3single' + subgroupid).prop('checked'), $('#executiveplansblock3couple' + subgroupid).prop('checked'), $('#executiveplansblock3family' + subgroupid).prop('checked'));


      if (coverage == "000" || coverage == "") {

        setTimeout(() => {
          $("#plancheck3Voluntry" + subgroupid).click()
        }, 1000);


      }
      else {
        coverage = coverage
      }
      this.Newplansresblack3[packageIndex]['groups'][grpIndex]['subGroups'][
        subGrpIndex
      ]['coverage'] = coverage;
      this.selectedplansblock1.forEach((element: any) => {
        if (
          element.packageindex == packageIndex &&
          element.groupindex == grpIndex &&
          element.subgroupindex == subGrpIndex
        ) {
          element['coverage'] = coverage;
        }
      });

      sessionStorage.setItem(
        'summaryBlock3',
        JSON.stringify(this.selectedplansblock1)
      );

      sessionStorage.setItem(
        'block3result',
        JSON.stringify(this.Newplansresblack3)
      );
    }, 1000);

  }
  executiveplansCoverageTier1(
    e,
    packageIndex,
    grpIndex,
    subGrpIndex,
    subgroupid
  ) {
    // [{"packageid":"5","parentId":"15","subGroupId":"18","orderId":"21","packagename":"Executive Benefits","groupname":"Exec","subGrpname":"Complete Executive Care","tiers":[],"packageindex":4,"groupindex":0,"subgroupindex":1}]
    let mainPlanTier = JSON.parse(
      sessionStorage.getItem('plansBlock1Tiers') || '[]'
    );
    this.selectedplansblock1 = JSON.parse(
      sessionStorage.getItem('selectedTiersBlock1') || '[]'
    );
    // console.log(this.plansNewBlock2[packageIndex]['groups'][grpIndex]['subGroups'][subGrpIndex])
    let coverage = this.getExecCoverage(
      $('#executiveplansTiersingle' + subgroupid).prop('checked'),
      $('#executiveplansTiercouple' + subgroupid).prop('checked'),
      $('#executiveplansTierfamily' + subgroupid).prop('checked')
    );

    mainPlanTier[packageIndex]['groups'][grpIndex]['subGroups'][subGrpIndex][
      'coverage'
    ] = coverage;
    //  this.seelctedplanLevelTierMapping[packageIndex]['groups'][grpIndex]['subGroups'][subGrpIndex]['coverage'] = e.target.value

    this.selectedplansblock1.forEach((element: any) => {
      if (
        element.packageindex == packageIndex &&
        element.groupindex == grpIndex &&
        element.subgroupindex == subGrpIndex
      ) {
        element['coverage'] = coverage;
      }
    });

    sessionStorage.setItem(
      'selectedTiersBlock1',
      JSON.stringify(this.selectedplansblock1)
    );

    sessionStorage.setItem('plansBlock1Tiers', JSON.stringify(mainPlanTier));

    if (this.seelctedplanLevelTierMapping.length > 0) {
      for (let i = 0; i < this.seelctedplanLevelTierMapping.length; i++) {
        if (
          this.seelctedplanLevelTierMapping[i].packageindex == packageIndex &&
          this.seelctedplanLevelTierMapping[i].groupindex == grpIndex &&
          this.seelctedplanLevelTierMapping[i].subgroupindex == subGrpIndex
        ) {
          this.seelctedplanLevelTierMapping[i].coverage = coverage;
        }
      }
      console.log(this.seelctedplanLevelTierMapping);
    }
  }
  executiveplansCoverageTier2(
    e,
    packageIndex,
    grpIndex,
    subGrpIndex,
    subgroupid
  ) {
    // [{"packageid":"5","parentId":"15","subGroupId":"18","orderId":"21","packagename":"Executive Benefits","groupname":"Exec","subGrpname":"Complete Executive Care","tiers":[],"packageindex":4,"groupindex":0,"subgroupindex":1}]
    let mainPlanTier = JSON.parse(
      sessionStorage.getItem('block2resultTiers') || '[]'
    );
    this.selectedplansblock1 = JSON.parse(
      sessionStorage.getItem('selectedTiersBlock2') || '[]'
    );
    // console.log(this.plansNewBlock2[packageIndex]['groups'][grpIndex]['subGroups'][subGrpIndex])
    let coverage = this.getExecCoverage(
      $('#executiveplansblock2Tiersingle' + subgroupid).prop('checked'),
      $('#executiveplansblock2Tiercouple' + subgroupid).prop('checked'),
      $('#executiveplansblock2Tierfamily' + subgroupid).prop('checked')
    );

    mainPlanTier[packageIndex]['groups'][grpIndex]['subGroups'][subGrpIndex][
      'coverage'
    ] = coverage;

    this.selectedplansblock1.forEach((element: any) => {
      if (
        element.packageindex == packageIndex &&
        element.groupindex == grpIndex &&
        element.subgroupindex == subGrpIndex
      ) {
        element['coverage'] = coverage;
      }
    });

    sessionStorage.setItem(
      'selectedTiersBlock2',
      JSON.stringify(this.selectedplansblock1)
    );

    sessionStorage.setItem('block2resultTiers', JSON.stringify(mainPlanTier));
    if (this.seelctedplanLevelTierMappingBlock2.length > 0) {
      for (let i = 0; i < this.seelctedplanLevelTierMappingBlock2.length; i++) {
        if (
          this.seelctedplanLevelTierMappingBlock2[i].packageindex ==
          packageIndex &&
          this.seelctedplanLevelTierMappingBlock2[i].groupindex == grpIndex &&
          this.seelctedplanLevelTierMappingBlock2[i].subgroupindex ==
          subGrpIndex
        ) {
          this.seelctedplanLevelTierMappingBlock2[i].coverage = coverage;
        }
      }
      console.log(this.seelctedplanLevelTierMapping);
    }
  }
  executiveplansCoverageTier3(
    e,
    packageIndex,
    grpIndex,
    subGrpIndex,
    subgroupid
  ) {
    // [{"packageid":"5","parentId":"15","subGroupId":"18","orderId":"21","packagename":"Executive Benefits","groupname":"Exec","subGrpname":"Complete Executive Care","tiers":[],"packageindex":4,"groupindex":0,"subgroupindex":1}]
    let mainPlanTier = JSON.parse(
      sessionStorage.getItem('block3resultTiers') || '[]'
    );
    this.selectedplansblock1 = JSON.parse(
      sessionStorage.getItem('selectedTiersBlock3') || '[]'
    );
    // console.log(this.plansNewBlock2[packageIndex]['groups'][grpIndex]['subGroups'][subGrpIndex])
    let coverage = this.getExecCoverage(
      $('#executiveplansblock3Tiersingle' + subgroupid).prop('checked'),
      $('#executiveplansblock3Tiercouple' + subgroupid).prop('checked'),
      $('#executiveplansblock3Tierfamily' + subgroupid).prop('checked')
    );

    mainPlanTier[packageIndex]['groups'][grpIndex]['subGroups'][subGrpIndex][
      'coverage'
    ] = coverage;

    this.selectedplansblock1.forEach((element: any) => {
      if (
        element.packageindex == packageIndex &&
        element.groupindex == grpIndex &&
        element.subgroupindex == subGrpIndex
      ) {
        element['coverage'] = coverage;
      }
    });

    sessionStorage.setItem(
      'selectedTiersBlock3',
      JSON.stringify(this.selectedplansblock1)
    );

    sessionStorage.setItem('block3resultTiers', JSON.stringify(mainPlanTier));
    if (this.seelctedplanLevelTierMappingBlock3.length > 0) {
      for (let i = 0; i < this.seelctedplanLevelTierMappingBlock3.length; i++) {
        if (
          this.seelctedplanLevelTierMappingBlock3[i].packageindex ==
          packageIndex &&
          this.seelctedplanLevelTierMappingBlock3[i].groupindex == grpIndex &&
          this.seelctedplanLevelTierMappingBlock3[i].subgroupindex ==
          subGrpIndex
        ) {
          this.seelctedplanLevelTierMappingBlock3[i].coverage = coverage;
        }
      }
    }
  }
  showPackageName(groups, category) {
    // if (category == 'upgrade') console.log(groups[0].name)
    // return
    // console.log(category)

    for (let grp of groups) {
      if (!grp || grp?.length <= 0) return false
      if (!grp || !grp?.subGroups || grp?.subGroups?.length <= 0) return false
      for (let sub of grp?.subGroups) {
        // if (category == 'upgrade') console.log(groups[0].name, sub)

        if (sub != null) {
          if (sub && sub?.settings) {
            if (sub?.settings[category]) {
              // if (category == 'upgrade') console.log(sub.settings[category])
              return true
            }
          }
        }
      }
    }


    return false
  }
  // showPackageName(groups, category) {
  //   // if (category == 'upgrade') console.log(groups[0].name)
  //   // return
  //   if (!groups || groups?.length <= 0) return false
  //   if (!groups[0] || !groups[0]?.subGroups || groups[0]?.subGroups?.length <= 0) return false
  //   for (let sub of groups[0].subGroups) {
  //     // if (category == 'upgrade') console.log(groups[0].name, sub)
  //     if (sub && sub?.settings) {
  //       if (sub?.settings[category]) {
  //         // if (category == 'upgrade') console.log(sub.settings[category])
  //         return true
  //       }
  //     }
  //   }
  //   return false
  // }

  public colors = { 0: "#FF3131", 1: "#37FBB3", 2: "black" }
  public text = { 0: "Unpublished", 1: "Published", 2: "Published but Restricted" }
  // unpublished(red -0 ), restricted / reserved(black 2 or 3), published(1 - green)
  getStatus(published, restricted) {
    // console.log({ published, restricted })
    let data = -1;
    if (published) {
      if (restricted) {
        data = 2
      }
      else {
        data = 1
        // console.log({ data })
      }

    }
    else {
      data = 0
    }
    return data
  }

  getColorForPlans(published, restricted, name?) {
    // console.log(published, restricted, name)
    const pubStatus = { 0: false, 1: true, 2: true }
    // console.log(pubStatus[published], restricted)
    let data = this.getStatus(pubStatus[published], restricted)

    // console.log(data)
    return this.colors[data]
  }

  getTextForTooltip(published, restricted) {
    const pubStatus = { 0: false, 1: true, 2: true }
    let data = this.getStatus(pubStatus[published], restricted)
    return this.text[data]
  }

  getColorForPlans1(published, restricted) {

    let data: any = this.getStatus(published, restricted)
    const color = this.colors[data];
    return color;
  }
  getTextForTooltip1(published, restricted) {
    let data: any = this.getStatus(published, restricted)
    const text = this.text[data]
    return text
  }



  preventNegative(event: KeyboardEvent) {
    if (event.key === '-' || event.key === '+' || event.key === '.') {
      event.preventDefault();
    }
  }

  preventNonNumeric(event: Event) {
    const input = event.target as HTMLInputElement;
    const value = input.value;

    if (!/^\d*$/.test(value)) {
      input.value = value.replace(/[^\d]/g, '');
    }
  }
  onCheckboxChangeBulkPlns(
    e: any,
    allow_multiple: any,
    disallowedPlanLevels: any,
    packageid: any,
    subgroupid: any,
    pname: any,
    subgroupname: any,
    subgroup: any,
    ordering: any,
    parentid: any,
    parentname: any,
    packageindex: number,
    groupindex: number,
    subgroupindex: number
  ) {

    if (e.target.checked) {
      const status = this.getTextForTooltip(subgroup.published?.data[0], subgroup.restricted)
      if (status == "Unpublished") {
        Swal.fire({
          title: this.lang.Info, text: this.lang.Plan_is_in_Unpublished_State_Selecting_this_plan_will_not_be_available_on_the_signup_forms,
          showConfirmButton: true,
          confirmButtonText: "Ok"
        })
      }
    }

    // this.hidementalplans = 2
    this.headCountmiss = false
    this.headCountmiss1 = false

    this.planselectedId = subgroupid;


    let multiple = allow_multiple == true ? true : false;
    if (e.target.checked) {

      // this.unselectPlanLevelBulk(e.target.id.replace('plancheck', ''), parentid);
      if (subgroup.settings) {
        this.checkboxCheck[subgroupid] = subgroup.settings?.showHeadCount //? true : false
        this.showinputboxvalue[subgroupid] = subgroup.settings?.showMemberDetailsDB //? true : false
      }
      this.hidementalplans = 2
    }
    else {
      this.hidementalplans = 222
      this.showinputbox = false
      this.showEmployeeValue = ""
      this.checkboxCheck[subgroupid] = false;
      this.showHeadCount[subgroupid] = ''
      this.showinputboxvalue[subgroupid] = false
    }



    console.log(disallowedPlanLevels);
    // if (disallowedPlanLevels != null) {
    //   let disallowed_plans = disallowedPlanLevels.split(',');
    //   const dom1: HTMLElement = this.elementRef.nativeElement;

    //   const disallowed_elements = dom1.querySelectorAll(
    //     '.plansscreen input.block1');

    //   for (let i = 0; i < disallowed_elements.length; i++) {
    //     console.log(disallowed_elements[i]);
    //     console.log(disallowed_elements[i]);
    //     let elem: any = disallowed_elements[i];
    //     // elementcv.checked=false

    //     if (!elem.attributes.data) {
    //       continue;
    //     }

    //     let plandetails = elem.attributes.data.value;

    //     let plandetailsobj = plandetails.split('##');

    //     // console.log('main', plandetailsobj);

    //     // console.log("disallowed_plans",disallowed_plans)

    //     if (e.target.checked) {
    //       if (!elem.disabled) {
    //         console.log('test');
    //         if (plandetailsobj[1] == null || plandetailsobj[1] == '') {
    //           if (disallowed_plans.indexOf(plandetailsobj[4]) >= 0) {
    //             //  elem.checked=false

    //             // elem.disabled = true

    //             this.disabledelement =
    //               'Already included in GroupBenefitz All-In';
    //           }
    //         } else {
    //           if (disallowed_plans.indexOf(plandetailsobj[4]) >= 0) {
    //             elem.previousElementSibling.style.opacity = 0.2;

    //             // this.elementid =  plandetailsobj[10]

    //             // eelem.parentElement.style.opacity = 0.2;

    //             ('Already included in GroupBenefitz All-In');
    //           }
    //         }
    //       }
    //       if (elem.checked) {
    //         // console.log(disallowed_plans)

    //         console.log(plandetailsobj);

    //         if (plandetailsobj[1] == null || plandetailsobj[1] == '') {
    //           if (disallowed_plans.indexOf(plandetailsobj[4]) >= 0) {
    //             elem.checked = false;

    //             this.unselectplanBulk(
    //               elem,
    //               pname,
    //               parentname,
    //               subgroupname,
    //               packageindex,
    //               groupindex,
    //               subgroupindex,
    //               plandetailsobj[10],
    //               plandetailsobj[11],
    //               plandetailsobj[12]
    //             );
    //             // eelem.previousElementSibling.style.opacity = 1;
    //           }
    //         } else {
    //           //console.log(disallowed_plans)
    //           //console.log(plandetailsobj)
    //           if (disallowed_plans.indexOf(plandetailsobj[4]) >= 0) {
    //             elem.checked = false;

    //             this.unselectplanBulk(
    //               elem,
    //               pname,
    //               parentname,
    //               subgroupname,
    //               packageindex,
    //               groupindex,
    //               subgroupindex,
    //               plandetailsobj[10],
    //               plandetailsobj[11],
    //               plandetailsobj[12]
    //             );
    //             // eelem.previousElementSibling.style.opacity = 1;
    //             // elem.disabled =true
    //           }
    //         }
    //       }
    //     } else {
    //       console.log('here');
    //       if (
    //         elem.disabled ||
    //         elem.previousElementSibling.style.opacity == '0.2'
    //       ) {
    //         if (plandetailsobj[1] == null || plandetailsobj[1] == '') {
    //           if (disallowed_plans.indexOf(plandetailsobj[4]) >= 0) {
    //             //  elem.checked=false
    //             elem.disabled = false;
    //             elem.previousElementSibling.style.opacity = 1;
    //           }
    //         } else {
    //           if (disallowed_plans.indexOf(plandetailsobj[4]) >= 0) {
    //             //  elem.checked=false
    //             elem.disabled = false;
    //             elem.previousElementSibling.style.opacity = 1;
    //           }
    //         }
    //       }
    //       if (elem.checked) {
    //         console.log('4');
    //         if (plandetailsobj[1] == null || plandetailsobj[1] == '') {
    //           if (disallowed_plans.indexOf(plandetailsobj[4]) >= 0) {
    //             elem.checked = false;
    //             // eelem.previousElementSibling.style.opacity =1
    //             // elem.disabled =true
    //           }
    //         } else {
    //           if (disallowed_plans.indexOf(plandetailsobj[4]) >= 0) {
    //             elem.checked = false;
    //             // eelem.previousElementSibling.style.opacity =1
    //             // elem.disabled =true
    //           }
    //         }
    //       }
    //     }
    //   }
    // }
    if (disallowedPlanLevels != null) {
      let disallowed_plans = disallowedPlanLevels.split(',');
      const dom1: HTMLElement = this.elementRef.nativeElement;

      // const disallowed_elements = dom1.querySelectorAll(
      //   '.plansscreen input.block1');

      for (let i = 0; i < disallowed_plans.length; i++) {
        console.log(disallowed_plans[i]);
        console.log(disallowed_plans[i]);
        let elem: any = dom1.querySelector(`#plancheckboxbulk${disallowed_plans[i]}`)
        // elementcv.checked=false

        // if (!elem.attributes.data) {
        //   continue;
        // }

        let plandetails = elem.attributes.data.value;

        let plandetailsobj = plandetails.split('##');

        // console.log(plandetailsobj)

        // // console.log('main', plandetailsobj);

        // console.log("disallowed_plans",disallowed_plans)
        // console.log(plandetailsobj[1])
        // console.log(plandetailsobj[4])

        if (e.target.checked) {
          if (!elem.disabled) {
            console.log('test');
            elem.disabled = true
            this.checkboxCheck[disallowed_plans[i]] = false
            this.showHeadCount[disallowed_plans[i]] = ''

            this.disabledelement =
              'Already included in GroupBenefitz All-In';

          }
          if (elem.checked) {
            // console.log(disallowed_plans)
            elem.checked = false;

            this.unselectplanBulk(
              elem,
              pname,
              parentname,
              subgroupname,
              packageindex,
              groupindex,
              subgroupindex,
              plandetailsobj[10],
              plandetailsobj[11],
              plandetailsobj[12],
              disallowedPlanLevels
            );


          }
        }
        else {
          console.log('here');

          if (
            elem.disabled ||
            elem.previousElementSibling.style.opacity == '0.2'
          ) {
            elem.disabled = false;
            elem.previousElementSibling.style.opacity = 1;

          }
          if (elem.checked) {
            elem.checked = false;

          }
        }
      }
    }
    // ////console.log(e)
    let classname = e.target.className;
    classname = classname.split(' ').join('.');

    console.log(classname);
    const dom: HTMLElement = this.elementRef.nativeElement;
    const elements = dom.querySelectorAll('.' + classname);

    console.log(elements);

    // let plandetailsobj = plandetails.split('##');

    let element: any;
    let elementcv: any;

    if (!multiple) {
      if (e.target.checked) {
        // this.unselectplan(e.target)
        for (let i = 0; i < elements.length; i++) {
          let elem = elements[i];
          element = elem;
          let plandetails = element.attributes.data.value;
          let plandetailsobj = plandetails.split('##');

          if (element.checked) {

            console.log(e.target.id)
            console.log(element.id)

            if (e.target.id == element.id) {
              continue;
            }
            this.unselectplanBulk(
              elem,
              pname,
              parentname,
              subgroupname,
              packageindex,
              groupindex,
              subgroupindex,
              plandetailsobj[9],
              plandetailsobj[10],
              plandetailsobj[11],
              disallowedPlanLevels
            );
            element.checked = false;
          }
        }

        e.checked = true;
        e.target.checked = true;
      } else {
      }
    } else {
    }
    setTimeout(() => {
      if (e.target.checked) {


        this.selectplanBulk(
          e.target,
          pname,
          parentname,
          subgroupname,
          packageindex,
          groupindex,
          subgroupindex,
          disallowedPlanLevels
        );

        this.executiveid = subgroupindex;

        console.log(this.executiveid);
      }
      else {
        console.log('indexx2 null');
        this.unselectplanBulk(
          e.target,
          pname,
          parentname,
          subgroupname,
          packageindex,
          groupindex,
          subgroupindex,
          packageindex,
          groupindex,
          subgroupindex,
          disallowedPlanLevels
        );
        // for (let i = 0; i < elements.length; i++) {
        //   let elem = elements[i];
        //   element = elem;
        //   let plandetails = element.attributes.data.value;
        //   let plandetailsobj = plandetails.split('##');

        //   console.log(plandetailsobj);

        //   this.unselectplanBulk(
        //     elem,
        //     pname,
        //     parentname,
        //     subgroupname,
        //     packageindex,
        //     groupindex,
        //     subgroupindex,
        //     plandetailsobj[9],
        //     plandetailsobj[10],
        //     plandetailsobj[11]
        //   );
        // }
        // this.unselectplan(e.target,pname,parentname,subgroupname,packageindex,groupindex,subgroupindex,null,null,null);
      }
    }, 10);

  }

  async updateHeadCount(subgrpId) {

    if (this.employeeList.length <= 0) return false
    console.log(this.showHeadCount[subgrpId], this.employeeList)
    this.showHeadCount[subgrpId] = 0
    this.employeeList.forEach((emp) => {
      if (emp.isBulk && emp.bulkPlanLevelId > 0 && emp.bulkPlanLevelId == subgrpId) {
        if (this.showHeadCount[emp.bulkPlanLevelId]) {
          console.log(this.showHeadCount[subgrpId], this.employeeList)
          this.showHeadCount[emp.bulkPlanLevelId]++;
        } else {
          this.showHeadCount[emp.bulkPlanLevelId] = 1;
        }
      }
    });
    console.log(this.showHeadCount[subgrpId], this.employeeList)

  }
  onCheckboxChange1(
    e: any,
    allow_multiple: any,
    disallowedPlanLevels: any,
    packageid: any,
    subgroupid: any,
    pname: any,
    subgroupname: any,
    subgroup: any,
    ordering: any,
    parentid: any,
    parentname: any,
    packageindex: number,
    groupindex: number,
    subgroupindex: number
  ) {

    this._LoaderService.ShowLoader()

    if (e.target.checked) {
      const status = this.getTextForTooltip(subgroup.published?.data[0], subgroup.restricted)
      if (status == "Unpublished") {
        Swal.fire({
          title: this.lang.Info, text: this.lang.Plan_is_in_Unpublished_State_Selecting_this_plan_will_not_be_available_on_the_signup_forms,
          showConfirmButton: true,
          confirmButtonText: "Ok"
        })
      }
      this.plansCoveragecheckboxCheck[subgroupid] = this.companyPaidCoveragePlanLevels[subgroupid]

      if (this.plansCoveragecheckboxCheck[subgroupid]) {
        this.finalCompanyPaidCoverages = this.companyPaidCoveragePlanLevels[subgroupid]
        console.group(this.plansCoveragecheckboxCheck[subgroupid])
      }
      this.getPlanCoverage[subgroupid] = ""
    }
    setTimeout(() => {
      this._LoaderService.HideLoader()

    }, 1200);
    this.planselectedId = subgroupid;


    let multiple = allow_multiple == true ? true : false;
    // let multiple = false;

    if (e.target.checked) {
      // this.unselectPlanLevel(e.target.id.replace('plancheck', ''), parentid);
    }

    if (disallowedPlanLevels != null) {
      let disallowed_plans = disallowedPlanLevels.split(',');
      const dom1: HTMLElement = this.elementRef.nativeElement;

      // const disallowed_elements = dom1.querySelectorAll(
      //   '.plansscreen input.block1');

      for (let i = 0; i < disallowed_plans.length; i++) {
        console.log(disallowed_plans[i]);
        console.log(disallowed_plans[i]);
        let elem: any = dom1.querySelector(`#plancheck${disallowed_plans[i]}`)


        if (!elem) {
          continue;
        }

        let plandetails = elem.attributes.data.value;

        let plandetailsobj = plandetails.split('##');

        // console.log(plandetailsobj)

        // // console.log('main', plandetailsobj);

        // console.log("disallowed_plans",disallowed_plans)
        // console.log(plandetailsobj[1])
        // console.log(plandetailsobj[4])

        if (e.target.checked) {
          if (!elem.disabled) {
            console.log('test');
            elem.disabled = true

            this.disabledelement =
              'Already included in GroupBenefitz All-In';

          }
          if (elem.checked) {
            // console.log(disallowed_plans)
            elem.checked = false;



            this.unselectplan(
              elem,
              pname,
              parentname,
              subgroupname,
              packageindex,
              groupindex,
              subgroupindex,
              plandetailsobj[9],
              plandetailsobj[10],
              plandetailsobj[11]
            );


          }
        }
        else {
          console.log('here');

          if (
            elem.disabled ||
            elem.previousElementSibling.style.opacity == '0.2'
          ) {
            elem.disabled = false;
            elem.previousElementSibling.style.opacity = 1;

          }
          if (elem.checked) {
            elem.checked = false;

          }
        }
      }
    }

    // ////console.log(e)
    let classname = e.target.className;
    classname = classname.split(' ').join('.');

    console.log(classname);
    const dom: HTMLElement = this.elementRef.nativeElement;
    const elements = dom.querySelectorAll('.' + classname);

    console.log(elements);

    // let plandetailsobj = plandetails.split('##');

    let element: any;
    let elementcv: any;

    if (!multiple) {
      if (e.target.checked) {
        // this.unselectplan(e.target)
        for (let i = 0; i < elements.length; i++) {
          let elem = elements[i];
          element = elem;
          let plandetails = element.attributes.data.value;
          let plandetailsobj = plandetails.split('##');

          if (element.checked) {

            console.log(e.target.id)
            console.log(element.id)

            if (e.target.id == element.id) {
              continue;
            }

            this.unselectplan(
              elem,
              pname,
              parentname,
              subgroupname,
              packageindex,
              groupindex,
              subgroupindex,
              plandetailsobj[9],
              plandetailsobj[10],
              plandetailsobj[11]
            );
            element.checked = false;
          }
        }

        e.checked = true;
        e.target.checked = true;
      } else {
      }
    } else {


    }
    setTimeout(() => {
      if (e.target.checked) {


        this.selectplan(
          e.target,
          pname,
          parentname,
          subgroupname,
          packageindex,
          groupindex,
          subgroupindex,
          subgroup,
          disallowedPlanLevels
        );

        this.executiveid = subgroupindex;

        console.log(this.executiveid);
      }
      else {
        console.log('indexx2 null');
        // for (let i = 0; i < elements.length; i++) {
        // let elem = elements[i];
        // element = elem;
        // let plandetails = element.attributes.data.value;
        // let plandetailsobj = plandetails.split('##');

        // console.log(plandetailsobj);



        // this.unselectplanBulk(
        //   e.target,
        //   pname,
        //   parentname,
        //   subgroupname,
        //   packageindex,
        //   groupindex,
        //   subgroupindex,
        //   plandetailsobj[9],
        //   plandetailsobj[10],
        //   plandetailsobj[11]
        // );

        this.unselectplan(
          e.target,
          pname,
          parentname,
          subgroupname,
          packageindex,
          groupindex,
          subgroupindex,
          packageindex,
          groupindex,
          subgroupindex
        );
        // }
        // this.unselectplan(e.target,pname,parentname,subgroupname,packageindex,groupindex,subgroupindex,null,null,null);
      }
    }, 10);

    if (this.employeeplanpurchase == true) {
      setTimeout(() => {
        let el1: HTMLElement = this.employeepurchasetrue.nativeElement;
        el1.click();
      }, 10);
    }
  }

  // async onCheckboxChange1(
  //   e: any,
  //   allow_multiple: any,
  //   disallowedPlanLevels: any,
  //   packageid: any,
  //   subgroupid: any,
  //   pname: any,
  //   subgroupname: any,
  //   subgroup: any,
  //   ordering: any,
  //   parentid: any,
  //   parentname: any,
  //   packageindex: number,
  //   groupindex: number,
  //   subgroupindex: number
  // ) {
  //   this.planselectedId = subgroupid;
  //   console.log("this.planselectedId: " + this.planselectedId + " *** subgroupid: " + subgroupid)

  //   // let multiple = allow_multiple ? Boolean(allow_multiple.data[0]) : false;
  //   let multiple = allow_multiple ? true : false;

  //   if (e.target.checked) {
  //     this.unselectPlanLevel(e.target.id.replace('plancheck', ''), parentid);
  //   }

  //   console.log(disallowedPlanLevels)
  //   if (disallowedPlanLevels != null) {
  //     let disallowed_plans = disallowedPlanLevels.split(',');
  //     const dom1: HTMLElement = this.elementRef.nativeElement;

  //     const disallowed_elements = dom1.querySelectorAll(
  //       '.plansscreen input.block1'
  //     );

  //     for (let i = 0; i < disallowed_elements.length; i++) {

  //       console.log(disallowed_elements[i]);
  //       console.log(disallowed_elements[i]);
  //       let elem: any = disallowed_elements[i];
  //       // elementcv.checked=false

  //       if (!elem.attributes.data) {
  //         continue;
  //       }

  //       let plandetails = elem.attributes.data.value;

  //       let plandetailsobj = plandetails.split('##');

  //       // console.log('main', plandetailsobj);

  //       // console.log("disallowed_plans",disallowed_plans)

  //       if (e.target.checked) {
  //         if (!elem.disabled) {
  //           console.log('test');
  //           if (plandetailsobj[3] == null || plandetailsobj[3] == '') {
  //             if (disallowed_plans.indexOf(plandetailsobj[4]) >= 0) {
  //               //  elem.checked=false

  //               // elem.disabled = true

  //               this.disabledelement =
  //                 'Already included in GroupBenefitz All-In';
  //             }
  //           } else {
  //             if (disallowed_plans.indexOf(plandetailsobj[3]) >= 0) {

  //               elem.previousElementSibling.style.opacity = 0.2;

  //               // this.elementid =  plandetailsobj[10]

  //               // eelem.parentElement.style.opacity = 0.2;

  //               ('Already included in GroupBenefitz All-In');
  //             }
  //           }
  //         }
  //         if (elem.checked) {
  //           // console.log(disallowed_plans)

  //           console.log("plandetailsobj: " + plandetailsobj);

  //           if (plandetailsobj[3] == null || plandetailsobj[3] == '') {
  //             if (disallowed_plans.indexOf(plandetailsobj[4]) >= 0) {
  //               elem.checked = false;
  //               this.unselectplan(
  //                 elem,
  //                 pname,
  //                 parentname,
  //                 subgroupname,
  //                 packageindex,
  //                 groupindex,
  //                 subgroupindex,
  //                 plandetailsobj[10],
  //                 plandetailsobj[11],
  //                 plandetailsobj[12]
  //               );
  //               // eelem.previousElementSibling.style.opacity = 1;
  //             }
  //           } else {
  //             //console.log(disallowed_plans)
  //             //console.log(plandetailsobj)
  //             if (disallowed_plans.indexOf(plandetailsobj[3]) >= 0) {
  //               elem.checked = false;
  //               this.unselectplan(
  //                 elem,
  //                 pname,
  //                 parentname,
  //                 subgroupname,
  //                 packageindex,
  //                 groupindex,
  //                 subgroupindex,
  //                 plandetailsobj[10],
  //                 plandetailsobj[11],
  //                 plandetailsobj[12]
  //               );
  //               // elem.previousElementSibling.style.opacity = 1;
  //               // elem.disabled = true
  //             }
  //           }
  //         }
  //       } else {
  //         console.log('here');
  //         if (
  //           elem.disabled ||
  //           elem.previousElementSibling.style.opacity == '0.2'
  //         ) {
  //           if (plandetailsobj[3] == null || plandetailsobj[3] == '') {
  //             if (disallowed_plans.indexOf(plandetailsobj[4]) >= 0) {
  //               //  elem.checked=false
  //               elem.disabled = false;
  //               elem.previousElementSibling.style.opacity = 1;
  //             }
  //           } else {
  //             if (disallowed_plans.indexOf(plandetailsobj[3]) >= 0) {
  //               //  elem.checked=false
  //               elem.disabled = false;
  //               elem.previousElementSibling.style.opacity = 1;
  //             }
  //           }
  //         }
  //         if (elem.checked) {
  //           console.log('4');
  //           if (plandetailsobj[3] == null || plandetailsobj[3] == '') {
  //             if (disallowed_plans.indexOf(plandetailsobj[4]) >= 0) {
  //               elem.checked = false;
  //               // eelem.previousElementSibling.style.opacity =1
  //               // elem.disabled =true
  //             }
  //           } else {
  //             if (disallowed_plans.indexOf(plandetailsobj[3]) >= 0) {
  //               elem.checked = false;
  //               // eelem.previousElementSibling.style.opacity =1
  //               // elem.disabled =true
  //             }
  //           }
  //         }
  //       }
  //     }
  //   }

  //   // ////console.log(e)
  //   let classname = e.target.className;
  //   classname = classname.split(' ').join('.');

  //   // console.log(classname);
  //   const dom: HTMLElement = this.elementRef.nativeElement;
  //   const elements = dom.querySelectorAll('.' + classname);

  //   // console.log(elements);

  //   // let plandetailsobj = plandetails.split('##');

  //   let element: any;
  //   let elementcv: any;

  //   if (!multiple) {
  //     if (e.target.checked) {
  //       // this.unselectplan(e.target)
  //       for (let i = 0; i < elements.length; i++) {
  //         let elem = elements[i];
  //         element = elem;
  //         let plandetails = element.attributes.data.value;
  //         let plandetailsobj = plandetails.split('##');

  //         if (element.checked) {
  //           this.unselectplan(
  //             elem,
  //             pname,
  //             parentname,
  //             subgroupname,
  //             packageindex,
  //             groupindex,
  //             subgroupindex,
  //             plandetailsobj[9],
  //             plandetailsobj[10],
  //             plandetailsobj[11]
  //           );
  //           element.checked = false;
  //         }
  //       }

  //       e.checked = true;
  //       e.target.checked = true;
  //     } else {
  //     }
  //   } else {
  //   }
  //   setTimeout(() => {
  //     if (e.target.checked) {
  //       this.selectplan(
  //         e.target,
  //         pname,
  //         parentname,
  //         subgroupname,
  //         packageindex,
  //         groupindex,
  //         subgroupindex,
  //         subgroupid
  //       );

  //       // this.executiveid = subgroupindex;

  //       if (subgroupid == 17 || subgroupid == 18) {
  //    if($("#executiveplanssingle" + subgroupid).prop("checked")){
  //        }
  //                     else{
  // $("#executiveplanssingle" + subgroupid).click();
  //                     }

  //       }
  //       // if (subgroupid == 18) {
  //       //   $("#executiveplanssingle" + subgroupid).click();
  //       // }
  //       console.log("this.executiveid: "+this.executiveid);

  // //  if (this.paidByCompany.length > 0) {
  // //                 for (let i = 0; i < this.paidByCompany.length; i++) {
  // //                   if (this.paidByCompany[i].coverage && this.paidByCompany[i].coverage.length) {
  // //                   }else{
  // //                    if (subgroupid == 17) {
  // //           $("#executiveplanssingle" + subgroupid).click();
  // //         }
  // //         if (subgroupid == 18) {
  // //           $("#executiveplanssingle" + subgroupid).click();
  // //         }
  // //                   }
  // //                 }
  // //               }

  //     } else {
  //       console.log('indexx2 null');
  //       for (let i = 0; i < elements.length; i++) {
  //         let elem = elements[i];
  //         element = elem;
  //         let plandetails = element.attributes.data.value;
  //         let plandetailsobj = plandetails.split('##');

  //         this.unselectplan(
  //           elem,
  //           pname,
  //           parentname,
  //           subgroupname,
  //           packageindex,
  //           groupindex,
  //           subgroupindex,
  //           plandetailsobj[9],
  //           plandetailsobj[10],
  //           plandetailsobj[11]
  //         );
  //       }
  //       // this.unselectplan(e.target,pname,parentname,subgroupname,packageindex,groupindex,subgroupindex,null,null,null);
  //     }
  //   }, 15);
  // }

  onCheckboxChange2(
    e: any,
    allow_multiple: any,
    disallowedPlanLevels: any,
    packageid: any,
    subgroupid: any,
    pname: any,
    subgroupname: any,
    subgroup: any,
    ordering: any,
    parentid: any,
    parentname: any,
    packageindex: number,
    groupindex: number,
    subgroupindex: number
  ) {
    this.block2execid = subgroupid;
    this._LoaderService.ShowLoader()
    if (e.target.checked) {
      const status = this.getTextForTooltip(subgroup.published?.data[0], subgroup.restricted)
      if (status == "Unpublished") {
        Swal.fire({
          title: this.lang.Info, text: this.lang.Plan_is_in_Unpublished_State_Selecting_this_plan_will_not_be_available_on_the_signup_forms,
          showConfirmButton: true,
          confirmButtonText: "Ok"
        })
      }
    }

    setTimeout(() => {
      this._LoaderService.HideLoader()

    }, 1200);
    // let multiple = allow_multiple ? Boolean(allow_multiple.data[0]) : false;

    //  for(let i of block2filter){

    //    console.log(i)
    //    console.log(i.subGroupId)

    //    let element: any = dom2.querySelector('#plancheck2Upgrade' + i.subGroupId);
    //    if (element.checked) {

    //      element.click()
    //      element.click()
    //    }
    //  }
    let multiple = allow_multiple == true ? true : false;

    // let multiple = true;
    if (e.target.checked) {
      this.unselectPlanLevel2(e.target.id.replace('plancheck2Upgrade', ''), parentid);
    }

    else {
      //we are changg=ing fron select to unselect
      /* using for select checked plans in block2 */
      let block2 = JSON.parse(sessionStorage.getItem('summaryBlock2') || '[]');

      let block2filter = block2.filter(
        (item: any) => item.parentId == parentid
      );

      console.log(block2filter);
      const dom2: HTMLElement = this.elementRef.nativeElement;
      if (block2filter.length > 1) {
        let element1: any = dom2.querySelector('#plancheck2Upgrade' + subgroupid);

        if (element1.checked) {
          console.log('checked');

          element1.checked = false;
          return;
        } else {
          if (block2) {

            let index = this.getslectedplansblock2(subgroupid);

            if (index > -1) {
              block2.splice(index, 1);
              let summaryBlock2 = JSON.parse(sessionStorage.getItem('summaryBlock2') || '[]');
              let mainresults = JSON.parse(
                sessionStorage.getItem('mainresults') || '{}'
              );


              if (subgroupid == 17 || subgroupid == 18 || subgroupid == 28) {


                mainresults[packageindex]['groups'][groupindex][
                  'subGroups'
                ][subgroupindex]['checked'] = false;

                console.log(mainresults[packageindex]['groups'][groupindex][
                  'subGroups'
                ][subgroupindex])
                console.log(mainresults[packageindex]['groups'][groupindex][
                  'subGroups'
                ][subgroupindex]['name'])
                if (
                  mainresults[packageindex]['groups'][groupindex][
                  'subGroups'
                  ][subgroupindex]['name'] == 'Executive Health'
                ) {


                  $('#executiveplansblock2single' + subgroupid).prop(
                    'checked',
                    false
                  );
                  $('#executiveplansblock2couple' + subgroupid).prop(
                    'checked',
                    false
                  );
                  $('#executiveplansblock2family' + subgroupid).prop(
                    'checked',
                    false
                  );
                  $('#executiveplansblock2single' + subgroupid).prop(
                    'disabled',
                    true
                  );
                  $('#executiveplansblock2couple' + subgroupid).prop(
                    'disabled',
                    true
                  );
                  $('#executiveplansblock2family' + subgroupid).prop(
                    'disabled',
                    true
                  );
                  let summaryBlock1 = JSON.parse(
                    sessionStorage.getItem('summaryBlock1') || '[]'
                  );


                  sessionStorage.setItem('block2result', JSON.stringify(this.plansresblack2));

                }

                if (
                  mainresults[packageindex]['groups'][groupindex][
                  'subGroups'
                  ][subgroupindex]['name'] == 'Complete Executive Care'
                ) {
                  // this.plansresblack2[obj.packageIndex]['groups'][obj.groupIndex][
                  //   'subGroups'
                  // ][obj.subgroupIndex]['coverage'] = 'default';

                  $('#executiveplansblock2single' + subgroupid).prop(
                    'checked',
                    false
                  );
                  $('#executiveplansblock2couple' + subgroupid).prop(
                    'checked',
                    false
                  );
                  $('#executiveplansblock2family' + subgroupid).prop(
                    'checked',
                    false
                  );
                  $('#executiveplansblock2single' + subgroupid).prop(
                    'disabled',
                    true
                  );
                  $('#executiveplansblock2couple' + subgroupid).prop(
                    'disabled',
                    true
                  );
                  $('#executiveplansblock2family' + subgroupid).prop(
                    'disabled',
                    true
                  );
                  sessionStorage.setItem('block2result', JSON.stringify(this.plansresblack2));

                }
                if (
                  mainresults[packageindex]['groups'][groupindex][
                  'subGroups'
                  ][subgroupindex]['name'] == 'Provincial Health Replacement Plan'
                ) {
                  // this.plansresblack2[obj.packageIndex]['groups'][obj.groupIndex][
                  //   'subGroups'
                  // ][obj.subgroupIndex]['coverage'] = 'default';

                  $('#executiveplansblock2single' + subgroupid).prop(
                    'checked',
                    false
                  );
                  $('#executiveplansblock2couple' + subgroupid).prop(
                    'checked',
                    false
                  );
                  $('#executiveplansblock2family' + subgroupid).prop(
                    'checked',
                    false
                  );
                  $('#executiveplansblock2single' + subgroupid).prop(
                    'disabled',
                    true
                  );
                  $('#executiveplansblock2couple' + subgroupid).prop(
                    'disabled',
                    true
                  );
                  $('#executiveplansblock2family' + subgroupid).prop(
                    'disabled',
                    true
                  );
                  sessionStorage.setItem('block2result', JSON.stringify(this.plansresblack2));

                }


              }



              sessionStorage.setItem(
                'mainresults',
                JSON.stringify(mainresults)
              );


              var newselectedplans: any = {};
              for (var i = 0; i < summaryBlock2.length; i++) {
                newselectedplans[summaryBlock2[i].subGroupId] = i;
              }

              sessionStorage.setItem('selectedPlans', JSON.stringify(newselectedplans));

              this.planssummarymain = [];
              this.planssummaryopt = [];

              summaryBlock2.forEach((element: any) => {
                if (element.packagename != 'Opt-in') {
                  this.planssummarymain.push(element);
                } else {
                  this.planssummaryopt.push(element);
                }
              });

              let selectedplansblock2 = JSON.parse(
                sessionStorage.getItem('summaryBlock2') || '[]'
              );
              let selectedplansblock3 = JSON.parse(
                sessionStorage.getItem('summaryBlock3') || '[]'
              );


              console.log(this.employeeplanpurchase)
              if (this.employeeplanpurchase == true) {

                // console.log("1")
                // let el: HTMLElement = this.employeepurchasefalse.nativeElement;
                // el.click();
                setTimeout(() => {
                  let el1: HTMLElement = this.employeepurchasetrue.nativeElement;
                  el1.click();
                  setTimeout(() => {
                    const dom: HTMLElement = this.elementRef.nativeElement;
                    if (selectedplansblock3.length > 0) {
                      let el1: HTMLElement = this.employeepurchasetrue.nativeElement;
                      el1.click();
                      this.employeeplanpurchase == true;
                      setTimeout(() => {
                        for (let i = 0; i < selectedplansblock3.length; i++) {
                          const element2: any = dom.querySelector(
                            '#plancheck3Voluntry' + selectedplansblock3[i].subGroupId
                          );
                          // element2.checked = true;
                          // element2.click()
                          element2.prop('checked', true);
                        }
                      }, 1500);
                    }
                  }, 1000);
                }, 100);
              }

              sessionStorage.setItem(
                'summaryBlock2main',
                JSON.stringify(this.planssummarymain)
              );
              sessionStorage.setItem(
                'summaryBlock2opt',
                JSON.stringify(this.planssummaryopt)
              );

              sessionStorage.setItem('summaryBlock2', JSON.stringify(summaryBlock2));


            } else {
              return;
            }
          }

          sessionStorage.setItem('summaryBlock2', JSON.stringify(block2));

          let selectedplansblock3 = JSON.parse(
            sessionStorage.getItem('summaryBlock3') || '[]'
          );


          console.log(this.employeeplanpurchase)
          if (this.employeeplanpurchase == true) {

            // let el: HTMLElement = this.employeepurchasefalse.nativeElement;
            // el.click();
            setTimeout(() => {
              let el1: HTMLElement = this.employeepurchasetrue.nativeElement;
              el1.click();
              setTimeout(() => {
                const dom: HTMLElement = this.elementRef.nativeElement;
                if (selectedplansblock3.length > 0) {
                  let el1: HTMLElement = this.employeepurchasetrue.nativeElement;
                  el1.click();
                  this.employeeplanpurchase == true;
                  setTimeout(() => {
                    for (let i = 0; i < selectedplansblock3.length; i++) {
                      const element2: any = dom.querySelector(
                        '#plancheck3Voluntry' + selectedplansblock3[i].subGroupId
                      );
                      element2.prop('checked', true);
                      // element2.checked = true;
                    }
                  }, 1500);
                }
              }, 1000);
            }, 10);
          }
          return;
        }
      }
    }
    if (disallowedPlanLevels != null) {
      let disallowed_plans = disallowedPlanLevels.split(',');
      const dom1: HTMLElement = this.elementRef.nativeElement;

      // const disallowed_elements = dom1.querySelectorAll(
      //   '.plansscreen input.block1');

      for (let i = 0; i < disallowed_plans.length; i++) {
        console.log(disallowed_plans[i]);
        console.log(disallowed_plans[i]);
        let elem: any = dom1.querySelector(`#plancheck2Upgrade${disallowed_plans[i]}`)


        if (!elem) {
          continue;
        }

        let plandetails = elem.attributes.data.value;

        let plandetailsobj = plandetails.split('##');

        console.log(plandetailsobj)

        // // console.log('main', plandetailsobj);

        // console.log("disallowed_plans",disallowed_plans)
        // console.log(plandetailsobj[1])
        // console.log(plandetailsobj[4])

        if (e.target.checked) {
          if (!elem.disabled) {
            console.log('test');
            elem.disabled = true

            this.disabledelement =
              'Already included in GroupBenefitz All-In';

          }
          if (elem.checked) {
            // console.log(disallowed_plans)
            elem.checked = false;



            this.unselectplanblock2(
              elem,
              pname,
              parentname,
              subgroupname,
              packageindex,
              groupindex,
              subgroupindex,
              plandetailsobj[9],
              plandetailsobj[10],
              plandetailsobj[11]
            );


          }
        }
        else {
          console.log('here');

          if (
            elem.disabled ||
            elem.previousElementSibling.style.opacity == '0.2'
          ) {
            elem.disabled = false;
            elem.previousElementSibling.style.opacity = 1;

          }
          if (elem.checked) {
            elem.checked = false;

          }
        }
      }
    }

    // ////console.log(e)
    let classname = e.target.className;
    classname = classname.split(' ').join('.');

    console.log(classname);
    const dom: HTMLElement = this.elementRef.nativeElement;
    const elements = dom.querySelectorAll('.' + classname);

    console.log(elements);

    // let plandetailsobj = plandetails.split('##');

    let element: any;
    let elementcv: any;

    if (!multiple) {
      if (e.target.checked) {
        // this.unselectplan(e.target)
        for (let i = 0; i < elements.length; i++) {
          let elem = elements[i];
          element = elem;
          let plandetails = element.attributes.data.value;
          let plandetailsobj = plandetails.split('##');

          if (element.checked) {

            console.log(e.target.id)
            console.log(element.id)

            if (e.target.id == element.id) {
              continue;
            }

            this.unselectplanblock2(
              elem,
              pname,
              parentname,
              subgroupname,
              packageindex,
              groupindex,
              subgroupindex,
              plandetailsobj[9],
              plandetailsobj[10],
              plandetailsobj[11]
            );
            element.checked = false;
          }
        }

        e.checked = true;
        e.target.checked = true;
      } else {
      }
    } else {


    }
    setTimeout(() => {
      if (e.target.checked) {


        this.selectplanblock2(
          e.target,
          pname,
          parentname,
          subgroupname,
          packageindex,
          groupindex,
          subgroupindex,
          subgroup,
          disallowedPlanLevels
        );

        this.executiveid = subgroupindex;

        console.log(this.executiveid);
      }
      else {
        console.log('indexx2 null');
        // for (let i = 0; i < elements.length; i++) {
        // let elem = elements[i];
        // element = elem;
        // let plandetails = element.attributes.data.value;
        // let plandetailsobj = plandetails.split('##');

        // console.log(plandetailsobj);

        // this.unselectplanBulk(
        //   e.target,
        //   pname,
        //   parentname,
        //   subgroupname,
        //   packageindex,
        //   groupindex,
        //   subgroupindex,
        //   plandetailsobj[9],
        //   plandetailsobj[10],
        //   plandetailsobj[11]
        // );

        this.unselectplanblock2(
          e.target,
          pname,
          parentname,
          subgroupname,
          packageindex,
          groupindex,
          subgroupindex,
          packageindex,
          groupindex,
          subgroupindex
        );
        // }
        // this.unselectplan(e.target,pname,parentname,subgroupname,packageindex,groupindex,subgroupindex,null,null,null);
      }
    }, 10);
  }

  onCheckboxChange3(
    e: any,
    allow_multiple: any,
    disallowedPlanLevels: any,
    packageid: any,
    subgroupid: any,
    pname: any,
    subgroupname: any,
    subgroup: any,
    ordering: any,
    parentid: any,
    parentname: any,
    packageindex: number,
    groupindex: number,
    subgroupindex: number
  ) {
    this._LoaderService.ShowLoader()

    if (e.target.checked) {
      const status = this.getTextForTooltip(subgroup.published?.data[0], subgroup.restricted)
      if (status == "Unpublished") {
        Swal.fire({
          title: this.lang.Info, text: this.lang.Plan_is_in_Unpublished_State_Selecting_this_plan_will_not_be_available_on_the_signup_forms, showConfirmButton: true,
          confirmButtonText: "Ok"
        })
      }
    }
    setTimeout(() => {
      this._LoaderService.HideLoader()

    }, 1200);
    let multiple = allow_multiple == true ? true : false;

    if (disallowedPlanLevels != null) {
      let disallowed_plans = disallowedPlanLevels.split(',');
      const dom1: HTMLElement = this.elementRef.nativeElement;

      // const disallowed_elements = dom1.querySelectorAll(
      //   '.plansscreen input.block1');

      for (let i = 0; i < disallowed_plans.length; i++) {
        console.log(disallowed_plans[i]);
        console.log(disallowed_plans[i]);
        let elem: any = dom1.querySelector(`#plancheck3Voluntry${disallowed_plans[i]}`)


        if (!elem) {
          continue;
        }

        let plandetails = elem.attributes.data.value;

        let plandetailsobj = plandetails.split('##');

        console.log(plandetailsobj)

        // // console.log('main', plandetailsobj);

        // console.log("disallowed_plans",disallowed_plans)
        // console.log(plandetailsobj[1])
        // console.log(plandetailsobj[4])

        if (e.target.checked) {
          if (!elem.disabled) {
            console.log('test');
            elem.disabled = true

            this.disabledelement =
              'Already included in GroupBenefitz All-In';

          }
          if (elem.checked) {
            // console.log(disallowed_plans)
            elem.checked = false;



            this.unselectplanblock3(
              elem,
              pname,
              parentname,
              subgroupname,
              packageindex,
              groupindex,
              subgroupindex,
              plandetailsobj[9],
              plandetailsobj[10],
              plandetailsobj[11]
            );


          }
        }
        else {
          console.log('here');

          if (
            elem.disabled ||
            elem.previousElementSibling.style.opacity == '0.2'
          ) {
            elem.disabled = false;
            elem.previousElementSibling.style.opacity = 1;

          }
          if (elem.checked) {
            elem.checked = false;

          }
        }
      }
    }

    // ////console.log(e)
    let classname = e.target.className;
    classname = classname.split(' ').join('.');

    console.log(classname);
    const dom: HTMLElement = this.elementRef.nativeElement;
    const elements = dom.querySelectorAll('.' + classname);

    console.log(elements);

    // let plandetailsobj = plandetails.split('##');

    let element: any;
    let elementcv: any;

    // if (!multiple) {
    //   if (e.target.checked) {
    //     // this.unselectplan(e.target)
    //     for (let i = 0; i < elements.length; i++) {
    //       let elem = elements[i];
    //       element = elem;
    //       let plandetails = element.attributes.data.value;
    //       let plandetailsobj = plandetails.split('##');

    //       if (element.checked) {

    //         console.log(e.target.id)
    //         console.log(element.id)

    //         if (e.target.id == element.id) {
    //           continue;
    //         }

    //         this.unselectplanblock3(
    //           elem,
    //           pname,
    //           parentname,
    //           subgroupname,
    //           packageindex,
    //           groupindex,
    //           subgroupindex,
    //           plandetailsobj[9],
    //           plandetailsobj[10],
    //           plandetailsobj[11]
    //         );
    //         element.checked = false;
    //       }
    //     }

    //     e.checked = true;
    //     e.target.checked = true;
    //   } else {
    //   }
    // } else {


    // }
    setTimeout(() => {
      if (e.target.checked) {


        this.selectplanblock3(
          e.target,
          pname,
          parentname,
          subgroupname,
          packageindex,
          groupindex,
          subgroupindex,
          subgroup,
          disallowedPlanLevels
        );

        this.executiveid = subgroupindex;

        console.log(this.executiveid);
      }
      else {
        console.log('indexx2 null');
        // for (let i = 0; i < elements.length; i++) {
        // let elem = elements[i];
        // element = elem;
        // let plandetails = element.attributes.data.value;
        // let plandetailsobj = plandetails.split('##');

        // console.log(plandetailsobj);



        // this.unselectplanBulk(
        //   e.target,
        //   pname,
        //   parentname,
        //   subgroupname,
        //   packageindex,
        //   groupindex,
        //   subgroupindex,
        //   plandetailsobj[9],
        //   plandetailsobj[10],
        //   plandetailsobj[11]
        // );

        this.unselectplanblock3(
          e.target,
          pname,
          parentname,
          subgroupname,
          packageindex,
          groupindex,
          subgroupindex,
          packageindex,
          groupindex,
          subgroupindex
        );
        // }
        // this.unselectplan(e.target,pname,parentname,subgroupname,packageindex,groupindex,subgroupindex,null,null,null);
      }
    }, 10);
    if (e.target.checked) {
      this.unselectPlanLevel3(e.target.id.replace('plancheck3Voluntry', ''), parentid);
    }
    else {
      //we are changg=ing fron select to unselect
      /* using for select checked plans in block3 */
      let block3 = JSON.parse(sessionStorage.getItem('summaryBlock3') || '[]');

      let block3filter = block3.filter(
        (item: any) => item.parentId == parentid
      );

      const dom2: HTMLElement = this.elementRef.nativeElement;
      if (block3filter.length > 1) {
        let element1: any = dom2.querySelector('#plancheck3Voluntry' + subgroupid);

        if (element1.checked) {
          console.log('checked');

          element1.checked = false;
          return;
        } else {
          if (block3) {

            let index = this.getslectedplansblock3(subgroupid);

            if (index > -1) {
              block3.splice(index, 1);
              let summaryBlock3 = JSON.parse(sessionStorage.getItem('summaryBlock3') || '[]');



              if (subgroupid == 17 || subgroupid == 18 || subgroupid == 28) {


                this.plansresblack3[packageindex]['groups'][groupindex][
                  'subGroups'
                ][subgroupindex]['checked'] = false;

                if (
                  this.plansresblack3[packageindex]['groups'][groupindex][
                  'subGroups'
                  ][subgroupindex]['name'] == 'Executive Health'
                ) {


                  $('#executiveplansblock3single' + subgroupid).prop(
                    'checked',
                    false
                  );
                  $('#executiveplansblock3couple' + subgroupid).prop(
                    'checked',
                    false
                  );
                  $('#executiveplansblock3family' + subgroupid).prop(
                    'checked',
                    false
                  );
                  $('#executiveplansblock3single' + subgroupid).prop(
                    'disabled',
                    true
                  );
                  $('#executiveplansblock3couple' + subgroupid).prop(
                    'disabled',
                    true
                  );
                  $('#executiveplansblock3family' + subgroupid).prop(
                    'disabled',
                    true
                  );



                }

                if (
                  this.plansresblack3[packageindex]['groups'][groupindex][
                  'subGroups'
                  ][subgroupindex]['name'] == 'Complete Executive Care'
                ) {


                  $('#executiveplansblock3single' + subgroupid).prop(
                    'checked',
                    false
                  );
                  $('#executiveplansblock3couple' + subgroupid).prop(
                    'checked',
                    false
                  );
                  $('#executiveplansblock3family' + subgroupid).prop(
                    'checked',
                    false
                  );
                  $('#executiveplansblock3single' + subgroupid).prop(
                    'disabled',
                    true
                  );
                  $('#executiveplansblock3couple' + subgroupid).prop(
                    'disabled',
                    true
                  );
                  $('#executiveplansblock3family' + subgroupid).prop(
                    'disabled',
                    true
                  );

                }
                if (
                  this.plansresblack3[packageindex]['groups'][groupindex][
                  'subGroups'
                  ][subgroupindex]['name'] == 'Provincial Health Replacement Plan'
                ) {


                  $('#executiveplansblock3single' + subgroupid).prop(
                    'checked',
                    false
                  );
                  $('#executiveplansblock3couple' + subgroupid).prop(
                    'checked',
                    false
                  );
                  $('#executiveplansblock3family' + subgroupid).prop(
                    'checked',
                    false
                  );
                  $('#executiveplansblock3single' + subgroupid).prop(
                    'disabled',
                    true
                  );
                  $('#executiveplansblock3couple' + subgroupid).prop(
                    'disabled',
                    true
                  );
                  $('#executiveplansblock3family' + subgroupid).prop(
                    'disabled',
                    true
                  );

                }


              }




              var newselectedplans: any = {};
              for (var i = 0; i < summaryBlock3.length; i++) {
                newselectedplans[summaryBlock3[i].subGroupId] = i;
              }

              sessionStorage.setItem('selectedPlans', JSON.stringify(newselectedplans));

              this.planssummarymain = [];
              this.planssummaryopt = [];

              summaryBlock3.forEach((element: any) => {
                if (element.packagename != 'Opt-in') {
                  this.planssummarymain.push(element);
                } else {
                  this.planssummaryopt.push(element);
                }
              });


              let selectedplansblock3 = JSON.parse(
                sessionStorage.getItem('summaryBlock3') || '[]'
              );



              sessionStorage.setItem(
                'summaryBlock3main',
                JSON.stringify(this.planssummarymain)
              );
              sessionStorage.setItem(
                'summaryBlock3opt',
                JSON.stringify(this.planssummaryopt)
              );

              sessionStorage.setItem('summaryBlock3', JSON.stringify(summaryBlock3));


            } else {
              return;
            }
          }

          sessionStorage.setItem('summaryBlock3', JSON.stringify(block3));

          let selectedplansblock3 = JSON.parse(
            sessionStorage.getItem('summaryBlock3') || '[]'
          );

          return;
        }
      }
    }

  }
  clean(obj) {
    for (var propName in obj) {
      if (
        obj[propName] === null ||
        obj[propName] === undefined ||
        obj[propName].length === 0
      ) {
        delete obj[propName];
      }
    }

    return obj;
  }

  onCheckboxChange1Tier(
    e: any,
    allow_multiple: any,
    disallowedPlanLevels: any,
    packageid: any,
    subgroupid: any,
    pname: any,
    subgroupname: any,
    subgroup: any,
    ordering: any,
    parentid: any,
    parentname: any,
    packageindex: number,
    groupindex: number,
    subgroupindex: number,
    backgroundColor: any
  ) {
    this.planselectedId = subgroupid;

    let obj = {
      packageId: packageid,
      subGroupid: subgroupid,
      subGroupName: subgroupname,
      packageName: pname,
      tiers: [],
      tiersidArray: [],
      disallowedPlanLevels: disallowedPlanLevels,
      packageindex: packageindex,
      groupindex: groupindex,
      subgroupindex: subgroupindex,
      parentid: parentid,
      backgroundColor: backgroundColor,
    };

    let selectedTiersBlock1 = JSON.parse(
      sessionStorage.getItem('selectedTiersBlock1') || '[]'
    );

    console.log(selectedTiersBlock1);
    if (e.target.checked) {
      this.plansBlock1Tiers[packageindex]['groups'][groupindex]['subGroups'][
        subgroupindex
      ].checked = true;
      this.selectedPlansInfoTierArray.push(obj);

      selectedTiersBlock1.push(obj);
      sessionStorage.setItem(
        'selectedTiersBlock1',
        JSON.stringify(selectedTiersBlock1)
      );

      if (!this.selectedPackagePlansInfoTier[pname]) {
        this.selectedPackagePlansInfoTier[pname] = [];
      }
      const exists =
        this.selectedPackagePlansInfoTier[pname].findIndex(
          (item) => item.subGroupid === subgroupid
        ) > -1;
      if (exists) {
        console.log('check');
      } else {
        console.log('check1');
        this.selectedPackagePlansInfoTier[pname].push(obj);

        this.selectedPackagePlansInfoTier = this.clean(
          this.selectedPackagePlansInfoTier
        );

        console.log(this.selectedPackagePlansInfoTier);
      }

      this.checkdisallowedPlans(subgroupid, parentid, packageid);


      if (
        this.plansBlock1Tiers[obj.packageindex]['groups'][obj.groupindex][
        'subGroups'
        ][obj.subgroupindex]['name'] == 'Executive Health'
      ) {
        this.plansBlock1Tiers[obj.packageindex]['groups'][obj.groupindex][
          'subGroups'
        ][obj.subgroupindex]['coverage'] = 'Exec';
        this.block1coverage = false;

        // $("#executiveplans" + obj.subGroupId).prop("checked", false);
        $('#executiveplansTiersingle' + obj.subGroupid).prop('disabled', false);
        $('#executiveplansTiercouple' + obj.subGroupid).prop('disabled', false);
        $('#executiveplansTierfamily' + obj.subGroupid).prop('disabled', false);
        $('#executiveplansTiersingle' + obj.subGroupid).click();
      }
      if (
        this.plansBlock1Tiers[obj.packageindex]['groups'][obj.groupindex][
        'subGroups'
        ][obj.subgroupindex]['name'] == 'Complete Executive Care'
      ) {
        this.plansBlock1Tiers[obj.packageindex]['groups'][obj.groupindex][
          'subGroups'
        ][obj.subgroupindex]['coverage'] = 'Exec';
        this.block1coverage = false;
        // $("#executiveplans" + obj.subGroupId).prop("checked", false);
        $('#executiveplansTiersingle' + obj.subGroupid).prop('disabled', false);
        $('#executiveplansTiercouple' + obj.subGroupid).prop('disabled', false);
        $('#executiveplansTierfamily' + obj.subGroupid).prop('disabled', false);
        $('#executiveplansTiersingle' + obj.subGroupid).click();
      }
    }


    else {
      if (
        this.plansBlock1Tiers[obj.packageindex]['groups'][obj.groupindex][
        'subGroups'
        ][obj.subgroupindex]['name'] == 'Executive Health'
      ) {
        this.plansBlock1Tiers[obj.packageindex]['groups'][obj.groupindex][
          'subGroups'
        ][obj.subgroupindex]['coverage'] = 'Exec';
        this.block1coverage = false;

        // $("#executiveplans" + obj.subGroupId).prop("checked", false);
        $('#executiveplansTiersingle' + obj.subGroupid).prop('disabled', true);
        $('#executiveplansTiercouple' + obj.subGroupid).prop('disabled', true);
        $('#executiveplansTierfamily' + obj.subGroupid).prop('disabled', true);

      }
      if (
        this.plansBlock1Tiers[obj.packageindex]['groups'][obj.groupindex][
        'subGroups'
        ][obj.subgroupindex]['name'] == 'Complete Executive Care'
      ) {
        this.plansBlock1Tiers[obj.packageindex]['groups'][obj.groupindex][
          'subGroups'
        ][obj.subgroupindex]['coverage'] = 'Exec';
        this.block1coverage = false;
        // $("#executiveplans" + obj.subGroupId).prop("checked", false);
        $('#executiveplansTiersingle' + obj.subGroupid).prop('disabled', true);
        $('#executiveplansTiercouple' + obj.subGroupid).prop('disabled', true);
        $('#executiveplansTierfamily' + obj.subGroupid).prop('disabled', true);

      }

      this.plansBlock1Tiers[packageindex]['groups'][groupindex]['subGroups'][
        subgroupindex
      ].checked = false;
      this.plansBlock1Tiers[packageindex]['groups'][groupindex]['subGroups'][
        subgroupindex
      ].coverage = '';  //default
      this.plansBlock1Tiers[packageindex]['groups'][groupindex]['subGroups'][
        subgroupindex
      ].tiers = [];

      console.log(this.selectedPackagesavailableTiers2);
      // this.selectedPackagesavailableTiers2[packageid]= this.configureTierList;

      console.log(this.selectedPackagesavailableTiers2);
      // this.selectedPackagesavailableTiers2[packageindex]['groups'][groupindex]['subGroups'][
      //   subgroupindex
      // ]= this.configureTierList;

      // Here to change
      const exists =
        this.selectedPackagePlansInfoTier[pname].findIndex(
          (item) => item.subGroupid === subgroupid
        ) > -1;

      // var index = this.selectedPackagePlansInfoTier[pname].findIndex(function(item){ return item.subGroupid === subgroupid})

      let arr = this.selectedPackagePlansInfoTier[pname];
      let subGroupIdindex;
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].subGroupid == subgroupid) {
          subGroupIdindex = i;
          break;
        }
      }

      if (subGroupIdindex > -1) {
        this.selectedPackagePlansInfoTier[pname].splice(subGroupIdindex, 1);
      }
      var index1 = selectedTiersBlock1.findIndex(function (item) {
        return item.subGroupid === subgroupid;
      });

      console.log(this.selectedPackagePlansInfoTier);

      console.log(this.selectedPackagePlansInfoTier);
      console.log(this.seelctedplanLevelTierMapping);
      selectedTiersBlock1.splice(index1, 1);

      for (let i = 0; i < this.seelctedplanLevelTierMapping.length; i++) {
        if (this.seelctedplanLevelTierMapping[i].subGroupid == subgroupid) {
          this.seelctedplanLevelTierMapping.splice(i, 1);
        }
      }
      sessionStorage.setItem(
        'selectedTiersBlock1',
        JSON.stringify(selectedTiersBlock1)
      );

      console.log(this.selectedPackagesavailableTiers2);
      if (exists) {
        console.log(exists);
      } else {
        this.selectedPackagePlansInfoTier[pname].push(obj);
        //   this.TiersArray.push(obj)
        //  sessionStorage.setItem('selectedTiersBlock1', JSON.stringify(this.TiersArray));

        console.log(this.selectedPackagePlansInfoTier);

        console.log(this.seelctedplanLevelTierMapping);
      }
    }

    sessionStorage.setItem(
      'plansBlock1Tiers',
      JSON.stringify(this.plansBlock1Tiers)
    );
    if (this.upgradeplansselectiontiers == true) {
      let el: HTMLElement = this.upgradeplanstiersfalse.nativeElement;
      el.click();
      // setTimeout(() => {
      //   let el1: HTMLElement = this.upgradeplanstierstrue.nativeElement;
      //   el1.click();
      // }, 10);
    }
    if (this.employeeplanpurchasetiers == true) {
      let el: HTMLElement = this.employeepurchaseTiersfalse.nativeElement;
      el.click();
      // setTimeout(() => {
      //   let el1: HTMLElement = this.employeepurchaseTierstrue.nativeElement;
      //   el1.click();
      // }, 10);
    }

    // this.selectedPlansInfoTierArray.push(obj);

    // if (!this.selectedPackagePlansInfoTier[pname]) {
    //   this.selectedPackagePlansInfoTier[pname] = [];
    // }
    // const exists =
    //   this.selectedPackagePlansInfoTier[pname].findIndex(
    //     (item) => item.subGroupid === subgroupid
    //   ) > -1;
    // if (exists) {
    //   console.log('check');
    // } else {

    //   this.selectedPackagePlansInfoTier[pname].push(obj);

    //   console.log(this.selectedPackagePlansInfoTier)
    // }
  }
  onCheckboxChange2Tier(
    e: any,
    allow_multiple: any,
    disallowedPlanLevels: any,
    packageid: any,
    subgroupid: any,
    pname: any,
    subgroupname: any,
    subgroup: any,
    ordering: any,
    parentid: any,
    parentname: any,
    packageindex: number,
    groupindex: number,
    subgroupindex: number,
    backgroundColor: any
  ) {
    this.planselectedId = subgroupid;

    let obj = {
      packageId: packageid,
      subGroupid: subgroupid,
      subGroupName: subgroupname,
      packageName: pname,
      tiers: [],
      tiersidArray: [],
      disallowedPlanLevels: disallowedPlanLevels,
      packageindex: packageindex,
      groupindex: groupindex,
      subgroupindex: subgroupindex,
      parentid: parentid,
      backgroundColor: backgroundColor,
    };

    let selectedTiersBlock2 = JSON.parse(
      sessionStorage.getItem('selectedTiersBlock2') || '[]'
    );

    console.log(selectedTiersBlock2);

    // seelctedplanLevelTierMappingBlock2
    if (e.target.checked) {
      this.plansresblack2Tiers[packageindex]['groups'][groupindex]['subGroups'][
        subgroupindex
      ].checked = true;
      this.selectedPlansInfoTierArrayBlock2.push(obj);

      selectedTiersBlock2.push(obj);
      sessionStorage.setItem(
        'selectedTiersBlock2',
        JSON.stringify(selectedTiersBlock2)
      );

      if (!this.selectedPackagePlansInfoTierBlock2[pname]) {
        this.selectedPackagePlansInfoTierBlock2[pname] = [];
      }
      const exists =
        this.selectedPackagePlansInfoTierBlock2[pname].findIndex(
          (item) => item.subGroupid === subgroupid
        ) > -1;
      if (exists) {
        console.log('check');
      } else {
        console.log('check1');
        this.selectedPackagePlansInfoTierBlock2[pname].push(obj);

        this.selectedPackagePlansInfoTierBlock2 = this.clean(
          this.selectedPackagePlansInfoTierBlock2
        );
        console.log(this.selectedPackagePlansInfoTierBlock2);


      }

      if (
        this.plansresblack2Tiers[obj.packageindex]['groups'][obj.groupindex][
        'subGroups'
        ][obj.subgroupindex]['name'] == 'Executive Health'
      ) {
        console.log('test1');
        $('#executiveplansblock2Tiersingle' + obj.subGroupid).prop(
          'disabled',
          false
        );
        $('#executiveplansblock2Tiercouple' + obj.subGroupid).prop(
          'disabled',
          false
        );
        $('#executiveplansblock2Tierfamily' + obj.subGroupid).prop(
          'disabled',
          false
        );
        $('#executiveplansblock2Tiersingle' + obj.subGroupid).click();

        console.log(this.seelctedplanLevelTierMappingBlock2);
      }
      if (
        this.plansresblack2Tiers[obj.packageindex]['groups'][obj.groupindex][
        'subGroups'
        ][obj.subgroupindex]['name'] == 'Complete Executive Care'
      ) {
        $('#executiveplansblock2Tiersingle' + obj.subGroupid).prop(
          'disabled',
          false
        );
        $('#executiveplansblock2Tiercouple' + obj.subGroupid).prop(
          'disabled',
          false
        );
        $('#executiveplansblock2Tierfamily' + obj.subGroupid).prop(
          'disabled',
          false
        );
        $('#executiveplansblock2Tiersingle' + obj.subGroupid).click();
      }

      console.log(this.seelctedplanLevelTierMapping)

      console.log(this.selectedPackagesavailableTiers2Block2)
      // selectedPackagesavailableTiers2Block2[planLevel.packageId][planLevel.subGroupid]
      let mappingtiers = this.seelctedplanLevelTierMapping;

      console.log(mappingtiers);


      if (mappingtiers.length > 0) {
        for (let i = 0; i < mappingtiers.length; i++) {

          if (mappingtiers[i] && mappingtiers[i].subGroupid == obj.subGroupid) {
            if (mappingtiers[i].tiers && mappingtiers[i].tiers.length > 0) {

              for (let j = 0; j < mappingtiers[i].tiers.length; j++) {



                for (let k = 0; k < this.configureTierList.length; k++) {
                  console.log(this.configureTierList[k].id);
                  console.log(mappingtiers[i].tiers[j].id);

                  if (this.configureTierList[k].id != mappingtiers[i].tiers[j].id) {


                    console.log(this.selectedPackagesavailableTiers2Block2)
                    console.log(obj.packageId)
                    console.log(obj.subGroupid)

                    if (!this.selectedPackagesavailableTiers2Block2[obj.packageId]) {

                      this.selectedPackagesavailableTiers2Block2[obj.packageId] = {};
                      this.selectedPackagesavailableTiers2Block2[obj.packageId][
                        obj.subGroupid
                      ] = this.configureTierList[k];
                    } else {

                      if (
                        !this.selectedPackagesavailableTiers2Block2[obj.packageId][
                        obj.subGroupid
                        ]
                      ) {
                        let array = []
                        array.push(this.configureTierList[k])
                        this.selectedPackagesavailableTiers2Block2[obj.packageId][
                          obj.subGroupid
                        ] = array;
                      }
                    }

                  }

                }


              }
            }
          }
          else {


            if (!this.selectedPackagesavailableTiers2Block2[obj.packageId]) {

              this.selectedPackagesavailableTiers2Block2[obj.packageId] = {};
              this.selectedPackagesavailableTiers2Block2[obj.packageId][
                obj.subGroupid
              ] = this.configureTierList;
            } else {

              if (
                !this.selectedPackagesavailableTiers2Block2[obj.packageId][
                obj.subGroupid
                ]
              ) {
                this.selectedPackagesavailableTiers2Block2[obj.packageId][
                  obj.subGroupid
                ] = this.configureTierList;
              }
            }
          }
        }
      }

      else {

        this.selectedPackagesavailableTiers2Block2[obj.packageId][
          obj.subGroupid
        ] = this.configureTierList;
      }


    }
    else {


      if (
        this.plansresblack2Tiers[obj.packageindex]['groups'][obj.groupindex][
        'subGroups'
        ][obj.subgroupindex]['name'] == 'Executive Health'
      ) {
        this.plansresblack2Tiers[obj.packageindex]['groups'][obj.groupindex][
          'subGroups'
        ][obj.subgroupindex]['coverage'] = 'Exec';
        this.block1coverage = false;

        // $("#executiveplans" + obj.subGroupId).prop("checked", false);
        $('#executiveplansblock2Tiersingle' + obj.subGroupid).prop(
          'disabled',
          true
        );
        $('#executiveplansblock2Tiercouple' + obj.subGroupid).prop(
          'disabled',
          true
        );
        $('#executiveplansblock2Tierfamily' + obj.subGroupid).prop(
          'disabled',
          true
        );

      }
      if (
        this.plansresblack2Tiers[obj.packageindex]['groups'][obj.groupindex][
        'subGroups'
        ][obj.subgroupindex]['name'] == 'Complete Executive Care'
      ) {
        this.plansresblack2Tiers[obj.packageindex]['groups'][obj.groupindex][
          'subGroups'
        ][obj.subgroupindex]['coverage'] = 'Exec';
        this.block1coverage = false;
        // $("#executiveplans" + obj.subGroupId).prop("checked", false);
        $('#executiveplansblock2Tiersingle' + obj.subGroupid).prop(
          'disabled',
          true
        );
        $('#executiveplansblock2Tiercouple' + obj.subGroupid).prop(
          'disabled',
          true
        );
        $('#executiveplansblock2Tierfamily' + obj.subGroupid).prop(
          'disabled',
          true
        );
      }
      this.plansresblack2Tiers[packageindex]['groups'][groupindex]['subGroups'][
        subgroupindex
      ].checked = false;
      this.plansresblack2Tiers[packageindex]['groups'][groupindex]['subGroups'][
        subgroupindex
      ].tiers = [];
      this.plansresblack2Tiers[packageindex]['groups'][groupindex]['subGroups'][
        subgroupindex
      ].coverage = ''; //default

      // Here to change





      if (this.selectedPackagesavailableTiers2Block2[packageindex]['groups']) {
        this.selectedPackagesavailableTiers2Block2[packageindex]['groups'][
          groupindex
        ]['subGroups'][subgroupindex] = this.configureTierList;

        this.selectedPackagesavailableTiers2Block2[packageid] =
          this.configureTierList;
      }




      const exists =
        this.selectedPackagePlansInfoTierBlock2[pname].findIndex(
          (item) => item.subGroupid === subgroupid
        ) > -1;

      // var index = this.selectedPackagePlansInfoTierBlock2[pname].findIndex(function(item){ return item.subGroupid === subgroupid})
      var index1 = selectedTiersBlock2.findIndex(function (item) {
        return item.subGroupid === subgroupid;
      });

      let arr = this.selectedPackagePlansInfoTierBlock2[pname];
      let subGroupIdindex;
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].subGroupid == subgroupid) {
          subGroupIdindex = i;
          break;
        }
      }

      if (subGroupIdindex > -1) {
        this.selectedPackagePlansInfoTierBlock2[pname].splice(
          subGroupIdindex,
          1
        );
      }
      // this.selectedPackagePlansInfoTierBlock2[pname].splice(index,1)
      selectedTiersBlock2.splice(index1, 1);

      //  console.log(this.seelctedplanLevelTierMappingBlock2)
      for (let i = 0; i < this.seelctedplanLevelTierMappingBlock2.length; i++) {
        if (
          this.seelctedplanLevelTierMappingBlock2[i].subGroupid == subgroupid
        ) {
          this.seelctedplanLevelTierMappingBlock2.splice(i, 1);
        }
      }

      // console.log(selectedTiersBlock2)
      // console.log(this.selectedPackagePlansInfoTierBlock2)
      // console.log(this.seelctedplanLevelTierMappingBlock2)
      sessionStorage.setItem(
        'selectedTiersBlock2',
        JSON.stringify(selectedTiersBlock2)
      );
      if (exists) {
        console.log(exists);
      } else {
        this.selectedPackagePlansInfoTierBlock2[pname].push(obj);
        //   this.TiersArray.push(obj)
        //  sessionStorage.setItem('selectedTiersBlock1', JSON.stringify(this.TiersArray));

        //   console.log(this.selectedPackagePlansInfoTier)
      }
    }
    sessionStorage.setItem(
      'plansBlock2Tiers',
      JSON.stringify(this.plansresblack2Tiers)
    );

    if (this.employeeplanpurchasetiers == true) {
      let el: HTMLElement = this.employeepurchaseTiersfalse.nativeElement;
      el.click();
      // setTimeout(() => {
      //   let el1: HTMLElement = this.employeepurchaseTierstrue.nativeElement;
      //   el1.click();
      // }, 10);
    }
  }
  onCheckboxChange3Tier(
    e: any,
    allow_multiple: any,
    disallowedPlanLevels: any,
    packageid: any,
    subgroupid: any,
    pname: any,
    subgroupname: any,
    subgroup: any,
    ordering: any,
    parentid: any,
    parentname: any,
    packageindex: number,
    groupindex: number,
    subgroupindex: number,
    backgroundColor: any
  ) {
    this.planselectedId = subgroupid;

    let obj = {
      packageId: packageid,
      subGroupid: subgroupid,
      subGroupName: subgroupname,
      packageName: pname,
      tiers: [],
      tiersidArray: [],
      disallowedPlanLevels: disallowedPlanLevels,
      packageindex: packageindex,
      groupindex: groupindex,
      subgroupindex: subgroupindex,
      parentid: parentid,
      backgroundColor: backgroundColor,
    };

    let selectedTiersBlock3 = JSON.parse(
      sessionStorage.getItem('selectedTiersBlock3') || '[]'
    );

    let block3TiersRes = JSON.parse(
      sessionStorage.getItem('block3resultTiers') || '[]'
    );

    //  if(block3TiersRes.length>0){
    //   this.plansresblack3Tiers = JSON.parse(sessionStorage.getItem('block3resultTiers') || '[]');
    //  }
    //  else{
    //   this.plansresblack3Tiers = this.plansresblack3Tiers
    //  }
    if (e.target.checked) {
      console.log(this.plansresblack3Tiers);
      // this.plansresblack3Tiers = JSON.parse(sessionStorage.getItem('block3resultTiers') || '[]');
      this.plansresblack3Tiers[packageindex]['groups'][groupindex]['subGroups'][
        subgroupindex
      ].checked = true;
      this.selectedPlansInfoTierArrayBlock3.push(obj);

      selectedTiersBlock3.push(obj);
      sessionStorage.setItem(
        'selectedTiersBlock3',
        JSON.stringify(selectedTiersBlock3)
      );

      if (!this.selectedPackagePlansInfoTierBlock3[pname]) {
        this.selectedPackagePlansInfoTierBlock3[pname] = [];
      }
      const exists =
        this.selectedPackagePlansInfoTierBlock3[pname].findIndex(
          (item) => item.subGroupid === subgroupid
        ) > -1;
      if (exists) {
        console.log('check');
      } else {
        console.log('check1');
        this.selectedPackagePlansInfoTierBlock3[pname].push(obj);
        this.selectedPackagePlansInfoTierBlock3 = this.clean(
          this.selectedPackagePlansInfoTierBlock3
        );
      }

      if (
        this.plansresblack3Tiers[obj.packageindex]['groups'][obj.groupindex][
        'subGroups'
        ][obj.subgroupindex]['name'] == 'Executive Health'
      ) {
        // this.plansresblack3Tiers[obj.packageindex]['groups'][obj.groupindex]['subGroups'][
        //   obj.subgroupindex
        // ]['coverage'] = 'Exec';
        this.block1coverage = false;

        // $("#executiveplans" + obj.subGroupId).prop("checked", false);
        $('#executiveplansblock3Tiersingle' + obj.subGroupid).prop(
          'disabled',
          false
        );
        $('#executiveplansblock3Tiercouple' + obj.subGroupid).prop(
          'disabled',
          false
        );
        $('#executiveplansblock3Tierfamily' + obj.subGroupid).prop(
          'disabled',
          false
        );
        $('#executiveplansblock3Tiersingle' + obj.subGroupid).click();
      }
      if (
        this.plansresblack3Tiers[obj.packageindex]['groups'][obj.groupindex][
        'subGroups'
        ][obj.subgroupindex]['name'] == 'Complete Executive Care'
      ) {
        // this.plansresblack3Tiers[obj.packageindex]['groups'][obj.groupindex]['subGroups'][
        //   obj.subgroupindex
        // ]['coverage'] = 'Exec';
        this.block1coverage = false;
        // $("#executiveplans" + obj.subGroupId).prop("checked", false);
        $('#executiveplansblock3Tiersingle' + obj.subGroupid).prop(
          'disabled',
          false
        );
        $('#executiveplansblock3Tiercouple' + obj.subGroupid).prop(
          'disabled',
          false
        );
        $('#executiveplansblock3Tierfamily' + obj.subGroupid).prop(
          'disabled',
          false
        );
        $('#executiveplansblock3Tiersingle' + obj.subGroupid).click();
      }


      if (this.seelctedplanLevelTierMappingBlock2.length > 0) {

        let mappingtiers = this.seelctedplanLevelTierMappingBlock2;

        console.log(mappingtiers);
        if (mappingtiers.length > 0) {
          for (let i = 0; i < mappingtiers.length; i++) {

            if (mappingtiers[i] && mappingtiers[i].subGroupid == obj.subGroupid) {
              if (mappingtiers[i].tiers && mappingtiers[i].tiers.length > 0) {

                for (let j = 0; j < mappingtiers[i].tiers.length; j++) {



                  for (let k = 0; k < this.configureTierList.length; k++) {
                    console.log(this.configureTierList[k].id);
                    console.log(mappingtiers[i].tiers[j].id);

                    if (this.configureTierList[k].id != mappingtiers[i].tiers[j].id) {

                      if (!this.selectedPackagesavailableTiers3Block3[obj.packageId]) {

                        this.selectedPackagesavailableTiers3Block3[obj.packageId] = {};
                        this.selectedPackagesavailableTiers3Block3[obj.packageId][
                          obj.subGroupid
                        ] = this.configureTierList[k];
                      } else {

                        if (
                          !this.selectedPackagesavailableTiers3Block3[obj.packageId][
                          obj.subGroupid
                          ]
                        ) {
                          let array = []
                          array.push(this.configureTierList[k])
                          this.selectedPackagesavailableTiers3Block3[obj.packageId][
                            obj.subGroupid
                          ] = array;
                        }
                      }

                    }

                  }


                }
              }
            }
            else {


              if (!this.selectedPackagesavailableTiers3Block3[obj.packageId]) {

                this.selectedPackagesavailableTiers3Block3[obj.packageId] = {};
                this.selectedPackagesavailableTiers3Block3[obj.packageId][
                  obj.subGroupid
                ] = this.configureTierList;
              } else {

                if (
                  !this.selectedPackagesavailableTiers3Block3[obj.packageId][
                  obj.subGroupid
                  ]
                ) {
                  this.selectedPackagesavailableTiers3Block3[obj.packageId][
                    obj.subGroupid
                  ] = this.configureTierList;
                }
              }
            }
          }
        }

        else {

          this.selectedPackagesavailableTiers3Block3[obj.packageId][
            obj.subGroupid
          ] = this.configureTierList;
        }
      }
      else {
        let mappingtiers = this.seelctedplanLevelTierMapping;

        console.log(mappingtiers);
        if (mappingtiers.length > 0) {
          for (let i = 0; i < mappingtiers.length; i++) {

            if (mappingtiers[i] && mappingtiers[i].subGroupid == obj.subGroupid) {
              if (mappingtiers[i].tiers && mappingtiers[i].tiers.length > 0) {

                for (let j = 0; j < mappingtiers[i].tiers.length; j++) {



                  for (let k = 0; k < this.configureTierList.length; k++) {
                    console.log(this.configureTierList[k].id);
                    console.log(mappingtiers[i].tiers[j].id);

                    if (this.configureTierList[k].id != mappingtiers[i].tiers[j].id) {

                      if (!this.selectedPackagesavailableTiers3Block3[obj.packageId]) {

                        this.selectedPackagesavailableTiers3Block3[obj.packageId] = {};
                        this.selectedPackagesavailableTiers3Block3[obj.packageId][
                          obj.subGroupid
                        ] = this.configureTierList[k];
                      } else {

                        if (
                          !this.selectedPackagesavailableTiers3Block3[obj.packageId][
                          obj.subGroupid
                          ]
                        ) {
                          let array = []
                          array.push(this.configureTierList[k])
                          this.selectedPackagesavailableTiers3Block3[obj.packageId][
                            obj.subGroupid
                          ] = array;
                        }
                      }

                    }

                  }


                }
              }
            }
            else {


              if (!this.selectedPackagesavailableTiers3Block3[obj.packageId]) {

                this.selectedPackagesavailableTiers3Block3[obj.packageId] = {};
                this.selectedPackagesavailableTiers3Block3[obj.packageId][
                  obj.subGroupid
                ] = this.configureTierList;
              } else {

                if (
                  !this.selectedPackagesavailableTiers3Block3[obj.packageId][
                  obj.subGroupid
                  ]
                ) {
                  this.selectedPackagesavailableTiers3Block3[obj.packageId][
                    obj.subGroupid
                  ] = this.configureTierList;
                }
              }
            }
          }
        }

        else {

          this.selectedPackagesavailableTiers3Block3[obj.packageId][
            obj.subGroupid
          ] = this.configureTierList;
        }
      }

    } else {
      if (
        this.plansresblack3Tiers[obj.packageindex]['groups'][obj.groupindex][
        'subGroups'
        ][obj.subgroupindex]['name'] == 'Executive Health'
      ) {
        this.plansresblack3Tiers[obj.packageindex]['groups'][obj.groupindex][
          'subGroups'
        ][obj.subgroupindex]['coverage'] = 'Exec';
        this.block1coverage = false;

        // $("#executiveplans" + obj.subGroupId).prop("checked", false);
        $('#executiveplansblock3Tiersingle' + obj.subGroupid).prop(
          'disabled',
          true
        );
        $('#executiveplansblock3Tiercouple' + obj.subGroupid).prop(
          'disabled',
          true
        );
        $('#executiveplansblock3Tierfamily' + obj.subGroupid).prop(
          'disabled',
          true
        );

      }
      if (
        this.plansresblack3Tiers[obj.packageindex]['groups'][obj.groupindex][
        'subGroups'
        ][obj.subgroupindex]['name'] == 'Complete Executive Care'
      ) {
        this.plansresblack3Tiers[obj.packageindex]['groups'][obj.groupindex][
          'subGroups'
        ][obj.subgroupindex]['coverage'] = 'Exec';
        this.block1coverage = false;
        // $("#executiveplans" + obj.subGroupId).prop("checked", false);
        $('#executiveplansblock3Tiersingle' + obj.subGroupid).prop(
          'disabled',
          true
        );
        $('#executiveplansblock3Tiercouple' + obj.subGroupid).prop(
          'disabled',
          true
        );
        $('#executiveplansblock3Tierfamily' + obj.subGroupid).prop(
          'disabled',
          true
        );

      }
      this.plansresblack3Tiers[packageindex]['groups'][groupindex]['subGroups'][
        subgroupindex
      ].checked = false;
      this.plansresblack3Tiers[packageindex]['groups'][groupindex]['subGroups'][
        subgroupindex
      ].tiers = [];
      this.selectedPackagesavailableTiers3Block3[packageid] =
        this.configureTierList;
      // this.plansresblack3Tiers[packageindex]['groups'][groupindex]['subGroups'][
      //   subgroupindex
      // ].coverage = "default";

      // Here to change
      this.selectedPackagesavailableTiers3Block3[packageindex]['groups'][
        groupindex
      ]['subGroups'][subgroupindex] = this.configureTierList;

      const exists =
        this.selectedPackagePlansInfoTierBlock3[pname].findIndex(
          (item) => item.subGroupid === subgroupid
        ) > -1;

      // var index = this.selectedPackagePlansInfoTierBlock3[pname].findIndex(function(item){ return item.subGroupid === subgroupid})
      var index1 = selectedTiersBlock3.findIndex(function (item) {
        return item.subGroupid === subgroupid;
      });

      let arr = this.selectedPackagePlansInfoTierBlock3[pname];
      let subGroupIdindex;
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].subGroupid == subgroupid) {
          subGroupIdindex = i;
          break;
        }
      }

      if (subGroupIdindex > -1) {
        this.selectedPackagePlansInfoTierBlock3[pname].splice(
          subGroupIdindex,
          1
        );
      }
      for (let i = 0; i < this.seelctedplanLevelTierMappingBlock3.length; i++) {
        if (
          this.seelctedplanLevelTierMappingBlock3[i].subGroupid == subgroupid
        ) {
          this.seelctedplanLevelTierMappingBlock3.splice(i, 1);
        }
      }
      // this.selectedPackagePlansInfoTierBlock3[pname].splice(index,1)
      selectedTiersBlock3.splice(index1, 1);

      sessionStorage.setItem(
        'selectedTiersBlock3',
        JSON.stringify(selectedTiersBlock3)
      );
      if (exists) {
        console.log(exists);
      } else {
        this.selectedPackagePlansInfoTierBlock3[pname].push(obj);
        //   this.TiersArray.push(obj)
        //  sessionStorage.setItem('selectedTiersBlock1', JSON.stringify(this.TiersArray));

        //   console.log(this.selectedPackagePlansInfoTier)
      }
    }
  }

  checkdisallowedPlansextension(
    curr_planLevel_id: number,
    curr_palnlevel_parentid: number,
    curr_packageid: number,

  ) {

    setTimeout(() => {
      let availabelTiers = JSON.parse(sessionStorage.getItem("avilableTiersBlock1"))
      console.log(availabelTiers)

      if (!availabelTiers[curr_packageid]) {
        availabelTiers[curr_packageid] = {};
        availabelTiers[curr_packageid][curr_planLevel_id] =
          this.configureTierList;
      } else {
        if (
          !availabelTiers[curr_packageid][curr_planLevel_id]
        ) {
          availabelTiers[curr_packageid][
            curr_planLevel_id
          ] = this.configureTierList;
        }
        else {
          availabelTiers[curr_packageid][
            curr_planLevel_id
          ] = this.configureTierList;
        }
      }

      const dom2: HTMLElement = this.elementRef.nativeElement;

      let pl = this.disallowedplansTiers;
      var all_pl: any = Object.keys(pl);

      console.log(pl);
      console.log(all_pl);


      let availableTiers2 =
        availabelTiers[curr_packageid][
        curr_planLevel_id
        ];
      for (var i = 0; i < all_pl.length; i++) {
        console.log(all_pl[i]);
        if (
          pl[all_pl[i]].includes(curr_planLevel_id.toString()) ||
          pl[all_pl[i]].includes(curr_palnlevel_parentid.toString())
        ) {
          console.log(all_pl[i]);
          // console.log(dom2.querySelector("#plancheck"+all_pl[i]))

          let mappingtiers = this.seelctedplanLevelTierMapping;

          console.log(mappingtiers);
          let subGroupIdindex;

          for (let i = 0; i < mappingtiers.length; i++) {

            if (mappingtiers[i] && mappingtiers[i].subGroupid == all_pl[i]) {
              if (mappingtiers[i].tiers && mappingtiers[i].tiers.length > 0) {

                for (let j = 0; j < mappingtiers[i].tiers.length; j++) {

                  let arr = availableTiers2

                  for (let k = 0; k < arr.length; k++) {
                    console.log(arr[k].id);
                    console.log(mappingtiers[i].tiers[j].id);

                    if (arr[k].id == mappingtiers[i].tiers[j].id) {
                      subGroupIdindex = i;
                      break;
                    }
                  }

                  console.log(subGroupIdindex)


                  availableTiers2.splice(subGroupIdindex, 1);
                  console.log(JSON.parse(JSON.stringify(availableTiers2)));
                  console.log(availableTiers2.length);

                  if (!availableTiers2) {
                    continue;
                  }
                  console.log(JSON.parse(JSON.stringify(availableTiers2)));
                  console.log(availableTiers2.length);

                  availabelTiers[curr_packageid][
                    curr_planLevel_id
                  ] = JSON.parse(JSON.stringify(availableTiers2))

                  console.log(availabelTiers)

                  this.selectedPackagesavailableTiers2 = availabelTiers;

                }
              }
            }
          }




        }
      }
      let current_element: any = dom2.querySelector(
        '#plancheck' + curr_planLevel_id
      );
      current_element.checked = true;
    }, 1000);


  }
  checkdisallowedPlans(
    curr_planLevel_id: number,
    curr_palnlevel_parentid: number,
    curr_packageid: number
  ) {


    console.log(this.configureTierList);
    console.log(this.selectedPackagesavailableTiers2);
    console.log(
      this.selectedPackagesavailableTiers2[curr_packageid][curr_planLevel_id]
    );
    let availabelTiers = this.selectedPackagesavailableTiers2

    sessionStorage.setItem("avilableTiersBlock1", JSON.stringify(this.selectedPackagesavailableTiers2))
    this.checkdisallowedPlansextension(curr_planLevel_id, curr_palnlevel_parentid, curr_packageid)

  }

  unselectPlanLevelTier(
    curr_planLevel_id: number,
    curr_palnlevel_parentid: number,
    curr_tier_id: number,
    packageindex: number,
    groupindex: number,
    subgroupindex: number
  ) {
    console.log(curr_planLevel_id);
    console.log(curr_palnlevel_parentid);
    const dom2: HTMLElement = this.elementRef.nativeElement;

    let pl = this.disallowedplans;
    var all_pl: any = Object.keys(pl);

    console.log(pl);

    for (var i = 0; i < all_pl.length; i++) {
      console.log(all_pl[i]);
      if (
        pl[all_pl[i]].includes(curr_planLevel_id.toString()) ||
        pl[all_pl[i]].includes(curr_palnlevel_parentid.toString())
      ) {
        // console.log(dom2.querySelector("#plancheck"+all_pl[i]))
        let element: any = dom2.querySelector('#plancheck' + all_pl[i]);

        let mappingtiers = this.seelctedplanLevelTierMapping;

        console.log(mappingtiers);

        for (let i = 0; i < mappingtiers.length; i++) {
          if (mappingtiers[i] && mappingtiers[i].subGroupid == all_pl[i]) {
            if (mappingtiers[i].tiersidArray.includes(curr_tier_id)) {
              // if (mappingtiers[i].tierid == curr_tier_id) {
              //remove this plan from seelctedplanLevelTierMapping

              console.log(mappingtiers);
              this.plansBlock1Tiers[mappingtiers[i].packageindex]['groups'][
                mappingtiers[i].groupindex
              ]['subGroups'][mappingtiers[i].subgroupindex].checked = false;
              this.plansBlock1Tiers[mappingtiers[i].packageindex]['groups'][
                mappingtiers[i].groupindex
              ]['subGroups'][mappingtiers[i].subgroupindex].tiers = [];
              this.seelctedplanLevelTierMapping[i] = null; ///here
            }
          }
        }
      }
    }
    sessionStorage.setItem(
      'plansBlock1Tiers',
      JSON.stringify(this.plansBlock1Tiers)
    );
    console.log(this.seelctedplanLevelTierMapping);
    let current_element: any = dom2.querySelector(
      '#plancheck' + curr_planLevel_id
    );
    current_element.checked = true;
  }


  unselectPlanLevelTierBlock2(
    curr_planLevel_id: number,
    curr_palnlevel_parentid: number,
    curr_tier_id: number
  ) {
    console.log(curr_planLevel_id);
    console.log(curr_palnlevel_parentid);
    const dom2: HTMLElement = this.elementRef.nativeElement;

    let pl = this.disallowedplans;
    var all_pl: any = Object.keys(pl);

    console.log(pl);

    for (var i = 0; i < all_pl.length; i++) {
      console.log(all_pl[i]);
      if (
        pl[all_pl[i]].includes(curr_planLevel_id.toString()) ||
        pl[all_pl[i]].includes(curr_palnlevel_parentid.toString())
      ) {
        // console.log(dom2.querySelector("#plancheck"+all_pl[i]))
        let element: any = dom2.querySelector('#plancheck2Upgrade' + all_pl[i]);

        let mappingtiers = this.seelctedplanLevelTierMappingBlock2;

        for (let i = 0; i < mappingtiers.length; i++) {
          if (mappingtiers[i] && mappingtiers[i].subGroupid == all_pl[i]) {
            if (mappingtiers[i].tiersidArray.includes(curr_tier_id)) {
              // if (mappingtiers[i].tierid == curr_tier_id) {
              //remove this plan from seelctedplanLevelTierMapping

              this.plansresblack2Tiers[mappingtiers[i].packageindex]['groups'][
                mappingtiers[i].groupindex
              ]['subGroups'][mappingtiers[i].subgroupindex].checked = false;
              this.plansresblack2Tiers[mappingtiers[i].packageindex]['groups'][
                mappingtiers[i].groupindex
              ]['subGroups'][mappingtiers[i].subgroupindex].tiers = [];
              this.seelctedplanLevelTierMappingBlock2[i] = null;
            }
          }
        }
      }
    }

    sessionStorage.setItem(
      'block2resultTiers',
      JSON.stringify(this.plansresblack2Tiers)
    );
    let current_element: any = dom2.querySelector(
      '#plancheck2Upgrade' + curr_planLevel_id
    );
    current_element.checked = true;
  }
  unselectPlanLevelTierBlock3(
    curr_planLevel_id: number,
    curr_palnlevel_parentid: number,
    curr_tier_id: number
  ) {
    console.log(curr_planLevel_id);
    console.log(curr_palnlevel_parentid);
    const dom2: HTMLElement = this.elementRef.nativeElement;

    let pl = this.disallowedplans;
    var all_pl: any = Object.keys(pl);

    console.log(pl);

    for (var i = 0; i < all_pl.length; i++) {
      console.log(all_pl[i]);
      if (
        pl[all_pl[i]].includes(curr_planLevel_id.toString()) ||
        pl[all_pl[i]].includes(curr_palnlevel_parentid.toString())
      ) {
        // console.log(dom2.querySelector("#plancheck"+all_pl[i]))
        let element: any = dom2.querySelector('#plancheck3Voluntry' + all_pl[i]);

        let mappingtiers = this.seelctedplanLevelTierMappingBlock3;

        for (let i = 0; i < mappingtiers.length; i++) {
          if (mappingtiers[i] && mappingtiers[i].subGroupid == all_pl[i]) {
            if (mappingtiers[i].tiersidArray.includes(curr_tier_id)) {
              // if (mappingtiers[i].tierid == curr_tier_id) {
              //remove this plan from seelctedplanLevelTierMapping

              this.plansresblack3Tiers[mappingtiers[i].packageindex]['groups'][
                mappingtiers[i].groupindex
              ]['subGroups'][mappingtiers[i].subgroupindex].checked = false;
              this.plansresblack3Tiers[mappingtiers[i].packageindex]['groups'][
                mappingtiers[i].groupindex
              ]['subGroups'][mappingtiers[i].subgroupindex].tiers = [];
              this.seelctedplanLevelTierMappingBlock3[i] = null;
            }
          }
        }
      }
    }
    let current_element: any = dom2.querySelector(
      '#plancheck3Voluntry' + curr_planLevel_id
    );
    current_element.checked = true;
  }
  unselectPlanLevelBulk(
    curr_planLevel_id: number,
    curr_palnlevel_parentid: number
  ) {
    console.log(curr_planLevel_id);
    console.log(curr_palnlevel_parentid);
    const dom2: HTMLElement = this.elementRef.nativeElement;

    let pl = this.disallowedplans;
    var all_pl: any = Object.keys(pl);

    console.log(pl);

    for (var i = 0; i < all_pl.length; i++) {
      console.log(all_pl[i]);
      if (
        pl[all_pl[i]].includes(curr_planLevel_id.toString()) ||
        pl[all_pl[i]].includes(curr_palnlevel_parentid.toString())
      ) {
        // console.log(dom2.querySelector("#plancheck"+all_pl[i]))
        let element: any = dom2.querySelector('#plancheck' + all_pl[i]);
        if (element.checked) {
          element.click();

          // this.unselectplan(dom2.querySelector('#plancheck' + all_pl[i]));
          // element.checked = false;
        } else {
          console.log('not checked ignore' + all_pl[i]);
        }

        // dom2.querySelector("planscheck"+all_pl[i])
        // matched_pl.push(all_pl[i])
      }
    }
    let current_element: any = dom2.querySelector(
      '#plancheck' + curr_planLevel_id
    );
    current_element.checked = true;
  }
  unselectPlanLevel(
    curr_planLevel_id: number,
    curr_palnlevel_parentid: number
  ) {
    console.log(curr_planLevel_id);
    console.log(curr_palnlevel_parentid);
    const dom2: HTMLElement = this.elementRef.nativeElement;

    let pl = this.disallowedplans;
    var all_pl: any = Object.keys(pl);

    console.log(pl);

    for (var i = 0; i < all_pl.length; i++) {
      console.log(all_pl[i]);
      if (
        pl[all_pl[i]].includes(curr_planLevel_id.toString()) ||
        pl[all_pl[i]].includes(curr_palnlevel_parentid.toString())
      ) {
        // console.log(dom2.querySelector("#plancheck"+all_pl[i]))
        let element: any = dom2.querySelector('#plancheck' + all_pl[i]);
        if (element.checked) {
          element.click();

          // this.unselectplan(dom2.querySelector('#plancheck' + all_pl[i]));
          // element.checked = false;
        } else {
          console.log('not checked ignore' + all_pl[i]);
        }

        // dom2.querySelector("planscheck"+all_pl[i])
        // matched_pl.push(all_pl[i])
      }
    }
    let current_element: any = dom2.querySelector(
      '#plancheck' + curr_planLevel_id
    );
    current_element.checked = true;
  }

  //Select for drayed plans in block2

  unselectPlanLevel2(
    curr_planLevel_id: number,
    curr_palnlevel_parentid: number
  ) {
    console.log(curr_planLevel_id);
    console.log(curr_palnlevel_parentid);
    const dom2: HTMLElement = this.elementRef.nativeElement;

    let pl = this.disallowedplans;
    var all_pl: any = Object.keys(pl);

    console.log(pl);

    for (var i = 0; i < all_pl.length; i++) {
      console.log(all_pl[i]);
      if (
        pl[all_pl[i]].includes(curr_planLevel_id.toString()) ||
        pl[all_pl[i]].includes(curr_palnlevel_parentid.toString())
      ) {
        // console.log(dom2.querySelector("#plancheck"+all_pl[i]))
        let element: any = dom2.querySelector('#plancheck2Upgrade' + all_pl[i]);

        console.log(element);
        if (element && element.checked) {
          element.click();

          // this.unselectplan(dom2.querySelector('#plancheck' + all_pl[i]));
          // element.checked = false;
        } else {
          console.log('not checked ignore' + all_pl[i]);
        }

        // dom2.querySelector("planscheck"+all_pl[i])
        // matched_pl.push(all_pl[i])
      }
    }
    let current_element: any = dom2.querySelector(
      '#plancheck2Upgrade' + curr_planLevel_id
    );
    current_element.checked = true;
  }
  //Select for drayed plans in block3
  unselectPlanLevel3(
    curr_planLevel_id: number,
    curr_palnlevel_parentid: number
  ) {
    console.log(curr_planLevel_id);
    console.log(curr_palnlevel_parentid);
    const dom2: HTMLElement = this.elementRef.nativeElement;

    let pl = this.disallowedplans;
    var all_pl: any = Object.keys(pl);

    console.log(pl);

    for (var i = 0; i < all_pl.length; i++) {
      console.log(all_pl[i]);
      if (
        pl[all_pl[i]].includes(curr_planLevel_id.toString()) ||
        pl[all_pl[i]].includes(curr_palnlevel_parentid.toString())
      ) {
        // console.log(dom2.querySelector("#plancheck"+all_pl[i]))
        let element: any = dom2.querySelector('#plancheck3Voluntry' + all_pl[i]);
        if (element && element.checked) {
          element.click();

          // this.unselectplan(dom2.querySelector('#plancheck' + all_pl[i]));
          // element.checked = false;
        } else {
          console.log('not checked ignore' + all_pl[i]);
        }

        // dom2.querySelector("planscheck"+all_pl[i])
        // matched_pl.push(all_pl[i])
      }
    }
    let current_element: any = dom2.querySelector(
      '#plancheck3Voluntry' + curr_planLevel_id
    );
    current_element.checked = true;
  }

  public selectplanBulk(
    elementcv: any,
    packname: any,
    grpname: any,
    subgrpname: any,
    packageindex: number,
    groupindex: number,
    subgroupindex: number,
    disallowedPlanLevels: any
  ) {


    this.tierconfig = [
      { id: 1, name: 'Employeee' },
      { id: 2, name: 'Employeee' },
    ];

    // console.log(elementcv)

    console.log(packname);

    console.log(grpname);

    console.log(subgrpname);
    let plandetails = elementcv.attributes.data.value;

    let plandetailsobj = plandetails.split('##');

    let obj = {
      packageid: plandetailsobj[2],
      parentId: plandetailsobj[3],
      subGroupId: plandetailsobj[4],
      orderId: plandetailsobj[8],
      packagename: packname,
      groupname: grpname,
      subGrpname: subgrpname,
      tiers: [],
      packageindex: packageindex,
      groupindex: groupindex,
      subgroupindex: subgroupindex,
      coverage: '',
      disallowedPlanLevels: disallowedPlanLevels
    };

    console.log(obj);

    this.addtosummaryBlock1Bulk(obj);
  }
  public addtosummaryBlock1Bulk(obj: any) {
    let summaryBlockBulk = JSON.parse(
      sessionStorage.getItem('summaryBlockBulk') || '[]'
    );
    let summaryBlock1 = JSON.parse(
      sessionStorage.getItem('summaryBlock1') || '[]'
    );

    let selectedBlock1 = JSON.parse(
      sessionStorage.getItem('summaryBlockBulk') || '[]'
    );


    this.addtoslectplans(obj.subGroupId, summaryBlockBulk.length);
    summaryBlockBulk.push(obj);


    this.planssummarymain = [];
    this.planssummaryopt = [];

    summaryBlockBulk.forEach((element: any) => {
      if (element.packagename != 'Opt-in') {
        this.planssummarymain.push(element);
      } else {
        this.planssummaryopt.push(element);
      }

      if (!this.packagePlanLevelTiers[element.packagename]) {
        this.packagePlanLevelTiers[element.packagename] = [];
      }
      const exists =
        this.packagePlanLevelTiers[element.packagename].findIndex(
          (item) => item.subGroupId === element.subGroupId
        ) > -1;
      if (exists) {
        console.log('check');
      } else {
        this.packagePlanLevelTiers[element.packagename].push(element);
      }
    });
    sessionStorage.setItem(
      'packagePlanLevelTiers',
      JSON.stringify(this.packagePlanLevelTiers)
    );

    if (selectedBlock1[obj.packageid]) {
      if (selectedBlock1[obj.packageid][obj.parentId]) {
        console.log(selectedBlock1[obj.packageid][obj.parentId]);
      } else {
        // console.log('firstelse');
        selectedBlock1[obj.packageid][obj.parentId] = [];
      }
    } else {
      // console.log('secondelse');
      selectedBlock1[obj.packageid] = {};
      selectedBlock1[obj.packageid][obj.parentId] = [];
    }

    //now push
    var selectedPlanLevel = { id: obj.subGroupId, order: obj.orderId };
    selectedBlock1[obj.packageid][obj.parentId].push(selectedPlanLevel);

    let subGroupIdindex;
    console.log(summaryBlock1);
    // if (summaryBlock1 && summaryBlock1.length > 0) {
    //   console.log('1');
    //   for (let i = 0; i < summaryBlock1.length; i++) {
    //     if (summaryBlock1[i].subGroupId == obj.subGroupId) {
    //       console.log('3');
    //       subGroupIdindex = i;
    //       console.log(subGroupIdindex);
    //       // if (summaryBlock1[i].disallowedPlanLevels != null) {
    //       //   let disallowed_plans = summaryBlock1[i].disallowedPlanLevels.split(',');
    //       //   const dom1: HTMLElement = this.elementRef.nativeElement;
    //       //   console.log(disallowed_plans)
    //       //   for (let i = 0; i < disallowed_plans.length; i++) {

    //       //     setTimeout(() => {
    //       //       let elem: any = dom1.querySelector(`#plancheck${disallowed_plans[i]}`)

    //       //       if(elem!=null){
    //       //       if (elem.disabled) {

    //       //         elem.disabled = false
    //       //       }
    //       //     }
    //       //     }, 100);

    //       //   }
    //       // }
    //       break;
    //     }
    //   }
    //   console.log(subGroupIdindex);
    //   if (subGroupIdindex > -1) {
    //     console.log(subGroupIdindex);
    //     $("#plancheck" + obj.subGroupId).prop("checked", false);

    //     summaryBlock1.splice(subGroupIdindex, 1);

    //   } else {
    //     console.log('check1');
    //   }
    // }
    console.log(summaryBlock1)
    console.log(JSON.stringify(summaryBlock1))

    setTimeout(() => {

      sessionStorage.setItem('summaryBlock1', JSON.stringify(summaryBlock1));

    }, 10);







    sessionStorage.setItem(
      'summaryBlock1main',
      JSON.stringify(this.planssummarymain)
    );
    sessionStorage.setItem(
      'summaryBlock1opt',
      JSON.stringify(this.planssummaryopt)
    );

    sessionStorage.setItem('summaryBlockBulk', JSON.stringify(summaryBlockBulk));
    // sessionStorage.setItem('summaryBlock2', '[]');

    // this.plansNewBlock1 = JSON.parse(
    //   sessionStorage.getItem('planResults') || '[]'
    // );

    // var res = JSON.parse(sessionStorage.getItem('planResults') || '[]');

    this.selectedplansblock1 = JSON.parse(
      sessionStorage.getItem('summaryBlockBulk') || '[]'
    );


    // this.plansNewBlock1.map((packagelevel: any, index: any) => {
    //   packagelevel.groups.map((groups: any, index1: any) => {
    //     this.selectedplansblock1.map((selectplan: any) => {
    //       if (
    //         packagelevel.id == selectplan.packageid &&
    //         packagelevel.groups.id == selectplan.parentid
    //       ) {
    //         var allAvailble =
    //           this.plansNewBlock1[index]['groups'][index1]['subGroups'];

    //         allAvailble.map((element1: any, index2: any) => {
    //           if (element1 != null) {
    //             if (element1.disallowedPlanLevels) {
    //               if (element1.id == selectplan.subGroupId) {
    //                 res.map((res1: any, index4: any) => {
    //                   res1.groups.map((groups1: any, index5: any) => {
    //                     // console.log(groups1)
    //                     groups1.subGroups.forEach(
    //                       (subgrp: any, index6: any) => {
    //                         console.log(element1.disallowedPlanLevels);
    //                         if (
    //                           element1.disallowedPlanLevels.indexOf(
    //                             groups1.id
    //                           ) > -1
    //                         ) {
    //                           this.plansBlock1[index4]['groups'][index5][
    //                             'subGroups'
    //                           ][index6]['tiers'] = [];
    //                           // this.plansBlock1[index4]['groups'][index5][
    //                           //   'subGroups'
    //                           // ][index6]['checked'] = false;

    //                           res[index4]['groups'][index5]['subGroups'][
    //                             index6
    //                           ] = null;
    //                         }
    //                       }
    //                     );
    //                   });
    //                 });
    //               }
    //             }
    //           }
    //         });
    //       }
    //     });
    //   });
    // });

    //  this.plansNewBlock1[obj.packageindex]['groups'][obj.groupindex]['subGroups'][obj.subgroupindex]['tiers'] = []
    // this.plansNewBlock1[obj.packageindex]['groups'][obj.groupindex]['subGroups'][obj.subgroupindex]['checked'] = false

    // sessionStorage.setItem('planResults', JSON.stringify(this.plansNewBlock1));

    //     this.plansBlock1 = JSON.parse(
    //       sessionStorage.getItem('mainresults') || '[]')
    //       this.plansBlock1.forEach((packagelevel: any, index: any) => {
    //         if (!packagelevel) {
    //         } else {
    //        packagelevel.groups.forEach((groups: any, index1: any) => {
    //         groups?.subGroups.forEach((subGroups: any, index2: any) => {
    //         if(subGroups){
    //           this.selectedplansblock1.forEach((selectplan: any) => {
    //           if (
    //             subGroups.id ==selectplan.subGroupId
    //           ) {
    //             this.plansBlock1[index]['groups'][index1]['subGroups'].splice(index2,1)

    //             if (selectplan.disallowedPlanLevels != null) {
    //               let disallowed_plans = selectplan.disallowedPlanLevels.split(',');

    //               console.log(disallowed_plans)

    //               disallowed_plans.forEach((disallowed: any,index9) => {


    //                 this.plansBlock1[index]['groups'][index1]['subGroups'].forEach((plan: any,index10) => {

    // if(this.plansBlock1[index]['groups'][index1]['subGroups'][index10] !=null){
    //                   if(this.plansBlock1[index]['groups'][index1]['subGroups'][index10].id==disallowed){
    //                     this.plansBlock1[index]['groups'][index1]['subGroups'].splice(index10,1)
    //                   }
    //                 }
    //                 })



    //               })


    //             }


    //           }
    //         })

    //       }

    //       });

    //     });
    //   }

    //     })
    sessionStorage.setItem('planResults', JSON.stringify(this.plansBlock1));

    // sessionStorage.setItem('mainresults', JSON.stringify(res));

    this.checkvalidationblock2()
    this.checkvalidationblock3()

    // for (let i = 0; i < this.selectedplansblock1.length; i++) {

    //   if (this.selectedplansblock1[i].disallowedPlanLevels != null) {
    //     // setTimeout(() => {
    //     //   let elem: any = dom1.querySelector(`#plancheck${this.selectedplansblock1[i].subGroupId}`)

    //     //   if(elem!=null){
    //     //   if (!elem.disabled) {

    //     //     elem.disabled = true
    //     //   }
    //     // }
    //     // }, 100);
    //     // let disallowed_plans = this.selectedplansblock1[i].disallowedPlanLevels.split(',');
    //     // const dom1: HTMLElement = this.elementRef.nativeElement;
    //     // for (let i = 0; i < disallowed_plans.length; i++) {
    //     //   setTimeout(() => {
    //     //     let elem: any = dom1.querySelector(`#plancheck${disallowed_plans[i]}`)

    //     //     if(elem!=null){
    //     //     if (!elem.disabled) {

    //     //       elem.disabled = true
    //     //     }
    //     //   }
    //     //   }, 100);

    //     // }
    //   }
    //   else{
    //     setTimeout(() => {
    //       const dom1: HTMLElement = this.elementRef.nativeElement;

    //       let elem: any = dom1.querySelector(`#plancheck${this.selectedplansblock1[i].subGroupId}`)

    //       if(elem!=null){
    //       if (!elem.disabled) {

    //         elem.disabled = true
    //       }
    //     }
    //     }, 100);
    //   }

    // }

  }
  public selectplan(
    elementcv: any,
    packname: any,
    grpname: any,
    subgrpname: any,
    packageindex: number,
    groupindex: number,
    subgroupindex: number,
    subgroup: any,
    disallowedPlanLevels: any
  ) {


    this.tierconfig = [
      { id: 1, name: 'Employeee' },
      { id: 2, name: 'Employeee' },
    ];

    // console.log(elementcv)

    console.log(packname);

    console.log(grpname);

    console.log(subgrpname);
    let plandetails = elementcv.attributes.data.value;

    let plandetailsobj = plandetails.split('##');

    let obj = {
      packageid: plandetailsobj[2],
      parentId: plandetailsobj[3],
      subGroupId: plandetailsobj[4],
      orderId: plandetailsobj[8],
      packagename: packname,
      groupname: grpname,
      subGrpname: subgrpname,
      tiers: [],
      packageindex: packageindex,
      groupindex: groupindex,
      subgroupindex: subgroupindex,
      coverage: '',
      settingsAdditional: subgroup?.settingsAdditional || {},
      disallowedPlanLevels: disallowedPlanLevels

    };

    console.log(obj);

    this.addtosummaryBlock1(obj);
  }

  // public addtosummaryBlock1(obj: any) {
  //   let summaryBlock1 = JSON.parse(
  //     sessionStorage.getItem('summaryBlock1') || '[]'
  //   );
  //   let summaryBlock2 = JSON.parse(
  //     sessionStorage.getItem('summaryBlock2') || '[]'
  //   );

  //   let selectedBlock1 = JSON.parse(
  //     sessionStorage.getItem('selectedBlock1') || '[]'
  //   );

  //   this.addtoslectplans(obj.subGroupId, summaryBlock1.length);
  //   summaryBlock1.push(obj);


  //   this.planssummarymain = [];
  //   this.planssummaryopt = [];

  //   summaryBlock1.forEach((element: any) => {
  //     if (element.packagename != 'Opt-in') {
  //       this.planssummarymain.push(element);
  //     } else {
  //       this.planssummaryopt.push(element);
  //     }

  //     if (!this.packagePlanLevelTiers[element.packagename]) {
  //       this.packagePlanLevelTiers[element.packagename] = [];
  //     }
  //     const exists =
  //       this.packagePlanLevelTiers[element.packagename].findIndex(
  //         (item) => item.subGroupId === element.subGroupId
  //       ) > -1;
  //     if (exists) {
  //       console.log('check');
  //     } else {
  //       this.packagePlanLevelTiers[element.packagename].push(element);
  //     }
  //   });
  //   sessionStorage.setItem(
  //     'packagePlanLevelTiers',
  //     JSON.stringify(this.packagePlanLevelTiers)
  //   );

  //   if (selectedBlock1[obj.packageid]) {
  //     if (selectedBlock1[obj.packageid][obj.parentId]) {
  //       console.log(selectedBlock1[obj.packageid][obj.parentId]);
  //     } else {
  //       // console.log('firstelse');
  //       selectedBlock1[obj.packageid][obj.parentId] = [];
  //     }
  //   } else {
  //     // console.log('secondelse');
  //     selectedBlock1[obj.packageid] = {};
  //     selectedBlock1[obj.packageid][obj.parentId] = [];
  //   }

  //   //now push
  //   var selectedPlanLevel = { id: obj.subGroupId, order: obj.orderId };
  //   selectedBlock1[obj.packageid][obj.parentId].push(selectedPlanLevel);

  //   let subGroupIdindex;
  //   console.log(summaryBlock2);
  //   if (summaryBlock2 && summaryBlock2.length > 0) {
  //     console.log('1');
  //     for (let i = 0; i < summaryBlock2.length; i++) {
  //       if (summaryBlock2[i].subGroupId == obj.subGroupId) {
  //         console.log('3');
  //         subGroupIdindex = i;
  //         console.log(subGroupIdindex);
  //         break;
  //       }
  //     }
  //     console.log(subGroupIdindex);
  //     if (subGroupIdindex > -1) {
  //       console.log(subGroupIdindex);
  //       summaryBlock2.splice(subGroupIdindex, 1);
  //     } else {
  //       console.log('check1');
  //     }
  //   }
  //   console.log(summaryBlock2)
  //   console.log(JSON.stringify(summaryBlock2))

  //   setTimeout(() => {

  //     sessionStorage.setItem('summaryBlock2', JSON.stringify(summaryBlock2));

  //   }, 10);

  //   let selectedplansblock2;
  //   let selectedplansblock3;
  //   setTimeout(() => {

  //     selectedplansblock2 = JSON.parse(
  //       sessionStorage.getItem('summaryBlock2') || '[]'
  //     );
  //   }, 20);

  //   setTimeout(() => {

  //     selectedplansblock3 = JSON.parse(
  //       sessionStorage.getItem('summaryBlock3') || '[]'
  //     );

  //   }, 30);







  //   sessionStorage.setItem(
  //     'summaryBlock1main',
  //     JSON.stringify(this.planssummarymain)
  //   );
  //   sessionStorage.setItem(
  //     'summaryBlock1opt',
  //     JSON.stringify(this.planssummaryopt)
  //   );

  //   sessionStorage.setItem('summaryBlock1', JSON.stringify(summaryBlock1));
  //   // sessionStorage.setItem('summaryBlock2', '[]');

  //   this.plansNewBlock1 = JSON.parse(
  //     sessionStorage.getItem('planResults') || '[]'
  //   );

  //   var res = JSON.parse(sessionStorage.getItem('planResults') || '[]');

  //   this.selectedplansblock1 = JSON.parse(
  //     sessionStorage.getItem('summaryBlock1') || '[]'
  //   );

  //   this.plansBlock1[obj.packageindex]['groups'][obj.groupindex]['subGroups'][
  //     obj.subgroupindex
  //   ]['checked'] = true;

  //   if (
  //     this.plansBlock1[obj.packageindex]['groups'][obj.groupindex]['subGroups'][
  //     obj.subgroupindex
  //     ]['name'] == 'Executive Health'
  //   ) {
  //     this.plansBlock1[obj.packageindex]['groups'][obj.groupindex]['subGroups'][
  //       obj.subgroupindex
  //     ]['coverage'] = 'Exec';
  //     this.block1coverage = false;
  //     console.log(obj.subGroupId);
  //     // $("#executiveplans" + obj.subGroupId).prop("checked", false);
  //     $('#executiveplanssingle' + obj.subGroupId).prop('disabled', false);
  //     $('#executiveplanscouple' + obj.subGroupId).prop('disabled', false);
  //     $('#executiveplansfamily' + obj.subGroupId).prop('disabled', false);
  //     $('#executiveplanssingle' + obj.subGroupId).click();
  //   }
  //   if (
  //     this.plansBlock1[obj.packageindex]['groups'][obj.groupindex]['subGroups'][
  //     obj.subgroupindex
  //     ]['name'] == 'Complete Executive Care'
  //   ) {
  //     this.plansBlock1[obj.packageindex]['groups'][obj.groupindex]['subGroups'][
  //       obj.subgroupindex
  //     ]['coverage'] = 'Exec';
  //     this.block1coverage = false;
  //     // $("#executiveplans" + obj.subGroupId).prop("checked", false);
  //     $('#executiveplanssingle' + obj.subGroupId).prop('disabled', false);
  //     $('#executiveplanscouple' + obj.subGroupId).prop('disabled', false);
  //     $('#executiveplansfamily' + obj.subGroupId).prop('disabled', false);
  //     $('#executiveplanssingle' + obj.subGroupId).click();
  //   }
  //   if (
  //     this.plansBlock1[obj.packageindex]['groups'][obj.groupindex]['subGroups'][
  //     obj.subgroupindex
  //     ]['name'] == 'Provincial Health Replacement Plan'
  //   ) {
  //     this.plansBlock1[obj.packageindex]['groups'][obj.groupindex]['subGroups'][
  //       obj.subgroupindex
  //     ]['coverage'] = 'Exec';
  //     this.block1coverage = false;
  //     // $("#executiveplans" + obj.subGroupId).prop("checked", false);
  //     $('#executiveplanssingle' + obj.subGroupId).prop('disabled', false);
  //     $('#executiveplanscouple' + obj.subGroupId).prop('disabled', false);
  //     $('#executiveplansfamily' + obj.subGroupId).prop('disabled', false);
  //     $('#executiveplanssingle' + obj.subGroupId).click();
  //   }
  //   this.plansNewBlock1.map((packagelevel: any, index: any) => {
  //     packagelevel.groups.map((groups: any, index1: any) => {
  //       this.selectedplansblock1.map((selectplan: any) => {
  //         if (
  //           packagelevel.id == selectplan.packageid &&
  //           packagelevel.groups.id == selectplan.parentid
  //         ) {
  //           var allAvailble =
  //             this.plansNewBlock1[index]['groups'][index1]['subGroups'];

  //           allAvailble.map((element1: any, index2: any) => {
  //             if (element1 != null) {
  //               if (element1.disallowedPlanLevels) {
  //                 if (element1.id == selectplan.subGroupId) {
  //                   res.map((res1: any, index4: any) => {
  //                     res1.groups.map((groups1: any, index5: any) => {
  //                       // console.log(groups1)
  //                       groups1.subGroups.forEach(
  //                         (subgrp: any, index6: any) => {
  //                           console.log(element1.disallowedPlanLevels);
  //                           if (
  //                             element1.disallowedPlanLevels.indexOf(
  //                               groups1.id
  //                             ) > -1
  //                           ) {
  //                             this.plansBlock1[index4]['groups'][index5][
  //                               'subGroups'
  //                             ][index6]['tiers'] = [];
  //                             // this.plansBlock1[index4]['groups'][index5][
  //                             //   'subGroups'
  //                             // ][index6]['checked'] = false;

  //                             // res[index4]['groups'][index5]['subGroups'][
  //                             //   index6
  //                             // ] = null;
  //                           }
  //                         }
  //                       );
  //                     });
  //                   });
  //                 }
  //               }
  //             }
  //           });
  //         }
  //       });
  //     });
  //   });

  //   //  this.plansNewBlock1[obj.packageindex]['groups'][obj.groupindex]['subGroups'][obj.subgroupindex]['tiers'] = []
  //   // this.plansNewBlock1[obj.packageindex]['groups'][obj.groupindex]['subGroups'][obj.subgroupindex]['checked'] = false

  //   // sessionStorage.setItem('planResults', JSON.stringify(this.plansNewBlock1));


  //   sessionStorage.setItem('planResults', JSON.stringify(this.plansBlock1));

  //   sessionStorage.setItem('mainresults', JSON.stringify(res));

  //   this.checkvalidationblock2()
  //   this.checkvalidationblock3()
  //   //  this.plansBlock1 = res
  // }

  // public addtosummaryBlock1(obj: any) {
  //   let summaryBlock1 = JSON.parse(
  //     sessionStorage.getItem('summaryBlock1') || '[]'
  //   );
  //   let summaryBlock2 = JSON.parse(
  //     sessionStorage.getItem('summaryBlock2') || '[]'
  //   );

  //   let selectedBlock1 = JSON.parse(
  //     sessionStorage.getItem('selectedBlock1') || '[]'
  //   );

  //   this.addtoslectplans(obj.subGroupId, summaryBlock1.length);
  //   summaryBlock1.push(obj);

  //   console.log(summaryBlock1)
  //   this.planssummarymain = [];
  //   this.planssummaryopt = [];

  //   summaryBlock1.forEach((element: any) => {
  //     if (element.packagename != 'Opt-in') {
  //       this.planssummarymain.push(element);
  //     } else {
  //       this.planssummaryopt.push(element);
  //     }

  //     if (!this.packagePlanLevelTiers[element.packagename]) {
  //       this.packagePlanLevelTiers[element.packagename] = [];
  //     }
  //     const exists =
  //       this.packagePlanLevelTiers[element.packagename].findIndex(
  //         (item) => item.subGroupId === element.subGroupId
  //       ) > -1;
  //     if (exists) {
  //       console.log('check');
  //     } else {
  //       this.packagePlanLevelTiers[element.packagename].push(element);
  //     }
  //   });
  //   sessionStorage.setItem(
  //     'packagePlanLevelTiers',
  //     JSON.stringify(this.packagePlanLevelTiers)
  //   );

  //   if (selectedBlock1[obj.packageid]) {
  //     if (selectedBlock1[obj.packageid][obj.parentId]) {
  //       console.log(selectedBlock1[obj.packageid][obj.parentId]);
  //     } else {
  //       // console.log('firstelse');
  //       selectedBlock1[obj.packageid][obj.parentId] = [];
  //     }
  //   } else {
  //     // console.log('secondelse');
  //     selectedBlock1[obj.packageid] = {};
  //     selectedBlock1[obj.packageid][obj.parentId] = [];
  //   }

  //   //now push
  //   var selectedPlanLevel = { id: obj.subGroupId, order: obj.orderId };
  //   selectedBlock1[obj.packageid][obj.parentId].push(selectedPlanLevel);

  //   let subGroupIdindex;
  //   console.log(summaryBlock2);
  //   if (summaryBlock2 && summaryBlock2.length > 0) {
  //     console.log('1');
  //     for (let i = 0; i < summaryBlock2.length; i++) {
  //       if (summaryBlock2[i].subGroupId == obj.subGroupId) {
  //         console.log('3');
  //         subGroupIdindex = i;
  //         console.log(subGroupIdindex);
  //         break;
  //       }
  //     }
  //     console.log(subGroupIdindex);
  //     if (subGroupIdindex > -1) {
  //       console.log(subGroupIdindex);
  //       summaryBlock2.splice(subGroupIdindex, 1);
  //     } else {
  //       console.log('check1');
  //     }
  //   }
  //   console.log(summaryBlock2)
  //   console.log(JSON.stringify(summaryBlock2))

  //   setTimeout(() => {

  //     sessionStorage.setItem('summaryBlock2', JSON.stringify(summaryBlock2));

  //   }, 10);

  //   let selectedplansblock2;
  //   let selectedplansblock3;





  //   sessionStorage.setItem(
  //     'summaryBlock1main',
  //     JSON.stringify(this.planssummarymain)
  //   );
  //   sessionStorage.setItem(
  //     'summaryBlock1opt',
  //     JSON.stringify(this.planssummaryopt)
  //   );
  //   sessionStorage.setItem('summaryBlock1', JSON.stringify(summaryBlock1));


  //   // setTimeout(() => {

  //   //   sessionStorage.setItem('summaryBlock1', JSON.stringify(summaryBlock1));

  //   // }, 3000);

  //   // sessionStorage.setItem('summaryBlock2', '[]');

  //   this.plansNewBlock1 = JSON.parse(
  //     sessionStorage.getItem('planResults') || '[]'
  //   );

  //   var res = JSON.parse(sessionStorage.getItem('planResults') || '[]');

  //   this.selectedplansblock1 = JSON.parse(
  //     sessionStorage.getItem('summaryBlock1') || '[]'
  //   );

  //   this.plansBlock1[obj.packageindex]['groups'][obj.groupindex]['subGroups'][
  //     obj.subgroupindex
  //   ]['checked'] = true;

  //   if (
  //     this.plansBlock1[obj.packageindex]['groups'][obj.groupindex]['subGroups'][
  //     obj.subgroupindex
  //     ]['name'] == 'Executive Health'
  //   ) {
  //     this.plansBlock1[obj.packageindex]['groups'][obj.groupindex]['subGroups'][
  //       obj.subgroupindex
  //     ]['coverage'] = '';
  //     this.block1coverage = false;
  //     console.log(obj.subGroupId);
  //     // $("#executiveplans" + obj.subGroupId).prop("checked", false);
  //     $('#executiveplanssingle' + obj.subGroupId).prop('disabled', false);
  //     $('#executiveplanscouple' + obj.subGroupId).prop('disabled', false);
  //     $('#executiveplansfamily' + obj.subGroupId).prop('disabled', false);

  //     let plans = this.paidByCompany.filter(
  //       (plan) => plan.planLevelId == obj.subGroupId
  //     );

  //     if (plans.length > 0) {


  //       let plancheck1Coverage = this.getExecutiveCoveragesFromCode(plans[0].coverage)

  //       console.log({ plancheck1Coverage })

  //       if (
  //         plancheck1Coverage
  //       ) {

  //         if (plancheck1Coverage.single) {

  //           // setTimeout(() => {
  //           $("#executiveplanssingle" + obj.subGroupId).click()

  //           // }, 1000);

  //         } if (plancheck1Coverage.couple) {

  //           $("#executiveplanscouple" + obj.subGroupId).click()

  //         } if (plancheck1Coverage.family) {
  //           $("#executiveplansfamily" + obj.subGroupId).click()

  //         }
  //       }

  //     }
  //     else {
  //       $('#executiveplanssingle' + obj.subGroupId).click();
  //     }

  //   }
  //   if (
  //     this.plansBlock1[obj.packageindex]['groups'][obj.groupindex]['subGroups'][
  //     obj.subgroupindex
  //     ]['name'] == 'Complete Executive Care'
  //   ) {
  //     this.plansBlock1[obj.packageindex]['groups'][obj.groupindex]['subGroups'][
  //       obj.subgroupindex
  //     ]['coverage'] = '';
  //     this.block1coverage = false;
  //     // $("#executiveplans" + obj.subGroupId).prop("checked", false);
  //     $('#executiveplanssingle' + obj.subGroupId).prop('disabled', false);
  //     $('#executiveplanscouple' + obj.subGroupId).prop('disabled', false);
  //     $('#executiveplansfamily' + obj.subGroupId).prop('disabled', false);
  //     // $('#executiveplanssingle' + obj.subGroupId).click();
  //     let plans = this.paidByCompany.filter(
  //       (plan) => plan.planLevelId == obj.subGroupId
  //     );


  //     console.log(plans)
  //     if (plans.length > 0) {
  //       let plancheck1Coverage = this.getExecutiveCoveragesFromCode(plans[0].coverage)

  //       console.log({ plancheck1Coverage })

  //       if (
  //         plancheck1Coverage
  //       ) {

  //         if (plancheck1Coverage.single) {

  //           // setTimeout(() => {
  //           $("#executiveplanssingle" + obj.subGroupId).click()

  //           // }, 1000);

  //         } if (plancheck1Coverage.couple) {

  //           $("#executiveplanscouple" + obj.subGroupId).click()

  //         } if (plancheck1Coverage.family) {
  //           $("#executiveplansfamily" + obj.subGroupId).click()

  //         }
  //       }

  //     }
  //     else {
  //       $('#executiveplanssingle' + obj.subGroupId).click();
  //     }
  //   }

  //   if (
  //     this.plansBlock1[obj.packageindex]['groups'][obj.groupindex]['subGroups'][
  //     obj.subgroupindex
  //     ]['name'] == 'Provincial Health Replacement Plan'
  //   ) {
  //     this.plansBlock1[obj.packageindex]['groups'][obj.groupindex]['subGroups'][
  //       obj.subgroupindex
  //     ]['coverage'] = 'PHR' //PHR;
  //     this.block1coverage = false;
  //     // $("#executiveplans" + obj.subGroupId).prop("checked", false);
  //     $('#executiveplanssingle' + obj.subGroupId).prop('disabled', false);
  //     $('#executiveplanscouple' + obj.subGroupId).prop('disabled', false);
  //     $('#executiveplansfamily' + obj.subGroupId).prop('disabled', false);
  //     // $('#executiveplanssingle' + obj.subGroupId).click();



  //     let plans = this.paidByCompany.filter(
  //       (plan) => plan.planLevelId == obj.subGroupId
  //     );

  //     if (plans.length > 0) {

  //       let plancheck1Coverage = this.getExecutiveCoveragesFromCode(plans[0].coverage)

  //       console.log({ plancheck1Coverage })

  //       if (
  //         plancheck1Coverage
  //       ) {

  //         if (plancheck1Coverage.single) {

  //           // setTimeout(() => {
  //           $("#executiveplanssingle" + obj.subGroupId).click()

  //           // }, 1000);

  //         } if (plancheck1Coverage.couple) {

  //           $("#executiveplanscouple" + obj.subGroupId).click()

  //         } if (plancheck1Coverage.family) {
  //           $("#executiveplansfamily" + obj.subGroupId).click()

  //         }
  //       }

  //     }
  //     else {
  //       $('#executiveplanssingle' + obj.subGroupId).click();
  //     }
  //   }

  //   this.plansNewBlock1.map((packagelevel: any, index: any) => {
  //     packagelevel.groups.map((groups: any, index1: any) => {
  //       this.selectedplansblock1.map((selectplan: any) => {
  //         if (
  //           packagelevel.id == selectplan.packageid &&
  //           packagelevel.groups.id == selectplan.parentid
  //         ) {
  //           var allAvailble =
  //             this.plansNewBlock1[index]['groups'][index1]['subGroups'];

  //             console.log(allAvailble)

  //           allAvailble.map((element1: any, index2: any) => {
  //             if (element1 != null) {


  //                   if(selectplan.disallowedPlanLevels){
  //                     let disallowed_plans = selectplan.disallowedPlanLevels.split(',');

  //                     console.log(disallowed_plans)

  //                     disallowed_plans.forEach((disallowed: any,index9) => {
  //                     console.log(this.plansNewBlock1[index]['groups'][index1]['subGroups'])

  //                       this.plansNewBlock1[index]['groups'][index1]['subGroups'].forEach((plan: any,index10) => {
  //                         if(this.plansNewBlock1[index]['groups'][index1]['subGroups'][index10]!=null){
  //                             console.log(this.plansNewBlock1[index]['groups'][index1]['subGroups'][index10].id)
  //                           console.log(disallowed)
  //                         if(this.plansNewBlock1[index]['groups'][index1]['subGroups'][index10].id==disallowed){
  //                           this.plansNewBlock1[index]['groups'][index1]['subGroups'][index10]=null
  //                         }
  //                       }
  //                       })



  //                     })
  //                     console.log(this.plansNewBlock1)

  //                   }
  //                   // res.map((res1: any, index4: any) => {
  //                   //   res1.groups.map((groups1: any, index5: any) => {
  //                   //     // console.log(groups1)
  //                   //     groups1.subGroups.forEach(
  //                   //       (subgrp: any, index6: any) => {
  //                   //         console.log(element1.disallowedPlanLevels);
  //                   //         if (
  //                   //           element1.disallowedPlanLevels.indexOf(
  //                   //             groups1.id
  //                   //           ) > -1
  //                   //         ) {
  //                   //           this.plansBlock1[index4]['groups'][index5][
  //                   //             'subGroups'
  //                   //           ][index6]['tiers'] = [];
  //                   //           // this.plansBlock1[index4]['groups'][index5][
  //                   //           //   'subGroups'
  //                   //           // ][index6]['checked'] = false;

  //                   //           res[index4]['groups'][index5]['subGroups'][
  //                   //             index6
  //                   //           ] = null;
  //                   //         }
  //                   //       }
  //                   //     );
  //                   //   });
  //                   // });
  //               //   }
  //               // }
  //             }
  //           });
  //         }
  //       });
  //     });
  //   });
  //   console.log(this.plansNewBlock1)
  //   //  this.plansNewBlock1[obj.packageindex]['groups'][obj.groupindex]['subGroups'][obj.subgroupindex]['tiers'] = []
  //   // this.plansNewBlock1[obj.packageindex]['groups'][obj.groupindex]['subGroups'][obj.subgroupindex]['checked'] = false

  //   // sessionStorage.setItem('planResults', JSON.stringify(this.plansNewBlock1));


  //   sessionStorage.setItem('planResults', JSON.stringify(this.plansBlock1));

  //   sessionStorage.setItem('mainresults', JSON.stringify(this.plansNewBlock1));

  //   this.checkvalidationblock2()
  //   this.checkvalidationblock3()

  // }
  public addtosummaryBlock1(obj: any) {
    let summaryBlock1 = JSON.parse(
      sessionStorage.getItem('summaryBlock1') || '[]'
    );
    let summaryBlock2 = JSON.parse(
      sessionStorage.getItem('summaryBlock2') || '[]'
    );

    let selectedBlock1 = JSON.parse(
      sessionStorage.getItem('selectedBlock1') || '[]'
    );

    this.addtoslectplans(obj.subGroupId, summaryBlock1.length);
    summaryBlock1.push(obj);

    // console.log(summaryBlock1)
    this.planssummarymain = [];
    this.planssummaryopt = [];

    summaryBlock1.forEach((element: any) => {
      if (element.packagename != 'Opt-in') {
        this.planssummarymain.push(element);
      } else {
        this.planssummaryopt.push(element);
      }

      if (!this.packagePlanLevelTiers[element.packagename]) {
        this.packagePlanLevelTiers[element.packagename] = [];
      }
      const exists =
        this.packagePlanLevelTiers[element.packagename].findIndex(
          (item) => item.subGroupId === element.subGroupId
        ) > -1;
      if (exists) {
        console.log('check');
      } else {
        this.packagePlanLevelTiers[element.packagename].push(element);
      }
    });
    sessionStorage.setItem(
      'packagePlanLevelTiers',
      JSON.stringify(this.packagePlanLevelTiers)
    );

    if (selectedBlock1[obj.packageid]) {
      if (selectedBlock1[obj.packageid][obj.parentId]) {
        console.log(selectedBlock1[obj.packageid][obj.parentId]);
      } else {
        // console.log('firstelse');
        selectedBlock1[obj.packageid][obj.parentId] = [];
      }
    } else {
      // console.log('secondelse');
      selectedBlock1[obj.packageid] = {};
      selectedBlock1[obj.packageid][obj.parentId] = [];
    }

    //now push
    var selectedPlanLevel = { id: obj.subGroupId, order: obj.orderId };
    selectedBlock1[obj.packageid][obj.parentId].push(selectedPlanLevel);

    let subGroupIdindex;
    console.log(summaryBlock2);
    if (summaryBlock2 && summaryBlock2.length > 0) {
      console.log('1');
      for (let i = 0; i < summaryBlock2.length; i++) {
        if (summaryBlock2[i].subGroupId == obj.subGroupId) {
          console.log('3');
          subGroupIdindex = i;
          console.log(subGroupIdindex);
          break;
        }
      }
      // console.log(subGroupIdindex);
      if (subGroupIdindex > -1) {
        console.log(subGroupIdindex);
        summaryBlock2.splice(subGroupIdindex, 1);
      } else {
        console.log('check1');
      }
    }


    setTimeout(() => {

      sessionStorage.setItem('summaryBlock2', JSON.stringify(summaryBlock2));

    }, 10);

    let selectedplansblock2;
    let selectedplansblock3;





    sessionStorage.setItem(
      'summaryBlock1main',
      JSON.stringify(this.planssummarymain)
    );
    sessionStorage.setItem(
      'summaryBlock1opt',
      JSON.stringify(this.planssummaryopt)
    );
    sessionStorage.setItem('summaryBlock1', JSON.stringify(summaryBlock1));


    // setTimeout(() => {

    //   sessionStorage.setItem('summaryBlock1', JSON.stringify(summaryBlock1));

    // }, 3000);

    // sessionStorage.setItem('summaryBlock2', '[]');

    this.plansNewBlock1 = JSON.parse(
      sessionStorage.getItem('planResults') || '[]'
    );


    this.selectedplansblock1 = JSON.parse(
      sessionStorage.getItem('summaryBlock1') || '[]'
    );

    this.plansBlock1[obj.packageindex]['groups'][obj.groupindex]['subGroups'][
      obj.subgroupindex
    ]['checked'] = true;

    if (
      this.plansBlock1[obj.packageindex]['groups'][obj.groupindex]['subGroups'][
      obj.subgroupindex
      ]['name'] == 'Executive Health' || this.plansBlock1[obj.packageindex]['groups'][obj.groupindex]['subGroups'][
      obj.subgroupindex
      ]['name'] == 'Complete Executive Care' || this.plansBlock1[obj.packageindex]['groups'][obj.groupindex]['subGroups'][
      obj.subgroupindex
      ]['name'] == 'Provincial Health Replacement Plan'
    ) {


      this.plansBlock1[obj.packageindex]['groups'][obj.groupindex]['subGroups'][
        obj.subgroupindex
      ]['coverage'] = '';
      this.block1coverage = false;

      $('#executiveplanssingle' + obj.subGroupId).prop('disabled', false);
      $('#executiveplanscouple' + obj.subGroupId).prop('disabled', false);
      $('#executiveplansfamily' + obj.subGroupId).prop('disabled', false);

      let plans = this.paidByCompany.filter(
        (plan) => plan.planLevelId == obj.subGroupId
      );
      console.log(this.paidByCompany)
      if (plans.length > 0) {


        let plancheck1Coverage = this.getExecutiveCoveragesFromCode(plans[0].coverage)

        console.log({ plancheck1Coverage })

        if (
          plancheck1Coverage
        ) {
          if (plancheck1Coverage.single) {


            this.checkconditionforblock1()
            setTimeout(() => {
              $("#executiveplanssingle" + obj.subGroupId).click()
            }, 1000);

          } if (plancheck1Coverage.couple) {
            setTimeout(() => {
              $("#executiveplanscouple" + obj.subGroupId).click()
            }, 1000);
          } if (plancheck1Coverage.family) {
            setTimeout(() => {
              $("#executiveplansfamily" + obj.subGroupId).click()
            }, 1000);
          }

        }

      }
      else {


        this.checkconditionforblock1()
        setTimeout(() => {
          $("#executiveplanssingle" + obj.subGroupId).click()
        }, 1000);

      }

    }
    else {
      this.checkconditionforblock1()
    }

  }
  checkconditionforblock1() {
    this.plansNewBlock1 = JSON.parse(
      sessionStorage.getItem('planResults') || '[]'
    );

    this.plansNewBlock1.map((packagelevel: any, index: any) => {
      packagelevel.groups.map((groups: any, index1: any) => {
        this.selectedplansblock1.map((selectplan: any) => {
          if (
            packagelevel.id == selectplan.packageid &&
            packagelevel.groups.id == selectplan.parentid
          ) {
            var allAvailble =
              this.plansNewBlock1[index]['groups'][index1]['subGroups'];

            console.log(allAvailble)

            allAvailble.map((element1: any, index2: any) => {
              if (element1 != null) {


                if (selectplan.disallowedPlanLevels) {
                  let disallowed_plans = selectplan.disallowedPlanLevels.split(',');

                  console.log(disallowed_plans)

                  disallowed_plans.forEach((disallowed: any, index9) => {
                    console.log(this.plansNewBlock1[index]['groups'][index1]['subGroups'])

                    this.plansNewBlock1[index]['groups'][index1]['subGroups'].forEach((plan: any, index10) => {
                      if (this.plansNewBlock1[index]['groups'][index1]['subGroups'][index10] != null) {
                        console.log(this.plansNewBlock1[index]['groups'][index1]['subGroups'][index10].id)
                        console.log(disallowed)
                        if (this.plansNewBlock1[index]['groups'][index1]['subGroups'][index10].id == disallowed) {

                          this.plansNewBlock1[index]['groups'][index1]['subGroups'][index10] = null
                        }
                      }
                    })



                  })
                  console.log(this.plansNewBlock1)

                }
                // res.map((res1: any, index4: any) => {
                //   res1.groups.map((groups1: any, index5: any) => {
                //     // console.log(groups1)
                //     groups1.subGroups.forEach(
                //       (subgrp: any, index6: any) => {
                //         console.log(element1.disallowedPlanLevels);
                //         if (
                //           element1.disallowedPlanLevels.indexOf(
                //             groups1.id
                //           ) > -1
                //         ) {
                //           this.plansBlock1[index4]['groups'][index5][
                //             'subGroups'
                //           ][index6]['tiers'] = [];
                //           // this.plansBlock1[index4]['groups'][index5][
                //           //   'subGroups'
                //           // ][index6]['checked'] = false;

                //           res[index4]['groups'][index5]['subGroups'][
                //             index6
                //           ] = null;
                //         }
                //       }
                //     );
                //   });
                // });
                //   }
                // }
              }
            });
          }
        });
      });
    });
    console.log(this.plansNewBlock1)
    //  this.plansNewBlock1[obj.packageindex]['groups'][obj.groupindex]['subGroups'][obj.subgroupindex]['tiers'] = []
    // this.plansNewBlock1[obj.packageindex]['groups'][obj.groupindex]['subGroups'][obj.subgroupindex]['checked'] = false

    // sessionStorage.setItem('planResults', JSON.stringify(this.plansNewBlock1));


    // sessionStorage.setItem('planResults', JSON.stringify(this.plansBlock1));

    sessionStorage.setItem('mainresults', JSON.stringify(this.plansNewBlock1));

    this.checkvalidationblock2()
    this.checkvalidationblock3()
  }
  public checkvalidationblock2() {



    setTimeout(() => {
      let selectedplansblock2 = JSON.parse(
        sessionStorage.getItem('summaryBlock2') || '[]'
      );


      console.log(selectedplansblock2)
      if (this.upgradeplansselection == true) {
        // let el: HTMLElement = this.upgradeplansfalse.nativeElement;
        // el.click();
        setTimeout(() => {
          let el1: HTMLElement = this.upgradeplanstrue.nativeElement;
          el1.click();
          setTimeout(() => {
            const dom: HTMLElement = this.elementRef.nativeElement;
            if (selectedplansblock2.length > 0) {

              this.upgradeplansselection == true;
              setTimeout(() => {
                for (let i = 0; i < selectedplansblock2.length; i++) {
                  const element1: any = dom.querySelector(
                    '#plancheck2Upgrade' + selectedplansblock2[i].subGroupId
                  );
                  // element1.checked = true;
                  $("#plancheck2Upgrade" + selectedplansblock2[i].subGroupId).prop("checked", true);
                  let plancheck2Coverage = this.getExecutiveCoveragesFromCode(selectedplansblock2[i].coverage)

                  setTimeout(() => {
                    if (
                      plancheck2Coverage
                    ) {
                      if (plancheck2Coverage.single) {
                        const element2: any = dom.querySelector(
                          '#executiveplansblock2single' +
                          selectedplansblock2[i].subGroupId
                        );
                        // element2.checked = true;

                        $("#executiveplansblock2single" + selectedplansblock2[i].subGroupId).prop("checked", true);

                      } if (plancheck2Coverage.couple) {
                        const element2: any = dom.querySelector(
                          '#executiveplansblock2couple' +
                          selectedplansblock2[i].subGroupId
                        );
                        // element2.checked = true;

                        $("#executiveplansblock2couple" + selectedplansblock2[i].subGroupId).prop("checked", true);

                      } if (plancheck2Coverage.family) {
                        const element2: any = dom.querySelector(
                          '#executiveplansblock2family' +
                          selectedplansblock2[i].subGroupId
                        );
                        // element2.checked = true;

                        $("#executiveplansblock2family" + selectedplansblock2[i].subGroupId).prop("checked", true);

                      }
                    }
                  }, 1000);

                  if (selectedplansblock2[i].disallowedPlanLevels != null) {
                    let disallowed_plans = selectedplansblock2[i].disallowedPlanLevels.split(',');
                    const dom1: HTMLElement = this.elementRef.nativeElement;
                    for (let i = 0; i < disallowed_plans.length; i++) {
                      // console.log(disallowed_plans[i]);
                      // console.log(disallowed_plans[i]);
                      setTimeout(() => {
                        let elem: any = dom1.querySelector(`#plancheck2Upgrade${disallowed_plans[i]}`)

                        if (elem != null) {
                          if (!elem.disabled) {

                            elem.disabled = true
                          }
                        }
                      }, 100);

                    }
                  }
                }

              }, 1000);
            }
          }, 1000);
        }, 10);

      }
    }, 1000);



  }

  public checkvalidationblock3() {
    let selectedplansblock3 = JSON.parse(
      sessionStorage.getItem('summaryBlock3') || '[]'
    );
    setTimeout(() => {
      // if (selectedplansblock3.length > 0) {

      //   this.employeeplanpurchase = true

      if (this.employeeplanpurchase == true) {
        // let el: HTMLElement = this.employeepurchasefalse.nativeElement;
        // el.click();
        this.employeeplanpurchase = true
        setTimeout(() => {
          let el1: HTMLElement = this.employeepurchasetrue.nativeElement;
          el1.click();
          setTimeout(() => {
            const dom: HTMLElement = this.elementRef.nativeElement;
            if (selectedplansblock3.length > 0) {
              let el1: HTMLElement = this.employeepurchasetrue.nativeElement;
              el1.click();
              this.employeeplanpurchase == true;
              setTimeout(() => {
                for (let i = 0; i < selectedplansblock3.length; i++) {
                  const element2: any = dom.querySelector(
                    '#plancheck3Voluntry' + selectedplansblock3[i].subGroupId
                  );
                  $("#plancheck3Voluntry" + selectedplansblock3[i].subGroupId).prop("checked", true);

                  // element2.checked = true;
                  let plancheck3Coverage = this.getExecutiveCoveragesFromCode(selectedplansblock3[i].coverage)

                  setTimeout(() => {
                    if (
                      plancheck3Coverage
                    ) {
                      if (plancheck3Coverage.single) {
                        const element2: any = dom.querySelector(
                          '#executiveplansblock3single' +
                          selectedplansblock3[i].subGroupId
                        );
                        $("#executiveplansblock3single" + selectedplansblock3[i].subGroupId).prop("checked", true);

                        // element2.checked = true;
                      } if (plancheck3Coverage.couple) {
                        const element2: any = dom.querySelector(
                          '#executiveplansblock3couple' +
                          selectedplansblock3[i].subGroupId
                        );
                        $("#executiveplansblock3couple" + selectedplansblock3[i].subGroupId).prop("checked", true);

                        // element2.checked = true;
                      } if (plancheck3Coverage.family) {
                        const element2: any = dom.querySelector(
                          '#executiveplansblock3family' +
                          selectedplansblock3[i].subGroupId
                        );
                        $("#executiveplansblock3family" + selectedplansblock3[i].subGroupId).prop("checked", true);

                        // element2.checked = true;
                      }
                    }
                  }, 1000);
                  if (selectedplansblock3[i].disallowedPlanLevels != null) {
                    let disallowed_plans = selectedplansblock3[i].disallowedPlanLevels.split(',');
                    const dom1: HTMLElement = this.elementRef.nativeElement;
                    for (let i = 0; i < disallowed_plans.length; i++) {
                      // console.log(disallowed_plans[i]);
                      // console.log(disallowed_plans[i]);
                      setTimeout(() => {
                        let elem: any = dom1.querySelector(`#plancheck3Voluntry${disallowed_plans[i]}`)

                        if (elem != null) {
                          if (!elem.disabled) {

                            elem.disabled = true
                          }
                        }
                      }, 100);

                    }
                  }
                }
              }, 1500);
            }
          }, 1000);
        }, 100);
      }
      else {
      }
      // }
    }, 3000);
  }


  public unselectplanBulk(
    elementcv: any,
    packname: any,
    grpname: any,
    subgrpname: any,
    packageindex: number,
    groupindex: number,
    subgroupindex: number,
    packageIndex: number,
    groupIndex: number,
    subgroupIndex: number,
    disallowedPlanLevels: any
  ) {
    console.log(elementcv);

    let plandetails = elementcv.attributes.data.value;

    let plandetailsobj = plandetails.split('##');

    console.log(plandetailsobj);

    // let obj = {
    //   packageid: plandetailsobj[2],
    //   parentId: plandetailsobj[3],
    //   subGroupId: plandetailsobj[4],
    //   orderId: plandetailsobj[8],
    // };

    let obj = {
      packageid: plandetailsobj[2],
      parentId: plandetailsobj[3],
      subGroupId: plandetailsobj[4],
      orderId: plandetailsobj[8],
      packagename: packname,
      groupname: grpname,
      subGrpname: subgrpname,
      tiers: [],
      packageindex: packageindex,
      groupindex: groupindex,
      subgroupindex: subgroupindex,
      packageIndex: packageIndex,
      groupIndex: groupIndex,
      subgroupIndex: subgroupIndex,
      disallowedPlanLevels: disallowedPlanLevels
    };

    console.log(obj);
    if (plandetailsobj[1] != null || plandetailsobj[1] != 'null') {
      if (plandetailsobj[1].includes(plandetailsobj[2])) {
      }
    }

    this.removesummaryBlock1Bulk(obj);
  }

  public removesummaryBlock1Bulk(obj: any) {


    console.log(obj);
    let Mainplanres = JSON.parse(sessionStorage.getItem('planResults'));

    let summaryBlock1 = JSON.parse(
      sessionStorage.getItem('summaryBlockBulk') || '[]'
    );
    let selectedBlock1 = JSON.parse(
      sessionStorage.getItem('summaryBlockBulk') || '[]'
    );
    console.log(obj.subGroupId)


    if (summaryBlock1 && summaryBlock1.length > 0) {
      let index = this.getslectedplansBulk(obj.subGroupId);

      console.log(index)

      if (index > -1) {
        console.log(obj);

        console.log(index)
        summaryBlock1.splice(index, 1);
        console.log(this.checkboxCheck)
        // this.checkboxCheck[obj.subGroupId] = subgroup.settings?.showMemberDetails ? true : false

        // this.checkboxCheck[obj.subGroupId] = false
        // console.log(this.checkboxCheck)
        // this.showHeadCount[obj.subGroupId] = ''




        console.log(this.employeeList)

        let arrayEmployee = []
        let arrayEmployee1 = []
        for (let i = 0; i < this.employeeList.length; i++) {
          if (this.employeeList[i].isBulk == true && this.employeeList[i].bulkPlanLevelId == obj.subGroupId) {
            if (this.employeeList[i].uId && this.employeeList[i].uId > 0) {
              this.deletedId.push(this.employeeList[i].uId);
            }
            else {
              arrayEmployee.push(this.employeeList[i]);
            }
          }
          else {
            arrayEmployee1.push(this.employeeList[i]);

          }
        }

        console.log(arrayEmployee)
        console.log(arrayEmployee1)
        setTimeout(() => {
          if (this.deletedId && this.deletedId.length > 0) {
            this.deleteEmployee1(this.deletedId);
          }
          if (arrayEmployee.length > 0) {
            this.deleteEmployee(arrayEmployee);
          }
        }, 1000);


        console.log(this.employeeList)






        sessionStorage.setItem('planResults', JSON.stringify(this.plansBlock1));

        this.checkvalidationblock2()

        this.checkvalidationblock3()
      } else {
        return;
      }

      // if(index >-1){

      //   alert(index)
      //   selectedBlock1.splice(index,1)

      // }
      // else{
      //   return
      // }

      var newselectedplans: any = {};
      for (var i = 0; i < summaryBlock1.length; i++) {
        newselectedplans[summaryBlock1[i].subGroupId] = i;
      }

      sessionStorage.setItem('selectedPlans', JSON.stringify(newselectedplans));

      this.planssummarymain = [];
      this.planssummaryopt = [];

      summaryBlock1.forEach((element: any) => {
        if (element.packagename != 'Opt-in') {
          this.planssummarymain.push(element);
        } else {
          this.planssummaryopt.push(element);
        }
      });






      sessionStorage.setItem(
        'summaryBlock1main',
        JSON.stringify(this.planssummarymain)
      );
      sessionStorage.setItem(
        'summaryBlock1opt',
        JSON.stringify(this.planssummaryopt)
      );

      sessionStorage.setItem('summaryBlockBulk', JSON.stringify(summaryBlock1));

    }

    this.plansNewBlock1 = JSON.parse(
      sessionStorage.getItem('planResults') || '[]'
    );

    var res = JSON.parse(sessionStorage.getItem('planResults') || '[]');


    // console.log(this.selectedplansblock1)

    this.selectedplansblock1 = JSON.parse(
      sessionStorage.getItem('summaryBlockBulk') || '[]')

    // this.plansNewBlock1.map((packagelevel: any, index: any) => {
    //   packagelevel.groups.map((groups: any, index1: any) => {
    //     this.selectedplansblock1.map((selectplan: any) => {
    //       if (
    //         packagelevel.id == selectplan.packageid &&
    //         packagelevel.groups.id == selectplan.parentid
    //       ) {
    //         var allAvailble =
    //           this.plansNewBlock1[index]['groups'][index1]['subGroups'];

    //         allAvailble.map((element1: any, index2: any) => {
    //           if (element1 != null) {

    //             console.log(element1.disallowedPlanLevels)
    //             if (element1.disallowedPlanLevels) {
    //               console.log(element1.id)
    //               console.log(obj.subGroupId)
    //               if (element1.id == obj.subGroupId) {

    //                 console.log(element1.id)
    //                 console.log(obj.subGroupId)
    //                 res.map((res1: any, index4: any) => {
    //                   res1.groups.map((groups1: any, index5: any) => {
    //                     // console.log(groups1)
    //                     groups1.subGroups.forEach(
    //                       (subgrp: any, index6: any) => {
    //                         console.log(subgrp);
    //                         if (
    //                           element1.disallowedPlanLevels.indexOf(
    //                             groups1.id
    //                           ) > -1
    //                         ) {
    //                           this.plansBlock1[index4]['groups'][index5][
    //                             'subGroups'
    //                           ][index6]['tiers'] = [];
    //                           // this.plansBlock1[index4]['groups'][index5][
    //                           //   'subGroups'
    //                           // ][index6]['checked'] = false;

    //                           res[index4]['groups'][index5]['subGroups'][
    //                             index6
    //                           ] = subgrp;
    //                         }
    //                       }
    //                     );
    //                   });
    //                 });
    //                 sessionStorage.setItem('mainresults', JSON.stringify(res));

    //               }
    //             }
    //           }
    //         });
    //       }
    //     });
    //   });
    // });

    // for (let i = 0; i < this.selectedplansblock1.length; i++) {


    console.log(obj)
    // if (obj.disallowedPlanLevels != null) {
    //   setTimeout(() => {
    //     let elem: any = dom1.querySelector(`#plancheck${obj.subGroupId}`)

    //     if(elem!=null){
    //     if (elem.disabled) {

    //       elem.disabled = false
    //     }
    //   }
    //   }, 100);
    //   let disallowed_plans = obj.disallowedPlanLevels.split(',');
    //   const dom1: HTMLElement = this.elementRef.nativeElement;
    //   for (let i = 0; i < disallowed_plans.length; i++) {
    //     setTimeout(() => {
    //       let elem: any = dom1.querySelector(`#plancheck${disallowed_plans[i]}`)

    //       if(elem!=null){
    //       if (elem.disabled) {

    //         elem.disabled = false
    //       }
    //     }
    //     }, 100);

    //   }
    // }
    // else{
    //   setTimeout(() => {
    //     const dom1: HTMLElement = this.elementRef.nativeElement;

    //     let elem: any = dom1.querySelector(`#plancheck${obj.subGroupId}`)

    //     if(elem!=null){
    //     if (elem.disabled) {

    //       elem.disabled = false
    //     }
    //   }
    //   }, 100);
    // }

    // }

  }
  public unselectplan(
    elementcv: any,
    packname: any,
    grpname: any,
    subgrpname: any,
    packageindex: number,
    groupindex: number,
    subgroupindex: number,
    packageIndex: number,
    groupIndex: number,
    subgroupIndex: number
  ) {
    console.log(elementcv);

    let plandetails = elementcv.attributes.data.value;

    let plandetailsobj = plandetails.split('##');

    console.log(plandetailsobj);

    // let obj = {
    //   packageid: plandetailsobj[2],
    //   parentId: plandetailsobj[3],
    //   subGroupId: plandetailsobj[4],
    //   orderId: plandetailsobj[8],
    // };

    let obj = {
      packageid: plandetailsobj[2],
      parentId: plandetailsobj[3],
      subGroupId: plandetailsobj[4],
      orderId: plandetailsobj[8],
      packagename: packname,
      groupname: grpname,
      subGrpname: subgrpname,
      tiers: [],
      packageindex: packageindex,
      groupindex: groupindex,
      subgroupindex: subgroupindex,
      packageIndex: packageIndex,
      groupIndex: groupIndex,
      subgroupIndex: subgroupIndex,
    };

    console.log(obj);
    if (plandetailsobj[1] != null || plandetailsobj[1] != 'null') {
      if (plandetailsobj[1].includes(plandetailsobj[2])) {
      }
    }

    this.removesummaryBlock1(obj);
  }

  public getslectedplansBulk(planid: number) {
    //console.log(planid)
    // let selectedPlans = JSON.parse(
    //   sessionStorage.getItem('selectedPlans') || '{}'
    // );
    // // console.log(selectedPlans)
    // return selectedPlans[planid];


    console.log(planid)
    let summaryBlock1 = JSON.parse(
      sessionStorage.getItem('summaryBlockBulk') || '{}'
    );
    let subGroupIdindex;
    for (let i = 0; i < summaryBlock1.length; i++) {
      console.log(summaryBlock1[i].subGroupId)
      console.log(planid)
      if (summaryBlock1[i].subGroupId == planid) {
        subGroupIdindex = i;
        break;
      }
    }

    return subGroupIdindex;
  }
  // public removesummaryBlock1(obj: any) {


  //   console.log(obj);
  //   let Mainplanres = JSON.parse(sessionStorage.getItem('planResults'));

  //   let summaryBlock1 = JSON.parse(
  //     sessionStorage.getItem('summaryBlock1') || '[]'
  //   );
  //   let selectedBlock1 = JSON.parse(
  //     sessionStorage.getItem('selectedBlock1') || '[]'
  //   );
  //   console.log(obj.subGroupId)
  //   if (summaryBlock1 && summaryBlock1.length > 0) {
  //     let index = this.getslectedplansblock1(obj.subGroupId);
  //     let index1 = this.getslectedblockplans(obj);

  //     console.log(index)

  //     if (index > -1) {
  //       console.log(obj);

  //       console.log(index)
  //       summaryBlock1.splice(index, 1);



  //       console.log(obj.packageIndex);
  //       console.log(obj.groupIndex);
  //       console.log(obj.subgroupIndex);

  //       if (obj.packageIndex >= 0 && obj.groupIndex >= 0 && obj.subgroupIndex >= 0) {
  //         //  if(!this.plansBlock1[obj.packageIndex]['groups'][obj.groupIndex] || this.plansBlock1[obj.packageIndex]['groups'][obj.groupIndex]['subGroups']){

  //         //  }
  //         //  else{
  //         this.plansBlock1[obj.packageIndex]['groups'][obj.groupIndex][
  //           'subGroups'
  //         ][obj.subgroupIndex]['tiers'] = [];
  //         this.plansBlock1[obj.packageIndex]['groups'][obj.groupIndex][
  //           'subGroups'
  //         ][obj.subgroupIndex]['checked'] = false;

  //         if (
  //           this.plansBlock1[obj.packageIndex]['groups'][obj.groupIndex][
  //           'subGroups'
  //           ][obj.subgroupIndex]['name'] == 'Executive Health'
  //         ) {
  //           console.log('Executive Health');
  //           this.plansBlock1[obj.packageIndex]['groups'][obj.groupIndex][
  //             'subGroups'
  //           ][obj.subgroupIndex]['coverage'] = '';  //default
  //           sessionStorage.setItem('mainresults', JSON.stringify(this.plansBlock1));
  //           this.block1coverage = true;

  //           // element.checked =false
  //           $('#executiveplanssingle' + obj.subGroupId).prop('checked', false);
  //           $('#executiveplanscouple' + obj.subGroupId).prop('checked', false);
  //           $('#executiveplansfamily' + obj.subGroupId).prop('checked', false);
  //           $('#executiveplanssingle' + obj.subGroupId).prop('disabled', true);
  //           $('#executiveplanscouple' + obj.subGroupId).prop('disabled', true);
  //           $('#executiveplansfamily' + obj.subGroupId).prop('disabled', true);
  //         }

  //         if (
  //           this.plansBlock1[obj.packageIndex]['groups'][obj.groupIndex][
  //           'subGroups'
  //           ][obj.subgroupIndex]['name'] == 'Complete Executive Care'
  //         ) {
  //           console.log('Complete Executive Care');
  //           this.plansBlock1[obj.packageIndex]['groups'][obj.groupIndex][
  //             'subGroups'
  //           ][obj.subgroupIndex]['coverage'] = ''; //default
  //           sessionStorage.setItem('mainresults', JSON.stringify(this.plansBlock1));

  //           this.block1coverage = true;

  //           // element.checked =false
  //           $('#executiveplanssingle' + obj.subGroupId).prop('checked', false);
  //           $('#executiveplanscouple' + obj.subGroupId).prop('checked', false);
  //           $('#executiveplansfamily' + obj.subGroupId).prop('checked', false);
  //           $('#executiveplanssingle' + obj.subGroupId).prop('disabled', true);
  //           $('#executiveplanscouple' + obj.subGroupId).prop('disabled', true);
  //           $('#executiveplansfamily' + obj.subGroupId).prop('disabled', true);
  //         }
  //         if (
  //           this.plansBlock1[obj.packageIndex]['groups'][obj.groupIndex][
  //           'subGroups'
  //           ][obj.subgroupIndex]['name'] == 'Provincial Health Replacement Plan'
  //         ) {
  //           console.log('Complete Executive Care');
  //           this.plansBlock1[obj.packageIndex]['groups'][obj.groupIndex][
  //             'subGroups'
  //           ][obj.subgroupIndex]['coverage'] = ''; //default
  //           sessionStorage.setItem('mainresults', JSON.stringify(this.plansBlock1));

  //           this.block1coverage = true;

  //           // element.checked =false
  //           $('#executiveplanssingle' + obj.subGroupId).prop('checked', false);
  //           $('#executiveplanscouple' + obj.subGroupId).prop('checked', false);
  //           $('#executiveplansfamily' + obj.subGroupId).prop('checked', false);
  //           $('#executiveplanssingle' + obj.subGroupId).prop('disabled', true);
  //           $('#executiveplanscouple' + obj.subGroupId).prop('disabled', true);
  //           $('#executiveplansfamily' + obj.subGroupId).prop('disabled', true);
  //         }
  //       }

  //       sessionStorage.setItem('planResults', JSON.stringify(this.plansBlock1));
  //       this.checkvalidationblock2()

  //       this.checkvalidationblock3()
  //     } else {
  //       return;
  //     }

  //     // if(index >-1){

  //     //   alert(index)
  //     //   selectedBlock1.splice(index,1)

  //     // }
  //     // else{
  //     //   return
  //     // }

  //     var newselectedplans: any = {};
  //     for (var i = 0; i < summaryBlock1.length; i++) {
  //       newselectedplans[summaryBlock1[i].subGroupId] = i;
  //     }

  //     sessionStorage.setItem('selectedPlans', JSON.stringify(newselectedplans));

  //     this.planssummarymain = [];
  //     this.planssummaryopt = [];

  //     summaryBlock1.forEach((element: any) => {
  //       if (element.packagename != 'Opt-in') {
  //         this.planssummarymain.push(element);
  //       } else {
  //         this.planssummaryopt.push(element);
  //       }
  //     });

  //     let selectedplansblock2 = JSON.parse(
  //       sessionStorage.getItem('summaryBlock2') || '[]'
  //     );
  //     let selectedplansblock3 = JSON.parse(
  //       sessionStorage.getItem('summaryBlock3') || '[]'
  //     );


  //     console.log(selectedplansblock2)
  //     // if (this.upgradeplansselection == true) {
  //     //   let el: HTMLElement = this.upgradeplansfalse.nativeElement;
  //     //   el.click();
  //     //   setTimeout(() => {
  //     //     let el1: HTMLElement = this.upgradeplanstrue.nativeElement;
  //     //     el1.click();
  //     //     setTimeout(() => {
  //     //       const dom: HTMLElement = this.elementRef.nativeElement;
  //     //       if (selectedplansblock2.length > 0) {
  //     //         let el1: HTMLElement = this.upgradeplanstrue.nativeElement;
  //     //         el1.click();
  //     //         this.upgradeplansselection == true;
  //     //         setTimeout(() => {
  //     //           for (let i = 0; i < selectedplansblock2.length; i++) {
  //     //             const element1: any = dom.querySelector(
  //     //               '#plancheck2Upgrade' + selectedplansblock2[i].subGroupId
  //     //             );
  //     //             $("#plancheck2Upgrade" + selectedplansblock2[i].subGroupId).prop("checked", true);

  //     //             let plancheck2Coverage =  this.getExecutiveCoveragesFromCode(selectedplansblock2[i].coverage)


  //     //             // console.log("rakess"+JSON.parse(plancheck2Coverage))
  //     //             console.log("rakess"+JSON.stringify(plancheck2Coverage))


  //     //             setTimeout(() => {
  //     //               if (
  //     //                 plancheck2Coverage
  //     //               ) {
  //     //                 if (plancheck2Coverage.single) {
  //     //                   const element2: any = dom.querySelector(
  //     //                     '#executiveplansblock2single' +
  //     //                       selectedplansblock2[i].subGroupId
  //     //                   );
  //     //                   // element2.checked = true;

  //     //                   $("#executiveplansblock2single" + selectedplansblock2[i].subGroupId).prop("checked", true);

  //     //                 } if (plancheck2Coverage.couple) {
  //     //                   const element2: any = dom.querySelector(
  //     //                     '#executiveplansblock2couple' +
  //     //                       selectedplansblock2[i].subGroupId
  //     //                   );
  //     //                   // element2.checked = true;

  //     //                   $("#executiveplansblock2couple" + selectedplansblock2[i].subGroupId).prop("checked", true);

  //     //                 } if (plancheck2Coverage.family) {
  //     //                   const element2: any = dom.querySelector(
  //     //                     '#executiveplansblock2family' +
  //     //                       selectedplansblock2[i].subGroupId
  //     //                   );
  //     //                   // element2.checked = true;

  //     //                   $("#executiveplansblock2family" + selectedplansblock2[i].subGroupId).prop("checked", true);

  //     //                 }
  //     //               }
  //     //             }, 1000);
  //     //           }
  //     //         }, 1000);
  //     //       }
  //     //     }, 1000);
  //     //   }, 400);
  //     // }


  //     // // alert(this.employeeplanpurchase)
  //     // if (this.employeeplanpurchase == true) {
  //     //   let el: HTMLElement = this.employeepurchasefalse.nativeElement;
  //     //   el.click();
  //     //   setTimeout(() => {
  //     //     let el1: HTMLElement = this.employeepurchasetrue.nativeElement;
  //     //     el1.click();
  //     //     setTimeout(() => {
  //     //       const dom: HTMLElement = this.elementRef.nativeElement;
  //     //       if (selectedplansblock3.length > 0) {
  //     //         let el1: HTMLElement = this.employeepurchasetrue.nativeElement;
  //     //         el1.click();
  //     //         this.employeeplanpurchase == true;
  //     //         setTimeout(() => {
  //     //           for (let i = 0; i < selectedplansblock3.length; i++) {
  //     //             const element2: any = dom.querySelector(
  //     //               '#plancheck3Voluntry' + selectedplansblock3[i].subGroupId
  //     //             );
  //     //             $("#plancheck3Voluntry" + selectedplansblock3[i].subGroupId).prop("checked", true);

  //     //             // element2.checked = true;
  //     //             let plancheck3Coverage =  this.getExecutiveCoveragesFromCode(selectedplansblock3[i].coverage)

  //     //             setTimeout(() => {
  //     //               if (
  //     //                 plancheck3Coverage
  //     //               ) {
  //     //                 if (plancheck3Coverage.single) {
  //     //                   const element2: any = dom.querySelector(
  //     //                     '#executiveplansblock3single' +
  //     //                       selectedplansblock3[i].subGroupId
  //     //                   );
  //     //                   $("#executiveplansblock3single" + selectedplansblock3[i].subGroupId).prop("checked", true);

  //     //                   // element2.checked = true;
  //     //                 } if (plancheck3Coverage.couple) {
  //     //                   const element2: any = dom.querySelector(
  //     //                     '#executiveplansblock3couple' +
  //     //                       selectedplansblock3[i].subGroupId
  //     //                   );
  //     //                   $("#executiveplansblock3couple" + selectedplansblock3[i].subGroupId).prop("checked", true);

  //     //                   // element2.checked = true;
  //     //                 } if (plancheck3Coverage.family) {
  //     //                   const element2: any = dom.querySelector(
  //     //                     '#executiveplansblock3family' +
  //     //                       selectedplansblock3[i].subGroupId
  //     //                   );
  //     //                   $("#executiveplansblock3family" + selectedplansblock3[i].subGroupId).prop("checked", true);

  //     //                   // element2.checked = true;
  //     //                 }
  //     //               }
  //     //             }, 1000);
  //     //           }
  //     //         }, 1500);
  //     //       }
  //     //     }, 1000);
  //     //   }, 3000);
  //     // }

  //     // let el: HTMLElement = this.upgradeplansfalse.nativeElement;
  //     // el.click();
  //     // let el1: HTMLElement = this.employeepurchasefalse.nativeElement;
  //     // el1.click();

  //     sessionStorage.setItem(
  //       'summaryBlock1main',
  //       JSON.stringify(this.planssummarymain)
  //     );
  //     sessionStorage.setItem(
  //       'summaryBlock1opt',
  //       JSON.stringify(this.planssummaryopt)
  //     );

  //     sessionStorage.setItem('summaryBlock1', JSON.stringify(summaryBlock1));
  //   }

  //   this.plansNewBlock1 = JSON.parse(
  //     sessionStorage.getItem('planResults') || '[]'
  //   );

  //   var res = JSON.parse(sessionStorage.getItem('planResults') || '[]');


  //   console.log(this.selectedplansblock1)

  //   this.plansNewBlock1.map((packagelevel: any, index: any) => {
  //     packagelevel.groups.map((groups: any, index1: any) => {
  //       this.selectedplansblock1.map((selectplan: any) => {
  //         if (
  //           packagelevel.id == selectplan.packageid &&
  //           packagelevel.groups.id == selectplan.parentid
  //         ) {
  //           var allAvailble =
  //             this.plansNewBlock1[index]['groups'][index1]['subGroups'];

  //           allAvailble.map((element1: any, index2: any) => {
  //             if (element1 != null) {

  //               console.log(element1.disallowedPlanLevels)
  //               if (element1.disallowedPlanLevels) {
  //                 console.log(element1.id)
  //                 console.log(obj.subGroupId)
  //                 if (element1.id == obj.subGroupId) {

  //                   console.log(element1.id)
  //                   console.log(obj.subGroupId)
  //                   res.map((res1: any, index4: any) => {
  //                     res1.groups.map((groups1: any, index5: any) => {
  //                       // console.log(groups1)
  //                       groups1.subGroups.forEach(
  //                         (subgrp: any, index6: any) => {
  //                           console.log(subgrp);
  //                           if (
  //                             element1.disallowedPlanLevels.indexOf(
  //                               groups1.id
  //                             ) > -1
  //                           ) {
  //                             this.plansBlock1[index4]['groups'][index5][
  //                               'subGroups'
  //                             ][index6]['tiers'] = [];
  //                             // this.plansBlock1[index4]['groups'][index5][
  //                             //   'subGroups'
  //                             // ][index6]['checked'] = false;

  //                             res[index4]['groups'][index5]['subGroups'][
  //                               index6
  //                             ] = subgrp;
  //                           }
  //                         }
  //                       );
  //                     });
  //                   });
  //                   sessionStorage.setItem('mainresults', JSON.stringify(res));

  //                 }
  //               }
  //             }
  //           });
  //         }
  //       });
  //     });
  //   });

  //   //        this.selectedplansblock1 = JSON.parse(sessionStorage.getItem("summaryBlock1") || "{}")

  //   // this.plansNewBlock2.forEach((packagelevel:any,index:any) => {

  //   // packagelevel.groups.forEach((groups:any,index1:any) => {
  //   // this.selectedplansblock1.forEach((selectplan:any) => {
  //   // if(packagelevel.id==selectplan.packageid && packagelevel.groups.id==selectplan.parentid){

  //   //  var allAvailble = this.plansNewBlock2[index]["groups"][index1]["subGroups"]

  //   // console.log(allAvailble)

  //   //  allAvailble.forEach((element1:any,index2:any) => {

  //   //    if(element1 !=null){

  //   //        if(element1.disallowedPlanLevels){

  //   //          console.log(element1)
  //   //            if(element1.id==selectplan.subGroupId){
  //   //          res.forEach((res1:any,index4:any) => {

  //   //            res1.groups.forEach((groups1:any,index5:any) => {
  //   //              console.log(groups1)
  //   //              groups1.subGroups.forEach((subgrp:any,index6:any) => {

  //   //                if(groups1.id==15){
  //   //               res[index4]["groups"][index5]["subGroups"][index6]=null
  //   //                }
  //   //               })

  //   //            })

  //   //          });

  //   //        }

  //   //        }

  //   //  }

  //   //  })

  //   // }

  //   // })
  //   // });

  //   // });
  //   // console.log(res)
  // }
  public removesummaryBlock1(obj: any) {


    console.log(obj);
    let Mainplanres = JSON.parse(sessionStorage.getItem('planResults'));

    let summaryBlock1 = JSON.parse(
      sessionStorage.getItem('summaryBlock1') || '[]'
    );
    let selectedBlock1 = JSON.parse(
      sessionStorage.getItem('selectedBlock1') || '[]'
    );
    console.log(obj.subGroupId)
    if (summaryBlock1 && summaryBlock1.length > 0) {
      let index = this.getslectedplansblock1(obj.subGroupId);
      let index1 = this.getslectedblockplans(obj);

      console.log(index)

      if (index > -1) {

        summaryBlock1.splice(index, 1);

        if (obj.packageIndex >= 0 && obj.groupIndex >= 0 && obj.subgroupIndex >= 0) {
          //  if(!this.plansBlock1[obj.packageIndex]['groups'][obj.groupIndex] || this.plansBlock1[obj.packageIndex]['groups'][obj.groupIndex]['subGroups']){

          //  }
          //  else{
          this.plansBlock1[obj.packageIndex]['groups'][obj.groupIndex][
            'subGroups'
          ][obj.subgroupIndex]['tiers'] = [];
          this.plansBlock1[obj.packageIndex]['groups'][obj.groupIndex][
            'subGroups'
          ][obj.subgroupIndex]['checked'] = false;

          if (
            this.plansBlock1[obj.packageIndex]['groups'][obj.groupIndex][
            'subGroups'
            ][obj.subgroupIndex]['name'] == 'Executive Health' || this.plansBlock1[obj.packageIndex]['groups'][obj.groupIndex][
            'subGroups'
            ][obj.subgroupIndex]['name'] == 'Complete Executive Care' || this.plansBlock1[obj.packageIndex]['groups'][obj.groupIndex][
            'subGroups'
            ][obj.subgroupIndex]['name'] == 'Provincial Health Replacement Plan'
          ) {
            console.log('Executive Health');
            this.plansBlock1[obj.packageIndex]['groups'][obj.groupIndex][
              'subGroups'
            ][obj.subgroupIndex]['coverage'] = '';  //default
            sessionStorage.setItem('mainresults', JSON.stringify(this.plansBlock1));
            this.block1coverage = true;


            // element.checked =false
            $('#executiveplanssingle' + obj.subGroupId).prop('checked', false);
            $('#executiveplanscouple' + obj.subGroupId).prop('checked', false);
            $('#executiveplansfamily' + obj.subGroupId).prop('checked', false);
            $('#executiveplanssingle' + obj.subGroupId).prop('disabled', true);
            $('#executiveplanscouple' + obj.subGroupId).prop('disabled', true);
            $('#executiveplansfamily' + obj.subGroupId).prop('disabled', true);
          }


        }



      } else {
        return;
      }



      var newselectedplans: any = {};
      for (var i = 0; i < summaryBlock1.length; i++) {
        newselectedplans[summaryBlock1[i].subGroupId] = i;
      }

      sessionStorage.setItem('selectedPlans', JSON.stringify(newselectedplans));

      this.planssummarymain = [];
      this.planssummaryopt = [];

      summaryBlock1.forEach((element: any) => {
        if (element.packagename != 'Opt-in') {
          this.planssummarymain.push(element);
        } else {
          this.planssummaryopt.push(element);
        }
      });

      let selectedplansblock2 = JSON.parse(
        sessionStorage.getItem('summaryBlock2') || '[]'
      );
      let selectedplansblock3 = JSON.parse(
        sessionStorage.getItem('summaryBlock3') || '[]'
      );

      sessionStorage.setItem(
        'summaryBlock1main',
        JSON.stringify(this.planssummarymain)
      );
      sessionStorage.setItem(
        'summaryBlock1opt',
        JSON.stringify(this.planssummaryopt)
      );

      sessionStorage.setItem('summaryBlock1', JSON.stringify(summaryBlock1));
    }

    this.plansNewBlock1 = JSON.parse(
      sessionStorage.getItem('planResults') || '[]'
    );

    var res = JSON.parse(sessionStorage.getItem('planResults') || '[]');


    this.selectedplansblock1 = JSON.parse(
      sessionStorage.getItem('summaryBlock1') || '[]'
    );


    this.plansNewBlock1.map((packagelevel: any, index: any) => {
      packagelevel.groups.map((groups: any, index1: any) => {
        this.selectedplansblock1.map((selectplan: any) => {
          if (
            packagelevel.id == selectplan.packageid &&
            packagelevel.groups.id == selectplan.parentid
          ) {
            var allAvailble =
              this.plansNewBlock1[index]['groups'][index1]['subGroups'];

            console.log(allAvailble)

            allAvailble.map((element1: any, index2: any) => {
              if (element1 != null) {

                console.log(selectplan)
                if (selectplan.disallowedPlanLevels) {
                  let disallowed_plans = selectplan.disallowedPlanLevels.split(',');

                  console.log(disallowed_plans)



                  disallowed_plans.forEach((disallowed: any, index9) => {
                    const dom1: HTMLElement = this.elementRef.nativeElement;

                    setTimeout(() => {
                      let elem: any = dom1.querySelector(`#plancheck${disallowed}`)

                      if (elem != null) {
                        if (!elem.disabled) {

                          elem.disabled = true
                        }
                      }
                    }, 100);

                    this.plansNewBlock1[index]['groups'][index1]['subGroups'].forEach((plan: any, index10) => {
                      if (this.plansNewBlock1[index]['groups'][index1]['subGroups'][index10] != null) {
                        console.log(this.plansNewBlock1[index]['groups'][index1]['subGroups'][index10].id)
                        console.log(disallowed)
                        if (this.plansNewBlock1[index]['groups'][index1]['subGroups'][index10].id == disallowed) {
                          this.plansNewBlock1[index]['groups'][index1]['subGroups'][index10] = null
                        }
                      }
                    })



                  })
                  console.log(this.plansNewBlock1)

                }

              }
            });
          }
        });
      });
    });
    sessionStorage.setItem('mainresults', JSON.stringify(this.plansNewBlock1));
    this.checkvalidationblock2()

    this.checkvalidationblock3()

  }

  public removeslectplans(planid: number, plansumamryindex: number) {
    let selectedPlans = JSON.parse(
      sessionStorage.getItem('selectedPlans') || '{}'
    );
    //console.log(selectedPlans)
    delete selectedPlans[planid];

    for (const planid in selectedPlans) {
      if (selectedPlans[planid] != 0) {
        selectedPlans[planid] = selectedPlans[planid] - 1;
        if (selectedPlans[planid]) {
        }
      }
    }
    //console.log("adjustedselectedPlans")
    //console.log(selectedPlans)
    sessionStorage.setItem('selectedPlans', JSON.stringify(selectedPlans));
  }

  public selectplanblock3(
    elementcv: any,
    packname: any,
    grpname: any,
    subgrpname: any,
    packageindex: number,
    groupindex: number,
    subgroupindex: number,
    subgroup: any,
    disallowedPlanLevels: any
  ) {
    let plandetails = elementcv.attributes.data.value;

    let plandetailsobj = plandetails.split('##');

    let obj = {
      packageid: plandetailsobj[2],
      parentId: plandetailsobj[3],
      subGroupId: plandetailsobj[4],
      orderId: plandetailsobj[8],
      packagename: packname,
      groupname: grpname,
      subGrpname: subgrpname,
      tiers: [],
      packageindex: packageindex,
      groupindex: groupindex,
      subgroupindex: subgroupindex,
      settingsAdditional: subgroup?.settingsAdditional || {},
      disallowedPlanLevels: disallowedPlanLevels
    };
    console.log(obj);

    this.addtosummaryBlock3(obj);
  }

  public addtosummaryBlock3(obj: any) {
    console.log(obj);
    let summaryBlock3 = JSON.parse(
      sessionStorage.getItem('summaryBlock3') || '[]'
    );

    let selectedBlock3 = JSON.parse(
      sessionStorage.getItem('selectedBlock3') || '{}'
    );

    this.addtoslectplansblock3(obj.subGroupId, summaryBlock3.length);
    summaryBlock3.push(obj);

    this.planssummarymain = [];
    this.planssummaryopt = [];

    summaryBlock3.forEach((element: any) => {
      if (element.packagename != 'Opt-in') {
        this.planssummarymain.push(element);
      } else {
        this.planssummaryopt.push(element);
      }
    });

    if (selectedBlock3[obj.packageid]) {
      if (selectedBlock3[obj.packageid][obj.parentId]) {
        // console.log(selectedBlock3[obj.packageid][obj.parentId])
      } else {
        // console.log("firstelse")
        selectedBlock3[obj.packageid][obj.parentId] = [];
      }
    } else {
      // console.log("secondelse")
      selectedBlock3[obj.packageid] = {};
      selectedBlock3[obj.packageid][obj.parentId] = [];
    }

    //now push
    var selectedPlanLevel = { id: obj.subGroupId, order: obj.orderId };
    selectedBlock3[obj.packageid][obj.parentId].push(selectedPlanLevel);

    // sessionStorage.setItem('selectedBlock3', JSON.stringify(selectedBlock3));
    sessionStorage.setItem(
      'summaryBlock3main',
      JSON.stringify(this.planssummarymain)
    );
    sessionStorage.setItem(
      'summaryBlock3opt',
      JSON.stringify(this.planssummaryopt)
    );

    sessionStorage.setItem('summaryBlock3', JSON.stringify(summaryBlock3));

    console.log(obj.packageindex);
    console.log(obj.groupindex);
    console.log(obj.subgroupindex);

    if (
      !this.plansresblack3[obj.packageindex] ||
      this.plansresblack3[obj.packageindex]['groups'] ||
      this.plansresblack3[obj.packageindex]['groups'][obj.groupindex] ||
      this.plansresblack3[obj.packageindex]['groups'][obj.groupindex][
      'subGroups'
      ]
    ) {
      console.log(
        this.plansresblack3[obj.packageindex]['groups'][obj.groupindex][
        'subGroups'
        ][obj.subgroupindex]
      );

      this.plansresblack3[obj.packageindex]['groups'][obj.groupindex][
        'subGroups'
      ][obj.subgroupindex]['checked'] = true;
    }

    if (
      this.plansresblack3[obj.packageindex]['groups'][obj.groupindex][
      'subGroups'
      ][obj.subgroupindex]['name'] == 'Executive Health'
    ) {
      $('#executiveplansblock3single' + obj.subGroupId).prop('disabled', false);
      $('#executiveplansblock3couple' + obj.subGroupId).prop('disabled', false);
      $('#executiveplansblock3family' + obj.subGroupId).prop('disabled', false);
      $('#executiveplansblock3single' + obj.subGroupId).click();
      $('#executiveplansblock3couple' + obj.subGroupId).click();
      $('#executiveplansblock3family' + obj.subGroupId).click();
    }
    if (
      this.plansresblack3[obj.packageindex]['groups'][obj.groupindex][
      'subGroups'
      ][obj.subgroupindex]['name'] == 'Complete Executive Care'
    ) {
      $('#executiveplansblock3single' + obj.subGroupId).prop('disabled', false);
      $('#executiveplansblock3couple' + obj.subGroupId).prop('disabled', false);
      $('#executiveplansblock3family' + obj.subGroupId).prop('disabled', false);
      $('#executiveplansblock3single' + obj.subGroupId).click();
      $('#executiveplansblock3couple' + obj.subGroupId).click();
      $('#executiveplansblock3family' + obj.subGroupId).click();
    }
    if (
      this.plansresblack3[obj.packageindex]['groups'][obj.groupindex][
      'subGroups'
      ][obj.subgroupindex]['name'] == 'Provincial Health Replacement Plan'
    ) {
      $('#executiveplansblock3single' + obj.subGroupId).prop('disabled', false);
      $('#executiveplansblock3couple' + obj.subGroupId).prop('disabled', false);
      $('#executiveplansblock3family' + obj.subGroupId).prop('disabled', false);
      $('#executiveplansblock3single' + obj.subGroupId).click();
      $('#executiveplansblock3couple' + obj.subGroupId).click();
      $('#executiveplansblock3family' + obj.subGroupId).click();
    }
    sessionStorage.setItem('block3result', JSON.stringify(this.plansresblack3));
  }


  public addtoslectplansblock3(planid: number, plansumamryindex: number) {
    let selectedPlans = JSON.parse(
      sessionStorage.getItem('selectedPlans') || '{}'
    );
    //console.log(selectedPlans)
    selectedPlans[planid] = plansumamryindex;

    sessionStorage.setItem('selectedPlans', JSON.stringify(selectedPlans));
  }

  public unselectplanblock3(
    elementcv: any,
    packname: any,
    grpname: any,
    subgrpname: any,
    packageindex: number,
    groupindex: number,
    subgroupindex: number,
    packageIndex: number,
    groupIndex: number,
    subgroupIndex: number
  ) {

    let plandetails = elementcv.attributes.data.value;

    let plandetailsobj = plandetails.split('##');

    // console.log(plandetailsobj)
    let obj = {
      packageid: plandetailsobj[2],
      parentId: plandetailsobj[3],
      subGroupId: plandetailsobj[4],
      orderId: plandetailsobj[8],
      packagename: packname,
      groupname: grpname,
      subGrpname: subgrpname,
      tiers: [],
      packageindex: packageindex,
      groupindex: groupindex,
      subgroupindex: subgroupindex,
      packageIndex: packageindex, //packageIndex,
      groupIndex: groupindex, //groupIndex,
      subgroupIndex: subgroupindex //subgroupIndex,
    };

    if (obj.parentId == '15') {
      this.block3coverage = true;
    }
    if (plandetailsobj[1] != null || plandetailsobj[1] != 'null') {
      if (plandetailsobj[1].includes(plandetailsobj[2])) {
      }
    }

    this.removesummaryBlock3(obj);
  }

  public removesummaryBlock3(obj: any) {
    // console.log("remove")

    // console.log(obj)

    let summaryBlock3 = JSON.parse(
      sessionStorage.getItem('summaryBlock3') || '[]'
    );
    let selectedBlock3 = JSON.parse(
      sessionStorage.getItem('selectedBlock3') || '{}'
    );
    // console.log(summaryBlock2)

    if (selectedBlock3[obj.packageid]) {
      if (selectedBlock3[obj.packageid][obj.parentId]) {
        delete selectedBlock3[obj.packageid][obj.parentId];

        // console.log(selectedBlock3[obj.packageid][obj.parentId])
      } else {
        // console.log("firstelse")
        selectedBlock3[obj.packageid][obj.parentId] = [];
      }
    } else {
      // console.log("secondelse")
      selectedBlock3[obj.packageid] = {};
      selectedBlock3[obj.packageid][obj.parentId] = [];
    }

    // var selectedPlanLevel={"id":obj.subGroupId, "order":obj.orderId}
    // selectedBlock1[obj.packageid][obj.parentId].push(selectedPlanLevel)

    // selectedBlock1.splice(obj.parentId)

    // console.log(selectedBlock2)

    // sessionStorage.setItem('selectedBlock2', JSON.stringify(selectedBlock3));
    if (summaryBlock3) {
      let index = this.getslectedplansblock3(obj.subGroupId);

      if (index > -1) {
        summaryBlock3.splice(index, 1);



        // if (
        //   !this.plansresblack3[obj.packageindex] ||
        //   this.plansresblack3[obj.packageindex]['groups'] ||
        //   this.plansresblack3[obj.packageindex]['groups'][obj.groupindex] ||
        //   this.plansresblack3[obj.packageindex]['groups'][obj.groupindex][
        //     'subGroups'
        //   ]
        // ) {

        console.log(
          this.plansresblack3[obj.packageindex]['groups'][obj.groupindex][
          'subGroups'
          ][obj.subgroupindex]
        );

        // this.plansresblack3[obj.packageindex]['groups'][obj.groupindex]['subGroups'][
        //   obj.subgroupindex
        // ]['checked'] = false;
        console.log(obj)

        if (this.plansresblack3[obj.packageIndex]['groups'][obj.groupIndex][
          'subGroups'
        ][obj.subgroupIndex]) {
          this.plansresblack3[obj.packageIndex]['groups'][obj.groupIndex][
            'subGroups'
          ][obj.subgroupIndex]['tiers'] = [];
          this.plansresblack3[obj.packageIndex]['groups'][obj.groupIndex][
            'subGroups'
          ][obj.subgroupIndex]['checked'] = false;


          if (
            this.plansresblack3[obj.packageIndex]['groups'][obj.groupIndex][
            'subGroups'
            ][obj.subgroupIndex]['name'] == 'Executive Health'
          ) {



            $('#executiveplansblock3single' + obj.subGroupId).prop(
              'checked',
              false
            );
            $('#executiveplansblock3couple' + obj.subGroupId).prop(
              'checked',
              false
            );
            $('#executiveplansblock3family' + obj.subGroupId).prop(
              'checked',
              false
            );
            $('#executiveplansblock3single' + obj.subGroupId).prop(
              'disabled',
              true
            );
            $('#executiveplansblock3couple' + obj.subGroupId).prop(
              'disabled',
              true
            );
            $('#executiveplansblock3family' + obj.subGroupId).prop(
              'disabled',
              true
            );
          }

          if (
            this.plansresblack3[obj.packageIndex]['groups'][obj.groupIndex][
            'subGroups'
            ][obj.subgroupIndex]['name'] == 'Complete Executive Care'
          ) {


            $('#executiveplansblock3single' + obj.subGroupId).prop(
              'checked',
              false
            );
            $('#executiveplansblock3couple' + obj.subGroupId).prop(
              'checked',
              false
            );
            $('#executiveplansblock3family' + obj.subGroupId).prop(
              'checked',
              false
            );
            $('#executiveplansblock3single' + obj.subGroupId).prop(
              'disabled',
              true
            );
            $('#executiveplansblock3couple' + obj.subGroupId).prop(
              'disabled',
              true
            );
            $('#executiveplansblock3family' + obj.subGroupId).prop(
              'disabled',
              true
            );
          }
          if (
            this.plansresblack3[obj.packageIndex]['groups'][obj.groupIndex][
            'subGroups'
            ][obj.subgroupIndex]['name'] == 'Provincial Health Replacement Plan'
          ) {


            $('#executiveplansblock3single' + obj.subGroupId).prop(
              'checked',
              false
            );
            $('#executiveplansblock3couple' + obj.subGroupId).prop(
              'checked',
              false
            );
            $('#executiveplansblock3family' + obj.subGroupId).prop(
              'checked',
              false
            );
            $('#executiveplansblock3single' + obj.subGroupId).prop(
              'disabled',
              true
            );
            $('#executiveplansblock3couple' + obj.subGroupId).prop(
              'disabled',
              true
            );
            $('#executiveplansblock3family' + obj.subGroupId).prop(
              'disabled',
              true
            );
          }
        }
        // }
      } else {
        return;
      }

      var newselectedplans: any = {};
      for (var i = 0; i < summaryBlock3.length; i++) {
        newselectedplans[summaryBlock3[i].subGroupId] = i;
      }

      sessionStorage.setItem('selectedPlans', JSON.stringify(newselectedplans));

      this.planssummarymain = [];
      this.planssummaryopt = [];

      summaryBlock3.forEach((element: any) => {
        if (element.packagename != 'Opt-in') {
          this.planssummarymain.push(element);
        } else {
          this.planssummaryopt.push(element);
        }
      });

      // let el1: HTMLElement = this.employeepurchasefalse.nativeElement;
      // el1.click();

      sessionStorage.setItem(
        'summaryBlock3main',
        JSON.stringify(this.planssummarymain)
      );
      sessionStorage.setItem(
        'summaryBlock3opt',
        JSON.stringify(this.planssummaryopt)
      );

      sessionStorage.setItem('summaryBlock3', JSON.stringify(summaryBlock3));
    }
  }


  public selectplanblock2(
    elementcv: any,
    packname: any,
    grpname: any,
    subgrpname: any,
    packageindex: number,
    groupindex: number,
    subgroupindex: number,
    subgroup: any,
    disallowedPlanLevels: any
  ) {
    let plandetails = elementcv.attributes.data.value;

    let plandetailsobj = plandetails.split('##');

    // console.log(plandetailsobj)

    let obj = {
      packageid: plandetailsobj[2],
      parentId: plandetailsobj[3],
      subGroupId: plandetailsobj[4],
      orderId: plandetailsobj[8],
      packagename: packname,
      groupname: grpname,
      subGrpname: subgrpname,
      tiers: [],
      packageindex: packageindex,
      groupindex: groupindex,
      subgroupindex: subgroupindex,
      coverage: '',
      settingsAdditional: subgroup?.settingsAdditional || {},
      disallowedPlanLevels: disallowedPlanLevels

    };

    // console.log(obj)

    this.addtosummaryBlock2(obj);
  }

  public addtosummaryBlock2(obj: any) {
    let summaryBlock2 = JSON.parse(
      sessionStorage.getItem('summaryBlock2') || '[]'
    );
    let summaryBlock3 = JSON.parse(
      sessionStorage.getItem('summaryBlock3') || '[]'
    );
    let selectedBlock2 = JSON.parse(
      sessionStorage.getItem('selectedBlock2') || '{}'
    );

    let mainresults = JSON.parse(
      sessionStorage.getItem('mainresults') || '{}'
    );

    this.addtoslectplansblock2(obj.subGroupId, summaryBlock2.length);
    summaryBlock2.push(obj);

    this.planssummarymain = [];
    this.planssummaryopt = [];

    summaryBlock2.forEach((element: any) => {
      if (element.packagename != 'Opt-in') {
        this.planssummarymain.push(element);
      } else {
        this.planssummaryopt.push(element);
      }

      if (!this.packagePlanLevelTiers[element.packagename]) {
        this.packagePlanLevelTiers[element.packagename] = [];
      }
      const exists =
        this.packagePlanLevelTiers[element.packagename].findIndex(
          (item) => item.subGroupId === element.subGroupId
        ) > -1;
      if (exists) {
        console.log('check');
      } else {
        this.packagePlanLevelTiers[element.packagename].push(element);
      }
    });

    if (selectedBlock2[obj.packageid]) {
      if (selectedBlock2[obj.packageid][obj.parentId]) {
        // console.log(selectedBlock2[obj.packageid][obj.parentId])
      } else {
        // console.log("firstelse")
        selectedBlock2[obj.packageid][obj.parentId] = [];
      }
    } else {
      // console.log("secondelse")
      selectedBlock2[obj.packageid] = {};
      selectedBlock2[obj.packageid][obj.parentId] = [];
    }

    //now push
    var selectedPlanLevel = { id: obj.subGroupId, order: obj.orderId };
    selectedBlock2[obj.packageid][obj.parentId].push(selectedPlanLevel);

    let subGroupIdindex;

    if (summaryBlock3 && summaryBlock3.length > 0) {
      for (let i = 0; i < summaryBlock3.length; i++) {
        if (summaryBlock3[i].subGroupId == obj.subGroupId) {
          subGroupIdindex = i;

          break;
        }
      }

      if (subGroupIdindex > -1) {
        summaryBlock3.splice(subGroupIdindex, 1);
      } else {
        console.log('check1');
      }
    }

    let selectedplansblock3;
    setTimeout(() => {
      sessionStorage.setItem('summaryBlock3', JSON.stringify(summaryBlock3));

    }, 50);
    setTimeout(() => {
      selectedplansblock3 = JSON.parse(
        sessionStorage.getItem('summaryBlock3') || '[]'
      );
    }, 100);




    // let el: HTMLElement = this.employeepurchasefalse.nativeElement;
    // el.click();

    // sessionStorage.setItem('selectedBlock2', JSON.stringify(selectedBlock2));
    sessionStorage.setItem(
      'summaryBlock2main',
      JSON.stringify(this.planssummarymain)
    );
    sessionStorage.setItem(
      'summaryBlock2opt',
      JSON.stringify(this.planssummaryopt)
    );

    sessionStorage.setItem('summaryBlock2', JSON.stringify(summaryBlock2));



    this.selectedplansblock1 = JSON.parse(
      sessionStorage.getItem('summaryBlock2') || '[]'
    );
    // this.plansresblack2--mainresults
    mainresults[obj.packageindex]['groups'][obj.groupindex][
      'subGroups'
    ][obj.subgroupindex]['checked'] = true;

    if (
      mainresults[obj.packageindex]['groups'][obj.groupindex][
      'subGroups'
      ][obj.subgroupindex]['name'] == 'Executive Health'
    ) {
      $('#executiveplansblock2single' + obj.subGroupId).prop('disabled', false);
      $('#executiveplansblock2couple' + obj.subGroupId).prop('disabled', false);
      $('#executiveplansblock2family' + obj.subGroupId).prop('disabled', false);

      $('#executiveplansblock2single' + obj.subGroupId).click()
      $('#executiveplansblock2couple' + obj.subGroupId).click()
      $('#executiveplansblock2family' + obj.subGroupId).click()
    }
    if (
      mainresults[obj.packageindex]['groups'][obj.groupindex][
      'subGroups'
      ][obj.subgroupindex]['name'] == 'Complete Executive Care'
    ) {
      $('#executiveplansblock2single' + obj.subGroupId).prop('disabled', false);
      $('#executiveplansblock2couple' + obj.subGroupId).prop('disabled', false);
      $('#executiveplansblock2family' + obj.subGroupId).prop('disabled', false);
      $('#executiveplansblock2single' + obj.subGroupId).click()
      $('#executiveplansblock2couple' + obj.subGroupId).click()
      $('#executiveplansblock2family' + obj.subGroupId).click()
    }
    if (
      mainresults[obj.packageindex]['groups'][obj.groupindex][
      'subGroups'
      ][obj.subgroupindex]['name'] == 'Provincial Health Replacement Plan'
    ) {
      $('#executiveplansblock2single' + obj.subGroupId).prop('disabled', false);
      $('#executiveplansblock2couple' + obj.subGroupId).prop('disabled', false);
      $('#executiveplansblock2family' + obj.subGroupId).prop('disabled', false);
      $('#executiveplansblock2single' + obj.subGroupId).click()
      $('#executiveplansblock2couple' + obj.subGroupId).click()
      $('#executiveplansblock2family' + obj.subGroupId).click()
    }
    // if (this.employeeplanpurchase == true) {
    //   // let el: HTMLElement = this.employeepurchasefalse.nativeElement;
    //   // el.click();
    //   setTimeout(() => {
    //     let el1: HTMLElement = this.employeepurchasetrue.nativeElement;
    //     el1.click();
    //     setTimeout(() => {
    //       const dom: HTMLElement = this.elementRef.nativeElement;

    //       if (selectedplansblock3.length > 0) {
    //         let el1: HTMLElement = this.employeepurchasetrue.nativeElement;
    //         el1.click();
    //         this.employeeplanpurchase == true;
    //         setTimeout(() => {
    //           for (let i = 0; i < selectedplansblock3.length; i++) {
    //             const element2: any = dom.querySelector(
    //               '#plancheck3Voluntry' + selectedplansblock3[i].subGroupId
    //             );
    //             // element2.checked = true;
    //             $("#plancheck3Voluntry" + selectedplansblock3[i].subGroupId).prop("checked", true);

    //           }
    //         }, 1500);
    //       }
    //     }, 1000);
    //   }, 100);
    // }
    if (this.employeeplanpurchase == true) {
      // let el: HTMLElement = this.employeepurchasefalse.nativeElement;
      // el.click();
      setTimeout(() => {
        let el1: HTMLElement = this.employeepurchasetrue.nativeElement;
        el1.click();
        setTimeout(() => {
          const dom: HTMLElement = this.elementRef.nativeElement;

          if (selectedplansblock3.length > 0) {
            let el1: HTMLElement = this.employeepurchasetrue.nativeElement;
            el1.click();
            this.employeeplanpurchase == true;
            setTimeout(() => {
              for (let i = 0; i < selectedplansblock3.length; i++) {
                const element2: any = dom.querySelector(
                  '#plancheck3Voluntry' + selectedplansblock3[i].subGroupId
                );
                // element2.checked = true;
                $("#plancheck3Voluntry" + selectedplansblock3[i].subGroupId).prop("checked", true);

                if (selectedplansblock3[i].disallowedPlanLevels != null) {
                  let disallowed_plans = selectedplansblock3[i].disallowedPlanLevels.split(',');
                  const dom1: HTMLElement = this.elementRef.nativeElement;
                  for (let i = 0; i < disallowed_plans.length; i++) {

                    setTimeout(() => {
                      let elem: any = dom1.querySelector(`#plancheck3Voluntry${disallowed_plans[i]}`)

                      if (elem != null) {
                        if (!elem.disabled) {

                          elem.disabled = true
                        }
                      }
                    }, 100);

                  }
                }

              }
            }, 1000);
          }
        }, 1000);
      }, 100);
    }
    sessionStorage.setItem('mainresults', JSON.stringify(mainresults));

    this.plansNewBlock2 = JSON.parse(
      sessionStorage.getItem('block2result') || '[]'
    );

    var res = JSON.parse(sessionStorage.getItem('block2result') || '[]');

    this.plansNewBlock2.map((packagelevel: any, index: any) => {

      if (!packagelevel) {

      }
      else {
        packagelevel.groups.map((groups: any, index1: any) => {
          this.selectedplansblock1.map((selectplan: any) => {
            if (
              packagelevel.id == selectplan.packageid &&
              packagelevel.groups.id == selectplan.parentid
            ) {

              if (
                !this.plansNewBlock2[index] ||
                !this.plansNewBlock2[index]['groups'] ||
                !this.plansNewBlock2[index]['groups'][index1] ||
                !this.plansNewBlock2[index]['groups'][index1]['subGroups']
              ) {
              }
              else {

                console.log("!")
                var allAvailble =
                  this.plansNewBlock2[index]['groups'][index1]['subGroups'];

                console.log(allAvailble)

                allAvailble.map((element1: any, index2: any) => {
                  if (element1 != null) {
                    if (element1.disallowedPlanLevels) {
                      if (element1.id == selectplan.subGroupId) {

                        console.log("check here data")
                        res.map((res1: any, index4: any) => {

                          if (!res[index4] || !res[index4]['groups'][index]) {

                          }
                          else {
                            res1.groups.map((groups1: any, index5: any) => {
                              console.log(groups1)
                              groups1.subGroups.forEach(
                                (subgrp: any, index6: any) => {
                                  console.log(element1.disallowedPlanLevels);
                                  if (
                                    element1.disallowedPlanLevels.indexOf(
                                      groups1.id
                                    ) > -1
                                  ) {

                                    if (
                                      !this.plansresblack2[index4] ||
                                      !this.plansresblack2[index4]['groups'] ||
                                      !this.plansresblack2[index4]['groups'][index5] ||
                                      !this.plansresblack2[index4]['groups'][index5]['subGroups']
                                    ) {
                                    }
                                    else {
                                      console.log(this.plansresblack2)
                                      // this.plansresblack2[index4]['groups'][index5][
                                      //   'subGroups'
                                      // ][index6]['tiers'] = [];
                                      // this.plansresblack2[index4]['groups'][index5][
                                      //   'subGroups'
                                      // ][index6]['checked'] = false;

                                      res[index4]['groups'][index5]['subGroups'][
                                        index6
                                      ] = null;
                                    }


                                  }
                                }
                              );
                            });
                          }
                        });
                      }
                    }
                  }
                });
              }
            }
          });
        });
      }

    });
    // this.plansNewBlock2.forEach((packagelevel: any, index: any) => {
    //   packagelevel.groups.forEach((groups: any, index1: any) => {
    //     this.selectedplansblock1.forEach((selectplan: any) => {
    //       if (
    //         packagelevel.id == selectplan.packageid &&
    //         packagelevel.groups.id == selectplan.parentid
    //       ) {

    //         if (
    //           !this.plansNewBlock2[index]['groups'] || !this.plansNewBlock2[index]['groups'][index1] || !this.plansNewBlock2[index]['groups'][index1]['subGroups']

    //         ) {
    //         }

    //         else{
    //           var allAvailble = this.plansNewBlock2[index]['groups'][index1]['subGroups'];

    //         console.log(allAvailble);

    //         // allAvailble.forEach((element1: any, index2: any) => {
    //         //   if (element1 != null) {
    //         //     if (element1.disallowedPlanLevels) {
    //         //       if (element1.id == selectplan.subGroupId) {
    //         //         res.forEach((res1: any, index4: any) => {

    //         //           if( res1.groups !=null){

    //         //           res1.groups.forEach((groups1: any, index5: any) => {
    //         //             console.log(groups1)

    //         //             groups1.subGroups.forEach(
    //         //               (subgrp: any, index6: any) => {
    //         //                 console.log(element1.disallowedPlanLevels);
    //         //                 if (
    //         //                   element1.disallowedPlanLevels.indexOf(
    //         //                     groups1.id
    //         //                   ) > 0
    //         //                 ) {
    //         //                   res[index4]['groups'][index5]['subGroups'][
    //         //                     index6
    //         //                   ] = null;
    //         //                 }
    //         //               }
    //         //             );

    //         //           });
    //         //         }
    //         //         });
    //         //       }
    //         //     }
    //         //   }
    //         // });
    //         }

    //       }
    //     });
    //   });
    // });
    console.log(res)
    sessionStorage.setItem('block2result', JSON.stringify(res));
  }

  public addtoslectplansblock2(planid: number, plansumamryindex: number) {
    let selectedPlans = JSON.parse(
      sessionStorage.getItem('selectedPlans') || '{}'
    );
    //console.log(selectedPlans)
    selectedPlans[planid] = plansumamryindex;

    sessionStorage.setItem('selectedPlans', JSON.stringify(selectedPlans));
  }

  public unselectplanblock2(
    elementcv: any,
    packname: any,
    grpname: any,
    subgrpname: any,
    packageindex: number,
    groupindex: number,
    subgroupindex: number,
    packageIndex: number,
    groupIndex: number,
    subgroupIndex: number
  ) {
    let plandetails = elementcv.attributes.data.value;

    let plandetailsobj = plandetails.split('##');

    // console.log(plandetailsobj)

    let obj = {
      packageid: plandetailsobj[2],
      parentId: plandetailsobj[3],
      subGroupId: plandetailsobj[4],
      orderId: plandetailsobj[8],
      packagename: packname,
      groupname: grpname,
      subGrpname: subgrpname,
      tiers: [],
      packageindex: packageindex,
      groupindex: groupindex,
      subgroupindex: subgroupindex,
      packageIndex: packageIndex,
      groupIndex: groupIndex,
      subgroupIndex: subgroupIndex,
    };

    // if(obj.parentId =='15'){
    //   this.block2coverage =true
    // }

    if (plandetailsobj[1] != null || plandetailsobj[1] != 'null') {
      if (plandetailsobj[1].includes(plandetailsobj[2])) {
      }
    }

    this.removesummaryBlock2(obj);
  }


  public removesummaryBlock2(obj: any) {
    console.log(obj);

    let summaryBlock2 = JSON.parse(
      sessionStorage.getItem('summaryBlock2') || '[]'
    );
    let selectedBlock2 = JSON.parse(
      sessionStorage.getItem('selectedBlock2') || '{}'
    );
    let mainresults = JSON.parse(
      sessionStorage.getItem('mainresults') || '{}'
    );
    // console.log(summaryBlock2)

    // if (selectedBlock2[obj.packageid]) {
    //   if (selectedBlock2[obj.packageid][obj.parentId]) {
    //     delete selectedBlock2[obj.packageid][obj.parentId];

    //     // console.log(selectedBlock2[obj.packageid][obj.parentId])
    //   } else {
    //     // console.log("firstelse")
    //     selectedBlock2[obj.packageid][obj.parentId] = [];
    //   }
    // }

    // else {
    //   // console.log("secondelse")
    //   selectedBlock2[obj.packageid] = {};
    //   selectedBlock2[obj.packageid][obj.parentId] = [];
    // }

    if (summaryBlock2 && summaryBlock2.length > 0) {

      console.log("TestHere")
      let index = this.getslectedplansblock2(obj.subGroupId);

      console.log(index)

      if (index > -1) {
        console.log(obj);
        summaryBlock2.splice(index, 1);

        // if (!this.packagePlanLevelTiers[obj.packagename]) {
        //   this.packagePlanLevelTiers[obj.packagename] = [];
        // }

        // this.packagePlanLevelTiers[obj.packagename].splice(obj, 1);

        // sessionStorage.setItem(
        //   'packagePlanLevelTiers',
        //   JSON.stringify(this.packagePlanLevelTiers) || '[]'
        // );


        console.log(obj.packageIndex);
        console.log(obj.groupIndex);
        console.log(this.plansresblack2);

        // this.plansresblack2 = JSON.parse(sessionStorage.getItem('block2result') || '[]');

        if (obj.packageIndex >= 0 && obj.groupIndex >= 0 && obj.subgroupIndex >= 0) {
          mainresults[obj.packageIndex]['groups'][obj.groupIndex][
            'subGroups'
          ][obj.subgroupIndex]['tiers'] = [];
          mainresults[obj.packageIndex]['groups'][obj.groupIndex][
            'subGroups'
          ][obj.subgroupIndex]['checked'] = false;

          if (
            mainresults[obj.packageIndex]['groups'][obj.groupIndex][
            'subGroups'
            ][obj.subgroupIndex]['name'] == 'Executive Health'
          ) {




            $('#executiveplansblock2single' + obj.subGroupId).prop(
              'checked',
              false
            );
            $('#executiveplansblock2couple' + obj.subGroupId).prop(
              'checked',
              false
            );
            $('#executiveplansblock2family' + obj.subGroupId).prop(
              'checked',
              false
            );
            $('#executiveplansblock2single' + obj.subGroupId).prop(
              'disabled',
              true
            );
            $('#executiveplansblock2couple' + obj.subGroupId).prop(
              'disabled',
              true
            );
            $('#executiveplansblock2family' + obj.subGroupId).prop(
              'disabled',
              true
            );
            let summaryBlock1 = JSON.parse(
              sessionStorage.getItem('summaryBlock1') || '[]'
            );


            sessionStorage.setItem('block2result', JSON.stringify(this.plansresblack2));

          }

          if (
            mainresults[obj.packageIndex]['groups'][obj.groupIndex][
            'subGroups'
            ][obj.subgroupIndex]['name'] == 'Complete Executive Care'
          ) {
            // this.plansresblack2[obj.packageIndex]['groups'][obj.groupIndex][
            //   'subGroups'
            // ][obj.subgroupIndex]['coverage'] = 'default';




            $('#executiveplansblock2single' + obj.subGroupId).prop(
              'checked',
              false
            );
            $('#executiveplansblock2couple' + obj.subGroupId).prop(
              'checked',
              false
            );
            $('#executiveplansblock2family' + obj.subGroupId).prop(
              'checked',
              false
            );
            $('#executiveplansblock2single' + obj.subGroupId).prop(
              'disabled',
              true
            );
            $('#executiveplansblock2couple' + obj.subGroupId).prop(
              'disabled',
              true
            );
            $('#executiveplansblock2family' + obj.subGroupId).prop(
              'disabled',
              true
            );
            sessionStorage.setItem('block2result', JSON.stringify(this.plansresblack2));

          }
          if (
            mainresults[obj.packageIndex]['groups'][obj.groupIndex][
            'subGroups'
            ][obj.subgroupIndex]['name'] == 'Provincial Health Replacement Plan'
          ) {
            // this.plansresblack2[obj.packageIndex]['groups'][obj.groupIndex][
            //   'subGroups'
            // ][obj.subgroupIndex]['coverage'] = 'default';




            $('#executiveplansblock2single' + obj.subGroupId).prop(
              'checked',
              false
            );
            $('#executiveplansblock2couple' + obj.subGroupId).prop(
              'checked',
              false
            );
            $('#executiveplansblock2family' + obj.subGroupId).prop(
              'checked',
              false
            );
            $('#executiveplansblock2single' + obj.subGroupId).prop(
              'disabled',
              true
            );
            $('#executiveplansblock2couple' + obj.subGroupId).prop(
              'disabled',
              true
            );
            $('#executiveplansblock2family' + obj.subGroupId).prop(
              'disabled',
              true
            );
            sessionStorage.setItem('block2result', JSON.stringify(this.plansresblack2));

          }
        }

        sessionStorage.setItem(
          'mainresults',
          JSON.stringify(mainresults)
        );
      } else {
        return;
      }

      var newselectedplans: any = {};
      for (var i = 0; i < summaryBlock2.length; i++) {
        newselectedplans[summaryBlock2[i].subGroupId] = i;
      }

      sessionStorage.setItem('selectedPlans', JSON.stringify(newselectedplans));

      this.planssummarymain = [];
      this.planssummaryopt = [];

      summaryBlock2.forEach((element: any) => {
        if (element.packagename != 'Opt-in') {
          this.planssummarymain.push(element);
        } else {
          this.planssummaryopt.push(element);
        }
      });

      let selectedplansblock2 = JSON.parse(
        sessionStorage.getItem('summaryBlock2') || '[]'
      );
      let selectedplansblock3 = JSON.parse(
        sessionStorage.getItem('summaryBlock3') || '[]'
      );


      console.log(this.employeeplanpurchase)
      if (this.employeeplanpurchase == true) {

        // console.log("1")
        // let el: HTMLElement = this.employeepurchasefalse.nativeElement;
        // el.click();
        setTimeout(() => {
          let el1: HTMLElement = this.employeepurchasetrue.nativeElement;
          el1.click();
          setTimeout(() => {
            const dom: HTMLElement = this.elementRef.nativeElement;
            if (selectedplansblock3.length > 0) {
              let el1: HTMLElement = this.employeepurchasetrue.nativeElement;
              el1.click();
              this.employeeplanpurchase == true;
              setTimeout(() => {
                for (let i = 0; i < selectedplansblock3.length; i++) {
                  const element2: any = dom.querySelector(
                    '#plancheck3Voluntry' + selectedplansblock3[i].subGroupId
                  );
                  // element2.checked = true;
                  // element2.click()
                  element2.prop('checked', true);
                }
              }, 1500);
            }
          }, 1000);
        }, 100);
      }

      sessionStorage.setItem(
        'summaryBlock2main',
        JSON.stringify(this.planssummarymain)
      );
      sessionStorage.setItem(
        'summaryBlock2opt',
        JSON.stringify(this.planssummaryopt)
      );

      sessionStorage.setItem('summaryBlock2', JSON.stringify(summaryBlock2));
    }
    this.plansNewBlock2 = JSON.parse(
      sessionStorage.getItem('block2result') || '[]'
    );

    var res = JSON.parse(sessionStorage.getItem('planResults') || '[]');

    this.plansNewBlock2.map((packagelevel: any, index: any) => {
      if (!packagelevel) {

      }
      else {
        packagelevel.groups.map((groups: any, index1: any) => {
          this.selectedplansblock1.map((selectplan: any) => {
            if (
              packagelevel.id == selectplan.packageid &&
              packagelevel.groups.id == selectplan.parentid
            ) {


              if (
                !this.plansNewBlock2[index] ||
                !this.plansNewBlock2[index]['groups'] ||
                !this.plansNewBlock2[index]['groups'][index1] ||
                !this.plansNewBlock2[index]['groups'][index1]['subGroups']
              ) {
              }
              else {
                var allAvailble =
                  this.plansNewBlock2[index]['groups'][index1]['subGroups'];

                allAvailble.map((element1: any, index2: any) => {
                  if (element1 != null) {

                    console.log(element1.disallowedPlanLevels)
                    if (element1.disallowedPlanLevels) {
                      console.log(element1.id)
                      console.log(obj.subGroupId)
                      if (element1.id == obj.subGroupId) {

                        console.log(element1.id)
                        console.log(obj.subGroupId)
                        res.map((res1: any, index4: any) => {
                          if (!res[index4] || !res[index4]['groups'][index]) {

                          } else {
                            res1.groups.map((groups1: any, index5: any) => {
                              // console.log(groups1)
                              groups1.subGroups.forEach(
                                (subgrp: any, index6: any) => {
                                  console.log(subgrp);
                                  if (
                                    element1.disallowedPlanLevels.indexOf(
                                      groups1.id
                                    ) > -1
                                  ) {
                                    if (
                                      !this.plansresblack2[index4] ||
                                      !this.plansresblack2[index4]['groups'] ||
                                      !this.plansresblack2[index4]['groups'][index5] ||
                                      !this.plansresblack2[index4]['groups'][index5]['subGroups']
                                    ) {
                                    }
                                    else {
                                      // this.plansresblack2[index4]['groups'][index5][
                                      //   'subGroups'
                                      // ][index6]['tiers'] = [];
                                      // this.plansresblack2[index4]['groups'][index5][
                                      //   'subGroups'
                                      // ][index6]['checked'] = false;

                                      res[index4]['groups'][index5]['subGroups'][
                                        index6
                                      ] = subgrp;
                                    }
                                  }
                                }
                              );
                            });
                          }
                        });
                        sessionStorage.setItem('block2result', JSON.stringify(this.plansresblack2));

                      }
                    }
                  }
                });
              }
            }
          });
        });
      }
    });
  }

  public getslectedplansblock1(planid: number) {
    //console.log(planid)
    // let selectedPlans = JSON.parse(
    //   sessionStorage.getItem('selectedPlans') || '{}'
    // );
    // // console.log(selectedPlans)
    // return selectedPlans[planid];


    console.log(planid)
    let summaryBlock1 = JSON.parse(
      sessionStorage.getItem('summaryBlock1') || '{}'
    );
    let subGroupIdindex;
    for (let i = 0; i < summaryBlock1.length; i++) {
      console.log(summaryBlock1[i].subGroupId)
      console.log(planid)
      if (summaryBlock1[i].subGroupId == planid) {
        subGroupIdindex = i;
        break;
      }
    }

    return subGroupIdindex;
  }

  public getslectedplansblock2(planid: number) {
    //console.log(planid)
    // let selectedPlans = JSON.parse(
    //   sessionStorage.getItem('selectedPlans') || '{}'
    // );
    // // console.log(selectedPlans)
    // return selectedPlans[planid];


    console.log(planid)
    let summaryBlock2 = JSON.parse(
      sessionStorage.getItem('summaryBlock2') || '{}'
    );
    let subGroupIdindex;
    for (let i = 0; i < summaryBlock2.length; i++) {
      console.log(summaryBlock2[i].subGroupId)
      console.log(planid)
      if (summaryBlock2[i].subGroupId == planid) {
        subGroupIdindex = i;
        break;
      }
    }

    return subGroupIdindex;
  }
  public getslectedplansblock3(planid: number) {
    //console.log(planid)
    // let selectedPlans = JSON.parse(
    //   sessionStorage.getItem('selectedPlans') || '{}'
    // );
    // // console.log(selectedPlans)
    // return selectedPlans[planid];


    console.log(planid)
    let summaryBlock3 = JSON.parse(
      sessionStorage.getItem('summaryBlock3') || '{}'
    );
    let subGroupIdindex;
    for (let i = 0; i < summaryBlock3.length; i++) {
      console.log(summaryBlock3[i].subGroupId)
      console.log(planid)
      if (summaryBlock3[i].subGroupId == planid) {
        subGroupIdindex = i;
        break;
      }
    }

    return subGroupIdindex;
  }
  public getslectedblockplans(obj: any) {
    //console.log(planid)
    let selectedPlans = JSON.parse(
      sessionStorage.getItem('selectedBlock1') || '{}'
    );

    if (selectedPlans[obj.packageid]) {
      if (selectedPlans[obj.packageid][obj.parentId]) {
        var res = selectedPlans[obj.packageid][obj.parentId];

        res.forEach((element: any, index: any) => {
          if ((element.id = obj.subGroupId && element.order == obj.orderId)) {
            return selectedPlans[index];
          }
        });
      } else {
        // console.log("firstelse")
        selectedPlans[obj.packageid][obj.parentId] = [];
      }
    }
  }

  checkPaymentInfo(e: any) {
    if (e.target.value == 'pad') {
      this.bankDetails = false;
    } else {
      this.bankDetails = false;
    }
  }

  public provincelist1(event: any) {
    // alert(event.target.value)

    this.configprovinceres.forEach((element: any) => {
      if (element.shortName == event) {
        this.provincialHealthcareUrl = element.provincialHealthcareUrl;
        this.provincialZipcodes = element.zipcodes.split(',');
        this.provincelistid = element.id;
        this.state_id = parseInt(element.fusebillId);
        this.statename = element.name;
      }
    });

    if (this.clientregform.value.postalCode) {
      if (
        this.provincialZipcodes.indexOf(
          this.clientregform.value.postalCode[0]
        ) == -1
      ) {
        this.invalidpostalcodeprivince = true;

        this.client['postalCode'].markAsTouched();
        this.client['postalCode'].updateValueAndValidity();
      } else {
        this.invalidpostalcodeprivince = false;
        // console.log("test1")
      }

      if (this.clientregform.value.postalCode.length == 0) {
        this.invalidpostalcodeprivince = false;
        // console.log("test11")
      }
    }
  }
  public provincelist(event: any) {
    // alert(event.target.value)

    this.configprovinceres.forEach((element: any) => {
      if (element.shortName == event.target.value) {
        this.provincialHealthcareUrl = element.provincialHealthcareUrl;
        this.provincialZipcodes = element.zipcodes.split(',');
        this.provincelistid = element.id;
        this.state_id = parseInt(element.fusebillId);
        this.statename = element.name;
      }
    });

    if (this.clientregform.value.postalCode) {
      if (
        this.provincialZipcodes.indexOf(
          this.clientregform.value.postalCode[0]
        ) == -1
      ) {
        this.invalidpostalcodeprivince = true;

        this.client['postalCode'].markAsTouched();
        this.client['postalCode'].updateValueAndValidity();
      } else {
        this.invalidpostalcodeprivince = false;
        // console.log("test1")
      }

      if (this.clientregform.value.postalCode.length == 0) {
        this.invalidpostalcodeprivince = false;
        // console.log("test11")
      }
    }
  }
  public provincelistwaddell(event: any) {
    // alert(event.target.value)

    this.configprovinceres.forEach((element: any) => {
      if (element.shortName == event.target.value) {
        this.provincialHealthcareUrl = element.provincialHealthcareUrl;
        this.provincialZipcodes = element.zipcodes.split(',');
        this.provincelistid = element.id;
        this.state_id = parseInt(element.fusebillId);
        this.statename = element.name;
      }
    });


    console.log(this.addEmployeeformListwaddell.value.employeePostalCode)
    console.log(this.provincialZipcodes)
    if (this.addEmployeeformListwaddell.value.employeePostalCode) {
      if (
        this.provincialZipcodes.indexOf(
          this.addEmployeeformListwaddell.value.employeePostalCode[0]
        ) == -1
      ) {

        this.invalidpostalcodeprivincewaddell = true;

        this.empwaddell['employeePostalCode'].markAsTouched();
        this.empwaddell['employeePostalCode'].updateValueAndValidity();
      } else {
        this.invalidpostalcodeprivincewaddell = false;
        // console.log("test1")
      }

      if (this.addEmployeeformListwaddell.value.employeePostalCode.length == 0) {
        this.invalidpostalcodeprivincewaddell = false;
        // console.log("test11")
      }
    }
  }
  public getprovincelist(event: any) {
    if (event.target.value.toLowerCase() == 'canada') {
      this.postalCodeDisplay = this.lang.Postal_Code;
      this.provianceDispaly = this.lang.Province;
      this.selectedCountry = 'Canada';
      this.clientregform.get('postalCode').setValidators([postalcodeValidator]);
      this.clientregform.get('postalCode').updateValueAndValidity();
      this.clientregform
        .get('multiSelectProviance')
        .setValidators([Validators.required]);
      this.clientregform.get('multiSelectProviance').updateValueAndValidity();
      this.isCountrySelected = true;
    } else {
      this.postalCodeDisplay = this.lang.Zip_Code;
      this.provianceDispaly = this.lang.State;
      this.selectedCountry = 'USA';
      this.clientregform.get('postalCode').reset();
      this.clientregform.get('postalCode').clearValidators();
      this.clientregform.get('postalCode').updateValueAndValidity();
      this.invalidpostalcodeprivince = false;
      this.clientregform.get('multiSelectProviance').clearValidators();
      this.clientregform.get('multiSelectProviance').updateValueAndValidity();
      this.multiSelectProviance = [];
      this.isCountrySelected = true;
    }

    this.countryList.forEach((element: any) => {
      if (element.name == event.target.value) {
        this.configprovincereslist = element.countryStates;
        this.configprovincereslist = [...this.configprovincereslist].sort(
          (a: any, b: any) => (a.shortName > b.shortName ? 1 : -1)
        );
      }
    });
  }
  public getprovincelist1(event: any) {
    // alert("!")

    this.countryList.forEach((element: any) => {
      if (element.name == event) {
        console.log(element)
        this.configprovincereslist = element.countryStates;
        this.configprovincereslist = [...this.configprovincereslist].sort(
          (a: any, b: any) => (a.shortName > b.shortName ? 1 : -1)
        );
        this.configprovincereslist.forEach((element1: any) => {
          if (element1.name == this.customerData.province) {
            this.customerData.province = element1.shortName
            this.clientregform.patchValue({

              Province: element1.shortName,


            });
          }
        })
      }
    });
  }
  changeTextToUppercase(field: any, event: any) {
    if (this.selectedCountry == 'USA') {
      return false;
    } else {
      console.log(field);
      const obj = {};
      // obj[field] = this.clientregform.controls[field].value.toUpperCase();
      // this.clientregform.patchValue(obj);

      this.postalvalue = event.target.value;

      console.log(this.postalvalue);

      if (this.provincialZipcodes?.indexOf(this.postalvalue[0]) == -1) {
        // console.log("r")
        this.invalidpostalcodeprivince = true;
        this.client['postalCode'].markAsTouched();
      } else {
        this.invalidpostalcodeprivince = false;
      }

      if (this.postalvalue.length == 0) {
        this.invalidpostalcodeprivince = false;
      }

      console.log(this.invalidpostalcodeprivince);

      //  postalcodeValidator1(this.invalidpostalcodeprivince )
    }
  }
  changeTextToUppercasewaddell(field: any, event: any) {
    console.log(field);
    const obj = {};
    // obj[field] = this.clientregform.controls[field].value.toUpperCase();
    // this.clientregform.patchValue(obj);

    this.postalvalue = event.target.value;

    console.log(this.postalvalue);

    if (this.provincialZipcodes.indexOf(this.postalvalue[0]) == -1) {
      // console.log("r")
      this.invalidpostalcodeprivincewaddell = true;
      this.empwaddell['employeePostalCode'].markAsTouched();
    } else {
      this.invalidpostalcodeprivincewaddell = false;
    }

    if (this.postalvalue.length == 0) {
      this.invalidpostalcodeprivincewaddell = false;
    }

    console.log(this.invalidpostalcodeprivincewaddell);

    //  postalcodeValidator1(this.invalidpostalcodeprivince )
  }

  addRow() {
    this.basicTiersCount++;
    this.dynamicArray.push({
      sno: '',
      tierName: this.capitalize(''),
      walletAmount: '$',
    });
    // console.log('New row added successfully', 'New Row')
  }
  deleteRowBlock1(index: number, dynamic: any) {
    this.defaulttiers = [];
    if (this.dynamicArray.length == 1) {
      Swal.fire({
        title: 'Warning',
        text: "Can't delete the row when there is only one row",
      });
      return false;
    } else {
      if (dynamic.id && dynamic.id > 0) {
        this.defaulttiers.push(dynamic.id);
        let requestBody = {
          default: this.defaulttiers,
          lengthOfService: [],
          annualIncome: [],
        };

        var corporateId = sessionStorage.getItem('corporateId');

        var DeleteTiers =
          '/api/ap/admin/corporate/' + corporateId + '/deleteTiers';
        var accessToken = sessionStorage.getItem('accessToken');
        this.http
          .post(environment.apiUrl + DeleteTiers, requestBody, {
            headers: {
              Authorization: 'Bearer ' + accessToken,
              'Content-Type': 'application/json',
            },
          })
          .subscribe(
            (response: any) => {
              if (response.status == '200') {
                Swal.fire({
                  title: 'Success',
                  text: response.message,
                  showDenyButton: false,
                  showCancelButton: false,
                  confirmButtonText: 'Ok',
                }).then((result) => {
                  if (result.isConfirmed) {
                    this.configuretiers();
                  }
                });
              } else {
                Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message });
              }
            },
            (error) => {
              if (
                error.status == 400 ||
                error.status == 401 ||
                error.status == 402 ||
                error.status == 403
              ) {
                Swal.fire({
                  title: this.lang.Error ?? 'Error',
                  text: error.error.error.message,
                  showCancelButton: false,
                  showDenyButton: false,
                  confirmButtonText: 'Proceed',
                }).then((result) => {
                  /* Read more about isConfirmed, isDenied below */
                  if (result.isConfirmed) {
                    sessionStorage.clear();
                    this.router.navigate(['/login']);
                  } else {
                    sessionStorage.clear();
                    this.router.navigate(['/login']);
                  }
                });
              } else {
                // Swal.fire(error.error.error.message)
                Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
              }
              // this.toastrService.error("Invalid Credentials", 'Error!');
            }
          );
      } else {
        this.dynamicArray.splice(index, 1);
      }
    }
  }
  deleteRowBlock2(index: number, dynamic: any) {
    this.defaulttiers = [];
    if (this.dynamicArray.length == 1) {
      Swal.fire({
        title: 'Warning',
        text: "Can't delete the row when there is only one row",
      });
      return false;
    } else {
      if (dynamic.id && dynamic.id > 0) {
        this.defaulttiers.push(dynamic.id);
        let requestBody = {
          default: this.defaulttiers,
          lengthOfService: [],
          annualIncome: [],
        };

        var corporateId = sessionStorage.getItem('corporateId');

        var DeleteTiers =
          '/api/ap/admin/corporate/' + corporateId + '/deleteTiers';
        var accessToken = sessionStorage.getItem('accessToken');
        this.http
          .post(environment.apiUrl + DeleteTiers, requestBody, {
            headers: {
              Authorization: 'Bearer ' + accessToken,
              'Content-Type': 'application/json',
            },
          })
          .subscribe(
            (response: any) => {
              if (response.status == '200') {
                Swal.fire({
                  title: 'Success',
                  text: response.message,
                  showDenyButton: false,
                  showCancelButton: false,
                  confirmButtonText: 'Ok',
                }).then((result) => {
                  if (result.isConfirmed) {
                    this.configuretiers();
                  }
                });
              } else {
                Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message });
              }
            },
            (error) => {
              if (
                error.status == 400 ||
                error.status == 401 ||
                error.status == 402 ||
                error.status == 403
              ) {
                Swal.fire({
                  title: this.lang.Error ?? 'Error',
                  text: error.error.error.message,
                  showCancelButton: false,
                  showDenyButton: false,
                  confirmButtonText: 'Proceed',
                }).then((result) => {
                  /* Read more about isConfirmed, isDenied below */
                  if (result.isConfirmed) {
                    sessionStorage.clear();
                    this.router.navigate(['/login']);
                  } else {
                    sessionStorage.clear();
                    this.router.navigate(['/login']);
                  }
                });
              } else {
                // Swal.fire(error.error.error.message)
                Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
              }
              // this.toastrService.error("Invalid Credentials", 'Error!');
            }
          );
      } else {
        this.dynamicArray.splice(index, 1);
      }
    }
  }
  deleteRowBlock3(index: number, dynamic: any) {
    this.defaulttiers = [];
    if (this.dynamicArray.length == 1) {
      Swal.fire({
        title: 'Warning',
        text: "Can't delete the row when there is only one row",
      });
      return false;
    } else {
      if (dynamic.id && dynamic.id > 0) {
        this.defaulttiers.push(dynamic.id);
        let requestBody = {
          default: this.defaulttiers,
          lengthOfService: [],
          annualIncome: [],
        };

        var corporateId = sessionStorage.getItem('corporateId');

        var DeleteTiers =
          '/api/ap/admin/corporate/' + corporateId + '/deleteTiers';
        var accessToken = sessionStorage.getItem('accessToken');
        this.http
          .post(environment.apiUrl + DeleteTiers, requestBody, {
            headers: {
              Authorization: 'Bearer ' + accessToken,
              'Content-Type': 'application/json',
            },
          })
          .subscribe(
            (response: any) => {
              if (response.status == '200') {
                Swal.fire({
                  title: 'Success',
                  text: response.message,
                  showDenyButton: false,
                  showCancelButton: false,
                  confirmButtonText: 'Ok',
                }).then((result) => {
                  if (result.isConfirmed) {
                    this.configuretiers();
                  }
                });
              } else {
                Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message });
              }
            },
            (error) => {
              if (
                error.status == 400 ||
                error.status == 401 ||
                error.status == 402 ||
                error.status == 403
              ) {
                Swal.fire({
                  title: this.lang.Error ?? 'Error',
                  text: error.error.error.message,
                  showCancelButton: false,
                  showDenyButton: false,
                  confirmButtonText: 'Proceed',
                }).then((result) => {
                  /* Read more about isConfirmed, isDenied below */
                  if (result.isConfirmed) {
                    sessionStorage.clear();
                    this.router.navigate(['/login']);
                  } else {
                    sessionStorage.clear();
                    this.router.navigate(['/login']);
                  }
                });
              } else {
                // Swal.fire(error.error.error.message)
                Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
              }
              // this.toastrService.error("Invalid Credentials", 'Error!');
            }
          );
      } else {
        this.dynamicArray.splice(index, 1);
      }
    }
  }
  deleteRow(index: number) {
    return false;
    if (this.dynamicArray.length == 1) {
      Swal.fire({
        title: 'Warning',
        text: "Can't delete the row when there is only one row",
      });
      return false;
    } else {
      // if(dynamic.id  && dynamic.id>0){

      this.defaulttiers.push(1119);
      let requestBody = {
        default: this.defaulttiers,
        lengthOfService: [],
        annualIncome: [],
      };

      var corporateId = sessionStorage.getItem('corporateId');

      var DeleteTiers =
        '/api/ap/admin/corporate/' + corporateId + '/deleteTiers';
      var accessToken = sessionStorage.getItem('accessToken');
      this.http
        .post(environment.apiUrl + DeleteTiers, requestBody, {
          headers: {
            Authorization: 'Bearer ' + accessToken,
            'Content-Type': 'application/json',
          },
        })
        .subscribe(
          (response: any) => {
            if (response.status == '200') {
              Swal.fire({
                title: 'Success',
                text: response.message,
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: 'Ok',
              }).then((result) => {
                if (result.isConfirmed) {
                  this.configuretiers();
                }
              });
            } else {
              Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message });
            }
          },
          (error) => {
            if (
              error.status == 400 ||
              error.status == 401 ||
              error.status == 402 ||
              error.status == 403
            ) {
              Swal.fire({
                title: this.lang.Error ?? 'Error',
                text: error.error.error.message,
                showCancelButton: false,
                showDenyButton: false,
                confirmButtonText: 'Proceed',
              }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                  sessionStorage.clear();
                  this.router.navigate(['/login']);
                } else {
                  sessionStorage.clear();
                  this.router.navigate(['/login']);
                }
              });
            } else {
              // Swal.fire(error.error.error.message)
              Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
            }
            // this.toastrService.error("Invalid Credentials", 'Error!');
          }
        );

      // }

      // else{
      //   // this.dynamicArray.splice(index, 1);

      // }
    }
  }
  addRowService() {
    this.serviceCount++;
    this.dynamicArrayService.push({
      sno: '',
      tierName: '',
      from: '',
      to: '',
      period: '',
      walletAmount: '$',
    });
    // console.log('New row added successfully', 'New Row')
  }
  deleteRowService(index: number) {
    this.dynamicArrayService.splice(index, 1);
    // this.serviceCount--
  }
  deleteRowServiceBlock1(index: number, dynamic: any) {
    // console.log(this.dynamicArray)

    this.defaulttiers = [];

    if (dynamic.id && dynamic.id > 0) {
      console.log(dynamic.id);

      this.defaulttiers.push(dynamic.id);
      let requestBody = {
        default: [],
        lengthOfService: this.defaulttiers,
        annualIncome: [],
      };

      var corporateId = sessionStorage.getItem('corporateId');

      var DeleteTiers =
        '/api/ap/admin/corporate/' + corporateId + '/deleteTiers';
      var accessToken = sessionStorage.getItem('accessToken');
      this.http
        .post(environment.apiUrl + DeleteTiers, requestBody, {
          headers: {
            Authorization: 'Bearer ' + accessToken,
            'Content-Type': 'application/json',
          },
        })
        .subscribe(
          (response: any) => {
            if (response.status == '200') {
              Swal.fire({
                title: 'Success',
                text: response.message,
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: 'Ok',
              }).then((result) => {
                if (result.isConfirmed) {
                  this.configuretiers();
                }
              });
            } else {
              Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message });
            }
          },
          (error) => {
            if (
              error.status == 400 ||
              error.status == 401 ||
              error.status == 402 ||
              error.status == 403
            ) {
              Swal.fire({
                title: this.lang.Error ?? 'Error',
                text: error.error.error.message,
                showCancelButton: false,
                showDenyButton: false,
                confirmButtonText: 'Proceed',
              }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                  sessionStorage.clear();
                  this.router.navigate(['/login']);
                } else {
                  sessionStorage.clear();
                  this.router.navigate(['/login']);
                }
              });
            } else {
              // Swal.fire(error.error.error.message)
              Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
            }
            // this.toastrService.error("Invalid Credentials", 'Error!');
          }
        );
    } else {
      this.dynamicArrayService.splice(index, 1);
    }
  }
  deleteRowServiceBlock2(index: number, dynamic: any) {
    // console.log(this.dynamicArray)

    this.defaulttiers = [];

    if (dynamic.id && dynamic.id > 0) {
      console.log(dynamic.id);

      this.defaulttiers.push(dynamic.id);
      let requestBody = {
        default: [],
        lengthOfService: this.defaulttiers,
        annualIncome: [],
      };

      var corporateId = sessionStorage.getItem('corporateId');

      var DeleteTiers =
        '/api/ap/admin/corporate/' + corporateId + '/deleteTiers';
      var accessToken = sessionStorage.getItem('accessToken');
      this.http
        .post(environment.apiUrl + DeleteTiers, requestBody, {
          headers: {
            Authorization: 'Bearer ' + accessToken,
            'Content-Type': 'application/json',
          },
        })
        .subscribe(
          (response: any) => {
            if (response.status == '200') {
              Swal.fire({
                title: 'Success',
                text: response.message,
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: 'Ok',
              }).then((result) => {
                if (result.isConfirmed) {
                  this.configuretiers();
                }
              });
            } else {
              Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message });
            }
          },
          (error) => {
            if (
              error.status == 400 ||
              error.status == 401 ||
              error.status == 402 ||
              error.status == 403
            ) {
              Swal.fire({
                title: this.lang.Error ?? 'Error',
                text: error.error.error.message,
                showCancelButton: false,
                showDenyButton: false,
                confirmButtonText: 'Proceed',
              }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                  sessionStorage.clear();
                  this.router.navigate(['/login']);
                } else {
                  sessionStorage.clear();
                  this.router.navigate(['/login']);
                }
              });
            } else {
              // Swal.fire(error.error.error.message)
              Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
            }
            // this.toastrService.error("Invalid Credentials", 'Error!');
          }
        );
    } else {
      this.dynamicArrayService.splice(index, 1);
    }
  }
  deleteRowServiceBlock3(index: number, dynamic: any) {
    // console.log(this.dynamicArray)

    this.defaulttiers = [];

    if (dynamic.id && dynamic.id > 0) {
      console.log(dynamic.id);

      this.defaulttiers.push(dynamic.id);
      let requestBody = {
        default: [],
        lengthOfService: this.defaulttiers,
        annualIncome: [],
      };

      var corporateId = sessionStorage.getItem('corporateId');

      var DeleteTiers =
        '/api/ap/admin/corporate/' + corporateId + '/deleteTiers';
      var accessToken = sessionStorage.getItem('accessToken');
      this.http
        .post(environment.apiUrl + DeleteTiers, requestBody, {
          headers: {
            Authorization: 'Bearer ' + accessToken,
            'Content-Type': 'application/json',
          },
        })
        .subscribe(
          (response: any) => {
            if (response.status == '200') {
              Swal.fire({
                title: 'Success',
                text: response.message,
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: 'Ok',
              }).then((result) => {
                if (result.isConfirmed) {
                  this.configuretiers();
                }
              });
            } else {
              Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message });
            }
          },
          (error) => {
            if (
              error.status == 400 ||
              error.status == 401 ||
              error.status == 402 ||
              error.status == 403
            ) {
              Swal.fire({
                title: this.lang.Error ?? 'Error',
                text: error.error.error.message,
                showCancelButton: false,
                showDenyButton: false,
                confirmButtonText: 'Proceed',
              }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                  sessionStorage.clear();
                  this.router.navigate(['/login']);
                } else {
                  sessionStorage.clear();
                  this.router.navigate(['/login']);
                }
              });
            } else {
              // Swal.fire(error.error.error.message)
              Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
            }
            // this.toastrService.error("Invalid Credentials", 'Error!');
          }
        );
    } else {
      this.dynamicArrayService.splice(index, 1);
    }
  }
  addRowAnnual() {
    this.AnnualCount++;
    this.dynamicArrayAnnualIncome.push({
      sno: '',
      tierName: '',
      percentage: '',
      from: '',
      to: '',
      walletAmount: '$',
    });
    // console.log('New row added successfully', 'New Row')
  }
  deleteRowAnnual(index: number) {
    this.dynamicArrayAnnualIncome.splice(index, 1);
  }

  deleteRowAnnualBlock1(index: number, dynamic: any) {
    this.defaulttiers = [];
    if (dynamic.id && dynamic.id > 0) {
      this.defaulttiers.push(dynamic.id);
      let requestBody = {
        default: [],
        lengthOfService: [],
        annualIncome: this.defaulttiers,
      };

      var corporateId = sessionStorage.getItem('corporateId');

      var DeleteTiers =
        '/api/ap/admin/corporate/' + corporateId + '/deleteTiers';
      var accessToken = sessionStorage.getItem('accessToken');
      this.http
        .post(environment.apiUrl + DeleteTiers, requestBody, {
          headers: {
            Authorization: 'Bearer ' + accessToken,
            'Content-Type': 'application/json',
          },
        })
        .subscribe(
          (response: any) => {
            if (response.status == '200') {
              Swal.fire({
                title: 'Success',
                text: response.message,
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: 'Ok',
              }).then((result) => {
                if (result.isConfirmed) {
                  this.configuretiers();
                }
              });
            } else {
              Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message });
            }
          },
          (error) => {
            if (
              error.status == 400 ||
              error.status == 401 ||
              error.status == 402 ||
              error.status == 403
            ) {
              Swal.fire({
                title: this.lang.Error ?? 'Error',
                text: error.error.error.message,
                showCancelButton: false,
                showDenyButton: false,
                confirmButtonText: 'Proceed',
              }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                  sessionStorage.clear();
                  this.router.navigate(['/login']);
                } else {
                  sessionStorage.clear();
                  this.router.navigate(['/login']);
                }
              });
            } else {
              // Swal.fire(error.error.error.message)
              Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
            }
            // this.toastrService.error("Invalid Credentials", 'Error!');
          }
        );
    } else {
      this.dynamicArrayAnnualIncome.splice(index, 1);
    }
  }
  deleteRowAnnualBlock2(index: number, dynamic: any) {
    this.defaulttiers = [];
    if (dynamic.id && dynamic.id > 0) {
      this.defaulttiers.push(dynamic.id);
      let requestBody = {
        default: [],
        lengthOfService: [],
        annualIncome: this.defaulttiers,
      };

      var corporateId = sessionStorage.getItem('corporateId');

      var DeleteTiers =
        '/api/ap/admin/corporate/' + corporateId + '/deleteTiers';
      var accessToken = sessionStorage.getItem('accessToken');
      this.http
        .post(environment.apiUrl + DeleteTiers, requestBody, {
          headers: {
            Authorization: 'Bearer ' + accessToken,
            'Content-Type': 'application/json',
          },
        })
        .subscribe(
          (response: any) => {
            if (response.status == '200') {
              Swal.fire({
                title: 'Success',
                text: response.message,
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: 'Ok',
              }).then((result) => {
                if (result.isConfirmed) {
                  this.configuretiers();
                }
              });
            } else {
              Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message });
            }
          },
          (error) => {
            if (
              error.status == 400 ||
              error.status == 401 ||
              error.status == 402 ||
              error.status == 403
            ) {
              Swal.fire({
                title: this.lang.Error ?? 'Error',
                text: error.error.error.message,
                showCancelButton: false,
                showDenyButton: false,
                confirmButtonText: 'Proceed',
              }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                  sessionStorage.clear();
                  this.router.navigate(['/login']);
                } else {
                  sessionStorage.clear();
                  this.router.navigate(['/login']);
                }
              });
            } else {
              // Swal.fire(error.error.error.message)
              Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
            }
            // this.toastrService.error("Invalid Credentials", 'Error!');
          }
        );
    } else {
      this.dynamicArrayAnnualIncome.splice(index, 1);
    }
  }
  deleteRowAnnualBlock3(index: number, dynamic: any) {
    this.defaulttiers = [];
    if (dynamic.id && dynamic.id > 0) {
      this.defaulttiers.push(dynamic.id);
      let requestBody = {
        default: [],
        lengthOfService: [],
        annualIncome: this.defaulttiers,
      };

      var corporateId = sessionStorage.getItem('corporateId');

      var DeleteTiers =
        '/api/ap/admin/corporate/' + corporateId + '/deleteTiers';
      var accessToken = sessionStorage.getItem('accessToken');
      this.http
        .post(environment.apiUrl + DeleteTiers, requestBody, {
          headers: {
            Authorization: 'Bearer ' + accessToken,
            'Content-Type': 'application/json',
          },
        })
        .subscribe(
          (response: any) => {
            if (response.status == '200') {
              Swal.fire({
                title: 'Success',
                text: response.message,
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: 'Ok',
              }).then((result) => {
                if (result.isConfirmed) {
                  this.configuretiers();
                }
              });
            } else {
              Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message });
            }
          },
          (error) => {
            if (
              error.status == 400 ||
              error.status == 401 ||
              error.status == 402 ||
              error.status == 403
            ) {
              Swal.fire({
                title: this.lang.Error ?? 'Error',
                text: error.error.error.message,
                showCancelButton: false,
                showDenyButton: false,
                confirmButtonText: 'Proceed',
              }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                  sessionStorage.clear();
                  this.router.navigate(['/login']);
                } else {
                  sessionStorage.clear();
                  this.router.navigate(['/login']);
                }
              });
            } else {
              // Swal.fire(error.error.error.message)
              Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
            }
            // this.toastrService.error("Invalid Credentials", 'Error!');
          }
        );
    } else {
      this.dynamicArrayAnnualIncome.splice(index, 1);
    }
  }
  public ngAfterViewInit(): void {
    // this.createChartGauge();
  }

  get client() {
    return this.clientregform.controls;
  }

  assignAllplanLvelwithdisallowed(plans: any) {
    this.disallowedplans = {};

    plans.forEach((packagelevel: any, index: number) => {
      packagelevel.groups.forEach((groups: any, index1: number) => {
        groups.subGroups.forEach((planlevel: any, index2: number) => {
          console.log(planlevel.id);
          console.log(planlevel.disallowedPlanLevels);

          if (planlevel.disallowedPlanLevels) {
            this.disallowedplans[planlevel.id] =
              planlevel.disallowedPlanLevels.split(',');
          }
        });
      });
    });
  }
  assignAllplanLvelwithdisallowedTiers(plans: any) {
    this.disallowedplansTiers = {};

    plans.forEach((packagelevel: any, index: number) => {
      packagelevel.groups.forEach((groups: any, index1: number) => {
        groups.subGroups.forEach((planlevel: any, index2: number) => {
          console.log(planlevel.id);
          console.log(planlevel.disallowedPlanLevels);

          if (planlevel.disallowedPlanLevels) {
            this.disallowedplansTiers[planlevel.id] =
              planlevel.disallowedPlanLevels.split(',');
          }
        });
      });
    });
  }
  public capitalize(str: any) {
    // if (str) {
    //   return str.charAt(0).toUpperCase() + str.slice(1);
    // }

    if (str) {
      return str.replace(/(?:^|\s)\S/g, function (match) {
        return match.toUpperCase();
      });
    }
  }

  public dummyData() {
    this.showtierbasicplans = true;
    if (this.clientregform.value.tierConfig == true) {
      this.showemptytierconfig = true;
    } else {
      this.showemptytierconfig = false;
    }
    if (this.clientregform.value.walletConfig == false) {
      this.showemptywalletConfig = false;
    } else {
      this.showemptywalletConfig = true;
    }

    // this.headerComponent.headerDetails('login');
    this.basicInfo = false;
    this.plansInfo = true;

    this.plansBlock1 = [
      {
        description: 'Health & Dental Insurance',
        id: 1,
        logo: null,
        name: 'Health & Dental Insurance',
        published: true,
        ordering: 1,
        allowMultiple: false,
        applyFilters: true,
        optIn: false,
        groups: [
          {
            id: 1,
            name: 'Classic',
            subGroups: [
              {
                backgroundColor: '#b08d57',
                childMaxAge: 21,
                description: null,
                disallowedPlanLevels: null,
                id: 3,
                level: 2,
                name: 'Classic Bronze',
                ordering: 4,
                parentId: 1,
                published: {
                  type: 'Buffer',
                  data: [1],
                },
                requirePlanLevel: null,
                textColor: '#FFFFFF',
                tooltipTitle: 'plan_coverage',
              },
              {
                backgroundColor: '#aaa9ad',
                childMaxAge: 21,
                description: null,
                disallowedPlanLevels: null,
                id: 4,
                level: 2,
                name: 'Classic Silver',
                ordering: 5,
                parentId: 1,
                published: {
                  type: 'Buffer',
                  data: [1],
                },
                requirePlanLevel: null,
                textColor: '#FFFFFF',
                tooltipTitle: 'plan_coverage',
              },
              {
                backgroundColor: '#d4af37',
                childMaxAge: 21,
                description: null,
                disallowedPlanLevels: null,
                id: 5,
                level: 2,
                name: 'Classic Gold',
                ordering: 6,
                parentId: 1,
                published: {
                  type: 'Buffer',
                  data: [1],
                },
                requirePlanLevel: 4,
                textColor: '#FFFFFF',
                tooltipTitle: 'plan_coverage',
              },
            ],
          },
          {
            id: 6,
            name: 'All-In',
            subGroups: [
              {
                backgroundColor: '#b08d57',
                childMaxAge: 21,
                description: null,
                disallowedPlanLevels: '1,10,14',
                id: 7,
                level: 2,
                name: 'All-In Bronze',
                ordering: 8,
                parentId: 6,
                published: {
                  type: 'Buffer',
                  data: [1],
                },
                requirePlanLevel: null,
                textColor: '#FFFFFF',
                tooltipTitle: 'plan_coverage',
              },
              {
                backgroundColor: '#aaa9ad',
                childMaxAge: 21,
                description: null,
                disallowedPlanLevels: '1,10,14',
                id: 8,
                level: 2,
                name: 'All-In Silver',
                ordering: 9,
                parentId: 6,
                published: {
                  type: 'Buffer',
                  data: [1],
                },
                requirePlanLevel: null,
                textColor: '#FFFFFF',
                tooltipTitle: 'plan_coverage',
              },
              {
                backgroundColor: '#d4af37',
                childMaxAge: 21,
                description: null,
                disallowedPlanLevels: '1,10,14',
                id: 9,
                level: 2,
                name: 'All-In Gold',
                ordering: 10,
                parentId: 6,
                published: {
                  type: 'Buffer',
                  data: [1],
                },
                requirePlanLevel: null,
                textColor: '#FFFFFF',
                tooltipTitle: 'plan_coverage',
              },
            ],
          },
        ],
      },
      {
        description: 'Opt-in plans',
        id: 8,
        logo: null,
        name: 'Opt-in',
        published: true,
        ordering: 2,
        allowMultiple: true,
        applyFilters: true,
        optIn: true,
        groups: [
          {
            id: 16,
            name: 'Opt-In',
            subGroups: [
              {
                backgroundColor: '#4e2a84',
                childMaxAge: 21,
                description: null,
                disallowedPlanLevels: null,
                id: 16,
                level: null,
                name: 'Opt-In',
                ordering: 1,
                parentId: null,
                published: {
                  type: 'Buffer',
                  data: [1],
                },
                requirePlanLevel: null,
                textColor: '#FFFFFF',
                tooltipTitle: 'name',
                plans: [
                  {
                    code: null,
                    corporatePlan: false,
                    cost: 0,
                    description:
                      'YES! I would like to activate PocketPills Digital Pharmacy to get the 10% coinsurance enhancement available in most GroupBenefitz Platform health plans including free shipping. Please share my information with PocketPills to activate my account.',
                    frqMonthly: null,
                    frqYearly: null,
                    fusebillId: null,
                    id: 429,
                    insuranceCompanyId: null,
                    isMonthlyCost: null,
                    logo: null,
                    maxAge: null,
                    minAge: null,
                    name: 'PocketPills Digital Pharmacy - Activate My Account',
                    ordering: 1,
                    packageId: 8,
                    planCoverage: null,
                    planLevel: 16,
                    published: {
                      type: 'Buffer',
                      data: [1],
                    },
                    package_id: 8,
                    plan_level: 16,
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        description: 'Mental Health & Wellness',
        id: 2,
        logo: null,
        name: 'Mental Health & Wellbeing',
        published: true,
        ordering: 3,
        allowMultiple: false,
        applyFilters: true,
        optIn: false,
        groups: [
          {
            id: 14,
            name: 'Wellness',
            subGroups: [
              {
                backgroundColor: '#694586',
                childMaxAge: 21,
                description: null,
                disallowedPlanLevels: null,
                id: 19,
                level: 2,
                name: 'EAP 2.0',
                ordering: 18,
                parentId: 14,
                published: {
                  type: 'Buffer',
                  data: [1],
                },
                requirePlanLevel: null,
                textColor: '#FFFFFF',
                tooltipTitle: 'name',
              },
              {
                backgroundColor: '#694586',
                childMaxAge: 21,
                description: null,
                disallowedPlanLevels: null,
                id: 21,
                level: 2,
                name: 'Mind & Body',
                ordering: 19,
                parentId: 14,
                published: {
                  type: 'Buffer',
                  data: [1],
                },
                requirePlanLevel: null,
                textColor: '#FFFFFF',
                tooltipTitle: 'name',
              },
              {
                backgroundColor: '#694586',
                childMaxAge: 21,
                description: null,
                disallowedPlanLevels: null,
                id: 20,
                level: 2,
                name: 'Complete Wellness',
                ordering: 21,
                parentId: 14,
                published: {
                  type: 'Buffer',
                  data: [1],
                },
                requirePlanLevel: null,
                textColor: '#FFFFFF',
                tooltipTitle: 'name',
              },
            ],
          },
        ],
      },
      {
        description: 'Catastrophic Medication Insurance',
        id: 3,
        logo: null,
        name: 'Catastrophic Medication Insurance',
        published: true,
        ordering: 4,
        allowMultiple: false,
        applyFilters: true,
        optIn: false,
        groups: [
          {
            id: 24,
            name: 'Medication',
            subGroups: [
              {
                backgroundColor: '#423894',
                childMaxAge: 21,
                description: null,
                disallowedPlanLevels: null,
                id: 10,
                level: 2,
                name: 'High-Cost Drugs',
                ordering: 12,
                parentId: 24,
                published: {
                  type: 'Buffer',
                  data: [1],
                },
                requirePlanLevel: null,
                textColor: '#FFFFFF',
                tooltipTitle: 'name',
              },
            ],
          },
        ],
      },
      {
        description: 'Accident & Serious Illness Disability Insurance',
        id: 4,
        logo: null,
        name: 'Accident & Serious Illness Disability Insurance',
        published: true,
        ordering: 5,
        allowMultiple: false,
        applyFilters: true,
        optIn: false,
        groups: [
          {
            id: 11,
            name: 'Protect',
            subGroups: [
              {
                backgroundColor: '#354a9f',
                childMaxAge: 21,
                description: null,
                disallowedPlanLevels: null,
                id: 12,
                level: 2,
                name: 'Protect 100',
                ordering: 14,
                parentId: 11,
                published: {
                  type: 'Buffer',
                  data: [1],
                },
                requirePlanLevel: null,
                textColor: '#FFFFFF',
                tooltipTitle: 'name',
              },
              {
                backgroundColor: '#354a9f',
                childMaxAge: 21,
                description: null,
                disallowedPlanLevels: null,
                id: 13,
                level: 2,
                name: 'Protect 200',
                ordering: 15,
                parentId: 11,
                published: {
                  type: 'Buffer',
                  data: [1],
                },
                requirePlanLevel: null,
                textColor: '#FFFFFF',
                tooltipTitle: 'name',
              },
            ],
          },
        ],
      },
      {
        description:
          'Executive Benefits- Executive Health, Complete Executive Care',
        id: 5,
        logo: null,
        name: 'Executive Benefits',
        published: true,
        ordering: 6,
        allowMultiple: false,
        applyFilters: false,
        optIn: false,
        groups: [
          {
            id: 15,
            name: 'Executive',
            subGroups: [
              {
                backgroundColor: '#5e152e',
                childMaxAge: 24,
                description: null,
                disallowedPlanLevels: null,
                id: 17,
                level: 2,
                name: 'Executive Health',
                ordering: 23,
                parentId: 15,
                published: {
                  type: 'Buffer',
                  data: [1],
                },
                requirePlanLevel: null,
                textColor: '#FFFFFF',
                tooltipTitle: 'plan_coverage',
              },
              {
                backgroundColor: '#5e152e',
                childMaxAge: 24,
                description: null,
                disallowedPlanLevels: null,
                id: 18,
                level: 2,
                name: 'Complete Executive Care',
                ordering: 24,
                parentId: 15,
                published: {
                  type: 'Buffer',
                  data: [1],
                },
                requirePlanLevel: null,
                textColor: '#FFFFFF',
                tooltipTitle: 'plan_coverage',
              },
            ],
          },
        ],
      },
    ];

    this.plansBlock1Tiers = [
      {
        description: 'Health & Dental Insurance',
        id: 1,
        logo: null,
        name: 'Health & Dental Insurance',
        published: true,
        ordering: 1,
        allowMultiple: false,
        applyFilters: true,
        optIn: false,
        groups: [
          {
            id: 1,
            name: 'Classic',
            subGroups: [
              {
                backgroundColor: '#b08d57',
                childMaxAge: 21,
                description: null,
                disallowedPlanLevels: null,
                id: 3,
                level: 2,
                name: 'Classic Bronze',
                ordering: 4,
                parentId: 1,
                published: {
                  type: 'Buffer',
                  data: [1],
                },
                requirePlanLevel: null,
                textColor: '#FFFFFF',
                tooltipTitle: 'plan_coverage',
              },
              {
                backgroundColor: '#aaa9ad',
                childMaxAge: 21,
                description: null,
                disallowedPlanLevels: null,
                id: 4,
                level: 2,
                name: 'Classic Silver',
                ordering: 5,
                parentId: 1,
                published: {
                  type: 'Buffer',
                  data: [1],
                },
                requirePlanLevel: null,
                textColor: '#FFFFFF',
                tooltipTitle: 'plan_coverage',
              },
              {
                backgroundColor: '#d4af37',
                childMaxAge: 21,
                description: null,
                disallowedPlanLevels: null,
                id: 5,
                level: 2,
                name: 'Classic Gold',
                ordering: 6,
                parentId: 1,
                published: {
                  type: 'Buffer',
                  data: [1],
                },
                requirePlanLevel: 4,
                textColor: '#FFFFFF',
                tooltipTitle: 'plan_coverage',
              },
            ],
          },
          {
            id: 6,
            name: 'All-In',
            subGroups: [
              {
                backgroundColor: '#b08d57',
                childMaxAge: 21,
                description: null,
                disallowedPlanLevels: '1,10,14',
                id: 7,
                level: 2,
                name: 'All-In Bronze',
                ordering: 8,
                parentId: 6,
                published: {
                  type: 'Buffer',
                  data: [1],
                },
                requirePlanLevel: null,
                textColor: '#FFFFFF',
                tooltipTitle: 'plan_coverage',
              },
              {
                backgroundColor: '#aaa9ad',
                childMaxAge: 21,
                description: null,
                disallowedPlanLevels: '1,10,14',
                id: 8,
                level: 2,
                name: 'All-In Silver',
                ordering: 9,
                parentId: 6,
                published: {
                  type: 'Buffer',
                  data: [1],
                },
                requirePlanLevel: null,
                textColor: '#FFFFFF',
                tooltipTitle: 'plan_coverage',
              },
              {
                backgroundColor: '#d4af37',
                childMaxAge: 21,
                description: null,
                disallowedPlanLevels: '1,10,14',
                id: 9,
                level: 2,
                name: 'All-In Gold',
                ordering: 10,
                parentId: 6,
                published: {
                  type: 'Buffer',
                  data: [1],
                },
                requirePlanLevel: null,
                textColor: '#FFFFFF',
                tooltipTitle: 'plan_coverage',
              },
            ],
          },
        ],
      },
      {
        description: 'Opt-in plans',
        id: 8,
        logo: null,
        name: 'Opt-in',
        published: true,
        ordering: 2,
        allowMultiple: true,
        applyFilters: true,
        optIn: true,
        groups: [
          {
            id: 16,
            name: 'Opt-In',
            subGroups: [
              {
                backgroundColor: '#4e2a84',
                childMaxAge: 21,
                description: null,
                disallowedPlanLevels: null,
                id: 16,
                level: null,
                name: 'Opt-In',
                ordering: 1,
                parentId: null,
                published: {
                  type: 'Buffer',
                  data: [1],
                },
                requirePlanLevel: null,
                textColor: '#FFFFFF',
                tooltipTitle: 'name',
                plans: [
                  {
                    code: null,
                    corporatePlan: false,
                    cost: 0,
                    description:
                      'YES! I would like to activate PocketPills Digital Pharmacy to get the 10% coinsurance enhancement available in most GroupBenefitz Platform health plans including free shipping. Please share my information with PocketPills to activate my account.',
                    frqMonthly: null,
                    frqYearly: null,
                    fusebillId: null,
                    id: 429,
                    insuranceCompanyId: null,
                    isMonthlyCost: null,
                    logo: null,
                    maxAge: null,
                    minAge: null,
                    name: 'PocketPills Digital Pharmacy - Activate My Account',
                    ordering: 1,
                    packageId: 8,
                    planCoverage: null,
                    planLevel: 16,
                    published: {
                      type: 'Buffer',
                      data: [1],
                    },
                    package_id: 8,
                    plan_level: 16,
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        description: 'Mental Health & Wellness',
        id: 2,
        logo: null,
        name: 'Mental Health & Wellbeing',
        published: true,
        ordering: 3,
        allowMultiple: false,
        applyFilters: true,
        optIn: false,
        groups: [
          {
            id: 14,
            name: 'Wellness',
            subGroups: [
              {
                backgroundColor: '#694586',
                childMaxAge: 21,
                description: null,
                disallowedPlanLevels: null,
                id: 19,
                level: 2,
                name: 'EAP 2.0',
                ordering: 18,
                parentId: 14,
                published: {
                  type: 'Buffer',
                  data: [1],
                },
                requirePlanLevel: null,
                textColor: '#FFFFFF',
                tooltipTitle: 'name',
              },
              {
                backgroundColor: '#694586',
                childMaxAge: 21,
                description: null,
                disallowedPlanLevels: null,
                id: 21,
                level: 2,
                name: 'Mind & Body',
                ordering: 19,
                parentId: 14,
                published: {
                  type: 'Buffer',
                  data: [1],
                },
                requirePlanLevel: null,
                textColor: '#FFFFFF',
                tooltipTitle: 'name',
              },
              {
                backgroundColor: '#694586',
                childMaxAge: 21,
                description: null,
                disallowedPlanLevels: null,
                id: 20,
                level: 2,
                name: 'Complete Wellness',
                ordering: 21,
                parentId: 14,
                published: {
                  type: 'Buffer',
                  data: [1],
                },
                requirePlanLevel: null,
                textColor: '#FFFFFF',
                tooltipTitle: 'name',
              },
            ],
          },
        ],
      },
      {
        description: 'Catastrophic Medication Insurance',
        id: 3,
        logo: null,
        name: 'Catastrophic Medication Insurance',
        published: true,
        ordering: 4,
        allowMultiple: false,
        applyFilters: true,
        optIn: false,
        groups: [
          {
            id: 24,
            name: 'Medication',
            subGroups: [
              {
                backgroundColor: '#423894',
                childMaxAge: 21,
                description: null,
                disallowedPlanLevels: null,
                id: 10,
                level: 2,
                name: 'High-Cost Drugs',
                ordering: 12,
                parentId: 24,
                published: {
                  type: 'Buffer',
                  data: [1],
                },
                requirePlanLevel: null,
                textColor: '#FFFFFF',
                tooltipTitle: 'name',
              },
            ],
          },
        ],
      },
      {
        description: 'Accident & Serious Illness Disability Insurance',
        id: 4,
        logo: null,
        name: 'Accident & Serious Illness Disability Insurance',
        published: true,
        ordering: 5,
        allowMultiple: false,
        applyFilters: true,
        optIn: false,
        groups: [
          {
            id: 11,
            name: 'Protect',
            subGroups: [
              {
                backgroundColor: '#354a9f',
                childMaxAge: 21,
                description: null,
                disallowedPlanLevels: null,
                id: 12,
                level: 2,
                name: 'Protect 100',
                ordering: 14,
                parentId: 11,
                published: {
                  type: 'Buffer',
                  data: [1],
                },
                requirePlanLevel: null,
                textColor: '#FFFFFF',
                tooltipTitle: 'name',
              },
              {
                backgroundColor: '#354a9f',
                childMaxAge: 21,
                description: null,
                disallowedPlanLevels: null,
                id: 13,
                level: 2,
                name: 'Protect 200',
                ordering: 15,
                parentId: 11,
                published: {
                  type: 'Buffer',
                  data: [1],
                },
                requirePlanLevel: null,
                textColor: '#FFFFFF',
                tooltipTitle: 'name',
              },
            ],
          },
        ],
      },
      {
        description:
          'Executive Benefits- Executive Health, Complete Executive Care',
        id: 5,
        logo: null,
        name: 'Executive Benefits',
        published: true,
        ordering: 6,
        allowMultiple: false,
        applyFilters: false,
        optIn: false,
        groups: [
          {
            id: 15,
            name: 'Executive',
            subGroups: [
              {
                backgroundColor: '#5e152e',
                childMaxAge: 24,
                description: null,
                disallowedPlanLevels: null,
                id: 17,
                level: 2,
                name: 'Executive Health',
                ordering: 23,
                parentId: 15,
                published: {
                  type: 'Buffer',
                  data: [1],
                },
                requirePlanLevel: null,
                textColor: '#FFFFFF',
                tooltipTitle: 'plan_coverage',
              },
              {
                backgroundColor: '#5e152e',
                childMaxAge: 24,
                description: null,
                disallowedPlanLevels: null,
                id: 18,
                level: 2,
                name: 'Complete Executive Care',
                ordering: 24,
                parentId: 15,
                published: {
                  type: 'Buffer',
                  data: [1],
                },
                requirePlanLevel: null,
                textColor: '#FFFFFF',
                tooltipTitle: 'plan_coverage',
              },
            ],
          },
        ],
      },
    ];

    this.plansBlock1.forEach((planlevel: any) => {
      planlevel.groups.forEach((groups: any) => {
        groups.subGroups.forEach((subgroup: any) => {
          subgroup.tiers = [];
          subgroup.checked = false;
          subgroup.coverage = ''; //default
        });
      });
    });
    this.plansBlock1Tiers.forEach((planlevel: any) => {
      this.selectedPackagePlansInfoTier[planlevel.id] = [];
      this.selectedPackagePlansInfoTiername[planlevel.id] = planlevel.name;
      this.selectedPackagePlansInfoTierBlock2[planlevel.id] = [];
      this.selectedPackagePlansInfoTiernameBlock2[planlevel.id] =
        planlevel.name;
      this.selectedPackagePlansInfoTierBlock3[planlevel.id] = [];
      this.selectedPackagePlansInfoTiernameBlock3[planlevel.id] =
        planlevel.name;

      this.selectedPackagesavailableTiers2[planlevel.id] = {};
      this.selectedPackagesassignedTiers2[planlevel.id] = {};
      this.selectedPackagesavailableTiers2Block2[planlevel.id] = {};
      this.selectedPackagesassignedTiers2Block2[planlevel.id] = {};

      this.selectedPackagesavailableTiers3[planlevel.id] = {};
      this.selectedPackagesassignedTiers3[planlevel.id] = {};
      this.selectedPackagesavailableTiers3Block3[planlevel.id] = {};
      this.selectedPackagesassignedTiers3Block3[planlevel.id] = {};
      planlevel.groups.forEach((groups: any) => {
        groups.subGroups.forEach((subgroup: any) => {
          this.selectedPackagesavailableTiers2[planlevel.id][subgroup.id] =
            null;
          this.selectedPackagesassignedTiers2[planlevel.id][subgroup.id] = [];
          this.selectedPackagesavailableTiers2Block2[planlevel.id][
            subgroup.id
          ] = null;
          this.selectedPackagesassignedTiers2Block2[planlevel.id][subgroup.id] =
            [];

          this.selectedPackagesavailableTiers3[planlevel.id][subgroup.id] =
            null;
          this.selectedPackagesassignedTiers3[planlevel.id][subgroup.id] = [];
          this.selectedPackagesavailableTiers3Block3[planlevel.id][
            subgroup.id
          ] = null;
          this.selectedPackagesassignedTiers3Block3[planlevel.id][subgroup.id] =
            [];
          subgroup.tiers = [];
          subgroup.checked = false;
          subgroup.coverage = ''; //default
        });
      });
    });

    sessionStorage.setItem('planResults', JSON.stringify(this.plansBlock1));
    sessionStorage.setItem(
      'plansBlock1Tiers',
      JSON.stringify(this.plansBlock1Tiers)
    );
    this.assignAllplanLvelwithdisallowed(this.plansBlock1);
    const dom: HTMLElement = this.elementRef.nativeElement;
    const element: any = dom.querySelector('#plancheck' + 16);
    element.click();

    setTimeout(() => {
      this.plansBlock1.forEach((element: any, index: number) => {
        if (element.id != 1) {
          const element1: any = dom.querySelector(
            '#plancheckcollapseone' + element.id
          );
          element1.click();
        } else {
          element.groups.forEach((groups: any, index1: number) => {
            const element1: any = dom.querySelector(
              '#plancheckcollapseone' + groups.id
            );
            console.log(element1);
          });
        }
      });
    }, 10);
  }

  checkCorporationExist() {
    let corporation = this.client['corporationName'].value;
    let accessToken = sessionStorage.getItem('accessToken');
    //localhost:3002/api/ap/admin/corporate/checkCorporateName'
    let endPoint = `/api/ap/admin/corporate/checkCorporateName`;
    let inputData = {
      'name': corporation
    }
    this.http.post(environment.apiUrl + endPoint, inputData, {
      headers: {
        Authorization: 'Bearer ' + accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response.status == '200') {//new corporate
        return false;
      }
      else {//Already exist
        Swal.fire({ title: 'Info', text: response.message }).then((result) => {
          if (result.isConfirmed) {
            this.client['corporationName'].setValue('');
          }
        });
      }
    }, (error) => {
      Swal.fire({ title: this.lang.Error ?? 'Error', text: error.message ?? error.error.message })
    })
  }


  getProfilebasedid(event) {
    console.log(event)
    let value = +event.target.value
    var endPoint = '/api/ap/broker/' + value + '/profiles';
    var accessToken = sessionStorage.getItem('accessToken');

    this.http
      .get(environment.apiUrl + endPoint, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe((response: any) => {
        if (response['status'] == 200) {
          this.brokerProfileslist = this.parseAllValuesInArray(response.data.profiles);
          console.log(this.brokerProfileslist)
          this.corporateDetails = { ...this.corporateDetails, parentName: this.brokerProfileslist[0]?.additionalData?.brokerFullDetails[0]?.name }
          console.log('this.corporateDetails parentname', this.corporateDetails)
        }
      });
  }
  parseAllValuesInArray(arr: any[]): any[] {
    return arr.map(obj => {
      const parsedObj: any = {};
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          try {
            parsedObj[key] = JSON.parse(obj[key]);
          } catch (e) {
            parsedObj[key] = obj[key]; // If parsing fails, retain original value
          }
        }
      }
      return parsedObj;
    });
  }
  textChangeToLowerCase(formGroup: any, formcontrolField: any) {
    formGroup[formcontrolField].setValue(formGroup[formcontrolField].value.toLowerCase());
  }
  othersField(event: any) {
    if (event.target.value == "CORPORATE_OTHERS") {
      this.showOtherField = true;
      this.adminform.get('roleName').setValidators(Validators.required);
      this.adminform.get('roleName').updateValueAndValidity();
    }
    else {
      this.showOtherField = false;
      this.adminform.get('roleName').clearValidators();
      this.adminform.get('roleName').updateValueAndValidity();
    }
  }
  public submitbasicInfo() {

    // $('#basicformSubmit1stScreen').prop('disabled', true)
    // this._LoaderService.ShowLoader();
    // sessionStorage.setItem('summaryBlockBulk', '[]');
    // sessionStorage.setItem('summaryBlock1', '[]');
    // sessionStorage.setItem('summaryBlock2', '[]');
    // sessionStorage.setItem('summaryBlock3', '[]');

    this.showEmployeeValue = this.clientregform.value.expectednoofEmployees || ""
    this.showEmployeeValue1 = this.clientregform.value.expectednoofEmployees || ""

    this.showinputbox = "121"

    // const submitbasicInfoEnableDisable = document.getElementById("basicformSubmit1stScreen") as HTMLButtonElement;
    // if (submitbasicInfoEnableDisable) {
    //   submitbasicInfoEnableDisable.disabled = true;
      // this._LoaderService.ShowLoader();
      console.log(this.clientregform);
      let customSelectedError = false;
      this.clientregform
        .get('waitingPeriod')
        .setValue(this.clientregform.get('waitingPeriod').value ?? '');





      if (this.clientregform.invalid || (!this.adminData || this.adminData.length === 0)) {
        this.adminform.markAllAsTouched()
        console.log(JSON.stringify(this.clientregform.value, null, 2));
        this.clientregform.markAllAsTouched();


        return;
        this.adminError = false;

        if (this.adminData.length <= 0) {
          this.adminError = true
          console.log({ adminerror: this.adminError })
          this.adminform.markAllAsTouched()
          setTimeout(() => {
            // submitbasicInfoEnableDisable.disabled = false;
            this._LoaderService.HideLoader();
          }, 500);
          return;
        }
      }
      else {


        this._LoaderService.ShowLoader();


        var accessToken = sessionStorage.getItem('accessToken');
        var customerValidation = '/api/ap/admin/v2/corporate/customer/validation';

        // this.checkboxCheck = {}
        // this.showHeadCount = {}
        // this.showinputboxvalue = {}

        sessionStorage.setItem(
          'requireEmployeeName',
          this.clientregform.value.ShowEmployer
        );

        // sessionStorage.setItem('planResults', JSON.stringify(this.plansBlock1));

        this.maxEmployeeCount = this.clientregform.value.expectednoofEmployees;
        var voidfileExtension = '';
        let voidcheckDetails = '';
        let logoDetails = '';

        if (this.bankDetails) {
          voidfileExtension = '.' + this.voidcheckfile.name.split('.').pop();
          (voidcheckDetails = this.voidcheckfile),
            'void_cheque_' + Date.now() + voidfileExtension.toLowerCase();
        } else {
          voidcheckDetails = '';
        }

        if (this.uploadadminlogoimg) {
          (logoDetails = this.uploadadminlogoimg),
            'Admin_logo' +
            Date.now() +
            '.' +
            this.uploadadminlogoimg.name.split('.').pop().toLowerCase();
        } else {
          logoDetails = '';
        }

        this.session = sessionStorage.getItem('session');

        var padinfo: any;
        var creditCardinfo;
        var invoicemonthy;
        if (this.clientregform.value.paymentInfo == 'pad') {
          padinfo = 'true';
        } else if (this.clientregform.value.paymentInfo == 'creditcard') {
          creditCardinfo = 'true';
        } else {
          invoicemonthy = 'true';
        }

        var formdata = new FormData();
        let shoeemp = this.clientregform.value.ShowEmployer == 'true' ? true : false;

        // formdata.append('corporationName',
        //   this.capitalize(this.clientregform.value.corporationName)
        // );
        formdata.append('corporationName', (this.clientregform.value.corporationName));
        formdata.append(
          'requireEmployeeName',
          this.clientregform.value.ShowEmployer
        );
        // this.clientregform.value.ShowEmployer
        formdata.append('brokerType', 'CORPORATE');
        formdata.append(
          'workingProvinces',
          JSON.stringify(this.multiSelectProviance)
        );
        formdata.append('cpPlanAutoSelection', this.clientregform.value.autoSelectEmp);

        formdata.append(
          'policyStartDate',
          this.datePipe.transform(
            this.clientregform.value.PolicyStartDate,
            'yyyy-MM-dd'
          ) || '0000-00-00'
        );

        formdata.append('logo', logoDetails);

        formdata.append('fuseBillCustomerCreation', 'true');

        formdata.append('voidCheck', voidcheckDetails);

        formdata.append('gropupAdmin', JSON.stringify(this.adminData));
        let waitingPeriod;
        if (this.customSelected && this.clientregform.value.waitingPeriod == 'Custom') {
          waitingPeriod = this.clientregform.value.waitingPeriodCustom || 0;

        } else {
          waitingPeriod = this.clientregform.value.waitingPeriod || 0;
        }
        formdata.append(
          'waitingPeriod',
          waitingPeriod || 0
        );
        // formdata.append(
        //   'waitingPeriod',
        //   this.clientregform.value.waitingPeriod || 0
        // );
        formdata.append(
          'corporateEmployeesInitialSignupWaittime',
          this.clientregform.value.waitingPeriodinitialsignup
        );

        formdata.append('useCreditCard', creditCardinfo ? 'true' : 'false');

        // formdata.append('invoicePayment', invoicemonthy ? 'true' : 'false');
        //Invoices are not using so send as false
        formdata.append('invoicePayment', invoicemonthy ? 'false' : 'false');

        formdata.append('padPayment', padinfo ? 'true' : 'false');

        formdata.append('session', this.session);

        formdata.append('setupWallet', this.clientregform.value.walletConfig);

        formdata.append(
          'setUplevelofCoverage',
          this.clientregform.value.tierConfig
        );

        formdata.append(
          'exptNumofEmp',
          this.clientregform.value.expectednoofEmployees || 0
        );

        formdata.append(
          'streetAddressLine1',
          this.capitalize(this.clientregform.value.streetAddress) || ''
        );

        formdata.append(
          'streetAddressLine2',
          this.capitalize(this.clientregform.value.streetAddress2) || ''
        );
        formdata.append('apt', this.clientregform.value.apt_suite || '');

        formdata.append('city', this.capitalize(this.clientregform.value.city));

        formdata.append('province', this.clientregform.value.Province);

        formdata.append('provinceId', this.provincelistid);

        formdata.append('state', this.clientregform.value.Province);

        formdata.append('stateId', this.state_id);

        formdata.append('country', this.clientregform.value.country);

        formdata.append('countryId', '1');
        formdata.append('fbcountryId', '124');
        // formdata.append('parentId', this.clientregform.value.brokerName || 0);
        formdata.append('parentId', this.clientregform.value.profile || 1); //1 is Groupbenefitz TPA/MGA


        formdata.append('postalCode', this.clientregform.value.postalCode);
        formdata.append(
          'corporateClientId',
          sessionStorage.getItem('corporateClientId') ||
          environment.corporateClientId
        ); //fusebillid
        formdata.append(
          'corporateId',
          sessionStorage.getItem('corporateId') || '0'
        ); //corporateid
        // formdata.append('originalBrokerId', this.clientregform.value.profile);

        this.clientregform.value['logo'] = logoDetails;
        sessionStorage.setItem(
          'formData',
          JSON.stringify(this.clientregform.value)
        );

        this.CorporateFormData = formdata
        var requestOptions: any = {
          method: 'POST',
          body: formdata,
          redirect: 'follow',
          headers: { Authorization: 'Bearer ' + accessToken },
        };

        // console.log(requestOptions)

        fetch(environment.apiUrl + customerValidation, requestOptions)
          .then((response) => response.text())

          .then(
            async (response: any) => {
              // console.log(response);
              response = JSON.parse(response);
              if (response.status == 200) {
                var getClients = '/api/ap/admin/corporate/details/false';

                // await postServiceWorkerMessage(WorkerMessageType.Delete, [
                //   environment.apiUrl + getClients
                // ]);

                this.addadminFinal(response.data.corporateId)
                this.coreplantemplateValue = null;
                this.plansBlock1 = response.plans.packages;

                this.corePlans = response.plans.packages;

                this.balkPlans = response.plans.bulkPackages;

                this.plansBlock1Tiers = response.plans.packages;

                this.plansBlock1.forEach((planlevel: any) => {
                  planlevel.groups.forEach((groups: any) => {
                    groups.subGroups.forEach((subgroup: any) => {
                      subgroup.tiers = [];
                      subgroup.checked = false;
                    });
                  });
                });
                this.plansBlock1Tiers.forEach((planlevel: any) => {
                  this.selectedPackagePlansInfoTier[planlevel.id] = [];
                  this.selectedPackagePlansInfoTiername[planlevel.id] =
                    planlevel.name;
                  this.selectedPackagePlansInfoTierBlock2[planlevel.id] = [];
                  this.selectedPackagePlansInfoTiernameBlock2[planlevel.id] =
                    planlevel.name;
                  this.selectedPackagePlansInfoTierBlock3[planlevel.id] = [];
                  this.selectedPackagePlansInfoTiernameBlock3[planlevel.id] =
                    planlevel.name;

                  this.selectedPackagesavailableTiers2[planlevel.id] = {};
                  this.selectedPackagesassignedTiers2[planlevel.id] = {};
                  this.selectedPackagesavailableTiers2Block2[planlevel.id] = {};
                  this.selectedPackagesassignedTiers2Block2[planlevel.id] = {};

                  this.selectedPackagesavailableTiers3[planlevel.id] = {};
                  this.selectedPackagesassignedTiers3[planlevel.id] = {};
                  this.selectedPackagesavailableTiers3Block3[planlevel.id] = {};
                  this.selectedPackagesassignedTiers3Block3[planlevel.id] = {};
                  planlevel.groups.forEach((groups: any) => {
                    groups.subGroups.forEach((subgroup: any) => {
                      this.selectedPackagesavailableTiers2[planlevel.id][
                        subgroup.id
                      ] = null;
                      this.selectedPackagesassignedTiers2[planlevel.id][
                        subgroup.id
                      ] = [];
                      this.selectedPackagesavailableTiers2Block2[planlevel.id][
                        subgroup.id
                      ] = null;
                      this.selectedPackagesassignedTiers2Block2[planlevel.id][
                        subgroup.id
                      ] = [];

                      this.selectedPackagesavailableTiers3[planlevel.id][
                        subgroup.id
                      ] = null;
                      this.selectedPackagesassignedTiers3[planlevel.id][
                        subgroup.id
                      ] = [];
                      this.selectedPackagesavailableTiers3Block3[planlevel.id][
                        subgroup.id
                      ] = null;
                      this.selectedPackagesassignedTiers3Block3[planlevel.id][
                        subgroup.id
                      ] = [];
                      subgroup.tiers = [];
                      subgroup.checked = false;
                      subgroup.coverage = ''; //default
                    });
                  });
                });

                this.executeBlocks()
                  .then((message) => console.log(message))
                  .catch((error) => console.error("An error occurred:", error));



                sessionStorage.setItem(
                  'planResults',
                  JSON.stringify(this.plansBlock1)
                );
                sessionStorage.setItem(
                  'plansBlock1Tiers',
                  JSON.stringify(this.plansBlock1Tiers)
                );

                setTimeout(() => {
                  $('#executiveplanssingle17').prop('disabled', true);
                  $('#executiveplanscouple17').prop('disabled', true);
                  $('#executiveplansfamily17').prop('disabled', true);
                  $('#executiveplanssingle18').prop('disabled', true);
                  $('#executiveplanscouple18').prop('disabled', true);
                  $('#executiveplansfamily18').prop('disabled', true);

                  $('#executiveplansTiersingle17').prop('disabled', true);
                  $('#executiveplansTiercouple17').prop('disabled', true);
                  $('#executiveplansTierfamily17').prop('disabled', true);
                  $('#executiveplansTiersingle18').prop('disabled', true);
                  $('#executiveplansTiercouple18').prop('disabled', true);
                  $('#executiveplansTierfamily18').prop('disabled', true);

                  $('#executiveplansblock2single17').prop('disabled', true);
                  $('#executiveplansblock2couple17').prop('disabled', true);
                  $('#executiveplansblock2family17').prop('disabled', true);
                  $('#executiveplansblock2single18').prop('disabled', true);
                  $('#executiveplansblock2couple18').prop('disabled', true);
                  $('#executiveplansblock2family18').prop('disabled', true);
                }, 1000);

                // if(this.existingPlans.length>0){
                //   for()
                // }

                this.updateAllStatus();

                this.assignAllplanLvelwithdisallowed(this.plansBlock1);
                this.headerComponent.headerDetails('login');
                this.headerComponent.applicationStatus(this.lengthofstatus);
                // this.plansBlock1 =response.plans.packages
                this.corporateId = response.data.corporateId;
                this.corporateClientId = response.data.fuseBillId;
                this.assignAllplanLvelwithdisallowedTiers(this.plansBlock1Tiers);
                sessionStorage.setItem('corporateId', this.corporateId);
                sessionStorage.setItem(
                  'corporateClientId',
                  this.corporateClientId
                );
                sessionStorage.setItem(
                  'corporateClientName',
                  response.data.corporateName
                );
                sessionStorage.setItem(
                  'mainresults',
                  JSON.stringify(this.plansBlock1)
                );
                sessionStorage.setItem(
                  'planResults',
                  JSON.stringify(this.plansBlock1)
                );

                this.basicInfo = false;
                this.plansInfo = true;
                const dom: HTMLElement = this.elementRef.nativeElement;

                this.headerComponent.headerDetails('login');

                if (this.clientregform.value.tierConfig == true) {
                  this.showtierbasicplans = false;
                  this.showtieradvplans = true;
                  this.showtierbasicplans = false;
                  this.showtieradvplans = true;
                  this.showconfigurebutton = true;
                } else {
                  this.showtierbasicplans = true;
                  this.showtieradvplans = false;
                  this.showtierbasicplans = true;
                  this.showtieradvplans = false;
                  this.showconfigurebutton = false;
                }
                if (this.clientregform.value.tierConfig == true) {
                  this.showemptytierconfig = true;
                } else {
                  this.showemptytierconfig = false;
                }
                if (this.clientregform.value.walletConfig == false) {
                  this.showemptywalletConfig = false;
                } else {
                  this.showemptywalletConfig = true;
                }
                // setTimeout(() => {
                //   // const element: any = dom.querySelector('#plancheck' + 16);
                //   // element.click();
                //   let el1: HTMLElement = this.upgradeplansfalse.nativeElement;
                //   el1.click();
                //   this.upgradeplansselection == false;
                //   let el2: HTMLElement = this.employeepurchasefalse.nativeElement;
                //   el2.click();
                //   this.employeeplanpurchase == false;
                // }, 1000);
                let selectedsummaryBlockBulk = JSON.parse(
                  sessionStorage.getItem('summaryBlockBulk') || '[]'
                );
                let selectedplansblock1 = JSON.parse(
                  sessionStorage.getItem('summaryBlock1') || '[]'
                );
                let selectedplansblock2 = JSON.parse(
                  sessionStorage.getItem('summaryBlock2') || '[]'
                );
                let selectedplansblock3 = JSON.parse(
                  sessionStorage.getItem('summaryBlock3') || '[]'
                );

                // this.executeBlocks1(selectedsummaryBlockBulk, selectedplansblock1, selectedplansblock2, selectedplansblock3)
                //   .then((message) => console.log(message))
                //   .catch((error) => console.error("An error occurred:", error));
                // setTimeout(() => {
                //   const dom: HTMLElement = this.elementRef.nativeElement;
                //   if(selectedplansblock1.length>0){
                //   for(let i=0;i<selectedplansblock1.length;i++){
                //     const element: any = dom.querySelector("#plancheck" + selectedplansblock1[i].subGroupId);
                //     element.checked =true
                //     this.plancheckCoverage = selectedplansblock1[i].coverage

                //   }
                // }
                //   if(selectedplansblock2.length>0){
                //     let el1: HTMLElement = this.upgradeplanstrue.nativeElement;
                //     el1.click();
                //     this.upgradeplansselection == true
                //     setTimeout(() => {
                //     for(let i=0;i<selectedplansblock2.length;i++){
                //       const element1: any = dom.querySelector("#plancheck2Upgrade" + selectedplansblock2[i].subGroupId);
                //       element1.checked =true
                //       this.plancheck2Coverage = selectedplansblock2[i].coverage
                //     }
                //   },1000)
                //   }
                //   if(selectedplansblock3.length>0){
                //     let el1: HTMLElement = this.employeepurchasetrue.nativeElement;
                //     el1.click();
                //     this.employeeplanpurchase == true
                //     setTimeout(() => {
                //     for(let i=0;i<selectedplansblock3.length;i++){
                //       const element2: any = dom.querySelector("#plancheck3Voluntry" + selectedplansblock3[i].subGroupId);
                //       element2.checked =true
                //       this.plancheck3Coverage = selectedplansblock3[i].coverage
                //     }
                //   },1500)
                //   }
                // }, 1000);
                sessionStorage.setItem('selectedTiersBlock1', '[]');
                sessionStorage.setItem('selectedTiersBlock2', '[]');
                sessionStorage.setItem('selectedTiersBlock3', '[]');
                this.selectedPackagePlansInfoTier = {};
                this.selectedPackagePlansInfoTierBlock2 = {};
                this.selectedPackagePlansInfoTierBlock3 = {};
                this.selectedPackagePlansInfoTier2 = {};
                this.selectedPackagePlansInfoTier2Block2 = {};
                this.selectedPackagePlansInfoTier3Block3 = {};

                this.seelctedplanLevelTierMapping = [];
                this.seelctedplanLevelTierMappingBlock2 = [];
                this.seelctedplanLevelTierMappingBlock3 = [];

                // this.http.post(environment.apiUrl + '/api/ap/v2/global/set-adminCorporates', { wait: true }).subscribe((newResponse) => {
                this.corporateDetails = {
                  ...this.corporateDetails,
                  id: response.data?.corporateId,
                  name: this.clientregform.value.corporationName,
                  customersCount: 0,
                  bulkEmployeeCount: 0,
                  adminApproved: false,
                  published: true,
                }
                console.log('this.corporateDetails final', this.corporateDetails)

                this.store.dispatch(loadCorporateDataSuccess({ corporateData: [...this.clientList, { ...this.corporateDetails }] }));
                // this.store.dispatch(loadCorporateDataSuccess({ corporateData: [] }));
                // this.store.dispatch(loadCorporateData());
                // })
                this.http.get(environment.apiUrl + '/api/ap/global/set-adminCorporates').subscribe((newResponse) => {
                  this.http.post(environment.reportApiUrl + '/websocket/corporate/notification-to-others', {
                    "message": "Corporates information has been updated. Please refresh screen."
                  }, {
                    headers: {
                      Authorization: 'Bearer ' + accessToken,
                      'Content-Type': 'application/json',
                    }
                  }).subscribe((res) => { })
                })
                this._LoaderService.HideLoader();
                $('#basicformSubmit1stScreen').prop('disabled', false)
                // }
              } else if (response['status'] == 202) {
                this._LoaderService.HideLoader()
                $('#basicformSubmit1stScreen').prop('disabled', false)
                // Swal.fire(this.lang.Error??'Error',response.message);
                Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message });
              } else {
                this._LoaderService.HideLoader()
                $('#basicformSubmit1stScreen').prop('disabled', false)
                Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message || response.error || response.error.error });
              }
            },
            (error) => {
              if (
                error.status == 400 ||
                error.status == 401 ||
                error.status == 402 ||
                error.status == 403
              ) {
                Swal.fire({
                  title: this.lang.Error ?? 'Error',
                  text: error.error.error.message || error.error || error.error.message || error.message,
                  showDenyButton: false,
                  showCancelButton: true,
                  confirmButtonText: 'Proceed',
                }).then((result) => {
                  /* Read more about isConfirmed, isDenied below */
                  if (result.isConfirmed) {
                    sessionStorage.clear();
                    this.router.navigate(['/login']);
                  } else {
                    sessionStorage.clear();
                    this.router.navigate(['/login']);
                  }
                });
              } else {
                // Swal.fire(error.error.error.message)
                Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
              }
              // this.toastrService.error("Invalid Credentials", 'Error!');
            }
          );
        this.scrollToFirstInvalidControl1();
        setTimeout(() => {
          // submitbasicInfoEnableDisable.disabled = false;
          this._LoaderService.HideLoader();
        }, 1000);

        // .catch((error) => console.log(this.lang.Error??'Error', error));


        // if (this.clientregform.invalid) {
        //   return;
        // }      this.scrollToFirstInvalidControl1();
        setTimeout(() => {
          // submitbasicInfoEnableDisable.disabled = false;
          this._LoaderService.HideLoader();
        }, 2000);
      }

    // }
  }



  executeBlocks() {
    return new Promise((resolve, reject) => {
      // First block of code
      console.log("Executing block 1");

      console.log(this.bulkplans)

      // if (this.bulkplans.length > 0) {
      //   for (let i = 0; i < this.bulkplans.length; i++) {


      //     setTimeout(() => {
      //       this.showHeadCount[this.bulkplans[i].planLevelId] = this.bulkplans[i].quantity
      //       const element: any = $("#plancheckboxbulk" + this.bulkplans[i].planLevelId);
      //       if (element != null)
      //         element.click()
      //       // if (this.bulkplans[i].planLevelId == 20) {
      //       //   const element: any = $("#plancheckboxbulk" + this.bulkplans[i].planLevelId);
      //       //   if (element != null)
      //       //     element.click()
      //       //   // setTimeout(() => {
      //       //   //   // this.showEmployeeValue = this.bulkplans[i].quantity

      //       //   // }, 10);

      //       //   if (this.bulkplans[i].subscriptionId && this.bulkplans[i].status != "Draft") {
      //       //     $("#plancheckboxbulk19").prop("disabled", true);
      //       //     $("#plancheckboxbulk20").prop("disabled", true);
      //       //     $("#plancheckboxbulk21").prop("disabled", true);
      //       //     $("#plancheckboxbulk33").prop("disabled", true);

      //       //   }
      //       // }
      //       // else if (this.bulkplans[i].planLevelId == 34) {
      //       //   const element: any = $("#plancheckboxbulk" + this.bulkplans[i].planLevelId);
      //       //   if (element != null)
      //       //     element.click()
      //       //   // setTimeout(() => {
      //       //   //   this.showEmployeeValue1 = this.bulkplans[i].quantity
      //       //   // }, 10);



      //       // }
      //       // else {
      //       //   const element: any = $("#plancheckboxbulk" + this.bulkplans[i].planLevelId);
      //       //   if (element != null)
      //       //     element.click()
      //       //   // setTimeout(() => {
      //       //   //   this.showEmployeeValue = this.bulkplans[i].quantity
      //       //   // }, 10);



      //       // }

      //       if (i === this.bulkplans.length - 1) {
      //         if (this.paidByCompany.length > 0 || this.coveredByCompany.length > 0 || this.paidByEmployee.length > 0) {
      //           for (let i = 0; i < this.paidByCompany.length; i++) {
      //             setTimeout(() => {
      //               let selectedCoverage = this.paidByCompany[i].companyPaidCoverage ?? "DIRECT"
      //               if (selectedCoverage == "null") {
      //                 selectedCoverage = "DIRECT"
      //               }

      //               console.log(selectedCoverage)
      //               this.getPlanCoverage[this.paidByCompany[i].planLevelId] = selectedCoverage
      //               const element: any = $("#plancheck" + this.paidByCompany[i].planLevelId);
      //               console.log({ element })
      //               if (element != null)
      //                 element.click()




      //               console.log(`Block 1 - Task ${i + 1} completed`);
      //               console.log(i)
      //               console.log(this.paidByCompany.length - 1)
      //               if (i === this.paidByCompany.length - 1) {
      //                 // Second block of code

      //                 console.log("Executing block 2");


      //                 setTimeout(() => {
      //                   if (this.coveredByCompany.length > 0) {
      //                     console.log("cehckheree")
      //                     let el1: HTMLElement = this.upgradeplanstrue.nativeElement;
      //                     if (el1 != null) el1.click();
      //                     this.upgradeplansselection == true;

      //                     for (let j = 0; j < this.coveredByCompany.length; j++) {
      //                       setTimeout(() => {
      //                         const element: any = $("#plancheck2Upgrade" + this.coveredByCompany[j].planLevelId);
      //                         if (element != null) element.click();

      //                         console.log(`Block 2 - Task ${j + 1} completed`);
      //                         if (j === this.coveredByCompany.length - 1) {
      //                           // Third block of code
      //                           console.log("Executing block 3");

      //                           setTimeout(() => {
      //                             if (this.paidByEmployee.length > 0) {
      //                               let el1: HTMLElement = this.employeepurchasetrue.nativeElement;
      //                               if (el1 != null) el1.click();
      //                               this.employeeplanpurchase == true
      //                               for (let k = 0; k < this.paidByEmployee.length; k++) {
      //                                 setTimeout(() => {
      //                                   const element: any = $("#plancheck3Voluntry" + this.paidByEmployee[k].planLevelId);
      //                                   element.click()


      //                                   console.log(`Block 3 - Task ${k + 1} completed`);
      //                                   if (k === this.paidByEmployee.length - 1) {
      //                                     resolve("All blocks executed successfully");
      //                                   }
      //                                 }, 1500);
      //                               }
      //                             }
      //                           }, 1000);

      //                         }
      //                       }, 1000);
      //                     }
      //                   }
      //                   if (this.coveredByCompany.length == 0 && this.paidByEmployee.length > 0) {
      //                     let el1: HTMLElement = this.employeepurchasetrue.nativeElement;
      //                     if (el1 != null) el1.click();
      //                     this.employeeplanpurchase == true
      //                     for (let k = 0; k < this.paidByEmployee.length; k++) {
      //                       setTimeout(() => {
      //                         const element: any = $("#plancheck3Voluntry" + this.paidByEmployee[k].planLevelId);
      //                         element.click()

      //                         // setTimeout(() => {
      //                         //   let block1 = JSON.parse(
      //                         //     sessionStorage.getItem('summaryBlock3') || '[]'
      //                         //   );
      //                         //   for (let z = 0; z < block1.length; z++) {
      //                         //     if (block1[z].subGroupId == this.paidByEmployee[i].planLevelId) {
      //                         //       block1[z].id = this.paidByEmployee[i].id
      //                         //     }
      //                         //   }
      //                         //   sessionStorage.setItem('summaryBlock3', JSON.stringify(block1))
      //                         // }, 4000)

      //                         let plancheck3Coverage = this.getExecutiveCoveragesFromCode(this.paidByEmployee[k].coverage)


      //                         if (
      //                           plancheck3Coverage
      //                         ) {
      //                           console.log(this.plancheck3Coverage);
      //                           if (plancheck3Coverage.single) {
      //                             setTimeout(() => {
      //                               $("#executiveplansblock3single" + this.paidByEmployee[k].planLevelId).click()
      //                             }, 100);
      //                           } if (plancheck3Coverage.couple) {
      //                             setTimeout(() => {
      //                               $("#executiveplansblock3couple" + this.paidByEmployee[k].planLevelId).click()
      //                             }, 100);
      //                           } if (plancheck3Coverage.family) {
      //                             setTimeout(() => {
      //                               $("#executiveplansblock3family" + this.paidByEmployee[k].planLevelId).click()
      //                             }, 100);
      //                           }
      //                         }
      //                         console.log(`Block 3 - Task ${k + 1} completed`);
      //                         if (k === this.paidByEmployee.length - 1) {
      //                           resolve("All blocks executed successfully");
      //                         }
      //                       }, 1500);
      //                     }
      //                   }
      //                 }, 2000);

      //               }
      //             }, 1000);
      //           }


      //         }
      //       }
      //     }, 1000);



      //   }
      // }
      if (this.customerPlans.length > 0) {

        for (let i = 0; i < this.customerPlans.length; i++) {
          setTimeout(() => {
            // let selectedCoverage = this.paidByCompany[i].companyPaidCoverage ?? "DIRECT"
            // if (selectedCoverage == "null") {
            //   selectedCoverage = "DIRECT"
            // }
            let selectedCoverage = "DIRECT"

            // console.log(this.capitalize(selectedCoverage))
            this.getPlanCoverage[this.customerPlans[i].planSelectionId2] = selectedCoverage
            const element: any = $("#plancheck" + this.customerPlans[i].planSelectionId2);
            console.log({ element })
            if (element != null)
              element.click()

            if (i === this.customerPlans.length - 1) {
              // Second block of code

              console.log("Executing block 2");


              // setTimeout(() => {
              //   if (this.coveredByCompany.length > 0) {
              //     console.log("cehckheree")
              //     let el1: HTMLElement = this.upgradeplanstrue.nativeElement;
              //     if (el1 != null) el1.click();
              //     this.upgradeplansselection == true;

              //     for (let j = 0; j < this.coveredByCompany.length; j++) {
              //       setTimeout(() => {
              //         const element: any = $("#plancheck2Upgrade" + this.coveredByCompany[j].planLevelId);
              //         if (element != null) element.click();


              //         if (j === this.coveredByCompany.length - 1) {
              //           // Third block of code
              //           console.log("Executing block 3");

              //           setTimeout(() => {
              //             if (this.paidByEmployee.length > 0) {
              //               let el1: HTMLElement = this.employeepurchasetrue.nativeElement;
              //               if (el1 != null) el1.click();
              //               this.employeeplanpurchase == true
              //               for (let k = 0; k < this.paidByEmployee.length; k++) {
              //                 setTimeout(() => {
              //                   const element: any = $("#plancheck3Voluntry" + this.paidByEmployee[k].planLevelId);
              //                   element.click()
              //                   console.log(`Block 3 - Task ${k + 1} completed`);
              //                   if (k === this.paidByEmployee.length - 1) {
              //                     resolve("All blocks executed successfully");
              //                   }
              //                 }, 1500);
              //               }
              //             }
              //           }, 1000);

              //         }
              //       }, 1000);
              //     }
              //   }
              //   if (this.coveredByCompany.length == 0 && this.paidByEmployee.length > 0) {
              //     let el1: HTMLElement = this.employeepurchasetrue.nativeElement;
              //     if (el1 != null) el1.click();
              //     this.employeeplanpurchase == true
              //     for (let k = 0; k < this.paidByEmployee.length; k++) {
              //       setTimeout(() => {
              //         const element: any = $("#plancheck3Voluntry" + this.paidByEmployee[k].planLevelId);
              //         element.click()
              //         console.log(`Block 3 - Task ${k + 1} completed`);
              //         if (k === this.paidByEmployee.length - 1) {
              //           resolve("All blocks executed successfully");
              //         }
              //       }, 1500);
              //     }
              //   }
              // }, 2000);





            }
          }, 1000);
        }
      }

      setTimeout(() => {
        let block1 = JSON.parse(
          sessionStorage.getItem('summaryBlock1') || '[]'
        );
        for (let i = 0; i < this.paidByCompany.length; i++) {
          for (let z = 0; z < block1.length; z++) {

            if (block1[z].subGroupId == this.paidByCompany[i].planLevelId) {
              block1[z].id = this.paidByCompany[i].id
            }
          }
        }
        sessionStorage.setItem('summaryBlock1', JSON.stringify(block1))

        let block2 = JSON.parse(
          sessionStorage.getItem('summaryBlock2') || '[]'
        );
        console.log(this.coveredByCompany)
        for (let i = 0; i < this.coveredByCompany.length; i++) {
          for (let z = 0; z < block2.length; z++) {

            if (block2[z].subGroupId == this.coveredByCompany[i].planLevelId) {
              block2[z].id = this.coveredByCompany[i].id
            }
          }
        }
        console.log({ block2 })
        sessionStorage.setItem('summaryBlock2', JSON.stringify(block2))

        let block3 = JSON.parse(
          sessionStorage.getItem('summaryBlock3') || '[]'
        );
        for (let i = 0; i < this.paidByEmployee.length; i++) {
          for (let z = 0; z < block3.length; z++) {

            if (block3[z].subGroupId == this.paidByEmployee[i].planLevelId) {
              block3[z].id = this.paidByEmployee[i].id
            }
          }
        }
        sessionStorage.setItem('summaryBlock3', JSON.stringify(block3))
      }, 10000)


    })
  }
  // executeBlocks() {


  //   return new Promise((resolve, reject) => {
  //     // First block of code
  //     console.log("Executing block 1");
  //     let summaryBlockBulkA = JSON.parse(
  //       sessionStorage.getItem('summaryBlockBulk') || '[]'
  //     );
  //     let summaryBlock1 = JSON.parse(
  //       sessionStorage.getItem('summaryBlock1') || '[]'
  //     );
  //     let summaryBlock2 = JSON.parse(
  //       sessionStorage.getItem('summaryBlock2') || '[]'
  //     );

  //     let summaryBlock3 = JSON.parse(
  //       sessionStorage.getItem('summaryBlock3') || '[]'
  //     );
  //     // alert(this.clientregform.value.expectednoofEmployees)
  //     let selectedsummaryBlockBulk = JSON.parse(
  //       sessionStorage.getItem('summaryBlockBulk') || '[]'
  //     );
  //     for (let i = 0; i < selectedsummaryBlockBulk.length; i++) {

  //       // this.showEmployeeValue = selectedsummaryBlockBulk[i].quantity
  //       // this.showinputbox = selectedsummaryBlockBulk[i].subgroupindex
  //       setTimeout(() => {
  //         if (selectedsummaryBlockBulk[i].packageid == 2) {
  //           if (selectedsummaryBlockBulk[i].quantity) {
  //             this.showEmployeeValue = selectedsummaryBlockBulk[i].quantity
  //           }
  //           else {
  //             this.showEmployeeValue = this.clientregform.value.expectednoofEmployees || ""

  //           }
  //         }
  //         else {
  //           if (selectedsummaryBlockBulk[i].quantity) {
  //             this.showEmployeeValue1 = selectedsummaryBlockBulk[i].quantity
  //           }
  //           else {
  //             this.showEmployeeValue1 = this.clientregform.value.expectednoofEmployees || ""

  //           }
  //         }

  //       }, 1000);


  //     }





  //     return false;

  //     for (let i = 0; i < summaryBlockBulkA.length; i++) {
  //       setTimeout(() => {
  //         const element: any = $("#plancheckboxbulk" + summaryBlockBulkA[i].subGroupId);
  //         if (element != null)
  //           element.click()
  //         setTimeout(() => {
  //           this.showEmployeeValue = summaryBlockBulkA[i].quantity
  //         }, 10);
  //       }, 1000);

  //     }
  //     for (let i = 0; i < summaryBlock1.length; i++) {
  //       setTimeout(() => {
  //         const element: any = $("#plancheck" + summaryBlock1[i].subGroupId);
  //         if (element != null)
  //           element.click()

  //         if (i === summaryBlock1.length - 1) {
  //           // Second block of code

  //           console.log("Executing block 2");


  //           setTimeout(() => {
  //             if (summaryBlock2.length > 0) {
  //               console.log("cehckheree")
  //               let el1: HTMLElement = this.upgradeplanstrue.nativeElement;
  //               if (el1 != null) el1.click();
  //               this.upgradeplansselection == true;

  //               for (let j = 0; j < summaryBlock2.length; j++) {
  //                 setTimeout(() => {
  //                   const element: any = $("#plancheck2Upgrade" + summaryBlock2[j].subGroupId);
  //                   if (element != null) element.click();
  //                   console.log(`Block 2 - Task ${j + 1} completed`);
  //                   if (j === summaryBlock2.length - 1) {
  //                     // Third block of code
  //                     console.log("Executing block 3");

  //                     setTimeout(() => {
  //                       if (summaryBlock3.length > 0) {
  //                         let el1: HTMLElement = this.employeepurchasetrue.nativeElement;
  //                         if (el1 != null) el1.click();
  //                         this.employeeplanpurchase == true
  //                         for (let k = 0; k < summaryBlock3.length; k++) {
  //                           setTimeout(() => {
  //                             const element: any = $("#plancheck3Voluntry" + summaryBlock3[k].subGroupId);
  //                             element.click()
  //                             console.log(`Block 3 - Task ${k + 1} completed`);
  //                             if (k === summaryBlock3.length - 1) {
  //                               resolve("All blocks executed successfully");
  //                             }
  //                           }, 1500);
  //                         }
  //                       }
  //                     }, 1000);

  //                   }
  //                 }, 1000);
  //               }
  //             }
  //             if (summaryBlock2.length == 0 && summaryBlock3.length > 0) {
  //               let el1: HTMLElement = this.employeepurchasetrue.nativeElement;
  //               if (el1 != null) el1.click();
  //               this.employeeplanpurchase == true
  //               for (let k = 0; k < summaryBlock3.length; k++) {
  //                 setTimeout(() => {
  //                   const element: any = $("#plancheck3Voluntry" + summaryBlock3[k].subGroupId);
  //                   element.click()
  //                   console.log(`Block 3 - Task ${k + 1} completed`);
  //                   if (k === summaryBlock3.length - 1) {
  //                     resolve("All blocks executed successfully");
  //                   }
  //                 }, 1500);
  //               }
  //             }
  //           }, 2000);





  //         }
  //       }, 1000);
  //     }
  //   });
  // }
  scrollToFirstInvalidControl1() {
    // const firstInvalidControl: HTMLElement =
    //   this.elementRef.nativeElement.querySelector(
    //     'form .ng-invalid' || 'form .ng-untouched'
    //   );

    // // console.log(firstInvalidControl)
    // window.scroll({
    //   top: this.getTopOffset(firstInvalidControl),
    //   left: 0,
    //   behavior: 'smooth',
    // });
  }
  getTopOffset(controlEl: HTMLElement): number {
    const labelOffset = 300;
    return controlEl.getBoundingClientRect().top + window.scrollY - labelOffset;
  }
  public submitplansInfo() {

    let palnRes = sessionStorage.getItem('planResults') || '[]';

    let Block1 = sessionStorage.getItem('summaryBlock1') || '[]';



    // return false;

    this.corporationclient = this.clientregform.value.corporationName;
    // let formData = JSON.parse(sessionStorage.getItem('formData') || '');

    // return false
    var corporateId = sessionStorage.getItem('corporateId');

    var accessToken = sessionStorage.getItem('accessToken');
    var endPoint = '/api/ap/admin/corporate/' + corporateId + '/planSelections';
    let bulkPlans: { planLevelId: any; quantity: any, tierId: number; parentPlanLevelId: number; subGrpname: any }[] = [];

    let paidByCompany: {
      planLevelId: any;
      tierId: number;
      parentPlanLevelId: number;
    }[] = [];
    let coveredByCompany: {
      planLevelId: any;
      tierId: number;
      parentPlanLevelId: number;
    }[] = [];
    let paidByEmployees: {
      planLevelId: any;
      tierId: number;
      parentPlanLevelId: number;
    }[] = [];

    // let TierlistforGrapsh: { planLevelName: any; tierId: number }[] = [];

    // let summaryBlock1 = JSON.parse(
    //   sessionStorage.getItem('summaryBlock1') || '[]'
    // );
    // let summaryBlock2 = JSON.parse(
    //   sessionStorage.getItem('summaryBlock2') || '[]'
    // );
    // let requireEmployeeName = JSON.parse(
    //   sessionStorage.getItem('requireEmployeeName')
    // );
    // let summaryBlock3 = JSON.parse(
    //   sessionStorage.getItem('summaryBlock3') || '[]'
    // );
    // let summaryBlock1=[];
    // let summaryBlock2=[];
    // let summaryBlock3=[];

    let summaryBlockBulkA = JSON.parse(
      sessionStorage.getItem('summaryBlockBulk') || '[]'
    );
    let summaryBlock1 = JSON.parse(
      sessionStorage.getItem('summaryBlock1') || '[]'
    );
    let summaryBlock2 = JSON.parse(
      sessionStorage.getItem('summaryBlock2') || '[]'
    );

    let summaryBlock3 = JSON.parse(
      sessionStorage.getItem('summaryBlock3') || '[]'
    );

    //   summaryBlock1 = summaryBlock1A.filter((item, index, self) =>
    // index === self.findIndex((t) => (
    //   t.planLevelId === item.planLevelId
    // ))
    // );
    // summaryBlock2 = summaryBlock2A.filter((item, index, self) =>
    // index === self.findIndex((t) => (
    //   t.planLevelId === item.planLevelId
    // ))
    // );
    //   summaryBlock3 = summaryBlock3A.filter((item, index, self) =>
    //   index === self.findIndex((t) => (
    //     t.planLevelId === item.planLevelId
    //   ))
    // );



    let summaryTiersBlock3 = JSON.parse(
      sessionStorage.getItem('selectedTiersBlock3') || '[]'
    );
    let formData = JSON.parse(sessionStorage.getItem('formData') || '');

    this.tierConfigCheck = formData.tierConfig == true ? true : false;
    this.walletConfigCheck = formData.walletConfig == true ? true : false;

    if (formData.tierConfig == false) {
      this.upgradertierscheck = this.upgradeplansselection;
      this.employeeplanpurchasetierscheck = this.employeeplanpurchase;
      summaryBlockBulkA.forEach((element: any) => {
        let obj = {
          planLevelId: parseInt(element.subGroupId),//subGroupId
          tierId: 0,
          quantity: element.subGroupId != 38 ? parseInt(this.showHeadCount[element.subGroupId]) : 0,
          coverage: element.coverage ? element.coverage : '',
          parentPlanLevelId: element.parentId ? parseInt(element.parentId) : 0,
          subscriptionId: '',
          subGrpname: element.subGrpname,

        };
        bulkPlans.push(obj);
      });
      summaryBlock1.forEach((element: any) => {
        let obj = {
          planLevelId: parseInt(element.subGroupId),
          tierId: 0,
          coverage: element.coverage ? element.coverage : '',
          parentPlanLevelId: element.parentId ? parseInt(element.parentId) : 0,
          settings: element?.settingsAdditional || {},
          companyPaidCoverage: this.getPlanCoverage[element.subGroupId] || "DIRECT"

        };
        paidByCompany.push(obj);
      });
      console.log({ paidByCompany })
      summaryBlock2.forEach((element: any) => {
        let obj = {
          planLevelId: parseInt(element.subGroupId),
          tierId: 0,
          coverage: element.coverage ? element.coverage : '',
          parentPlanLevelId: element.parentId ? parseInt(element.parentId) : 0,
          settings: element?.settingsAdditional || {}
        };
        coveredByCompany.push(obj);
      });
      summaryBlock3.forEach((element: any) => {
        let obj = {
          planLevelId: parseInt(element.subGroupId),
          tierId: 0,
          coverage: element.coverage ? element.coverage : '',
          parentPlanLevelId: element.parentId ? parseInt(element.parentId) : 0,
          settings: element?.settingsAdditional || {}
        };
        paidByEmployees.push(obj);
      });
    } else {
      this.upgradertierscheck = this.upgradeplansselectiontiers;
      this.employeeplanpurchasetierscheck = this.employeeplanpurchasetiers;
      this.seelctedplanLevelTierMapping.forEach((element: any) => {
        element.tiers.forEach((tiers: any) => {
          let obj = {
            planLevelId: parseInt(element.subGroupid),
            tierId: parseInt(tiers.id),
            coverage: element.coverage,
            parentPlanLevelId: element.parentId ? parseInt(element.parentId) : 0,
          };
          paidByCompany.push(obj);
        });
      });
      console.log({ paidByCompany })
      this.seelctedplanLevelTierMapping.forEach((element: any) => {
        let array = [];
        element.tiers.forEach((tiers: any) => {
          let obj: any = {
            planLevelName: element.subGroupName,
            tierId: tiers.name,
          };
          this.TierlistforGrapsh.push(obj);
        });
      });
      this.seelctedplanLevelTierMappingBlock2.forEach((element: any) => {
        element.tiers.forEach((tiers: any) => {
          let obj = {
            planLevelId: parseInt(element.subGroupid),
            tierId: parseInt(tiers.id),
            coverage: element.coverage,
            parentPlanLevelId: element.parentId ? parseInt(element.parentId) : 0,
          };
          coveredByCompany.push(obj);
        });
      });
      this.seelctedplanLevelTierMappingBlock3.forEach((element: any) => {
        element.tiers.forEach((tiers: any) => {
          let obj = {
            planLevelId: parseInt(element.subGroupid),
            tierId: parseInt(tiers.id),
            coverage: element.coverage,
            parentPlanLevelId: element.parentId ? parseInt(element.parentId) : 0,
          };
          paidByEmployees.push(obj);
        });
      });
    }

    // console.log(typeof  formData.tierConfig)
    // console.log(formData.walletConfig)
    this.planRequestBody = {
      configuration: {
        tier: formData.tierConfig == true ? true : false,
        wallet: formData.walletConfig == true ? true : false,
      },
      bulkPlans: bulkPlans,
      bulkPlansIncluded: bulkPlans.length > 0 ? true : false,

      paidByCompany: paidByCompany,
      // "upgradedPlans": [{"planLevelId": 0, "tierId": 0}],
      // "employeePurchasePlans": [{"planLevelId": 0,"tierId": 0}],
      coveredByCompany: coveredByCompany.length > 0 ? coveredByCompany : [],
      paidByEmployee: paidByEmployees.length > 0 ? paidByEmployees : [],
      enableCoveredByCompany: this.upgradeplansselection
        ? true
        : false || this.upgradeplansselectiontiers
          ? true
          : false,
      enablePaidByEmployee: this.employeeplanpurchase
        ? true
        : false || this.employeeplanpurchasetiers
          ? true
          : false,
      corporateTieredPlanLevelIds: [],
      defaultTier: 0,
      // payRollDeduction:this.payrollOptions || '',
      payRollDeduction: 'YES',
      requireEmployeeName: JSON.parse(
        sessionStorage.getItem('requireEmployeeName')
      ),
    };

    console.log(coveredByCompany);
    console.log(coveredByCompany.length);
    if (this.upgradeplansselection == true) {
      let selectedplansblock2 = JSON.parse(
        sessionStorage.getItem('summaryBlock2') || '[]'
      );

      if (selectedplansblock2.length > 0) {

      } else {
        Swal.fire({ title: this.lang.Info, text: "Please select one Upgrade plan" });
        return false;
      }
    }
    if (this.employeeplanpurchase == true) {
      let selectedplansblock3 = JSON.parse(
        sessionStorage.getItem('summaryBlock3') || '[]'
      );

      if (selectedplansblock3.length > 0) {

      } else {
        Swal.fire({ title: 'Info', text: "Please select one voluntary plan" });
        return false;
      }
    }


    const paidByCompanyfilteredPlans = summaryBlock1.filter((plan: any) => plan.subGrpname.includes('La Vie'));
    const paidByCompanyfilteredExecutive = summaryBlock1.filter((plan: any) => plan.subGroupId == 18);

    const coveredByCompanyfilteredPlans = summaryBlock2.filter((plan: any) => plan.subGrpname.includes('La Vie'));
    const coveredByCompanyfilteredExecutive = summaryBlock2.filter((plan: any) => plan.subGroupId == 18);

    const paidByEmployeesfilteredPlans = summaryBlock3.filter((plan: any) => plan.subGrpname.includes('La Vie'));
    const paidByEmployeesfilteredExecutive = summaryBlock3.filter((plan: any) => plan.subGroupId == 18);

    console.log(coveredByCompanyfilteredPlans)
    console.log(coveredByCompanyfilteredExecutive)
    if (paidByCompanyfilteredPlans.length > 0) {
      if (paidByCompanyfilteredExecutive.length > 0) {

      } else {
        Swal.fire({ title: this.lang.Info, text: "Select Complete Executive Care Plan along with La Vie in Core Plans" });
        return false;
      }
    }
    if (coveredByCompanyfilteredPlans.length > 0) {
      if (coveredByCompanyfilteredExecutive.length > 0) {

      } else {
        Swal.fire({ title: this.lang.Info, text: "Select Complete Executive Care Plan along with La Vie in Upgrade Plans" });
        return false;
      }
    }
    if (paidByEmployeesfilteredPlans.length > 0) {
      if (paidByEmployeesfilteredExecutive.length > 0) {

      } else {
        Swal.fire({ title: this.lang.Info, text: "Select Complete Executive Care Plan along with La Vie in Voluntry Plans" });
        return false;
      }
    }

    // this.submitplansSections()
    // if (coveredByCompany.length > 1) {
    //   // $('#payrolldeduction-modal').modal('show');
    //   // this.payrolldeductionoption.reset();
    //   this.submitplansSections();
    // } else {
    //   this.payrollOptions = '';
    //   // this.payrolldeduction=
    //   this.submitplansSections();
    // }
    if (coveredByCompany.length > 1) {
      // $('#payrolldeduction-modal').modal('show');
      // this.payrolldeductionoption.reset();

      let bulkplansCheck = bulkPlans.filter(
        (element: any) => Number.isNaN(element.quantity)
      );
      let bulkplansCheckCloud = bulkPlans.filter(
        (element: any) => element.planLevelId == "33"
      );

      if (bulkplansCheck.length > 0) {
        for (let i = 0; i < bulkplansCheck.length; i++) {
          Swal.fire({ title: 'Info', text: `Please enter head count for ${bulkplansCheck[i].subGrpname} ` });

          return false;
        }
      } else {
        this.plansSumitInfo()
      }

      // if (bulkplansCheck.length > 0) {
      //   Swal.fire({ title: 'Info', text: "Please enter head count" });

      //   return false;
      // }
      // else {
      //   if (bulkplansCheckCloud.length > 0) {
      //     if (bulkplansCheckCloud[0].quantity >= 100) {

      //       this.plansSumitInfo()

      //     }
      //     else {
      //       Swal.fire({ title: 'Info', text: "This is allowed only if the head count is minimum of 100" });
      //       return false;


      //     }
      //   }
      //   else {
      //     this.submitplansSections();
      //   }

      // }

    }
    else {
      this.payrollOptions = ""
      // this.payrolldeduction=


      let bulkplansCheck = bulkPlans.filter(
        (element: any) => Number.isNaN(element.quantity)
      );
      let bulkplansCheckCloud = bulkPlans.filter(
        (element: any) => element.planLevelId == "33"
      );

      if (bulkplansCheck.length > 0) {
        for (let i = 0; i < bulkplansCheck.length; i++) {
          Swal.fire({ title: 'Info', text: `Please enter head count for ${bulkplansCheck[i].subGrpname} ` });

          return false;
        }
      } else {
        this.plansSumitInfo()
      }

      // if (bulkplansCheck.length > 0) {
      //   Swal.fire({ title: 'Info', text: "Please enter head count" });

      //   return false;
      // }
      // else {
      //   if (bulkplansCheckCloud.length > 0) {
      //     if (bulkplansCheckCloud[0].quantity >= 100) {

      //       this.plansSumitInfo()

      //     }
      //     else {
      //       Swal.fire({ title: 'Info', text: "This is allowed only if the head count is minimum of 100" });
      //       return false;


      //     }
      //   }
      //   else {
      //     this.submitplansSections();
      //   }

      // }
    }
  }

  public payrolldeductionConfirm() {
    console.log(this.payrolldeductionoption.value.payrolloption);
    this.payrollOptions = this.payrolldeductionoption.value.payrolloption;

    this.planRequestBody['payRollDeduction'] =
      this.payrolldeductionoption.value.payrolloption;
    $('#payrolldeduction-modal').modal('hide');
    this.planRequestBody['requireEmployeeName'] = sessionStorage.getItem(
      'requireEmployeeName'
    );
    this.submitplansSections();
  }
  public payrolldeductionCancel() {
    this.payrollOptions = '';
    this.planRequestBody['payRollDeduction'] = '';

    this.submitplansSections();

    //   console.log(this.planRequestBody.coveredByCompany)
    //   this.planRequestBody.coveredByCompany.forEach((element: any) => {
    //     let obj = {
    //       planLevelId: parseInt(element.subGroupId),
    //       tierId: 0,
    //       coverage: element.coverage ? element.coverage : '',
    //     };
    // if(obj.planLevelId ==17 || obj.planLevelId ==18){

    //   if(obj.coverage=="" || obj.coverage == "000"){
    //     alert("test")
    //   }
    // }
    // else{
    //   this.submitplansSections()
    // }

    //   });
  }

  submitplansSections() {


    let summaryBlockBulk = JSON.parse(
      sessionStorage.getItem('summaryBlockBulk') || '[]')

    if (summaryBlockBulk.length > 0) {
      let bulkplancehck = this.planRequestBody.bulkPlans

      let array = []
      for (let i = 0; i < this.employeeList.length; i++) {
        if (this.employeeList[i].isBulk == true) {
          array.push(this.employeeList[i])
        }


      }

      for (let i = 0; i < bulkplancehck.length; i++) {

        if (bulkplancehck[i].quantity >= 0) {
          let block1Bulkres = JSON.parse(sessionStorage.getItem('summaryBlockBulk'))
          // let obj={"quantity":this.showEmployeeValue}
          if (block1Bulkres[i]["packageid"] == 2) {
            for (let i = 0; i < block1Bulkres.length; i++) {
              block1Bulkres[i]["quantity"] = +this.showEmployeeValue
            }
          } else {

            for (let i = 0; i < block1Bulkres.length; i++) {
              block1Bulkres[i]["quantity"] = +this.showEmployeeValue1
            }
          }
          // block1Bulkres["quantity"]=this.showEmployeeValue
          sessionStorage.setItem('summaryBlockBulk', JSON.stringify(block1Bulkres));
          // if (bulkplancehck[i].planLevelId == "20" || bulkplancehck[i].planLevelId == "34") {

          //   this.addedEmployeelist = this.employeeList
          //   console.log("1")
          //   this.plansSumitInfo()



          // }

          // else if (bulkplancehck[i].planLevelId == "33") {


          //   if (bulkplancehck[i].quantity >= 100) {
          //     console.log("2")
          //     this.plansSumitInfo()

          //   }
          //   else {
          //     Swal.fire({ title: 'Info', text: "This is allowed only if the head count is minimum of 100" });



          //   }

          // }
          // if (bulkplancehck[i].planLevelId == "20" || bulkplancehck[i].planLevelId == "34") {

          //   this.addedEmployeelist = this.employeeList
          //   console.log("1")
          //   this.plansSumitInfo()



          // }

          // if (bulkplancehck[i].planLevelId == "33") {


          //   if (bulkplancehck[i].quantity >= 100) {
          //     console.log("2")
          //     this.plansSumitInfo()

          //   }
          //   else {
          //     Swal.fire({ title: 'Info', text: "This is allowed only if the head count is minimum of 100" });



          //   }

          // }
          // else {
          //   this.addedEmployeelist = this.showEmployeelist
          //   console.log("3")
          //   this.plansSumitInfo()

          // }



        }
        else {
          Swal.fire({ title: 'Info', text: "Please enter head count" });

        }

      }
      this.plansSumitInfo()
    }
    else {
      console.log("4")
      this.plansSumitInfo()
    }

  }

  plansSumitInfo() {

    let bulkBlock = JSON.parse(sessionStorage.getItem('summaryBlockBulk')) || '[]';
    var accessToken = sessionStorage.getItem('accessToken');
    var corporateId = sessionStorage.getItem('corporateId');
    if (bulkBlock.length > 0) {
      bulkBlock.forEach(element => {

        if (element.subGroupId == "20") {
          element["qunatity"] = this.showEmployeeValue

        }
        if (element.subGroupId == "34") {
          element["qunatity"] = this.showEmployeeValue1

        }

      });
    }
    sessionStorage.setItem('summaryBlockBulk', JSON.stringify(bulkBlock))

    let requireEmployeeName = JSON.parse(
      sessionStorage.getItem('requireEmployeeName')
    );
    var endPoint = '/api/ap/admin/corporate/' + corporateId + '/planSelections';
    let formData = JSON.parse(sessionStorage.getItem('formData') || '');

    this.http
      .post(environment.apiUrl + endPoint, this.planRequestBody, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (response: any) => {
          if (response['status'] == 200) {
            // this.employeeWorkingProviance=response.data.working_provinces;
            this.employeeWorkingProviance = response.data.working_provinces.sort(
              (a: any, b: any) => (a.shortName > b.shortName ? 1 : -1)
            );
            this.updateAllStatus();
            this.EmployeeAddData = response.data.employeeKeys;
            this.headerComponent.applicationStatus(7);

            if (
              formData.tierConfig == false &&
              formData.walletConfig == false
            ) {
              this.basicInfo = false;
              this.plansInfo = false;
              this.wallettierInfo = false;
              this.nowalletnotierInfo = false;
              this.EmployeeInfo = false;
              this.walletData = 'No';
              this.TierData = 'No';
              console.log(this.employeeList)
              this.addedEmployeelist = this.employeeList
              this.GetCorpDetails1(corporateId);
              // this.getServiceWorkerDetails(corporateId)


            }
            else if (
              formData.tierConfig == false &&
              formData.walletConfig == true
            ) {
              this.basicInfo = false;
              this.plansInfo = false;
              this.wallettierInfo = true;
              this.nowalletnotierInfo = false;
              this.walletData = 'Selected';
              this.TierData = 'No';
              this.GetCorpDetails1(corporateId);
              // this.getServiceWorkerDetails(corporateId)
            } else if (
              formData.tierConfig == true &&
              formData.walletConfig == true
            ) {
              this.basicInfo = false;
              this.plansInfo = false;
              this.wallettierInfo = true;
              this.nowalletnotierInfo = false;
              this.walletData = 'Selected';
              this.TierData = 'Selected';
              this.GetCorpDetails1(corporateId);
              // this.getServiceWorkerDetails(corporateId)
            } else if (
              formData.tierConfig == true &&
              formData.walletConfig == false
            ) {
              this.basicInfo = false;
              this.plansInfo = false;
              this.wallettierInfo = false;
              this.nowalletnotierInfo = false;
              this.EmployeeInfo = false;
              this.walletData = 'No';
              this.TierData = 'Selected';
              this.GetCorpDetails1(corporateId);
              // this.getServiceWorkerDetails(corporateId)
            }

            this.wallettierInfoandtier = false;
            console.log(this.uploadEmployeeExcelData)

          } else {
            Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message });

            // this.toastrService.error(this.lang.Error??'Error', response.message);
          }
        },
        (error) => {
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: this.lang.Error ?? 'Error',
              text: error.error.error.message,
              showCancelButton: false,
              showDenyButton: false,
              confirmButtonText: 'Proceed',
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              } else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            // Swal.fire(error.error.error.message)
            console.log(error);
            Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.message });
          }
          // this.toastrService.error("Invalid Credentials", 'Error!');
        }
      );
    // }
  }


  public submitTierInfo() {
    var corporateId = sessionStorage.getItem('corporateId');

    let annualIncome = [];

    for (let i = 0; i < this.dynamicArray.length; i++) {
      this.dynamicArray[i].tierName = this.capitalize(
        this.dynamicArray[i].tierName
      );

      if (this.dynamicArray[i].walletAmount.length > 2) {
        this.dynamicArray[i].walletAmount = parseInt(
          this.dynamicArray[i].walletAmount.replace(/\$/g, '')
        );
      } else {
        this.dynamicArray[i].walletAmount = 0;
      }
    }
    for (let i = 0; i < this.dynamicArrayService.length; i++) {
      if (this.dynamicArrayService[i].walletAmount.length > 2) {
        this.dynamicArrayService[i].walletAmount = parseInt(
          this.dynamicArrayService[i].walletAmount.replace(/\$/g, '') || ''
        );
      } else {
        this.dynamicArrayService[i].walletAmount = 0;
      }

      this.dynamicArrayService[i].from = parseInt(
        this.dynamicArrayService[i].from
      );
      this.dynamicArrayService[i].to = parseInt(this.dynamicArrayService[i].to);
    }

    for (let i = 0; i < this.dynamicArrayAnnualIncome.length; i++) {
      if (this.dynamicArrayAnnualIncome[i].walletAmount.length > 2) {
        this.dynamicArrayAnnualIncome[i].walletAmount = parseInt(
          this.dynamicArrayAnnualIncome[i].walletAmount.replace(/\$/g, '') || ''
        );
      } else {
        this.dynamicArrayAnnualIncome[i].walletAmount = 0;
      }

      this.dynamicArrayAnnualIncome[i].from = parseInt(
        this.dynamicArrayAnnualIncome[i].from
      );

      this.dynamicArrayAnnualIncome[i].to = parseInt(
        this.dynamicArrayAnnualIncome[i].to
      );

      this.dynamicArrayAnnualIncome[i].percentage = parseInt(
        this.dynamicArrayAnnualIncome[i].percentage
      );
    }

    console.log(this.dynamicArray);

    var ConfigureTiers =
      '/api/ap/admin/corporate/' + corporateId + '/configureTiers';
    var GetTiers = '/api/ap/admin/corporate/' + corporateId + '/tiers';
    var accessToken = sessionStorage.getItem('accessToken');
    let requestBody = {
      corporateId: corporateId,
      enableLengthOfService: this.lengthofServiceCheck,
      enableAnnualIncome: this.annualincomeCheck,
      default: this.dynamicArray,
      lengthOfService: this.lengthofServiceCheck
        ? this.dynamicArrayService
        : [],
      annualIncome: this.annualincomeCheck ? this.dynamicArrayAnnualIncome : [],
    };

    // this.dynamicArray.forEach((element: any) => {
    //   let obj = {
    //     id: element.sno,
    //     tierName: element.tierName,
    //   };
    //   this.tierinfonames.push(obj);
    // });
    // this.dynamicArrayService.forEach((element: any) => {
    //   let obj = {
    //     id: element.sno,
    //     tierName: element.tierName,
    //   };
    //   this.tierinfonames.push(obj);
    // });
    // this.dynamicArrayAnnualIncome.forEach((element: any) => {
    //   let obj = {
    //     id: element.sno,
    //     tierName: element.tierName,
    //   };
    //   this.tierinfonames.push(obj);
    // });
    // this.tierinfonames = [
    //   ...new Map(
    //     this.tierinfonames.map((item) => [item.tierName, item])
    //   ).values(),
    // ];

    //  console.log(this.tierinfonames)

    //  this.tierinfonames.filter((item, index) => this.tierinfonames.indexOf(item) === index);
    let el: HTMLElement = this.nextpage.nativeElement;
    el.click();

    this.http
      .post(environment.apiUrl + ConfigureTiers, requestBody, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (response: any) => {
          if (this.annualincomeCheck == true) {
            for (let i = 0; i < this.dynamicArrayAnnualIncome.length; i++) {
              let obj = {
                Tier: this.capitalize(
                  this.dynamicArrayAnnualIncome[i].tierName
                ),
                walletAmount: this.dynamicArrayAnnualIncome[i].walletAmount,
              };

              this.finalTiersforGraph.push(obj);
            }
          } else if (this.lengthofServiceCheck == true) {
            for (let i = 0; i < this.dynamicArrayService.length; i++) {
              let obj = {
                Tier: this.capitalize(this.dynamicArrayService[i].tierName),
                walletAmount: this.dynamicArrayService[i].walletAmount,
              };

              this.finalTiersforGraph.push(obj);
            }
          } else {
            for (let i = 0; i < this.dynamicArray.length; i++) {
              let obj = {
                Tier: this.capitalize(this.dynamicArray[i].tierName),
                walletAmount: this.dynamicArray[i].walletAmount,
              };

              this.finalTiersforGraph.push(obj);
            }
          }

          this.http
            .get(environment.apiUrl + GetTiers, {
              headers: {
                Authorization: 'Bearer ' + accessToken,
                'Content-Type': 'application/json',
              },
            })
            .subscribe(
              (response: any) => {
                if (response['status'] == 200) {
                  this.configureTierList = response.data;
                } else {
                  Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message });
                }
              },
              (error) => {
                console.log(error);
                Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
              }
            );
        },
        (error) => {
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: this.lang.Error ?? 'Error',
              text: error.error.error.message,
              showCancelButton: false,
              showDenyButton: false,
              confirmButtonText: 'Proceed',
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              } else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            // Swal.fire(error.error.error.message)
            Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
          }
          // this.toastrService.error("Invalid Credentials", 'Error!');
        }
      );
  }

  annualIncome(e: any) {
    // console.log(e.target.value)

    if (e.target.value == 'true') {
      this.annualincomeCheck = true;
      // this.addRowAnnual()
    } else {
      this.annualincomeCheck = false;
    }
  }

  lengthOfService(e: any) {
    // console.log(e.target.value)

    if (e.target.value == 'true') {
      this.lengthofServiceCheck = true;
      // this.addRowService()

      // let el: HTMLElement = this.myDiv.nativeElement;
      // el.click();
    } else {
      this.lengthofServiceCheck = false;
    }
  }
  tierslevel(e: any) {
    // console.log(e.target.value)

    if (e.target.value == 'true') {
      this.tiersLevelCheck = true;
    } else {
      this.tiersLevelCheck = false;
    }
  }
  checkSettings(data) {
    console.log(data)
    for (const pack of data) {
      for (const group of pack.groups) {
        for (const subGroup of group.subGroups) {
          if (subGroup?.settings?.upgrade) {
            return true;
          }
        }
      }
    }
    return false;
  }

  //   upgradeplans(e: any) {
  //     if (!this.checkSettings(this.plansBlock1)) {
  //       Swal.fire({ title: "Info", text: "No Plans to Upgrade" });
  //       let el: HTMLElement = this.upgradeplansfalse.nativeElement;
  //       el.click();
  //       return
  //     }

  //     setTimeout(() => {
  //       if (e.target.value == 'true') {
  // this.upgradeplansselection =true
  //         let block1res = JSON.parse(
  //           sessionStorage.getItem('summaryBlock1') || '[]'
  //         );
  //         let block1Bulkres = JSON.parse(sessionStorage.getItem('summaryBlockBulk'))
  //         console.log(block1res)
  //         this.plansblock2();
  //         // if (block1res.length > 0) {
  //         //   this.upgradeplansselection = true;
  //         //   this.plansblock2();
  //         //   this.plansresblack3 = [];
  //         // }
  //         // else if (block1Bulkres.length > 0) {
  //         //   this.upgradeplansselection = true;
  //         //   this.plansblock2();
  //         //   this.plansresblack3 = [];
  //         // }
  //         // else {
  //         //   Swal.fire({
  //         //     title: 'Info',
  //         //     text: 'Please select one core plan from above',
  //         //   });

  //         //   this.upgradeplansselection = false;
  //         //   let el: HTMLElement = this.upgradeplansfalse.nativeElement;
  //         //   el.click();
  //         // }
  //         if (this.employeeplanpurchase == true) {
  //           this.employeeplanpurchase = true
  //           // let el: HTMLElement = this.employeepurchasefalse.nativeElement;
  //           // el.click();
  //           setTimeout(() => {
  //             let el1: HTMLElement = this.employeepurchasetrue.nativeElement;
  //             el1.click();
  //           }, 100);
  //         }
  //       }
  //       else {

  //         this.upgradeplansselection = false;
  //         sessionStorage.setItem('summaryBlock2', '[]');
  //         if (this.employeeplanpurchase == true) {
  //           // let el: HTMLElement = this.employeepurchasefalse.nativeElement;
  //           // el.click();
  //           setTimeout(() => {
  //             let el1: HTMLElement = this.employeepurchasetrue.nativeElement;
  //             el1.click();
  //           }, 100);
  //         }
  //       }
  //     }, 1000);

  //   }
  upgradeplans(e: any) {
    if (!this.checkSettings(this.plansBlock1)) {
      Swal.fire({ title: this.lang.Info, text: "No Plans to Upgrade" });
      let el: HTMLElement = this.upgradeplansfalse.nativeElement;
      el.click();
      return
    }

    setTimeout(() => {
      if (e.target.value == 'true') {
        // this.upgradeplansselection = true;
        let block1res = JSON.parse(
          sessionStorage.getItem('summaryBlock1') || '[]'
        );
        let block1Bulkres = JSON.parse(sessionStorage.getItem('summaryBlockBulk'))

        // console.log(block1res)
        // this.plansblock2()
        if (block1res.length > 0) {
          this.upgradeplansselection = true;
          this.plansblock2();
          // this.plansresblack3 = [];
        }
        else if (block1Bulkres.length > 0) {
          this.upgradeplansselection = true;
          this.plansblock2();
          // this.plansresblack3 = [];
        }
        else {
          Swal.fire({
            title: this.lang.Info,
            text: 'Please select one core plan from above',
          });

          this.upgradeplansselection = false;
          let el: HTMLElement = this.upgradeplansfalse.nativeElement;
          el.click();
        }
        if (this.employeeplanpurchase == true) {
          this.employeeplanpurchase = true
          // let el: HTMLElement = this.employeepurchasefalse.nativeElement;
          // el.click();
          setTimeout(() => {
            let el1: HTMLElement = this.employeepurchasetrue.nativeElement;
            el1.click();
          }, 100);
        }
      }
      else {

        this.upgradeplansselection = false;
        sessionStorage.setItem('summaryBlock2', '[]');
        if (this.employeeplanpurchase == true) {
          // let el: HTMLElement = this.employeepurchasefalse.nativeElement;
          // el.click();
          setTimeout(() => {
            let el1: HTMLElement = this.employeepurchasetrue.nativeElement;
            if (el1 != null) el1.click();
          }, 100);
        }
      }
    }, 1000);

  }
  upgradeplansTiers(e: any) {
    if (e.target.value == 'true') {
      let block1res = JSON.parse(
        sessionStorage.getItem('selectedTiersBlock1') || '[]'
      );
      let block2filter = block1res.filter(
        (item: any) => item.parentid == 1 || item.parentid == 6
      );

      console.log(block2filter);

      if (block1res.length > 0) {
        let el: HTMLElement = this.employeepurchaseTiersfalse.nativeElement;
        el.click();

        this.upgradeplansselectiontiers = true;
        this.plansblock2tiers();
      } else {
        Swal.fire({
          title: this.lang.Info,
          text: this.lang.Please_select_one_plan_from_above,
        });

        this.upgradeplansselectiontiers = false;
        let el: HTMLElement = this.upgradeplanstiersfalse.nativeElement;
        el.click();
      }
    } else {
      this.upgradeplansselectiontiers = false;
    }
  }

  public getpackageGroupId(packageId: any, Groupid: any) {
    // console.log("packageid"+packageId)

    this.planres2.forEach((element: any, index: any) => {
      if (element.id == packageId) {
        // console.log("packageidcheck"+element.id)
        // console.log("packageid"+packageId)
        this.packageIndex = index;
      }

      element.groups.forEach((element1: any, index1: any) => {
        if (element.id == packageId && element1.id == Groupid) {
          // console.log("groupidcheck"+element1.id)
          // console.log("groupid"+Groupid)
          this.groupIndex = index1;
        }
      });
    });
  }
  public getpackageGroupIdblock2(packageId: any, Groupid: any) {
    let results = JSON.parse(sessionStorage.getItem('block2result') || '[]');

    results.forEach((element: any, index: any) => {
      if (element.id == packageId) {
        // console.log("packageidcheck"+element.id)
        // console.log("packageid"+packageId)
        this.packageIndexblock2 = index;
      }

      element.groups.forEach((element1: any, index1: any) => {
        if (element.id == packageId && element1.id == Groupid) {
          // console.log("groupidcheck"+element1.id)
          // console.log("groupid"+Groupid)
          this.groupIndexblock2 = index1;
          // alert(this.groupIndex)
        }
      });
    });
  }

  // public plansblock2() {
  //   this.plansNewBlock2 = [];

  //   this.plansNewBlock2 = JSON.parse(
  //     sessionStorage.getItem('mainresults') || '[]'
  //   );

  //   this.selectedplansblock1 = JSON.parse(
  //     sessionStorage.getItem('summaryBlock1') || '[]'
  //   );

  //   let block1Bulk = JSON.parse(
  //     sessionStorage.getItem('summaryBlockBulk') || '[]')
  //   this.plansNewBlock2.forEach((packagelevel: any, index: any) => {
  //     if (!packagelevel) {
  //     } else {
  //       packagelevel.groups.forEach((groups: any, index1: any) => {
  //         // if (packagelevel.id == 2 && block1Bulk.length > 0) {
  //         //   this.selectedplansblock1 = JSON.parse(
  //         //     sessionStorage.getItem('summaryBlockBulk') || '[]')
  //         // } else {
  //           this.selectedplansblock1 = JSON.parse(
  //             sessionStorage.getItem('summaryBlock1') || '[]')
  //         // }
  //         this.selectedplansblock1.forEach((selectplan: any) => {
  //           if (
  //             packagelevel.id == selectplan.packageid &&
  //             packagelevel.groups.id == selectplan.parentid
  //           ) {
  //             if (
  //               !this.plansNewBlock2[index] ||
  //               !this.plansNewBlock2[index]['groups'] ||
  //               !this.plansNewBlock2[index]['groups'][index1] ||
  //               !this.plansNewBlock2[index]['groups'][index1]['subGroups']
  //             ) {
  //             } else {
  //               var allAvailble =
  //                 this.plansNewBlock2[index]['groups'][index1]['subGroups'];

  //               console.log(allAvailble);

  //               // if (
  //               //   this.plansNewBlock2[index].id == selectplan.packageid &&
  //               //   this.plansNewBlock2[index]['groups'][index1].id !=
  //               //   selectplan.parentId
  //               // ) {
  //               //   console.log('ignore');

  //               //   this.plansNewBlock2[index]['groups'][index1] = null;
  //               //   // this.plansNewBlock2[index] = null;
  //               // }

  //               // else {
  //               console.log('oktoselect');
  //               console.log(allAvailble);
  //               allAvailble.forEach((element1: any, index2: any) => {
  //                 if (element1 != null) {
  //                   // if(element1.)
  //                   if (element1.id != '17' && element1.id != '18' && element1.id != '28') {
  //                     // if (element1.ordering > selectplan.orderId) {
  //                     // }
  //                     // else {
  //                       this.plansNewBlock2[index]['groups'][index1][
  //                         'subGroups'
  //                       ][index2] = null;

  //                       this.plansNewBlock2.forEach(
  //                         (elementres: any, index5: any) => {
  //                           if (!elementres || !elementres.groups) {
  //                           } else {
  //                             elementres.groups.forEach(
  //                               (group: any, index6: any) => {
  //                                 console.log(group);
  //                                 if (
  //                                   !this.plansNewBlock2[index5] ||
  //                                   !this.plansNewBlock2[index5]['groups'] ||
  //                                   !this.plansNewBlock2[index5]['groups'][
  //                                   index6
  //                                   ] ||
  //                                   !this.plansNewBlock2[index5]['groups'][
  //                                   index6
  //                                   ]['subGroups']
  //                                 ) {
  //                                 } else {
  //                                   group.subGroups.forEach(
  //                                     (subgroups: any, index7: any) => {
  //                                       let validSubgroups = group[
  //                                         'subGroups'
  //                                       ].filter((v: any) => v !== null);

  //                                       console.log(validSubgroups);
  //                                       if (validSubgroups.length > 0) {
  //                                       } else {
  //                                         // this.plansNewBlock2[index5][
  //                                         //   'groups'
  //                                         // ][index6] = null;

  //                                         this.plansNewBlock2[index5] = null;
  //                                         // this.plansNewBlock2.splice(index5,1)
  //                                       }
  //                                     }
  //                                   );
  //                                 }

  //                                 let validgroups = elementres.groups.filter(
  //                                   (v: any) => v !== null
  //                                 );

  //                                 console.log(validgroups);
  //                                 if (validgroups.length > 0) {
  //                                 } else {
  //                                   this.plansNewBlock2[index5] = null;
  //                                   ////////show subGroups here
  //                                 }
  //                                 //
  //                               }
  //                             );
  //                           }
  //                         }
  //                       );
  //                     // }
  //                   }

  //                   else {
  //                     console.log(element1.ordering); //23  24   Default===single and Family
  //                     console.log(selectplan.orderId); //23  23
  //                     // if (element1.ordering > selectplan.orderId) {
  //                     //   console.log('ifstate');
  //                     // }
  //                     // else {
  //                       console.log('coverage' + selectplan.coverage);

  //                       this.upgradeplanscheck =
  //                         this.getExecutiveCoveragesFromCode(
  //                           selectplan.coverage
  //                         );
  //                       // {single:true,couple:true,fam:false}

  //                       if (this.upgradeplanscheck && this.upgradeplanscheck != null) {
  //                         if (this.upgradeplanscheck.single) {
  //                           console.log(element1.id);
  //                           console.log(selectplan.subGroupId);
  //                           if (element1.id >= selectplan.subGroupId) {
  //                             this.plansNewBlock2[index]['groups'][index1][
  //                               'subGroups'
  //                             ][index2]['coverage'] = '001';
  //                           } else {
  //                             this.plansNewBlock2[index]['groups'][index1][
  //                               'subGroups'
  //                             ][index2] = null;
  //                           }
  //                         }
  //                         if (this.upgradeplanscheck.couple) {
  //                           if (element1.id >= selectplan.subGroupId) {
  //                             this.plansNewBlock2[index]['groups'][index1][
  //                               'subGroups'
  //                             ][index2]['coverage'] = '010';
  //                           } else {
  //                             this.plansNewBlock2[index]['groups'][index1][
  //                               'subGroups'
  //                             ][index2] = null;
  //                           }
  //                         }
  //                         if (
  //                           this.upgradeplanscheck.single &&
  //                           this.upgradeplanscheck.couple
  //                         ) {
  //                           if (element1.id >= selectplan.subGroupId) {
  //                             this.plansNewBlock2[index]['groups'][index1][
  //                               'subGroups'
  //                             ][index2]['coverage'] = '011';
  //                           } else {
  //                             this.plansNewBlock2[index]['groups'][index1][
  //                               'subGroups'
  //                             ][index2] = null;
  //                           }
  //                         }
  //                         if (this.upgradeplanscheck.family) {
  //                           this.plansNewBlock2[index]['groups'][index1][
  //                             'subGroups'
  //                           ][index2] = null;
  //                         }
  //                       }

  //                       this.plansNewBlock2.forEach(
  //                         (elementres: any, index5: any) => {
  //                           if (!elementres || !elementres.groups) {
  //                           } else {
  //                             elementres.groups.forEach(
  //                               (group: any, index6: any) => {
  //                                 console.log(group);
  //                                 if (
  //                                   !this.plansNewBlock2[index5] ||
  //                                   !this.plansNewBlock2[index5]['groups'] ||
  //                                   !this.plansNewBlock2[index5]['groups'][
  //                                   index6
  //                                   ] ||
  //                                   !this.plansNewBlock2[index5]['groups'][
  //                                   index6
  //                                   ]['subGroups']
  //                                 ) {
  //                                 } else {
  //                                   group.subGroups.forEach(
  //                                     (subgroups: any, index7: any) => {
  //                                       let validSubgroups = group[
  //                                         'subGroups'
  //                                       ].filter((v: any) => v !== null);

  //                                       console.log(validSubgroups);
  //                                       if (validSubgroups.length > 0) {
  //                                       } else {
  //                                         // this.plansNewBlock2[index5][
  //                                         //   'groups'
  //                                         // ][index6] = null;

  //                                         this.plansNewBlock2[index5] = null;
  //                                         // this.plansNewBlock2.splice(index5,1)
  //                                       }
  //                                     }
  //                                   );
  //                                 }

  //                                 let validgroups = elementres.groups.filter(
  //                                   (v: any) => v !== null
  //                                 );

  //                                 console.log(validgroups);
  //                                 if (validgroups.length > 0) {
  //                                 } else {
  //                                   this.plansNewBlock2[index5] = null;
  //                                   ////////show subGroups here
  //                                 }
  //                                 //
  //                               }
  //                             );
  //                           }
  //                         }
  //                       );
  //                     // }
  //                   }
  //                 }
  //               });
  //               // }
  //             }
  //           }
  //         });
  //       });
  //     }
  //   });

  //   console.log(this.plansNewBlock2);

  //   this.plansresblack2 = this.plansNewBlock2;

  //   sessionStorage.setItem('block2result', JSON.stringify(this.plansresblack2));

  //   setTimeout(() => {
  //     let selectedplansblock2 = JSON.parse(
  //       sessionStorage.getItem('summaryBlock2') || '[]'
  //     );
  //     setTimeout(() => {
  //       const dom: HTMLElement = this.elementRef.nativeElement;
  //       if (selectedplansblock2.length > 0) {
  //         for (let i = 0; i < selectedplansblock2.length; i++) {
  //           if (selectedplansblock2[i].subGroupId != 4) {
  //             // this.selectInBlock2()
  //           }
  //         }
  //       } else {
  //         // this.selectInBlock2()
  //       }
  //     }, 1000);
  //   }, 1000);

  //   // setTimeout(() => {
  //   //   $("#executiveplansblock2single17").prop("disabled", true);
  //   //   $("#executiveplansblock2couple17").prop("disabled", true);
  //   //   $("#executiveplansblock2family17").prop("disabled", true);
  //   //   $("#executiveplansblock2single18").prop("disabled", true);
  //   //   $("#executiveplansblock2couple18").prop("disabled", true);
  //   //   $("#executiveplansblock2family18").prop("disabled", true);

  //   // }, 1000);
  // }
  // public plansblock2() {

  //   this.plansNewBlock2 = [];

  //   this.plansNewBlock2 = JSON.parse(
  //     sessionStorage.getItem('mainresults') || '[]'
  //   );

  //   this.selectedplansblock1 = JSON.parse(
  //     sessionStorage.getItem('summaryBlock1') || '[]'
  //   );




  //   setTimeout(() => {

  //     let block1res = JSON.parse(
  //       sessionStorage.getItem('summaryBlock2') || '[]');



  //     for (let i = 0; i < block1res.length; i++) {
  //       if (block1res[i].subGroupId == 17) {

  //         $('#executiveplanssingle17').prop('disabled', false);
  //         $('#executiveplanscouple17').prop('disabled', false);
  //         $('#executiveplansfamily17').prop('disabled', false);
  //       }
  //       else {

  //         // $('#executiveplanssingle17').prop('disabled', true);
  //         // $('#executiveplanscouple17').prop('disabled', true);
  //         // $('#executiveplansfamily17').prop('disabled', true);
  //       }
  //       if (block1res[i].subGroupId == 18) {
  //         $('#executiveplanssingle18').prop('disabled', false);
  //         $('#executiveplanscouple18').prop('disabled', false);
  //         $('#executiveplansfamily18').prop('disabled', false);
  //       }
  //       else {
  //         // $('#executiveplanssingle18').prop('disabled', true);
  //         // $('#executiveplanscouple18').prop('disabled', true);
  //         // $('#executiveplansfamily18').prop('disabled', true);
  //       }

  //       if (block1res[i].subGroupId == 28) {
  //         $('#executiveplanssingle28').prop('disabled', false);
  //         $('#executiveplanscouple28').prop('disabled', false);
  //         $('#executiveplansfamily28').prop('disabled', false);
  //       }
  //       else {
  //         // $('#executiveplanssingle28').prop('disabled', true);
  //         // $('#executiveplanscouple28').prop('disabled', true);
  //         // $('#executiveplansfamily28').prop('disabled', true);
  //       }
  //       // if(block1res[i].subGroupId == 17 && block1res[i].subGroupId == 18 ){

  //       // }
  //       // else{
  //       //   $('#executiveplanssingle17').prop('disabled', true);
  //       //   $('#executiveplanscouple17').prop('disabled', true);
  //       //   $('#executiveplansfamily17').prop('disabled', true);
  //       //   $('#executiveplanssingle18').prop('disabled', true);
  //       //   $('#executiveplanscouple18').prop('disabled', true);
  //       //   $('#executiveplansfamily18').prop('disabled', true);
  //       // }
  //     }

  //   }, 100);
  //   let block1Bulk = JSON.parse(
  //     sessionStorage.getItem('summaryBlockBulk') || '[]')
  //   this.plansNewBlock2.forEach((packagelevel: any, index: any) => {
  //     if (!packagelevel) {
  //     }
  //     else {
  //       packagelevel.groups.forEach((groups: any, index1: any) => {
  //         // if (packagelevel.id == 2 && block1Bulk.length > 0) {
  //         //   this.selectedplansblock1 = JSON.parse(
  //         //     sessionStorage.getItem('summaryBlockBulk') || '[]')
  //         // } else {
  //           this.selectedplansblock1 = JSON.parse(
  //             sessionStorage.getItem('summaryBlock1') || '[]')
  //         // }
  //         groups?.subGroups.forEach((subGroups: any, index2: any) => {
  //         if(subGroups){
  //         this.selectedplansblock1.forEach((selectplan: any) => {
  //           if (
  //             packagelevel.id == selectplan.packageid &&
  //             packagelevel.groups.id == selectplan.parentid
  //           ) {

  //             if (subGroups.id == selectplan.subGroupId && subGroups.id != '17' && subGroups.id != '18' && subGroups.id != '28') {
  //               this.plansNewBlock2[index]['groups'][index1]['subGroups'].splice(index2,1)

  //               if(selectplan.disallowedPlanLevels){
  //                 let disallowed_plans = selectplan.disallowedPlanLevels.split(',');

  //                 console.log(disallowed_plans)

  //                 disallowed_plans.forEach((disallowed: any,index9) => {


  //                   this.plansNewBlock2[index]['groups'][index1]['subGroups'].forEach((plan: any,index10) => {

  //                     if(this.plansNewBlock2[index]['groups'][index1]['subGroups'][index10].id==disallowed){
  //                       this.plansNewBlock2[index]['groups'][index1]['subGroups'].splice(index10,1)
  //                     }
  //                   })



  //                 })


  //               }



  //             }
  //             if (
  //               !this.plansNewBlock2[index] ||
  //               !this.plansNewBlock2[index]['groups'] ||
  //               !this.plansNewBlock2[index]['groups'][index1] ||
  //               !this.plansNewBlock2[index]['groups'][index1]['subGroups']
  //             ) {
  //             }

  //             else {
  //               var allAvailble =
  //                 this.plansNewBlock2[index]['groups'][index1]['subGroups']

  //               console.log(allAvailble)


  //               console.log(console.log(this.plansNewBlock2[index]))
  //               console.log(selectplan)
  //               console.log(this.plansNewBlock2[index].id)
  //               console.log(selectplan.packageid)
  //               console.log(this.plansNewBlock2[index]['groups'][index1].id)
  //               console.log(selectplan.parentId)




  //               // if (

  //               //   this.plansNewBlock2[index].id == selectplan.packageid &&
  //               //   this.plansNewBlock2[index]['groups'][index1].id !=
  //               //   selectplan.parentId
  //               // ) {
  //               //   console.log("ignore")

  //               //   this.plansNewBlock2[index]['groups'][index1] = null;
  //               //   // this.plansNewBlock2[index] = null;

  //               // }

  //               // else {

  //               console.log("oktoselect")
  //               console.log(allAvailble);
  //               allAvailble.forEach((element1: any, index2: any) => {
  //                 if (element1 != null) {
  //                   // if(element1.)
  //                   console.log(element1)

  //                   if (element1.id == '17' || element1.id == '18' || element1.id == '28') {
  //                     console.log(element1.id)
  //                     console.log(element1.ordering); //23  24   Default===single and Family
  //                     console.log(selectplan.orderId); //23  23
  //                     // if (element1.ordering > selectplan.orderId) {
  //                     //   console.log('ifstate');
  //                     // }
  //                     // else {
  //                       console.log('coverage' + selectplan.coverage);

  //                       this.upgradeplanscheck = this.getExecutiveCoveragesFromCode(selectplan.coverage)
  //                       // {single:true,couple:true,fam:false}

  //                       console.log(this.upgradeplanscheck)

  //                       if (this.upgradeplanscheck && this.upgradeplanscheck != null) {
  //                         if (this.upgradeplanscheck.single) {
  //                           console.log(element1.id)
  //                           console.log(selectplan.subGroupId)
  //                           if (element1.id >= selectplan.subGroupId) {
  //                             this.plansNewBlock2[index]['groups'][index1][
  //                               'subGroups'
  //                             ][index2]['coverage'] = '001';
  //                           } else {
  //                             this.plansNewBlock2[index]['groups'][index1][
  //                               'subGroups'
  //                             ][index2] = null;
  //                           }
  //                         }
  //                         if (this.upgradeplanscheck.couple) {
  //                           if (element1.id >= selectplan.subGroupId) {
  //                             this.plansNewBlock2[index]['groups'][index1][
  //                               'subGroups'
  //                             ][index2]['coverage'] = '010';
  //                           } else {
  //                             this.plansNewBlock2[index]['groups'][index1][
  //                               'subGroups'
  //                             ][index2] = null;
  //                           }
  //                         }
  //                         if (this.upgradeplanscheck.single && this.upgradeplanscheck.couple) {
  //                           if (element1.id >= selectplan.subGroupId) {
  //                             this.plansNewBlock2[index]['groups'][index1][
  //                               'subGroups'
  //                             ][index2]['coverage'] = '011';
  //                           } else {
  //                             this.plansNewBlock2[index]['groups'][index1][
  //                               'subGroups'
  //                             ][index2] = null;
  //                           }
  //                         }
  //                         if (this.upgradeplanscheck.family) {
  //                           this.plansNewBlock2[index]['groups'][index1][
  //                             'subGroups'
  //                           ][index2] = null;
  //                         }
  //                       }

  //                       this.plansNewBlock2.forEach(
  //                         (elementres: any, index5: any) => {
  //                           if (!elementres || !elementres.groups) {
  //                           } else {
  //                             elementres.groups.forEach(
  //                               (group: any, index6: any) => {
  //                                 console.log(group);
  //                                 if (!this.plansNewBlock2[index5] ||
  //                                   !this.plansNewBlock2[index5]['groups'] ||
  //                                   !this.plansNewBlock2[index5]['groups'][
  //                                   index6
  //                                   ] ||
  //                                   !this.plansNewBlock2[index5]['groups'][
  //                                   index6
  //                                   ]['subGroups']
  //                                 ) {
  //                                 } else {
  //                                   group.subGroups.forEach(
  //                                     (subgroups: any, index7: any) => {
  //                                       let validSubgroups = group[
  //                                         'subGroups'
  //                                       ].filter((v: any) => v !== null);

  //                                       console.log(validSubgroups);
  //                                       if (validSubgroups.length > 0) {
  //                                       } else {
  //                                         // this.plansNewBlock2[index5][
  //                                         //   'groups'
  //                                         // ][index6] = null;

  //                                         this.plansNewBlock2[index5] = null;
  //                                         // this.plansNewBlock2.splice(index5,1)
  //                                       }
  //                                     }
  //                                   );
  //                                 }

  //                                 let validgroups = elementres.groups.filter(
  //                                   (v: any) => v !== null
  //                                 );

  //                                 console.log(validgroups);
  //                                 if (validgroups.length > 0) {
  //                                 } else {
  //                                   this.plansNewBlock2[index5] = null;
  //                                   ////////show subGroups here
  //                                 }
  //                                 //
  //                               }
  //                             );
  //                           }
  //                         }
  //                       );
  //                     // }
  //                   }
  //                   else {
  //                     console.log(element1.id)
  //                     // if (element1.ordering > selectplan.orderId) {
  //                     // }
  //                     // else {
  //                       this.plansNewBlock2[index]['groups'][index1][
  //                         'subGroups'
  //                       ][index2] = null;

  //                       this.plansNewBlock2.forEach(
  //                         (elementres: any, index5: any) => {
  //                           if (!elementres || !elementres.groups) {
  //                           } else {
  //                             elementres.groups.forEach(
  //                               (group: any, index6: any) => {
  //                                 console.log(group);
  //                                 if (!this.plansNewBlock2[index5] ||
  //                                   !this.plansNewBlock2[index5]['groups'] ||
  //                                   !this.plansNewBlock2[index5]['groups'][
  //                                   index6
  //                                   ] ||
  //                                   !this.plansNewBlock2[index5]['groups'][
  //                                   index6
  //                                   ]['subGroups']
  //                                 ) {
  //                                 } else {
  //                                   group.subGroups.forEach(
  //                                     (subgroups: any, index7: any) => {
  //                                       let validSubgroups = group[
  //                                         'subGroups'
  //                                       ].filter((v: any) => v !== null);

  //                                       console.log(validSubgroups);
  //                                       if (validSubgroups.length > 0) {
  //                                       } else {
  //                                         // this.plansNewBlock2[index5][
  //                                         //   'groups'
  //                                         // ][index6] = null;

  //                                         this.plansNewBlock2[index5] = null;
  //                                         // this.plansNewBlock2.splice(index5,1)
  //                                       }
  //                                     }
  //                                   );
  //                                 }

  //                                 let validgroups = elementres.groups.filter(
  //                                   (v: any) => v !== null
  //                                 );

  //                                 console.log(validgroups);
  //                                 if (validgroups.length > 0) {
  //                                 } else {
  //                                   this.plansNewBlock2[index5] = null;
  //                                   ////////show subGroups here
  //                                 }
  //                                 //
  //                               }
  //                             );
  //                           }
  //                         }
  //                       );
  //                     // }
  //                   }
  //                 }
  //               });
  //               // }
  //             }
  //           }
  //         });
  //       }
  //     })
  //       });
  //     }
  //   });

  //   console.log(this.plansNewBlock2);

  //   this.plansresblack2 = this.plansNewBlock2;

  //   sessionStorage.setItem('block2result', JSON.stringify(this.plansresblack2));

  //   setTimeout(() => {
  //     let selectedplansblock2 = JSON.parse(
  //       sessionStorage.getItem('summaryBlock2') || '[]'
  //     );
  //     setTimeout(() => {
  //       const dom: HTMLElement = this.elementRef.nativeElement;
  //       if (selectedplansblock2.length > 0) {
  //         for (let i = 0; i < selectedplansblock2.length; i++) {
  //           if (selectedplansblock2[i].subGroupId != 4) {
  //             // this.selectInBlock2()
  //           }
  //         }
  //       } else {
  //         // this.selectInBlock2()
  //       }
  //     }, 1000);
  //   }, 1000);

  //   // setTimeout(() => {
  //   //   $("#executiveplansblock2single17").prop("disabled", true);
  //   //   $("#executiveplansblock2couple17").prop("disabled", true);
  //   //   $("#executiveplansblock2family17").prop("disabled", true);
  //   //   $("#executiveplansblock2single18").prop("disabled", true);
  //   //   $("#executiveplansblock2couple18").prop("disabled", true);
  //   //   $("#executiveplansblock2family18").prop("disabled", true);

  //   // }, 1000);
  // }
  // public plansblock2() {

  //   this.plansNewBlock2 = [];

  //   this.plansNewBlock2 = JSON.parse(
  //     sessionStorage.getItem('mainresults') || '[]'
  //   );

  //   this.selectedplansblock1 = JSON.parse(
  //     sessionStorage.getItem('summaryBlock1') || '[]'
  //   );




  //   setTimeout(() => {

  //     let block1res = JSON.parse(
  //       sessionStorage.getItem('summaryBlock2') || '[]');



  //     for (let i = 0; i < block1res.length; i++) {
  //       if (block1res[i].subGroupId == 17) {

  //         $('#executiveplanssingle17').prop('disabled', false);
  //         $('#executiveplanscouple17').prop('disabled', false);
  //         $('#executiveplansfamily17').prop('disabled', false);
  //       }
  //       else {

  //         // $('#executiveplanssingle17').prop('disabled', true);
  //         // $('#executiveplanscouple17').prop('disabled', true);
  //         // $('#executiveplansfamily17').prop('disabled', true);
  //       }
  //       if (block1res[i].subGroupId == 18) {
  //         $('#executiveplanssingle18').prop('disabled', false);
  //         $('#executiveplanscouple18').prop('disabled', false);
  //         $('#executiveplansfamily18').prop('disabled', false);
  //       }
  //       else {
  //         // $('#executiveplanssingle18').prop('disabled', true);
  //         // $('#executiveplanscouple18').prop('disabled', true);
  //         // $('#executiveplansfamily18').prop('disabled', true);
  //       }

  //       if (block1res[i].subGroupId == 28) {
  //         $('#executiveplanssingle28').prop('disabled', false);
  //         $('#executiveplanscouple28').prop('disabled', false);
  //         $('#executiveplansfamily28').prop('disabled', false);
  //       }
  //       else {
  //         // $('#executiveplanssingle28').prop('disabled', true);
  //         // $('#executiveplanscouple28').prop('disabled', true);
  //         // $('#executiveplansfamily28').prop('disabled', true);
  //       }

  //     }

  //   }, 100);

  //   this.plansNewBlock2.forEach((packagelevel: any, index: any) => {
  //     if (!packagelevel) {
  //     }
  //     else {
  //       packagelevel.groups.forEach((groups: any, index1: any) => {

  //           this.selectedplansblock1 = JSON.parse(
  //             sessionStorage.getItem('summaryBlock1') || '[]')
  //           groups?.subGroups.forEach((subGroups: any, index2: any) => {

  //         // }
  //         if(subGroups){
  //         this.selectedplansblock1.forEach((selectplan: any) => {
  //           if (
  //             packagelevel.id == selectplan.packageid &&
  //             packagelevel.groups.id == selectplan.parentid
  //           ) {

  //             if (subGroups.id == selectplan.subGroupId && subGroups.id != '17' && subGroups.id != '18' && subGroups.id != '28') {
  //               this.plansNewBlock2[index]['groups'][index1]['subGroups'].splice(index2,1)

  //               if(selectplan.disallowedPlanLevels){
  //                 let disallowed_plans = selectplan.disallowedPlanLevels.split(',');

  //                 console.log(disallowed_plans)

  //                 disallowed_plans.forEach((disallowed: any,index9) => {


  //                   this.plansNewBlock2[index]['groups'][index1]['subGroups'].forEach((plan: any,index10) => {

  //                     if(this.plansNewBlock2[index]['groups'][index1]['subGroups'][index10].id==disallowed){
  //                       this.plansNewBlock2[index]['groups'][index1]['subGroups'].splice(index10,1)
  //                     }
  //                   })



  //                 })
  //                 console.log(this.plansNewBlock2)

  //               }



  //             }

  //                console.log(this.plansNewBlock2)
  //             if (
  //               !this.plansNewBlock2[index] ||
  //               !this.plansNewBlock2[index]['groups'] ||
  //               !this.plansNewBlock2[index]['groups'][index1] ||
  //               !this.plansNewBlock2[index]['groups'][index1]['subGroups']
  //             ) {
  //             }

  //             else {
  //               var allAvailble = this.plansNewBlock2[index]['groups'][index1]['subGroups']

  //               console.log(allAvailble)



  //               allAvailble.forEach((element1: any, index2: any) => {
  //                 if (element1 != null) {
  //                   // if(element1.)
  //                   console.log(element1)

  //                   if (element1.id == '17' || element1.id == '18' || element1.id == '28') {
  //                     console.log(element1.id)
  //                     console.log(element1.ordering); //23  24   Default===single and Family
  //                     console.log(selectplan.orderId); //23  23
  //                     // if (element1.ordering > selectplan.orderId) {
  //                     //   console.log('ifstate');
  //                     // }
  //                     // else {
  //                       console.log('coverage' + selectplan.coverage);

  //                       this.upgradeplanscheck = this.getExecutiveCoveragesFromCode(selectplan.coverage)
  //                       // {single:true,couple:true,fam:false}

  //                       console.log(this.upgradeplanscheck)

  //                       if (this.upgradeplanscheck && this.upgradeplanscheck != null) {
  //                         if (this.upgradeplanscheck.single) {
  //                           console.log(element1.id)
  //                           console.log(selectplan.subGroupId)
  //                           if (element1.id >= selectplan.subGroupId) {
  //                             this.plansNewBlock2[index]['groups'][index1][
  //                               'subGroups'
  //                             ][index2]['coverage'] = '001';
  //                           } else {
  //                             this.plansNewBlock2[index]['groups'][index1][
  //                               'subGroups'
  //                             ][index2] = null;
  //                           }
  //                         }
  //                         if (this.upgradeplanscheck.couple) {
  //                           if (element1.id >= selectplan.subGroupId) {
  //                             this.plansNewBlock2[index]['groups'][index1][
  //                               'subGroups'
  //                             ][index2]['coverage'] = '010';
  //                           } else {
  //                             this.plansNewBlock2[index]['groups'][index1][
  //                               'subGroups'
  //                             ][index2] = null;
  //                           }
  //                         }
  //                         if (this.upgradeplanscheck.single && this.upgradeplanscheck.couple) {
  //                           if (element1.id >= selectplan.subGroupId) {
  //                             this.plansNewBlock2[index]['groups'][index1][
  //                               'subGroups'
  //                             ][index2]['coverage'] = '011';
  //                           } else {
  //                             this.plansNewBlock2[index]['groups'][index1][
  //                               'subGroups'
  //                             ][index2] = null;
  //                           }
  //                         }
  //                         if (this.upgradeplanscheck.family) {
  //                           this.plansNewBlock2[index]['groups'][index1][
  //                             'subGroups'
  //                           ][index2] = null;
  //                         }
  //                       }

  //                       this.plansNewBlock2.forEach(
  //                         (elementres: any, index5: any) => {
  //                           if (!elementres || !elementres.groups) {
  //                           } else {
  //                             elementres.groups.forEach(
  //                               (group: any, index6: any) => {
  //                                 console.log(group);
  //                                 if (!this.plansNewBlock2[index5] ||
  //                                   !this.plansNewBlock2[index5]['groups'] ||
  //                                   !this.plansNewBlock2[index5]['groups'][
  //                                   index6
  //                                   ] ||
  //                                   !this.plansNewBlock2[index5]['groups'][
  //                                   index6
  //                                   ]['subGroups']
  //                                 ) {
  //                                 } else {
  //                                   group.subGroups.forEach(
  //                                     (subgroups: any, index7: any) => {
  //                                       let validSubgroups = group[
  //                                         'subGroups'
  //                                       ].filter((v: any) => v !== null);

  //                                       console.log(validSubgroups);
  //                                       if (validSubgroups.length > 0) {
  //                                       } else {
  //                                         // this.plansNewBlock2[index5][
  //                                         //   'groups'
  //                                         // ][index6] = null;

  //                                         // this.plansNewBlock2[index5] = null;
  //                                         // this.plansNewBlock2.splice(index5,1)
  //                                       }
  //                                     }
  //                                   );
  //                                 }

  //                                 let validgroups = elementres.groups.filter(
  //                                   (v: any) => v !== null
  //                                 );

  //                                 console.log(validgroups);
  //                                 if (validgroups.length > 0) {
  //                                 } else {
  //                                   // this.plansNewBlock2[index5] = null;
  //                                   ////////show subGroups here
  //                                 }
  //                                 //
  //                               }
  //                             );
  //                           }
  //                         }
  //                       );
  //                     // }
  //                   }
  //                   else {
  //                     console.log(element1.id)
  //                     // if (element1.ordering > selectplan.orderId) {
  //                     // }
  //                     // else {
  //                     // console.log(this.plansNewBlock2?.[index]?.groups?.[index1]?.subGroups?.[index2])
  //                       // this.plansNewBlock2[index]['groups'][index1][
  //                       //   'subGroups'
  //                       // ][index2] = null;

  //                       this.plansNewBlock2.forEach(
  //                         (elementres: any, index5: any) => {
  //                           if (!elementres || !elementres.groups) {
  //                           } else {
  //                             elementres.groups.forEach(
  //                               (group: any, index6: any) => {
  //                                 console.log(group);
  //                                 if (!this.plansNewBlock2[index5] ||
  //                                   !this.plansNewBlock2[index5]['groups'] ||
  //                                   !this.plansNewBlock2[index5]['groups'][
  //                                   index6
  //                                   ] ||
  //                                   !this.plansNewBlock2[index5]['groups'][
  //                                   index6
  //                                   ]['subGroups']
  //                                 ) {
  //                                 } else {
  //                                   group.subGroups.forEach(
  //                                     (subgroups: any, index7: any) => {
  //                                       let validSubgroups = group[
  //                                         'subGroups'
  //                                       ].filter((v: any) => v !== null);

  //                                       console.log(validSubgroups);
  //                                       if (validSubgroups.length > 0) {
  //                                       } else {
  //                                         // this.plansNewBlock2[index5][
  //                                         //   'groups'
  //                                         // ][index6] = null;

  //                                         // this.plansNewBlock2[index5] = null;
  //                                         // this.plansNewBlock2.splice(index5,1)
  //                                       }
  //                                     }
  //                                   );
  //                                 }

  //                                 let validgroups = elementres.groups.filter(
  //                                   (v: any) => v !== null
  //                                 );

  //                                 console.log(validgroups);
  //                                 if (validgroups.length > 0) {
  //                                 } else {
  //                                   // this.plansNewBlock2[index5] = null;
  //                                   ////////show subGroups here
  //                                 }
  //                                 //
  //                               }
  //                             );
  //                           }
  //                         }
  //                       );
  //                     // }
  //                   }
  //                 }
  //               });
  //               // }
  //             }
  //           }
  //         });
  //       }
  //     })
  //       });
  //     }
  //   });

  //   console.log(this.plansNewBlock2);

  //   this.plansresblack2 = this.plansNewBlock2;

  //   sessionStorage.setItem('block2result', JSON.stringify(this.plansresblack2));

  //   setTimeout(() => {
  //     let selectedplansblock2 = JSON.parse(
  //       sessionStorage.getItem('summaryBlock2') || '[]'
  //     );
  //     setTimeout(() => {
  //       const dom: HTMLElement = this.elementRef.nativeElement;
  //       if (selectedplansblock2.length > 0) {
  //         for (let i = 0; i < selectedplansblock2.length; i++) {
  //           if (selectedplansblock2[i].subGroupId != 4) {
  //             // this.selectInBlock2()
  //           }
  //         }
  //       } else {
  //         // this.selectInBlock2()
  //       }
  //     }, 1000);
  //   }, 1000);

  //   // setTimeout(() => {
  //   //   $("#executiveplansblock2single17").prop("disabled", true);
  //   //   $("#executiveplansblock2couple17").prop("disabled", true);
  //   //   $("#executiveplansblock2family17").prop("disabled", true);
  //   //   $("#executiveplansblock2single18").prop("disabled", true);
  //   //   $("#executiveplansblock2couple18").prop("disabled", true);
  //   //   $("#executiveplansblock2family18").prop("disabled", true);

  //   // }, 1000);
  // }
  // public plansblock2() {

  //   this.plansNewBlock2 = [];

  //   this.plansNewBlock2 = JSON.parse(
  //     sessionStorage.getItem('mainresults') || '[]'
  //   );

  //   this.selectedplansblock1 = JSON.parse(
  //     sessionStorage.getItem('summaryBlock1') || '[]'
  //   );

  //   setTimeout(() => {

  //     let block1res = JSON.parse(
  //       sessionStorage.getItem('summaryBlock2') || '[]');



  //     for (let i = 0; i < block1res.length; i++) {
  //       if (block1res[i].subGroupId == 17) {

  //         $('#executiveplanssingle17').prop('disabled', false);
  //         $('#executiveplanscouple17').prop('disabled', false);
  //         $('#executiveplansfamily17').prop('disabled', false);
  //       }
  //       else {

  //         // $('#executiveplanssingle17').prop('disabled', true);
  //         // $('#executiveplanscouple17').prop('disabled', true);
  //         // $('#executiveplansfamily17').prop('disabled', true);
  //       }
  //       if (block1res[i].subGroupId == 18) {
  //         $('#executiveplanssingle18').prop('disabled', false);
  //         $('#executiveplanscouple18').prop('disabled', false);
  //         $('#executiveplansfamily18').prop('disabled', false);
  //       }
  //       else {
  //         // $('#executiveplanssingle18').prop('disabled', true);
  //         // $('#executiveplanscouple18').prop('disabled', true);
  //         // $('#executiveplansfamily18').prop('disabled', true);
  //       }

  //       if (block1res[i].subGroupId == 28) {
  //         $('#executiveplanssingle28').prop('disabled', false);
  //         $('#executiveplanscouple28').prop('disabled', false);
  //         $('#executiveplansfamily28').prop('disabled', false);
  //       }
  //       else {
  //         // $('#executiveplanssingle28').prop('disabled', true);
  //         // $('#executiveplanscouple28').prop('disabled', true);
  //         // $('#executiveplansfamily28').prop('disabled', true);
  //       }

  //     }

  //   }, 100);

  //   this.plansNewBlock2.forEach((packagelevel: any, index: any) => {
  //     if (!packagelevel) {
  //     }
  //     else {
  //       packagelevel.groups.forEach((groups: any, index1: any) => {

  //           this.selectedplansblock1 = JSON.parse(
  //             sessionStorage.getItem('summaryBlock1') || '[]')
  //           groups?.subGroups.forEach((subGroups: any, index2: any) => {

  //         // }
  //         if(subGroups){
  //         this.selectedplansblock1.forEach((selectplan: any) => {
  //           if (
  //             packagelevel.id == selectplan.packageid &&
  //             packagelevel.groups.id == selectplan.parentid
  //           ) {

  //             // if (subGroups.id == selectplan.subGroupId && subGroups.id != '17' && subGroups.id != '18' && subGroups.id != '28') {
  //             //   this.plansNewBlock2[index]['groups'][index1]['subGroups'].splice(index2,1)

  //             //   if(selectplan.disallowedPlanLevels){
  //             //     let disallowed_plans = selectplan.disallowedPlanLevels.split(',');

  //             //     console.log(disallowed_plans)

  //             //     disallowed_plans.forEach((disallowed: any,index9) => {


  //             //       this.plansNewBlock2[index]['groups'][index1]['subGroups'].forEach((plan: any,index10) => {

  //             //         if(this.plansNewBlock2[index]['groups'][index1]['subGroups'][index10].id==disallowed){
  //             //           this.plansNewBlock2[index]['groups'][index1]['subGroups'].splice(index10,1)
  //             //         }
  //             //       })



  //             //     })
  //             //     console.log(this.plansNewBlock2)

  //             //   }



  //             // }


  //             if (
  //               !this.plansNewBlock2[index] ||
  //               !this.plansNewBlock2[index]['groups'] ||
  //               !this.plansNewBlock2[index]['groups'][index1] ||
  //               !this.plansNewBlock2[index]['groups'][index1]['subGroups']
  //             ) {
  //             }

  //             else {
  //               var allAvailble = this.plansNewBlock2[index]['groups'][index1]['subGroups']

  //               console.log(allAvailble)

  //               allAvailble.forEach((element1: any, index2: any) => {
  //                 if (element1 != null) {
  //                   // if(element1.)
  //                   console.log(element1)

  //                   if (element1.id == '17' || element1.id == '18' || element1.id == '28') {
  //                     console.log(element1.id)
  //                     console.log(element1.ordering); //23  24   Default===single and Family
  //                     console.log(selectplan.orderId); //23  23
  //                     // if (element1.ordering > selectplan.orderId) {
  //                     //   console.log('ifstate');
  //                     // }
  //                     // else {
  //                       console.log('coverage' + selectplan.coverage);

  //                       this.upgradeplanscheck = this.getExecutiveCoveragesFromCode(selectplan.coverage)
  //                       // {single:true,couple:true,fam:false}

  //                       console.log(this.upgradeplanscheck)

  //                       if (this.upgradeplanscheck && this.upgradeplanscheck != null) {
  //                         if (this.upgradeplanscheck.single) {
  //                           console.log(element1.id)
  //                           console.log(selectplan.subGroupId)
  //                           if (element1.id >= selectplan.subGroupId) {
  //                             this.plansNewBlock2[index]['groups'][index1][
  //                               'subGroups'
  //                             ][index2]['coverage'] = '001';
  //                           } else {
  //                             // this.plansNewBlock2[index]['groups'][index1][
  //                             //   'subGroups'
  //                             // ][index2] = null;
  //                           }
  //                         }
  //                         if (this.upgradeplanscheck.couple) {
  //                           if (element1.id >= selectplan.subGroupId) {
  //                             this.plansNewBlock2[index]['groups'][index1][
  //                               'subGroups'
  //                             ][index2]['coverage'] = '010';
  //                           } else {
  //                             // this.plansNewBlock2[index]['groups'][index1][
  //                             //   'subGroups'
  //                             // ][index2] = null;
  //                           }
  //                         }
  //                         if (this.upgradeplanscheck.single && this.upgradeplanscheck.couple) {
  //                           if (element1.id >= selectplan.subGroupId) {
  //                             this.plansNewBlock2[index]['groups'][index1][
  //                               'subGroups'
  //                             ][index2]['coverage'] = '011';
  //                           } else {
  //                             // this.plansNewBlock2[index]['groups'][index1][
  //                             //   'subGroups'
  //                             // ][index2] = null;
  //                           }
  //                         }
  //                         if (this.upgradeplanscheck.family) {
  //                           // this.plansNewBlock2[index]['groups'][index1][
  //                           //   'subGroups'
  //                           // ][index2] = null;
  //                         }
  //                       }

  //                       // this.plansNewBlock2.forEach(
  //                       //   (elementres: any, index5: any) => {
  //                       //     if (!elementres || !elementres.groups) {
  //                       //     } else {
  //                       //       elementres.groups.forEach(
  //                       //         (group: any, index6: any) => {
  //                       //           console.log(group);
  //                       //           if (!this.plansNewBlock2[index5] ||
  //                       //             !this.plansNewBlock2[index5]['groups'] ||
  //                       //             !this.plansNewBlock2[index5]['groups'][
  //                       //             index6
  //                       //             ] ||
  //                       //             !this.plansNewBlock2[index5]['groups'][
  //                       //             index6
  //                       //             ]['subGroups']
  //                       //           ) {
  //                       //           } else {
  //                       //             group.subGroups.forEach(
  //                       //               (subgroups: any, index7: any) => {
  //                       //                 let validSubgroups = group[
  //                       //                   'subGroups'
  //                       //                 ].filter((v: any) => v !== null);

  //                       //                 console.log(validSubgroups);
  //                       //                 if (validSubgroups.length > 0) {
  //                       //                 } else {
  //                       //                   // this.plansNewBlock2[index5][
  //                       //                   //   'groups'
  //                       //                   // ][index6] = null;

  //                       //                   this.plansNewBlock2[index5] = null;
  //                       //                   // this.plansNewBlock2.splice(index5,1)
  //                       //                 }
  //                       //               }
  //                       //             );
  //                       //           }

  //                       //           let validgroups = elementres.groups.filter(
  //                       //             (v: any) => v !== null
  //                       //           );

  //                       //           console.log(validgroups);
  //                       //           if (validgroups.length > 0) {
  //                       //           } else {
  //                       //            this.plansNewBlock2[index5] = null;
  //                       //             ////////show subGroups here
  //                       //           }
  //                       //           //
  //                       //         }
  //                       //       );
  //                       //     }
  //                       //   }
  //                       // );
  //                     // }
  //                   }
  //                   else {
  //                     console.log(element1.id)


  //                       // this.plansNewBlock2[index]['groups'][index1][
  //                       //   'subGroups'
  //                       // ][index2] = null;

  //                       // this.plansNewBlock2.forEach(
  //                       //   (elementres: any, index5: any) => {
  //                       //     if (!elementres || !elementres.groups) {
  //                       //     } else {
  //                       //       elementres.groups.forEach(
  //                       //         (group: any, index6: any) => {
  //                       //           console.log(group);
  //                       //           if (!this.plansNewBlock2[index5] ||
  //                       //             !this.plansNewBlock2[index5]['groups'] ||
  //                       //             !this.plansNewBlock2[index5]['groups'][
  //                       //             index6
  //                       //             ] ||
  //                       //             !this.plansNewBlock2[index5]['groups'][
  //                       //             index6
  //                       //             ]['subGroups']
  //                       //           ) {
  //                       //           } else {
  //                       //             group.subGroups.forEach(
  //                       //               (subgroups: any, index7: any) => {
  //                       //                 let validSubgroups = group[
  //                       //                   'subGroups'
  //                       //                 ].filter((v: any) => v !== null);

  //                       //                 console.log(validSubgroups);
  //                       //                 if (validSubgroups.length > 0) {
  //                       //                 } else {
  //                       //                   // this.plansNewBlock2[index5][
  //                       //                   //   'groups'
  //                       //                   // ][index6] = null;
  //                       //                   // this.plansNewBlock2[index5] = null;
  //                       //                   // this.plansNewBlock2[index5] = null;
  //                       //                   // this.plansNewBlock2.splice(index5,1)
  //                       //                 }
  //                       //               }
  //                       //             );
  //                       //           }

  //                       //           let validgroups = elementres.groups.filter(
  //                       //             (v: any) => v !== null
  //                       //           );

  //                       //           console.log(validgroups);
  //                       //           if (validgroups.length > 0) {
  //                       //           } else {
  //                       //             // this.plansNewBlock2[index5] = null;
  //                       //             ////////show subGroups here
  //                       //           }
  //                       //           //
  //                       //         }
  //                       //       );
  //                       //     }
  //                       //   }
  //                       // );
  //                     // }
  //                   }
  //                 }
  //               });
  //               // }
  //             }
  //           }
  //         });
  //       }
  //     })
  //       });
  //     }
  //   });

  //   console.log(this.plansNewBlock2);

  //   this.plansresblack2 = this.plansNewBlock2;

  //   sessionStorage.setItem('block2result', JSON.stringify(this.plansresblack2));

  //   setTimeout(() => {
  //     let selectedplansblock2 = JSON.parse(
  //       sessionStorage.getItem('summaryBlock2') || '[]'
  //     );
  //     setTimeout(() => {
  //       const dom: HTMLElement = this.elementRef.nativeElement;
  //       if (selectedplansblock2.length > 0) {
  //         for (let i = 0; i < selectedplansblock2.length; i++) {
  //           if (selectedplansblock2[i].subGroupId != 4) {
  //             // this.selectInBlock2()
  //           }
  //         }
  //       } else {
  //         // this.selectInBlock2()
  //       }
  //     }, 1000);
  //   }, 1000);

  //   // setTimeout(() => {
  //   //   $("#executiveplansblock2single17").prop("disabled", true);
  //   //   $("#executiveplansblock2couple17").prop("disabled", true);
  //   //   $("#executiveplansblock2family17").prop("disabled", true);
  //   //   $("#executiveplansblock2single18").prop("disabled", true);
  //   //   $("#executiveplansblock2couple18").prop("disabled", true);
  //   //   $("#executiveplansblock2family18").prop("disabled", true);

  //   // }, 1000);
  // }
  public plansblock2() {

    this.plansNewBlock2 = [];

    this.plansNewBlock2 = JSON.parse(
      sessionStorage.getItem('mainresults') || '[]'
    );

    this.selectedplansblock1 = JSON.parse(
      sessionStorage.getItem('summaryBlock1') || '[]'
    );

    setTimeout(() => {

      let block1res = JSON.parse(
        sessionStorage.getItem('summaryBlock2') || '[]');



      for (let i = 0; i < block1res.length; i++) {
        if (block1res[i].subGroupId == 17) {

          $('#executiveplanssingle17').prop('disabled', false);
          $('#executiveplanscouple17').prop('disabled', false);
          $('#executiveplansfamily17').prop('disabled', false);
        }
        else {

          // $('#executiveplanssingle17').prop('disabled', true);
          // $('#executiveplanscouple17').prop('disabled', true);
          // $('#executiveplansfamily17').prop('disabled', true);
        }
        if (block1res[i].subGroupId == 18) {
          $('#executiveplanssingle18').prop('disabled', false);
          $('#executiveplanscouple18').prop('disabled', false);
          $('#executiveplansfamily18').prop('disabled', false);
        }
        else {
          // $('#executiveplanssingle18').prop('disabled', true);
          // $('#executiveplanscouple18').prop('disabled', true);
          // $('#executiveplansfamily18').prop('disabled', true);
        }

        if (block1res[i].subGroupId == 28) {
          $('#executiveplanssingle28').prop('disabled', false);
          $('#executiveplanscouple28').prop('disabled', false);
          $('#executiveplansfamily28').prop('disabled', false);
        }
        else {
          // $('#executiveplanssingle28').prop('disabled', true);
          // $('#executiveplanscouple28').prop('disabled', true);
          // $('#executiveplansfamily28').prop('disabled', true);
        }

      }

    }, 100);

    this.plansNewBlock2.forEach((packagelevel: any, index: any) => {
      if (!packagelevel) {
      }
      else {
        packagelevel.groups.forEach((groups: any, index1: any) => {

          this.selectedplansblock1 = JSON.parse(
            sessionStorage.getItem('summaryBlock1') || '[]')
          groups?.subGroups.forEach((subGroups: any, index2: any) => {

            // }
            if (subGroups) {
              this.selectedplansblock1.forEach((selectplan: any) => {
                if (
                  packagelevel.id == selectplan.packageid &&
                  packagelevel.groups.id == selectplan.parentid
                ) {

                  // if (subGroups.id == selectplan.subGroupId && subGroups.id != '17' && subGroups.id != '18' && subGroups.id != '28') {
                  //   this.plansNewBlock2[index]['groups'][index1]['subGroups'].splice(index2,1)

                  //   if(selectplan.disallowedPlanLevels){
                  //     let disallowed_plans = selectplan.disallowedPlanLevels.split(',');

                  //     console.log(disallowed_plans)

                  //     disallowed_plans.forEach((disallowed: any,index9) => {


                  //       this.plansNewBlock2[index]['groups'][index1]['subGroups'].forEach((plan: any,index10) => {

                  //         if(this.plansNewBlock2[index]['groups'][index1]['subGroups'][index10].id==disallowed){
                  //           this.plansNewBlock2[index]['groups'][index1]['subGroups'].splice(index10,1)
                  //         }
                  //       })



                  //     })
                  //     console.log(this.plansNewBlock2)

                  //   }



                  // }


                  if (
                    !this.plansNewBlock2[index] ||
                    !this.plansNewBlock2[index]['groups'] ||
                    !this.plansNewBlock2[index]['groups'][index1] ||
                    !this.plansNewBlock2[index]['groups'][index1]['subGroups']
                  ) {
                  }

                  else {
                    var allAvailble = this.plansNewBlock2[index]['groups'][index1]['subGroups']

                    // console.log(allAvailble)

                    allAvailble.forEach((element1: any, index2: any) => {
                      if (element1 != null) {
                        // if(element1.)
                        // console.log(element1)

                        if (element1.id == '17' || element1.id == '18' || element1.id == '28') {
                          // console.log(element1.id)
                          // console.log(element1.ordering); //23  24   Default===single and Family
                          // console.log(selectplan.orderId); //23  23
                          // if (element1.ordering > selectplan.orderId) {
                          //   console.log('ifstate');
                          // }
                          // else {

                          this.upgradeplanscheck = this.getExecutiveCoveragesFromCode(selectplan.coverage)
                          // {single:true,couple:true,fam:false}



                          if (element1.id == selectplan.subGroupId) {
                            if (this.upgradeplanscheck && this.upgradeplanscheck != null) {
                              if (this.upgradeplanscheck.single) {
                                console.log(element1.id)
                                console.log(selectplan.subGroupId)
                                if (element1.id >= selectplan.subGroupId) {
                                  this.plansNewBlock2[index]['groups'][index1][
                                    'subGroups'
                                  ][index2]['coverage'] = '001';
                                } else {
                                  this.plansNewBlock2[index]['groups'][index1][
                                    'subGroups'
                                  ][index2] = null;
                                }
                              }
                              if (this.upgradeplanscheck.couple) {
                                if (element1.id >= selectplan.subGroupId) {
                                  this.plansNewBlock2[index]['groups'][index1][
                                    'subGroups'
                                  ][index2]['coverage'] = '010';
                                } else {
                                  this.plansNewBlock2[index]['groups'][index1][
                                    'subGroups'
                                  ][index2] = null;
                                }
                              }
                              if (this.upgradeplanscheck.single && this.upgradeplanscheck.couple) {
                                if (element1.id >= selectplan.subGroupId) {
                                  this.plansNewBlock2[index]['groups'][index1][
                                    'subGroups'
                                  ][index2]['coverage'] = '011';
                                } else {
                                  this.plansNewBlock2[index]['groups'][index1][
                                    'subGroups'
                                  ][index2] = null;
                                }
                              }
                              if (this.upgradeplanscheck.family) {
                                this.plansNewBlock2[index]['groups'][index1][
                                  'subGroups'
                                ][index2] = null;
                              }
                            }
                          }

                          // this.plansNewBlock2.forEach(
                          //   (elementres: any, index5: any) => {
                          //     if (!elementres || !elementres.groups) {
                          //     } else {
                          //       elementres.groups.forEach(
                          //         (group: any, index6: any) => {
                          //           console.log(group);
                          //           if (!this.plansNewBlock2[index5] ||
                          //             !this.plansNewBlock2[index5]['groups'] ||
                          //             !this.plansNewBlock2[index5]['groups'][
                          //             index6
                          //             ] ||
                          //             !this.plansNewBlock2[index5]['groups'][
                          //             index6
                          //             ]['subGroups']
                          //           ) {
                          //           } else {
                          //             group.subGroups.forEach(
                          //               (subgroups: any, index7: any) => {
                          //                 let validSubgroups = group[
                          //                   'subGroups'
                          //                 ].filter((v: any) => v !== null);

                          //                 console.log(validSubgroups);
                          //                 if (validSubgroups.length > 0) {
                          //                 } else {
                          //                   // this.plansNewBlock2[index5][
                          //                   //   'groups'
                          //                   // ][index6] = null;

                          //                   this.plansNewBlock2[index5] = null;
                          //                   // this.plansNewBlock2.splice(index5,1)
                          //                 }
                          //               }
                          //             );
                          //           }

                          //           let validgroups = elementres.groups.filter(
                          //             (v: any) => v !== null
                          //           );

                          //           console.log(validgroups);
                          //           if (validgroups.length > 0) {
                          //           } else {
                          //            this.plansNewBlock2[index5] = null;
                          //             ////////show subGroups here
                          //           }
                          //           //
                          //         }
                          //       );
                          //     }
                          //   }
                          // );
                          // }
                        }
                        else {
                          if (element1.id == selectplan.subGroupId) {
                            this.plansNewBlock2[index]['groups'][index1][
                              'subGroups'
                            ][index2] = null;
                          }

                          // if (element1.ordering >= selectplan.orderId) {
                          // }
                          // else {
                          //   this.plansNewBlock2[index]['groups'][index1][
                          //     'subGroups'
                          //   ][index2] = null;
                          // }
                          // if(element1.id ==selectplan.subGroupId){


                          //      this.plansNewBlock2[index]['groups'][index1][
                          //     'subGroups'
                          //   ][index2] = null;
                          // }
                          // console.log(element1.id)


                          // this.plansNewBlock2[index]['groups'][index1][
                          //   'subGroups'
                          // ][index2] = null;

                          // this.plansNewBlock2.forEach(
                          //   (elementres: any, index5: any) => {
                          //     if (!elementres || !elementres.groups) {
                          //     } else {
                          //       elementres.groups.forEach(
                          //         (group: any, index6: any) => {
                          //           console.log(group);
                          //           if (!this.plansNewBlock2[index5] ||
                          //             !this.plansNewBlock2[index5]['groups'] ||
                          //             !this.plansNewBlock2[index5]['groups'][
                          //             index6
                          //             ] ||
                          //             !this.plansNewBlock2[index5]['groups'][
                          //             index6
                          //             ]['subGroups']
                          //           ) {
                          //           } else {
                          //             group.subGroups.forEach(
                          //               (subgroups: any, index7: any) => {
                          //                 let validSubgroups = group[
                          //                   'subGroups'
                          //                 ].filter((v: any) => v !== null);

                          //                 console.log(validSubgroups);
                          //                 if (validSubgroups.length > 0) {
                          //                 } else {
                          //                   // this.plansNewBlock2[index5][
                          //                   //   'groups'
                          //                   // ][index6] = null;
                          //                   // this.plansNewBlock2[index5] = null;
                          //                   // this.plansNewBlock2[index5] = null;
                          //                   // this.plansNewBlock2.splice(index5,1)
                          //                 }
                          //               }
                          //             );
                          //           }

                          //           let validgroups = elementres.groups.filter(
                          //             (v: any) => v !== null
                          //           );

                          //           console.log(validgroups);
                          //           if (validgroups.length > 0) {
                          //           } else {
                          //             // this.plansNewBlock2[index5] = null;
                          //             ////////show subGroups here
                          //           }
                          //           //
                          //         }
                          //       );
                          //     }
                          //   }
                          // );
                          // }
                        }
                      }
                    });
                    // }
                  }
                }
              });
            }
          })
        });
      }
    });

    console.log(this.plansNewBlock2);

    this.plansresblack2 = this.plansNewBlock2;

    sessionStorage.setItem('block2result', JSON.stringify(this.plansresblack2));

    setTimeout(() => {
      let selectedplansblock2 = JSON.parse(
        sessionStorage.getItem('summaryBlock2') || '[]'
      );
      setTimeout(() => {
        const dom: HTMLElement = this.elementRef.nativeElement;
        if (selectedplansblock2.length > 0) {
          for (let i = 0; i < selectedplansblock2.length; i++) {
            if (selectedplansblock2[i].subGroupId != 4) {
              // this.selectInBlock2()
            }
          }
        } else {
          // this.selectInBlock2()
        }
      }, 1000);
    }, 1000);

    // setTimeout(() => {
    //   $("#executiveplansblock2single17").prop("disabled", true);
    //   $("#executiveplansblock2couple17").prop("disabled", true);
    //   $("#executiveplansblock2family17").prop("disabled", true);
    //   $("#executiveplansblock2single18").prop("disabled", true);
    //   $("#executiveplansblock2couple18").prop("disabled", true);
    //   $("#executiveplansblock2family18").prop("disabled", true);

    // }, 1000);
  }
  public selectInBlock2() {
    const dom: HTMLElement = this.elementRef.nativeElement;
    const element: any = dom.querySelector('#plancheck2Upgrade' + 4);

    if (element) {
      element.click();
    }
  }

  public plansblock2tiers() {
    this.plansNewBlock2Tiers = [];

    // this.plansNewBlock2Tiers = this.plansBlock1Tiers
    this.plansNewBlock2Tiers = JSON.parse(
      sessionStorage.getItem('plansBlock1Tiers') || '[]'
    );
    // this.plansNewBlock2Tiers = this.plansBlock1Tiers

    // this.selectedplansblock1 = JSON.parse(
    //   sessionStorage.getItem('selectedTiersBlock1') || '[]'
    // );

    this.selectedplansblock1 = this.seelctedplanLevelTierMapping;

    console.log(this.selectedplansblock1);

    this.plansNewBlock2Tiers.forEach((packagelevel: any, index: any) => {
      if (!packagelevel) {
      } else {
        packagelevel.groups.forEach((groups: any, index1: any) => {
          this.selectedplansblock1.forEach((selectplan: any) => {
            if (
              packagelevel.id == selectplan.packageId &&
              packagelevel.groups.id == selectplan.parentId
            ) {
              if (
                !this.plansNewBlock2Tiers[index] ||
                !this.plansNewBlock2Tiers[index]['groups'] ||
                !this.plansNewBlock2Tiers[index]['groups'][index1] ||
                !this.plansNewBlock2Tiers[index]['groups'][index1]['subGroups']
              ) {
              } else {
                var allAvailble =
                  this.plansNewBlock2Tiers[index]['groups'][index1][
                  'subGroups'
                  ];

                if (
                  this.plansNewBlock2Tiers[index].id == selectplan.packageId &&
                  this.plansNewBlock2Tiers[index]['groups'][index1].id !=
                  selectplan.parentid
                ) {
                  // console.log("ignore")

                  this.plansNewBlock2Tiers[index]['groups'][index1] = null;
                } else {
                  //  console.log("oktoselect")
                  console.log(allAvailble);
                  allAvailble.forEach((element1: any, index2: any) => {
                    if (element1 != null) {
                      this.plansNewBlock2Tiers[index]['groups'][index1][
                        'subGroups'
                      ][index2].tiers = []; //here tiersmake empty Array
                      this.plansNewBlock2Tiers[index]['groups'][index1][
                        'subGroups'
                      ][index2].checked = false; //here tiersmake empty Array
                      // if(element1.)

                      if (element1.parentId != 15) {
                        if (element1.id == selectplan.subGroupid) {
                          // this.plansNewBlock2Tiers[index]['groups'][index1][
                          //   'subGroups'
                          // ][index2] = null;    ///Here Plan Selection

                          selectplan.tiers.forEach(
                            (tiers: any, index7: any) => {
                              if (tiers.name == 'All') {
                                this.plansNewBlock2Tiers[index]['groups'][
                                  index1
                                ]['subGroups'][index2] = null;
                              } else {
                                // console.log(availbleTierBlock2)
                              }
                            }
                          );

                          this.plansNewBlock2Tiers.forEach(
                            (elementres: any, index5: any) => {
                              if (!elementres || !elementres.groups) {
                              } else {
                                elementres.groups.forEach(
                                  (group: any, index6: any) => {
                                    if (
                                      !this.plansNewBlock2Tiers[index5] ||
                                      !this.plansNewBlock2Tiers[index5][
                                      'groups'
                                      ] ||
                                      !this.plansNewBlock2Tiers[index5][
                                      'groups'
                                      ][index6] ||
                                      !this.plansNewBlock2Tiers[index5][
                                      'groups'
                                      ][index6]['subGroups']
                                    ) {
                                    } else {
                                      console.log(group);
                                      group.subGroups.forEach(
                                        (subgroups: any, index7: any) => {
                                          let validSubgroups = group[
                                            'subGroups'
                                          ].filter((v: any) => v !== null);

                                          console.log(validSubgroups);
                                          if (validSubgroups.length > 0) {
                                          } else {
                                            this.plansNewBlock2Tiers[index5][
                                              'groups'
                                            ][index6] = null;
                                            // this.plansNewBlock2.splice(index5,1)
                                          }
                                        }
                                      );
                                    }

                                    let validgroups = elementres.groups.filter(
                                      (v: any) => v !== null
                                    );

                                    console.log(validgroups);
                                    if (validgroups.length > 0) {
                                    } else {
                                      this.plansNewBlock2Tiers[index5] = null;
                                      ////////show subGroups here
                                    }
                                    //
                                  }
                                );
                              }
                            }
                          );
                        } else {
                        }
                      } else {
                        if (element1.id == selectplan.subGroupid) {
                          if (selectplan.coverage == 'Single') {
                            // if (element1.id >= selectplan.subGroupId) {
                            //   this.plansNewBlock2Tiers[index]['groups'][index1][
                            //     'subGroups'
                            //   ][index2]['coverage']="Couple"
                            // }
                            // else{
                            //   this.plansNewBlock2Tiers[index]['groups'][index1][
                            //     'subGroups'
                            //   ][index2] = null;
                            // }
                          } else if (selectplan.coverage == 'Couple') {
                            // if (element1.id >= selectplan.subGroupId) {
                            //   this.plansNewBlock2Tiers[index]['groups'][index1][
                            //     'subGroups'
                            //   ][index2]['coverage']="Family"
                            // }
                            // else{
                            //   this.plansNewBlock2Tiers[index]['groups'][index1][
                            //     'subGroups'
                            //   ][index2] = null;
                            // }
                          } else {
                            this.plansNewBlock2Tiers[index]['groups'][index1][
                              'subGroups'
                            ][index2] = null;
                          }
                          this.plansNewBlock2Tiers.forEach(
                            (elementres: any, index5: any) => {
                              if (!elementres || !elementres.groups) {
                              } else {
                                elementres.groups.forEach(
                                  (group: any, index6: any) => {
                                    if (
                                      !this.plansNewBlock2Tiers[index5] ||
                                      !this.plansNewBlock2Tiers[index5][
                                      'groups'
                                      ] ||
                                      !this.plansNewBlock2Tiers[index5][
                                      'groups'
                                      ][index6] ||
                                      !this.plansNewBlock2Tiers[index5][
                                      'groups'
                                      ][index6]['subGroups']
                                    ) {
                                    } else {
                                      console.log(group);
                                      group.subGroups.forEach(
                                        (subgroups: any, index7: any) => {
                                          let validSubgroups = group[
                                            'subGroups'
                                          ].filter((v: any) => v !== null);

                                          console.log(validSubgroups);
                                          if (validSubgroups.length > 0) {
                                          } else {
                                            this.plansNewBlock2Tiers[index5][
                                              'groups'
                                            ][index6] = null;
                                            // this.plansNewBlock2.splice(index5,1)
                                          }
                                        }
                                      );
                                    }

                                    let validgroups = elementres.groups.filter(
                                      (v: any) => v !== null
                                    );

                                    console.log(validgroups);
                                    if (validgroups.length > 0) {
                                    } else {
                                      this.plansNewBlock2Tiers[index5] = null;
                                      ////////show subGroups here
                                    }
                                    //
                                  }
                                );
                              }
                            }
                          );
                        } else {
                          // console.log("coverage"+selectplan.coverage)
                          // if(selectplan.coverage=="Single"){
                          //   if (element1.id >= selectplan.subGroupId) {
                          //     this.plansNewBlock2Tiers[index]['groups'][index1][
                          //       'subGroups'
                          //     ][index2]['coverage']="Couple"
                          //   }
                          //   else{
                          //     this.plansNewBlock2Tiers[index]['groups'][index1][
                          //       'subGroups'
                          //     ][index2] = null;
                          //   }
                          // }
                          // else if(selectplan.coverage=="Couple"){
                          //   if (element1.id >= selectplan.subGroupId) {
                          //     this.plansNewBlock2Tiers[index]['groups'][index1][
                          //       'subGroups'
                          //     ][index2]['coverage']="Family"
                          //   }
                          //   else{
                          //     this.plansNewBlock2Tiers[index]['groups'][index1][
                          //       'subGroups'
                          //     ][index2] = null;
                          //   }
                          // }
                          // else{
                          //   this.plansNewBlock2Tiers[index]['groups'][index1][
                          //     'subGroups'
                          //   ][index2] = null;
                          // }
                        }
                      }
                    }
                  });
                }
              }
            }
          });
        });
      }
    });

    console.log(this.plansNewBlock2Tiers);

    this.plansresblack2Tiers = this.plansNewBlock2Tiers;

    sessionStorage.setItem(
      'block2resultTiers',
      JSON.stringify(this.plansresblack2Tiers)
    );

    setTimeout(() => {
      sessionStorage.setItem('selectedTiersBlock2', '[]');
      const dom: HTMLElement = this.elementRef.nativeElement;

      this.plansresblack2Tiers.forEach((packagelevel: any, index: any) => {
        if (!packagelevel) {
        } else {
          packagelevel.groups.forEach((groups: any, index1: any) => {
            if (
              !this.plansresblack2Tiers[index] ||
              !this.plansresblack2Tiers[index]['groups']
            ) {
            } else {
              if (
                !this.plansresblack2Tiers[index]['groups'][index1] ||
                !this.plansresblack2Tiers[index]['groups'][index1]['subGroups']
              ) {
              } else {
                groups.subGroups.forEach((subGroups: any, index2: any) => {
                  if (
                    !this.plansresblack2Tiers[index]['groups'][index1] ||
                    !this.plansresblack2Tiers[index]['groups'][index1][
                    'subGroups'
                    ][index2]
                  ) {
                  } else {
                    // const element: any = dom.querySelector("#plancheck2Upgrade" +  this.plansresblack2Tiers[index]['groups'][index1]['subGroups'][index2].id);
                    // console.log(element)
                    //    element.click()    ///Here plans Selectedt Auto
                  }
                });
              }
            }
          });
        }
      });
    }, 1000);
  }

  planpurchase(e: any) {

    if (e.target.value == 'true') {
      let checkCoverage = true;

      this.employeeplanpurchase = true;

      if (this.upgradeplansselection == true) {
        let block1res = JSON.parse(
          sessionStorage.getItem('summaryBlock2') || '[]'
        );


        console.log(block1res)
        sessionStorage.setItem('summaryBlock2', JSON.stringify(block1res))
        this.plansblock3();
        // if (JSON.parse(sessionStorage.getItem('summaryBlock1'))) {

        //   this.employeeplanpurchase = true;

        //   this.plansblock3();
        // }
        // else {
        //   // Swal.fire('Info','Please select one plan from above');
        //   Swal.fire({ title: 'Info', text: 'Please select one plan from above' });

        //   this.employeeplanpurchase = false;
        //   let el: HTMLElement = this.employeepurchasefalse.nativeElement;
        //   el.click();
        // }
      }
      else {
        let summaryBlock1 = JSON.parse(sessionStorage.getItem('summaryBlock1')) ?? [];
        this.plansblock3();
        // if (summaryBlock1 && summaryBlock1.length > 0) {

        //   this.employeeplanpurchase = true;

        //   this.plansblock3();
        // }
        // else {
        //   // Swal.fire('Info','Please select one plan from above');
        //   Swal.fire({ title: 'Info', text: 'Please select one plan from above' });

        //   this.employeeplanpurchase = false;
        //   let el: HTMLElement = this.employeepurchasefalse.nativeElement;
        //   el.click();
        // }
      }

      let selectedplansblock3 = JSON.parse(
        sessionStorage.getItem('summaryBlock3') || '[]'
      );

      setTimeout(() => {
        for (let i = 0; i < selectedplansblock3.length; i++) {

          $("#plancheck3Voluntry" + selectedplansblock3[i].subGroupId).prop("checked", true);

          // element2.checked = true;
          // this.plancheck3Coverage = selectedplansblock3[i].coverage;
          this.plancheck3Coverage = this.getExecutiveCoveragesFromCode(selectedplansblock3[i].coverage)


          if (
            this.plancheck3Coverage
          ) {
            if (this.plancheck3Coverage.single) {

              $("#executiveplansblock3single" + selectedplansblock3[i].subGroupId).prop("checked", true);

              // element2.checked = true;
            } if (this.plancheck3Coverage.couple) {

              $("#executiveplansblock3couple" + selectedplansblock3[i].subGroupId).prop("checked", true);

              // element2.checked = true;
            } if (this.plancheck3Coverage.family) {

              $("#executiveplansblock3family" + selectedplansblock3[i].subGroupId).prop("checked", true);

              // element2.checked = true;
            }
          }
        }
      }, 3000);



    }
    else {


      this.employeeplanpurchase = false;
      sessionStorage.setItem('summaryBlock3', '[]');
    }
  }
  planpurchaseTiers(e: any) {
    if (e.target.value == 'true') {
      if (
        JSON.parse(sessionStorage.getItem('selectedTiersBlock1') || '[]')
          .length > 0
      ) {
        this.employeeplanpurchasetiers = true;
        this.plansblock3Tiers();
      } else {
        // Swal.fire('Info','Please select one plan from above');
        Swal.fire({ title: this.lang.Info, text: this.lang.Please_select_one_plan_from_above });

        this.employeeplanpurchasetiers = false;
        let el: HTMLElement = this.employeepurchasefalse.nativeElement;
        el.click();
      }
    } else {
      this.employeeplanpurchasetiers = false;
      sessionStorage.setItem('selectedTiersBlock3', '[]');
    }
  }
  // public plansblock3() {
  //   this.Newplansresblack3 = [];

  //   if (this.upgradeplansselection == true) {
  //     this.Newplansresblack3 = JSON.parse(
  //       sessionStorage.getItem('block2result') || '[]'
  //     );

  //     // this.Newplansresblack3 = this.plansresblack2Tiers;
  //     this.selectedplansblock1 = JSON.parse(
  //       sessionStorage.getItem('summaryBlock2') || '[]'
  //     );
  //   } else {
  //     this.Newplansresblack3 = JSON.parse(
  //       sessionStorage.getItem('mainresults') || '[]'
  //     );
  //     // this.Newplansresblack3 = this.plansBlock1Tiers;
  //     this.selectedplansblock1 = JSON.parse(
  //       sessionStorage.getItem('summaryBlock1') || '[]'
  //     );
  //   }

  //   this.Newplansresblack3.forEach((packagelevel: any, index: any) => {
  //     var grpcount = 0;

  //     if (!packagelevel) {
  //     } else {
  //       packagelevel.groups.forEach((groups: any, index1: any) => {
  //         this.selectedplansblock1.forEach((selectplan: any) => {
  //           if (
  //             packagelevel.id == selectplan.packageid &&
  //             packagelevel.groups.id == selectplan.parentid
  //           ) {
  //             if (
  //               !this.Newplansresblack3[index] ||
  //               !this.Newplansresblack3[index]['groups']
  //             ) {
  //             } else {
  //               if (
  //                 !this.Newplansresblack3[index]['groups'][index1] ||
  //                 !this.Newplansresblack3[index]['groups'][index1]['subGroups']
  //               ) {
  //               } else {
  //                 var allAvailble =
  //                   this.Newplansresblack3[index]['groups'][index1][
  //                   'subGroups'
  //                   ];

  //                 var sgcount = 0;

  //                 allAvailble.forEach((element1: any, index2: any) => {
  //                   if (element1 != null) {
  //                     //removeif
  //                     console.log('6');
  //                     if (element1.id != '17' && element1.id != '18' && element1.id != '28') {
  //                       // if (element1.ordering > selectplan.orderId) {
  //                       // }
  //                       // else {
  //                         this.Newplansresblack3[index]['groups'][index1][
  //                           'subGroups'
  //                         ][index2] = null;

  //                         this.Newplansresblack3.forEach(
  //                           (elementres: any, index5: any) => {
  //                             if (!elementres || !elementres.groups) {
  //                             } else {
  //                               elementres.groups.forEach(
  //                                 (group: any, index6: any) => {
  //                                   // console.log(group)
  //                                   if (
  //                                     !this.Newplansresblack3[index5] ||
  //                                     !this.Newplansresblack3[index5][
  //                                     'groups'
  //                                     ] ||
  //                                     !this.Newplansresblack3[index5]['groups'][
  //                                     index6
  //                                     ] ||
  //                                     !this.Newplansresblack3[index5]['groups'][
  //                                     index6
  //                                     ]['subGroups']
  //                                   ) {
  //                                   } else {
  //                                     group.subGroups.forEach(
  //                                       (subgroups: any, index7: any) => {
  //                                         let validSubgroups = group[
  //                                           'subGroups'
  //                                         ].filter((v: any) => v !== null);

  //                                         console.log(validSubgroups);
  //                                         if (validSubgroups.length > 0) {
  //                                         } else {
  //                                           this.Newplansresblack3[index5][
  //                                             'groups'
  //                                           ][index6] = null;
  //                                           // this.plansNewBlock2.splice(index5,1)
  //                                         }
  //                                       }
  //                                     );
  //                                   }

  //                                   let validgroups = elementres.groups.filter(
  //                                     (v: any) => v !== null
  //                                   );

  //                                   console.log(validgroups);
  //                                   if (validgroups.length > 0) {
  //                                   } else {
  //                                     this.Newplansresblack3[index5] = null;
  //                                     ////////show subGroups here
  //                                   }
  //                                   //
  //                                 }
  //                               );
  //                             }
  //                           }
  //                         );
  //                         sgcount++;
  //                       // }
  //                     }
  //                     else {
  //                       console.log(element1.ordering); //23  24   Default===single and Family
  //                       console.log(selectplan.orderId); //23  23
  //                       // if (element1.ordering > selectplan.orderId) {
  //                       //   console.log('ifstate');
  //                       // }
  //                       // else {
  //                         console.log('coverage' + selectplan.coverage);

  //                         this.employeeplancheck =
  //                           this.getExecutiveCoveragesFromCode(
  //                             selectplan.coverage
  //                           );
  //                         if (this.employeeplancheck && this.employeeplancheck.single) {
  //                           if (element1.id >= selectplan.subGroupId) {
  //                             this.Newplansresblack3[index]['groups'][index1][
  //                               'subGroups'
  //                             ][index2]['coverage'] = '001';
  //                           } else {
  //                             this.Newplansresblack3[index]['groups'][index1][
  //                               'subGroups'
  //                             ][index2] = null;
  //                           }
  //                         }
  //                         if (this.employeeplancheck && this.employeeplancheck.couple) {
  //                           if (element1.id >= selectplan.subGroupId) {
  //                             this.Newplansresblack3[index]['groups'][index1][
  //                               'subGroups'
  //                             ][index2]['coverage'] = '010';
  //                           } else {
  //                             this.Newplansresblack3[index]['groups'][index1][
  //                               'subGroups'
  //                             ][index2] = null;
  //                           }
  //                         }
  //                         if (this.employeeplancheck && this.employeeplancheck.family) {
  //                           this.Newplansresblack3[index]['groups'][index1][
  //                             'subGroups'
  //                           ][index2] = null;
  //                         }

  //                         this.Newplansresblack3.forEach(
  //                           (elementres: any, index5: any) => {
  //                             if (!elementres || !elementres.groups) {
  //                             } else {
  //                               elementres.groups.forEach(
  //                                 (group: any, index6: any) => {
  //                                   // console.log(group)
  //                                   if (
  //                                     !this.Newplansresblack3[index5] ||
  //                                     !this.Newplansresblack3[index5][
  //                                     'groups'
  //                                     ] ||
  //                                     !this.Newplansresblack3[index5]['groups'][
  //                                     index6
  //                                     ] ||
  //                                     !this.Newplansresblack3[index5]['groups'][
  //                                     index6
  //                                     ]['subGroups']
  //                                   ) {
  //                                   } else {
  //                                     group.subGroups.forEach(
  //                                       (subgroups: any, index7: any) => {
  //                                         let validSubgroups = group[
  //                                           'subGroups'
  //                                         ].filter((v: any) => v !== null);

  //                                         console.log(validSubgroups);
  //                                         if (validSubgroups.length > 0) {
  //                                         } else {
  //                                           this.Newplansresblack3[index5][
  //                                             'groups'
  //                                           ][index6] = null;
  //                                           // this.plansNewBlock2.splice(index5,1)
  //                                         }
  //                                       }
  //                                     );
  //                                   }

  //                                   let validgroups = elementres.groups.filter(
  //                                     (v: any) => v !== null
  //                                   );

  //                                   console.log(validgroups);
  //                                   if (validgroups.length > 0) {
  //                                   } else {
  //                                     this.Newplansresblack3[index5] = null;
  //                                     ////////show subGroups here
  //                                   }
  //                                   //
  //                                 }
  //                               );
  //                             }
  //                           }
  //                         );
  //                       // }
  //                     }
  //                   }
  //                 });
  //               }
  //             }
  //           }
  //         });
  //       });
  //     }
  //   });

  //   console.log(this.plansresblack3);
  //   this.plansresblack3 = this.Newplansresblack3.filter((v: any) => v !== null);

  //   // console.log(this.plansresblack3)
  //   sessionStorage.setItem('block3result', JSON.stringify(this.plansresblack3));
  // }
  public plansblock3() {

    this.Newplansresblack3 = [];

    if (this.upgradeplansselection == true) {
      this.Newplansresblack3 = JSON.parse(
        sessionStorage.getItem('block2result') || '[]'
      );

      // this.Newplansresblack3 = this.plansresblack2Tiers;
      this.selectedplansblock1 = JSON.parse(
        sessionStorage.getItem('summaryBlock2') || '[]'
      );
    } else {
      this.Newplansresblack3 = JSON.parse(
        sessionStorage.getItem('mainresults') || '[]'
      );
      // this.Newplansresblack3 = this.plansBlock1Tiers;
      this.selectedplansblock1 = JSON.parse(
        sessionStorage.getItem('summaryBlock1') || '[]'
      );
    }

    this.Newplansresblack3.forEach((packagelevel: any, index: any) => {
      var grpcount = 0;

      if (!packagelevel) {
      } else {


        packagelevel.groups.forEach((groups: any, index1: any) => {
          groups?.subGroups.forEach((subGroups: any, index2: any) => {
            console.log(subGroups)
            if (subGroups) {
              this.selectedplansblock1.forEach((selectplan: any) => {
                if (
                  packagelevel.id == selectplan.packageid &&
                  packagelevel.groups.id == selectplan.parentid
                ) {
                  if (subGroups.id == selectplan.subGroupId && subGroups.id != '17' && subGroups.id != '18' && subGroups.id != '28') {
                    this.Newplansresblack3[index]['groups'][index1]['subGroups'].splice(index2, 1)

                    if (selectplan.disallowedPlanLevels) {
                      let disallowed_plans = selectplan.disallowedPlanLevels.split(',');

                      console.log(disallowed_plans)

                      disallowed_plans.forEach((disallowed: any, index9) => {


                        this.Newplansresblack3[index]['groups'][index1]['subGroups'].forEach((plan: any, index10) => {
                          // console.log(this.Newplansresblack3[index]['groups'][index1]['subGroups'][index10].id)
                          // console.log(this.Newplansresblack3[index]['groups'][index1]['subGroups'])
                          // console.log(disallowed)

                          if (this.Newplansresblack3[index]['groups'][index1]['subGroups'][index10] != null) {
                            if (this.Newplansresblack3[index]['groups'][index1]['subGroups'][index10].id == disallowed) {
                              this.Newplansresblack3[index]['groups'][index1]['subGroups'].splice(index10, 1)
                            }
                          }
                        })



                      })


                    }



                  }

                  if (
                    !this.Newplansresblack3[index] ||
                    !this.Newplansresblack3[index]['groups']
                  ) {

                  }
                  else {
                    if (
                      !this.Newplansresblack3[index]['groups'][index1] ||
                      !this.Newplansresblack3[index]['groups'][index1]['subGroups']
                    ) {

                    } else {

                      var allAvailble =
                        this.Newplansresblack3[index]['groups'][index1][
                        'subGroups'
                        ];

                      var sgcount = 0;

                      console.log(allAvailble)

                      allAvailble.forEach((element1: any, index2: any) => {
                        if (element1 != null) {
                          //removeif
                          console.log("6")
                          if (element1.id != '17' && element1.id != '18' && element1.id != '28') {
                            // if (element1.ordering > selectplan.orderId) {
                            // }
                            // else {
                            //   this.Newplansresblack3[index]['groups'][index1][
                            //     'subGroups'
                            //   ][index2] = null;

                            //   this.Newplansresblack3.forEach(
                            //     (elementres: any, index5: any) => {
                            //       if (!elementres || !elementres.groups) {
                            //       } else {
                            //         elementres.groups.forEach(
                            //           (group: any, index6: any) => {
                            //             // console.log(group)
                            //             if (
                            //               !this.Newplansresblack3[index5] ||
                            //               !this.Newplansresblack3[index5][
                            //               'groups'
                            //               ] ||
                            //               !this.Newplansresblack3[index5]['groups'][
                            //               index6
                            //               ] ||
                            //               !this.Newplansresblack3[index5]['groups'][
                            //               index6
                            //               ]['subGroups']
                            //             ) {
                            //             } else {
                            //               group.subGroups.forEach(
                            //                 (subgroups: any, index7: any) => {
                            //                   let validSubgroups = group[
                            //                     'subGroups'
                            //                   ].filter((v: any) => v !== null);

                            //                   console.log(validSubgroups);
                            //                   if (validSubgroups.length > 0) {
                            //                   } else {
                            //                     this.Newplansresblack3[index5][
                            //                       'groups'
                            //                     ][index6] = null;
                            //                     // this.plansNewBlock2.splice(index5,1)
                            //                   }
                            //                 }
                            //               );
                            //             }

                            //             let validgroups = elementres.groups.filter(
                            //               (v: any) => v !== null
                            //             );

                            //             console.log(validgroups);
                            //             if (validgroups.length > 0) {
                            //             } else {
                            //               this.Newplansresblack3[index5] = null;
                            //               ////////show subGroups here
                            //             }
                            //             //
                            //           }
                            //         );
                            //       }
                            //     }
                            //   );
                            //   sgcount++;
                            // }
                          }





                          else {
                            console.log(element1.ordering); //23  24   Default===single and Family
                            console.log(selectplan.orderId); //23  23

                            if (selectplan.disallowedPlanLevels) {
                              let disallowed_plans = selectplan.disallowedPlanLevels.split(',');
                              disallowed_plans.forEach((disallowed: any, index9) => {
                                console.log(this.Newplansresblack3[index]['groups'][index1]['subGroups'])

                                this.Newplansresblack3[index]['groups'][index1]['subGroups'].forEach((plan: any, index11) => {
                                  if (this.Newplansresblack3[index]['groups'][index1]['subGroups'][index11] != null) {
                                    console.log(this.Newplansresblack3[index]['groups'][index1]['subGroups'][index11])
                                    if (this.Newplansresblack3[index]['groups'][index1]['subGroups'][index11].id == disallowed) {
                                      this.Newplansresblack3[index]['groups'][index1]['subGroups'][index11] = null
                                    }
                                  }
                                })

                              })


                            }
                            if (element1.ordering > selectplan.orderId) {
                              console.log('ifstate');
                            }

                            else {
                              console.log('coverage' + selectplan.coverage);

                              this.employeeplancheck = this.getExecutiveCoveragesFromCode(selectplan.coverage)

                              console.log(this.employeeplancheck)
                              if (this.employeeplancheck && this.employeeplancheck.single) {
                                if (element1.id >= selectplan.subGroupId) {
                                  this.Newplansresblack3[index]['groups'][index1][
                                    'subGroups'
                                  ][index2]['coverage'] = '001';
                                } else {
                                  this.Newplansresblack3[index]['groups'][index1][
                                    'subGroups'
                                  ][index2] = null;
                                }
                              }
                              if (this.employeeplancheck && this.employeeplancheck.couple) {
                                if (element1.id >= selectplan.subGroupId) {
                                  this.Newplansresblack3[index]['groups'][index1][
                                    'subGroups'
                                  ][index2]['coverage'] = '010';
                                } else {
                                  this.Newplansresblack3[index]['groups'][index1][
                                    'subGroups'
                                  ][index2] = null;
                                }
                              }
                              if (this.employeeplancheck && this.employeeplancheck.family) {
                                this.Newplansresblack3[index]['groups'][index1][
                                  'subGroups'
                                ][index2] = null;
                              }

                              this.Newplansresblack3.forEach(
                                (elementres: any, index5: any) => {
                                  if (!elementres || !elementres.groups) {
                                  } else {
                                    elementres.groups.forEach(
                                      (group: any, index6: any) => {
                                        // console.log(group)
                                        if (
                                          !this.Newplansresblack3[index5] ||
                                          !this.Newplansresblack3[index5][
                                          'groups'
                                          ] ||
                                          !this.Newplansresblack3[index5]['groups'][
                                          index6
                                          ] ||
                                          !this.Newplansresblack3[index5]['groups'][
                                          index6
                                          ]['subGroups']
                                        ) {
                                        } else {
                                          group.subGroups.forEach(
                                            (subgroups: any, index7: any) => {
                                              let validSubgroups = group[
                                                'subGroups'
                                              ].filter((v: any) => v !== null);

                                              console.log(validSubgroups);
                                              if (validSubgroups.length > 0) {
                                              } else {
                                                this.Newplansresblack3[index5][
                                                  'groups'
                                                ][index6] = null;
                                                // this.plansNewBlock2.splice(index5,1)
                                              }
                                            }
                                          );
                                        }

                                        let validgroups = elementres.groups.filter(
                                          (v: any) => v !== null
                                        );

                                        console.log(validgroups);
                                        if (validgroups.length > 0) {
                                        } else {
                                          this.Newplansresblack3[index5] = null;
                                          ////////show subGroups here
                                        }
                                        //
                                      }
                                    );
                                  }
                                }
                              );
                            }
                          }
                        }
                      });
                    }
                  }
                }
              });
            }

          });
        });
      }
    });

    console.log(this.plansresblack3)
    const idToMove = 13;
    const index = this.Newplansresblack3.findIndex(item => item?.id === idToMove);

    // Check if the object with id exists and move it
    if (index !== -1) {
      const [objectToMove] = this.Newplansresblack3.splice(index, 1);  // Remove the object
      this.Newplansresblack3.unshift(objectToMove);  // Add it to the front
    }
    this.plansresblack3 = this.Newplansresblack3.filter((v: any) => v !== null);

    // console.log(this.plansresblack3)
    sessionStorage.setItem('block3result', JSON.stringify(this.plansresblack3));
  }
  public plansblock3Tiers() {
    this.plansNewBlock3Tiers = [];

    if (this.upgradeplansselectiontiers == true) {
      this.plansNewBlock3Tiers = JSON.parse(
        sessionStorage.getItem('block2resultTiers') || '[]'
      );

      // this.selectedplansblock1 = JSON.parse(
      //   sessionStorage.getItem('selectedTiersBlock2') || '[]'
      // );
      this.selectedplansblock1 = this.seelctedplanLevelTierMappingBlock2;
    } else {
      this.plansNewBlock3Tiers = JSON.parse(
        sessionStorage.getItem('plansBlock1Tiers') || '[]'
      );
      // this.selectedplansblock1 = JSON.parse(
      //   sessionStorage.getItem('selectedTiersBlock2') || '[]'
      // );
      this.selectedplansblock1 = this.seelctedplanLevelTierMappingBlock2;
    }

    console.log(this.selectedplansblock1);

    this.plansNewBlock3Tiers.forEach((packagelevel: any, index: any) => {
      if (!packagelevel) {
      } else {
        packagelevel.groups.forEach((groups: any, index1: any) => {
          this.selectedplansblock1.forEach((selectplan: any) => {
            if (
              packagelevel.id == selectplan.packageId &&
              packagelevel.groups.id == selectplan.parentId
            ) {
              if (
                !this.plansNewBlock3Tiers[index] ||
                !this.plansNewBlock3Tiers[index]['groups'] ||
                !this.plansNewBlock3Tiers[index]['groups'][index1] ||
                !this.plansNewBlock3Tiers[index]['groups'][index1]['subGroups']
              ) {
              } else {
                var allAvailble =
                  this.plansNewBlock3Tiers[index]['groups'][index1][
                  'subGroups'
                  ];

                if (
                  this.plansNewBlock3Tiers[index].id == selectplan.packageId &&
                  this.plansNewBlock3Tiers[index]['groups'][index1].id !=
                  selectplan.parentid
                ) {
                  // console.log("ignore")

                  this.plansNewBlock3Tiers[index]['groups'][index1] = null;
                } else {
                  //  console.log("oktoselect")
                  console.log(allAvailble);
                  allAvailble.forEach((element1: any, index2: any) => {
                    if (element1 != null) {
                      this.plansNewBlock3Tiers[index]['groups'][index1][
                        'subGroups'
                      ][index2].tiers = []; //here tiersmake empty Array
                      this.plansNewBlock3Tiers[index]['groups'][index1][
                        'subGroups'
                      ][index2].checked = false;
                      // if(element1.)

                      if (element1.parentId != 15) {
                        if (element1.id == selectplan.subGroupid) {
                          // this.plansNewBlock2Tiers[index]['groups'][index1][
                          //   'subGroups'
                          // ][index2] = null;    ///Here Plas Selection

                          selectplan.tiers.forEach(
                            (tiers: any, index7: any) => {
                              if (tiers.name == 'All') {
                                this.plansNewBlock3Tiers[index]['groups'][
                                  index1
                                ]['subGroups'][index2] = null;
                              }
                            }
                          );

                          this.plansNewBlock3Tiers.forEach(
                            (elementres: any, index5: any) => {
                              if (!elementres || !elementres.groups) {
                              } else {
                                elementres.groups.forEach(
                                  (group: any, index6: any) => {
                                    if (
                                      !this.plansNewBlock3Tiers[index5] ||
                                      !this.plansNewBlock3Tiers[index5][
                                      'groups'
                                      ] ||
                                      !this.plansNewBlock3Tiers[index5][
                                      'groups'
                                      ][index6] ||
                                      !this.plansNewBlock3Tiers[index5][
                                      'groups'
                                      ][index6]['subGroups']
                                    ) {
                                    } else {
                                      console.log(group);
                                      group.subGroups.forEach(
                                        (subgroups: any, index7: any) => {
                                          let validSubgroups = group[
                                            'subGroups'
                                          ].filter((v: any) => v !== null);

                                          console.log(validSubgroups);
                                          if (validSubgroups.length > 0) {
                                          } else {
                                            this.plansNewBlock3Tiers[index5][
                                              'groups'
                                            ][index6] = null;
                                            // this.plansNewBlock2.splice(index5,1)
                                          }
                                        }
                                      );
                                    }

                                    let validgroups = elementres.groups.filter(
                                      (v: any) => v !== null
                                    );

                                    console.log(validgroups);
                                    if (validgroups.length > 0) {
                                    } else {
                                      this.plansNewBlock3Tiers[index5] = null;
                                      ////////show subGroups here
                                    }
                                    //
                                  }
                                );
                              }
                            }
                          );
                        } else {
                        }
                      } else {
                        if (element1.id == selectplan.subGroupid) {
                          if (selectplan.coverage == 'Single') {
                            // if (element1.id >= selectplan.subGroupId) {
                            //   this.plansNewBlock2Tiers[index]['groups'][index1][
                            //     'subGroups'
                            //   ][index2]['coverage']="Couple"
                            // }
                            // else{
                            //   this.plansNewBlock2Tiers[index]['groups'][index1][
                            //     'subGroups'
                            //   ][index2] = null;
                            // }
                          } else if (selectplan.coverage == 'Couple') {
                            // if (element1.id >= selectplan.subGroupId) {
                            //   this.plansNewBlock2Tiers[index]['groups'][index1][
                            //     'subGroups'
                            //   ][index2]['coverage']="Family"
                            // }
                            // else{
                            //   this.plansNewBlock2Tiers[index]['groups'][index1][
                            //     'subGroups'
                            //   ][index2] = null;
                            // }
                          } else {
                            this.plansNewBlock3Tiers[index]['groups'][index1][
                              'subGroups'
                            ][index2] = null;
                          }
                          this.plansNewBlock3Tiers.forEach(
                            (elementres: any, index5: any) => {
                              if (!elementres || !elementres.groups) {
                              } else {
                                elementres.groups.forEach(
                                  (group: any, index6: any) => {
                                    if (
                                      !this.plansNewBlock3Tiers[index5] ||
                                      !this.plansNewBlock3Tiers[index5][
                                      'groups'
                                      ] ||
                                      !this.plansNewBlock3Tiers[index5][
                                      'groups'
                                      ][index6] ||
                                      !this.plansNewBlock3Tiers[index5][
                                      'groups'
                                      ][index6]['subGroups']
                                    ) {
                                    } else {
                                      console.log(group);
                                      group.subGroups.forEach(
                                        (subgroups: any, index7: any) => {
                                          let validSubgroups = group[
                                            'subGroups'
                                          ].filter((v: any) => v !== null);

                                          console.log(validSubgroups);
                                          if (validSubgroups.length > 0) {
                                          } else {
                                            this.plansNewBlock3Tiers[index5][
                                              'groups'
                                            ][index6] = null;
                                            // this.plansNewBlock2.splice(index5,1)
                                          }
                                        }
                                      );
                                    }

                                    let validgroups = elementres.groups.filter(
                                      (v: any) => v !== null
                                    );

                                    console.log(validgroups);
                                    if (validgroups.length > 0) {
                                    } else {
                                      this.plansNewBlock3Tiers[index5] = null;
                                      ////////show subGroups here
                                    }
                                    //
                                  }
                                );
                              }
                            }
                          );
                        } else {
                          // console.log("coverage"+selectplan.coverage)
                          // if(selectplan.coverage=="Single"){
                          //   if (element1.id >= selectplan.subGroupId) {
                          //     this.plansNewBlock2Tiers[index]['groups'][index1][
                          //       'subGroups'
                          //     ][index2]['coverage']="Couple"
                          //   }
                          //   else{
                          //     this.plansNewBlock2Tiers[index]['groups'][index1][
                          //       'subGroups'
                          //     ][index2] = null;
                          //   }
                          // }
                          // else if(selectplan.coverage=="Couple"){
                          //   if (element1.id >= selectplan.subGroupId) {
                          //     this.plansNewBlock2Tiers[index]['groups'][index1][
                          //       'subGroups'
                          //     ][index2]['coverage']="Family"
                          //   }
                          //   else{
                          //     this.plansNewBlock2Tiers[index]['groups'][index1][
                          //       'subGroups'
                          //     ][index2] = null;
                          //   }
                          // }
                          // else{
                          //   this.plansNewBlock2Tiers[index]['groups'][index1][
                          //     'subGroups'
                          //   ][index2] = null;
                          // }
                        }
                      }
                    }
                  });
                }
              }
            }
          });
        });
      }
    });

    console.log(this.plansNewBlock3Tiers);

    this.plansresblack3Tiers = this.plansNewBlock3Tiers;
    sessionStorage.setItem(
      'block3resultTiers',
      JSON.stringify(this.plansresblack3Tiers)
    );

    setTimeout(() => {
      const dom: HTMLElement = this.elementRef.nativeElement;

      this.plansresblack3Tiers.forEach((packagelevel: any, index: any) => {
        if (!packagelevel) {
        } else {
          packagelevel.groups.forEach((groups: any, index1: any) => {
            if (
              !this.plansresblack3Tiers[index] ||
              !this.plansresblack3Tiers[index]['groups']
            ) {
            } else {
              if (
                !this.plansresblack3Tiers[index]['groups'][index1] ||
                !this.plansresblack3Tiers[index]['groups'][index1]['subGroups']
              ) {
              } else {
                groups.subGroups.forEach((subGroups: any, index2: any) => {
                  if (
                    !this.plansresblack3Tiers[index]['groups'][index1] ||
                    !this.plansresblack3Tiers[index]['groups'][index1][
                    'subGroups'
                    ][index2]
                  ) {
                  } else {
                    // const element: any = dom.querySelector("#plancheck3Voluntry" +  this.plansresblack3Tiers[index]['groups'][index1]['subGroups'][index2].id);
                    // this block is for automatic Check
                    //  element.click()
                  }
                });
              }
            }
          });
        }
      });
    }, 1000);
  }

  gotonotiernwalletInfo() {
    this.nowalletnotierInfo = false;
    this.EmployeeInfo = false;
    this.plansInfo = true;
  }
  gotoEmployeeDetails() {
    // this.basicInfo =false;
    // this.plansInfo =false;
    // this.wallettierInfo =false;
    // this.wallettierInfoandtier =false;
    this.nowalletnotierInfo = false;
    this.EmployeeInfo = true;
  }
  public configuretiers() {
    var corporateId = sessionStorage.getItem('corporateId');

    var GetTiers = '/api/ap/admin/corporate/' + corporateId + '/tiers';
    var accessToken = sessionStorage.getItem('accessToken');
    this.http
      .get(environment.apiUrl + GetTiers, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (response: any) => {
          if (response['status'] == 200) {
            this.dynamicArray = [];
            this.dynamicArrayService = [];
            this.dynamicArrayAnnualIncome = [];
            this.configureTierList = response.data;

            for (let i = 0; i < this.configureTierList.length; i++) {
              if (this.configureTierList[i].tierType == 'DEFAULT') {
                let obj = {
                  sno: i + 1,
                  tierName: this.configureTierList[i].name,
                  walletAmount: '$' + this.configureTierList[i].spendingLimit,
                  id: this.configureTierList[i].id,
                };

                this.dynamicArray.push(obj);

                console.log(this.dynamicArray);
              }
            }

            for (let j = 0; j < this.configureTierList.length; j++) {
              if (this.configureTierList[j].tierType == 'LENGTH_OF_SERVICE') {
                let el1: HTMLElement = this.lengthOfServicetrue.nativeElement;
                el1.click();
                let obj = {
                  sno: j + 1,
                  tierName: this.configureTierList[j].name,
                  from: this.configureTierList[j].fromLength,
                  to: this.configureTierList[j].toLength,
                  period: '',
                  walletAmount: '$' + this.configureTierList[j].spendingLimit,
                  id: this.configureTierList[j].id,
                };

                this.dynamicArrayService.push(obj);
              }
            }

            for (let k = 0; k < this.configureTierList.length; k++) {
              if (this.configureTierList[k].tierType == 'ANNUAL_INCOME') {
                let el1: HTMLElement = this.annualIncometrue.nativeElement;
                el1.click();
                let obj = {
                  sno: k + 1,
                  tierName: this.configureTierList[k].name,
                  percentage: this.configureTierList[k].incomePercentage,
                  from: this.configureTierList[k].fromLength,
                  to: this.configureTierList[k].toLength,
                  period: '',
                  walletAmount: '$' + this.configureTierList[k].spendingLimit,
                  id: this.configureTierList[k].id,
                };

                this.dynamicArrayAnnualIncome.push(obj);
              }
            }
          } else {
            // Swal.fire('Info',response.message)
            Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message });
          }
        },
        (error) => {
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: this.lang.Error ?? 'Error',
              text: error.error.error.message,
              showCancelButton: false,
              showDenyButton: false,
              confirmButtonText: 'Proceed',
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              } else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            // Swal.fire(error.error.error.message)
            Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
          }
          // this.toastrService.error("Invalid Credentials", 'Error!');
        }
      );

    this.selectedplansforTier = JSON.parse(
      sessionStorage.getItem('summaryBlock1') || '[]'
    );
  }
  public gotobasicInfo() {
    // sessionStorage.setItem("header","Home")
    this.customSelected = false;
    this.basicInfo = true;
    this.plansInfo = false;
    this.showstatus = false;
    this.showsearchbox = true;
    this.headerComponent.headerDetails('Home');
    let formData = JSON.parse(sessionStorage.getItem('formData') || '');

    // this.waitTime = formData.expectednoofEmployees;

    this.CorpName = formData.corporationName;
    this.policyStartDate =
      this.datePipe.transform(formData.PolicyStartDate, 'MM-dd-yyyy') || '';
    this.streetAddress = formData.streetAddress;
    this.streetAddress2 = formData.streetAddress2;
    this.country = formData.country;
    this.city = formData.city;
    this.province = formData.Province;
    this.postalCode = formData.postalCode;
    this.waitTime = formData.waitingPeriod;
    this.paymentInfo = formData.paymentInfo;
    this.setupWallet = formData.walletConfig;
    this.setUplevelofCoverage = formData.tierConfig;
    this.noOfEmployees = formData.expectednoofEmployees;
    // this.imagedisplay = this.uploadadminlogoimg
    const dom: HTMLElement = this.elementRef.nativeElement;

    setTimeout(() => {
      if (this.waitTime == 0) {
        const element: any = dom.querySelector('#nowaitingPeriod');
        if (element != null && element != undefined) element.click();
      } else if (this.waitTime == 3) {
        const element: any = dom.querySelector('#threemonths');
        if (element != null && element != undefined) element.click();
      } else if (this.waitTime == 6) {
        const element: any = dom.querySelector('#sixmonths');
        if (element != null && element != undefined) element.click();
      } else {
        const element: any = dom.querySelector('#customselection');
        console.log(element);
        if (element != null || element != undefined) element.click();
      }

      var reader = new FileReader();
      reader.readAsDataURL(this.uploadadminlogoimg);

      reader.onload = (_event) => {
        this.showimagelogo = false;
        this.uploadlogoafter = true;
        this.imagedisplay = reader.result;
      };
    }, 1000);
    let adminData;
    if (sessionStorage.getItem('adminData')) {
      adminData = JSON.parse(sessionStorage.getItem('adminData'));
      this.adminData = adminData;
      this.addadminform = false;
      this.showaddadmin = true;
    }

    // if (adminData) {

    // }
  }

  public gotoplansInfo() {
    this.basicInfo = false;
    this.plansInfo = true;
    this.wallettierInfo = false;
    this.wallettierInfoandtier = false;

    this.planssummary = JSON.parse(sessionStorage.getItem('planResults'));

    this.selectedplansblock1 = JSON.parse(
      sessionStorage.getItem('summaryBlock1')
    );

    if (this.planssummary) {
      // [{"packageid":"2","parentId":"14","subGroupId":"21","orderId":"18","packagename":"Mental Health & Wellness","groupname":"Wellness","subGrpname":"Mind & Body","tiers":[],"packageindex":1,"groupindex":0,"subgroupindex":2}]
      // this.planssummary.forEach((plandetails:any,index:number) => {
      //   plandetails.groups.forEach((groups:any,index1:number) => {
      //     this.selectedplansblock1.forEach((subgroup:any,index3:number) => {
      //       var allAvailble = this.planssummary[index]['groups'][index1]['subGroups'];
      //       allAvailble.forEach((element1: any, index2: any) => {
      //         if (element1 != null) {
      //           if (element1.id == subgroup.subGroupId) {
      //             setTimeout(() => {
      //               const dom: HTMLElement = this.elementRef.nativeElement;
      //               const element: any = dom.querySelector("#plancheck" + element1.id);
      //               console.log(element)
      //                 element.click()
      //             },100)
      //           }
      //         }
      //         });
      //   });
      //   });
      // });
    }
  }

  public submitwallettierInfo() {
    // this.basicInfo = false;
    // this.plansInfo = false;
    // this.wallettierInfo = false;
    // this.wallettierInfoandtier = false;
    // this.EmployeeInfo = true;
  }

  public gotoEmployeeInfo() {
    this.basicInfo = false;
    this.plansInfo = false;
    this.wallettierInfo = false;
    this.EmployeeInfo = true;
    this.datagraphInfo = false;
    this.addedEmployeelist = this.employeeList
    // console.log(this.employeeList)

  }
  public submitdatagraphInfo() {
    this.basicInfo = true;
    this.plansInfo = false;
    this.wallettierInfo = false;
    this.EmployeeInfo = false;
    this.datagraphInfo = false;
  }








  invitationbroker(id: any) {
    var corporateId = sessionStorage.getItem('corporateId');
    var accessToken = sessionStorage.getItem('accessToken');
    var GetBrokers = `/api/ap/admin/corporate/${id}/invitation`;

    //https://testadminapi.groupbenefitz.aitestpro.com/api/ap/admin/corporate/1660/invitation
    this.http
      .get(environment.apiUrl + GetBrokers, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe((response: any) => {
        if (response['status'] == 200 || response['statusCode'] == 200) {
          Swal.fire({ title: 'Info', text: response.message }).then((result) => {
            if (result.isConfirmed) {
              let accessTokensession = sessionStorage.getItem('accessToken');
              var keyToPreserve = ['adminName', 'role', 'loginname', 'accessToken', 'accessToken'];

              // Get all keys from sessionStorage
              var keys = Object.keys(sessionStorage);

              // Iterate through the keys and remove them from sessionStorage, except the one to preserve
              keys.forEach(function (key) {
                // if (key !== keyToPreserve) {
                if (!keyToPreserve.includes(key)) {
                  sessionStorage.removeItem(key);
                }
              });
              sessionStorage.setItem('accessToken', accessTokensession);
              // window.location.reload();
              this.basicInfo = true;
              this.plansInfo = false;
              this.wallettierInfo = false;
              this.EmployeeInfo = false;
              this.datagraphInfo = false;

              this.router.navigate(['/manageCorporates'])
            }
          });
        } else {
          Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message });
        }
      }),
      (error) => {
        Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
      };
  }

  submitformlink() {
    let GroupContacts = JSON.parse(sessionStorage.getItem('adminData') || '[]');
    var corporateId = sessionStorage.getItem('corporateId');
    // this.store.dispatch(loadCorporateDataSuccess({ corporateData: [] }));
    // this.store.dispatch(loadCorporateData());

    if (this.domainExisting) {
      this.invitationbroker(corporateId);
    } else {

      if (GroupContacts.length > 0) {
        $('#subdomains-modal').modal('show');
        var accessToken = sessionStorage.getItem('accessToken');
        var subdomains =
          '/api/ap/admin/corporate/' + corporateId + '/subDomains';

        this.http
          .get(environment.apiUrl + subdomains, {
            headers: {
              Authorization: 'Bearer ' + accessToken,
              'Content-Type': 'application/json',
            },
          })
          .subscribe(
            (response: any) => {
              if (response['status'] == 200) {
                this.SubDomains = response.data;
                this.SubDomains = this.SubDomains;
              } else {
                // Swal.fire(this.lang.Error??'Error',response.message)
                Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message || response.error });
              }
            },
            (error) => {
              if (
                error.status == 400 ||
                error.status == 401 ||
                error.status == 402 ||
                error.status == 403
              ) {
                Swal.fire({
                  title: this.lang.Error ?? 'Error',
                  text: error.error.error.message,
                  showCancelButton: false,
                  showDenyButton: false,
                  confirmButtonText: 'Proceed',
                }).then((result) => {
                  /* Read more about isConfirmed, isDenied below */
                  if (result.isConfirmed) {
                    sessionStorage.clear();
                    this.router.navigate(['/login']);
                  } else {
                    sessionStorage.clear();
                    this.router.navigate(['/login']);
                  }
                });
              } else {
                // Swal.fire(error.error.error.message)
                Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
              }
              // this.toastrService.error("Invalid Credentials", 'Error!');
            }
          );
      } else {
        this.adminform.reset();
        $('#groupAmdins-modal').modal('show');
      }
    }
  }

  addGroupadmin() {
    this.emailAlreadyexist = false;
    $('#groupAmdins-modal').modal('hide');
    console.log(this.adminData);
    if (this.adminform.invalid) {
      console.log(this.adminform);
      return;
    }
    console.log(JSON.stringify(this.adminform.value, null, 2));

    let obj = {
      firstName: this.capitalize(this.adminform.value.adminfirstname),
      lastName: this.capitalize(this.adminform.value.adminlastname),
      phoneNum: this.adminform.value.adminphone,
      email: this.adminform.value.adminemail,
      role: this.adminform.value.role,
      roleName: this.adminform.value.roleName
    };

    this.adminData.push(obj);
    console.log('adminData', this.adminData);

    // this.adminData = JSON.parse(sessionStorage.getItem('adminData') || '[]');
    // this.adminData = this.dummyAdminData;
    this.adminform.reset();
    this.showaddadmin = true;
    this.addadminform = false;
    sessionStorage.setItem('adminData', JSON.stringify(this.adminData));

    // this.adminData= JSON.parse(sessionStorage.getItem("adminData") || "[]")

    console.log(this.adminData);

    this.updateStatus(3);

    $('#subdomains-modal').modal('show');
    var corporateId = sessionStorage.getItem('corporateId');
    var accessToken = sessionStorage.getItem('accessToken');
    var subdomains = '/api/ap/admin/corporate/' + corporateId + '/subDomains';

    this.http
      .get(environment.apiUrl + subdomains, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (response: any) => {
          if (response['status'] == 200) {
            this.SubDomains = response.data;
          } else {
            // Swal.fire(this.lang.Error??'Error',response.message)
            Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message });
          }
        },
        (error) => {
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: this.lang.Info,
              text: error.error.error.message,
              showCancelButton: false,
              showDenyButton: false,
              confirmButtonText: this.lang.Proceed,
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              } else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            // Swal.fire(error.error.error.message)
            Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
          }
          // this.toastrService.error("Invalid Credentials", 'Error!');
        }
      );
  }

  subDomainConfirm() {
    if (this.subdomainName && this.subdomainName.length > 0) {
      var corporateId = sessionStorage.getItem('corporateId');
      var endPoint = '/api/ap/admin/corporate/' + corporateId + '/employee';
      var accessToken = sessionStorage.getItem('accessToken');
      var SubmitAdminInfo =
        '/api/ap/admin/v2/corporate/' +
        corporateId +
        '/signupConfirmationDuplicate';

      let accessTokensession = sessionStorage.getItem('accessToken');

      let GroupContacts = JSON.parse(
        sessionStorage.getItem('adminData') || '[]'
      );
      // let
      let dublicateGroupContacts = GroupContacts.map((groupContact) => {
        if (groupContact.roleName == null || groupContact.roleName == undefined) {
          groupContact.roleName = '';
        }
        return groupContact
      });
      GroupContacts = dublicateGroupContacts;

      let obj = {
        groupadmins: GroupContacts,
        domainName: this.subdomainName,
      };

      if (GroupContacts.length > 0) {
        this.http
          .post(environment.apiUrl + SubmitAdminInfo, obj, {
            headers: {
              Authorization: 'Bearer ' + accessToken,
              'Content-Type': 'application/json',
            },
          })
          .subscribe(
            (response: any) => {
              if (response['status'] == 200) {
                $('#subdomains-modal').modal('hide');
                // Swal.fire('Success','successfully sent to admin');

                if (response.warning && response.warning.length > 0) {
                  Swal.fire({
                    title: 'Warning',
                    text: response.warning,
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonText: 'Ok',
                  }).then((result) => {
                    if (result.isConfirmed) {
                      var role = sessionStorage.getItem('role');

                      // sessionStorage.clear();
                      sessionStorage.setItem('accessToken', accessTokensession);
                      sessionStorage.setItem('role', role);
                      $("#showaddMemberConfiguration").modal('show')
                      // Swal.fire({
                      //          title: 'Info',
                      //          text: 'Add this GIG Member with which plans?',
                      //          showDenyButton: true,
                      //          showCancelButton: true,
                      //          confirmButtonText: 'Existing',
                      //          denyButtonText: `Convert`,
                      //          cancelButtonText: 'New',

                      //        }).then((result) => {
                      //          if (result.isConfirmed) {
                      //            this.continueWithExistingPlans = true
                      //            this.samePlansWithCorporate = false
                      //            this.effectiveDateForm.reset()
                      //            $('#showeffectiveDate').modal('show');
                      //            // this.gigtoCorpConvertion(CorpId, parentId)
                      //          }
                      //          else if (result.isDenied) {
                      //            this.continueWithExistingPlans = false
                      //            this.samePlansWithCorporate = true


                      //            this.effectiveDateForm.reset()
                      //            $('#showeffectiveDate').modal('show');
                      //          }
                      //          else {
                      //            this.continueWithExistingPlans = false
                      //            this.samePlansWithCorporate = false
                      //            this.effectiveDateForm.reset()
                      //            $('#showeffectiveDate').modal('show');
                      //            // this.getCorporatePlans(CorpId)
                      //          }
                      //        })
                      // window.location.reload();
                      // this.basicInfo = false;
                      // this.plansInfo = false;
                      // this.wallettierInfo = false;
                      // this.EmployeeInfo = false;
                      // this.datagraphInfo = true;

                      // this.router.navigate(['/manageCorporates'])
                    }
                  });
                }
                else {
                  $("#showaddMemberConfiguration").modal('show')
                //  Swal.fire({
                //           title: 'Info',
                //           text: 'Add this GIG Member with which plans?',
                //           showDenyButton: true,
                //           showCancelButton: true,
                //           confirmButtonText: 'Existing',
                //           denyButtonText: `Convert`,
                //           cancelButtonText: 'New',

                //         }).then((result) => {
                //           if (result.isConfirmed) {
                //             this.continueWithExistingPlans = true
                //             this.samePlansWithCorporate = false
                //             this.effectiveDateForm.reset()
                //             $('#showeffectiveDate').modal('show');
                //             // this.gigtoCorpConvertion(CorpId, parentId)
                //           }
                //           else if (result.isDenied) {
                //             this.continueWithExistingPlans = false
                //             this.samePlansWithCorporate = true


                //             this.effectiveDateForm.reset()
                //             $('#showeffectiveDate').modal('show');
                //           }
                //           else {
                //             this.continueWithExistingPlans = false
                //             this.samePlansWithCorporate = false
                //             this.effectiveDateForm.reset()
                //             $('#showeffectiveDate').modal('show');
                //             // this.getCorporatePlans(CorpId)
                //           }
                //         })
                  // this.gigtoCorpConvertion()


                }
              } else {
                //  this.submitformlink()
                // Swal.fire(this.lang.Error??'Error',response.message)
                Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message });
              }
            },
            (error) => {
              if (
                error.status == 400 ||
                error.status == 401 ||
                error.status == 402 ||
                error.status == 403
              ) {
                Swal.fire({
                  title: 'Info',
                  text: error.error.error.message,
                  showCancelButton: false,
                  showDenyButton: false,
                  confirmButtonText: this.lang.Proceed,
                }).then((result) => {
                  /* Read more about isConfirmed, isDenied below */
                  if (result.isConfirmed) {
                    sessionStorage.clear();
                    this.router.navigate(['/login']);
                  } else {
                    sessionStorage.clear();
                    this.router.navigate(['/login']);
                  }
                });
              } else {
                // Swal.fire(error.error.error.message)
                Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
              }
              // this.toastrService.error("Invalid Credentials", 'Error!');
            }
          );
      } else {
        // Swal.fire('Please add one Group Contact');
      }
    } else {
      Swal.fire({
        title: this.lang.Info,
        text: this.lang.Please_select_subdomain_for_your_portal,
      });
    }
  }
  scrollTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }
  ExistingPlans() {
    this.continueWithExistingPlans = true
    this.samePlansWithCorporate = false
    this.effectiveDateForm.reset()
    $('#showaddMemberConfiguration').modal('hide');
    $('#showeffectiveDate').modal('show');
  }
  ConvertPlans() {
    this.continueWithExistingPlans = false
    this.samePlansWithCorporate = true


    this.effectiveDateForm.reset()
    $('#showaddMemberConfiguration').modal('hide');
    $('#showeffectiveDate').modal('show');
  }
  Newplans() {
    this.continueWithExistingPlans = false
    this.samePlansWithCorporate = false
    this.effectiveDateForm.reset()
    $('#showaddMemberConfiguration').modal('hide');
    $('#showeffectiveDate').modal('show');
  }
  submiteffectiveDate1() {
    var corporateId = sessionStorage.getItem('corporateId');
    $('#showeffectiveDate').modal('hide');
    if (this.continueWithExistingPlans) {
      this.gigtoCorpConvertion()
    }
    else{
      this.getCorporatePlans(corporateId)
    }

  }

   submiteffectiveDate() {


      var corporateId = sessionStorage.getItem('corporateId');
      $('#showeffectiveDate').modal('hide');
      if (this.continueWithExistingPlans && !this.samePlansWithCorporate) {
        this.gigtoCorpConvertion()
      }
      else if (!this.continueWithExistingPlans && this.samePlansWithCorporate) {

        console.log(this.configprovinceres)


        let requests = []; // Array to store all HTTP requests
        let statesData = this.configprovinceres.filter((item) => {
          return item.name == this.customerData.state || item.shortName == this.customerData.state
        });

        console.log(statesData)

        if (this.customerData.customerPlans.length>0){

        for (let i = 0; i < this.customerData.customerPlans.length; i++) {


          let produtype;
          let productCoverage;

          if (this.customerData.customerPlans[i].isBundle) {

            if (this.customerData.customerPlans[i].name.includes("Classic")) {
              produtype = 'CORP';
            }
            else {
              produtype = 'BOTH';
            }
            productCoverage = this.customerData.customerPlans[i].coverage1.trim();
          } else {
            produtype = 'BOTH';
            productCoverage = 'any';
          }

          let accessToken = sessionStorage.getItem('accessToken');
          let endPoint = `/api/ap/plan/pricing?plan=${this.customerData.customerPlans[i].name}&state=${statesData[0].shortName}&productType=${produtype}&productCoverage=${productCoverage}&fields=all`;

          let request = this.http.get(environment.apiUrl + endPoint, {
            headers: {
              Authorization: 'Bearer ' + accessToken,
              'Content-Type': 'application/json',
            },
          });

          requests.push(request); // Push the request into the array
        }

        // Execute all HTTP requests in parallel and wait for completion
        forkJoin(requests).subscribe((responses: any[]) => {
          responses.forEach(response => {
            if (response?.status === 200) {

              let obj = {
                "enrollmentDate": this._CustomDatePipe.transform(this.effectiveDateForm.get('effectiveDate').value),
                "taxesInfo": this.determineTaxes(response.data?.products?.[0]?.calculatedTax?.planProductInfos ?? []),
                "taxApplicable": response.data.totalTax > 0
              };

              Object.assign(response.data, obj, { ...obj.taxesInfo });
              this.plansDataarray.push(response.data);
            }
          });

          // Call gigtoCorpConvertion after all requests are done
          this.gigtoCorpConvertion();
        });
      }
      else{
          Swal.fire({ title: "Info", text: 'No Existing Plans Available' });
      }



      }


      else {
        this.getCorporatePlans(corporateId)
      }

    }

  getformid(getformid: any) {

    console.log(getformid)
  }

  public determineTaxes(taxArray: any) {
    let taxObj: any = {
      pst: null,
      pstTaxRate: null,
      hst: null,
      hstTaxRate: null,
      gst: null,
      gstTaxRate: null,
      taxName: null,
      taxPrice: null
    };
    for (let tax of taxArray) {
      if (!taxObj.taxName || taxObj.taxName == null) {
        taxObj.taxName = "";
      }

      if (tax.name.includes("PST") || tax.name.includes("Prov")) {
        taxObj.pst = parseFloat(tax.price + (taxObj.pst ?? 0));
        taxObj.pstTaxRate = (tax.taxRate ?? tax.tax_rate) * 100
        if (!taxObj.taxName.includes(tax.name))
          taxObj.taxName += tax.name + " | "
      }
      if (tax.name.includes("HST")) {
        taxObj.hst = parseFloat(tax.price + (taxObj.hst ?? 0));
        taxObj.hstTaxRate = (tax.taxRate ?? tax.tax_rate) * 100
        if (!taxObj.taxName.includes(tax.name))
          taxObj.taxName += tax.name + " | "
      }
      if (tax.name.includes("GST")) {
        taxObj.gst = parseFloat(tax.price + (taxObj.gst ?? 0));
        taxObj.gstTaxRate = (tax.taxRate ?? tax.tax_rate) * 100;
        if (!taxObj.taxName.includes(tax.name))
          taxObj.taxName += tax.name + " | "
      }
    }
    taxObj.taxName = taxObj.taxName?.trim();
    if (taxObj.taxName && taxObj.taxName[taxObj.taxName.length - 1] == "|") {
      taxObj.taxName = taxObj.taxName.slice(0, -1);
      taxObj.taxName = taxObj.taxName?.trim();
    }

    if (taxObj.pst || taxObj.hst || taxObj.gst) {
      taxObj.taxPrice = 0;
      taxObj.taxPrice = (taxObj.pst ?? 0) + (taxObj.hst ?? 0) + (taxObj.gst ?? 0)
    }

    return taxObj;
  }

  getCorporatePlans(corporateId: any) {

    console.log(this.clientregform)

    let statesData = this.configprovinceres.filter((item) => {
      return item.shortName??item.name === this.clientregform.value.Province;
    });
    console.log(statesData)
    let statesId: any;
    let statesName: any;
    let fusebillStateId: any
    if (statesData.length > 0) {
      statesId = statesData[0].id;
      fusebillStateId = parseInt(statesData[0].fusebillId),
        statesName = statesData[0].name;
    } else {
      statesId = '';
      fusebillStateId = '';
      statesName = '';
    }
    let obj = {
      "isStudent": false,
      "recaptchaCheck": false,
      "g_recaptcha_response": "test",
      "fusebillCustomerId": null,
      "planEnrollmentDate": this.datePipe.transform(
        this.clientregform.value.PolicyStartDate,
        'yyyy-MM-dd'
      ) || '0000-00-00',
      "enrollmentDate": this.datePipe.transform(
        this.clientregform.value.PolicyStartDate,
        'yyyy-MM-dd'
      ) || '0000-00-00',
      "EnrollmentDate": this.datePipe.transform(
        this.clientregform.value.PolicyStartDate,
        'yyyy-MM-dd'
      ) || '0000-00-00',
      "first_name": this.customerData.firstName,
      "firstName": this.customerData.firstName,
      "last_name": this.customerData.lastName,
      "lastName": this.customerData.lastName,
      "email": "johndemoaitp" + this.genRandonString(3) + "@aitestpro.com",
      "phone_number": this.customerData.primaryPhone,
      "street_address_line1": this.clientregform.value.streetAddress,
      "street_address_line2": this.clientregform.value.streetAddress2,
      "city": this.clientregform.value.city,
      "province": this.clientregform.value.Province,
      "province_id": this.provincelistid,
      "country": "Canada",
      "country_id": 124,
      "countryId": 124,
      "postal_code": this.clientregform.value.postalCode,
      "date_of_birth": this.customerData.dob,
      "dob": this.customerData.dob,
      "gender": this.customerData.gender,
      "workingProvince": this.clientregform.value.Province,
      "enrolmentProgramName": "",
      "working_20hours": true,
      "weeklyHours": 0,
      "hours_per_week": 40,
      "coveredParentalHealthInsurance": false,
      "provincial_health_coverage": true,
      "work_visa": "",
      "having_spouse": false,
      "spouse_details": {},
      "having_dependent_children": false,
      "no_of_children": 0,
      "children_details": "",
      "signature": "digiSign",
      "fusebillCustomer": true,
      "formId": this.corporateDetailsMain.formId || 1,
      "brokerId": +corporateId,
      "termsandconditions": "",
      "disclouseradvisor": true,
      "state": this.clientregform.value.Province,
      "stateId": this.state_id,
      "state_id": this.state_id,
      "fusebillStateId": fusebillStateId,
      "currency": "CAD",
      "currencySymbol": "$",
      "apt": "",
      "studentId": null,
      "beneficiaries_details": [],
      "employeeKey": "",
      "employeeGeneric": true,
      "employerName": "",
      "date_of_hiring": this._CustomDatePipe.transform(this.customerData.registrationDate),
      "isCorporate": true
    }
    let validationdata: string = `${environment.apiUrl}/api/ap/customer/v3/plans`;

    var accessToken = sessionStorage.getItem('accessToken');
    //this.studentService.validation(personalInfoData)
    this.http.post(validationdata, obj,
      {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        }
      })
      .subscribe(
        (result: any) => {
          if (result.status == '200') {

            $("#showPlansForEmployee").modal('show')
            this.allFormData = {}
            this.formData = {}
            this.mainarray = [];
            this.mainarrayValues = [];
            this.mainarrayFinal = [];
            this.modifiedBlocksPaidByCompany = ''
            this.modifiedBlocksCoveredByCompany = '',



              sessionStorage.setItem("employeeshare", "0");



            sessionStorage.setItem('plansummaryLife', '[]');
            sessionStorage.setItem('planssummarymainLife', '[]');

            sessionStorage.setItem("planDetailsArrayBlock", "[]");

            sessionStorage.setItem("totalAmount", "0");
            sessionStorage.setItem("totalAmountUI", "0");

            sessionStorage.setItem("allSelectedPlans", "[]");


            sessionStorage.setItem("plansummary", "[]");
            sessionStorage.setItem("selectedPlans", "{}");
            sessionStorage.setItem("selectedPlansLife", "{}");
            sessionStorage.setItem("plansummarymain", "[]");
            sessionStorage.setItem("plansummaryopt", "[]");
            sessionStorage.removeItem("Spousesignature")


            sessionStorage.setItem(
              "corporateStateId",
              result.data.workingProvince.id
            );
            sessionStorage.setItem(
              "corporateStateName",
              result.data.workingProvince.name
            );
            sessionStorage.setItem(
              "companyStateId",
              result.data.corporateProvince.id
            );
            // sessionStorage.removeItem("paymentMethod")   ////here
            sessionStorage.removeItem("paymentfail");
            this.companypaidproductid = [];
            this.disabledcompanypaidproductid = [];
            this.removedisabledcompanypaidproductid = [];
            this.adddisabledcompanypaidproductid = [];






            this.specialpackages = [];
            this.packagesInBlocks = result.data.blocks;
            this.basepackages = result.data.packages;
            let companyplans = this.convertpackagesToPlans2(
              this.packagesInBlocks
            )[1];
            let baseplans = this.convertpackagesToPlans2(this.basepackages)[1];
            this.calculateBasePlanDeltasforCCplans(
              this.packagesInBlocks.coveredByCompany,
              baseplans,
              companyplans
            );
            this.calculateBasePlanCPplans(
              this.packagesInBlocks.paidByCompany,
              baseplans,
              companyplans
            );

            // //console.log(this.packagesInBlocks.paidByCompany)
            // //console.log(this.modifiedBlocksPaidByCompany)
            this.mainarrayValues = this.cobminedcommonfunction(
              // this.packagesInBlocks.paidByCompany,
              this.modifiedBlocksPaidByCompany,
              this.modifiedBlocksCoveredByCompany,
              this.packagesInBlocks.paidByEmployee
            );

            let allPackages = [];
            for (let key in this.mainarrayValues) {
              //this.consoleMessage(key)
              allPackages.push(this.mainarrayValues[key]);
            }
            // this.mainarray = allPackages;





            let filteredMainArray = allPackages
              .map((element: any) => {
                // Map the groups
                let filteredGroups = element.groups.map((group: any) => {
                  // Map the plans
                  let filteredPlans = group.plans.map((plan: any) => {
                    // Filter the productAddonss


                    let filteredProductAddonss = Object.keys(plan.productAddonss).reduce(
                      (acc: any, key) => {

                        let filteredProducts = plan.productAddonss[key].filter((product: any) =>
                          product.hasOwnProperty('display') && product.display
                        );
                        console.log(filteredProducts)
                        const containsOnlyEmptyObjects = filteredProducts.every(
                          (product: any) => Object.keys(product).length === 0
                        );

                        if (containsOnlyEmptyObjects) {
                          console.log("filteredProducts contains only empty objects.");
                        } else {
                          acc[key] = filteredProducts;
                          console.log("filteredProducts contains non-empty objects.");
                        }
                        // if (filteredProducts.length > 0) {
                        //   acc[key] = filteredProducts;
                        // }
                        return acc;
                      },
                      {}
                    );
                    return {
                      ...plan,
                      productAddonss: filteredProductAddonss,
                    };
                  }).filter((plan: any) => Object.keys(plan.productAddonss).length > 0); // Remove plans without any matching productAddons

                  return {
                    ...group,
                    plans: filteredPlans,
                  };
                }).filter((group: any) => group.plans.length > 0); // Remove groups without any matching plans

                return {
                  ...element,
                  groups: filteredGroups,
                };
              })
              .filter((element: any) => element.groups.length > 0); // Remove elements without any matching groups


            console.log(filteredMainArray)

            this.mainarrayFinal = filteredMainArray

            console.log(this.mainarrayFinal)

            // this code needs to comment for single single in
            this.mainarrayFinal.forEach((element: any) => {
              element.groups.forEach((group: any) => {
                group.plans.forEach((plan: any) => {
                  if (plan.productAddonss) {
                    Object.keys(plan.productAddonss).forEach((key) => {
                      // plan.productAddonss[key].forEach((product) => {
                      const keys = ['planCoverage'];
                      const filteredData = plan.productAddonss[key].filter((value: any, index: any, self: any) =>
                        self.findIndex((v: { [x: string]: any; }) => keys.every(k => v[k] === value[k])) === index
                      );
                      plan.productAddonss[key] = filteredData
                      // });
                    });
                  }
                });

              });
            });

            this.mainarrayFinal.forEach((element: any) => {
              element.groups.forEach((group: any) => {
                if (group.categorization.paidByCompany == 1) {
                  group.plans.forEach((plan: any) => {
                    let pl = { ...plan, ...group.categorization }
                    Object.keys(plan.productAddonss).forEach((key) => {
                      let productLength = plan.productAddonss[key]?.display
                      let displayingProductlengths = plan.productAddonss[key].filter((e: any) => { return e.dispaly == true })?.length

                      plan.productAddonss[key].forEach((product: any) => {

                        if (pl.isBundle) {
                          this.companypaidproductid.push(pl);
                        }
                        else {
                          this.companypaidproductid.push(product.planlevel);
                        }


                        const dom: HTMLElement = this.elementRef.nativeElement;

                        const plan: any = dom.querySelector("#plancheck" + product.id);

                        if (plan) {
                          plan.checked = false;
                        }
                        // $("#plancheck" + product.id).prop("checked", false);
                      });
                    });
                  });
                }

                setTimeout(() => {
                  if (group.categorization.coveredByCompany == 1) {
                    group.plans.forEach((plan: any) => {
                      Object.keys(plan.productAddonss).forEach((key) => {
                        plan.productAddonss[key].forEach((product: any) => {
                          // $("#plancheck" + product.id).prop("checked", false);
                          const dom: HTMLElement = this.elementRef.nativeElement;

                          const plan: any = dom.querySelector("#plancheck" + product.id);

                          if (plan) {
                            plan.checked = false;
                          }
                        });
                      });
                    });
                  }
                  if (group.categorization.paidByEmployee == 1) {
                    group.plans.forEach((plan: any) => {

                      if (plan.productAddonss) {
                        Object.keys(plan.productAddonss).forEach((key) => {
                          plan.productAddonss[key].forEach((product: any) => {
                            // $("#plancheck" + product.id).prop("checked", false);
                            const dom: HTMLElement = this.elementRef.nativeElement;

                            const plan: any = dom.querySelector("#plancheck" + product.id);

                            if (plan) {
                              plan.checked = false;
                            }
                          });
                        });
                      }
                    });
                  }
                }, 1000);
              });
            });


            sessionStorage.setItem("stateid", result.data.province.id);


            sessionStorage.setItem(
              "planDetailsArray",
              JSON.stringify(this.specialpackages)
            );
            sessionStorage.setItem(
              "planDetailsArrayBlock",
              JSON.stringify(this.mainarrayFinal)
            );
            this.autoSelectCompanyPaidPlans();




            // this.http.post(environment.apiUrl+'/api/ap/v2/global/set-adminCorporates',{wait:true}).subscribe((newResponse) => {
            //   this.http.post(environment.reportApiUrl+'/websocket/corporate/notification-to-others',{
            //     "message": "Corporates information has been updated. Please refresh screen."
            //   }, { headers: {
            //     Authorization: 'Bearer ' + accessToken,
            //     'Content-Type': 'application/json',
            //   } }).subscribe((res)=>{
            //     console.log({res})
            //   })
            // })

          }
          else {
            Swal.fire({ title: "Info", text: result.message });

          }
        })



  }
  newplansadded() {

    let plansummarymain = JSON.parse(sessionStorage.getItem("plansummarymain")) || "";

    if (plansummarymain.length > 0) {
      $("#showPlansForEmployee").modal('hide')
      this.gigtoCorpConvertion()
    }
    else {

Swal.fire({ title: "Info", text: "Please Choose at least one plan to procced" });


    }

  }
  public autoSelectCompanyPaidPlans() {

    // console.log(this.companypaidproductid)
    this.companypaidproductid = this.companypaidproductid.filter(
      (item: any) => item !== undefined && item !== null
    );

    var result = this.companypaidproductid.reduce((unique: any, o: any) => {
      if (!unique.some((obj: { name: any; }) => obj.name === o.name)) {
        unique.push(o);
      }
      return unique;
    }, []);
    console.log(result);

    // this.companypaidproductid.forEach((element, index) => {

    result.forEach((element: any, index: any) => {


      setTimeout(() => {
        const dom: HTMLElement = this.elementRef.nativeElement;
        // const plan: any = dom.querySelector("#plancheck" + element.id);
        // this.renderer.selectRootElement("#plancheck" + element.id).click()



        if (element.isBundle) {
          let productKeyArray: any = Object.keys(element.productAddonss)
          for (let productkey of productKeyArray) {
            //console.log(productkey)
            //console.log(element.productAddonss)
            //console.log(productKeyArray)
            for (let i = 0; i < element.productAddonss[productkey].length; i++) {
              //console.log(element.productAddonss[productkey][i])
              let coverage = element.companyPaidCoverage?.replace("SELECTIVE_", "")
              console.log(coverage)
              if (coverage && coverage != "DIRECT") {
                try {
                  const elementSelector = "#plancheck" +
                    element.productAddonss[productkey][i].planId +
                    ".coverage" +
                    coverage;

                  const targetElement = this.renderer.selectRootElement(elementSelector, true);
                  console.log(targetElement)
                  // Use the second argument 'true' to avoid throwing an error if the element is not found
                  if (targetElement.disabled) {
                    targetElement.disabled = false
                    targetElement.click();
                    break;
                  }
                  else {
                    targetElement.click();
                    break;
                  }




                } catch (error) {
                  console.warn('Element not found. Moving to the next element:', error);
                  // Handle the case when the element is not found
                  // You can skip the iteration or log the error as needed
                }
                // this.renderer.selectRootElement("#plancheck" + element.productAddonss[productkey][i].planId + ".coverage" + coverage).click()

              }
              else {

                try {
                  const elementSelector = "#plancheck" +
                    element.productAddonss[productkey][i].planId +
                    ".coverage" +
                    element.productAddonss[productkey][i].planCoverage;

                  const targetElement = this.renderer.selectRootElement(elementSelector, true);
                  // Use the second argument 'true' to avoid throwing an error if the element is not found
                  console.log(targetElement)
                  if (targetElement.disabled) {
                    targetElement.disabled = false
                    targetElement.click();
                  }
                  else {
                    targetElement.click();
                  }

                } catch (error) {
                  console.warn('Element not found. Moving to the next element:', error);
                  // Handle the case when the element is not found
                  // You can skip the iteration or log the error as needed
                }
                // this.renderer.selectRootElement("#plancheck" + element.productAddonss[productkey][i].planId + ".coverage" + element.productAddonss[productkey][i].planCoverage).click()

              }

            }

          }

          // Object.keys(element.productAddonss).forEach((key) => {
          //   element.productAddonss[key].forEach((product: any) => {
          //    //console.log(product)
          //    let coverage = element.companyPaidCoverage?.replace("SELECTIVE_","")
          //    //console.log(coverage)
          //   //  //console.log(this.renderer.selectRootElement("#plancheck" + product.planId + ".coverage" + coverage?coverage:product.planCoverage))
          //   //   // //console.log(this.renderer.selectRootElement("#plancheck" + product.planId + ".coverage" + covergae))
          //     // this.renderer.selectRootElement("#plancheck" + product.planId + ".coverage" + coverage?coverage:product.planCoverage).click()

          //     if(coverage!="DIRECT"){
          //       this.renderer.selectRootElement("#plancheck" + product.planId + ".coverage" + coverage).click()

          //     }
          //     else{
          //       this.renderer.selectRootElement("#plancheck" + product.planId + ".coverage" + product.planCoverage).click()
          //     }

          //   })
          // })

        }
        else {
          this.renderer.selectRootElement("#plancheck" + element.id).click()
        }



      }, 100);

    });


    setTimeout(() => {
      let selectplans =
        JSON.parse(sessionStorage.getItem("plansummarymain") || '[]') || "";

      //this.consoleMessage(selectplans)

      //console.log(selectplans)
      selectplans.forEach((element: any) => {
        if (element.paidByCompany == 1) {
          element.products.forEach((product: any, index: any) => {
            const dom: HTMLElement = this.elementRef.nativeElement;
            const plan: any = dom.querySelector("#plancheck" + product.id);

            if (plan) {
              plan.disabled = true;
            }
          })

        }
      });
    }, 2000);
    // this.mainarrayFinal.forEach((element: any) => {
    //   element.groups.forEach((group: any) => {
    //     group.plans.forEach((plan: any) => {
    //       if (plan.productAddonss) {
    //         Object.keys(plan.productAddonss).forEach((key) => {
    //           // plan.productAddonss[key].forEach((product) => {
    //           const keys = ['planCoverage'];
    //           const filteredData = plan.productAddonss[key].filter((value: any, index: any, self: any) =>
    //             self.findIndex((v: { [x: string]: any; }) => keys.every(k => v[k] === value[k])) === index
    //           );
    //           plan.productAddonss[key] = filteredData
    //           // });
    //         });
    //       }
    //     });

    //   });
    // });
    //this.consoleMessage(this.mainarray)

    this.mainarrayFinal.forEach((element: { groups: any[]; }) => {
      element.groups.forEach((group: { categorization: { paidByCompany: number; }; plans: any[]; }) => {
        // //this.consoleMessage(element.groups)
        if (element.groups.length == 1) {
          // //this.consoleMessage(group)
          if (group.categorization.paidByCompany == 1) {
            group.plans.forEach((plan: { productAddonss: { [x: string]: any[]; }; }) => {
              Object.keys(plan.productAddonss).forEach((key) => {
                plan.productAddonss[key].forEach((product: { id: any; }) => {
                  this.disabledcompanypaidproductid.push({ id: product.id });
                  const dom: HTMLElement = this.elementRef.nativeElement;

                  const plan: any = dom.querySelector("#plancheck" + product.id);

                  if (plan) {
                    plan.checked = false;
                  }
                  // $("#plancheck" + product.id).prop("checked", false);
                });
              });
            });
          }
        }
      });
    });


    this.disabledcompanypaidproductid.forEach((element: { id: string; }, index: any) => {
      setTimeout(() => {
        const dom: HTMLElement = this.elementRef.nativeElement;
        const plan: any = dom.querySelector("#plancheck" + element.id);

        // plan.disabled=true
      }, 100);
    });
    // if (packagesInBlocks && packagesInBlocks.paidByCompany) {
    //   for (const cpPackage of packagesInBlocks.paidByCompany) {
    //     for (const cpGroup of cpPackage.groupsCP) {
    //       for (const cpPlan of cpGroup.plans) {

    //         for(const product1 in cpPlan.productAddonss){
    //           //this.consoleMessage(product1)
    //           //this.consoleMessage(cpPlan.productAddonss[product1])
    //           $("#plancheck"+cpPlan.productAddonss[product1][0].id).click();

    //         }

    //       }
    //     }
    //   }
    // }
    // this.toastrService.success("Company paid plans are all selected", "");

  }
  public planCoverafeFunction() {
    this.paidEmployeeShare = 0;
    this.coveredEmployeeShare = 0;

    //this.consoleMessage("plancoverage");

    let planDetailsArray = JSON.parse(
      sessionStorage.getItem("planDetailsArray") || "[]"
    );
    //this.consoleMessage(planDetailsArray);
    // var package_plans = this.convertpackagesToPlans(planDetailsArray);
    // var package_plans = this.convertpackagesToPlans2(this.packagesInBlocks);
    var package_plans = this.convertpackagesToPlans2(this.basepackages);

    //this.consoleMessage(package_plans);
    let planSummaryMain = JSON.parse(sessionStorage.getItem("plansummary") || "[]");
    let planSummaryLife = JSON.parse(sessionStorage.getItem("plansummaryLife") || "[]");
    // let iafgplansCheck = JSON.parse(
    //   sessionStorage.getItem('plansummaryLife') || '[]'
    // );

    this.iafgplansCheck = JSON.parse(
      sessionStorage.getItem('plansummaryLife') || '[]'
    );
    //console.log(planSummaryMain)

    // let planSummary;
    // if(planSummaryMain.length>0){
    //  let planSummary = planSummaryMain.concat(planSummaryLife)
    // }else{
    //    planSummary = planSummaryLife
    // }
    let planSummary = planSummaryMain.concat(planSummaryLife)

    //console.log(planSummary)
    //this.consoleMessage(planSummary);
    var all_selected_plans = [];
    var payrollCCplans = [];
    var directpayCCplans = [];
    var employeeDealingPlans = [];
    var companyDealingPlans = [];
    var alloptinplans = [];
    var company_selected_plans = [];
    var employee_selected_plans = [];
    var company_paid_selected_plans = [];
    var company_covered_selected_plans = [];


    var selected_cp_plans = planSummary.filter(function (plan: any) {
      return plan.paidByCompany == 1 || plan.categorization?.paidByCompany == true;;
    });

    var selected_cc_plans = planSummary.filter(function (plan: any) {
      return plan.coveredByCompany == 1 || plan.categorization?.coveredByCompany == true;;
    });

    var selected_ep_plans = planSummary.filter(function (plan: any) {
      return plan.paidByEmployee == 1 || plan.categorization?.paidByEmployee == true;
    });

    // var selected_cc_plans = planSummary.forEach(element => {

    //   element.groups.forEach(group => {
    //     return group.categorization.coveredByCompany == 1;

    //   });

    // });

    // var selected_cp_plans = planSummary.forEach(element => {

    //   element.groups.forEach(group => {
    //     return group.categorization.paidByCompany == 1;

    //   });

    // });
    // var selected_ep_plans = planSummary.forEach(element => {

    //   element.groups.forEach(group => {
    //     return group.categorization.paidByEmployee == 1;

    //   });

    // });

    //this.consoleMessage(selected_cc_plans);
    //this.consoleMessage(selected_cp_plans);
    //this.consoleMessage(selected_ep_plans);

    //console.log(selected_cp_plans)

    for (var cp = 0; cp < selected_cp_plans.length; cp++) {
      var current_cp_plan: any = selected_cp_plans[cp];

      // current_cp_plan.amount = parseFloat(
      //   this._decimalPipe.transform(current_cp_plan.amount, "1.2-2")
      // );
      current_cp_plan.amount = adjustWith2DecimalsForUI(current_cp_plan.amount)

      // //this.consoleMessage("rakesh",current_cp_plan.amount)
      current_cp_plan["amounts"] = {
        company: current_cp_plan.amount,
        employee: 0,
        total: current_cp_plan.amount,
      };
      current_cp_plan["categorization"] = {
        paidByCompany: true,
        coveredByCompany: false,
        paidByEmployee: false,
      };

      current_cp_plan["type"] = this.lang["100_Company_Paid"];

      current_cp_plan["companyCoveredBasePlan"] = {
        planId: 0, //0
        planName: "NA", //NA
        planLevelId: 0, //0
        amount: 0, //0
        tax: 0,
        total: 0,
      };
      current_cp_plan["employeeAmount"] = current_cp_plan["amounts"].employee;
      current_cp_plan["employeeAmountUI"] =
        "$" + current_cp_plan["amounts"].employee;
      current_cp_plan["companyAmount"] = current_cp_plan["amounts"].company;
      current_cp_plan["companyAmountUI"] =
        "$" + current_cp_plan["amounts"].company;
      current_cp_plan["planLevelName"] = current_cp_plan.groupName || ""; //Here

      if (
        current_cp_plan.id == 429 ||
        current_cp_plan.packageId == 8 ||
        current_cp_plan.planLevel == 16
      ) {
        alloptinplans.push(current_cp_plan);
      } else {
        all_selected_plans.push(current_cp_plan);
        company_selected_plans.push(current_cp_plan);
        company_paid_selected_plans.push(current_cp_plan);
      }
    }

    for (var cc = 0; cc < selected_cc_plans.length; cc++) {
      var current_cc_plan: any = selected_cc_plans[cc];

      current_cc_plan["amounts"] = {
        company: current_cc_plan.upgradeCalculation.baseplanPrice,
        employee: current_cc_plan.upgradeCalculation.deltaplanPrice,
        total: current_cc_plan.upgradeCalculation.combinedplanPrice,
      };

      current_cc_plan["companyCoveredBasePlan"] =
        current_cc_plan.upgradeCalculation.basePlanDetails;

      current_cc_plan["companyCoveredBasePlan"].companyTax =
        current_cc_plan.upgradeCalculation.baseplanTax;
      current_cc_plan["companyCoveredBasePlan"].companyTaxPercentage =
        current_cc_plan.upgradeCalculation.companyTaxPercentage;

      current_cc_plan["companyCoveredBasePlan"].employeeTax = 0;
      current_cc_plan["companyCoveredBasePlan"].employeeTaxPercentage =
        current_cc_plan.upgradeCalculation.employeeTaxPercentage;
      current_cc_plan["companyCoveredBasePlan"].employeeTaxEffect = 0;
      current_cc_plan["companyCoveredBasePlan"].employeeTaxPercentageEffect =
        "0%";
      current_cc_plan["companyCoveredBasePlan"].specialTax =
        current_cc_plan["companyCoveredBasePlan"].companyTax +
        current_cc_plan["companyCoveredBasePlan"].employeeTaxEffect;
      current_cc_plan["companyCoveredBasePlan"].tax2 =
        current_cc_plan["companyCoveredBasePlan"].companyTax;

      //this.consoleMessage(current_cc_plan);
      ///
      //deleta plan things
      current_cc_plan["employeeDeductions"] = {
        amount: current_cc_plan.upgradeCalculation.deltaplanPrice, //0
        amountUI: `$${current_cc_plan.upgradeCalculation.deltaplanPrice}`, //0
        tax: `${current_cc_plan.upgradeCalculation.deltaplanTax}`,
        total: `${current_cc_plan.upgradeCalculation.deltaplanTotal}`,
        taxUI: `$${current_cc_plan.upgradeCalculation.deltaplanTax}`,
        totalUI: `$${current_cc_plan.upgradeCalculation.deltaplanTotal}`,
      };

      // current_cc_plan["employeeDeductions"].amountUI =
      //   "$" + current_cc_plan["employeeDeductions"].amount;
      // current_cc_plan["employeeDeductions"].taxUI = current_cc_plan[
      //   "companyCoveredBasePlan"
      // ].taxUI.replace(
      //   current_cc_plan["companyCoveredBasePlan"].tax,
      //   current_cc_plan["employeeDeductions"].tax
      // );
      // current_cc_plan["employeeDeductions"].totalUI =
      //   "$" + current_cc_plan["employeeDeductions"].total;

      current_cc_plan["categorization"] = {
        paidByCompany: false,
        coveredByCompany: true,
        paidByEmployee: false,
      };

      current_cc_plan["type"] = current_cc_plan.upgradeCalculation.type;

      current_cc_plan["planGrandTotal"] = {
        amount: current_cc_plan.upgradeCalculation.combinedplanPrice, //0
        amountUI: `$${current_cc_plan.upgradeCalculation.combinedplanPrice}`, //0
        tax: current_cc_plan.upgradeCalculation.combinedplanTax,
        total: current_cc_plan.upgradeCalculation.combinedplanTotal,
        taxUI: `$${current_cc_plan.upgradeCalculation.combinedplanTax}`,
        totalUI: `$${current_cc_plan.upgradeCalculation.combinedplanTotal}`,
      };
      // planid,planname,planlevelid,planlevename,amount
      current_cc_plan.amount = adjustWith2DecimalsForUI(current_cc_plan["planGrandTotal"].amount);
      current_cc_plan.amountUI = adjustWith2DecimalsForUI(current_cc_plan["planGrandTotal"].amount);
      current_cc_plan.tax = current_cc_plan["planGrandTotal"].tax;
      current_cc_plan.taxUI = current_cc_plan["planGrandTotal"].taxUI;
      current_cc_plan.total = current_cc_plan["planGrandTotal"].total;
      current_cc_plan.totalUI = current_cc_plan["planGrandTotal"].totalUI;
      current_cc_plan.skuTotalPrice = current_cc_plan["planGrandTotal"].total;
      current_cc_plan.totalPrice = current_cc_plan["planGrandTotal"].total;

      //this.consoleMessage(current_cc_plan);

      current_cc_plan["companyShareTotal"] =
        current_cc_plan["companyCoveredBasePlan"].total;
      current_cc_plan["employeeShareTotal"] =
        current_cc_plan["employeeDeductions"].total;

      current_cc_plan["companySharePlanAmountTotal"] =
        current_cc_plan["companyCoveredBasePlan"].amount;
      current_cc_plan["employeeSharePlanAmountTotal"] =
        current_cc_plan["employeeDeductions"].amount;

      current_cc_plan["companyShareTaxTotal"] =
        current_cc_plan["companyCoveredBasePlan"].tax;
      current_cc_plan["employeeShareTaxTotal"] =
        current_cc_plan["employeeDeductions"].tax;

      current_cc_plan["employeeAmount"] = current_cc_plan["amounts"].employee;
      current_cc_plan["employeeAmountUI"] =
        "$" + current_cc_plan["amounts"].employee;
      current_cc_plan["companyAmount"] = current_cc_plan["amounts"].company;
      current_cc_plan["companyAmountUI"] =
        "$" + current_cc_plan["amounts"].company;
      //this.consoleMessage(current_cc_plan["amounts"].employee);
      //this.consoleMessage(current_cc_plan["amounts"].company);
      //this.consoleMessage(current_cc_plan["amounts"].total);
      this.coveredEmployeeShare += parseFloat(
        current_cc_plan["amounts"].employee
      );

      // this.coveredEmployeeShare = parseFloat(
      //   this._decimalPipe.transform(this.coveredEmployeeShare, "1.2-2" ||)
      // );
      this.coveredEmployeeShare = parseFloat(this.coveredEmployeeShare)
      all_selected_plans.push(current_cc_plan);
      company_selected_plans.push(current_cc_plan);
      company_covered_selected_plans.push(current_cc_plan);

      if (current_cc_plan.upgradeCalculation.payroll) {
        payrollCCplans.push(current_cc_plan);
      } else {
        directpayCCplans.push(current_cc_plan);
      }
      //this.consoleMessage("payrollCCplans",payrollCCplans)
      //this.consoleMessage("directpayCCplans",directpayCCplans)
    }

    for (var ep = 0; ep < selected_ep_plans.length; ep++) {
      var current_ep_plan: any = selected_ep_plans[ep];

      //this.consoleMessage(current_ep_plan)

      current_ep_plan.amount = adjustWith2DecimalsForUI(current_ep_plan.products[0].price);

      current_ep_plan["amounts"] = {
        company: 0,
        employee: current_ep_plan.total, //current_ep_plan.amount,(+tax)
        total: current_ep_plan.total, //current_ep_plan.amount,(+tax)
      };

      current_ep_plan["categorization"] = {
        paidByCompany: false,
        coveredByCompany: false,
        paidByEmployee: true,
      };

      current_ep_plan["type"] = this.lang["Voluntary_Opt_In"];

      current_ep_plan["companyCoveredBasePlan"] = {
        planId: 0, //0
        planName: "NA", //NA
        planLevelId: 0, //0
        amount: 0, //0
        tax: 0,
        total: 0,
      };
      current_ep_plan["employeeAmount"] = current_ep_plan["amounts"].employee;
      current_ep_plan["employeeAmountUI"] =
        "$" + current_ep_plan["amounts"].employee;
      current_ep_plan["companyAmount"] = current_ep_plan["amounts"].company;
      current_ep_plan["companyAmountUI"] =
        "$" + current_ep_plan["amounts"].company;
      //  current_cp_plan["planLevelName"] = current_ep_plan.groupName || ""

      //this.consoleMessage(current_ep_plan)

      //console.log(current_ep_plan)

      //this.consoleMessage(current_ep_plan["amounts"].employee);
      //this.consoleMessage(this.paidEmployeeShare);
      // this.paidEmployeeShare = +current_ep_plan["amounts"].employee;
      this.paidEmployeeShare += parseFloat(current_ep_plan["amounts"].total);
      //this.consoleMessage(this.paidEmployeeShare);
      // this.paidEmployeeShare = parseFloat(
      //   this._decimalPipe.transform(this.paidEmployeeShare, "1.2-2")
      // );

      //this.consoleMessage(this.paidEmployeeShare);
      all_selected_plans.push(current_ep_plan);
      employee_selected_plans.push(current_ep_plan);
    }

    employeeDealingPlans = directpayCCplans.concat(employee_selected_plans);

    //console.log(employeeDealingPlans)
    companyDealingPlans = company_paid_selected_plans.concat(payrollCCplans);
    //console.log(this.iafgplansCheck)
    // employeeDealingPlans = employeeDealingPlans.concat(this.iafgplansCheck)  //hererakesh
    //console.log(employeeDealingPlans)

    //this.consoleMessage("employeeDealingPlans",employeeDealingPlans)
    //this.consoleMessage("companyDealingPlans",companyDealingPlans)

    this.alloptinplans = alloptinplans;

    //this.consoleMessage(this.coveredEmployeeShare);
    //this.consoleMessage(this.paidEmployeeShare);

    sessionStorage.setItem("employeeshare", this.paidEmployeeShare);
    //this.consoleMessage(this._decimalPipe.transform(this.coveredEmployeeShare, "1.2-2"));
    //this.consoleMessage(this._decimalPipe.transform(this.paidEmployeeShare, "1.2-2"));

    var totalIAFG = 0;
    for (let i = 0; i < this.iafgplansCheck.length; i++) {
      totalIAFG += parseFloat(this.iafgplansCheck[i].skuTotalPrice);
    }



    this.totalEmployeeShare =
      this.coveredEmployeeShare + this.paidEmployeeShare;
    // this.cartDisplayAmount = this.paidEmployeeShare + totalIAFG;
    this.cartDisplayAmount = this.paidEmployeeShare;
    // this.totalEmployeeShare = parseFloat(
    //   this._decimalPipe.transform(this.totalEmployeeShare, "1.2-2")
    // );
    this.totalEmployeeShare = parseFloat(this.totalEmployeeShare)
    this.cartDisplayAmount = this._decimalPipe.transform(
      this.cartDisplayAmount,
      "1.2-2"
    );

    //this.cartDisplayAmount = floatWith2Decimals(this.cartDisplayAmount);

    //this.consoleMessage(this.totalEmployeeShare);

    /* if (employee_selected_plans.length > 0) {
      this.showPaymenthMethod = true;
      this.showPaymenthMethod1 = false;
      this.creditcardform = true;
      sessionStorage.setItem("paymentMethod", "CC");
      this.bankpaymentmethod = "CC";

    } else {


      this.showPaymenthMethod = false;
      this.showPaymenthMethod1 = true;
      this.creditcardform = false;
      sessionStorage.setItem("paymentMethod", "NONE");
    }*/

    //console.log(this.iafgplansCheck)
    //console.log(this.iafgplansCheck.length)
    // if (employeeDealingPlans.length > 0 || this.iafgplansCheck.length > 0) {
    //   this.showPaymenthMethod = true;
    //   this.showPaymenthMethod1 = false;
    //   this.creditcardform = true;
    //   sessionStorage.setItem("paymentMethod", "CC");
    //   this.bankpaymentmethod = "CC";
    //   this.voluntryplansCheck = true
    //   // this.paymentForm.get('paymentRadioCheck')?.setValue("CC");
    // } else {
    //   this.showPaymenthMethod = false;
    //   this.showPaymenthMethod1 = true;
    //   this.creditcardform = false;
    //   this.voluntryplansCheck = false
    //   // this.bankpay =false;  //rakesh
    //   // this.paymentForm.get('paymentRadioCheck')?.setValue('');
    //   sessionStorage.setItem("paymentMethod", "NONE");
    // }

    this.directpayCCplansarr = directpayCCplans;
    this.payrollCCplansarr = payrollCCplans;
    this.companyDealingPlans = companyDealingPlans;
    this.employeeDealingPlansarr = employeeDealingPlans;

    //console.log(this.employeeDealingPlansarr)


    this.payrollCCplansarr = this.payrollCCplansarr.sort(function (a: any, b: any) {
      return a.packageId - b.packageId;
    });
    this.companyDealingPlans = this.companyDealingPlans.sort(function (a: any, b: any) {
      return a.packageId - b.packageId;
    });
    this.companyDealingPlans = this.companyDealingPlans.sort(function (a: any, b: any) {
      return a.packageId - b.packageId;
    });

    if (this.payrollCCplansarr.length > 0) {
      // this.upgradeplansCheck = true
    }
    //this.consoleMessage(this.companyDealingPlans)
    //this.consoleMessage(this.payrollCCplansarr)
    sessionStorage.setItem(
      "allSelectedPlans",
      JSON.stringify(all_selected_plans)
    );
    sessionStorage.setItem(
      "allSelectedOptPlans",
      JSON.stringify(alloptinplans)
    );
    //this.consoleMessage(all_selected_plans);
    //this.consoleMessage(company_selected_plans);

    //this.consoleMessage(company_paid_selected_plans);
    //this.consoleMessage(company_covered_selected_plans);
    //this.consoleMessage(employee_selected_plans);

    //company paid plans

    this.companySelectedPlans = company_paid_selected_plans;
    this.companyCoveredPlans = company_covered_selected_plans;
    // this.EmployeeSelectedPlans = employee_selected_plans.concat(this.iafgplansCheck);
    this.EmployeeSelectedPlans = employee_selected_plans
    this.allSelectedPlans = all_selected_plans;

    this.allSelectedPlans = this.allSelectedPlans.sort(function (a: any, b: any) {
      return a.packageId - b.packageId;
    });

    this.allPlansAmountTotal = sumBy(this.allSelectedPlans, "amount");
    //     this.allPlansAmountTotal =  this._decimalPipe.transform(
    //   this.allPlansAmountTotal,
    //   "1.2-2"
    // );
    this.allPlansTotal = sumBy(this.allSelectedPlans, "total");
    // this.allPlansTotal =  this._decimalPipe.transform(
    //   this.allPlansTotal,
    //   "1.2-2"
    // );
    this.allPlansTotaltax = sumBy(this.allSelectedPlans, "tax");
    // this.allPlansTotaltax =  this._decimalPipe.transform(
    //   this.allPlansTotaltax,
    //   "1.2-2"
    // );

    this.allCPPlansAmountTotal = sumBy(this.companySelectedPlans, "amount");
    this.allCPTaxTotal = sumBy(this.companySelectedPlans, "tax");
    this.companyPaidTotal = sumBy(this.companySelectedPlans, "total");
    //this.consoleMessage(this.companyPaidTotal);
    // this.companyPaidTotal =  this._decimalPipe.transform(
    //   this.companyPaidTotal,
    //   "1.2-2"
    // );
    //this.consoleMessage(this.companyPaidTotal);
    // for(var i=0;i<this.companySelectedPlans.length;i++){
    //   this.companyPaidTotal += this.companySelectedPlans[i].total

    //   this.companyPaidTotal = parseFloat(this._decimalPipe.transform(this.companySelectedPlans[i].total, "1.2-2"))

    // }
    // for(var i=0;i<this.companyCoveredPlans.length;i++){
    //   this.companyCoveredTotal += this.companyCoveredPlans[i].total
    //   this.companyCoveredTotal = parseFloat(this._decimalPipe.transform(this.companyCoveredTotal, "1.2-2"))

    // }
    this.allCCPlansAmountTotal = sumBy(this.companyCoveredPlans, "amount");
    this.allCCTaxTotal = sumBy(this.companyCoveredPlans, "tax");
    this.companyCoveredTotal = sumBy(this.companyCoveredPlans, "total");
    //this.consoleMessage(this.allCCPlansAmountTotal);
    //this.consoleMessage(this.allCCTaxTotal);
    //this.consoleMessage(this.companyCoveredTotal);
    this.companyCoveredCompanyShareTotal = sumBy(
      this.companyCoveredPlans,
      "companyShareTotal"
    );
    this.companyCoveredCompanySharePlanAmountTotal = sumBy(
      this.companyCoveredPlans,
      "companySharePlanAmountTotal"
    );
    this.companyCoveredCompanyShareTaxTotal = sumBy(
      this.companyCoveredPlans,
      "companyShareTaxTotal"
    );
    this.companyCoveredEmployeeShareTotal = sumBy(
      this.companyCoveredPlans,
      "employeeShareTotal"
    );
    this.companyCoveredEmployeeSharePlanAmountTotal = sumBy(
      this.companyCoveredPlans,
      "employeeSharePlanAmountTotal"
    );
    this.companyCoveredEmployeeShareTaxTotal = sumBy(
      this.companyCoveredPlans,
      "employeeShareTaxTotal"
    );

    this.payrollCCPlansAmountTotal = sumBy(payrollCCplans, "amount");
    this.payrollCCPlantaxTotal = sumBy(payrollCCplans, "tax");
    this.payrollCCPlangrandTotal = sumBy(payrollCCplans, "total");

    this.DirectCCpayPlanamountTotal = sumBy(directpayCCplans, "amount");
    this.DirectCCpayPlantaxTotal = sumBy(directpayCCplans, "tax");
    this.DirectCCpayPlangrandTotal = sumBy(directpayCCplans, "total");

    //The below includes Employee-voluntary-plans and company-covered-split with direct-pay-plans
    this.empDirectpayPlanamountTotal = sumBy(employeeDealingPlans, "amount");
    this.empDirectpayPlantaxTotal = sumBy(employeeDealingPlans, "tax");
    this.empDirectpayPlangrandTotal = sumBy(employeeDealingPlans, "total");

    //Company paid and company covered split with payroll
    this.companydealingplansTotal = sumBy(companyDealingPlans, "amount");
    this.companydealingplanstaxTotal = sumBy(companyDealingPlans, "tax");
    this.companydealingplansgrandTotal = sumBy(companyDealingPlans, "total");

    // for(var i=0;i<this.EmployeeSelectedPlans.length;i++){
    //   this.companyCoveredTotal += this.EmployeeSelectedPlans[i].total
    //   this.companyCoveredTotal = parseFloat(this._decimalPipe.transform(this.EmployeeSelectedPlans[i].total, "1.2-2"))

    // }
    //cp+cc(company)
    this.effectiveCompanyPlansAmountTotal =
      parseFloat(this.allCPPlansAmountTotal) +
      parseFloat(this.companyCoveredCompanySharePlanAmountTotal);
    this.effectiveCompanyPlansAmountTotal = this._decimalPipe.transform(
      this.effectiveCompanyPlansAmountTotal,
      "1.2-2"
    );
    this.effectiveCompanyTaxTotal =
      parseFloat(this.allCPTaxTotal) +
      parseFloat(this.companyCoveredCompanyShareTaxTotal);
    this.effectiveCompanyTaxTotal = this._decimalPipe.transform(
      this.effectiveCompanyTaxTotal,
      "1.2-2"
    );
    this.effectiveCompanyTotalContibution =
      parseFloat(this.companyPaidTotal) +
      parseFloat(this.companyCoveredCompanyShareTotal);
    this.effectiveCompanyTotalContibution = this._decimalPipe.transform(
      this.effectiveCompanyTotalContibution,
      "1.2-2"
    );


    this.allEPPlansAmountTotal = sumBy(this.EmployeeSelectedPlans, "amount");
    this.allEPTaxTotal = sumBy(this.EmployeeSelectedPlans, "tax");
    this.paidEmployeedTotal = sumBy(this.EmployeeSelectedPlans, "total");
    //this.consoleMessage(this.paidEmployeedTotal);
    // this.paidEmployeedTotal = this._decimalPipe.transform(
    //   this.paidEmployeedTotal,
    //   "1.2-2"
    // );
    // //this.consoleMessage(this.companyPaidTotal)
    // //this.consoleMessage(this.companyCoveredTotal)
    // //this.consoleMessage(this.paidEmployeedTotal)



    this.planssummarymainLife = JSON.parse(
      sessionStorage.getItem('plansummaryLife') || '[]'
    );

    //console.log(this.planssummarymainLife)
    let total: any = 0;
    for (let i = 0; i < this.planssummarymainLife.length; i++) {
      total += parseFloat(this.planssummarymainLife[i].skuTotalPrice);
    }

    //console.log(total)


    //this.consoleMessage(this.companyCoveredPlans)
    //payrollDeduction setting

    let payrollDeduction = sessionStorage.getItem("payrollDeduction")
      ? sessionStorage.getItem("payrollDeduction")
      : "EMPLOYEE_CHOICE";

    if (
      this.companyCoveredPlans.length > 0 &&
      payrollDeduction == "EMPLOYEE_CHOICE"
    ) {
      // $("payrolldeduction-modal").show()
      // jQuery("#payrolldeduction-modal").modal("show");
    }
  }
  public calculateTaxforPlan(plan: any) {
    let plandetails;
    //this.logger.log(plan)
    //this.logger.log($(`#plancheck${plan.id}`))
    for (const cpPlan of plan) {
      //this.logger.log(plan)
      for (const product1 in cpPlan.productAddonss) {

        //this.logger.log(cpPlan.productAddonss[product1][0].id)

        plandetails = $("#plancheck" + cpPlan.productAddonss[product1][0].id).attr("data");


        //this.logger.log(plandetails)
        let plandetailsobj = plandetails.split("##");

        let obj = {
          // enrollmentDate:this.datePipe.transform(
          //   this.userForm.value.planenrollmentdate,
          //   'yyyy-MM-dd'
          // ),
          enrollmentDate: sessionStorage.getItem('enrollmentdate'),

          // "name":plandetailsobj[1]+"-"+plandetailsobj[2],
          name: plandetailsobj[14],
          details: plandetailsobj[0],
          packagename: plandetailsobj[0],
          groupName: plandetailsobj[1],
          amount: parseFloat(plandetailsobj[3].replace(/\,/g, '')),
          planCoverage: plandetailsobj[2],
          planPrice: parseFloat(plandetailsobj[3].replace(/\,/g, '')),
          amountUI: "$" + parseFloat(plandetailsobj[3].replace(/\,/g, '')),
          gst:
            plandetailsobj[4] == null ||
              plandetailsobj[4] == "" ||
              plandetailsobj[4] == undefined ||
              plandetailsobj[4] == "null"
              ? 0
              : parseFloat(plandetailsobj[4]),
          hst:
            plandetailsobj[5] == null ||
              plandetailsobj[5] == "" ||
              plandetailsobj[5] == undefined ||
              plandetailsobj[5] == "null"
              ? 0
              : parseFloat(plandetailsobj[5]),
          pst:
            plandetailsobj[6] == null ||
              plandetailsobj[6] == "" ||
              plandetailsobj[6] == undefined ||
              plandetailsobj[6] == "null"
              ? 0
              : parseFloat(plandetailsobj[6]),
          qst:
            plandetailsobj[17] == null ||
              plandetailsobj[17] == "" ||
              plandetailsobj[17] == undefined ||
              plandetailsobj[17] == "null"
              ? 0
              : parseFloat(plandetailsobj[17]),
          gstCheck:
            plandetailsobj[4] == null ||
              plandetailsobj[4] == "" ||
              plandetailsobj[4] == undefined ||
              plandetailsobj[4] == "null"
              ? false
              : true,
          hstCheck:
            plandetailsobj[5] == null ||
              plandetailsobj[5] == "" ||
              plandetailsobj[5] == undefined ||
              plandetailsobj[5] == "null"
              ? false
              : true,
          pstCheck:
            plandetailsobj[6] == null ||
              plandetailsobj[6] == "" ||
              plandetailsobj[6] == undefined ||
              plandetailsobj[6] == "null"
              ? false
              : true,
          qstCheck:
            plandetailsobj[17] == null ||
              plandetailsobj[17] == "" ||
              plandetailsobj[17] == undefined ||
              plandetailsobj[17] == "null"
              ? false
              : true,
          id: parseFloat(plandetailsobj[7]),
          fusebillPlanID:
            plandetailsobj[8] == null ||
              plandetailsobj[8] == "" ||
              plandetailsobj[8] == undefined ||
              plandetailsobj[8] == "null"
              ? 0
              : parseFloat(plandetailsobj[8]),
          planFrequencyID:
            plandetailsobj[9] == null ||
              plandetailsobj[9] == "" ||
              plandetailsobj[9] == undefined ||
              plandetailsobj[9] == "null"
              ? 0
              : parseFloat(plandetailsobj[9]),
          optIn: plandetailsobj[10] == "true" ? true : false,
          planname: plandetailsobj[14],
          planLevel: parseInt(plandetailsobj[15]),
          packageId: parseInt(plandetailsobj[16]),
          options: [],
          paidByCompany1: plandetailsobj[19],
          coveredByCompany1: plandetailsobj[20],
          paidByEmployee1: plandetailsobj[21],
          planLevel_parentId: plandetailsobj[12],
          disallowedPlanLevels: plandetailsobj[11],
        };

        ////this.logger.log(obj)
        let gstprice = 0;
        let hstprice = 0;
        let pstprice = 0;
        let qstprice = 0;

        if (obj.gst > 0) {
          gstprice = obj.planPrice * obj.gst;
          obj["gstPrice"] = parseFloat(this._decimalPipe.transform(gstprice, "1.2-2"));
        } else {
          obj["gstPrice"] = 0;
        }

        if (obj.hst > 0) {
          hstprice = obj.planPrice * obj.hst;

          obj["hstPrice"] = parseFloat(this._decimalPipe.transform(hstprice, "1.2-2"));
        } else {
          obj["hstPrice"] = 0;
        }

        if (obj.pst > 0) {
          pstprice = obj.planPrice * obj.pst;
          obj["pstPrice"] = parseFloat(this._decimalPipe.transform(pstprice, "1.2-2"));
        } else {
          obj["pstPrice"] = 0;
        }

        if (obj.qst > 0) {
          qstprice = obj.planPrice * obj.qst;
          obj["qstPrice"] = parseFloat(this._decimalPipe.transform(qstprice, "1.2-2"));
        } else {
          obj["qstPrice"] = 0;
        }

        obj["taxUI"] = "";
        if (obj["gstCheck"]) {
          obj["taxUI"] += "<span>";
          if (obj["gstPrice"] == 0) {
            obj["taxUI"] += "-";
          } else {
            obj["taxUI"] += "$" + this._decimalPipe.transform(obj["gstPrice"], "1.2-2") + "&nbsp;(GST)";
          }
          obj["taxUI"] += "</span>";
        }

        if (obj["pstCheck"]) {
          obj["taxUI"] += "<span>";
          if (obj["pstPrice"] == 0) {
            obj["taxUI"] += "-";
          } else {
            obj["taxUI"] += "$" + this._decimalPipe.transform(obj["pstPrice"], "1.2-2") + "&nbsp;(PST)";
          }
          obj["taxUI"] += "</span>";
        }

        if (obj["qstCheck"]) {
          obj["taxUI"] += "<span>";
          if (obj["qstPrice"] == 0) {
            obj["taxUI"] += "-";
          } else {
            obj["taxUI"] += "$" + this._decimalPipe.transform(obj["qstPrice"], "1.2-2") + "&nbsp;(QST)";
          }
          obj["taxUI"] += "</span>";
        }

        if (obj["hstCheck"]) {
          obj["taxUI"] += "<span> ";
          if (obj["hstPrice"] == 0) {
            obj["taxUI"] += "-";
          } else {
            obj["taxUI"] += "$" + this._decimalPipe.transform(obj["hstPrice"], "1.2-2") + "&nbsp;(HST)";
          }
          obj["taxUI"] += "</span>";
        }

        if (!obj["hstCheck"] && !obj["gstCheck"] && !obj["pstCheck"] && !obj["qstCheck"]) {
          obj["taxUI"] += "<span>-";

          obj["taxUI"] += "</span>";
        }

        // ////this.logger.log(object["taxUI"])

        obj["tax"] = parseFloat(
          this._decimalPipe.transform(gstprice + hstprice + pstprice + qstprice, "1.2-2")
        );

        //this.logger.log(obj.planPrice);
        //this.logger.log(gstprice);
        //this.logger.log(hstprice);
        //this.logger.log(pstprice);

        //this.logger.log(qstprice);
        let pricecal = obj.planPrice + gstprice + hstprice + pstprice + qstprice;
        obj["totalPrice"] = pricecal;

        obj["totalUI"] = "$" + pricecal;

        obj["total"] = pricecal;
        //this.logger.log(obj)
        return obj;


      }

    }


  }

  public convertpackagesToPlans2(packages: { paidByCompany: any[]; }) {
    //this.consoleMessage("pacakges");
    //all_plans
    var plans: any[] = [];
    var cp_plans: any[] = [];
    var cc_plans: any[] = [];
    var ep_plans: any[] = [];

    packages?.paidByCompany.forEach((pack: { groupsCP: any[]; name: any; }, index: any) => {
      pack.groupsCP.forEach((group: { plans: any[]; parentId: any; name: any; id: any; categorization: { paidByCompany: any; coveredByCompany: any; paidByEmployee: any; companyPaidCoverage: any }; }, index1: any) => {
        group.plans.forEach((plan: { [x: string]: any; }, index2: any) => {
          if (plan) {
            plan["planLevel_parentId"] = group.parentId;
            plan["packageName"] = pack.name;
            plan["groupName"] = group.name;
            plan["groupId"] = group.id;
            plan["groupparentId"] = group.parentId;
            plan["companyPaidCoverage"] = group.categorization?.companyPaidCoverage ?? "DIRECT";
            plans.push(plan);

            if (group.categorization.paidByCompany) {
              cp_plans.push(plan);
            }
            if (group.categorization.coveredByCompany) {
              cc_plans.push(plan);
            }
            if (group.categorization.paidByEmployee) {
              ep_plans.push(plan);
            }
          } else {
            //this.consoleMessage("else");
          }
        });
      });
    });



    return [plans, cp_plans, cc_plans, ep_plans];
  }

  calculateBasePlanDeltasforCCplans(ccplanspackages: string | any[], baseplans: any[], compnayplans: any[]) {

    //console.log(ccplanspackages)
    let modifiedCCplanPackages = [];
    //console.log(baseplans)
    for (let i = 0; i < ccplanspackages?.length; i++) {
      let modifiedCCPackage = ccplanspackages[i];
      //this.consoleMessage(ccplanspackages[i].name)
      //this.consoleMessage(ccplanspackages[i].id)
      let CCplansgroups = ccplanspackages[i].groupsCC;

      modifiedCCPackage.groupsCC = [];
      for (let CCplangroup of CCplansgroups) {
        let modifiedCCgroup = CCplangroup;

        let bbCoverage = baseplans.filter((bb: any) => { return bb.packageId == modifiedCCPackage.id && bb.planLevel_parentId == modifiedCCgroup.parentId })

        let selectedCoverage = bbCoverage[0]?.companyPaidCoverage ?? "DIRECT"

        // let selectedCoverage = CCplangroup?.categorization?.companyPaidCoverage ?? "DIRECT"

        if (selectedCoverage == "null" || selectedCoverage == "" || selectedCoverage == " ") {
          selectedCoverage = "DIRECT"
        }
        if (selectedCoverage != "DIRECT") {
          selectedCoverage = selectedCoverage.replace("SELECTIVE_", "")
        }

        //console.log(selectedCoverage)
        let CCplans = CCplangroup.plans;
        //console.log(CCplangroup)

        modifiedCCgroup.plans = [];
        for (let CCplan of CCplans) {
          let modifiedCCplan = CCplan;
          //this.consoleMessage(CCplan.id);
          //this.consoleMessage(CCplan.isBundle);
          //this.consoleMessage(CCplan.name);

          CCplan.planLevel_parentId = CCplangroup.parentId;

          let payroll = true;
          let EmployeeChoice = 0;

          if (
            this.CORP_PAYROLL_NOT_MANDATORY_PACKAGES.includes(CCplan.packageId)
          ) {
            if (EmployeeChoice == 2) {
              payroll = false;
            }
          } else {
            if (
              this.CORP_PAYROLL_NOT_MANDATORY_PLANLEVELS.includes(
                CCplan.planLevel
              )
            ) {
              if (EmployeeChoice == 2) {
                payroll = false;
              }
            }
          }
          let selectedCCplanProductarray = CCplan.productAddonss[CCplan.name];
          console.log(CCplan)
          console.log(CCplan.productAddonss[CCplan.name])

          if (CCplan.isBundle) {
            //this.consoleMessage("BundlePlan")

            //this.consoleMessage(baseplans)
            //console.log(baseplans)
            var filtered_base_plans = baseplans.filter(function (plan: { packageId: any; planLevel_parentId: any; planLevel: number; productAddonss: any }) {



              return (
                CCplan.packageId == plan.packageId &&
                CCplan.planLevel_parentId == plan.planLevel_parentId &&
                CCplan.planLevel >= plan.planLevel &&
                plan.productAddonss && JSON.stringify(plan.productAddonss).length > 2
              );
            });

            var filtered_compnay_plans = compnayplans.filter(function (plan: { packageId: any; planLevel_parentId: any; planLevel: number; productAddonss: any }) {
              //this.consoleMessage(plan)
              //cp_plans

              //this.consoleMessage(CCplan.packageId,plan.packageId)
              //this.consoleMessage(CCplan.planLevel_parentId,plan.planLevel_parentId)
              //this.consoleMessage(CCplan.planLevel,plan.planLevel)

              return (
                CCplan.packageId == plan.packageId &&
                CCplan.planLevel_parentId == plan.planLevel_parentId &&
                CCplan.planLevel >= plan.planLevel &&
                plan.productAddonss && JSON.stringify(plan.productAddonss).length > 2
              );
            });

            //this.consoleMessage(filtered_base_plans);

            //this.consoleMessage(filtered_compnay_plans)
            let selectedBasePlan;
            let selectedCompnayPlan;
            let DeltaPlan;
            let selectedBaseplanProduct: any;
            let selectedBaseplanProductsArray: any = [];
            let selectedCompanyplanProduct: any;
            let selectedCompanyplanProductsArray: any = [];


            //console.log("length" + filtered_base_plans.length)
            //console.log(filtered_base_plans)
            //console.log(filtered_compnay_plans)

            if (filtered_base_plans.length == 0) {
            } else if (filtered_base_plans.length == 1) {
              selectedBasePlan = filtered_base_plans[0];
              selectedCompnayPlan = filtered_compnay_plans[0];
            } else {


              var filtered_base_plans2 = filtered_base_plans.filter(function (plan: { id: any; }) {
                return (
                  CCplan.id == plan.id
                );
              });
              var filtered_compnay_plans2 = filtered_compnay_plans.filter(function (plan: { id: any; }) {


                return (
                  CCplan.id == plan.id
                );
              });
              selectedBasePlan = filtered_base_plans2[0];
              selectedCompnayPlan = filtered_compnay_plans2[0];
            }

            //console.log(selectedBasePlan)
            //console.log(selectedCompnayPlan)
            //console.log("name" + selectedBasePlan?.name)
            if (selectedBasePlan) {
              // //this.consoleMessage(selectedBasePlan)
              // selectedBaseplanProduct = selectedBasePlan.productAddonss[selectedBasePlan.name][0]
              selectedBaseplanProductsArray = selectedBasePlan.productAddonss[selectedBasePlan.name];
              let selectedBaseplanProductsArray2 = [];
              //  //this.consoleMessage(CCplan.packageId)
              if (CCplan.packageId == 5 || CCplan.packageId == 10) {
                selectedBaseplanProductsArray2 = selectedBaseplanProductsArray
                for (let i = 0; i < selectedCCplanProductarray.length - selectedBaseplanProductsArray.length; i++) {
                  selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[selectedBaseplanProductsArray.length - 1]);
                }

                let remainigProdcuts = selectedCCplanProductarray.length - selectedBaseplanProductsArray2.length
                // //this.consoleMessage(selectedBaseplanProductsArray)

                if (remainigProdcuts > 0) {
                  for (let i = 0; i < remainigProdcuts; i++) {
                    selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray2[selectedBaseplanProductsArray2.length - 1]);
                  }
                }
                selectedBaseplanProductsArray = selectedBaseplanProductsArray2
                // //this.consoleMessage(selectedBaseplanProductsArray)
              }
              else {

                // Direct Coverage Method
                // setTimeout(() => {
                if (selectedCoverage == "DIRECT") {
                  selectedBaseplanProductsArray = this.DirectCoverageMethod(selectedCCplanProductarray, selectedBaseplanProductsArray)
                  //console.log(selectedBaseplanProductsArray)
                }

                // Selective single Coverage Method
                if (selectedCoverage == "SINGLE") {
                  selectedBaseplanProductsArray = this.selectiveSingleCoverageMethod(selectedCCplanProductarray, selectedBaseplanProductsArray)
                }
                // Selective Couple Coverage Method

                if (selectedCoverage == "COUPLE") {
                  selectedBaseplanProductsArray = this.selectiveCoupleCoverageMethod(selectedCCplanProductarray, selectedBaseplanProductsArray)
                }
                //  // Selective Family Coverage Method
                if (selectedCoverage == "FAMILY") {
                  selectedBaseplanProductsArray = this.selectiveFamilyCoverageMethod(selectedCCplanProductarray, selectedBaseplanProductsArray)
                }

                //console.log(selectedBaseplanProductsArray)
                // }, 1000)

                // let productCoverageFound = false;
                // for (let i = 0; i < selectedCCplanProductarray.length; i++) {
                //   for (let j = 0; j < selectedBaseplanProductsArray.length; j++) {

                //     if (selectedCCplanProductarray[i].planCoverage == selectedBaseplanProductsArray[j].planCoverage) {
                //       productCoverageFound = true
                //       selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[j])
                //       break;
                //     }


                //   }
                //   if (!productCoverageFound) {



                //     selectedBasePlan = {};
                //     selectedBaseplanProduct = {};
                //     selectedBaseplanProduct.calculatedTax = {};
                //     selectedBaseplanProduct.calculatedTax.price = 0;
                //     selectedBaseplanProduct.calculatedTax.tax = 0;
                //     selectedBaseplanProduct.calculatedTax.total = 0;
                //     selectedBaseplanProduct.name = "NA";
                //     selectedBaseplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
                //     selectedBaseplanProductsArray2.push(selectedBaseplanProduct);



                //   }

                // }
                // //this.consoleMessage(selectedBaseplanProductsArray)
                // selectedBaseplanProductsArray = selectedBaseplanProductsArray2
                //this.consoleMessage(selectedBaseplanProductsArray)
              }
            }
            else {
              //console.log("elseStatement")
              selectedBasePlan = {};
              selectedBaseplanProduct = {};
              selectedBaseplanProduct.calculatedTax = {};
              selectedBaseplanProduct.calculatedTax.price = 0;
              selectedBaseplanProduct.calculatedTax.tax = 0;
              selectedBaseplanProduct.calculatedTax.total = 0;
              selectedBaseplanProduct.name = "NA";

              for (let i = 0; i < selectedCCplanProductarray.length; i++) {
                selectedBaseplanProductsArray.push(selectedBaseplanProduct);
              }
            }


            //console.log(selectedBaseplanProductsArray)
            if (selectedCompnayPlan) {
              // selectedCompanyplanProduct = selectedCompnayPlan.productAddonss[selectedCompnayPlan.name][0]
              selectedCompanyplanProductsArray =
                selectedCompnayPlan.productAddonss[selectedCompnayPlan.name];
              // //this.consoleMessage(selectedCompanyplanProductsArray)
              // //this.consoleMessage(selectedCompnayPlan.name)

              let selectedCompanyplanProductsArray2 = [];

              if (CCplan.packageId == 5 || CCplan.packageId == 10) {
                selectedCompanyplanProductsArray2 = selectedCompanyplanProductsArray
                for (let i = 0; i < selectedCCplanProductarray.length - selectedCompanyplanProductsArray.length; i++) {
                  selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray[selectedCompanyplanProductsArray.length - 1]);
                }
                //this.consoleMessage(selectedCompanyplanProductsArray)

                let remainigProdcuts = selectedCCplanProductarray.length - selectedCompanyplanProductsArray2.length
                // //this.consoleMessage(selectedBaseplanProductsArray)

                if (remainigProdcuts > 0) {
                  for (let i = 0; i < remainigProdcuts; i++) {
                    selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray2[selectedCompanyplanProductsArray2.length - 1]);
                  }
                }
                selectedCompanyplanProductsArray = selectedCompanyplanProductsArray2
                //this.consoleMessage(selectedCompanyplanProductsArray)

              }
              else {

                //console.log(selectedCCplanProductarray)
                // let productCoverageFound = false;
                // for (let i = 0; i < selectedCCplanProductarray.length; i++) {
                //   for (let j = 0; j < selectedCompanyplanProductsArray.length; j++) {

                //     if (selectedCCplanProductarray[i].planCoverage == selectedCompanyplanProductsArray[j].planCoverage) {
                //       productCoverageFound = true
                //       selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray[j])
                //       break;
                //     }


                //   }
                //   if (!productCoverageFound) {


                //     selectedCompanyplanProduct = {};
                //     selectedCompanyplanProduct.calculatedTax = {};
                //     selectedCompanyplanProduct.calculatedTax.planProductInfos = [];
                //     selectedCompanyplanProduct.name = "NA";
                //     selectedCompanyplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
                //     selectedCompanyplanProductsArray2.push(selectedCompanyplanProduct);



                //   }

                // }
                // selectedCompanyplanProductsArray = selectedCompanyplanProductsArray2

                // // setTimeout(() => {
                if (selectedCoverage == "DIRECT") {
                  selectedCompanyplanProductsArray = this.CompanyDirectCoverageMethod(selectedCCplanProductarray, selectedCompanyplanProductsArray)
                  //console.log(selectedBaseplanProductsArray)
                }

                // Selective single Coverage Method
                if (selectedCoverage == "SINGLE") {
                  selectedCompanyplanProductsArray = this.CompanyselectiveSingleCoverageMethod(selectedCCplanProductarray, selectedCompanyplanProductsArray)
                }
                // Selective Couple Coverage Method

                if (selectedCoverage == "COUPLE") {
                  selectedCompanyplanProductsArray = this.CompanyselectiveCoupleCoverageMethod(selectedCCplanProductarray, selectedCompanyplanProductsArray)
                }
                //  // Selective Family Coverage Method
                if (selectedCoverage == "FAMILY") {
                  selectedCompanyplanProductsArray = this.CompanyselectiveFamilyCoverageMethod(selectedCCplanProductarray, selectedCompanyplanProductsArray)
                }


                // // }, 1000)


                //console.log(selectedCompanyplanProductsArray)


              }


            } else {
              selectedCompanyplanProduct = {};
              selectedCompanyplanProduct.calculatedTax = {};
              selectedCompanyplanProduct.calculatedTax.planProductInfos = [];
              for (let i = 0; i < selectedCCplanProductarray.length; i++) {
                selectedCompanyplanProductsArray.push(
                  selectedCompanyplanProduct
                );
              }
              //console.log(selectedCompanyplanProductsArray)
              //this.consoleMessage(selectedCompanyplanProductsArray)
            }


            let upgradeText;
            let upgradepaymentText;
            if (payroll) {
              upgradeText = "Employee upgraded using payroll deduction";
              upgradepaymentText = "using payroll deduction";
              //this.consoleMessage("One subscription to parent/corp with base(company tax)+Delta(employee tax)")
            } else {
              upgradeText = "Employee upgraded using Direct payment";
              upgradepaymentText = "using Direct payment";
            }

            modifiedCCplan.products = []



            for (let i = 0; i < selectedCCplanProductarray.length; i++) {
              let selectedBaseplanProduct = selectedBaseplanProductsArray[i];
              //console.log(selectedBaseplanProduct)
              let selectedCompanyplanProduct =
                selectedCompanyplanProductsArray[i];
              let selectedCCplanProduct = selectedCCplanProductarray[i];
              //console.log(selectedCCplanProduct)
              //console.log(selectedCompanyplanProductsArray[i])
              let companyTax =
                selectedCompanyplanProduct.calculatedTax.planProductInfos
                  .length > 0
                  ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
                    .taxRate
                  : 0;
              let companyTaxPercentage =
                selectedCompanyplanProduct.calculatedTax.planProductInfos
                  .length > 0
                  ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
                    .taxRatePercentage
                  : 0;

              let baseplanPrice = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.price
              );
              let baseplanTaxorg = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.tax
              );
              let baseplanTax = adjustWith2DecimalsForUI(
                baseplanPrice * companyTax
              );
              let baseplanTotalorg = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.total
              );
              let baseplanTotal = adjustWith2DecimalsForUI(
                baseplanPrice + baseplanTax
              );


              let employeeTax =
                selectedCCplanProduct?.calculatedTax?.planProductInfos.length > 0
                  ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
                    .taxRate
                  : 0;
              let employeeTaxPercentage =
                selectedCCplanProduct?.calculatedTax?.planProductInfos.length > 0
                  ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
                    .taxRatePercentage
                  : 0;
              let deltaplanPrice = adjustWith2DecimalsForUI(
                selectedCCplanProduct.calculatedTax.price -
                selectedBaseplanProduct.calculatedTax.price
              );
              //console.log(deltaplanPrice)


              //console.log(selectedBaseplanProduct.calculatedTax.price)

              if (selectedBaseplanProduct.name == 'NA') {
                //this.consoleMessage("No Base plan/product for this upgrade plans/product")
                // companyTax = employeeTax
                companyTax = 0  ////when there is no base planproduct
                // companyTaxPercentage = employeeTaxPercentage
                companyTaxPercentage = "0%" //when there is no base planproduct

              }
              //Delete plan Total Price and Total Combination
              if (deltaplanPrice < 0) {
                deltaplanPrice = 0
                baseplanPrice = adjustWith2DecimalsForUI(
                  selectedCCplanProduct.calculatedTax.price
                );
                baseplanTaxorg = adjustWith2DecimalsForUI(
                  selectedCCplanProduct.calculatedTax.tax
                );
                baseplanTax = adjustWith2DecimalsForUI(
                  baseplanPrice * companyTax
                );
                baseplanTotalorg = adjustWith2DecimalsForUI(
                  selectedCCplanProduct.calculatedTax.total
                );
                baseplanTotal = adjustWith2DecimalsForUI(
                  baseplanPrice + baseplanTax
                );
              }
              // let deltaplanTax = adjustWith2DecimalsForUI(
              //   deltaplanPrice *
              //   (this.deltaCompanyTax ? companyTax : employeeTax)
              // );
              let deltaplanTax = adjustWith2DecimalsForUI(deltaplanPrice * employeeTax);

              let deltaplanTotal = adjustWith2DecimalsForUI(
                deltaplanPrice + deltaplanTax
              );
              let combinedplanPrice = adjustWith2DecimalsForUI(
                baseplanPrice + deltaplanPrice
              );
              let combinedplanbasePrice = baseplanPrice;
              let combinedplanDeltaprice = deltaplanPrice;
              let combinedplanTax = adjustWith2DecimalsForUI(
                baseplanTax + deltaplanTax
              );
              let combinedplanCompanyTax = baseplanTax;
              let combinedplanEmployeeTax =
                adjustWith2DecimalsForUI(deltaplanTax);
              let combinedplanCompanyTaxPercentage = companyTaxPercentage;
              let combinedplanemployeeTaxPercentage = this.deltaCompanyTax
                ? companyTaxPercentage
                : employeeTaxPercentage;
              let combinedplanemployeeTaxPercentageorg = employeeTaxPercentage;

              let combinedplanTotal = adjustWith2DecimalsForUI(
                baseplanTotal + deltaplanTotal
              );

              let scenario = `Employee Upgrade from ${selectedBasePlan.name} to ${CCplan.name}`;
              let planName = `${CCplan.name} (${upgradeText})`;
              let compnayShareStatement = `${CCplan.name} Contribution`;
              let employeeShareStatement = `${CCplan.name} upgrade cost`;
              let planDescription = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanTotal} and Employee- pays ${upgradepaymentText} ${deltaplanTotal} `;
              let planDescription2 = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanPrice}(with tax:${companyTaxPercentage}) and Employee- pays ${upgradepaymentText} ${deltaplanPrice}(with tax:${employeeTaxPercentage}) `;
              let type;

              if (payroll) {
                type = "Split with payroll deduction";
              } else {
                type = "Split with direct pay";
              }
              let basePlanDetails = {
                planId: selectedBasePlan.id, //0
                planName: selectedBasePlan.name, //NA
                planLevelId: selectedBasePlan.planLevel, //0
                amount: baseplanPrice, //0
                amountUI: `$${baseplanPrice}`, //0
                tax: baseplanTax,
                total: baseplanTotal,
                taxUI: `$${baseplanTax}`, //companyTaxpercentage
                totalUI: `$${baseplanTotal}`,
                planLevelName: selectedBasePlan.groupName || "", //if it is Bundle
                planFrequencyID: selectedBasePlan.frqMonthly || "",
                planFusebillID: selectedBasePlan.fusebillId || "",
                products: [selectedBaseplanProduct],
                planLevel_parentId: selectedBasePlan.planLevel_parentId,
                packageName: selectedBasePlan.packageName,
                packageId: selectedBasePlan.packageId,
              };





              let obj = {
                companyTax,
                companyTaxPercentage,
                baseplanPrice,
                baseplanTaxorg,
                baseplanTax,
                baseplanTotalorg,
                baseplanTotal,
                employeeTax,
                employeeTaxPercentage,
                deltaplanPrice,
                deltaplanTax,
                deltaplanTotal,
                combinedplanPrice,
                combinedplanbasePrice,
                combinedplanDeltaprice,
                combinedplanTax,
                combinedplanCompanyTax,
                combinedplanEmployeeTax,
                combinedplanCompanyTaxPercentage,
                combinedplanemployeeTaxPercentage,
                combinedplanTotal,
                payroll,
                scenario,
                planName,
                compnayShareStatement,
                employeeShareStatement,
                planDescription,
                planDescription2,
                type,
                basePlanDetails,
                combinedplanemployeeTaxPercentageorg,
                selectedCoverage
              };

              //this.consoleMessage(obj)

              console.log(obj)
              let ccProduct: any = {}
              ccProduct.upgradeCalculation = obj;
              modifiedCCplan.products.push(ccProduct)
              modifiedCCplan.upgradeCalculation = obj;


            }
            modifiedCCgroup.plans.push(modifiedCCplan);

          }
          else {
            let selectedCCplanNamearray = Object.keys(CCplan.productAddonss)

            let selectedCCplanProductarray: any = []
            for (let name of selectedCCplanNamearray) {
              selectedCCplanProductarray = selectedCCplanProductarray.concat(CCplan.productAddonss[name])
            }
            var filtered_base_plans = baseplans.filter(function (plan: { packageId: any; planLevel_parentId: any; planLevel: number; productAddonss: any }) {


              return (
                CCplan.packageId == plan.packageId &&
                CCplan.planLevel_parentId == plan.planLevel_parentId &&
                CCplan.planLevel >= plan.planLevel &&
                plan.productAddonss && JSON.stringify(plan.productAddonss).length > 2
              );
            });

            var filtered_compnay_plans = compnayplans.filter(function (plan: { packageId: any; planLevel_parentId: any; planLevel: number; productAddonss: any }) {


              return (
                CCplan.packageId == plan.packageId &&
                CCplan.planLevel_parentId == plan.planLevel_parentId &&
                CCplan.planLevel >= plan.planLevel &&
                plan.productAddonss && JSON.stringify(plan.productAddonss).length > 2
              );
            });

            //this.consoleMessage(filtered_base_plans)

            //this.consoleMessage(filtered_compnay_plans)
            let selectedBasePlan;
            let selectedCompnayPlan;
            let DeltaPlan;
            console.log("length" + filtered_base_plans.length)
            console.log(filtered_base_plans)
            console.log(filtered_compnay_plans)
            if (filtered_base_plans.length == 0) {
            } else if (filtered_base_plans.length == 1) {
              selectedBasePlan = filtered_base_plans[0];
              selectedCompnayPlan = filtered_compnay_plans[0];
            } else {
              //this.consoleMessage(filtered_base_plans.length)

            }

            let selectedbaseplanproduct: any;
            let selectedBaseplanProduct: any;
            let selectedBaseplanProductsArray = []
            if (selectedBasePlan) {
              for (let planname in selectedBasePlan.productAddonss) {
                console.log(planname)
                console.log(selectedBasePlan.productAddonss[planname])
                let products = selectedBasePlan.productAddonss[planname];
                console.log("length" + products.length)
                if (products.length == 0) {
                } else if (products.length == 1) {
                  selectedbaseplanproduct = products[0];
                  selectedBaseplanProductsArray.push(products[0]);

                  // selectedCompnayPlan= filtered_compnay_plans[0]
                } else {
                  selectedbaseplanproduct = products[products.length - 1]; //

                  for (let i = 0; i < selectedCCplanProductarray.length; i++) {
                    selectedBaseplanProductsArray.push(products[i]);
                  }
                  /* Added for in the case of medacan year roudn care as base plan and with two products one is Individual(single) and(Family)
                  Selecting last product(highest) in this case */
                  console.log(products.length)
                }
              }
              console.log(selectedbaseplanproduct)
              selectedBaseplanProduct = selectedbaseplanproduct;

              //this.consoleMessage(selectedBaseplanProduct.calculatedTax.price)
              //this.consoleMessage(selectedBaseplanProduct.calculatedTax.tax)
              //this.consoleMessage(selectedBaseplanProduct.calculatedTax.total)
            } else {
              selectedBasePlan = {};
              selectedBaseplanProduct = {};
              selectedBaseplanProduct.calculatedTax = {};
              selectedBaseplanProduct.calculatedTax.price = 0;
              selectedBaseplanProduct.calculatedTax.tax = 0;
              selectedBaseplanProduct.calculatedTax.total = 0;
              selectedBaseplanProduct.name = "NA";


              for (let i = 0; i < selectedCCplanProductarray.length; i++) {
                selectedBaseplanProductsArray.push(selectedBaseplanProduct);
              }
            }

            let CCplanProduct;
            let CCproductslength

            for (let planname in CCplan.productAddonss) {
              let products = CCplan.productAddonss[planname];
              CCproductslength = products.length
              console.log("length" + products.length)

              if (products.length == 0) {
              } else if (products.length == 1) {
                CCplanProduct = products[0];
                // selectedCompnayPlan= filtered_compnay_plans[0]
              } else {
                CCplanProduct = products[products.length - 1]; //
                /* Added for in the case of medacan year M care as base plan and with two products one is Individual(single) and(Family)
                Selecting last product(highest) in this case */
                //this.consoleMessage(products.length)
              }
            }
            let selectedCCplanProduct = CCplanProduct;


            let selectedcompanyplanproduct: any;
            let selectedCompanyplanProduct: any;
            let selectedCompanyplanProductsArray = []

            if (selectedCompnayPlan) {
              for (let planname in selectedCompnayPlan.productAddonss) {
                //this.consoleMessage(planname)
                //this.consoleMessage(selectedCompnayPlan.productAddonss[planname])
                let products = selectedCompnayPlan.productAddonss[planname];

                if (products.length == 0) {
                } else if (products.length == 1) {
                  selectedcompanyplanproduct = products[0];
                  selectedCompanyplanProductsArray.push(
                    products[0]
                  );
                  // selectedCompnayPlan= filtered_compnay_plans[0]
                } else {
                  selectedcompanyplanproduct = products[products.length - 1]; //
                  for (let i = 0; i < products.length; i++) {
                    selectedCompanyplanProductsArray.push(
                      products[i]
                    );
                  }

                  /* Added for in the case of medacan year M care as base plan and with two products one is Individual(single) and(Family)
                  Selecting last product(highest) in this case */
                }
              }
              selectedCompanyplanProduct = selectedcompanyplanproduct;
              // for (let i = 0; i < selectedCCplanProductarray.length; i++) {
              //   selectedCompanyplanProductsArray.push(
              //     selectedCompanyplanProduct
              //   );
              // }
              //this.consoleMessage("CompanyTax")
              //this.consoleMessage(selectedCompanyplanProduct.calculatedTax.planProductInfos.length>0?selectedCompanyplanProduct.calculatedTax.planProductInfos[0].taxRate:0)
              //this.consoleMessage(selectedCompanyplanProduct.calculatedTax.planProductInfos.length>0?selectedCompanyplanProduct.calculatedTax.planProductInfos[0].taxRatePercentage:0)
            } else {
              selectedCompanyplanProduct = {};
              selectedCompanyplanProduct.calculatedTax = {};
              selectedCompanyplanProduct.calculatedTax.planProductInfos = [];
              console.log(selectedCCplanProductarray)
              console.log(selectedCompanyplanProduct)
              for (let i = 0; i < selectedCCplanProductarray.length; i++) {
                selectedCompanyplanProductsArray.push(
                  selectedCompanyplanProduct
                );
              }


            }

            let upgradeText;
            let upgradepaymentText;
            if (payroll) {
              upgradeText = "Employee upgraded using payroll deduction";
              upgradepaymentText = "using payroll deduction";
              //this.consoleMessage("One subscription to parent/corp with base(company tax)+Delta(employee tax)")
            } else {
              upgradeText = "Employee upgraded using Direct payment";
              upgradepaymentText = "using Direct payment";
            }



            if (CCproductslength == 1) {
              modifiedCCplan = this.singleCCCoverageProduct(selectedCompanyplanProduct, selectedBaseplanProduct, selectedCCplanProduct, CCplan, upgradeText, payroll, selectedBasePlan, upgradepaymentText, modifiedCCplan)

            }
            else {
              modifiedCCplan = this.multipleCCCoverageProduct(selectedCCplanProductarray, selectedBaseplanProductsArray, selectedCompanyplanProductsArray, selectedBasePlan, CCplan, upgradeText, payroll, upgradepaymentText, selectedCoverage, modifiedCCplan)

            }
            modifiedCCgroup.plans.push(modifiedCCplan);
          }
          //           modifiedCCgroup.plans = Array.from(new Set(modifiedCCgroup.plans.map((item:any) => JSON.stringify(item)))
          // ).map((str:any) => JSON.parse(str));
          modifiedCCPackage.groupsCC.push(modifiedCCgroup);
        }

        modifiedCCplanPackages.push(modifiedCCPackage);
      }
      modifiedCCplanPackages = Array.from(new Set(modifiedCCplanPackages.map((item: any) => JSON.stringify(item)))
      ).map((str: any) => JSON.parse(str));
      this.modifiedBlocksCoveredByCompany = modifiedCCplanPackages;

      console.log(this.modifiedBlocksCoveredByCompany)
    }
  }
  public singleCCCoverageProduct(selectedCompanyplanProduct: any, selectedBaseplanProduct: any, selectedCCplanProduct: any, CCplan: any, upgradeText: any, payroll: any, selectedBasePlan: any, upgradepaymentText: any, modifiedCCplan: any) {
    let companyTax =
      selectedCompanyplanProduct.calculatedTax.planProductInfos.length >
        0
        ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
          .taxRate
        : 0;
    let companyTaxPercentage =
      selectedCompanyplanProduct.calculatedTax.planProductInfos.length >
        0
        ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
          .taxRatePercentage
        : 0;
    let baseplanPrice = adjustWith2DecimalsForUI(
      selectedBaseplanProduct.calculatedTax.price
    );
    let baseplanTaxorg = adjustWith2DecimalsForUI(
      selectedBaseplanProduct.calculatedTax.tax
    );
    let baseplanTax = adjustWith2DecimalsForUI(
      baseplanPrice * companyTax
    );
    let baseplanTotalorg = adjustWith2DecimalsForUI(
      selectedBaseplanProduct.calculatedTax.total
    );
    let baseplanTotal = adjustWith2DecimalsForUI(
      baseplanPrice + baseplanTax
    );
    let employeeTax =
      selectedCCplanProduct.calculatedTax.planProductInfos.length > 0
        ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
          .taxRate
        : 0;
    let employeeTaxPercentage =
      selectedCCplanProduct.calculatedTax.planProductInfos.length > 0
        ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
          .taxRatePercentage
        : 0;

    let deltaplanPrice = adjustWith2DecimalsForUI(
      selectedCCplanProduct.calculatedTax.price -
      selectedBaseplanProduct.calculatedTax.price
    );

    //this.consoleMessage(selectedCCplanProduct.calculatedTax.price)
    //this.consoleMessage(selectedBaseplanProduct.calculatedTax.price)
    //this.consoleMessage(selectedCCplanProduct.calculatedTax.price -selectedBaseplanProduct.calculatedTax.price)
    if (selectedBaseplanProduct.name == 'NA') {
      //this.consoleMessage("No Base plan/product for this upgrade plans/product")
      companyTax = employeeTax
      companyTaxPercentage = employeeTaxPercentage
    }
    let deltaplanTax = adjustWith2DecimalsForUI(
      deltaplanPrice * (this.deltaCompanyTax ? companyTax : employeeTax)
    );
    // let deltaplanTax = deltaplanPrice*(this.deltaCompanyTax?companyTax:employeeTax)

    let deltaplanTotal = adjustWith2DecimalsForUI(
      deltaplanPrice + deltaplanTax
    );

    let combinedplanPrice = baseplanPrice + deltaplanPrice;
    let combinedplanbasePrice = baseplanPrice;
    let combinedplanDeltaprice = deltaplanPrice;
    let combinedplanTax = adjustWith2DecimalsForUI(
      baseplanTax + deltaplanTax
    );
    let combinedplanCompanyTax = baseplanTax;
    let combinedplanEmployeeTax =
      adjustWith2DecimalsForUI(deltaplanTax);
    let combinedplanCompanyTaxPercentage = companyTaxPercentage;
    let combinedplanemployeeTaxPercentage = this.deltaCompanyTax
      ? companyTaxPercentage
      : employeeTaxPercentage;
    let combinedplanemployeeTaxPercentageorg = employeeTaxPercentage;
    let combinedplanTotal = adjustWith2DecimalsForUI(
      baseplanTotal + deltaplanTotal
    );

    let scenario = `Employee Upgrade from ${selectedBaseplanProduct.name} to ${selectedCCplanProduct.name}`;
    let planName = `${CCplan.name}(${selectedCCplanProduct.name}) (${upgradeText})`;
    let compnayShareStatement = `${CCplan.name}(${selectedCCplanProduct.name}) Contribution`;
    let employeeShareStatement = `${CCplan.name}(${selectedCCplanProduct.name}) upgrade cost`;
    let planDescription = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanTotal} and Employee- pays ${upgradepaymentText} ${deltaplanTotal} `;
    let planDescription2 = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanPrice}(with tax:${companyTaxPercentage}) and Employee- pays ${upgradepaymentText} ${deltaplanPrice}(with tax:${employeeTaxPercentage}) `;
    let type;

    if (payroll) {
      type = "Split with payroll deduction";
    } else {
      type = "Split with direct pay";
    }
    let basePlanDetails = {
      planId: selectedBasePlan.id || 0, //0
      planName: selectedBasePlan.name || "NA", //NA
      planLevelId: selectedBasePlan.planLevel || 0, //0
      amount: baseplanPrice || 0, //0
      amountUI: `$${baseplanPrice}` || 0, //0
      tax: baseplanTax,
      total: baseplanTotal,
      taxUI: `$${baseplanTax}`, //companyTaxpercentage
      totalUI: `$${baseplanTotal}`,
      planLevelName: selectedBasePlan.groupName || "", //if it is Bundle
      planFrequencyID: selectedBasePlan.frqMonthly || "",
      planFusebillID: selectedBasePlan.fusebillId || "",
      products: [selectedBaseplanProduct],
      planLevel_parentId: selectedBasePlan.planLevel_parentId || 0,
      packageName: selectedBasePlan.packageName || "",
      packageId: selectedBasePlan.packageId || 0,
    };
    let obj = {
      companyTax,
      companyTaxPercentage,
      baseplanPrice,
      baseplanTaxorg,
      baseplanTax,
      baseplanTotalorg,
      baseplanTotal,
      employeeTax,
      employeeTaxPercentage,
      deltaplanPrice,
      deltaplanTax,
      deltaplanTotal,
      combinedplanPrice,
      combinedplanbasePrice,
      combinedplanDeltaprice,
      combinedplanTax,
      combinedplanCompanyTax,
      combinedplanEmployeeTax,
      combinedplanCompanyTaxPercentage,
      combinedplanemployeeTaxPercentage,
      combinedplanTotal,
      payroll,
      scenario,
      planName,
      compnayShareStatement,
      employeeShareStatement,
      planDescription,
      planDescription2,
      type,
      basePlanDetails,
      combinedplanemployeeTaxPercentageorg,
    };

    console.log(obj)
    modifiedCCplan.upgradeCalculation = obj;
    return modifiedCCplan
  }

  public multipleCCCoverageProduct(selectedCCplanProductarray: any, selectedBaseplanProductsArray: any, selectedCompanyplanProductsArray: any, selectedBasePlan: any, CCplan: any, upgradeText: any, payroll: any, upgradepaymentText: any, selectedCoverage: any, modifiedCCplan: any) {

    console.log(selectedCCplanProductarray)
    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      let selectedBaseplanProduct = selectedBaseplanProductsArray[i];
      console.log(selectedBaseplanProduct)
      let selectedCompanyplanProduct =
        selectedCompanyplanProductsArray[i];
      let selectedCCplanProduct = selectedCCplanProductarray[i];
      console.log(selectedCCplanProduct)
      console.log(selectedCompanyplanProductsArray[i])
      let companyTax =
        selectedCompanyplanProduct.calculatedTax.planProductInfos
          .length > 0
          ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
            .taxRate
          : 0;
      let companyTaxPercentage =
        selectedCompanyplanProduct.calculatedTax.planProductInfos
          .length > 0
          ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
            .taxRatePercentage
          : 0;

      let baseplanPrice = adjustWith2DecimalsForUI(
        selectedBaseplanProduct.calculatedTax.price
      );
      let baseplanTaxorg = adjustWith2DecimalsForUI(
        selectedBaseplanProduct.calculatedTax.tax
      );
      let baseplanTax = adjustWith2DecimalsForUI(
        baseplanPrice * companyTax
      );
      let baseplanTotalorg = adjustWith2DecimalsForUI(
        selectedBaseplanProduct.calculatedTax.total
      );
      let baseplanTotal = adjustWith2DecimalsForUI(
        baseplanPrice + baseplanTax
      );


      let employeeTax =
        selectedCCplanProduct?.calculatedTax?.planProductInfos.length > 0
          ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
            .taxRate
          : 0;
      let employeeTaxPercentage =
        selectedCCplanProduct?.calculatedTax?.planProductInfos.length > 0
          ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
            .taxRatePercentage
          : 0;
      let deltaplanPrice = adjustWith2DecimalsForUI(
        selectedCCplanProduct.calculatedTax.price -
        selectedBaseplanProduct.calculatedTax.price
      );
      //console.log(deltaplanPrice)


      //console.log(selectedBaseplanProduct.calculatedTax.price)

      if (selectedBaseplanProduct.name == 'NA') {
        //this.consoleMessage("No Base plan/product for this upgrade plans/product")
        // companyTax = employeeTax
        companyTax = 0  ////when there is no base planproduct
        // companyTaxPercentage = employeeTaxPercentage
        companyTaxPercentage = "0%" //when there is no base planproduct

      }
      //Delete plan Total Price and Total Combination
      if (deltaplanPrice < 0) {
        deltaplanPrice = 0
        baseplanPrice = adjustWith2DecimalsForUI(
          selectedCCplanProduct.calculatedTax.price
        );
        baseplanTaxorg = adjustWith2DecimalsForUI(
          selectedCCplanProduct.calculatedTax.tax
        );
        baseplanTax = adjustWith2DecimalsForUI(
          baseplanPrice * companyTax
        );
        baseplanTotalorg = adjustWith2DecimalsForUI(
          selectedCCplanProduct.calculatedTax.total
        );
        baseplanTotal = adjustWith2DecimalsForUI(
          baseplanPrice + baseplanTax
        );
      }
      // let deltaplanTax = adjustWith2DecimalsForUI(
      //   deltaplanPrice *
      //   (this.deltaCompanyTax ? companyTax : employeeTax)
      // );
      let deltaplanTax = adjustWith2DecimalsForUI(deltaplanPrice * employeeTax);

      let deltaplanTotal = adjustWith2DecimalsForUI(
        deltaplanPrice + deltaplanTax
      );
      let combinedplanPrice = adjustWith2DecimalsForUI(
        baseplanPrice + deltaplanPrice
      );
      let combinedplanbasePrice = baseplanPrice;
      let combinedplanDeltaprice = deltaplanPrice;
      let combinedplanTax = adjustWith2DecimalsForUI(
        baseplanTax + deltaplanTax
      );
      let combinedplanCompanyTax = baseplanTax;
      let combinedplanEmployeeTax =
        adjustWith2DecimalsForUI(deltaplanTax);
      let combinedplanCompanyTaxPercentage = companyTaxPercentage;
      let combinedplanemployeeTaxPercentage = this.deltaCompanyTax
        ? companyTaxPercentage
        : employeeTaxPercentage;
      let combinedplanemployeeTaxPercentageorg = employeeTaxPercentage;

      let combinedplanTotal = adjustWith2DecimalsForUI(
        baseplanTotal + deltaplanTotal
      );

      let scenario = `Employee Upgrade from ${selectedBasePlan.name} to ${CCplan.name}`;
      let planName = `${CCplan.name} (${upgradeText})`;
      let compnayShareStatement = `${CCplan.name} Contribution`;
      let employeeShareStatement = `${CCplan.name} upgrade cost`;
      let planDescription = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanTotal} and Employee- pays ${upgradepaymentText} ${deltaplanTotal} `;
      let planDescription2 = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanPrice}(with tax:${companyTaxPercentage}) and Employee- pays ${upgradepaymentText} ${deltaplanPrice}(with tax:${employeeTaxPercentage}) `;
      let type;

      if (payroll) {
        type = "Split with payroll deduction";
      } else {
        type = "Split with direct pay";
      }
      let basePlanDetails = {
        planId: selectedBasePlan.id, //0
        planName: selectedBasePlan.name, //NA
        planLevelId: selectedBasePlan.planLevel, //0
        amount: baseplanPrice, //0
        amountUI: `$${baseplanPrice}`, //0
        tax: baseplanTax,
        total: baseplanTotal,
        taxUI: `$${baseplanTax}`, //companyTaxpercentage
        totalUI: `$${baseplanTotal}`,
        planLevelName: selectedBasePlan.groupName || "", //if it is Bundle
        planFrequencyID: selectedBasePlan.frqMonthly || "",
        planFusebillID: selectedBasePlan.fusebillId || "",
        products: [selectedBaseplanProduct],
        planLevel_parentId: selectedBasePlan.planLevel_parentId,
        packageName: selectedBasePlan.packageName,
        packageId: selectedBasePlan.packageId,
      };





      let obj = {
        companyTax,
        companyTaxPercentage,
        baseplanPrice,
        baseplanTaxorg,
        baseplanTax,
        baseplanTotalorg,
        baseplanTotal,
        employeeTax,
        employeeTaxPercentage,
        deltaplanPrice,
        deltaplanTax,
        deltaplanTotal,
        combinedplanPrice,
        combinedplanbasePrice,
        combinedplanDeltaprice,
        combinedplanTax,
        combinedplanCompanyTax,
        combinedplanEmployeeTax,
        combinedplanCompanyTaxPercentage,
        combinedplanemployeeTaxPercentage,
        combinedplanTotal,
        payroll,
        scenario,
        planName,
        compnayShareStatement,
        employeeShareStatement,
        planDescription,
        planDescription2,
        type,
        basePlanDetails,
        combinedplanemployeeTaxPercentageorg,
        selectedCoverage
      };

      //this.consoleMessage(obj)

      console.log(obj)

      if (modifiedCCplan.products) {

      } else {
        modifiedCCplan.products = []
      }
      let ccProduct: any = {}
      ccProduct.upgradeCalculation = obj;
      modifiedCCplan.products.push(ccProduct)
      modifiedCCplan.upgradeCalculation = obj;

      //console.log(modifiedCCplan)
    }

    return modifiedCCplan
  }
  // calculateBasePlanCPplans(cpplanspackages: string | any[], baseplans: any[], compnayplans: any[]) {

  //   //console.log(cpplanspackages)


  //   let modifiedCPplanPackages: any = [];
  //   for (let i = 0; i < cpplanspackages?.length; i++) {
  //     let modifiedCPPackage = cpplanspackages[i];

  //     let CPplansgroups = cpplanspackages[i].groupsCP;

  //     modifiedCPPackage.groupsCP = [];
  //     for (let CPplangroup of CPplansgroups) {
  //       let modifiedCPgroup = CPplangroup;
  //       let selectedCoverage = CPplangroup?.categorization?.companyPaidCoverage ?? "DIRECT"
  //       if (selectedCoverage == "null") {
  //         selectedCoverage = "DIRECT"
  //       }
  //       if (selectedCoverage != "DIRECT") {
  //         selectedCoverage = selectedCoverage.replace("SELECTIVE_", "")
  //       }

  //       //console.log(selectedCoverage)


  //       if (selectedCoverage == "DIRECT") {
  //         modifiedCPPackage.groupsCP.push(modifiedCPgroup)
  //         if (modifiedCPPackage.groupsCP.length == CPplansgroups.length) {
  //           modifiedCPplanPackages.push(modifiedCPPackage)
  //         }
  //         continue;
  //       }
  //       let CPplans = CPplangroup.plans;

  //       //console.log(CPplangroup)

  //       modifiedCPgroup.plans = [];
  //       baseplans = []
  //       for (let CPplan of CPplans) {
  //         let modifiedCPplan = CPplan;


  //         CPplan.planLevel_parentId = CPplangroup.parentId;

  //         let payroll = true;
  //         let EmployeeChoice = 0;

  //         if (
  //           this.CORP_PAYROLL_NOT_MANDATORY_PACKAGES.includes(CPplan.packageId)
  //         ) {
  //           if (EmployeeChoice == 2) {
  //             payroll = false;
  //           }
  //         } else {
  //           if (
  //             this.CORP_PAYROLL_NOT_MANDATORY_PLANLEVELS.includes(
  //               CPplan.planLevel
  //             )
  //           ) {
  //             if (EmployeeChoice == 2) {
  //               payroll = false;
  //             }
  //           }
  //         }
  //         console.log(CPplan)
  //         let selectedCPplanProductarray = CPplan.productAddonss[CPplan.name];
  //         //console.log(CPplan)
  //         //console.log(CPplan.productAddonss[CPplan.name])


  //         for (let i = 0; i < selectedCPplanProductarray.length; i++) {

  //           for (let j = 0; j < selectedCPplanProductarray.length; j++) {
  //             if (selectedCPplanProductarray[i].planCoverage == selectedCoverage) {

  //               baseplans.push(selectedCPplanProductarray[i])
  //             }

  //           }

  //         }

  //         if (CPplan.isBundle) {

  //           //console.log(baseplans)
  //           var filtered_base_plans = baseplans



  //           //this.consoleMessage(filtered_base_plans);

  //           //this.consoleMessage(filtered_compnay_plans)
  //           let selectedBasePlan;
  //           let selectedCompnayPlan;
  //           let DeltaPlan;
  //           let selectedBaseplanProduct: any;
  //           let selectedBaseplanProductsArray = [];
  //           let selectedCompanyplanProduct: any;
  //           let selectedCompanyplanProductsArray: any = [];

  //           //console.log("length" + filtered_base_plans.length)

  //           selectedBasePlan = filtered_base_plans[0];

  //           //console.log(selectedBasePlan)

  //           if (selectedBasePlan) {
  //             // //this.consoleMessage(selectedBasePlan)
  //             // selectedBaseplanProduct = selectedBasePlan.productAddonss[selectedBasePlan.name][0]
  //             selectedBaseplanProductsArray = [selectedBasePlan];
  //             let selectedBaseplanProductsArray2 = [];
  //             //  //this.consoleMessage(CCplan.packageId)
  //             if (CPplan.packageId == 5 || CPplan.packageId == 10) {

  //               // selectedBaseplanProductsArray2 = selectedBaseplanProductsArray
  //               // for (let i = 0; i < selectedCPplanProductarray.length - selectedBaseplanProductsArray.length; i++) {
  //               //   selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[selectedBaseplanProductsArray.length - 1]);
  //               // }
  //               // // //this.consoleMessage(selectedBaseplanProductsArray)
  //               // selectedBaseplanProductsArray = selectedBaseplanProductsArray2
  //               // //this.consoleMessage(selectedBaseplanProductsArray)
  //             }
  //             else {

  //               // Direct Coverage Method

  //               // selectedBaseplanProductsArray =this.DirectCoverageMethod(selectedCCplanProductarray,selectedBaseplanProductsArray)


  //               // Selective single Coverage Method

  //               //  selectedBaseplanProductsArray =this.selectiveSingleCoverageMethod(selectedCCplanProductarray,selectedBaseplanProductsArray)

  //               // Selective Couple Coverage Method
  //               if (selectedCoverage != "DIRECT") {
  //                 selectedBaseplanProductsArray = this.selectiveCPCoverageMethod(selectedCPplanProductarray, selectedBaseplanProductsArray, selectedCoverage)
  //               }
  //               //  // Selective Family Coverage Method


  //             }
  //           }
  //           else {
  //             selectedBasePlan = {};
  //             selectedBaseplanProduct = {};
  //             selectedBaseplanProduct.calculatedTax = {};
  //             selectedBaseplanProduct.calculatedTax.price = 0;
  //             selectedBaseplanProduct.calculatedTax.tax = 0;
  //             selectedBaseplanProduct.calculatedTax.total = 0;
  //             selectedBaseplanProduct.name = "NA";

  //             for (let i = 0; i < selectedCPplanProductarray.length; i++) {
  //               selectedBaseplanProductsArray.push(selectedBaseplanProduct);
  //             }
  //           }



  //           let upgradeText;
  //           let upgradepaymentText;
  //           if (payroll) {
  //             upgradeText = "Employee upgraded using payroll deduction";
  //             upgradepaymentText = "using payroll deduction";
  //             //this.consoleMessage("One subscription to parent/corp with base(company tax)+Delta(employee tax)")
  //           } else {
  //             upgradeText = "Employee upgraded using Direct payment";
  //             upgradepaymentText = "using Direct payment";
  //           }

  //           modifiedCPplan.products = []

  //           for (let i = 0; i < selectedCPplanProductarray.length; i++) {
  //             let selectedBaseplanProduct = selectedBaseplanProductsArray[i];
  //             //console.log(selectedBaseplanProduct)
  //             let selectedCPplanProduct = selectedCPplanProductarray[i];
  //             //console.log(selectedCPplanProduct)
  //             let coverage = selectedCPplanProduct.planCoverage


  //             if (selectedCoverage == coverage) {

  //               modifiedCPplan.products.push(selectedCPplanProduct)
  //               continue;
  //             }

  //             //console.log(selectedCPplanProduct)
  //             let selectedCompanyplanProduct =
  //               selectedCompanyplanProductsArray[i];


  //             let companyTax =
  //               selectedCPplanProduct?.calculatedTax?.planProductInfos.length > 0
  //                 ? selectedCPplanProduct.calculatedTax.planProductInfos[0]
  //                   .taxRate
  //                 : 0;
  //             let companyTaxPercentage =
  //               selectedCPplanProduct?.calculatedTax?.planProductInfos.length > 0
  //                 ? selectedCPplanProduct.calculatedTax.planProductInfos[0]
  //                   .taxRatePercentage
  //                 : 0;

  //             let baseplanPrice = adjustWith2DecimalsForUI(
  //               selectedBaseplanProduct.calculatedTax.price
  //             );
  //             let baseplanTaxorg = adjustWith2DecimalsForUI(
  //               selectedBaseplanProduct.calculatedTax.tax
  //             );
  //             let baseplanTax = adjustWith2DecimalsForUI(
  //               baseplanPrice * companyTax
  //             );
  //             let baseplanTotalorg = adjustWith2DecimalsForUI(
  //               selectedBaseplanProduct.calculatedTax.total
  //             );
  //             let baseplanTotal = adjustWith2DecimalsForUI(
  //               baseplanPrice + baseplanTax
  //             );



  //             let employeeTax =
  //               selectedCPplanProduct?.calculatedTax?.planProductInfos.length > 0
  //                 ? selectedCPplanProduct.calculatedTax.planProductInfos[0]
  //                   .taxRate
  //                 : 0;
  //             let employeeTaxPercentage =
  //               selectedCPplanProduct?.calculatedTax?.planProductInfos.length > 0
  //                 ? selectedCPplanProduct.calculatedTax.planProductInfos[0]
  //                   .taxRatePercentage
  //                 : 0;
  //             let deltaplanPrice = adjustWith2DecimalsForUI(
  //               selectedCPplanProduct.calculatedTax.price -
  //               selectedBaseplanProduct.calculatedTax.price
  //             );
  //             //console.log(deltaplanPrice)


  //             //console.log(selectedBaseplanProduct.calculatedTax.price)

  //             if (selectedBaseplanProduct.name == 'NA') {
  //               //this.consoleMessage("No Base plan/product for this upgrade plans/product")
  //               companyTax = employeeTax
  //               companyTaxPercentage = employeeTaxPercentage
  //             }
  //             //Delete plan Total Price and Total Combination
  //             if (deltaplanPrice <= 0) {
  //               deltaplanPrice = 0
  //               /*      baseplanPrice = adjustWith2DecimalsForUI(
  //                     selectedCPplanProduct.calculatedTax.price
  //                   );
  //                    baseplanTaxorg = adjustWith2DecimalsForUI(
  //                     selectedCPplanProduct.calculatedTax.tax
  //                   );
  //                    baseplanTax = adjustWith2DecimalsForUI(
  //                     baseplanPrice * companyTax
  //                   );
  //                    baseplanTotalorg = adjustWith2DecimalsForUI(
  //                     selectedCPplanProduct.calculatedTax.total
  //                   );
  //                    baseplanTotal = adjustWith2DecimalsForUI(
  //                     baseplanPrice + baseplanTax
  //                   ); */

  //               modifiedCPplan.products.push(selectedCPplanProduct)
  //               continue;

  //             }


  //             let deltaplanTax = adjustWith2DecimalsForUI(
  //               deltaplanPrice *
  //               (this.deltaCompanyTax ? companyTax : employeeTax)
  //             );
  //             let deltaplanTotal = adjustWith2DecimalsForUI(
  //               deltaplanPrice + deltaplanTax
  //             );
  //             let combinedplanPrice = adjustWith2DecimalsForUI(
  //               baseplanPrice + deltaplanPrice
  //             );
  //             let combinedplanbasePrice = baseplanPrice;
  //             let combinedplanDeltaprice = deltaplanPrice;
  //             let combinedplanTax = adjustWith2DecimalsForUI(
  //               baseplanTax + deltaplanTax
  //             );
  //             let combinedplanCompanyTax = baseplanTax;
  //             let combinedplanEmployeeTax =
  //               adjustWith2DecimalsForUI(deltaplanTax);
  //             let combinedplanCompanyTaxPercentage = companyTaxPercentage;
  //             let combinedplanemployeeTaxPercentage = this.deltaCompanyTax
  //               ? companyTaxPercentage
  //               : employeeTaxPercentage;
  //             let combinedplanemployeeTaxPercentageorg = employeeTaxPercentage;

  //             let combinedplanTotal = adjustWith2DecimalsForUI(
  //               baseplanTotal + deltaplanTotal
  //             );

  //             let scenario = `Employee Upgrade from ${selectedBasePlan.name}  (${selectedCoverage}) to ${CPplan.name}`;
  //             let planName = `${CPplan.name} (${this.capitalize(coverage)}) (${upgradeText})`;
  //             let compnayShareStatement = `${CPplan.name} (${this.capitalize(selectedCoverage)})  Contribution`;
  //             let employeeShareStatement = `${CPplan.name} (${this.capitalize(coverage)}) upgrade cost`;
  //             let planDescription = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanTotal} and Employee- pays ${upgradepaymentText} ${deltaplanTotal} `;
  //             let planDescription2 = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanPrice}(with tax:${companyTaxPercentage}) and Employee- pays ${upgradepaymentText} ${deltaplanPrice}(with tax:${employeeTaxPercentage}) `;
  //             let type;

  //             if (payroll) {
  //               type = "Split with payroll deduction";
  //             } else {
  //               type = "Split with direct pay";
  //             }
  //             let basePlanDetails = {
  //               planId: selectedBasePlan.id, //0
  //               planName: selectedBasePlan.name, //NA
  //               planLevelId: selectedBasePlan.planLevel, //0
  //               amount: baseplanPrice, //0
  //               amountUI: `$${baseplanPrice}`, //0
  //               tax: baseplanTax,
  //               total: baseplanTotal,
  //               taxUI: `$${baseplanTax}`, //companyTaxpercentage
  //               totalUI: `$${baseplanTotal}`,
  //               planLevelName: selectedBasePlan.groupName || "", //if it is Bundle
  //               planFrequencyID: selectedBasePlan.frqMonthly || "",
  //               planFusebillID: selectedBasePlan.fusebillId || "",
  //               products: [selectedBaseplanProduct],
  //               planLevel_parentId: selectedBasePlan.planLevel_parentId,
  //               packageName: selectedBasePlan.packageName,
  //               packageId: selectedBasePlan.packageId,
  //             };





  //             let obj = {
  //               companyTax,
  //               companyTaxPercentage,
  //               baseplanPrice,
  //               baseplanTaxorg,
  //               baseplanTax,
  //               baseplanTotalorg,
  //               baseplanTotal,
  //               employeeTax,
  //               employeeTaxPercentage,
  //               deltaplanPrice,
  //               deltaplanTax,
  //               deltaplanTotal,
  //               combinedplanPrice,
  //               combinedplanbasePrice,
  //               combinedplanDeltaprice,
  //               combinedplanTax,
  //               combinedplanCompanyTax,
  //               combinedplanEmployeeTax,
  //               combinedplanCompanyTaxPercentage,
  //               combinedplanemployeeTaxPercentage,
  //               combinedplanTotal,
  //               payroll,
  //               scenario,
  //               planName,
  //               compnayShareStatement,
  //               employeeShareStatement,
  //               planDescription,
  //               planDescription2,
  //               type,
  //               basePlanDetails,
  //               combinedplanemployeeTaxPercentageorg,
  //               coverage,
  //               selectedCoverage
  //             };

  //             //this.consoleMessage(obj)

  //             //console.log(selectedCoverage)
  //             //console.log(coverage)

  //             //console.log(obj)
  //             let cpProduct: any = {}
  //             cpProduct.upgradeCalculation = obj;
  //             modifiedCPplan.products.push(cpProduct)
  //             // modifiedCPplan.upgradeCalculation = obj;

  //             // if(selectedCoverage == coverage){

  //             // }else{
  //             //   cpProduct.upgradeCalculation = obj;
  //             //   modifiedCPplan.products.push(cpProduct)
  //             // }

  //             //console.log(modifiedCPplan)
  //           }

  //         }
  //         else {
  //           //this.consoleMessage("Not a BundlePlan")

  //           //this.consoleMessage(baseplans)



  //           filtered_base_plans = baseplans

  //           let selectedBasePlan;
  //           let selectedCompnayPlan;
  //           let DeltaPlan;
  //           //console.log("length" + filtered_base_plans.length)
  //           if (filtered_base_plans.length == 0) {
  //           } else if (filtered_base_plans.length == 0) {
  //             selectedBasePlan = filtered_base_plans[0];
  //           } else {
  //             //this.consoleMessage(filtered_base_plans.length)
  //           }

  //           let selectedbaseplanproduct: any;
  //           let selectedBaseplanProduct: any;

  //           if (selectedBasePlan) {
  //             for (let planname in selectedBasePlan.productAddonss) {
  //               //this.consoleMessage(planname)
  //               //this.consoleMessage(selectedBasePlan.productAddonss[planname])
  //               let products = selectedBasePlan.productAddonss[planname];
  //               //console.log("length" + products.length)
  //               if (products.length == 0) {
  //               } else if (products.length == 1) {
  //                 selectedbaseplanproduct = products[0];
  //                 // selectedCompnayPlan= filtered_compnay_plans[0]
  //               } else {
  //                 //this.consoleMessage(products.length)
  //               }
  //             }
  //             //this.consoleMessage(selectedbaseplanproduct)
  //             selectedBaseplanProduct = selectedbaseplanproduct;

  //           } else {
  //             selectedBasePlan = {};
  //             selectedBaseplanProduct = {};
  //             selectedBaseplanProduct.calculatedTax = {};
  //             selectedBaseplanProduct.calculatedTax.price = 0;
  //             selectedBaseplanProduct.calculatedTax.tax = 0;
  //             selectedBaseplanProduct.calculatedTax.total = 0;
  //             selectedBaseplanProduct.name = "NA";
  //           }

  //           let CCplanProduct;

  //           for (let planname in CPplan.productAddonss) {
  //             let products = CPplan.productAddonss[planname];
  //             //console.log("length" + products.length)

  //             if (products.length == 0) {
  //             } else if (products.length == 1) {
  //               CCplanProduct = products[0];
  //               // selectedCompnayPlan= filtered_compnay_plans[0]
  //             } else {
  //               //this.consoleMessage(products.length)
  //             }
  //           }
  //           let selectedCCplanProduct = CCplanProduct;


  //           let selectedcompanyplanproduct: any;
  //           let selectedCompanyplanProduct: any;

  //           if (selectedCompnayPlan) {

  //             let upgradeText;
  //             let upgradepaymentText;
  //             if (payroll) {
  //               upgradeText = "Employee upgraded using payroll deduction";
  //               upgradepaymentText = "using payroll deduction";
  //               //this.consoleMessage("One subscription to parent/corp with base(company tax)+Delta(employee tax)")
  //             } else {
  //               upgradeText = "Employee upgraded using Direct payment";
  //               upgradepaymentText = "using Direct payment";
  //             }
  //             let companyTax =
  //               selectedCompanyplanProduct.calculatedTax.planProductInfos.length >
  //                 0
  //                 ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
  //                   .taxRate
  //                 : 0;
  //             let companyTaxPercentage =
  //               selectedCompanyplanProduct.calculatedTax.planProductInfos.length >
  //                 0
  //                 ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
  //                   .taxRatePercentage
  //                 : 0;
  //             let baseplanPrice = adjustWith2DecimalsForUI(
  //               selectedBaseplanProduct.calculatedTax.price
  //             );
  //             let baseplanTaxorg = adjustWith2DecimalsForUI(
  //               selectedBaseplanProduct.calculatedTax.tax
  //             );
  //             let baseplanTax = adjustWith2DecimalsForUI(
  //               baseplanPrice * companyTax
  //             );
  //             let baseplanTotalorg = adjustWith2DecimalsForUI(
  //               selectedBaseplanProduct.calculatedTax.total
  //             );
  //             let baseplanTotal = adjustWith2DecimalsForUI(
  //               baseplanPrice + baseplanTax
  //             );
  //             let coverage = selectedCCplanProduct.planCoverage
  //             let employeeTax =
  //               selectedCCplanProduct.calculatedTax.planProductInfos.length > 0
  //                 ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
  //                   .taxRate
  //                 : 0;
  //             let employeeTaxPercentage =
  //               selectedCCplanProduct.calculatedTax.planProductInfos.length > 0
  //                 ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
  //                   .taxRatePercentage
  //                 : 0;

  //             let deltaplanPrice = adjustWith2DecimalsForUI(
  //               selectedCCplanProduct.calculatedTax.price -
  //               selectedBaseplanProduct.calculatedTax.price
  //             );

  //             //this.consoleMessage(selectedCCplanProduct.calculatedTax.price)
  //             //this.consoleMessage(selectedBaseplanProduct.calculatedTax.price)
  //             //this.consoleMessage(selectedCCplanProduct.calculatedTax.price -selectedBaseplanProduct.calculatedTax.price)
  //             if (selectedBaseplanProduct.name == 'NA') {
  //               //this.consoleMessage("No Base plan/product for this upgrade plans/product")
  //               companyTax = employeeTax
  //               companyTaxPercentage = employeeTaxPercentage
  //             }
  //             let deltaplanTax = adjustWith2DecimalsForUI(
  //               deltaplanPrice * (this.deltaCompanyTax ? companyTax : employeeTax)
  //             );
  //             // let deltaplanTax = deltaplanPrice*(this.deltaCompanyTax?companyTax:employeeTax)

  //             let deltaplanTotal = adjustWith2DecimalsForUI(
  //               deltaplanPrice + deltaplanTax
  //             );

  //             let combinedplanPrice = baseplanPrice + deltaplanPrice;
  //             let combinedplanbasePrice = baseplanPrice;
  //             let combinedplanDeltaprice = deltaplanPrice;
  //             let combinedplanTax = adjustWith2DecimalsForUI(
  //               baseplanTax + deltaplanTax
  //             );
  //             let combinedplanCompanyTax = baseplanTax;
  //             let combinedplanEmployeeTax =
  //               adjustWith2DecimalsForUI(deltaplanTax);
  //             let combinedplanCompanyTaxPercentage = companyTaxPercentage;
  //             let combinedplanemployeeTaxPercentage = this.deltaCompanyTax
  //               ? companyTaxPercentage
  //               : employeeTaxPercentage;
  //             let combinedplanemployeeTaxPercentageorg = employeeTaxPercentage;
  //             let combinedplanTotal = adjustWith2DecimalsForUI(
  //               baseplanTotal + deltaplanTotal
  //             );

  //             let scenario = `Employee Upgrade from ${selectedBaseplanProduct.name} to ${selectedCCplanProduct.name}`;
  //             let planName = `${CPplan.name}(${selectedCCplanProduct.name}) (${upgradeText})`;
  //             let compnayShareStatement = `${CPplan.name}(${selectedCCplanProduct.name}) Contribution`;
  //             let employeeShareStatement = `${CPplan.name}(${selectedCCplanProduct.name}) upgrade cost`;
  //             let planDescription = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanTotal} and Employee- pays ${upgradepaymentText} ${deltaplanTotal} `;
  //             let planDescription2 = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanPrice}(with tax:${companyTaxPercentage}) and Employee- pays ${upgradepaymentText} ${deltaplanPrice}(with tax:${employeeTaxPercentage}) `;
  //             let type;

  //             if (payroll) {
  //               type = "Split with payroll deduction";
  //             } else {
  //               type = "Split with direct pay";
  //             }
  //             let basePlanDetails = {
  //               planId: selectedBasePlan.id || 0, //0
  //               planName: selectedBasePlan.name || "NA", //NA
  //               planLevelId: selectedBasePlan.planLevel || 0, //0
  //               amount: baseplanPrice || 0, //0
  //               amountUI: `$${baseplanPrice}` || 0, //0
  //               tax: baseplanTax,
  //               total: baseplanTotal,
  //               taxUI: `$${baseplanTax}`, //companyTaxpercentage
  //               totalUI: `$${baseplanTotal}`,
  //               planLevelName: selectedBasePlan.groupName || "", //if it is Bundle
  //               planFrequencyID: selectedBasePlan.frqMonthly || "",
  //               planFusebillID: selectedBasePlan.fusebillId || "",
  //               products: [selectedBaseplanProduct],
  //               planLevel_parentId: selectedBasePlan.planLevel_parentId || 0,
  //               packageName: selectedBasePlan.packageName || "",
  //               packageId: selectedBasePlan.packageId || 0,
  //             };
  //             let obj = {
  //               companyTax,
  //               companyTaxPercentage,
  //               baseplanPrice,
  //               baseplanTaxorg,
  //               baseplanTax,
  //               baseplanTotalorg,
  //               baseplanTotal,
  //               employeeTax,
  //               employeeTaxPercentage,
  //               deltaplanPrice,
  //               deltaplanTax,
  //               deltaplanTotal,
  //               combinedplanPrice,
  //               combinedplanbasePrice,
  //               combinedplanDeltaprice,
  //               combinedplanTax,
  //               combinedplanCompanyTax,
  //               combinedplanEmployeeTax,
  //               combinedplanCompanyTaxPercentage,
  //               combinedplanemployeeTaxPercentage,
  //               combinedplanTotal,
  //               payroll,
  //               scenario,
  //               planName,
  //               compnayShareStatement,
  //               employeeShareStatement,
  //               planDescription,
  //               planDescription2,
  //               type,
  //               basePlanDetails,
  //               combinedplanemployeeTaxPercentageorg,
  //               coverage
  //             };

  //             //this.consoleMessage(obj)
  //             // modifiedCPplan.upgradeCalculation = obj;
  //           }
  //         }
  //         modifiedCPgroup.plans.push(modifiedCPplan);

  //         modifiedCPPackage.groupsCP.push(modifiedCPgroup);
  //       }
  //       //console.log(modifiedCPPackage)
  //       modifiedCPplanPackages.push(modifiedCPPackage);
  //     }

  //     this.modifiedBlocksPaidByCompany = modifiedCPplanPackages;

  //     console.log(this.modifiedBlocksPaidByCompany)

  //     //this.consoleMessage(this.modifiedBlocksCoveredByCompany)
  //   }
  // }
  calculateBasePlanCPplans(cpplanspackages: string | any[], baseplansMain: any[], compnayplans: any[]) {

    console.log(cpplanspackages)
    console.log(baseplansMain)

    if (baseplansMain) {
      baseplansMain = baseplansMain.filter(name => name.productAddonssNames.length > 0)
    }



    let selectedbasePlanMain;
    console.log(baseplansMain)
    let modifiedCPplanPackages: any = [];
    for (let i = 0; i < cpplanspackages?.length; i++) {
      if (baseplansMain) {
        selectedbasePlanMain = baseplansMain.filter(name => name.packageId == cpplanspackages[i].id)
        if (selectedbasePlanMain.length > 0) {
          selectedbasePlanMain = selectedbasePlanMain[selectedbasePlanMain.length - 1]
        }

      }
      let modifiedCPPackage = cpplanspackages[i];

      let CPplansgroups = cpplanspackages[i].groupsCP;

      modifiedCPPackage.groupsCP = [];
      for (let CPplangroup of CPplansgroups) {
        let modifiedCPgroup = CPplangroup;
        let selectedCoverage = CPplangroup?.categorization?.companyPaidCoverage ?? "DIRECT"
        if (selectedCoverage == "null") {
          selectedCoverage = "DIRECT"
        }
        if (selectedCoverage != "DIRECT") {
          selectedCoverage = selectedCoverage.replace("SELECTIVE_", "")
        }

        console.log(selectedCoverage)


        if (selectedCoverage == "DIRECT") {
          modifiedCPPackage.groupsCP.push(modifiedCPgroup)
          if (modifiedCPPackage.groupsCP.length == CPplansgroups.length) {
            modifiedCPplanPackages.push(modifiedCPPackage)
          }
          continue;
        }
        let CPplans = CPplangroup.plans;

        //console.log(CPplangroup)

        modifiedCPgroup.plans = [];
        let baseplans = []
        for (let CPplan of CPplans) {
          let modifiedCPplan = CPplan;


          CPplan.planLevel_parentId = CPplangroup.parentId;

          let payroll = true;
          let EmployeeChoice = 0;

          if (
            this.CORP_PAYROLL_NOT_MANDATORY_PACKAGES.includes(CPplan.packageId)
          ) {
            if (EmployeeChoice == 2) {
              payroll = false;
            }
          } else {
            if (
              this.CORP_PAYROLL_NOT_MANDATORY_PLANLEVELS.includes(
                CPplan.planLevel
              )
            ) {
              if (EmployeeChoice == 2) {
                payroll = false;
              }
            }
          }
          console.log(CPplan)
          let selectedCPplanProductarray: any = CPplan.productAddonss[CPplan.name];


          // let selectedCPplanProductarray: any = Object.keys(CPplan.productAddonss)

          console.log(selectedCPplanProductarray)
          if (selectedbasePlanMain) {
            let selectedMainProductarray: any = selectedbasePlanMain.productAddonss[selectedbasePlanMain.name];

            console.log(selectedMainProductarray)
            //console.log(CPplan.productAddonss[CPplan.name])

            for (let i = 0; i < selectedCPplanProductarray.length; i++) {

              for (let j = 0; j < selectedMainProductarray.length; j++) {
                if (selectedMainProductarray[i].planCoverage == selectedCoverage) {

                  baseplans.push(selectedMainProductarray[i])
                }

              }
            }
          }
          else {
            for (let i = 0; i < selectedCPplanProductarray.length; i++) {

              for (let j = 0; j < selectedCPplanProductarray.length; j++) {
                if (selectedCPplanProductarray[i].planCoverage == selectedCoverage) {

                  baseplans.push(selectedCPplanProductarray[i])
                }

              }

            }

          }






          if (CPplan.isBundle) {

            console.log(baseplans)
            var filtered_base_plans = baseplans



            //this.consoleMessage(filtered_base_plans);

            //this.consoleMessage(filtered_compnay_plans)
            let selectedBasePlan;
            let selectedCompnayPlan;
            let DeltaPlan;
            let selectedBaseplanProduct: any;
            let selectedBaseplanProductsArray = [];
            let selectedCompanyplanProduct: any;
            let selectedCompanyplanProductsArray: any = [];

            //console.log("length" + filtered_base_plans.length)

            selectedBasePlan = filtered_base_plans[0];

            console.log(selectedBasePlan)

            if (selectedBasePlan) {
              // //this.consoleMessage(selectedBasePlan)
              // selectedBaseplanProduct = selectedBasePlan.productAddonss[selectedBasePlan.name][0]
              selectedBaseplanProductsArray = [selectedBasePlan];
              let selectedBaseplanProductsArray2 = [];
              //  //this.consoleMessage(CCplan.packageId)
              if (CPplan.packageId == 5 || CPplan.packageId == 10) {

                // selectedBaseplanProductsArray2 = selectedBaseplanProductsArray
                // for (let i = 0; i < selectedCPplanProductarray.length - selectedBaseplanProductsArray.length; i++) {
                //   selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[selectedBaseplanProductsArray.length - 1]);
                // }
                // // //this.consoleMessage(selectedBaseplanProductsArray)
                // selectedBaseplanProductsArray = selectedBaseplanProductsArray2
                // //this.consoleMessage(selectedBaseplanProductsArray)
              }
              else {

                // Direct Coverage Method

                // selectedBaseplanProductsArray =this.DirectCoverageMethod(selectedCCplanProductarray,selectedBaseplanProductsArray)


                // Selective single Coverage Method

                //  selectedBaseplanProductsArray =this.selectiveSingleCoverageMethod(selectedCCplanProductarray,selectedBaseplanProductsArray)

                // Selective Couple Coverage Method
                if (selectedCoverage != "DIRECT") {
                  selectedBaseplanProductsArray = this.selectiveCPCoverageMethod(selectedCPplanProductarray, selectedBaseplanProductsArray, selectedCoverage)
                }
                //  // Selective Family Coverage Method


              }
            }
            else {
              selectedBasePlan = {};
              selectedBaseplanProduct = {};
              selectedBaseplanProduct.calculatedTax = {};
              selectedBaseplanProduct.calculatedTax.price = 0;
              selectedBaseplanProduct.calculatedTax.tax = 0;
              selectedBaseplanProduct.calculatedTax.total = 0;
              selectedBaseplanProduct.name = "NA";

              for (let i = 0; i < selectedCPplanProductarray.length; i++) {
                selectedBaseplanProductsArray.push(selectedBaseplanProduct);
              }
            }



            let upgradeText;
            let upgradepaymentText;
            if (payroll) {
              upgradeText = "Employee upgraded using payroll deduction";
              upgradepaymentText = "using payroll deduction";
              //this.consoleMessage("One subscription to parent/corp with base(company tax)+Delta(employee tax)")
            } else {
              upgradeText = "Employee upgraded using Direct payment";
              upgradepaymentText = "using Direct payment";
            }

            modifiedCPplan.products = []

            for (let i = 0; i < selectedCPplanProductarray.length; i++) {
              let selectedBaseplanProduct = selectedBaseplanProductsArray[i];
              console.log(selectedBaseplanProduct)
              let selectedCPplanProduct = selectedCPplanProductarray[i];
              console.log(selectedCPplanProduct)
              let coverage = selectedCPplanProduct.planCoverage

              console.log(coverage)
              if (selectedCoverage == coverage) {

                modifiedCPplan.products.push(selectedCPplanProduct)
                continue;
              }

              console.log(selectedCPplanProduct)
              let selectedCompanyplanProduct =
                selectedCompanyplanProductsArray[i];

              let companyTax;
              let companyTaxPercentage;
              let employeeTax;
              let employeeTaxPercentage;

              if (selectedBaseplanProduct) {
                companyTax =
                  selectedBaseplanProduct?.calculatedTax?.planProductInfos.length > 0
                    ? selectedBaseplanProduct.calculatedTax.planProductInfos[0]
                      .taxRate
                    : 0;
                companyTaxPercentage =
                  selectedBaseplanProduct?.calculatedTax?.planProductInfos.length > 0
                    ? selectedBaseplanProduct.calculatedTax.planProductInfos[0]
                      .taxRatePercentage
                    : 0;
                employeeTax =
                  selectedBaseplanProduct?.calculatedTax?.planProductInfos.length > 0
                    ? selectedBaseplanProduct.calculatedTax.planProductInfos[0]
                      .taxRate
                    : 0;
                employeeTaxPercentage =
                  selectedBaseplanProduct?.calculatedTax?.planProductInfos.length > 0
                    ? selectedBaseplanProduct.calculatedTax.planProductInfos[0]
                      .taxRatePercentage
                    : 0;
              } else {
                companyTax =
                  selectedCPplanProduct?.calculatedTax?.planProductInfos.length > 0
                    ? selectedCPplanProduct.calculatedTax.planProductInfos[0]
                      .taxRate
                    : 0;
                companyTaxPercentage =
                  selectedCPplanProduct?.calculatedTax?.planProductInfos.length > 0
                    ? selectedCPplanProduct.calculatedTax.planProductInfos[0]
                      .taxRatePercentage
                    : 0;
                employeeTax =
                  selectedCPplanProduct?.calculatedTax?.planProductInfos.length > 0
                    ? selectedCPplanProduct.calculatedTax.planProductInfos[0]
                      .taxRate
                    : 0;
                employeeTaxPercentage =
                  selectedCPplanProduct?.calculatedTax?.planProductInfos.length > 0
                    ? selectedCPplanProduct.calculatedTax.planProductInfos[0]
                      .taxRatePercentage
                    : 0;
              }




              let baseplanPrice = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.price
              );
              let baseplanTaxorg = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.tax
              );
              let baseplanTax = adjustWith2DecimalsForUI(
                baseplanPrice * companyTax
              );
              let baseplanTotalorg = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.total
              );
              let baseplanTotal = adjustWith2DecimalsForUI(
                baseplanPrice + baseplanTax
              );



              console.log(selectedCPplanProduct)

              let deltaplanPrice = adjustWith2DecimalsForUI(
                selectedCPplanProduct?.calculatedTax?.price -
                selectedBaseplanProduct?.calculatedTax?.price
              );
              console.log(deltaplanPrice)


              //console.log(selectedBaseplanProduct.calculatedTax.price)

              if (selectedBaseplanProduct.name == 'NA') {
                //this.consoleMessage("No Base plan/product for this upgrade plans/product")
                companyTax = employeeTax
                companyTaxPercentage = employeeTaxPercentage
              }
              //Delete plan Total Price and Total Combination
              if (deltaplanPrice <= 0) {
                deltaplanPrice = 0
                /*      baseplanPrice = adjustWith2DecimalsForUI(
                      selectedCPplanProduct.calculatedTax.price
                    );
                     baseplanTaxorg = adjustWith2DecimalsForUI(
                      selectedCPplanProduct.calculatedTax.tax
                    );
                     baseplanTax = adjustWith2DecimalsForUI(
                      baseplanPrice * companyTax
                    );
                     baseplanTotalorg = adjustWith2DecimalsForUI(
                      selectedCPplanProduct.calculatedTax.total
                    );
                     baseplanTotal = adjustWith2DecimalsForUI(
                      baseplanPrice + baseplanTax
                    ); */

                modifiedCPplan.products.push(selectedCPplanProduct)
                continue;

              }


              // let deltaplanTax = adjustWith2DecimalsForUI(
              //   deltaplanPrice *
              //   (this.deltaCompanyTax ? companyTax : employeeTax)
              // );
              let deltaplanTax = adjustWith2DecimalsForUI(deltaplanPrice * employeeTax);
              let deltaplanTotal = adjustWith2DecimalsForUI(
                deltaplanPrice + deltaplanTax
              );
              let combinedplanPrice = adjustWith2DecimalsForUI(
                baseplanPrice + deltaplanPrice
              );
              let combinedplanbasePrice = baseplanPrice;
              let combinedplanDeltaprice = deltaplanPrice;
              let combinedplanTax = adjustWith2DecimalsForUI(
                baseplanTax + deltaplanTax
              );
              let combinedplanCompanyTax = baseplanTax;
              let combinedplanEmployeeTax =
                adjustWith2DecimalsForUI(deltaplanTax);
              let combinedplanCompanyTaxPercentage = companyTaxPercentage;
              let combinedplanemployeeTaxPercentage = this.deltaCompanyTax
                ? companyTaxPercentage
                : employeeTaxPercentage;
              let combinedplanemployeeTaxPercentageorg = employeeTaxPercentage;

              let combinedplanTotal = adjustWith2DecimalsForUI(
                baseplanTotal + deltaplanTotal
              );

              let scenario = `Employee Upgrade from ${selectedBasePlan.name}  (${selectedCoverage}) to ${CPplan.name}`;
              let planName = `${CPplan.name} (${this.capitalize(coverage)}) (${upgradeText})`;
              let compnayShareStatement = `${CPplan.name} (${this.capitalize(selectedCoverage)})  Contribution`;
              let employeeShareStatement = `${CPplan.name} (${this.capitalize(coverage)}) upgrade cost`;
              let planDescription = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanTotal} and Employee- pays ${upgradepaymentText} ${deltaplanTotal} `;
              let planDescription2 = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanPrice}(with tax:${companyTaxPercentage}) and Employee- pays ${upgradepaymentText} ${deltaplanPrice}(with tax:${employeeTaxPercentage}) `;
              let type;

              if (payroll) {
                type = "Split with payroll deduction";
              } else {
                type = "Split with direct pay";
              }
              let basePlanDetails = {
                planId: selectedBasePlan.id, //0
                planName: selectedBasePlan.name, //NA
                planLevelId: selectedBasePlan.planLevel, //0
                amount: baseplanPrice, //0
                amountUI: `$${baseplanPrice}`, //0
                tax: baseplanTax,
                total: baseplanTotal,
                taxUI: `$${baseplanTax}`, //companyTaxpercentage
                totalUI: `$${baseplanTotal}`,
                planLevelName: selectedBasePlan.groupName || "", //if it is Bundle
                planFrequencyID: selectedBasePlan.frqMonthly || "",
                planFusebillID: selectedBasePlan.fusebillId || "",
                products: [selectedBaseplanProduct],
                planLevel_parentId: selectedBasePlan.planLevel_parentId,
                packageName: selectedBasePlan.packageName,
                packageId: selectedBasePlan.packageId,
              };





              let obj = {
                companyTax,
                companyTaxPercentage,
                baseplanPrice,
                baseplanTaxorg,
                baseplanTax,
                baseplanTotalorg,
                baseplanTotal,
                employeeTax,
                employeeTaxPercentage,
                deltaplanPrice,
                deltaplanTax,
                deltaplanTotal,
                combinedplanPrice,
                combinedplanbasePrice,
                combinedplanDeltaprice,
                combinedplanTax,
                combinedplanCompanyTax,
                combinedplanEmployeeTax,
                combinedplanCompanyTaxPercentage,
                combinedplanemployeeTaxPercentage,
                combinedplanTotal,
                payroll,
                scenario,
                planName,
                compnayShareStatement,
                employeeShareStatement,
                planDescription,
                planDescription2,
                type,
                basePlanDetails,
                combinedplanemployeeTaxPercentageorg,
                coverage,
                selectedCoverage
              };

              //this.consoleMessage(obj)

              //console.log(selectedCoverage)
              //console.log(coverage)

              //console.log(obj)
              let cpProduct: any = {}
              cpProduct.upgradeCalculation = obj;
              modifiedCPplan.products.push(cpProduct)
              // modifiedCPplan.upgradeCalculation = obj;

              // if(selectedCoverage == coverage){

              // }else{
              //   cpProduct.upgradeCalculation = obj;
              //   modifiedCPplan.products.push(cpProduct)
              // }

              //console.log(modifiedCPplan)
            }

          }
          else {
            //this.consoleMessage("Not a BundlePlan")

            //this.consoleMessage(baseplans)



            filtered_base_plans = baseplans

            let selectedBasePlan;
            let selectedCompnayPlan;
            let DeltaPlan;
            //console.log("length" + filtered_base_plans.length)
            if (filtered_base_plans.length == 0) {
            } else if (filtered_base_plans.length == 0) {
              selectedBasePlan = filtered_base_plans[0];
            } else {
              //this.consoleMessage(filtered_base_plans.length)
            }

            let selectedbaseplanproduct: any;
            let selectedBaseplanProduct: any;

            if (selectedBasePlan) {
              for (let planname in selectedBasePlan.productAddonss) {
                //this.consoleMessage(planname)
                //this.consoleMessage(selectedBasePlan.productAddonss[planname])
                let products = selectedBasePlan.productAddonss[planname];
                //console.log("length" + products.length)
                if (products.length == 0) {
                } else if (products.length == 1) {
                  selectedbaseplanproduct = products[0];
                  // selectedCompnayPlan= filtered_compnay_plans[0]
                } else {
                  //this.consoleMessage(products.length)
                }
              }
              //this.consoleMessage(selectedbaseplanproduct)
              selectedBaseplanProduct = selectedbaseplanproduct;

            } else {
              selectedBasePlan = {};
              selectedBaseplanProduct = {};
              selectedBaseplanProduct.calculatedTax = {};
              selectedBaseplanProduct.calculatedTax.price = 0;
              selectedBaseplanProduct.calculatedTax.tax = 0;
              selectedBaseplanProduct.calculatedTax.total = 0;
              selectedBaseplanProduct.name = "NA";
            }

            let CCplanProduct;

            for (let planname in CPplan.productAddonss) {
              let products = CPplan.productAddonss[planname];
              //console.log("length" + products.length)

              if (products.length == 0) {
              } else if (products.length == 1) {
                CCplanProduct = products[0];
                // selectedCompnayPlan= filtered_compnay_plans[0]
              } else {
                //this.consoleMessage(products.length)
              }
            }
            let selectedCCplanProduct = CCplanProduct;


            let selectedcompanyplanproduct: any;
            let selectedCompanyplanProduct: any;

            if (selectedCompnayPlan) {

              let upgradeText;
              let upgradepaymentText;
              if (payroll) {
                upgradeText = "Employee upgraded using payroll deduction";
                upgradepaymentText = "using payroll deduction";
                //this.consoleMessage("One subscription to parent/corp with base(company tax)+Delta(employee tax)")
              } else {
                upgradeText = "Employee upgraded using Direct payment";
                upgradepaymentText = "using Direct payment";
              }
              let companyTax =
                selectedCompanyplanProduct.calculatedTax.planProductInfos.length >
                  0
                  ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
                    .taxRate
                  : 0;
              let companyTaxPercentage =
                selectedCompanyplanProduct.calculatedTax.planProductInfos.length >
                  0
                  ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
                    .taxRatePercentage
                  : 0;
              let baseplanPrice = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.price
              );
              let baseplanTaxorg = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.tax
              );
              let baseplanTax = adjustWith2DecimalsForUI(
                baseplanPrice * companyTax
              );
              let baseplanTotalorg = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.total
              );
              let baseplanTotal = adjustWith2DecimalsForUI(
                baseplanPrice + baseplanTax
              );
              let coverage = selectedCCplanProduct.planCoverage
              let employeeTax =
                selectedCCplanProduct.calculatedTax.planProductInfos.length > 0
                  ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
                    .taxRate
                  : 0;
              let employeeTaxPercentage =
                selectedCCplanProduct.calculatedTax.planProductInfos.length > 0
                  ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
                    .taxRatePercentage
                  : 0;

              let deltaplanPrice = adjustWith2DecimalsForUI(
                selectedCCplanProduct.calculatedTax.price -
                selectedBaseplanProduct.calculatedTax.price
              );

              //this.consoleMessage(selectedCCplanProduct.calculatedTax.price)
              //this.consoleMessage(selectedBaseplanProduct.calculatedTax.price)
              //this.consoleMessage(selectedCCplanProduct.calculatedTax.price -selectedBaseplanProduct.calculatedTax.price)
              if (selectedBaseplanProduct.name == 'NA') {
                //this.consoleMessage("No Base plan/product for this upgrade plans/product")
                companyTax = employeeTax
                companyTaxPercentage = employeeTaxPercentage
              }
              // let deltaplanTax = adjustWith2DecimalsForUI(
              //   deltaplanPrice * (this.deltaCompanyTax ? companyTax : employeeTax)
              // );
              let deltaplanTax = adjustWith2DecimalsForUI(deltaplanPrice * employeeTax);
              // let deltaplanTax = deltaplanPrice*(this.deltaCompanyTax?companyTax:employeeTax)

              let deltaplanTotal = adjustWith2DecimalsForUI(
                deltaplanPrice + deltaplanTax
              );

              let combinedplanPrice = baseplanPrice + deltaplanPrice;
              let combinedplanbasePrice = baseplanPrice;
              let combinedplanDeltaprice = deltaplanPrice;
              let combinedplanTax = adjustWith2DecimalsForUI(
                baseplanTax + deltaplanTax
              );
              let combinedplanCompanyTax = baseplanTax;
              let combinedplanEmployeeTax =
                adjustWith2DecimalsForUI(deltaplanTax);
              let combinedplanCompanyTaxPercentage = companyTaxPercentage;
              let combinedplanemployeeTaxPercentage = this.deltaCompanyTax
                ? companyTaxPercentage
                : employeeTaxPercentage;
              let combinedplanemployeeTaxPercentageorg = employeeTaxPercentage;
              let combinedplanTotal = adjustWith2DecimalsForUI(
                baseplanTotal + deltaplanTotal
              );

              let scenario = `Employee Upgrade from ${selectedBaseplanProduct.name} to ${selectedCCplanProduct.name}`;
              let planName = `${CPplan.name}(${selectedCCplanProduct.name}) (${upgradeText})`;
              let compnayShareStatement = `${CPplan.name}(${selectedCCplanProduct.name}) Contribution`;
              let employeeShareStatement = `${CPplan.name}(${selectedCCplanProduct.name}) upgrade cost`;
              let planDescription = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanTotal} and Employee- pays ${upgradepaymentText} ${deltaplanTotal} `;
              let planDescription2 = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanPrice}(with tax:${companyTaxPercentage}) and Employee- pays ${upgradepaymentText} ${deltaplanPrice}(with tax:${employeeTaxPercentage}) `;
              let type;

              if (payroll) {
                type = "Split with payroll deduction";
              } else {
                type = "Split with direct pay";
              }
              let basePlanDetails = {
                planId: selectedBasePlan.id || 0, //0
                planName: selectedBasePlan.name || "NA", //NA
                planLevelId: selectedBasePlan.planLevel || 0, //0
                amount: baseplanPrice || 0, //0
                amountUI: `$${baseplanPrice}` || 0, //0
                tax: baseplanTax,
                total: baseplanTotal,
                taxUI: `$${baseplanTax}`, //companyTaxpercentage
                totalUI: `$${baseplanTotal}`,
                planLevelName: selectedBasePlan.groupName || "", //if it is Bundle
                planFrequencyID: selectedBasePlan.frqMonthly || "",
                planFusebillID: selectedBasePlan.fusebillId || "",
                products: [selectedBaseplanProduct],
                planLevel_parentId: selectedBasePlan.planLevel_parentId || 0,
                packageName: selectedBasePlan.packageName || "",
                packageId: selectedBasePlan.packageId || 0,
              };
              let obj = {
                companyTax,
                companyTaxPercentage,
                baseplanPrice,
                baseplanTaxorg,
                baseplanTax,
                baseplanTotalorg,
                baseplanTotal,
                employeeTax,
                employeeTaxPercentage,
                deltaplanPrice,
                deltaplanTax,
                deltaplanTotal,
                combinedplanPrice,
                combinedplanbasePrice,
                combinedplanDeltaprice,
                combinedplanTax,
                combinedplanCompanyTax,
                combinedplanEmployeeTax,
                combinedplanCompanyTaxPercentage,
                combinedplanemployeeTaxPercentage,
                combinedplanTotal,
                payroll,
                scenario,
                planName,
                compnayShareStatement,
                employeeShareStatement,
                planDescription,
                planDescription2,
                type,
                basePlanDetails,
                combinedplanemployeeTaxPercentageorg,
                coverage
              };

              //this.consoleMessage(obj)
              // modifiedCPplan.upgradeCalculation = obj;
            }
          }
          modifiedCPgroup.plans.push(modifiedCPplan);

          modifiedCPPackage.groupsCP.push(modifiedCPgroup);
        }
        //console.log(modifiedCPPackage)
        modifiedCPplanPackages.push(modifiedCPPackage);
      }

      this.modifiedBlocksPaidByCompany = modifiedCPplanPackages;

      console.log(this.modifiedBlocksPaidByCompany)

      //this.consoleMessage(this.modifiedBlocksCoveredByCompany)
    }
  }
  public DirectCoverageMethod(selectedCCplanProductarray: any, selectedBaseplanProductsArray: any) {

    //console.log("DirectCoveragemETHOD")
    let productCoverageFound = false;
    let selectedBaseplanProductsArray2 = []
    let selectedBasePlan = {};
    let selectedBaseplanProduct: any;
    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      for (let j = 0; j < selectedBaseplanProductsArray.length; j++) {

        //console.log(selectedCCplanProductarray[i])
        //console.log(selectedBaseplanProductsArray[j])

        if (selectedCCplanProductarray[i].planCoverage == selectedBaseplanProductsArray[j].planCoverage) {
          productCoverageFound = true
          selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[j])
          break;
        }


      }
      if (!productCoverageFound) {


        //console.log("ElseDirectCoveragemETHOD")
        selectedBasePlan = {};
        selectedBaseplanProduct = {};
        selectedBaseplanProduct.calculatedTax = {};
        selectedBaseplanProduct.calculatedTax.price = 0;
        selectedBaseplanProduct.calculatedTax.tax = 0;
        selectedBaseplanProduct.calculatedTax.total = 0;
        selectedBaseplanProduct.name = "NA";
        selectedBaseplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
        selectedBaseplanProductsArray2.push(selectedBaseplanProduct);



      }

    }
    //this.consoleMessage(selectedBaseplanProductsArray)

    //console.log(selectedBaseplanProductsArray2)
    selectedBaseplanProductsArray = selectedBaseplanProductsArray2

    return selectedBaseplanProductsArray
  }

  public selectiveSingleCoverageMethod(selectedCCplanProductarray: any, selectedBaseplanProductsArray: any) {
    let productCoverageFound = false;
    let selectedBaseplanProductsArray2 = []
    let selectedBasePlan = {};
    let selectedBaseplanProduct: any;

    //console.log(selectedBaseplanProductsArray)
    selectedBaseplanProductsArray = selectedBaseplanProductsArray.filter((bb: any) => { return bb.planCoverage == 'SINGLE' })
    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      for (let j = 0; j < selectedBaseplanProductsArray.length; j++) {
        productCoverageFound = true
        //console.log(selectedBaseplanProductsArray[j])
        selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[j])
        break;
        // if (selectedCCplanProductarray[i].planCoverage == selectedBaseplanProductsArray[j].planCoverage) {
        //   productCoverageFound = true
        //   selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[j])
        //   break;
        // }


      }
      if (!productCoverageFound) {



        selectedBasePlan = {};
        selectedBaseplanProduct = {};
        selectedBaseplanProduct.calculatedTax = {};
        selectedBaseplanProduct.calculatedTax.price = 0;
        selectedBaseplanProduct.calculatedTax.tax = 0;
        selectedBaseplanProduct.calculatedTax.total = 0;
        selectedBaseplanProduct.name = "NA";
        selectedBaseplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
        selectedBaseplanProductsArray2.push(selectedBaseplanProduct);



      }

    }
    //this.consoleMessage(selectedBaseplanProductsArray)

    //console.log(selectedBaseplanProductsArray2)
    selectedBaseplanProductsArray = selectedBaseplanProductsArray2

    return selectedBaseplanProductsArray
  }

  public selectiveCoupleCoverageMethod(selectedCCplanProductarray: any, selectedBaseplanProductsArray: any) {
    let productCoverageFound = false;
    let selectedBaseplanProductsArray2 = []
    let selectedBasePlan = {};
    let selectedBaseplanProduct: any;
    selectedBaseplanProductsArray = selectedBaseplanProductsArray.filter((bb: any) => { return bb.planCoverage == 'COUPLE' })
    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      for (let j = 0; j < selectedBaseplanProductsArray.length; j++) {
        productCoverageFound = true
        selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[j])
        break;


      }
      if (!productCoverageFound) {



        selectedBasePlan = {};
        selectedBaseplanProduct = {};
        selectedBaseplanProduct.calculatedTax = {};
        selectedBaseplanProduct.calculatedTax.price = 0;
        selectedBaseplanProduct.calculatedTax.tax = 0;
        selectedBaseplanProduct.calculatedTax.total = 0;
        selectedBaseplanProduct.name = "NA";
        selectedBaseplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
        selectedBaseplanProductsArray2.push(selectedBaseplanProduct);



      }

    }
    //this.consoleMessage(selectedBaseplanProductsArray)
    selectedBaseplanProductsArray = selectedBaseplanProductsArray2

    return selectedBaseplanProductsArray
  }

  public selectiveFamilyCoverageMethod(selectedCCplanProductarray: any, selectedBaseplanProductsArray: any) {
    let productCoverageFound = false;
    let selectedBaseplanProductsArray2 = []
    let selectedBasePlan = {};
    let selectedBaseplanProduct: any;
    selectedBaseplanProductsArray = selectedBaseplanProductsArray.filter((bb: any) => { return bb.planCoverage == 'FAMILY' })
    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      for (let j = 0; j < selectedBaseplanProductsArray.length; j++) {
        productCoverageFound = true
        selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[j])
        break;


      }
      if (!productCoverageFound) {



        selectedBasePlan = {};
        selectedBaseplanProduct = {};
        selectedBaseplanProduct.calculatedTax = {};
        selectedBaseplanProduct.calculatedTax.price = 0;
        selectedBaseplanProduct.calculatedTax.tax = 0;
        selectedBaseplanProduct.calculatedTax.total = 0;
        selectedBaseplanProduct.name = "NA";
        selectedBaseplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
        selectedBaseplanProductsArray2.push(selectedBaseplanProduct);



      }

    }
    //this.consoleMessage(selectedBaseplanProductsArray)
    selectedBaseplanProductsArray = selectedBaseplanProductsArray2

    return selectedBaseplanProductsArray
  }
  public selectiveCPCoverageMethod(selectedCCplanProductarray: any, selectedBaseplanProductsArray: any, selectedCoverage: any) {
    let productCoverageFound = false;
    let selectedBaseplanProductsArray2 = []
    let selectedBasePlan = {};
    let selectedBaseplanProduct: any;
    selectedBaseplanProductsArray = selectedBaseplanProductsArray.filter((bb: any) => { return bb.planCoverage == selectedCoverage })
    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      for (let j = 0; j < selectedBaseplanProductsArray.length; j++) {
        productCoverageFound = true
        selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[j])
        break;


      }
      if (!productCoverageFound) {



        selectedBasePlan = {};
        selectedBaseplanProduct = {};
        selectedBaseplanProduct.calculatedTax = {};
        selectedBaseplanProduct.calculatedTax.price = 0;
        selectedBaseplanProduct.calculatedTax.tax = 0;
        selectedBaseplanProduct.calculatedTax.total = 0;
        selectedBaseplanProduct.name = "NA";
        selectedBaseplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
        selectedBaseplanProductsArray2.push(selectedBaseplanProduct);



      }

    }
    //this.consoleMessage(selectedBaseplanProductsArray)
    selectedBaseplanProductsArray = selectedBaseplanProductsArray2

    return selectedBaseplanProductsArray
  }
  public CompanyDirectCoverageMethod(selectedCCplanProductarray: any, selectedCompanyplanProductsArray: any) {

    //console.log("DirectCoveragemETHOD")
    let productCoverageFound = false;
    let selectedCompanyplanProductsArray2 = []
    let selectedBasePlan = {};
    let selectedCompanyplanProduct: any;



    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      for (let j = 0; j < selectedCompanyplanProductsArray.length; j++) {

        if (selectedCCplanProductarray[i].planCoverage == selectedCompanyplanProductsArray[j].planCoverage) {
          productCoverageFound = true
          selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray[j])
          break;
        }


      }
      if (!productCoverageFound) {


        selectedCompanyplanProduct = {};
        selectedCompanyplanProduct.calculatedTax = {};
        selectedCompanyplanProduct.calculatedTax.planProductInfos = [];
        selectedCompanyplanProduct.name = "NA";
        selectedCompanyplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
        selectedCompanyplanProductsArray2.push(selectedCompanyplanProduct);



      }

    }
    selectedCompanyplanProductsArray = selectedCompanyplanProductsArray2

    return selectedCompanyplanProductsArray
  }

  public CompanyselectiveSingleCoverageMethod(selectedCCplanProductarray: any, selectedCompanyplanProductsArray: any) {
    let productCoverageFound = false;
    let selectedCompanyplanProductsArray2 = []
    let selectedBasePlan = {};
    let selectedCompanyplanProduct: any;
    selectedCompanyplanProductsArray = selectedCompanyplanProductsArray.filter((bb: any) => { return bb.planCoverage == 'SINGLE' })
    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      for (let j = 0; j < selectedCompanyplanProductsArray.length; j++) {

        productCoverageFound = true
        selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray[j])
        break;
        // if (selectedCCplanProductarray[i].planCoverage == selectedCompanyplanProductsArray[j].planCoverage) {
        //   productCoverageFound = true
        //   selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray[j])
        //   break;
        // }


      }
      if (!productCoverageFound) {


        selectedCompanyplanProduct = {};
        selectedCompanyplanProduct.calculatedTax = {};
        selectedCompanyplanProduct.calculatedTax.planProductInfos = [];
        selectedCompanyplanProduct.name = "NA";
        selectedCompanyplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
        selectedCompanyplanProductsArray2.push(selectedCompanyplanProduct);



      }

    }
    selectedCompanyplanProductsArray = selectedCompanyplanProductsArray2

    return selectedCompanyplanProductsArray
  }

  public CompanyselectiveCoupleCoverageMethod(selectedCCplanProductarray: any, selectedCompanyplanProductsArray: any) {
    let productCoverageFound = false;
    let selectedCompanyplanProductsArray2 = []
    let selectedBasePlan = {};
    let selectedCompanyplanProduct: any;
    selectedCompanyplanProductsArray = selectedCompanyplanProductsArray.filter((bb: any) => { return bb.planCoverage == 'COUPLE' })
    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      for (let j = 0; j < selectedCompanyplanProductsArray.length; j++) {

        productCoverageFound = true
        selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray[j])
        break;
        // if (selectedCCplanProductarray[i].planCoverage == selectedCompanyplanProductsArray[j].planCoverage) {
        //   productCoverageFound = true
        //   selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray[j])
        //   break;
        // }


      }
      if (!productCoverageFound) {


        selectedCompanyplanProduct = {};
        selectedCompanyplanProduct.calculatedTax = {};
        selectedCompanyplanProduct.calculatedTax.planProductInfos = [];
        selectedCompanyplanProduct.name = "NA";
        selectedCompanyplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
        selectedCompanyplanProductsArray2.push(selectedCompanyplanProduct);



      }

    }
    selectedCompanyplanProductsArray = selectedCompanyplanProductsArray2

    return selectedCompanyplanProductsArray
  }
  public CompanyselectiveFamilyCoverageMethod(selectedCCplanProductarray: any, selectedCompanyplanProductsArray: any) {
    let productCoverageFound = false;
    let selectedCompanyplanProductsArray2 = []
    let selectedBasePlan = {};
    let selectedCompanyplanProduct: any;
    selectedCompanyplanProductsArray = selectedCompanyplanProductsArray.filter((bb: any) => { return bb.planCoverage == 'FAMILY' })
    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      for (let j = 0; j < selectedCompanyplanProductsArray.length; j++) {

        productCoverageFound = true
        selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray[j])
        break;
        // if (selectedCCplanProductarray[i].planCoverage == selectedCompanyplanProductsArray[j].planCoverage) {
        //   productCoverageFound = true
        //   selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray[j])
        //   break;
        // }


      }
      if (!productCoverageFound) {


        selectedCompanyplanProduct = {};
        selectedCompanyplanProduct.calculatedTax = {};
        selectedCompanyplanProduct.calculatedTax.planProductInfos = [];
        selectedCompanyplanProduct.name = "NA";
        selectedCompanyplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
        selectedCompanyplanProductsArray2.push(selectedCompanyplanProduct);



      }

    }
    selectedCompanyplanProductsArray = selectedCompanyplanProductsArray2

    return selectedCompanyplanProductsArray
  }
  cobminedcommonfunction(cpPackages: any, ccPackages: any, epPackages: any) {

    // //console.log(cpPackages)
    let commonPackages: any = {};
    if (cpPackages) {
      for (let cpPackage of cpPackages) {
        let pckg = cpPackage;
        pckg.groups = pckg.groupsCP;

        if (commonPackages && commonPackages[pckg.id]) {
          commonPackages[pckg.id].groups.push(pckg.groupsCP);
        } else {
          commonPackages[pckg.id] = pckg;
        }
      }
    }
    //this.consoleMessage(commonPackages)
    if (ccPackages) {
      for (let ccPackage of ccPackages) {
        let pckg = ccPackage;
        //this.consoleMessage(pckg)
        pckg.groups = pckg.groupsCC;

        //this.consoleMessage(pckg.groups)
        //this.consoleMessage(pckg.groupsCC)

        if (commonPackages && commonPackages[pckg.id]) {
          //this.consoleMessage(commonPackages[pckg.id])
          commonPackages[pckg.id].groups = commonPackages[pckg.id].groups.concat(
            pckg.groupsCC
          );
        } else {
          commonPackages[pckg.id] = pckg;
        }
      }
    }
    if (epPackages) {
      for (let epPackage of epPackages) {
        let pckg = epPackage;
        pckg.groups = pckg.groupsEP;

        if (commonPackages && commonPackages[pckg.id]) {
          commonPackages[pckg.id].groups = commonPackages[pckg.id].groups.concat(
            pckg.groupsEP
          );
        } else {
          commonPackages[pckg.id] = pckg;
        }
      }
    }

    return commonPackages;


  }


  public onCheckboxChange(
    e: any,
    allow_multiple: any,
    disallowedPlanLevels: any,
    options: any,
    pname: any,
    groupname: any,
    plancoverage: any,
    planprice: any,
    gst: any,
    hst: any,
    pst: any,
    event: any,
    event1: any,
    packageindex: any,
    groupindex: any,
    planindex: any,
    plan: any,
    product: any,
    pckage: any,
    group: any
  ) {
    // let multiple = allow_multiple ? Boolean(allow_multiple.data[0]) : false;
    let multiple = allow_multiple == true ? true : false;


    if (e.target.checked) {
      //unselect all checkboxes with same id(fix for single.couple and family multiple seelction)



      const dom: HTMLElement = this.elementRef.nativeElement;

      const samePlanIdElements = dom.querySelectorAll('#' + e.target.id);
      //console.log(samePlanIdElements)
      let targetClassName = 'cp_plan'
      if (e.target.className.includes('cp_plan')) {
        targetClassName = 'cp_plan'
      }
      else if (e.target.className.includes('cc_plan')) {
        targetClassName = 'cc_plan'
      }
      else if (e.target.className.includes('ep_plan')) {
        targetClassName = 'ep_plan'
      }

      for (let i = 0; i < samePlanIdElements.length; i++) {
        let elem = samePlanIdElements[i];
        let element: any = elem;
        //console.log(elem)


        if (element.checked && element.className.includes(targetClassName)) {
          element.checked = false;
          element.disabled = false;  //need to change here for flex bronze disabled
          this.unselectplan1(elem, options, plan, product, pckage, group, planindex, disallowedPlanLevels);

        }
      }
      e.target.checked = true

    } else {

    }



    //console.log(disallowedPlanLevels)
    if (disallowedPlanLevels != null) {
      let disallowed_plans = disallowedPlanLevels.split(",");
      //console.log(disallowed_plans)
      const dom1: HTMLElement = this.elementRef.nativeElement;
      const disallowed_elements = dom1.querySelectorAll(
        ".plansscreen input[type='checkbox']"
      );

      // disallowed_elements.forEach((elem: any) => {

      for (let i = 0; i < disallowed_elements.length; i++) {
        let elem: any = disallowed_elements[i];
        // elementcv.checked=false

        let plandetails = elem.attributes.data.value;

        let plandetailsobj = plandetails.split("##");

        //this.consoleMessage("main", plandetailsobj);
        let isBundle = plandetailsobj[21] == "true" ? true : false
        if (e.target.checked) {
          if (!elem.disabled) {

            if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                  //  elem.checked=false
                  elem.disabled = true;
                  this.disabledelement =
                    'Already included in GroupBenefitz All-In';
                }
              } else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  //  elem.checked=false
                  elem.disabled = true;
                  this.disabledelement =
                    'Already included in GroupBenefitz All-In';
                }
              }

            } else {

              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {

                  elem.disabled = true;

                  this.disabledelement =
                    'Already included in GroupBenefitz All-In';
                }
              } else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {

                  elem.disabled = true;

                  this.disabledelement =
                    'Already included in GroupBenefitz All-In';
                }
              }

            }
          }
          if (elem.checked) {

            if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                  elem.checked = false;
                  this.unselectplan1(elem, options, plan, product, pckage, group, planindex, disallowedPlanLevels);
                }

              }
              else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  elem.checked = false;
                  this.unselectplan1(elem, options, plan, product, pckage, group, planindex, disallowedPlanLevels);
                }
              }
            } else {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {
                  elem.checked = false;
                  this.unselectplan1(elem, options, plan, product, pckage, group, planindex, disallowedPlanLevels);
                  // elem.disabled =true
                }
              }
              else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  elem.checked = false;
                  this.unselectplan1(elem, options, plan, product, pckage, group, planindex, disallowedPlanLevels);
                  // elem.disabled =true
                }
              }

            }
          }
        }
        else {
          if (elem.disabled) {
            if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                  //  elem.checked=false
                  elem.disabled = false;
                }
              } else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  //  elem.checked=false
                  elem.disabled = false;
                }
              }
            }
            if (isBundle) {
              if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {

                elem.disabled = false;

                this.disabledelement =
                  'Already included in GroupBenefitz All-In';
              }
            } else {
              if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {

                elem.disabled = false;

                this.disabledelement =
                  'Already included in GroupBenefitz All-In';
              }
            }

            // else {
            //   if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {
            //     //  elem.checked=false
            //     elem.disabled = false;
            //   }
            // }
          }


          if (elem.checked) {

            if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                  elem.checked = false;
                  this.unselectplan1(elem, options, plan, product, pckage, group, planindex, disallowedPlanLevels);
                }

              }
              else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  elem.checked = false;
                  this.unselectplan1(elem, options, plan, product, pckage, group, planindex, disallowedPlanLevels);
                }
              }
            } else {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {
                  elem.checked = false;
                  this.unselectplan1(elem, options, plan, product, pckage, group, planindex, disallowedPlanLevels);
                  // elem.disabled =true
                }
              }
              else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  elem.checked = false;
                  this.unselectplan1(elem, options, plan, product, pckage, group, planindex, disallowedPlanLevels);
                  // elem.disabled =true
                }
              }

            }
          }
        }


      }
    }





    //////this.consoleMessage(e)
    // //console.log(`newPlan${plan.id}`)

    let sameplanclassname = `newPlan${plan.id}`
    // //console.log(e.target.className)/////this.consoleMessage(e)
    let classname = e.target.className.replace(sameplanclassname, '');
    // //console.log(classname)
    classname = e.target.className.split(' ').join('.');
    // classname = classname.split(' ').join('.');

    // if (classname[0] != '.') {
    //   classname = `.${classname}`

    // }

    // if (classname[classname.length - 1] == '.') {
    //   classname = classname.substring(0, classname.length - 1);
    // }

    //console.log(classname)
    //console.log(sameplanclassname)
    // //////this.consoleMessage(classname)
    const dom: HTMLElement = this.elementRef.nativeElement;
    // const elements = dom.querySelectorAll('.' + classname);
    const elements = dom.querySelectorAll(classname);

    const samePlanElements = dom.querySelectorAll('.' + sameplanclassname);
    let element: any;
    let elementcv: any;

    if (!multiple) {
      if (e.target.checked) {
        for (let i = 0; i < elements.length; i++) {
          let elem = elements[i];
          element = elem;

          if (element.checked) {
            this.unselectplan1(elem, options, plan, product, pckage, group, planindex, disallowedPlanLevels);
            element.checked = false;
          }
        }

        e.checked = true;
        e.target.checked = true;
      } else {

      }
    } else {

      //console.log("elesehere")
      if (e.target.checked) {


        // for (let i = 0; i < samePlanElements.length; i++) {
        //   let elem = samePlanElements[i];
        //   element = elem;

        //   if (element.checked) {

        //     this.unselectplan(elem, options, plan, product, pckage, group,planindex);
        //     element.checked = false;
        //   }
        // }

        // e.checked = true;
        // e.target.checked = true;
      } else {
      }
      // alert("!")
      //no checking for other checkboxes you can selet multiple
    }
    setTimeout(() => {
      if (e.target.checked) {

        console.log(group)
        console.log(pckage)

        let removedisabledcompanypaidproductid: any = []
        let removedisabledcoveredpaidproductid: any = []
        let removedisabledemployedpaidproductid: any = []
        if (
          group.categorization.coveredByCompany == 1
          // ||
          // group.categorization.paidByEmployee == 1
        ) {

          pckage.groups.forEach((element: any) => {
            if (pckage.id != 5) {
              if (element.categorization.paidByCompany == 1 || element.categorization.paidByEmployee == 1) {
                element.plans.forEach((plan: any) => {
                  let pl = plan
                  Object.keys(plan.productAddonss).forEach((key) => {
                    plan.productAddonss[key].forEach((product: any) => {
                      if (pl.isBundle) {
                        removedisabledcompanypaidproductid.push(
                          pl
                        );
                      }
                      else {
                        removedisabledcompanypaidproductid.push(
                          // id: product.id,

                          product.planLevel,

                        );
                      }

                    });
                  });
                });
              }
            }
            else {
              if (group?.parentId == element?.parentId) {
                if (element.categorization.paidByCompany == 1 || element.categorization.paidByEmployee == 1) {
                  element.plans.forEach((plan: any) => {
                    let pl = plan
                    Object.keys(plan.productAddonss).forEach((key) => {
                      plan.productAddonss[key].forEach((product: any) => {
                        if (pl.isBundle) {
                          removedisabledcompanypaidproductid.push(
                            pl
                          );
                        }
                        else {
                          removedisabledcompanypaidproductid.push(
                            // id: product.id,

                            product.planLevel,

                          );
                        }

                      });
                    });
                  });
                }
              }
            }

          });
        } else {
        }

        if (
          group.categorization.paidByCompany == 1
          // ||
          // group.categorization.paidByEmployee == 1
        ) {

          pckage.groups.forEach((element: any) => {
            if (pckage.id != 5) {
              if (element.categorization.coveredByCompany == 1 || element.categorization.paidByEmployee == 1) {
                element.plans.forEach((plan: any) => {
                  let pl = plan
                  Object.keys(plan.productAddonss).forEach((key) => {
                    plan.productAddonss[key].forEach((product: any) => {
                      if (pl.isBundle) {
                        removedisabledcoveredpaidproductid.push(
                          pl,
                        );
                      }
                      else {
                        removedisabledcoveredpaidproductid.push(
                          // id: product.id,
                          product.planLevel,
                        );
                      }

                    });
                  });
                });
              }
            }
            else {
              if (group?.parentId == element?.parentId) {
                if (element.categorization.coveredByCompany == 1 || element.categorization.paidByEmployee == 1) {
                  element.plans.forEach((plan: any) => {
                    let pl = plan
                    Object.keys(plan.productAddonss).forEach((key) => {
                      plan.productAddonss[key].forEach((product: any) => {
                        if (pl.isBundle) {
                          removedisabledcoveredpaidproductid.push(
                            pl,
                          );
                        }
                        else {
                          removedisabledcoveredpaidproductid.push(
                            // id: product.id,
                            product.planLevel,
                          );
                        }

                      });
                    });
                  });
                }
              }
            }
          });
        } else {
        }

        if (
          group.categorization.paidByEmployee == 1
          // ||
          // group.categorization.paidByEmployee == 1
        ) {



          pckage.groups.forEach((element: any) => {
            //console.log(element)
            if (pckage.id != 5) {

              if (element.categorization.paidByCompany == 1 || element.categorization.coveredByCompany == 1) {
                element.plans.forEach((plan: any) => {
                  let pl = plan
                  Object.keys(plan.productAddonss).forEach((key) => {
                    plan.productAddonss[key].forEach((product: any) => {
                      if (pl.isBundle) {
                        removedisabledemployedpaidproductid.push(
                          pl,
                        );
                      }
                      else {
                        removedisabledemployedpaidproductid.push(
                          product.planLevel,
                        );
                      }

                    });
                  });
                });
              }
            }
            else {


              if (group?.parentId == element?.parentId) {
                if (element.categorization.paidByCompany == 1 || element.categorization.coveredByCompany == 1) {
                  element.plans.forEach((plan: any) => {
                    let pl = plan
                    Object.keys(plan.productAddonss).forEach((key) => {
                      plan.productAddonss[key].forEach((product: any) => {
                        if (pl.isBundle) {
                          removedisabledemployedpaidproductid.push(
                            pl,
                          );
                        }
                        else {
                          removedisabledemployedpaidproductid.push(
                            product.planLevel,
                          );
                        }

                      });
                    });
                  });
                }
              }
            }
          });
        } else {
        }

        console.log(removedisabledcompanypaidproductid)
        console.log(removedisabledcoveredpaidproductid)
        console.log(removedisabledemployedpaidproductid)

        removedisabledcompanypaidproductid = removedisabledcompanypaidproductid.filter(
          (item: any) => item !== undefined && item !== null
        );
        removedisabledcoveredpaidproductid = removedisabledcoveredpaidproductid.filter(
          (item: any) => item !== undefined && item !== null
        );
        removedisabledemployedpaidproductid = removedisabledemployedpaidproductid.filter(
          (item: any) => item !== undefined && item !== null
        );
        removedisabledcompanypaidproductid.forEach((element: any, index: any) => {
          setTimeout(() => {
            const dom: HTMLElement = this.elementRef.nativeElement;


            if (element.isBundle) {

              Object.keys(element.productAddonss).forEach((key) => {
                element.productAddonss[key].forEach((product: any) => {
                  //console.log(product)
                  plan = dom.querySelectorAll("#plancheck" + product.planId + ".coverage" + product.planCoverage)
                  //  plan.disabled = false;
                  plan.forEach((element: any) => {
                    //console.log(element)
                    element.disabled = false;
                    element.checked = false
                  });
                })
              })


            }
            else {
              plan = dom.querySelectorAll("#plancheck" + element.id);
              plan.disabled = false;
              plan.forEach((element: any) => {
                //console.log(element)
                element.disabled = false;
                element.checked = false
              });
            }





            //remove this plan from sum
            // plan.click()

            let selectplans =
              JSON.parse(sessionStorage.getItem("plansummarymain") || '[]') || "";

            selectplans.forEach((elem: any, index: any) => {

              setTimeout(() => {


                if (elem.id == element.id) {

                } else {
                  setTimeout(() => {
                    const dom: HTMLElement = this.elementRef.nativeElement;
                    const plan = dom.querySelectorAll(".plan-description-span.single" + ".plancheck" + element.id);
                    const plan2 = dom.querySelectorAll(".plan-description-span.couple" + ".plancheck" + element.id);
                    const plan3 = dom.querySelectorAll(".plan-description-span.family" + ".plancheck" + element.id);
                    /* //console.log(plan) */

                    plan.forEach((elem: any) => {
                      (elem as HTMLElement).style.display = 'block';
                    });

                    plan2.forEach((elem: any) => {
                      (elem as HTMLElement).style.display = 'block';
                    });
                    plan3.forEach((elem: any) => {
                      (elem as HTMLElement).style.display = 'block';
                    });



                  }, 1000);
                }



              }, 1000);


              if (elem.isBundle) {
                // if (elem.id == element.id) {
                //   selectplans.splice(index, 1)
                // }

                Object.keys(element.productAddonss).forEach((key) => {
                  element.productAddonss[key].forEach((product: any) => {
                    if (elem.id == element.id && elem.coverage == product.planCoverage) {
                      selectplans.splice(index, 1)
                    }
                  })
                })
              } else {


                if (elem.id == elem.products[0].planLevel) {
                  selectplans.splice(index, 1)
                }
                // if(elem.id==elem.products[0].id){
                //   selectplans.splice(index,1)
                // }
              }


            })

            sessionStorage.setItem(
              "plansummarymain",
              JSON.stringify(selectplans)
            );


            sessionStorage.setItem("plansummary", JSON.stringify(selectplans));

            this.planCoverafeFunction();

          }, 1000);
        });
        removedisabledcoveredpaidproductid.forEach((element: any, index: any) => {
          setTimeout(() => {
            const dom: HTMLElement = this.elementRef.nativeElement;



            let plan: any = ''


            //console.log(element)
            if (element.isBundle) {

              Object.keys(element.productAddonss).forEach((key) => {
                element.productAddonss[key].forEach((product: any) => {
                  //console.log(product)
                  plan = dom.querySelectorAll("#plancheck" + product.planId + ".coverage" + product.planCoverage)


                  //console.log(plan)
                  plan.forEach((element: any) => {
                    //console.log(element)
                    element.disabled = false;
                    element.checked = false
                  });
                })
              })


            } else {
              plan = dom.querySelectorAll("#plancheck" + element.id);

              plan.forEach((element: any) => {
                //console.log(element)
                element.disabled = false;
                element.checked = false
              });
            }


            //remove this plan from sum
            // plan.click()

            let selectplans =
              JSON.parse(sessionStorage.getItem("plansummarymain") || '[]') || "";

            selectplans.forEach((elem: any, index: any) => {
              setTimeout(() => {


                if (elem.id == element.id) {

                } else {
                  setTimeout(() => {
                    const dom: HTMLElement = this.elementRef.nativeElement;
                    const plan = dom.querySelectorAll(".plan-description-span.single" + ".plancheck" + element.id);
                    const plan2 = dom.querySelectorAll(".plan-description-span.couple" + ".plancheck" + element.id);
                    const plan3 = dom.querySelectorAll(".plan-description-span.family" + ".plancheck" + element.id);
                    // //console.log(plan)


                    plan.forEach((elem: any) => {
                      (elem as HTMLElement).style.display = 'block';
                    });

                    plan2.forEach((elem: any) => {
                      (elem as HTMLElement).style.display = 'block';
                    });
                    plan3.forEach((elem: any) => {
                      (elem as HTMLElement).style.display = 'block';
                    });



                  }, 1000);
                }



              }, 1000);
              if (elem.isBundle) {


                Object.keys(element.productAddonss).forEach((key) => {
                  element.productAddonss[key].forEach((product: any) => {
                    if (elem.id == element.id && elem.coverage == product.planCoverage) {
                      selectplans.splice(index, 1)
                    }
                  })
                })
              } else {
                if (elem.id == elem.products[0].planLevel) {
                  selectplans.splice(index, 1)
                }
              }


            })

            sessionStorage.setItem(
              "plansummarymain",
              JSON.stringify(selectplans)
            );


            sessionStorage.setItem("plansummary", JSON.stringify(selectplans));

            this.planCoverafeFunction();
          }, 100);
        });
        removedisabledemployedpaidproductid.forEach((element: any, index: any) => {
          setTimeout(() => {
            const dom: HTMLElement = this.elementRef.nativeElement;
            // const plan: any = dom.querySelectorAll("#plancheck" + element.id);
            // //console.log(plan)
            // //Rakesh changes here company to upgrade
            // plan.disabled = false;
            // plan.forEach((element: any) => {
            //   //console.log(element)
            //   element.checked = false
            // });


            let plan: any = ''


            //console.log(element)
            if (element.isBundle) {

              Object.keys(element.productAddonss).forEach((key) => {
                element.productAddonss[key].forEach((product: any) => {
                  //console.log(product)
                  plan = dom.querySelectorAll("#plancheck" + product.planId + ".coverage" + product.planCoverage)


                  //console.log(plan)
                  plan.forEach((element: any) => {
                    //console.log(element)
                    element.disabled = false;
                    element.checked = false
                  });
                })
              })


            } else {
              plan = dom.querySelectorAll("#plancheck" + element.id);

              plan.forEach((element: any) => {
                //console.log(element)
                element.disabled = false;
                element.checked = false
              });
            }


            //remove this plan from sum
            // plan.click()

            let selectplans =
              JSON.parse(sessionStorage.getItem("plansummarymain") || '[]') || "";

            selectplans.forEach((elem: any, index: any) => {
              setTimeout(() => {


                if (elem.id == element.id) {

                } else {
                  setTimeout(() => {
                    const dom: HTMLElement = this.elementRef.nativeElement;
                    const plan = dom.querySelectorAll(".plan-description-span.single" + ".plancheck" + element.id);
                    const plan2 = dom.querySelectorAll(".plan-description-span.couple" + ".plancheck" + element.id);
                    const plan3 = dom.querySelectorAll(".plan-description-span.family" + ".plancheck" + element.id);
                    // //console.log(plan)


                    plan.forEach((elem: any) => {
                      (elem as HTMLElement).style.display = 'block';
                    });

                    plan2.forEach((elem: any) => {
                      (elem as HTMLElement).style.display = 'block';
                    });
                    plan3.forEach((elem: any) => {
                      (elem as HTMLElement).style.display = 'block';
                    });



                  }, 1000);
                }



              }, 1000);
              if (elem.isBundle) {


                Object.keys(element.productAddonss).forEach((key) => {
                  element.productAddonss[key].forEach((product: any) => {
                    if (elem.id == element.id && elem.coverage == product.planCoverage) {
                      selectplans.splice(index, 1)

                    }
                  })
                })
              } else {
                if (elem.id == elem.products[0].planLevel) {
                  selectplans.splice(index, 1)

                }
              }


            })

            sessionStorage.setItem(
              "plansummarymain",
              JSON.stringify(selectplans)
            );


            sessionStorage.setItem("plansummary", JSON.stringify(selectplans));

            this.planCoverafeFunction();
          }, 100);
        });


        this.selectplan1(e.target, options, plan, product, pckage, group, planindex, disallowedPlanLevels);
      } else {


        this.unselectplan1(e.target, options, plan, product, pckage, group, planindex, disallowedPlanLevels);
      }
    }, 10);
  }


  public allowmultipleplans() { }

  public disallowedPlans() { }
  public selectplan1(
    elementcv: any,
    options: any,
    plan: any,
    product: any,
    pckage: any,
    group: any,
    planProductIndex: any,
    disallowedPlanLevels: any
  ) {
    // ////this.consoleMessage(elementcv)
    //this.consoleMessage(plan);
    //this.consoleMessage(product)
    //this.consoleMessage(pckage)
    //this.consoleMessage(group)

    // alert("1")
    this.planobjdata = {};
    this.planobjdataobj = {}

    console.log(disallowedPlanLevels)

    let details: any = elementcv.attributes.data.value;

    let detailsObj: any = details.split("##");


    let categorization = {}

    if (group.categorization.paidByCompany == 1) {

      categorization = {
        paidByCompany: detailsObj[22] == "true" ? 0 : 1,
        coveredByCompany: detailsObj[22] == "true" ? 1 : 0,
        paidByEmployee: group.categorization.paidByEmployee,
      }
    } else {
      categorization = {
        paidByCompany: group.categorization.paidByCompany,
        coveredByCompany: group.categorization.coveredByCompany,
        paidByEmployee: group.categorization.paidByEmployee,
      }
    }

    //console.log(categorization)

    // paidByCompany: group.categorization.paidByCompany,
    // coveredByCompany: group.categorization.coveredByCompany,
    // paidByEmployee: group.categorization.paidByEmployee,

    let plandetails = elementcv.attributes.data.value;

    let plandetailsobj = plandetails.split("##");
    if (options && options.length > 0) {
      sessionStorage.setItem('options', JSON.stringify(options));
    }
    // if (options && options.length > 0) {
    //   let obj = {
    //     isBundle: plan.isBundle,
    //     disallowedPlanLevels: disallowedPlanLevels,
    //     enrollmentDate: this.userForm.value.planEnrollmentDate
    //       ? this._CustomDatePipe.transform(this.userForm.value.planEnrollmentDate)
    //       : undefined,
    //     // "name":plandetailsobj[1]+"-"+plandetailsobj[2],
    //     name: plandetailsobj[14],
    //     details: plandetailsobj[0],
    //     packagename: plandetailsobj[0],
    //     groupName: plandetailsobj[1],
    //     // amount: parseFloat(plandetailsobj[3]),
    //     amount: parseFloat(product.calculatedTax.price),
    //     planCoverage: plandetailsobj[2],
    //     // planPrice: parseFloat(plandetailsobj[3]),
    //     planPrice: parseFloat(product.calculatedTax.price),
    //     // amountUI: "$" + this._decimalPipe.transform(plandetailsobj[3], "1.2-2"),
    //     amountUI: "$" + parseFloat(product.calculatedTax.price),
    //     gst:
    //       plandetailsobj[4] == null ||
    //         plandetailsobj[4] == "" ||
    //         plandetailsobj[4] == undefined ||
    //         plandetailsobj[4] == "null"
    //         ? 0
    //         : parseFloat(plandetailsobj[4]),
    //     hst:
    //       plandetailsobj[5] == null ||
    //         plandetailsobj[5] == "" ||
    //         plandetailsobj[5] == undefined ||
    //         plandetailsobj[5] == "null"
    //         ? 0
    //         : parseFloat(plandetailsobj[5]),
    //     pst:
    //       plandetailsobj[6] == null ||
    //         plandetailsobj[6] == "" ||
    //         plandetailsobj[6] == undefined ||
    //         plandetailsobj[6] == "null"
    //         ? 0
    //         : parseFloat(plandetailsobj[6]),
    //     qst:
    //       plandetailsobj[17] == null ||
    //         plandetailsobj[17] == "" ||
    //         plandetailsobj[17] == undefined ||
    //         plandetailsobj[17] == "null"
    //         ? 0
    //         : parseFloat(plandetailsobj[17]),
    //     gstCheck:
    //       plandetailsobj[4] == null ||
    //         plandetailsobj[4] == "" ||
    //         plandetailsobj[4] == undefined ||
    //         plandetailsobj[4] == "null"
    //         ? false
    //         : true,
    //     hstCheck:
    //       plandetailsobj[5] == null ||
    //         plandetailsobj[5] == "" ||
    //         plandetailsobj[5] == undefined ||
    //         plandetailsobj[5] == "null"
    //         ? false
    //         : true,
    //     pstCheck:
    //       plandetailsobj[6] == null ||
    //         plandetailsobj[6] == "" ||
    //         plandetailsobj[6] == undefined ||
    //         plandetailsobj[6] == "null"
    //         ? false
    //         : true,
    //     qstCheck:
    //       plandetailsobj[17] == null ||
    //         plandetailsobj[17] == "" ||
    //         plandetailsobj[17] == undefined ||
    //         plandetailsobj[17] == "null"
    //         ? false
    //         : true,
    //     id: parseFloat(plandetailsobj[7]),
    //     fusebillPlanID:
    //       plandetailsobj[8] == null ||
    //         plandetailsobj[8] == "" ||
    //         plandetailsobj[8] == undefined ||
    //         plandetailsobj[8] == "null"
    //         ? 0
    //         : parseFloat(plandetailsobj[8]),
    //     planFrequencyID:
    //       plandetailsobj[9] == null ||
    //         plandetailsobj[9] == "" ||
    //         plandetailsobj[9] == undefined ||
    //         plandetailsobj[9] == "null"
    //         ? 0
    //         : parseFloat(plandetailsobj[9]),
    //     optIn: plandetailsobj[10] == "true" ? true : false,
    //     planname: plandetailsobj[14],
    //     planLevel: parseInt(plandetailsobj[15]),
    //     packageId: parseInt(plandetailsobj[16]),
    //     options: [],
    //     paidByCompany1: plandetailsobj[19],
    //     coveredByCompany1: plandetailsobj[20],
    //     paidByEmployee1: plandetailsobj[21],
    //     planLevel_parentId: plandetailsobj[12],
    //     // disallowedPlanLevels: plandetailsobj[11],
    //     version: plan.version,
    //     description: plan.description,
    //     insuranceType: plan.insuranceType,
    //   };
    //   if (plandetailsobj[11] != null || plandetailsobj[11] != "null") {
    //     if (plandetailsobj[11].includes(plandetailsobj[12])) {
    //     }
    //   }
    //   let coverage = product.planCoverage;

    //   coverage = ["SINGLE", "COUPLE", "FAMILY"].includes(coverage)
    //     ? coverage
    //     : null;
    //   ////this.consoleMessage(obj)
    //   this.productobj = {
    //     id: product.id,
    //     productId: product.productId,
    //     name: product.name,

    //     planProductId: product.planProductId,
    //     price: adjustWith2DecimalsForUI(product.price1 || product.price),
    //     tax: adjustWith2DecimalsForUI(
    //       product.calculatedTax ? product.calculatedTax.tax : 0
    //     ),
    //     total: adjustWith2DecimalsForUI(
    //       product.calculatedTax ? product.calculatedTax.total : 0
    //     ),
    //     //  price: parseFloat(this._decimalPipe.transform(product.price1 || product.price, "1.2-2")) ,
    //     //  tax: parseFloat(this._decimalPipe.transform(product.calculatedTax ? product.calculatedTax.tax : 0, "1.2-2")),
    //     //  total:parseFloat(this._decimalPipe.transform(product.calculatedTax ? product.calculatedTax.total : 0, "1.2-2")),
    //     tax_details:
    //       product.bundledTaxes && product.bundledTaxes.length > 0
    //         ? product.bundledTaxes
    //         : product.taxesDataJSON,
    //     calculatedTax: product.calculatedTax,
    //     bundledProducts: product.bundledProducts,
    //     planCoverage: product.planCoverage,
    //     planLevel: product.planlevel
    //       ? product.planlevel.id
    //       : plan.planLevel
    //         ? plan.planLevel
    //         : group.id,
    //     planLevelParent: product.planlevel
    //       ? product.planlevel.parentId
    //       : group.parentId,
    //     description: product.description,
    //     coverage: coverage,
    //     version: product.version
    //   };
    //   let obj1: any = {
    //     packageId: plan.packageId,
    //     packageName: pckage.name,

    //     planproductname: this.productobj.name,

    //     groupid: plan.planLevel,
    //     groupName: group.name,
    //     id: plan.id,
    //     name: plan.name,
    //     planLevel: plan.planLevel ? plan.planLevel : group.id,
    //     planLevelParent: group.parentId,
    //     fusebillPlanID: plan.fusebillId,
    //     planFrequencyID: plan.frqMonthly,
    //     isBundle: plan.isBundle,
    //     disallowedPlanLevels: disallowedPlanLevels,
    //     coverage: coverage,
    //     planCoverage: product.planCoverage,
    //     bundledProducts: [],
    //     products: [],
    //     upgradeCalculation: plan.products && plan.products[planProductIndex] ? plan.products[planProductIndex].upgradeCalculation : plan.upgradeCalculation,

    //   };
    //   obj1.products.push(this.productobj);
    //   let finalobj1: any = { ...obj1, ...categorization };



    //   //this.consoleMessage(obj1);


    //   this.planobjdata = finalobj1;
    //   this.planobjdataobj = obj
    //   this.elementcvValues = elementcv

    //   console.log(this.planobjdata)

    //   // this.addtoplansummary(obj, obj1, elementcv);
    //   this.addtoplansummary(obj, finalobj1, elementcv);
    //   setTimeout(() => {


    //     // this.openplanoptions(elementcv, options, plan, product)

    //     this.openplanoptions(elementcv)
    //   }, 1000);
    // }
    // else {
    let obj = {
      isBundle: plan.isBundle,
      disallowedPlanLevels: disallowedPlanLevels,
      enrollmentDate: this.datePipe.transform(
        this.clientregform.value.PolicyStartDate,
        'yyyy-MM-dd'
      ) || '0000-00-00',
      // "name":plandetailsobj[1]+"-"+plandetailsobj[2],
      name: plandetailsobj[14],
      details: plandetailsobj[0],
      packagename: plandetailsobj[0],
      groupName: plandetailsobj[1],
      // amount: parseFloat(plandetailsobj[3]),
      amount: parseFloat(product.calculatedTax.price),
      planCoverage: plandetailsobj[2],
      // planPrice: parseFloat(plandetailsobj[3]),
      planPrice: parseFloat(product.calculatedTax.price),
      // amountUI: "$" + this._decimalPipe.transform(plandetailsobj[3], "1.2-2"),
      amountUI: "$" + parseFloat(product.calculatedTax.price),
      gst:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == "" ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == "null"
          ? 0
          : parseFloat(plandetailsobj[4]),
      hst:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == "" ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == "null"
          ? 0
          : parseFloat(plandetailsobj[5]),
      pst:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == "" ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == "null"
          ? 0
          : parseFloat(plandetailsobj[6]),
      qst:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == "" ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == "null"
          ? 0
          : parseFloat(plandetailsobj[17]),
      gstCheck:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == "" ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == "null"
          ? false
          : true,
      hstCheck:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == "" ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == "null"
          ? false
          : true,
      pstCheck:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == "" ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == "null"
          ? false
          : true,
      qstCheck:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == "" ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == "null"
          ? false
          : true,
      id: parseFloat(plandetailsobj[7]),
      fusebillPlanID:
        plandetailsobj[8] == null ||
          plandetailsobj[8] == "" ||
          plandetailsobj[8] == undefined ||
          plandetailsobj[8] == "null"
          ? 0
          : parseFloat(plandetailsobj[8]),
      planFrequencyID:
        plandetailsobj[9] == null ||
          plandetailsobj[9] == "" ||
          plandetailsobj[9] == undefined ||
          plandetailsobj[9] == "null"
          ? 0
          : parseFloat(plandetailsobj[9]),
      optIn: plandetailsobj[10] == "true" ? true : false,
      planname: plandetailsobj[14],
      planLevel: parseInt(plandetailsobj[15]),
      packageId: parseInt(plandetailsobj[16]),
      options: [],
      paidByCompany1: plandetailsobj[19],
      coveredByCompany1: plandetailsobj[20],
      paidByEmployee1: plandetailsobj[21],
      planLevel_parentId: plandetailsobj[12],
      // disallowedPlanLevels: plandetailsobj[11],
      version: plan.version,
      description: plan.description,
      insuranceType: plan.insuranceType,
    };
    if (plandetailsobj[11] != null || plandetailsobj[11] != "null") {
      if (plandetailsobj[11].includes(plandetailsobj[12])) {
      }
    }

    let coverage = product.planCoverage;

    coverage = ["SINGLE", "COUPLE", "FAMILY"].includes(coverage)
      ? coverage
      : null;
    ////this.consoleMessage(obj)
    this.productobj = {
      id: product.id,
      productId: product.productId,
      name: product.name,

      planProductId: product.planProductId,
      //  price: product.price1 || product.price,
      //  tax: product.calculatedTax ? product.calculatedTax.tax : 0,
      //  total: product.calculatedTax ? product.calculatedTax.total : 0,

      price: adjustWith2DecimalsForUI(product.price1 || product.price),
      tax: adjustWith2DecimalsForUI(
        product.calculatedTax ? product.calculatedTax.tax : 0
      ),
      total: adjustWith2DecimalsForUI(
        product.calculatedTax ? product.calculatedTax.total : 0
      ),
      //  price: parseFloat(this._decimalPipe.transform(product.price1 || product.price, "1.2-2")) ,
      //  tax: parseFloat(this._decimalPipe.transform(product.calculatedTax ? product.calculatedTax.tax : 0, "1.2-2")),
      //  total:parseFloat(this._decimalPipe.transform(product.calculatedTax ? product.calculatedTax.total : 0, "1.2-2")),

      tax_details:
        product.bundledTaxes && product.bundledTaxes.length > 0
          ? product.bundledTaxes
          : product.taxesDataJSON,
      calculatedTax: product.calculatedTax,
      bundledProducts: product.bundledProducts,
      planCoverage: product.planCoverage,
      planLevel: product.planlevel
        ? product.planlevel.id
        : plan.planLevel
          ? plan.planLevel
          : group.id,
      planLevelParent: product.planlevel
        ? product.planlevel.parentId
        : group.parentId,
      description: product.description,
      coverage: coverage,
      version: product.version
    };
    let obj1: any = {
      packageId: plan.packageId,
      packageName: pckage.name,

      planproductname: this.productobj.name,

      groupid: plan.planLevel,
      groupName: group.name,
      id: plan.id,
      name: plan.name,
      planLevel: plan.planLevel ? plan.planLevel : group.id,
      planLevelParent: group.parentId,
      fusebillPlanID: plan.fusebillId,
      planFrequencyID: plan.frqMonthly,
      isBundle: plan.isBundle,
      coverage: coverage,
      planCoverage: product.planCoverage,
      bundledProducts: [],
      products: [],
      upgradeCalculation: plan.products && plan.products[planProductIndex] ? plan.products[planProductIndex].upgradeCalculation : plan.upgradeCalculation,

    };

    obj1.products.push(this.productobj);
    let finalobj1: any = { ...obj1, ...categorization };

    //console.log(finalobj1)


    this.addtoplansummary(obj, finalobj1, elementcv);
    setTimeout(() => {

      this.openplanoptions(elementcv)
    }, 1000);
    // }
  }

  public unselectplan1(
    elementcv: any,
    options: any,
    plan: any,
    product: any,
    pckage: any,
    group: any,
    planProductIndex: any,
    disallowedPlanLevels: any
  ) {

    //console.log(plan)

    let plandetails = elementcv.attributes.data.value;

    let plandetailsobj = plandetails.split("##");
    let obj = {
      isBundle: plan.isBundle,
      enrollmentDate: this.datePipe.transform(
        this.clientregform.value.PolicyStartDate,
        'yyyy-MM-dd'
      ) || '0000-00-00',
      // "name":plandetailsobj[1]+"-"+plandetailsobj[2],
      name: plandetailsobj[14],
      details: plandetailsobj[0],
      packagename: plandetailsobj[0],
      groupName: plandetailsobj[1],
      amount: parseFloat(plandetailsobj[3].replace(/\,/g, "")),
      planCoverage: plandetailsobj[2],
      planPrice: parseFloat(plandetailsobj[3].replace(/\,/g, "")),
      amountUI: "$" + parseFloat(plandetailsobj[3].replace(/\,/g, "")),
      gst:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == "" ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == "null"
          ? 0
          : parseFloat(plandetailsobj[4]),
      hst:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == "" ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == "null"
          ? 0
          : parseFloat(plandetailsobj[5]),
      pst:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == "" ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == "null"
          ? 0
          : parseFloat(plandetailsobj[6]),
      qst:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == "" ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == "null"
          ? 0
          : parseFloat(plandetailsobj[17]),
      gstCheck:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == "" ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == "null"
          ? false
          : true,
      hstCheck:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == "" ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == "null"
          ? false
          : true,
      pstCheck:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == "" ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == "null"
          ? false
          : true,
      qstCheck:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == "" ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == "null"
          ? false
          : true,
      id: parseFloat(plandetailsobj[7]),
      fusebillPlanID:
        plandetailsobj[8] == null ||
          plandetailsobj[8] == "" ||
          plandetailsobj[8] == undefined ||
          plandetailsobj[8] == "null"
          ? 0
          : parseFloat(plandetailsobj[8]),
      planFrequencyID:
        plandetailsobj[9] == null ||
          plandetailsobj[9] == "" ||
          plandetailsobj[9] == undefined ||
          plandetailsobj[9] == "null"
          ? 0
          : parseFloat(plandetailsobj[9]),
      optIn: plandetailsobj[10] == "true" ? true : false,
      planname: plandetailsobj[14],
      planLevel: parseInt(plandetailsobj[15]),
      packageId: parseInt(plandetailsobj[16]),
      options: [],
      paidByCompany1: plandetailsobj[19],
      coveredByCompany1: plandetailsobj[20],
      paidByEmployee1: plandetailsobj[21],
      planLevel_parentId: plandetailsobj[12],
      disallowedPlanLevels: plandetailsobj[11],
    };
    if (plandetailsobj[11] != null || plandetailsobj[11] != "null") {
      if (plandetailsobj[11].includes(plandetailsobj[12])) {
      }
    }

    this.removeplansummary(obj, group, pckage, elementcv);
    setTimeout(() => {


      this.openplanoptions(elementcv)


    }, 1000);
  }

  public openplanoptions(elementcv: any) {
    let plandetails = elementcv.attributes.data.value;

    let plandetailsobj = plandetails.split("##");

    let modifiedOptions: any = [];
    let optionumber: any = [];
    // let optionumber = $("#optionumber").val();  //rakesh
    // jQuery("#showplanoptions-modal").modal("hide");

    let planSummary = JSON.parse(sessionStorage.getItem('plansummary') || '[]');
    let optionsValue = JSON.parse(sessionStorage.getItem('options') || '[]');

    for (let i = 0; i < planSummary.length; i++) {

      if (planSummary[i].planproductname && planSummary[i].planproductname.includes("Medcan")) {
        // Your code here

        const filteredData = optionsValue.map((item: any) => {
          return {
            ...item, // Preserve the rest of the object
            planOptionsValues: item.planOptionsValues.filter((option: any) =>
              option.name.includes("Medcan") ||
              option.name.includes("Yes") ||
              option.name.includes("No")
            )
          };
        });
        optionsValue = filteredData


      }
      if (planSummary[i].planproductname && planSummary[i].planproductname.includes("La Vie")) {
        // Your code here

        const filteredData = optionsValue.map((item: any) => {
          return {
            ...item, // Preserve the rest of the object
            planOptionsValues: item.planOptionsValues.filter((option: any) =>
              option.name.includes("La Vie") ||
              option.name.includes("Yes") ||
              option.name.includes("No")
            )
          };
        });
        optionsValue = filteredData

      }
      if (planSummary[i].planproductname && planSummary[i].planproductname.includes("La Vie") && planSummary[i].planproductname.includes("Medcan")) {
        // Your code here

        const filteredData = optionsValue.map((item: any) => {
          return {
            ...item, // Preserve the rest of the object
            planOptionsValues: item.planOptionsValues.filter((option: any) =>
              option.name.includes("La Vie") || option.name.includes("Medcan") ||
              option.name.includes("Yes") ||
              option.name.includes("No")
            )
          };
        });

        optionsValue = filteredData


      }
    }

    // this.plandetailsobjvalue = plandetailsobj;

    this.plandetailsobjvalue = plandetails;

    optionsValue.forEach((element: any) => {
      element.planOptionsValues.forEach((options: any) => {
        options.planOptionName = element.name;
        options.json = JSON.stringify(options);
      });

      modifiedOptions.push(element);
    });

    this.optionstitle = modifiedOptions;
    //this.consoleMessage("isexeccp:" + plandetailsobj[19]);
    this.isExecutiveCP = plandetailsobj[19]
      ? parseInt(plandetailsobj[19]) == 1
        ? true
        : false
      : false;
    this.planOptionsModel = true
    // alert("startrhetre")
    // jQuery("#showplanoptions-modal").modal("show");
  }
  public addtoplansummary(obj: any, obj1: any, e: any) {
    let planSummary = JSON.parse(sessionStorage.getItem("plansummary") || "[]");

    // console.log(obj)
    // console.log(obj1)

    /* This code mainly for flex plan silver and gold */


    for (let i = 0; i < planSummary.length; i++) {
      if (obj1.planLevelParent) {
        if (planSummary[i].planLevelParent == obj1.planLevelParent && planSummary[i].coveredByCompany == obj1.coveredByCompany) {

          const dom: HTMLElement = this.elementRef.nativeElement;

          const plan: any = dom.querySelector("#plancheck" + planSummary[i].id + ".coverage" + planSummary[i].coverage);
          //console.log(plan)
          if (plan.checked) {
            plan.checked = false
          }
          planSummary.splice(i, 1)
        }
      }
    }



    //this.consoleMessage("obj1", obj1);
    //console.log("obj", obj);
    setTimeout(() => {
      const dom: HTMLElement = this.elementRef.nativeElement;
      const plan = dom.querySelectorAll(".plan-description-span.single" + ".plancheck" + obj.id);
      const plan2 = dom.querySelectorAll(".plan-description-span.couple" + ".plancheck" + obj.id);
      const plan3 = dom.querySelectorAll(".plan-description-span.family" + ".plancheck" + obj.id);
      // //console.log(plan)

      if (obj.coverage === "SINGLE") {
        if (plan) {
          plan.forEach((elem: any) => {
            (elem as HTMLElement).style.display = 'block';
          });
        }
        if (plan2) {
          plan2.forEach((elem: any) => {
            (elem as HTMLElement).style.display = 'none';
          });
        }
        if (plan3) {
          plan3.forEach((elem: any) => {
            (elem as HTMLElement).style.display = 'none';
          });
        }
      } else if (obj.coverage === "COUPLE") {
        if (plan) {
          plan.forEach((elem: any) => {
            (elem as HTMLElement).style.display = 'none';
          });
        }
        if (plan2) {
          plan2.forEach((elem: any) => {
            (elem as HTMLElement).style.display = 'block';
          });
        }
        if (plan3) {
          plan3.forEach((elem: any) => {
            (elem as HTMLElement).style.display = 'none';
          });
        }
      } else if (obj.coverage === "FAMILY") {
        if (plan) {
          plan.forEach((elem: any) => {
            (elem as HTMLElement).style.display = 'none';
          });
        }
        if (plan2) {
          plan2.forEach((elem: any) => {
            (elem as HTMLElement).style.display = 'none';
          });
        }
        if (plan3) {
          plan3.forEach((elem: any) => {
            (elem as HTMLElement).style.display = 'block';
          });
        }
      } else {
        // Default case - hide all plans if coverage doesn't match expected
      }



    }, 2000);

    this.addtoslectplans(obj.id, planSummary.length);
    planSummary.push(obj);

    let gstprice = 0;
    let hstprice = 0;
    let pstprice = 0;
    let qstprice = 0;

    if (obj.options && obj.options.length > 0) {
      obj["disallowedPlanLevels"] = obj1.disallowedPlanLevels

    }

    if (obj.gst > 0) {
      gstprice = obj.planPrice * obj.gst;

      obj['gstPrice'] = gstprice
        ? this._decimalPipe.transform(gstprice, '1.2-2')
        : 0;
      obj['gstPrice'] = parseFloat(obj['gstPrice']);
    } else {
      obj["gstPrice"] = 0;
    }

    if (obj.hst > 0) {
      hstprice = obj.planPrice * obj.hst;

      obj['hstPrice'] = hstprice
        ? this._decimalPipe.transform(hstprice, '1.2-2')
        : 0;
      obj['hstPrice'] = parseFloat(obj['hstPrice']);
    } else {
      obj["hstPrice"] = 0;
    }

    if (obj.pst > 0) {
      pstprice = obj.planPrice * obj.pst;


      obj['pstPrice'] = pstprice
        ? this._decimalPipe.transform(pstprice, '1.2-2')
        : 0;
      obj['pstPrice'] = parseFloat(obj['pstPrice']);
    } else {
      obj["pstPrice"] = 0;
    }

    if (obj.qst > 0) {
      qstprice = obj.planPrice * obj.qst;

      obj['qstPrice'] = qstprice
        ? this._decimalPipe.transform(qstprice, '1.2-2')
        : 0;
      obj['qstPrice'] = parseFloat(obj['qstPrice']);
    } else {
      obj["qstPrice"] = 0;
    }

    obj["taxUI"] = "";
    if (obj["gstCheck"]) {
      obj["taxUI"] += "<span>";
      if (obj["gstPrice"] == 0) {
        obj["taxUI"] += "-";
      } else {
        obj["taxUI"] +=
          "$" +
          this._decimalPipe.transform(obj["gstPrice"], "1.2-2") +
          "&nbsp;(GST)";
      }
      obj["taxUI"] += "</span>";
    }

    if (obj["pstCheck"]) {
      obj["taxUI"] += "<span>";
      if (obj["pstPrice"] == 0) {
        obj["taxUI"] += "-";
      } else {
        obj["taxUI"] +=
          "$" +
          this._decimalPipe.transform(obj["pstPrice"], "1.2-2") +
          "&nbsp;(PST)";
      }
      obj["taxUI"] += "</span>";
    }

    if (obj["qstCheck"]) {
      obj["taxUI"] += "<span>";
      if (obj["qstPrice"] == 0) {
        obj["taxUI"] += "-";
      } else {
        obj["taxUI"] +=
          "$" +
          this._decimalPipe.transform(obj["qstPrice"], "1.2-2") +
          "&nbsp;(QST)";
      }
      obj["taxUI"] += "</span>";
    }

    if (obj["hstCheck"]) {
      obj["taxUI"] += "<span> ";
      if (obj["hstPrice"] == 0) {
        obj["taxUI"] += "-";
      } else {
        obj["taxUI"] +=
          "$" +
          this._decimalPipe.transform(obj["hstPrice"], "1.2-2") +
          "&nbsp;(HST)";
      }
      obj["taxUI"] += "</span>";
    }

    if (
      !obj["hstCheck"] &&
      !obj["gstCheck"] &&
      !obj["pstCheck"] &&
      !obj["qstCheck"]
    ) {
      obj["taxUI"] += "<span>-";

      obj["taxUI"] += "</span>";
    }

    // ////this.consoleMessage(object["taxUI"])

    // obj["tax"] = parseFloat(
    //   this._decimalPipe.transform(gstprice + hstprice + pstprice + qstprice, "1.2-2")
    // );
    // obj["tax"] = parseFloat(
    //   this._decimalPipe.transform(obj1.products[0].calculatedTax.tax, "1.2-2")
    // );
    obj['tax'] = obj1.products[0]
      ? this._decimalPipe.transform(obj1.products[0].calculatedTax.tax, "1.2-2") : 0;
    obj['tax'] = parseFloat(obj['tax']);
    // obj["products"] =obj1

    obj["coverage"] = obj1.coverage;
    obj["planCoverage"] = obj1.planCoverage;
    obj["planLevelParent"] = obj1.planLevelParent;
    obj["planproductname"] = obj1.planproductname;

    obj["products"] = obj1.products;
    obj["upgradeCalculation"] = obj1.upgradeCalculation;
    obj["paidByCompany"] = obj1.paidByCompany;
    obj["coveredByCompany"] = obj1.coveredByCompany;
    obj["paidByEmployee"] = obj1.paidByEmployee;



    let pricecal = obj1.products[0].calculatedTax.total;
    obj["totalPrice"] = pricecal;

    obj["totalUI"] = "$" + pricecal;

    (obj["total"] = pricecal),
      (obj["skuTotalPrice"] = parseFloat(
        obj1.products.reduce((acc: any, calculatedTax: any) => {
          return acc + calculatedTax.total;
        }, 0)
      ));

    let updatedSum = this.addtosum(obj.skuTotalPrice);
    this.planssummarymain = [];
    this.planssummaryopt = [];

    planSummary.forEach((element: any) => {
      if (element.packagename != "Opt-in") {
        this.planssummarymain.push(element);
      } else {
        this.planssummaryopt.push(element);
      }
    });

    this.plansskumain.push(obj1);

    sessionStorage.setItem("plansskumain", JSON.stringify(this.plansskumain));

    sessionStorage.setItem(
      "plansummarymain",
      JSON.stringify(this.planssummarymain)
    );
    sessionStorage.setItem(
      "plansummaryopt",
      JSON.stringify(this.planssummaryopt)
    );

    sessionStorage.setItem("plansummary", JSON.stringify(planSummary));

    // setTimeout(() => {
    this.planCoverafeFunction();

    // }, 3000);



    setTimeout(() => {
      this.planssummarymainLife = JSON.parse(
        sessionStorage.getItem('planssummarymainLife') || '[]'
      );

      this.planssummarymain = JSON.parse(
        sessionStorage.getItem('plansummarymain') || '[]'
      );
      var total = 0;
      for (let i = 0; i < this.planssummarymainLife.length; i++) {
        total += parseFloat(this.planssummarymainLife[i].skuTotalPrice);
      }
      // for (let i = 0; i < this.planssummarymain.length; i++) {
      //   if (obj.planproductname.includes("La Vie")) {

      //     if (this.planssummarymain[i].planLevel == 18) {

      //       if (this.planssummarymain[i].coverage == obj.coverage) {

      //       } else {
      //         const dom: HTMLElement = this.elementRef.nativeElement;
      //         // const plan: any = dom.querySelector(`#plancheck792`)
      //         const plan: any = dom.querySelector("#plancheck792" + ".coverage" + obj.coverage);
      //         setTimeout(() => {
      //           plan.click()
      //           this.toastrService.success("La Vie plan selection automatically includes Complete Executive Care plan.", "");
      //         }, 1000);
      //       }
      //       break;
      //     }
      //     else {

      //       const dom: HTMLElement = this.elementRef.nativeElement;
      //       // const plan: any = dom.querySelector(`#plancheck792`)
      //       const plan: any = dom.querySelector("#plancheck792" + ".coverage" + obj.coverage);

      //       console.log(plan)
      //       setTimeout(() => {
      //         plan.click()
      //         this.toastrService.success("La Vie plan selection automatically includes Complete Executive Care plan.", "");
      //       }, 1000);
      //     }
      //   }
      // }
      this.companypaidproductid = this.companypaidproductid.filter(
        (item: any) => item !== undefined && item !== null
      );

      var result = this.companypaidproductid.reduce((unique: any, o: any) => {
        if (!unique.some((obj: { name: any; }) => obj.name === o.name)) {
          unique.push(o);
        }
        return unique;
      }, []);
      console.log(result);
      const filteredPlans = result.filter((result: any) => result.planLevel === 18);

      console.log(filteredPlans);


      if (filteredPlans.length > 0) {
        for (let i = 0; i < this.planssummarymain.length; i++) {
          if (obj.planproductname.includes("La Vie")) {

            if (this.planssummarymain[i].coverage == obj.coverage) {

            } else {
              const dom: HTMLElement = this.elementRef.nativeElement;
              // const plan: any = dom.querySelector(`#plancheck792`)
              const plan: any = dom.querySelector("#plancheck792" + ".coverage" + obj.coverage);
              setTimeout(() => {
                plan.click()
                this.toastrService.success("La Vie plan selection automatically includes Complete Executive Care plan", "");
              }, 1000);
            }



          }
        }
      } else {
        for (let i = 0; i < this.planssummarymain.length; i++) {
          if (obj.planproductname.includes("La Vie")) {

            if (this.planssummarymain[i].planLevel == 18) {

              if (this.planssummarymain[i].coverage == obj.coverage) {

              } else {
                const dom: HTMLElement = this.elementRef.nativeElement;
                // const plan: any = dom.querySelector(`#plancheck792`)
                const plan: any = dom.querySelector("#plancheck792" + ".coverage" + obj.coverage);
                setTimeout(() => {
                  plan.click()
                  this.toastrService.success("La Vie plan selection automatically includes Complete Executive Care plan", "");
                }, 1000);
              }
              break;
            }
            else {

              const dom: HTMLElement = this.elementRef.nativeElement;
              // const plan: any = dom.querySelector(`#plancheck792`)
              const plan: any = dom.querySelector("#plancheck792" + ".coverage" + obj.coverage);

              console.log(plan)
              setTimeout(() => {
                plan.click()
                this.toastrService.success("La Vie plan selection automatically includes Complete Executive Care plan", "");
              }, 1000);
              break;
            }
          }
        }
      }
      for (let i = 0; i < this.planssummarymain.length; i++) {

        total += parseFloat(this.planssummarymain[i].skuTotalPrice);
      }

    }, 100);

    setTimeout(() => {
      let selectplans =
        JSON.parse(sessionStorage.getItem("plansummarymain") || '[]') || "";



      selectplans.forEach((element: any) => {
        if (element.paidByCompany == 1) {
          const dom: HTMLElement = this.elementRef.nativeElement;
          const plan: any = dom.querySelector("#plancheck" + element.id);

          const samePlanIdElements = dom.querySelectorAll('#' + e.id);
          //console.log(samePlanIdElements)
          let targetClassName = 'cp_plan'
          if (e.className.includes('cp_plan')) {
            targetClassName = 'cp_plan'
          }
          else if (e.className.includes('cc_plan')) {
            targetClassName = 'cc_plan'
          }
          else if (e.className.includes('ep_plan')) {
            targetClassName = 'ep_plan'
          }

          for (let i = 0; i < samePlanIdElements.length; i++) {
            let elem = samePlanIdElements[i];
            let element: any = elem;
            // //console.log(elem)
            // //console.log(elem.className.includes('cp_plan'))
            if (elem.className.includes('cp_plan')) {
              element.disabled = false;
              if (element.checked) {
                element.disabled = true;

              }
            }
          }
          if (plan) {
            // plan.disabled = true;
            // if(plan.isBundle){
            //   plan.disabled = false;
            // }else{
            //   plan.disabled = false;
            // }

          }
        }
      });
    }, 1000);
  }

  public getindexofplan(obj: any) {

    //console.log(obj)
    let plansproductarray = JSON.parse(sessionStorage.getItem("plansummary") || '[]');

    for (let i = 0; i < plansproductarray.length; i++) {
      if (obj.isBundle == false) {
        if (plansproductarray[i].id == obj.id) {

          if (plansproductarray[i].paidByCompany == 1) {
            plansproductarray[i].products.forEach((product: any, index: any) => {
              const dom: HTMLElement = this.elementRef.nativeElement;
              const plan: any = dom.querySelector("#plancheck" + product.id);

              if (plan) {
                // plan.disabled = false;
              }
            })

          }
          return i;
        }
      } else {
        if (plansproductarray[i].id == obj.id) {
          if (plansproductarray[i].paidByCompany == 1) {
            plansproductarray[i].products.forEach((product: any, index: any) => {
              const dom: HTMLElement = this.elementRef.nativeElement;
              const plan: any = dom.querySelector("#plancheck" + product.id);

              if (plan) {
                plan.disabled = false;
              }
            })

          }
          return i;
        }
      }
    }
  }

  toggleItem1(item: any): void {
    item.expanded = !item.expanded;
  }
  toggleItem2(item: any): void {
    item.expanded = !item.expanded;
  }

  public removeplansummary(obj: any, group: any, pckage: any, e: any) {



    console.log(obj)
    let planSummary = JSON.parse(sessionStorage.getItem("plansummary") || '[]');

    if (obj.planLevel == 15) {
      for (let i = 0; i < planSummary.length; i++) {

        if (planSummary[i].planLevel == 18) {
          planSummary[i].options = []
        }

      }

    }

    if (planSummary) {

      let index: any = this.getindexofplan(obj);
      if (index > -1) {
        planSummary.splice(index, 1);
      } else {

        return;
      }

      var newselectedplans: any = {};
      for (var i = 0; i < planSummary.length; i++) {
        newselectedplans[planSummary[i].id] = i;
      }

      sessionStorage.setItem("selectedPlans", JSON.stringify(newselectedplans));

      let gstprice = 0;
      let hstprice = 0;
      let pstprice = 0;
      let qstprice = 0;

      if (obj.gst > 0) {
        gstprice = obj.planPrice * obj.gst;


        obj['gstPrice'] = gstprice
          ? this._decimalPipe.transform(gstprice, '1.2-2')
          : 0;
        obj['gstPrice'] = parseFloat(obj['gstPrice']);
      } else {
        obj["gstPrice"] = 0;
      }

      if (obj.hst > 0) {
        hstprice = obj.planPrice * obj.hst;




        obj['hstPrice'] = hstprice
          ? this._decimalPipe.transform(hstprice, '1.2-2')
          : 0;
        obj['hstPrice'] = parseFloat(obj['hstPrice']);

      } else {
        obj["hstPrice"] = 0;
      }

      if (obj.pst > 0) {
        pstprice = obj.planPrice * obj.pst;


        obj['pstPrice'] = pstprice
          ? this._decimalPipe.transform(pstprice, '1.2-2')
          : 0;
        obj['pstPrice'] = parseFloat(obj['pstPrice']);




      } else {
        obj["pstPrice"] = 0;
      }
      if (obj.qst > 0) {
        qstprice = obj.planPrice * obj.qst;

        obj['qstPrice'] = qstprice
          ? this._decimalPipe.transform(qstprice, '1.2-2')
          : 0;
        obj['qstPrice'] = parseFloat(obj['qstPrice']);
      } else {
        obj["qstPrice"] = 0;
      }

      obj["taxUI"] = "";
      if (obj["gstCheck"]) {
        obj["taxUI"] += "<span>";
        if (obj["gstPrice"] == 0) {
          obj["taxUI"] += "-";
        } else {
          obj["taxUI"] +=
            "$" +
            this._decimalPipe.transform(obj["gstPrice"], "1.2-2") +
            "&nbsp;(GST)";
        }
        obj["taxUI"] += "</span>";
      }

      if (obj["pstCheck"]) {
        obj["taxUI"] += "<span>";
        if (obj["pstPrice"] == 0) {
          obj["taxUI"] += "-";
        } else {
          obj["taxUI"] +=
            "$" +
            this._decimalPipe.transform(obj["pstPrice"], "1.2-2") +
            "&nbsp;(PST)";
        }
        obj["taxUI"] += "</span>";
      }

      if (obj["qstCheck"]) {
        obj["taxUI"] += "<span>";
        if (obj["qstPrice"] == 0) {
          obj["taxUI"] += "-";
        } else {
          obj["taxUI"] +=
            "$" +
            this._decimalPipe.transform(obj["qstPrice"], "1.2-2") +
            "&nbsp;(QST)";
        }
        obj["taxUI"] += "</span>";
      }

      if (obj["hstCheck"]) {
        obj["taxUI"] += "<span> ";
        if (obj["hstPrice"] == 0) {
          obj["taxUI"] += "-";
        } else {
          obj["taxUI"] +=
            "$" +
            this._decimalPipe.transform(obj["hstPrice"], "1.2-2") +
            "&nbsp;(HST)";
        }
        obj["taxUI"] += "</span>";
      }

      if (
        !obj["hstCheck"] &&
        !obj["gstCheck"] &&
        !obj["pstCheck"] &&
        !obj["qstCheck"]
      ) {
        obj["taxUI"] += "<span>-";

        obj["taxUI"] += "</span>";
      }

      // ////this.consoleMessage(object["taxUI"])



      obj['tax'] = gstprice + hstprice + pstprice + qstprice
        ? this._decimalPipe.transform(gstprice + hstprice + pstprice + qstprice, '1.2-2')
        : 0;
      obj['tax'] = parseFloat(obj['tax']);
      (obj["totalPrice"] =
        obj.planPrice + gstprice + hstprice + pstprice + qstprice),
        (obj["totalUI"] =
          "$" +
          parseFloat(
            obj.planPrice + gstprice + hstprice + pstprice + qstprice
          ));

      obj["total"] = parseFloat(
        obj.planPrice + gstprice + hstprice + pstprice + qstprice
      );

      let updatedSum = this.removetosum(obj.totalPrice);
      this.planssummarymain = [];
      this.planssummaryopt = [];
      console.log(planSummary)

      planSummary.forEach((element: any) => {
        if (element.packagename != "Opt-in") {
          this.planssummarymain.push(element);
        } else {
          this.planssummaryopt.push(element);
        }
      });

      sessionStorage.setItem(
        "plansummarymain",
        JSON.stringify(this.planssummarymain)
      );
      sessionStorage.setItem(
        "plansummaryopt",
        JSON.stringify(this.planssummaryopt)
      );

      sessionStorage.setItem("plansummary", JSON.stringify(planSummary));



      this.planCoverafeFunction();








      setTimeout(() => {
        let selectplans =
          JSON.parse(sessionStorage.getItem("plansummarymain") || '[]') || "";

        //console.log(pckage);
        //console.log(group);

        let adddisabledcompanypaidproductid: any = []

        if (
          group.categorization.coveredByCompany == 1
          ||
          group.categorization.paidByEmployee == 1
        ) {
          pckage.groups.forEach((element: any) => {
            if (element.categorization.paidByCompany == 1) {
              if (group?.parentId == element?.parentId) {
                element.plans.forEach((plan: any) => {

                  let pl = { ...plan, ...element.categorization }
                  Object.keys(plan.productAddonss).forEach((key) => {
                    plan.productAddonss[key].forEach((product: any) => {
                      //console.log(product)
                      //console.log(pl)
                      if (pl.isBundle) {
                        adddisabledcompanypaidproductid.push(
                          pl,
                        );
                      } else {
                        adddisabledcompanypaidproductid.push(product.planlevel);
                      }

                    });
                  });
                });
              }
            }
          });



          adddisabledcompanypaidproductid = adddisabledcompanypaidproductid.filter(
            (item: any) => item !== undefined && item !== null
          );
          console.log(adddisabledcompanypaidproductid);

          for (let i = 0; i < adddisabledcompanypaidproductid.length; i++) {
            // adddisabledcompanypaidproductid.forEach((element: any, index: any) => {
            const dom: HTMLElement = this.elementRef.nativeElement;
            // const plan: any = dom.querySelector("#plancheck" + adddisabledcompanypaidproductid[i].id);


            // const planCheck1 = this.renderer.selectRootElement("#plancheck" + element.id, true);

            let selectPlanCheck;
            if (obj?.isBundle == true) {
              selectPlanCheck = selectplans.some(function (el: any) {
                return el.packageId == adddisabledcompanypaidproductid[i].packageId && el.planLevelParent == adddisabledcompanypaidproductid[i].planLevel_parentId;
              })
            }
            else {
              selectPlanCheck = selectplans.some(function (el: any) {
                return el.packageId == adddisabledcompanypaidproductid[i].packageId;
              })



              let planData: any = dom.querySelectorAll("#plancheck" + adddisabledcompanypaidproductid[i].id);
              let targetClassName = 'cp_plan'
              if (e.className.includes('cp_plan')) {
                targetClassName = 'cp_plan'
              }
              else if (e.className.includes('cc_plan')) {
                targetClassName = 'cc_plan'
              }
              else if (e.className.includes('ep_plan')) {
                targetClassName = 'ep_plan'
              }

              for (let i = 0; i < planData.length; i++) {
                console.log(planData[i])
                if (planData[i].className.includes('cp_plan')) {
                  planData[i].click()
                  return false;

                }
              }


            }

            //console.log(selectPlanCheck)
            if (selectPlanCheck) {

              selectplans.forEach((products: any) => {

                if (products.packageId == adddisabledcompanypaidproductid[i].packageId) {

                  products.products.forEach((prod: any) => {
                    // if (prod.id == adddisabledcompanypaidproductid[i].id) {
                    if (prod.planLevel == adddisabledcompanypaidproductid[i].id) {
                    } else {
                      //console.log("checkHere")
                      // $("#plancheck" + element.id).click()
                    }
                  });
                } else {
                  // //this.consoleMessage("CheckHere1")

                }
              });
            } else {


              const dom: HTMLElement = this.elementRef.nativeElement;

              let coverage = adddisabledcompanypaidproductid[i].companyPaidCoverage?.replace("SELECTIVE_", "")
              //console.log(coverage)

              let planData;
              if (coverage && coverage != "DIRECT") {
                planData = dom.querySelectorAll("#plancheck" + adddisabledcompanypaidproductid[i].id + ".coverage" + coverage)
                //console.log(planData)
                let targetClassName = 'cp_plan'
                if (e.className.includes('cp_plan')) {
                  targetClassName = 'cp_plan'
                }
                else if (e.className.includes('cc_plan')) {
                  targetClassName = 'cc_plan'
                }
                else if (e.className.includes('ep_plan')) {
                  targetClassName = 'ep_plan'
                }

                planData.forEach((element: any) => {
                  if (element.className.includes('cp_plan')) {

                    //console.log(element)
                    element.click()
                  }
                });
                break;
              }
              else {
                planData = dom.querySelectorAll("#plancheck" + adddisabledcompanypaidproductid[i].id);
                let targetClassName = 'cp_plan'
                if (e.className.includes('cp_plan')) {
                  targetClassName = 'cp_plan'
                }
                else if (e.className.includes('cc_plan')) {
                  targetClassName = 'cc_plan'
                }
                else if (e.className.includes('ep_plan')) {
                  targetClassName = 'ep_plan'
                }

                planData.forEach((element: any) => {
                  if (element.className.includes('cp_plan')) {

                    //console.log(element)
                    element.click()
                  }
                });
              }


            }
          }
        }




        setTimeout(() => {
          let selectplans =
            JSON.parse(sessionStorage.getItem("plansummarymain") || '[]') || "";

          selectplans.forEach((products: any) => {
            if (products.paidByCompany == 1) {
              products.products.forEach((element: any) => {
                const dom: HTMLElement = this.elementRef.nativeElement;
                const plan: any = dom.querySelector("#plancheck" + element.id);

                //this.consoleMessage(plan);

                if (plan) {

                }


                const samePlanIdElements = dom.querySelectorAll('#' + e.id);
                //console.log(e)
                let targetClassName = 'cp_plan'
                if (e.className.includes('cp_plan')) {
                  targetClassName = 'cp_plan'
                }
                else if (e.className.includes('cc_plan')) {
                  targetClassName = 'cc_plan'
                }
                else if (e.className.includes('ep_plan')) {
                  targetClassName = 'ep_plan'
                }

                for (let i = 0; i < samePlanIdElements.length; i++) {
                  let elem = samePlanIdElements[i];
                  let element: any = elem;
                  if (elem.className.includes('cp_plan')) {
                    element.disabled = false;
                    if (element.checked) {
                      element.disabled = true;

                    }
                  }

                }
              });
            }
          });
        }, 1000);
      }, 100);



      setTimeout(() => {
        let selectplansInfo =
          JSON.parse(sessionStorage.getItem("plansummary") || '[]') || "";

        //console.log(selectplansInfo)

        if (selectplansInfo.length > 0) {
          for (let i = 0; i < selectplansInfo.length; i++) {
            if (selectplansInfo[i].id == obj.id) {

            }

            else {
              setTimeout(() => {
                const dom: HTMLElement = this.elementRef.nativeElement;
                const plan = dom.querySelectorAll(".plan-description-span.single" + ".plancheck" + obj.id);
                const plan2 = dom.querySelectorAll(".plan-description-span.couple" + ".plancheck" + obj.id);
                const plan3 = dom.querySelectorAll(".plan-description-span.family" + ".plancheck" + obj.id);
                /*  //console.log(plan) */


                plan.forEach((elem: any) => {
                  (elem as HTMLElement).style.display = 'block';
                });

                plan2.forEach((elem: any) => {
                  (elem as HTMLElement).style.display = 'block';
                });
                plan3.forEach((elem: any) => {
                  (elem as HTMLElement).style.display = 'block';
                });



              }, 1000);
            }
          }



        }
        else {
          setTimeout(() => {
            const dom: HTMLElement = this.elementRef.nativeElement;
            const plan = dom.querySelectorAll(".plan-description-span.single" + ".plancheck" + obj.id);
            const plan2 = dom.querySelectorAll(".plan-description-span.couple" + ".plancheck" + obj.id);
            const plan3 = dom.querySelectorAll(".plan-description-span.family" + ".plancheck" + obj.id);
            /*  //console.log(plan) */


            plan.forEach((elem: any) => {
              (elem as HTMLElement).style.display = 'block';
            });

            plan2.forEach((elem: any) => {
              (elem as HTMLElement).style.display = 'block';
            });
            plan3.forEach((elem: any) => {
              (elem as HTMLElement).style.display = 'block';
            });



          }, 1000);
        }
      }, 1000);

      setTimeout(() => {
        let selectplansInfo = JSON.parse(sessionStorage.getItem("plansummary") || '[]') || "";
        if (selectplansInfo.length === 0) {
          if (obj.groupName != "Complete Executive Care") {
            this.autoSelectCompanyPaidPlans()
          }


        }
      }, 1000);
    }
  }
  public addtoslectplans(planid: number, plansumamryindex: number) {
    ////this.logger.log("beforeaddtoplans")
    ////this.logger.log(planid)
    ////this.logger.log(plansumamryindex)
    let selectedPlans = JSON.parse(sessionStorage.getItem("selectedPlans") || "{}");
    ////this.logger.log(selectedPlans)
    selectedPlans[planid] = plansumamryindex;
    ////this.logger.log("afteraddtoplans")
    ////this.logger.log(selectedPlans)
    sessionStorage.setItem("selectedPlans", JSON.stringify(selectedPlans));
  }


  public getslectedplans(planid: number) {
    ////this.logger.log(planid)
    let selectedPlans = JSON.parse(sessionStorage.getItem("selectedPlans") || "{}");
    ////this.logger.log(selectedPlans)
    return selectedPlans[planid];
  }
  public addtosum(amount: any) {
    //this.logger.log("addtosum" + amount);

    // amount = Math.round((amount + Number.EPSILON) * 100) / 100;
    let selectedPlansAmount = parseFloat(
      sessionStorage.getItem('totalAmount') || '0.00'
    );

    selectedPlansAmount = selectedPlansAmount + parseFloat(amount);
    // let selectedPlansAmount:any = parseFloat(sessionStorage.getItem("totalAmount") || "0.00");

    // // selectedPlansAmount = selectedPlansAmount + amount;
    // selectedPlansAmount = selectedPlansAmount+parseFloat(amount)
    //this.logger.log("selectedPlansAmount" + selectedPlansAmount);

    console.log(selectedPlansAmount)
    sessionStorage.setItem(
      "totalAmount",
      this._decimalPipe.transform(selectedPlansAmount, "1.2-2").replace(/,/g, "")
    );

    sessionStorage.setItem(
      "totalAmountUI",
      "$" + this._decimalPipe.transform(selectedPlansAmount, "1.2-2").replace(/,/g, "")
    );

    // this.planAmount = selectedPlansAmount


    //this.logger.log("palnamopunt" + this.planAmount);
    return selectedPlansAmount;
    // //////this.logger.log(this.planAmount )
  }

  public removetosum(amount: number) {
    let selectedPlansAmount = parseFloat(sessionStorage.getItem("totalAmount").replace(/,/g, ""));

    selectedPlansAmount = selectedPlansAmount - amount;
    sessionStorage.setItem(
      "totalAmount",
      this._decimalPipe.transform(selectedPlansAmount, "1.2-2").replace(/,/g, "")
    );
    sessionStorage.setItem(
      "totalAmountUI",
      "$" + this._decimalPipe.transform(selectedPlansAmount, "1.2-2").replace(/,/g, "")
    );

    // this.planAmount = selectedPlansAmount
    return selectedPlansAmount;
  }

  calculateBasePlanDeltasforCCplans1(ccplanspackages, baseplans, compnayplans) {


    let modifiedCCplanPackages = []
    for (let i = 0; i < ccplanspackages.length; i++) {
      let modifiedCCPackage = ccplanspackages[i]
      //this.logger.log(ccplanspackages[i].name)
      //this.logger.log(ccplanspackages[i].id)
      let CCplansgroups = ccplanspackages[i].groupsCC

      modifiedCCPackage.groupsCC = []
      for (let CCplangroup of CCplansgroups) {

        let modifiedCCgroup = CCplangroup
        //this.logger.log(CCplangroup.id)
        //this.logger.log(CCplangroup.parentId)
        //this.logger.log(CCplangroup.name)
        let CCplans = CCplangroup.plans
        modifiedCCgroup.plans = []
        for (let CCplan of CCplans) {

          let modifiedCCplan = CCplan
          //this.logger.log(CCplan.id)
          //this.logger.log(CCplan.isBundle)
          //this.logger.log(CCplan.name)

          CCplan.planLevel_parentId = CCplangroup.parentId

          let payroll = true;
          let EmployeeChoice = 0

          if (this.CORP_PAYROLL_NOT_MANDATORY_PACKAGES.includes(CCplan.packageId)) {

            if (EmployeeChoice == 2) {
              payroll = false;
            }

          }
          else {
            if (this.CORP_PAYROLL_NOT_MANDATORY_PLANLEVELS.includes(CCplan.planLevel)) {

              if (EmployeeChoice == 2) {
                payroll = false;
              }
            }
          }
          let selectedCCplanProductarray = CCplan.productAddonss[CCplan.name];

          if (CCplan.isBundle) {
            //this.logger.log("BundlePlan")

            //this.logger.log(baseplans)
            var filtered_base_plans = baseplans.filter(function (plan) {
              //this.logger.log(plan)
              //cp_plans

              //this.logger.log(CCplan.packageId,plan.packageId)
              //this.logger.log(CCplan.planLevel_parentId,plan.planLevel_parentId)
              //this.logger.log(CCplan.planLevel,plan.planLevel)

              return (
                CCplan.packageId == plan.packageId &&
                CCplan.planLevel_parentId == plan.planLevel_parentId &&
                CCplan.planLevel >= plan.planLevel
              );
            });

            var filtered_compnay_plans = compnayplans.filter(function (plan) {
              //this.logger.log(plan)
              //cp_plans

              //this.logger.log(CCplan.packageId,plan.packageId)
              //this.logger.log(CCplan.planLevel_parentId,plan.planLevel_parentId)
              //this.logger.log(CCplan.planLevel,plan.planLevel)

              return (
                CCplan.packageId == plan.packageId &&
                CCplan.planLevel_parentId == plan.planLevel_parentId &&
                CCplan.planLevel >= plan.planLevel
              );
            });

            console.log(filtered_base_plans);

            //this.logger.log(filtered_compnay_plans)
            let selectedBasePlan;
            let selectedCompnayPlan;
            let DeltaPlan;
            let selectedBaseplanProduct;
            let selectedBaseplanProductsArray = [];
            let selectedCompanyplanProduct;
            let selectedCompanyplanProductsArray = [];

            if (filtered_base_plans.length == 0) {
            } else if (filtered_base_plans.length == 1) {
              selectedBasePlan = filtered_base_plans[0];
              selectedCompnayPlan = filtered_compnay_plans[0];
            } else {
              var filtered_base_plans2 = filtered_base_plans.filter(function (plan) {


                return (
                  CCplan.id == plan.id
                );
              });
              var filtered_compnay_plans2 = filtered_compnay_plans.filter(function (plan) {
                ////this.logger.log(plan)
                //cp_plans

                // //this.logger.log(CCplan.packageId,plan.packageId)
                // //this.logger.log(CCplan.planLevel_parentId,plan.planLevel_parentId)
                // //this.logger.log(CCplan.planLevel,plan.planLevel)

                return (
                  CCplan.id == plan.id
                );
              });
              selectedBasePlan = filtered_base_plans2[0];
              selectedCompnayPlan = filtered_compnay_plans2[0];
              // alert("morethan1")
            }
            console.log({ selectedBasePlan })

            if (selectedBasePlan) {
              // selectedBaseplanProduct = selectedBasePlan.productAddonss[selectedBasePlan.name][0]
              selectedBaseplanProductsArray = selectedBasePlan.productAddonss[selectedBasePlan.name];
              let selectedBaseplanProductsArray2 = [];

              if (CCplan.packageId == 5 || CCplan.packageId == 10) {
                selectedBaseplanProductsArray2 = selectedBaseplanProductsArray
                for (let i = 0; i < selectedCCplanProductarray.length - selectedBaseplanProductsArray.length; i++) {
                  selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[selectedBaseplanProductsArray.length - 1]);
                }
                selectedBaseplanProductsArray = selectedBaseplanProductsArray2
              }
              else {
                let productCoverageFound = false;
                for (let i = 0; i < selectedCCplanProductarray.length; i++) {
                  for (let j = 0; j < selectedBaseplanProductsArray.length; j++) {

                    if (selectedCCplanProductarray[i].planCoverage == selectedBaseplanProductsArray[j].planCoverage) {
                      productCoverageFound = true
                      selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[j])
                      break;
                    }


                  }
                  if (!productCoverageFound) {



                    selectedBasePlan = {};
                    selectedBaseplanProduct = {};
                    selectedBaseplanProduct.calculatedTax = {};
                    selectedBaseplanProduct.calculatedTax.price = 0;
                    selectedBaseplanProduct.calculatedTax.tax = 0;
                    selectedBaseplanProduct.calculatedTax.total = 0;
                    selectedBaseplanProduct.name = "NA";
                    selectedBaseplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
                    selectedBaseplanProductsArray2.push(selectedBaseplanProduct);



                  }

                }
                selectedBaseplanProductsArray = selectedBaseplanProductsArray2
              }




            } else {
              selectedBasePlan = {};
              selectedBaseplanProduct = {};
              selectedBaseplanProduct.calculatedTax = {};
              selectedBaseplanProduct.calculatedTax.price = 0;
              selectedBaseplanProduct.calculatedTax.tax = 0;
              selectedBaseplanProduct.calculatedTax.total = 0;
              selectedBaseplanProduct.name = "NA";

              for (let i = 0; i < selectedCCplanProductarray.length; i++) {
                selectedBaseplanProductsArray.push(selectedBaseplanProduct);
              }
            }

            if (selectedCompnayPlan) {
              // selectedCompanyplanProduct = selectedCompnayPlan.productAddonss[selectedCompnayPlan.name][0]
              selectedCompanyplanProductsArray =
                selectedCompnayPlan.productAddonss[selectedCompnayPlan.name];


              let selectedCompanyplanProductsArray2 = [];

              if (CCplan.packageId == 5 || CCplan.packageId == 10) {
                selectedCompanyplanProductsArray2 = selectedCompanyplanProductsArray
                for (let i = 0; i < selectedCCplanProductarray.length - selectedCompanyplanProductsArray.length; i++) {
                  selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray[selectedCompanyplanProductsArray.length - 1]);
                }
                selectedCompanyplanProductsArray = selectedCompanyplanProductsArray2

              } else {
                let productCoverageFound = false;
                for (let i = 0; i < selectedCCplanProductarray.length; i++) {
                  for (let j = 0; j < selectedCompanyplanProductsArray.length; j++) {

                    if (selectedCCplanProductarray[i].planCoverage == selectedCompanyplanProductsArray[j].planCoverage) {
                      productCoverageFound = true
                      selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray[j])
                      break;
                    }


                  }
                  if (!productCoverageFound) {


                    selectedCompanyplanProduct = {};
                    selectedCompanyplanProduct.calculatedTax = {};
                    selectedCompanyplanProduct.calculatedTax.planProductInfos = [];
                    selectedCompanyplanProduct.name = "NA";
                    selectedCompanyplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
                    selectedCompanyplanProductsArray2.push(selectedCompanyplanProduct);



                  }

                }
                selectedCompanyplanProductsArray = selectedCompanyplanProductsArray2
              }


            } else {
              selectedCompanyplanProduct = {};
              selectedCompanyplanProduct.calculatedTax = {};
              selectedCompanyplanProduct.calculatedTax.planProductInfos = [];
              for (let i = 0; i < selectedCCplanProductarray.length; i++) {
                selectedCompanyplanProductsArray.push(
                  selectedCompanyplanProduct
                );
              }
            }


            let upgradeText;
            let upgradepaymentText;
            if (payroll) {
              upgradeText = "Employee upgraded using payroll deduction";
              upgradepaymentText = "using payroll deduction";
              //this.logger.log("One subscription to parent/corp with base(company tax)+Delta(employee tax)")
            } else {
              upgradeText = "Employee upgraded using Direct payment";
              upgradepaymentText = "using Direct payment";
            }

            modifiedCCplan.products = []

            for (let i = 0; i < selectedCCplanProductarray.length; i++) {
              let selectedBaseplanProduct = selectedBaseplanProductsArray[i];
              let selectedCompanyplanProduct =
                selectedCompanyplanProductsArray[i];
              let selectedCCplanProduct = selectedCCplanProductarray[i];
              let companyTax =
                selectedCompanyplanProduct.calculatedTax.planProductInfos
                  .length > 0
                  ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
                    .taxRate
                  : 0;
              let companyTaxPercentage =
                selectedCompanyplanProduct.calculatedTax.planProductInfos
                  .length > 0
                  ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
                    .taxRatePercentage
                  : 0;
              let baseplanPrice = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax?.price
              );
              let baseplanTaxorg = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.tax
              );
              let baseplanTax = adjustWith2DecimalsForUI(
                baseplanPrice * companyTax
              );
              let baseplanTotalorg = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.total
              );
              let baseplanTotal = adjustWith2DecimalsForUI(
                baseplanPrice + baseplanTax
              );
              let employeeTax =
                selectedCCplanProduct.calculatedTax.planProductInfos.length > 0
                  ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
                    .taxRate
                  : 0;
              let employeeTaxPercentage =
                selectedCCplanProduct.calculatedTax.planProductInfos.length > 0
                  ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
                    .taxRatePercentage
                  : 0;
              let deltaplanPrice = adjustWith2DecimalsForUI(
                selectedCCplanProduct.calculatedTax?.price -
                selectedBaseplanProduct.calculatedTax?.price
              );

              if (selectedBaseplanProduct.name == 'NA') {
                //this.logger.log("No Base plan/product for this upgrade plans/product")
                companyTax = employeeTax
                companyTaxPercentage = employeeTaxPercentage
              }
              let deltaplanTax = adjustWith2DecimalsForUI(
                deltaplanPrice *
                (this.deltaCompanyTax ? companyTax : employeeTax)
              );
              let deltaplanTotal = adjustWith2DecimalsForUI(
                deltaplanPrice + deltaplanTax
              );
              let combinedplanPrice = adjustWith2DecimalsForUI(
                baseplanPrice + deltaplanPrice
              );
              let combinedplanbasePrice = baseplanPrice;
              let combinedplanDeltaprice = deltaplanPrice;
              let combinedplanTax = adjustWith2DecimalsForUI(
                baseplanTax + deltaplanTax
              );
              let combinedplanCompanyTax = baseplanTax;
              let combinedplanEmployeeTax =
                adjustWith2DecimalsForUI(deltaplanTax);
              let combinedplanCompanyTaxPercentage = companyTaxPercentage;
              let combinedplanemployeeTaxPercentage = this.deltaCompanyTax
                ? companyTaxPercentage
                : employeeTaxPercentage;
              let combinedplanemployeeTaxPercentageorg = employeeTaxPercentage;

              let combinedplanTotal = adjustWith2DecimalsForUI(
                baseplanTotal + deltaplanTotal
              );

              let scenario = `Employee Upgrade from ${selectedBasePlan.name} to ${CCplan.name}`;
              let planName = `${CCplan.name} (${upgradeText})`;
              let compnayShareStatement = `${CCplan.name} Contribution`;
              let employeeShareStatement = `${CCplan.name} upgrade cost`;
              let planDescription = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanTotal} and Employee- pays ${upgradepaymentText} ${deltaplanTotal} `;
              let planDescription2 = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanPrice}(with tax:${companyTaxPercentage}) and Employee- pays ${upgradepaymentText} ${deltaplanPrice}(with tax:${employeeTaxPercentage}) `;
              let type;

              if (payroll) {
                type = "Split with payroll deduction";
              } else {
                type = "Split with direct pay";
              }
              let basePlanDetails = {
                planId: selectedBasePlan.id, //0
                planName: selectedBasePlan.name, //NA
                planLevelId: selectedBasePlan.planLevel, //0
                amount: baseplanPrice, //0
                amountUI: `$${baseplanPrice}`, //0
                tax: baseplanTax,
                total: baseplanTotal,
                taxUI: `$${baseplanTax}`, //companyTaxpercentage
                totalUI: `$${baseplanTotal}`,
                planLevelName: selectedBasePlan.groupName || "", //if it is Bundle
                planFrequencyID: selectedBasePlan.frqMonthly || "",
                planFusebillID: selectedBasePlan.fusebillId || "",
                products: [selectedBaseplanProduct],
                planLevel_parentId: selectedBasePlan.planLevel_parentId,
                packageName: selectedBasePlan.packageName,
                packageId: selectedBasePlan.packageId,
              };

              let obj = {
                companyTax,
                companyTaxPercentage,
                baseplanPrice,
                baseplanTaxorg,
                baseplanTax,
                baseplanTotalorg,
                baseplanTotal,
                employeeTax,
                employeeTaxPercentage,
                deltaplanPrice,
                deltaplanTax,
                deltaplanTotal,
                combinedplanPrice,
                combinedplanbasePrice,
                combinedplanDeltaprice,
                combinedplanTax,
                combinedplanCompanyTax,
                combinedplanEmployeeTax,
                combinedplanCompanyTaxPercentage,
                combinedplanemployeeTaxPercentage,
                combinedplanTotal,
                payroll,
                scenario,
                planName,
                compnayShareStatement,
                employeeShareStatement,
                planDescription,
                planDescription2,
                type,
                basePlanDetails,
                combinedplanemployeeTaxPercentageorg,
              };

              let ccProduct: any = {}
              ccProduct.upgradeCalculation = obj;
              modifiedCCplan.products.push(ccProduct)
              modifiedCCplan.upgradeCalculation = obj;
            }

          }
          else {

            var filtered_base_plans = baseplans.filter(function (plan) {

              console.log(plan)
              //cp_plans

              console.log(CCplan.packageId, plan.packageId)
              console.log(CCplan.planLevel_parentId, plan.planLevel_parentId)
              console.log(CCplan.planLevel, plan.planLevel)

              return (
                CCplan.packageId == plan.packageId &&
                CCplan.planLevel_parentId == plan.planLevel_parentId &&
                CCplan.planLevel >= plan.planLevel
              );
            });

            var filtered_compnay_plans = compnayplans.filter(function (plan) {

              console.log(plan)
              //cp_plans

              console.log(CCplan.packageId, plan.packageId)
              console.log(CCplan.planLevel_parentId, plan.planLevel_parentId)
              console.log(CCplan.planLevel, plan.planLevel)

              return (
                CCplan.packageId == plan.packageId &&
                CCplan.planLevel_parentId == plan.planLevel_parentId &&
                CCplan.planLevel >= plan.planLevel
              );
            });


            let selectedBasePlan;
            let selectedCompnayPlan;
            let DeltaPlan;
            if (filtered_base_plans.length == 0) {

            } else if (filtered_base_plans.length == 1) {
              selectedBasePlan = filtered_base_plans[0]
              selectedCompnayPlan = filtered_compnay_plans[0]

            } else {
              //this.logger.log(filtered_base_plans.length)
            }

            let selectedbaseplanproduct
            let selectedBaseplanProduct

            if (selectedBasePlan) {
              for (let planname in selectedBasePlan.productAddonss) {


                let products = selectedBasePlan.productAddonss[planname]

                if (products.length == 0) {

                } else if (products.length == 1) {
                  selectedbaseplanproduct = products[0]
                  // selectedCompnayPlan= filtered_compnay_plans[0]

                } else {
                  //this.logger.log(products.length)
                }
              }
              //this.logger.log(selectedbaseplanproduct)
              selectedBaseplanProduct = selectedbaseplanproduct

            }
            else {
              selectedBasePlan = {}
              selectedBaseplanProduct = {}
              selectedBaseplanProduct.calculatedTax = {}
              selectedBaseplanProduct.calculatedTax.price = 0
              selectedBaseplanProduct.calculatedTax.tax = 0
              selectedBaseplanProduct.calculatedTax.total = 0
              selectedBaseplanProduct.name = "NA"
            }





            let CCplanProduct;

            for (let planname in CCplan.productAddonss) {
              let products = CCplan.productAddonss[planname]
              if (products.length == 0) {

              } else if (products.length == 1) {
                CCplanProduct = products[0]
                // selectedCompnayPlan= filtered_compnay_plans[0]

              } else {
                //this.logger.log(products.length)
              }
            }
            console.log({ CCplanProduct, CCplan })
            let selectedCCplanProduct = CCplanProduct


            // //this.logger.log(selectedCCplanProduct.calculatedTax?.price)
            // //this.logger.log(selectedCCplanProduct.calculatedTax.tax)
            // //this.logger.log(selectedCCplanProduct.calculatedTax.total)


            // //this.logger.log("Delta")
            // //this.logger.log(selectedCCplanProduct.calculatedTax?.price-selectedBaseplanProduct.calculatedTax?.price)
            // //this.logger.log("EmployeeTax")
            // //this.logger.log(selectedCCplanProduct.calculatedTax.planProductInfos.length>0?selectedCCplanProduct.calculatedTax.planProductInfos[0].taxRate:0)
            // //this.logger.log(selectedCCplanProduct.calculatedTax.planProductInfos.length>0?selectedCCplanProduct.calculatedTax.planProductInfos[0].taxRatePercentage:0)

            let selectedcompanyplanproduct
            let selectedCompanyplanProduct

            if (selectedCompnayPlan) {
              for (let planname in selectedCompnayPlan.productAddonss) {

                //this.logger.log(planname)
                //this.logger.log(selectedCompnayPlan.productAddonss[planname])
                let products = selectedCompnayPlan.productAddonss[planname]

                if (products.length == 0) {

                } else if (products.length == 1) {
                  selectedcompanyplanproduct = products[0]
                  // selectedCompnayPlan= filtered_compnay_plans[0]

                } else {
                  //this.logger.log(products.length)
                }
              }
              selectedCompanyplanProduct = selectedcompanyplanproduct

              //this.logger.log("CompanyTax")
              //this.logger.log(selectedCompanyplanProduct.calculatedTax.planProductInfos.length>0?selectedCompanyplanProduct.calculatedTax.planProductInfos[0].taxRate:0)
              //this.logger.log(selectedCompanyplanProduct.calculatedTax.planProductInfos.length>0?selectedCompanyplanProduct.calculatedTax.planProductInfos[0].taxRatePercentage:0)

            }
            else {
              selectedCompanyplanProduct = {}
              selectedCompanyplanProduct.calculatedTax = {}
              selectedCompanyplanProduct.calculatedTax.planProductInfos = []
            }


            let upgradeText;
            let upgradepaymentText;
            if (payroll) {
              upgradeText = "Employee upgraded using payroll deduction"
              upgradepaymentText = "using payroll deduction"
              //this.logger.log("One subscription to parent/corp with base(company tax)+Delta(employee tax)")
            }
            else {
              upgradeText = "Employee upgraded using Direct payment"
              upgradepaymentText = "using Direct payment"


            }
            console.log({ selectedCCplanProduct })
            let companyTax = selectedCompanyplanProduct.calculatedTax?.planProductInfos.length > 0 ? selectedCompanyplanProduct.calculatedTax?.planProductInfos[0].taxRate : 0
            let companyTaxPercentage = selectedCompanyplanProduct.calculatedTax?.planProductInfos.length > 0 ? selectedCompanyplanProduct.calculatedTax?.planProductInfos[0].taxRatePercentage : 0
            let baseplanPrice = adjustWith2DecimalsForUI(selectedBaseplanProduct.calculatedTax?.price)
            let baseplanTaxorg = adjustWith2DecimalsForUI(selectedBaseplanProduct.calculatedTax?.tax)
            let baseplanTax = adjustWith2DecimalsForUI(baseplanPrice * companyTax)
            let baseplanTotalorg = adjustWith2DecimalsForUI(selectedBaseplanProduct.calculatedTax?.total)
            let baseplanTotal = adjustWith2DecimalsForUI(baseplanPrice + baseplanTax)
            let employeeTax = selectedCCplanProduct.calculatedTax?.planProductInfos.length > 0 ? selectedCCplanProduct.calculatedTax.planProductInfos[0].taxRate : 0
            let employeeTaxPercentage = selectedCCplanProduct.calculatedTax?.planProductInfos.length > 0 ? selectedCCplanProduct.calculatedTax?.planProductInfos[0].taxRatePercentage : 0

            let deltaplanPrice = adjustWith2DecimalsForUI(selectedCCplanProduct.calculatedTax?.price - selectedBaseplanProduct.calculatedTax?.price)
            if (selectedBaseplanProduct.name == 'NA') {
              //this.logger.log("No Base plan/product for this upgrade plans/product")
              companyTax = employeeTax
              companyTaxPercentage = employeeTaxPercentage
            }
            let deltaplanTax = adjustWith2DecimalsForUI(deltaplanPrice * (this.deltaCompanyTax ? companyTax : employeeTax))
            // let deltaplanTax = deltaplanPrice*(this.deltaCompanyTax?companyTax:employeeTax)

            let deltaplanTotal = adjustWith2DecimalsForUI(deltaplanPrice + deltaplanTax)



            let combinedplanPrice = baseplanPrice + deltaplanPrice
            let combinedplanbasePrice = baseplanPrice
            let combinedplanDeltaprice = deltaplanPrice
            let combinedplanTax = adjustWith2DecimalsForUI(baseplanTax + deltaplanTax)
            let combinedplanCompanyTax = baseplanTax
            let combinedplanEmployeeTax = adjustWith2DecimalsForUI(deltaplanTax)
            let combinedplanCompanyTaxPercentage = companyTaxPercentage
            let combinedplanemployeeTaxPercentage = this.deltaCompanyTax ? companyTaxPercentage : employeeTaxPercentage
            let combinedplanemployeeTaxPercentageorg = employeeTaxPercentage
            let combinedplanTotal = adjustWith2DecimalsForUI(baseplanTotal + deltaplanTotal)

            let scenario = `Employee Upgrade from ${selectedBaseplanProduct.name} to ${selectedCCplanProduct.name}`
            let planName = `${CCplan.name}(${selectedCCplanProduct.name}) (${upgradeText})`
            let compnayShareStatement = `${CCplan.name}(${selectedCCplanProduct.name}) Contribution`
            let employeeShareStatement = `${CCplan.name}(${selectedCCplanProduct.name}) upgrade cost`
            let planDescription = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanTotal} and Employee- pays ${upgradepaymentText} ${deltaplanTotal} `
            let planDescription2 = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanPrice}(with tax:${companyTaxPercentage}) and Employee- pays ${upgradepaymentText} ${deltaplanPrice}(with tax:${employeeTaxPercentage}) `
            let type;

            if (payroll) {
              type = "Split with payroll deduction"
            } else {
              type = "Split with direct pay"

            }
            let basePlanDetails = {
              planId: selectedBasePlan.id || 0, //0
              planName: selectedBasePlan.name || "NA", //NA
              planLevelId: selectedBasePlan.planLevel || 0, //0
              amount: baseplanPrice || 0, //0
              amountUI: `$${baseplanPrice}` || 0, //0
              tax: baseplanTax,
              total: baseplanTotal,
              taxUI: `$${baseplanTax}`, //companyTaxpercentage
              totalUI: `$${baseplanTotal}`,
              planLevelName: selectedBasePlan.groupName || "", //if it is Bundle
              planFrequencyID: selectedBasePlan.frqMonthly || "",
              planFusebillID: selectedBasePlan.fusebillId || "",
              products: [selectedBaseplanProduct],
              planLevel_parentId: selectedBasePlan.planLevel_parentId || 0,
              packageName: selectedBasePlan.packageName || "",
              packageId: selectedBasePlan.packageId || 0
            };
            let obj = {
              companyTax, companyTaxPercentage, baseplanPrice, baseplanTaxorg, baseplanTax, baseplanTotalorg, baseplanTotal, employeeTax, employeeTaxPercentage,
              deltaplanPrice, deltaplanTax, deltaplanTotal, combinedplanPrice, combinedplanbasePrice, combinedplanDeltaprice, combinedplanTax,
              combinedplanCompanyTax, combinedplanEmployeeTax, combinedplanCompanyTaxPercentage, combinedplanemployeeTaxPercentage, combinedplanTotal, payroll,
              scenario, planName, compnayShareStatement, employeeShareStatement, planDescription, planDescription2, type, basePlanDetails, combinedplanemployeeTaxPercentageorg
            }

            //this.logger.log(obj)
            modifiedCCplan.upgradeCalculation = obj

          }
          modifiedCCgroup.plans.push(modifiedCCplan)

        }
        modifiedCCPackage.groupsCC.push(modifiedCCgroup)


      }

      modifiedCCplanPackages.push(modifiedCCPackage)


    }

    this.modifiedBlocksCoveredByCompany = modifiedCCplanPackages

    //this.logger.log(this.modifiedBlocksCoveredByCompany)
  }
  //   getCorporatePlans() {
  //      let getPlans = '/api/ap/admin/corporate/' + this.memberid + '/terminateConfigurationPlans'
  //         this.http.post(environment.apiUrl + getPlans, data, { headers: headers })
  //           .subscribe(async (response: any) => {
  //             // if (responce.status == '200') {

  //             sessionStorage.setItem('plansummaryLife', '[]');
  //             sessionStorage.setItem('planssummarymainLife', '[]');
  //             sessionStorage.setItem('plansummary', '[]');

  //             sessionStorage.setItem('selectedPlans', '{}');
  //             sessionStorage.setItem('selectedPlansLife', '{}');
  //             sessionStorage.setItem('plansummarymain', '[]');
  //             sessionStorage.setItem('plansummaryopt', '[]');
  //             sessionStorage.setItem('studentsPlansArray', '[]');
  //             sessionStorage.setItem('allproducts', '[]');
  //             sessionStorage.setItem('totalAmount', '');
  //             sessionStorage.setItem('totalAmountUI', '');
  //             sessionStorage.setItem('planDetailsArray', '[]');
  //             this.getEmployeePlans = response.data

  //             $('#showTerminateMemberDetailsCorpoarte').modal('show');
  //             $('#showTerminateMemberDetailsCorpoarteList').modal('show');
  //             // this.store.dispatch(loadCorporateData())




  //             // } else {
  //             //   Swal.fire({ title: "info", text: responce.data.message });
  //             // }

  //           }, (error) => {
  //             Swal.fire({ title: "Error", text: error.message || error.data.message });
  //           })

  // }




  // Converting Gig Member to Corporate here

  gigtoCorpConvertion() {
    let memberId = this.route.snapshot.params['id'];
    let date = this._CustomDatePipe.transform(this.effectiveDateForm.get('effectiveDate').value)
    let accessTokensession = sessionStorage.getItem('accessToken');
    let gigtermination = `/api/ap/member/${memberId}/configureMemberTermination?terminationDate=${date}`
    let endPoint = '/api/ap/admin/customer/' + memberId + '/convert-gig-to-corp';
    let accessToken = sessionStorage.getItem('accessToken');


    this.http
      .get(environment.apiUrl + gigtermination, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (response: any) => {
          if (response['status'] == 200) {
            let plansummarymain = JSON.parse(sessionStorage.getItem("plansummarymain")) || "";

            this.gigterminationRes = response.data

            if (this.continueWithExistingPlans == false && this.samePlansWithCorporate == false) {

              if (!this.gigterminationRes.plans) {
                this.gigterminationRes.plans = [];
              }

              plansummarymain.forEach((source) => {
                this.gigterminationRes.plans.push(source);
              });

            }

            else if (this.continueWithExistingPlans == false && this.samePlansWithCorporate == true) {

              if (!this.gigterminationRes.plans) {
                this.gigterminationRes.plans = [];
              }


              this.gigterminationRes.plans = this.plansDataarray;
            }
            else {
              if (!this.gigterminationRes.plans) {
                this.gigterminationRes.plans = [];
              }
            }

            // if(this.continueWithExistingPlans!=true){

            //     if (!this.gigterminationRes.plans) {
            //       this.gigterminationRes.plans = []; // Initialize plans if not already initialized
            //     }

            //     plansummarymain.forEach((source) => {
            //       this.gigterminationRes.plans.push(source);
            //     });

            // }else{
            //   if (!this.gigterminationRes.plans) {
            //     this.gigterminationRes.plans = []; // Initialize plans if not already initialized
            //   }
            // }

            let object = {};
            this.CorporateFormData.forEach((value, key) => object[key] = value);
            let json = JSON.stringify(object);
            let jsonObject = JSON.parse(json);


            // Add new key-value pair to the object


            // Convert the modified object back to a JSON string
            let updatedJsonString = JSON.stringify(jsonObject);
            let parsedObject = JSON.parse(updatedJsonString);

            // Now, parse the nested JSON strings inside 'workingProvinces' and 'gropupAdmin'
            parsedObject.workingProvinces = JSON.parse(parsedObject.workingProvinces);
            parsedObject.gropupAdmin = JSON.parse(parsedObject.gropupAdmin);
            parsedObject.id = sessionStorage.getItem('corporateId');
            let obj = {
              corporateDetails: parsedObject, //dev/test/prod/dummy
              continueWithExistingPlans: this.continueWithExistingPlans,
              data: this.gigterminationRes,
              provisioning: this.provisioning,
              plansDataarray: this.plansDataarray,
            }

      console.log(obj)


            this.http
              .post(environment.apiUrl + endPoint, obj, {
                headers: {
                  Authorization: 'Bearer ' + accessToken,
                  'Content-Type': 'application/json',
                },
              })
              .subscribe(
                (response: any) => {
                  if (response['status'] == 200) {
                    this.http.get(environment.apiUrl + '/api/ap/global/set-adminCorporates').subscribe((newResponse) => {
                      this.http.post(environment.reportApiUrl + '/websocket/corporate/notification-to-others', {
                        "message": "Corporates information has been updated. Please refresh screen."
                      }, {
                        headers: {
                          Authorization: 'Bearer ' + accessToken,
                          'Content-Type': 'application/json',
                        }
                      }).subscribe((res) => {
                        console.log({ res })
                      })
                    })
                    // this.http.get(environment.apiUrl + '/api/ap/global/set-adminMembers').subscribe((newResponse) => {})
                      this.http.post(environment.reportApiUrl + '/websocket/corporate/notification-to-others', {
                        "message": "Member information has been updated. Please refresh screen."
                      }, {
                        headers: {
                          Authorization: 'Bearer ' + accessToken,
                          'Content-Type': 'application/json',
                        }
                      }).subscribe((res) => {
                        console.log({ res })
                      })
                    // this.lang.Corporate_profile_created_and_sent_to_corporate_plan_administrators_for_approval,
                    Swal.fire({
                      title: this.lang.Info,
                      text:response.message,
                      showDenyButton: false,
                      showCancelButton: false,
                      confirmButtonText: 'Ok',
                    }).then((result) => {
                      if (result.isConfirmed) {
                        var keyToPreserve = ['adminName', 'role', 'loginname', 'accessToken', 'language'];

                        // Get all keys from sessionStorage
                        var keys = Object.keys(sessionStorage);

                        // Iterate through the keys and remove them from sessionStorage, except the one to preserve
                        keys.forEach(function (key) {
                          // if (key !== keyToPreserve) {
                          if (!keyToPreserve.includes(key)) {
                            // sessionStorage.removeItem(key);
                          }
                        });

                        sessionStorage.setItem('accessToken', accessTokensession);

                        // window.location.reload();
                        this.basicInfo = true;
                        this.plansInfo = false;
                        this.wallettierInfo = false;
                        this.EmployeeInfo = false;
                        this.datagraphInfo = false;

                        // this.router.navigate(['/manageCorporates'])
                      }
                    });
                    this.router.navigate(['/manageMembers'])
                  }
                })



          }
             else {
             Swal.fire({ title: this.lang.Info, text: response.message || response.data.message })
            this.router.navigate(['/manageMembers'])
                  }
        })


  }


  gotoPlansorWallet(employeeData: any) {
    let selectedsummaryBlockBulk = JSON.parse(
      sessionStorage.getItem('summaryBlockBulk') || '[]'
    );
    console.log(employeeData)

    this.employeeList = employeeData
    this._LoaderService.ShowLoader()


    setTimeout(() => {
      this._LoaderService.HideLoader()

    }, 2000);

    this.showEmployeelist = employeeData
    let bulkcheckarray = []

    for (let i = 0; i < this.showEmployeelist.length; i++) {
      if (this.showEmployeelist[i].isBulk == true) {
        bulkcheckarray.push(this.showEmployeelist[i])
      }
    }

    if (bulkcheckarray.length > 0) {
      this.showEmployeeValue = bulkcheckarray.length
      this.showEmployeeValue1 = bulkcheckarray.length
    }
    else {
      this.showEmployeeValue = ''


      // setTimeout(() => {
      //   for (let i = 0; i < selectedsummaryBlockBulk.length; i++) {

      //     $("#plancheckboxbulk" + selectedsummaryBlockBulk[i].subGroupId).click()


      // }
      // }, 1000);

    }
    let formData = JSON.parse(sessionStorage.getItem('formData') || '');



    if (formData.walletConfig == true) {
      this.basicInfo = false;
      this.plansInfo = false;
      this.wallettierInfo = true;
      this.EmployeeInfo = false;
      this.datagraphInfo = false;
      this.nowalletnotierInfo = false;




    }

    else {
      this.basicInfo = false;
      this.plansInfo = true;
      this.wallettierInfo = false;
      this.EmployeeInfo = false;
      this.datagraphInfo = false;
      this.nowalletnotierInfo = false;


      if (formData.tierConfig == false) {
        let selectedsummaryBlockBulk = JSON.parse(
          sessionStorage.getItem('summaryBlockBulk') || '[]'
        );
        let selectedplansblock1 = JSON.parse(
          sessionStorage.getItem('summaryBlock1') || '[]'
        );
        let selectedplansblock2 = JSON.parse(
          sessionStorage.getItem('summaryBlock2') || '[]'
        );
        let selectedplansblock3 = JSON.parse(
          sessionStorage.getItem('summaryBlock3') || '[]'
        );

        // this.uploadEmployeeExcelData = []

        this.executeBlocks1(selectedsummaryBlockBulk, selectedplansblock1, selectedplansblock2, selectedplansblock3)
          .then((message) => console.log(message))
          .catch((error) => console.error("An error occurred:", error));

        // setTimeout(() => {
        //   const dom: HTMLElement = this.elementRef.nativeElement;
        //   if (selectedplansblock1.length > 0) {
        //     // for (let i = 0; i < selectedplansblock1.length; i++) {
        //     //   const element: any = dom.querySelector(
        //     //     '#plancheck' + selectedplansblock1[i].subGroupId
        //     //   );
        //     //   element.click()
        //     //   setTimeout(() => {
        //     //     element.click()
        //     //   }, 10);
        //     //   // element.checked = true;
        //     //   // this.plancheckCoverage = selectedplansblock1[i].coverage;
        //     //   this.plancheckCoverage =  this.getExecutiveCoveragesFromCode(selectedplansblock1[i].coverage)

        //     //   if (this.plancheckCoverage) {
        //     //     console.log(this.plancheckCoverage);
        //     //     if (this.plancheckCoverage.single) {
        //     //       const element2: any = dom.querySelector(
        //     //         '#executiveplanssingle' + selectedplansblock1[i].subGroupId
        //     //       );
        //     //       element2.checked = true;
        //     //     } if (this.plancheckCoverage.couple) {
        //     //       const element2: any = dom.querySelector(
        //     //         '#executiveplanscouple' + selectedplansblock1[i].subGroupId
        //     //       );
        //     //       element2.checked = true;
        //     //     } if (this.plancheckCoverage.family) {
        //     //       const element2: any = dom.querySelector(
        //     //         '#executiveplansfamily' + selectedplansblock1[i].subGroupId
        //     //       );
        //     //       element2.checked = true;
        //     //     }
        //     //   }
        //     // }
        //     for (let i = 0; i < selectedplansblock1.length; i++) {
        //       const element: any = dom.querySelector(
        //         '#plancheck' + selectedplansblock1[i].subGroupId
        //       );
        //       $("#plancheck" + selectedplansblock1[i].subGroupId).prop("checked", true);


        //       // element.checked = true;
        //       // this.plancheckCoverage = selectedplansblock1[i].coverage;
        //       this.plancheckCoverage =  this.getExecutiveCoveragesFromCode(selectedplansblock1[i].coverage)

        //       if (this.plancheckCoverage) {
        //         console.log(this.plancheckCoverage);
        //         if (this.plancheckCoverage.single) {
        //           const element2: any = dom.querySelector(
        //             '#executiveplanssingle' + selectedplansblock1[i].subGroupId
        //           );
        //           $("#executiveplanssingle" + selectedplansblock1[i].subGroupId).prop("checked", true);

        //           // element2.checked = true;
        //         } if (this.plancheckCoverage.couple) {
        //           const element2: any = dom.querySelector(
        //             '#executiveplanscouple' + selectedplansblock1[i].subGroupId
        //           );
        //           $("#executiveplanscouple" + selectedplansblock1[i].subGroupId).prop("checked", true);

        //           // element2.checked = true;
        //         } if (this.plancheckCoverage.family) {
        //           const element2: any = dom.querySelector(
        //             '#executiveplansfamily' + selectedplansblock1[i].subGroupId
        //           );
        //           $("#executiveplansfamily" + selectedplansblock1[i].subGroupId).prop("checked", true);

        //           // element2.checked = true;
        //         }
        //       }
        //     }
        //   }
        //   if (selectedplansblock2.length > 0) {


        //     let el1: HTMLElement = this.upgradeplanstrue.nativeElement;
        //     el1.click();
        //     this.upgradeplansselection == true;

        //     setTimeout(() => {
        //       for (let i = 0; i < selectedplansblock2.length; i++) {
        //         const element1: any = dom.querySelector(
        //           '#plancheck2Upgrade' + selectedplansblock2[i].subGroupId
        //         );
        //         $("#plancheck2Upgrade" + selectedplansblock2[i].subGroupId).prop("checked", true);
        //         // element1.checked = true;
        //         this.plancheck2Coverage =  this.getExecutiveCoveragesFromCode(selectedplansblock2[i].coverage)

        //         if (
        //           this.plancheck2Coverage
        //         ) {
        //           console.log(this.plancheckCoverage);
        //           if (this.plancheck2Coverage.single) {
        //             const element2: any = dom.querySelector(
        //               '#executiveplansblock2single' +
        //                 selectedplansblock2[i].subGroupId
        //             );
        //             // element2.checked = true;
        //             $("#executiveplansblock2single" + selectedplansblock2[i].subGroupId).prop("checked", true);

        //           } if (this.plancheck2Coverage.couple) {
        //             const element2: any = dom.querySelector(
        //               '#executiveplansblock2couple' +
        //                 selectedplansblock2[i].subGroupId
        //             );
        //             // element2.checked = true;
        //             $("#executiveplansblock2couple" + selectedplansblock2[i].subGroupId).prop("checked", true);

        //           } if (this.plancheck2Coverage.family) {
        //             const element2: any = dom.querySelector(
        //               '#executiveplansblock2family' +
        //                 selectedplansblock2[i].subGroupId
        //             );
        //             // element2.checked = true;
        //             $("#executiveplansblock2family" + selectedplansblock2[i].subGroupId).prop("checked", true);

        //           }
        //         }
        //       }
        //     }, 2000);


        //                 }

        //   else{
        //     if (this.upgradeplansselection == true) {
        //       let el: HTMLElement = this.upgradeplansfalse.nativeElement;
        //       el.click();
        //       setTimeout(() => {
        //         let el1: HTMLElement = this.upgradeplanstrue.nativeElement;
        //         el1.click();

        //       }, 10);
        //     }
        //   }


        //   setTimeout(() => {
        //     if (selectedplansblock3.length > 0) {
        //       let el1: HTMLElement = this.employeepurchasetrue.nativeElement;
        //       el1.click();
        //       this.employeeplanpurchase == true;
        //        setTimeout(() => {

        //         for (let i = 0; i < selectedplansblock3.length; i++) {
        //           const element2: any = dom.querySelector(
        //             '#plancheck3Voluntry' + selectedplansblock3[i].subGroupId
        //           );
        //           $("#plancheck3Voluntry" + selectedplansblock3[i].subGroupId).prop("checked", true);

        //           this.plancheck3Coverage =  this.getExecutiveCoveragesFromCode(selectedplansblock3[i].coverage)


        //           if (
        //             this.plancheck3Coverage
        //           ) {
        //             if (this.plancheck3Coverage.single) {
        //               const element2: any = dom.querySelector(
        //                 '#executiveplansblock3single' +
        //                   selectedplansblock3[i].subGroupId
        //               );
        //               $("#executiveplansblock3single" + selectedplansblock3[i].subGroupId).prop("checked", true);

        //               // element2.checked = true;
        //             } if (this.plancheck3Coverage.couple) {
        //               const element2: any = dom.querySelector(
        //                 '#executiveplansblock3couple' +
        //                   selectedplansblock3[i].subGroupId
        //               );
        //               $("#executiveplansblock3couple" + selectedplansblock3[i].subGroupId).prop("checked", true);

        //               // element2.checked = true;
        //             } if (this.plancheck3Coverage.family) {
        //               const element2: any = dom.querySelector(
        //                 '#executiveplansblock3family' +
        //                   selectedplansblock3[i].subGroupId
        //               );
        //               $("#executiveplansblock3family" + selectedplansblock3[i].subGroupId).prop("checked", true);

        //               // element2.checked = true;
        //             }
        //           }
        //         }
        //        }, 1500);
        //     }
        //     else{
        //       if (this.employeeplanpurchase == true) {
        //         let el: HTMLElement = this.employeepurchasefalse.nativeElement;
        //         el.click();
        //         setTimeout(() => {
        //           let el1: HTMLElement = this.employeepurchasetrue.nativeElement;
        //           el1.click();
        //         }, 100);
        //       }
        //     }
        //   }, 3000);

        // }, 1000);
      }
      else {
        let selectedplansblock1 = this.seelctedplanLevelTierMapping || [];
        let selectedplansblock2 = this.seelctedplanLevelTierMappingBlock2 || [];
        let selectedplansblock3 = this.seelctedplanLevelTierMappingBlock3 || [];

        console.log(selectedplansblock1);
        console.log(selectedplansblock2);
        console.log(selectedplansblock3);

        setTimeout(() => {
          const dom: HTMLElement = this.elementRef.nativeElement;

          console.log(selectedplansblock1);
          if (selectedplansblock1.length > 0) {
            for (let i = 0; i < selectedplansblock1.length; i++) {
              const element: any = dom.querySelector(
                '#plancheck' + selectedplansblock1[i].subGroupid
              );
              element.checked = true;
              this.plancheckCoverage = this.getExecutiveCoveragesFromCode(selectedplansblock1[i].coverage)

              // this.plancheckCoverage = selectedplansblock1[i].coverage;
              if (this.plancheckCoverage) {
                if (this.plancheckCoverage.single) {
                  const element2: any = dom.querySelector(
                    '#executiveplansTiersingle' +
                    selectedplansblock1[i].subGroupid
                  );
                  element2.checked = true;
                } if (this.plancheckCoverage.couple) {
                  const element2: any = dom.querySelector(
                    '#executiveplansTiercouple' +
                    selectedplansblock1[i].subGroupid
                  );
                  element2.checked = true;
                } if (this.plancheckCoverage.family) {
                  const element2: any = dom.querySelector(
                    '#executiveplansTierfamily' +
                    selectedplansblock1[i].subGroupid
                  );
                  element2.checked = true;
                }
              }
              this.plansBlock1Tiers[selectedplansblock1[i].packageindex][
                'groups'
              ][selectedplansblock1[i].groupindex]['subGroups'][
                selectedplansblock1[i].subgroupindex
              ].tiers = selectedplansblock1[i].tiers;
            }
          }
          if (selectedplansblock2.length > 0) {
            console.log(selectedplansblock2);
            let el1: HTMLElement = this.upgradeplanstierstrue.nativeElement;
            el1.click();
            this.upgradeplansselectiontiers == true;
            setTimeout(() => {
              for (let i = 0; i < selectedplansblock2.length; i++) {
                const element1: any = dom.querySelector(
                  '#plancheck2Upgrade' + selectedplansblock2[i].subGroupid
                );
                element1.checked = true;

                this.plancheck2Coverage = this.getExecutiveCoveragesFromCode(selectedplansblock2[i].coverage)

                if (
                  this.plancheck2Coverage
                ) {
                  console.log(this.plancheck2Coverage);
                  if (this.plancheck2Coverage.single) {
                    const element2: any = dom.querySelector(
                      '#executiveplansblock2Tiersingle' +
                      selectedplansblock2[i].subGroupid
                    );
                    element2.checked = true;
                  } else if (this.plancheck2Coverage.couple) {
                    const element2: any = dom.querySelector(
                      '#executiveplansblock2Tiercouple' +
                      selectedplansblock2[i].subGroupid
                    );
                    element2.checked = true;
                  } else if (this.plancheck2Coverage.family) {
                    const element2: any = dom.querySelector(
                      '#executiveplansblock2Tierfamily' +
                      selectedplansblock2[i].subGroupid
                    );
                    element2.checked = true;
                  }
                }
                this.plansresblack2Tiers[selectedplansblock2[i].packageindex][
                  'groups'
                ][selectedplansblock2[i].groupindex]['subGroups'][
                  selectedplansblock2[i].subgroupindex
                ].tiers = selectedplansblock2[i].tiers;
              }
            }, 1000);
          }
          if (selectedplansblock3.length > 0) {
            let el1: HTMLElement = this.employeepurchaseTierstrue.nativeElement;
            el1.click();
            this.employeeplanpurchasetiers == true;
            setTimeout(() => {
              for (let i = 0; i < selectedplansblock3.length; i++) {
                const element2: any = dom.querySelector(
                  '#plancheck3Voluntry' + selectedplansblock3[i].subGroupid
                );
                element2.checked = true;
                // this.plancheck3Coverage = selectedplansblock3[i].coverage;
                this.plancheck3Coverage = this.getExecutiveCoveragesFromCode(selectedplansblock3[i].coverage)

                if (
                  this.plancheck3Coverage
                ) {
                  if (this.plancheck3Coverage.single) {
                    const element2: any = dom.querySelector(
                      '#executiveplansblock3Tiersingle' +
                      selectedplansblock3[i].subGroupid
                    );
                    element2.checked = true;
                  } else if (this.plancheck3Coverage.couple) {
                    const element2: any = dom.querySelector(
                      '#executiveplansblock3Tiercouple' +
                      selectedplansblock3[i].subGroupid
                    );
                    element2.checked = true;
                  } else if (this.plancheck3Coverage.family) {
                    const element2: any = dom.querySelector(
                      '#executiveplansblock3Tierfamily' +
                      selectedplansblock3[i].subGroupid
                    );
                    element2.checked = true;
                  }
                }
                this.plansresblack3Tiers[selectedplansblock3[i].packageindex][
                  'groups'
                ][selectedplansblock3[i].groupindex]['subGroups'][
                  selectedplansblock3[i].subgroupindex
                ].tiers = selectedplansblock3[i].tiers;
              }
            }, 1500);
          }
        }, 1000);
      }

      setTimeout(() => {

        let block1res = JSON.parse(
          sessionStorage.getItem('summaryBlock1') || '[]');



        for (let i = 0; i < block1res.length; i++) {
          if (block1res[i].subGroupId == 17) {

            $('#executiveplanssingle17').prop('disabled', false);
            $('#executiveplanscouple17').prop('disabled', false);
            $('#executiveplansfamily17').prop('disabled', false);
          }
          else {

            // $('#executiveplanssingle17').prop('disabled', true);
            // $('#executiveplanscouple17').prop('disabled', true);
            // $('#executiveplansfamily17').prop('disabled', true);
          }
          if (block1res[i].subGroupId == 18) {
            $('#executiveplanssingle18').prop('disabled', false);
            $('#executiveplanscouple18').prop('disabled', false);
            $('#executiveplansfamily18').prop('disabled', false);
          }
          else {
            // $('#executiveplanssingle18').prop('disabled', true);
            // $('#executiveplanscouple18').prop('disabled', true);
            // $('#executiveplansfamily18').prop('disabled', true);
          }
          if (block1res[i].subGroupId == 28) {
            $('#executiveplanssingle28').prop('disabled', false);
            $('#executiveplanscouple28').prop('disabled', false);
            $('#executiveplansfamily28').prop('disabled', false);
          }
          else {
            // $('#executiveplanssingle28').prop('disabled', true);
            // $('#executiveplanscouple28').prop('disabled', true);
            // $('#executiveplansfamily28').prop('disabled', true);
          }
          // if(block1res[i].subGroupId == 17 && block1res[i].subGroupId == 18 ){

          // }
          // else{
          //   $('#executiveplanssingle17').prop('disabled', true);
          //   $('#executiveplanscouple17').prop('disabled', true);
          //   $('#executiveplansfamily17').prop('disabled', true);
          //   $('#executiveplanssingle18').prop('disabled', true);
          //   $('#executiveplanscouple18').prop('disabled', true);
          //   $('#executiveplansfamily18').prop('disabled', true);
          // }
        }

      }, 100);

    }
  }

  executeBlocks1(selectedsummaryBlockBulk, selectedplansblock1, selectedplansblock2, selectedplansblock3) {
    return new Promise((resolve, reject) => {
      // First block of code
      console.log("Executing block 1");
      for (let i = 0; i < selectedsummaryBlockBulk.length; i++) {

        if (selectedsummaryBlockBulk[i].subGroupId == 34) {
          setTimeout(() => {
            $("#plancheckboxbulk" + selectedsummaryBlockBulk[i].subGroupId).prop("checked", true);
            this.showEmployeeValue1 = selectedsummaryBlockBulk[i].quantity
            this.showinputbox1 = selectedsummaryBlockBulk[i].subgroupindex

          })
        } else {
          setTimeout(() => {
            $("#plancheckboxbulk" + selectedsummaryBlockBulk[i].subGroupId).prop("checked", true);
            this.showEmployeeValue = selectedsummaryBlockBulk[i].quantity
            this.showinputbox = selectedsummaryBlockBulk[i].subgroupindex

          })
        }
        if (selectedsummaryBlockBulk[i].disallowedPlanLevels != null) {
          let disallowed_plans = selectedsummaryBlockBulk[i].disallowedPlanLevels.split(',');
          const dom1: HTMLElement = this.elementRef.nativeElement;
          for (let i = 0; i < disallowed_plans.length; i++) {
            // console.log(disallowed_plans[i]);
            // console.log(disallowed_plans[i]);
            setTimeout(() => {
              let elem: any = dom1.querySelector(`#plancheckboxbulk${disallowed_plans[i]}`)

              if (elem != null) {
                if (!elem.disabled) {

                  elem.disabled = true
                }
              }
            }, 100);

          }
        }

      }

      for (let i = 0; i < selectedplansblock1.length; i++) {
        setTimeout(() => {
          $("#plancheck" + selectedplansblock1[i].subGroupId).prop("checked", true);
          this.plancheckCoverage = this.getExecutiveCoveragesFromCode(selectedplansblock1[i].coverage)

          if (this.plancheckCoverage) {
            console.log(this.plancheckCoverage);
            if (this.plancheckCoverage.single) {

              $("#executiveplanssingle" + selectedplansblock1[i].subGroupId).prop("checked", true);

              // element2.checked = true;
            } if (this.plancheckCoverage.couple) {

              $("#executiveplanscouple" + selectedplansblock1[i].subGroupId).prop("checked", true);

              // element2.checked = true;
            } if (this.plancheckCoverage.family) {

              $("#executiveplansfamily" + selectedplansblock1[i].subGroupId).prop("checked", true);

              // element2.checked = true;
            }
          }
          if (selectedplansblock1[i].disallowedPlanLevels != null) {
            let disallowed_plans = selectedplansblock1[i].disallowedPlanLevels.split(',');
            const dom1: HTMLElement = this.elementRef.nativeElement;
            for (let i = 0; i < disallowed_plans.length; i++) {
              // console.log(disallowed_plans[i]);
              // console.log(disallowed_plans[i]);
              setTimeout(() => {
                let elem: any = dom1.querySelector(`#plancheck${disallowed_plans[i]}`)

                if (elem != null) {
                  if (!elem.disabled) {

                    elem.disabled = true
                  }
                }
              }, 100);

            }
          }

          if (i === selectedplansblock1.length - 1) {
            // Second block of code

            console.log("Executing block 2");


            setTimeout(() => {
              if (selectedplansblock2.length > 0) {
                let el1: HTMLElement = this.upgradeplanstrue.nativeElement;
                el1.click();
                this.upgradeplansselection == true;

                for (let j = 0; j < selectedplansblock2.length; j++) {
                  setTimeout(() => {
                    $("#plancheck2Upgrade" + selectedplansblock2[j].subGroupId).prop("checked", true);
                    // element1.checked = true;
                    this.plancheck2Coverage = this.getExecutiveCoveragesFromCode(selectedplansblock2[j].coverage)

                    if (
                      this.plancheck2Coverage
                    ) {
                      console.log(this.plancheckCoverage);
                      if (this.plancheck2Coverage.single) {
                        $("#executiveplansblock2single" + selectedplansblock2[j].subGroupId).prop("checked", true);

                      } if (this.plancheck2Coverage.couple) {
                        $("#executiveplansblock2couple" + selectedplansblock2[j].subGroupId).prop("checked", true);

                      } if (this.plancheck2Coverage.family) {
                        $("#executiveplansblock2family" + selectedplansblock2[j].subGroupId).prop("checked", true);

                      }
                    }
                    console.log(`Block 2 - Task ${j + 1} completed`);
                    if (j === selectedplansblock2.length - 1) {
                      // Third block of code
                      console.log("Executing block 3");

                      setTimeout(() => {
                        if (selectedplansblock3.length > 0) {
                          let el1: HTMLElement = this.employeepurchasetrue.nativeElement;
                          if (el1 != null) el1.click();
                          this.employeeplanpurchase == true
                          for (let k = 0; k < selectedplansblock3.length; k++) {
                            setTimeout(() => {
                              $("#plancheck3Voluntry" + selectedplansblock3[k].subGroupId).prop("checked", true);

                              this.plancheck3Coverage = this.getExecutiveCoveragesFromCode(selectedplansblock3[k].coverage)


                              if (
                                this.plancheck3Coverage
                              ) {
                                if (this.plancheck3Coverage.single) {

                                  $("#executiveplansblock3single" + selectedplansblock3[k].subGroupId).prop("checked", true);

                                  // element2.checked = true;
                                } if (this.plancheck3Coverage.couple) {

                                  $("#executiveplansblock3couple" + selectedplansblock3[k].subGroupId).prop("checked", true);

                                  // element2.checked = true;
                                } if (this.plancheck3Coverage.family) {

                                  $("#executiveplansblock3family" + selectedplansblock3[k].subGroupId).prop("checked", true);

                                  // element2.checked = true;
                                }
                              }
                              console.log(`Block 3 - Task ${k + 1} completed`);
                              if (k === selectedplansblock3.length - 1) {
                                resolve("All blocks executed successfully");
                              }
                            }, 1500);
                          }
                        }
                      }, 1000);

                    }
                  }, 1000);
                }
              }
              if (selectedplansblock2.length == 0 && selectedplansblock3.length > 0) {
                let el1: HTMLElement = this.employeepurchasetrue.nativeElement;
                if (el1 != null) el1.click();
                this.employeeplanpurchase == true
                for (let k = 0; k < selectedplansblock3.length; k++) {
                  setTimeout(() => {
                    $("#plancheck3Voluntry" + selectedplansblock3[k].subGroupId).prop("checked", true);

                    this.plancheck3Coverage = this.getExecutiveCoveragesFromCode(selectedplansblock3[k].coverage)


                    if (
                      this.plancheck3Coverage
                    ) {
                      if (this.plancheck3Coverage.single) {

                        $("#executiveplansblock3single" + selectedplansblock3[k].subGroupId).prop("checked", true);

                        // element2.checked = true;
                      } if (this.plancheck3Coverage.couple) {

                        $("#executiveplansblock3couple" + selectedplansblock3[k].subGroupId).prop("checked", true);

                        // element2.checked = true;
                      } if (this.plancheck3Coverage.family) {

                        $("#executiveplansblock3family" + selectedplansblock3[k].subGroupId).prop("checked", true);

                        // element2.checked = true;
                      }
                    }
                    console.log(`Block 3 - Task ${k + 1} completed`);
                    if (k === selectedplansblock3.length - 1) {
                      resolve("All blocks executed successfully");
                    }
                  }, 1500);
                }
              }
            }, 1000);





          }
        }, 1000);
      }
    });
  }

  showdatagrpah(employeelist) {
    console.log(employeelist);

    // alert(this.applicationStatus)

    this.addedEmployeelist = employeelist;

    this.employeeList = employeelist;
    this.basicInfo = false;
    this.plansInfo = false;
    this.wallettierInfo = false;
    this.EmployeeInfo = false;
    this.datagraphInfo = true;
    this.nowalletnotierInfo = false;
    this.updateAllStatus();
  }

  updateStatus(id: number) {
    let i = this.adminStatuslist.findIndex((status) => status.id == id);

    if (id == 1) {
      //address -- province
      if (
        this.clientregform.value.streetAddress &&
        this.clientregform.value.country &&
        this.clientregform.value.city &&
        this.clientregform.value.Province &&
        this.clientregform.value.postalCode
      ) {
        if (this.adminStatuslist[i].id == 1) {
          this.adminStatuslist[i].checked = true;
          //statusChangeCounter++;
          //this.add()
        }
      } else {
        if (this.adminStatuslist[i].id == 1) {
          this.adminStatuslist[i].checked = false;
          //statusChangeCounter++;
          //this.add()
        }
      }
    }

    if (id == 2) {
      console.log('poclist date changed---update!?');
      //policy start date
      if (this.clientregform.value.PolicyStartDate) {
        if (this.adminStatuslist[i].id == 2) {
          this.adminStatuslist[i].checked = true;
        }
      } else {
        if (this.adminStatuslist[i].id == 2) {
          this.adminStatuslist[i].checked = false;
        }
      }
    }

    if (id == 3) {
      if (this.adminData.length > 0) {
        if (this.adminStatuslist[i].id == 3) {
          this.adminStatuslist[i].checked = true;
        }
      } else {
        if (this.adminStatuslist[i].id == 3) {
          this.adminStatuslist[i].checked = false;
        }
      }
    }

    if (id == 4) {
      if (this.clientregform.value.waitingPeriod) {
        if (this.adminStatuslist[i].id == 4) {
          this.adminStatuslist[i].checked = true;
        }
      } else {
        if (this.adminStatuslist[i].id == 4) {
          this.adminStatuslist[i].checked = false;
        }
      }
    }
    if (id == 5) {
      if (this.clientregform.value.paymentInfo) {
        if (this.adminStatuslist[i].id == 5) {
          this.adminStatuslist[i].checked = true;
        }
      } else {
        if (this.adminStatuslist[i].id == 5) {
          this.adminStatuslist[i].checked = false;
        }
      }
    }

    if (id == 6) {
      if (this.clientregform.value.corporatelogo) {
        if (this.adminStatuslist[i].id == 6) {
          this.adminStatuslist[i].checked = true;
        }
      } else {
        if (this.adminStatuslist[i].id == 6) {
          this.adminStatuslist[i].checked = false;
        }
      }
    }

    if (id == 7) {
      if (this.clientregform.value.walletConfig) {
        if (this.adminStatuslist[i].id == 7) {
          this.adminStatuslist[i].checked = true;
        }
      } else {
        if (this.adminStatuslist[i].id == 7) {
          this.adminStatuslist[i].checked = true;
        }
      }
    }

    if (id == 8) {
      if (this.clientregform.value.tierConfig) {
        if (this.adminStatuslist[i].id == 8) {
          this.adminStatuslist[i].checked = true;
        }
      } else {
        if (this.adminStatuslist[i].id == 8) {
          this.adminStatuslist[i].checked = true;
        }
      }
    }

    if (id == 9) {
      if (this.paidByCompany.length > 0) {
        if (this.adminStatuslist[i].id == 9) {
          this.adminStatuslist[i].checked = true;
        }
      } else {
        if (this.adminStatuslist[i].id == 9) {
          this.adminStatuslist[i].checked = false;
        }
      }
    }

    if (id == 10) {
      if (this.employeeList.length > 0) {
        if (this.adminStatuslist[i].id == 10) {
          this.adminStatuslist[i].checked = true;
        }
      } else {
        if (this.adminStatuslist[i].id == 10) {
          this.adminStatuslist[i].checked = false;
        }
      }
    }

    //last after all status
    this.add();
  }
  updateAllStatus() {
    console.log(this.adminData);
    for (let i = 0; i < this.adminStatuslist.length; i++) {
      if (
        this.clientregform.value.streetAddress &&
        this.clientregform.value.country &&
        this.clientregform.value.city &&
        this.clientregform.value.Province &&
        this.clientregform.value.postalCode
      ) {
        if (this.adminStatuslist[i].id == 1) {
          this.adminStatuslist[i].checked = true;
        }
      } else {
        if (this.adminStatuslist[i].id == 1) {
          this.adminStatuslist[i].checked = false;
        }
      }
      if (this.clientregform.value.PolicyStartDate) {
        if (this.adminStatuslist[i].id == 2) {
          this.adminStatuslist[i].checked = true;
        }
      } else {
        if (this.adminStatuslist[i].id == 2) {
          this.adminStatuslist[i].checked = false;
        }
      }

      if (this.adminData.length > 0) {
        if (this.adminStatuslist[i].id == 3) {
          this.adminStatuslist[i].checked = true;
        }
      } else {
        if (this.adminStatuslist[i].id == 3) {
          this.adminStatuslist[i].checked = false;
        }
      }
      if (this.clientregform.value.waitingPeriod) {
        if (this.adminStatuslist[i].id == 4) {
          this.adminStatuslist[i].checked = true;
        }
      } else {
        if (this.adminStatuslist[i].id == 4) {
          this.adminStatuslist[i].checked = false;
        }
      }

      if (this.clientregform.value.paymentInfo) {
        if (this.adminStatuslist[i].id == 5) {
          this.adminStatuslist[i].checked = true;
        }
      } else {
        if (this.adminStatuslist[i].id == 5) {
          this.adminStatuslist[i].checked = false;
        }
      }
      if (this.clientregform.value.corporatelogo) {
        if (this.adminStatuslist[i].id == 6) {
          this.adminStatuslist[i].checked = true;
        }
      } else {
        if (this.adminStatuslist[i].id == 6) {
          this.adminStatuslist[i].checked = false;
        }
      }

      if (this.clientregform.value.walletConfig) {
        if (this.adminStatuslist[i].id == 7) {
          this.adminStatuslist[i].checked = true;
        }
      } else {
        if (this.adminStatuslist[i].id == 7) {
          this.adminStatuslist[i].checked = true;
        }
      }

      if (this.clientregform.value.tierConfig) {
        if (this.adminStatuslist[i].id == 8) {
          this.adminStatuslist[i].checked = true;
        }
      } else {
        if (this.adminStatuslist[i].id == 8) {
          this.adminStatuslist[i].checked = true;
        }
      }

      console.log(this.paidByCompany);
      if (this.paidByCompany.length > 0) {
        if (this.adminStatuslist[i].id == 9) {
          this.adminStatuslist[i].checked = true;
        }
      } else {
        if (this.adminStatuslist[i].id == 9) {
          this.adminStatuslist[i].checked = false;
        }
      }
      if (this.employeeList.length > 0) {
        if (this.adminStatuslist[i].id == 10) {
          this.adminStatuslist[i].checked = true;
        }
      } else {
        if (this.adminStatuslist[i].id == 10) {
          this.adminStatuslist[i].checked = false;
        }
      }
    }

    this.add();

    //this.add()
  }

  public add() {
    //re-order them by color --- red // black
    let redStatus = this.adminStatuslist.filter(
      (status) => status.color == 'red'
    );
    let blackStatus = this.adminStatuslist.filter(
      (status) => status.color == 'black'
    );
    this.adminStatuslist = redStatus.concat(blackStatus);

    var t = this.adminStatuslist.filter((opt) => opt.checked).map((opt) => opt);
    console.log(t);
    this.lengthofstatus = t.length;
    this.applicationStatus = this.lengthofstatus;
    this.headerComponent.applicationStatus(this.lengthofstatus);
  }
  showemployeepage(event) {
    console.log(event);
    this.selectedWalletConfig = event.payForService;
    this.basicInfo = false;
    this.plansInfo = false;
    this.wallettierInfo = false;
    this.EmployeeInfo = true;
    this.datagraphInfo = false;
    this.nowalletnotierInfo = false;
  }

  public getExecutiveCoveragesFromCode(code: string) {
    let coverage;

    if (code) {
      coverage = { single: false, couple: false, family: false };
      if (code[0] == '1') {
        coverage.family = true;
      }
      if (code[1] == '1') {
        coverage.couple = true;
      }
      if (code[2] == '1') {
        coverage.single = true;
      }
    } else {
      coverage = null;
    }

    return coverage;
  }
  gotoplanspagefromwallet() {
    let formData = JSON.parse(sessionStorage.getItem('formData') || '');

    this.basicInfo = false;
    this.plansInfo = true;
    this.wallettierInfo = false;
    this.EmployeeInfo = false;
    this.datagraphInfo = false;
    this.nowalletnotierInfo = false;

    if (formData.tierConfig == false) {
      let selectedplansblock1 = JSON.parse(
        sessionStorage.getItem('summaryBlock1') || '[]'
      );
      let selectedplansblock2 = JSON.parse(
        sessionStorage.getItem('summaryBlock2') || '[]'
      );
      let selectedplansblock3 = JSON.parse(
        sessionStorage.getItem('summaryBlock3') || '[]'
      );

      setTimeout(() => {
        const dom: HTMLElement = this.elementRef.nativeElement;
        if (selectedplansblock1.length > 0) {
          for (let i = 0; i < selectedplansblock1.length; i++) {
            const element: any = dom.querySelector(
              '#plancheck' + selectedplansblock1[i].subGroupId
            );
            // element.checked = true;
            element.click();

            setTimeout(() => {
              element.click();
            }, 10);
            // this.plancheckCoverage = selectedplansblock1[i].coverage;

            this.plancheckCoverage = this.getExecutiveCoveragesFromCode(
              selectedplansblock1[i].coverage
            );

            // {single: true, couple: true, family: false}
            if (this.plancheckCoverage) {
              // console.log(this.plancheckCoverage['single']);

              console.log(this.plancheckCoverage.single);
              if (this.plancheckCoverage.single) {
                const element2: any = dom.querySelector(
                  '#executiveplanssingle' + selectedplansblock1[i].subGroupId
                );
                element2.checked = true;
              }
              if (this.plancheckCoverage.couple) {
                const element2: any = dom.querySelector(
                  '#executiveplanscouple' + selectedplansblock1[i].subGroupId
                );
                element2.checked = true;
              }
              if (this.plancheckCoverage.family) {
                const element2: any = dom.querySelector(
                  '#executiveplansfamily' + selectedplansblock1[i].subGroupId
                );
                element2.checked = true;
              }
            }
          }
        }
        if (selectedplansblock2.length > 0) {
          let el1: HTMLElement = this.upgradeplanstrue.nativeElement;
          el1.click();
          this.upgradeplansselection == true;
          setTimeout(() => {
            for (let i = 0; i < selectedplansblock2.length; i++) {
              const element1: any = dom.querySelector(
                '#plancheck2Upgrade' + selectedplansblock2[i].subGroupId
              );
              element1.checked = true;
              // this.plancheck2Coverage = selectedplansblock2[i].coverage;
              this.plancheck2Coverage = this.getExecutiveCoveragesFromCode(
                selectedplansblock2[i].coverage
              );

              if (this.plancheck2Coverage) {
                if (this.plancheck2Coverage.single) {
                  const element2: any = dom.querySelector(
                    '#executiveplansblock2single' +
                    selectedplansblock2[i].subGroupId
                  );
                  element2.checked = true;
                }
                if (this.plancheck2Coverage.couple) {
                  const element2: any = dom.querySelector(
                    '#executiveplansblock2couple' +
                    selectedplansblock2[i].subGroupId
                  );
                  element2.checked = true;
                } else if (this.plancheck2Coverage.family) {
                  const element2: any = dom.querySelector(
                    '#executiveplansblock2family' +
                    selectedplansblock2[i].subGroupId
                  );
                  element2.checked = true;
                }
              }
            }
          }, 1000);
        } else {
          if (this.upgradeplansselection == true) {
            // let el: HTMLElement = this.upgradeplansfalse.nativeElement;
            // el.click();
            setTimeout(() => {
              let el1: HTMLElement = this.upgradeplanstrue.nativeElement;
              el1.click();
            }, 10);
          }
        }
        if (selectedplansblock3.length > 0) {
          let el1: HTMLElement = this.employeepurchasetrue.nativeElement;
          el1.click();
          this.employeeplanpurchase == true;
          setTimeout(() => {
            for (let i = 0; i < selectedplansblock3.length; i++) {
              const element2: any = dom.querySelector(
                '#plancheck3Voluntry' + selectedplansblock3[i].subGroupId
              );
              element2.checked = true;
              this.plancheck3Coverage = this.getExecutiveCoveragesFromCode(
                selectedplansblock3[i].coverage
              );

              // this.plancheck3Coverage = selectedplansblock3[i].coverage;

              if (this.plancheck3Coverage) {
                if (this.plancheck3Coverage.single) {
                  const element2: any = dom.querySelector(
                    '#executiveplansblock3single' +
                    selectedplansblock3[i].subGroupId
                  );
                  element2.checked = true;
                }
                if (this.plancheck3Coverage.couple) {
                  const element2: any = dom.querySelector(
                    '#executiveplansblock3couple' +
                    selectedplansblock3[i].subGroupId
                  );
                  element2.checked = true;
                }
                if (this.plancheck3Coverage.family) {
                  const element2: any = dom.querySelector(
                    '#executiveplansblock3family' +
                    selectedplansblock3[i].subGroupId
                  );
                  element2.checked = true;
                }
              }
            }
          }, 1500);
        } else {
          if (this.employeeplanpurchase == true) {
            // let el: HTMLElement = this.employeepurchasefalse.nativeElement;
            // el.click();
            setTimeout(() => {
              let el1: HTMLElement = this.employeepurchasetrue.nativeElement;
              el1.click();
            }, 10);
          }
        }
      }, 1000);
    } else {
      let selectedplansblock1 = this.seelctedplanLevelTierMapping || [];
      let selectedplansblock2 = this.seelctedplanLevelTierMappingBlock2 || [];
      let selectedplansblock3 = this.seelctedplanLevelTierMappingBlock3 || [];

      setTimeout(() => {
        const dom: HTMLElement = this.elementRef.nativeElement;

        console.log(selectedplansblock1);
        if (selectedplansblock1.length > 0) {
          for (let i = 0; i < selectedplansblock1.length; i++) {
            const element: any = dom.querySelector(
              '#plancheck' + selectedplansblock1[i].subGroupid
            );
            element.checked = true;
            this.plancheckCoverage = this.getExecutiveCoveragesFromCode(
              selectedplansblock1[i].coverage
            );

            // this.plancheckCoverage = selectedplansblock1[i].coverage;
            if (this.plancheckCoverage) {
              if (this.plancheckCoverage.single) {
                const element2: any = dom.querySelector(
                  '#executiveplansTiersingle' +
                  selectedplansblock1[i].subGroupid
                );
                element2.checked = true;
              }
              if (this.plancheckCoverage.couple) {
                const element2: any = dom.querySelector(
                  '#executiveplansTiercouple' +
                  selectedplansblock1[i].subGroupid
                );
                element2.checked = true;
              }
              if (this.plancheckCoverage.family) {
                const element2: any = dom.querySelector(
                  '#executiveplansTierfamily' +
                  selectedplansblock1[i].subGroupid
                );
                element2.checked = true;
              }
            }
            this.plansBlock1Tiers[selectedplansblock1[i].packageindex][
              'groups'
            ][selectedplansblock1[i].groupindex]['subGroups'][
              selectedplansblock1[i].subgroupindex
            ].tiers = selectedplansblock1[i].tiers;
          }
        }
        if (selectedplansblock2.length > 0) {
          console.log(selectedplansblock2);
          let el1: HTMLElement = this.upgradeplanstierstrue.nativeElement;
          el1.click();
          this.upgradeplansselectiontiers == true;
          setTimeout(() => {
            for (let i = 0; i < selectedplansblock2.length; i++) {
              const element1: any = dom.querySelector(
                '#plancheck2Upgrade' + selectedplansblock2[i].subGroupid
              );
              element1.checked = true;

              this.plancheck2Coverage = this.getExecutiveCoveragesFromCode(
                selectedplansblock2[i].coverage
              );

              if (this.plancheck2Coverage) {
                console.log(this.plancheck2Coverage);
                if (this.plancheck2Coverage.single) {
                  const element2: any = dom.querySelector(
                    '#executiveplansblock2Tiersingle' +
                    selectedplansblock2[i].subGroupid
                  );
                  element2.checked = true;
                } else if (this.plancheck2Coverage.couple) {
                  const element2: any = dom.querySelector(
                    '#executiveplansblock2Tiercouple' +
                    selectedplansblock2[i].subGroupid
                  );
                  element2.checked = true;
                } else if (this.plancheck2Coverage.family) {
                  const element2: any = dom.querySelector(
                    '#executiveplansblock2Tierfamily' +
                    selectedplansblock2[i].subGroupid
                  );
                  element2.checked = true;
                }
              }
              this.plansresblack2Tiers[selectedplansblock2[i].packageindex][
                'groups'
              ][selectedplansblock2[i].groupindex]['subGroups'][
                selectedplansblock2[i].subgroupindex
              ].tiers = selectedplansblock2[i].tiers;
            }
          }, 1000);
        }
        if (selectedplansblock3.length > 0) {
          let el1: HTMLElement = this.employeepurchaseTierstrue.nativeElement;
          el1.click();
          this.employeeplanpurchasetiers == true;
          setTimeout(() => {
            for (let i = 0; i < selectedplansblock3.length; i++) {
              const element2: any = dom.querySelector(
                '#plancheck3Voluntry' + selectedplansblock3[i].subGroupid
              );
              element2.checked = true;
              // this.plancheck3Coverage = selectedplansblock3[i].coverage;
              this.plancheck3Coverage = this.getExecutiveCoveragesFromCode(
                selectedplansblock3[i].coverage
              );

              if (this.plancheck3Coverage) {
                if (this.plancheck3Coverage.single) {
                  const element2: any = dom.querySelector(
                    '#executiveplansblock3Tiersingle' +
                    selectedplansblock3[i].subGroupid
                  );
                  element2.checked = true;
                } else if (this.plancheck3Coverage.couple) {
                  const element2: any = dom.querySelector(
                    '#executiveplansblock3Tiercouple' +
                    selectedplansblock3[i].subGroupid
                  );
                  element2.checked = true;
                } else if (this.plancheck3Coverage.family) {
                  const element2: any = dom.querySelector(
                    '#executiveplansblock3Tierfamily' +
                    selectedplansblock3[i].subGroupid
                  );
                  element2.checked = true;
                }
              }
              this.plansresblack3Tiers[selectedplansblock3[i].packageindex][
                'groups'
              ][selectedplansblock3[i].groupindex]['subGroups'][
                selectedplansblock3[i].subgroupindex
              ].tiers = selectedplansblock3[i].tiers;
            }
          }, 1500);
        }
      }, 1000);
    }
  }
  phonenumbercheck(event) {
    // console.log(event)
    this.formatPhoneNumber(event.target.value);
  }
  formatPhoneNumber(phoneNumberString) {
    var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      var intlCode = match[1] ? '+1 ' : '';
      return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
    }
    return null;
  }

  phoneFormat(event: any) {
    const inputValue = this.adminform.get('adminphone').value;

    this.adminform
      .get('adminphone')
      .setValue(this.phoneNoFormat.transform(inputValue), { emitEvent: false });
  }

  phoneFormat1(event: any) {
    const inputValue = this.addEmployeeformList.get("employeePhoneno").value;

    this.addEmployeeformList
      .get("employeePhoneno")
      .setValue(this.phoneNoFormat.transform(inputValue), { emitEvent: false });
  }

  phoneFormatWaddell(event: any) {
    const inputValue = this.addEmployeeformListwaddell.get("employeePhoneno").value;

    this.addEmployeeformListwaddell
      .get("employeePhoneno")
      .setValue(this.phoneNoFormat.transform(inputValue), { emitEvent: false });
  }
  alphabatesOnly(event: any) {
    const charCode = event.which ? event.which : event.keyCode;

    if (event.currentTarget.value.length == 0) {
      if (
        (charCode >= 65 && charCode <= 90) ||
        (charCode >= 97 && charCode <= 122) ||
        (charCode >= 192 && charCode <= 255) ||
        charCode == 46 ||
        charCode == 45 ||
        charCode == 39 ||
        charCode == 95
      )
        return true;
      else return false;
    } else {
      if (
        (charCode >= 65 && charCode <= 90) ||
        (charCode >= 97 && charCode <= 122) ||
        (charCode >= 192 && charCode <= 255) ||
        charCode === 32 ||
        charCode == 46 ||
        charCode == 45 ||
        charCode == 39 ||
        charCode == 95
      )
        return true;
      else return false;
    }
  }

  alphaNumarics(event: any) {
    const charCode = event.which ? event.which : event.keyCode;

    if (event.currentTarget.value.length === 0) {
      if (
        (charCode >= 48 && charCode <= 57) || // Numbers
        (charCode >= 65 && charCode <= 90) || // Uppercase letters
        (charCode >= 97 && charCode <= 122) || // Lowercase letters
        (charCode >= 192 && charCode <= 255) ||
        charCode === 46 ||
        charCode === 45 ||
        charCode === 39 ||
        charCode === 95
      )
        return true;
      else return false;
    } else {
      if (
        (charCode >= 48 && charCode <= 57) || // Numbers
        (charCode >= 65 && charCode <= 90) || // Uppercase letters
        (charCode >= 97 && charCode <= 122) || // Lowercase letters
        (charCode >= 192 && charCode <= 255) ||
        charCode === 32 ||
        charCode === 46 ||
        charCode == 47 ||
        charCode === 45 ||
        charCode === 39 ||
        charCode === 95
      )
        return true;
      else return false;
    }
  }
  // textChangeToLowerCase(formcontrolField: any) {
  //   this.f[formcontrolField].setValue(
  //     this.f[formcontrolField].value.toLowerCase()
  //   );
  //   console.log('qwertytrty     ', this.f[formcontrolField].value);
  // }
  changeAdminRole(event: any) {
    if (event.target.value == 'CORPORATE_OTHERS') {
      this.showOtherField = true;
      // this.adminform.get('roleName').setValidators(Validators.required);
      this.adminform.get('roleName').updateValueAndValidity();
    } else {
      this.showOtherField = false;
      this.adminform.get('roleName').clearValidators();
      this.adminform.get('roleName').updateValueAndValidity();
    }
  }


  exportAsExcel() {

    let employeedata = [

      {
        label: this.lang.First_Name,
        header: this.lang.First_Name,
        key: 'firstName',
        mandatory: true,
        display: true,
      },
      {
        label: this.lang.Last_Name,
        header: this.lang.Last_Name,
        key: 'lastName',
        mandatory: true,
        display: true,
      },
      {
        label: this.lang.Email,
        header: this.lang.Email,
        key: 'email',
        mandatory: true,
        display: true,
      },
      {
        label: 'Province of Residence',
        header: 'Province of Residence',
        key: 'provinceOfResidence',
        dispaly: true,
        mandatory: true,
      }
    ];
    var obj: any = {};
    let excelempdata = [];
    for (let i = 0; i < employeedata.length; i++) {
      obj[employeedata[i].label] = '';
      excelempdata.push(obj);
    }
    var finalres = Object.values(
      excelempdata.reduce((c, e) => {
        if (!c[e.Email]) c[e.Email] = e;
        return c;
      }, {})
    );
    let finalemployeekeys = finalres;
    this.excelService.exportAsExcelFilePlans(finalemployeekeys, employeedata, 'Employee Details');



  }
  toCamelCase(str) {
    // console.log(str)
    const s = str
      .toLowerCase()
      .split(' ')
      .map((word, index) => {
        if (index === 0) {
          return word;
        } else {
          return word.charAt(0).toUpperCase() + word.slice(1);
        }
      })
      .join('');
    return s
  }

  exportAsXLSX(subgroupId, keys): void {

    // console.log(keys, this.showHeadCount[subgroupId])
    this.excelempdata = []

    if (!this.showHeadCount[subgroupId] || this.showHeadCount[subgroupId] <= 0) {
      return
    }


    this.employeedata = keys

    this.employeedata2 = keys
    var obj: any = {};


    console.log(this.employeedata)
    for (let i = 0; i < this.employeedata.length; i++) {
      obj[this.employeedata[i].value] = '';
      this.excelempdata.push(obj);
      console.log({ "exp": this.excelempdata })
    }

    var finalres = Object.values(
      this.excelempdata.reduce((c, e) => {
        if (!c[e.Gender]) c[e.Gender] = e;
        return c;
      }, {})
    );
    console.log(this.excelempdata)

    this.finalemployeekeys = finalres;

    console.log(this.finalemployeekeys);
    let multiProviance = [];

    this.configprovincereslist.map((proviance) => {
      multiProviance.push(proviance.shortName);
    });

    let formData = JSON.parse(sessionStorage.getItem('formData') || '');

    this.excelService.exportAsExcelFileBulk(
      this.finalemployeekeys,
      this.employeedata2,
      'CorporateBulksPlans',
      formData.tierConfig,
      formData.walletConfig,
      this.showHeadCount[subgroupId],
      this.multiSelectProviancenames
    );

  }

  onFileChangeExcelbulk(ev: any) {
    console.log(this.showEmployeeValue)
    if (!this.showEmployeeValue) {
      this.headCountmiss = true
    }
    else {
      this.headCountmiss = false

      // this.editemployeefrom = false;
      // this.addemployeefrom = false;
      let workBook: any = null;
      let jsonData = [];
      const reader = new FileReader();

      const file = ev.target.files[0];
      reader.readAsArrayBuffer(file)
      reader.onload = async (event) => {
        const data = reader.result;
        const wb = await this.excelService.readDataFromExcel(data);
        const employeeSheet = wb.getWorksheet(this.excelService.EXCEL_SHEETNAME);
        console.log(employeeSheet);
        // read first row as data keys
        if (employeeSheet) {
          let firstRow = employeeSheet.getRow(1);
          console.log(firstRow)
          if (!firstRow.cellCount) return;
          let keys = firstRow.values;
          console.log(keys)
          let ExceldataError = false
          let ExceldataErrorMessage = ''
          let ExceldataemailError = false
          let ExceldataEmailErrorMessage = ''
          let ExceldataFirstNameError = false
          let ExceldataFirstNameErrorMessage = ''
          let ExceldataLastNameError = false
          let ExceldataLastNameErrorMessage = ''
          employeeSheet.eachRow((row, rowNumber) => {
            if (rowNumber == 1) return;
            let values = row.values;
            let obj = {};
            //@ts-ignore


            //@ts-ignore
            for (let i = 1; i < keys.length; i++) {
              if (ExceldataError) {
                break;
              }
              if (keys[i]) {
                let value = values[i]
                // if(value==""){
                //   this.myFileInput.nativeElement.value = '';

                // }
                switch (keys[i]) {
                  case this.lang.First_Name:
                    if (value && value != '') {

                      if (value.text && value.text.length) {
                        value = value.text.charAt(0).toUpperCase() + value.text.slice(1)
                      }
                      else {
                        value = value.charAt(0).toUpperCase() + value.slice(1)
                      }
                      if (value.length >= 1) {

                      }
                      else {
                        ExceldataFirstNameError = true
                        ExceldataFirstNameErrorMessage = 'First Name must be minimum of 1 characters, please check';
                        break;
                      }
                    }
                    else {

                      console.log(value)
                      ExceldataError = true
                      ExceldataErrorMessage = this.lang.First_Name_can_t_be_empty
                      break;
                    }
                    break;
                  case this.lang.Last_Name:
                    if (value && value != '') {

                      if (value.text && value.text.length) {
                        value = value.text.charAt(0).toUpperCase() + value.text.slice(1)
                      }
                      else {
                        value = value.charAt(0).toUpperCase() + value.slice(1)
                      }
                      if (value.length >= 1) {

                      }
                      else {
                        ExceldataLastNameError = true
                        ExceldataLastNameErrorMessage = 'Last Name must be minimum of 1 characters, please check';
                        break;
                      }
                    }
                    else {
                      ExceldataError = true
                      ExceldataErrorMessage = this.lang.Last_Name_can_t_be_empty
                      break;
                    }
                    break;

                  case this.lang.Email:
                    if (value && value != '') {
                      // value=value.text
                      if (value.text && value.text.length) {
                        value = value.text.charAt(0).toLowerCase() + value.text.slice(1)
                      }
                      else {
                        value = value.charAt(0).toLowerCase() + value.slice(1)
                      }
                      var filter = this.commonPatternsService.emailTestPattern;
                      // if (!filter.test(value)) {
                      //     // alert('Please /provide a valid email address');

                      //     ExceldataemailError =true
                      // ExceldataEmailErrorMessage = "Some fields have invalid email, please check"
                      // break;
                      // }

                    }
                    else {
                      ExceldataError = true
                      ExceldataErrorMessage = this.lang.Email_can_t_be_empty
                      break;
                    }


                    break;
                  case this.lang.Date_of_Hire:
                    if (value && value != '') {
                      value = moments(value).format(this.dateFormat)
                    }
                    break;
                  case this.lang.Date_of_Birth:
                    if (value && value != '') {
                      value = moments(value).format(this.dateFormat);
                      let today = moment(new Date());
                      let maxDAte = moment(today.subtract('16', 'years').calendar()).format(this.dateFormat);

                      if (moment(value).isAfter(maxDAte)) {
                        ExceldataError = true;
                        ExceldataErrorMessage = this.lang.Age_should_not_exceed_16_years;
                      }
                    }
                    break;


                  case this.lang.Province_of_Employment:

                    if (value && value != '') {


                    }
                    // else{
                    //   ExceldataError =true
                    //   ExceldataErrorMessage = this.lang.Province_can_t_be_empty
                    //   break;
                    // }
                    break;
                  case this.lang.Classification_Tiers:
                    // obj["classificationTier"] = this.gettierId(value)
                    break;
                  case this.lang.Job_Title:
                    if (value && value != '') {

                      if (value.text && value.text.length) {
                        value = value.text.charAt(0).toUpperCase() + value.text.slice(1)
                      }
                      else {
                        value = value.charAt(0).toUpperCase() + value.slice(1)
                      }
                    }
                    break;
                }

                obj[keys[i]] = value;


              }

            }

            jsonData.push(obj);
          });
          if (ExceldataError) {

            Swal.fire({
              title: this.lang.Info
              , text: ExceldataErrorMessage
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                this.myFileInput.nativeElement.value = '';
              }


            });
            jsonData = []
          }
          if (ExceldataemailError) {

            Swal.fire({
              title: this.lang.Info,
              text: ExceldataEmailErrorMessage
            }).then((result) => {
              if (result.isConfirmed) {
                this.myFileInput.nativeElement.value = '';
              }

            });
            jsonData = []
          }
          if (ExceldataFirstNameError) {

            Swal.fire({
              title: this.lang.Info,
              text: ExceldataFirstNameErrorMessage
            }).then((result) => {
              if (result.isConfirmed) {
                this.myFileInput.nativeElement.value = '';
              }


            });
            jsonData = []
          }
          if (ExceldataLastNameError) {

            Swal.fire({
              title: this.lang.Info,
              text: ExceldataLastNameErrorMessage
            }).then((result) => {
              if (result.isConfirmed) {
                this.myFileInput.nativeElement.value = '';
              }
            })
            jsonData = []
          }
        } else {
          //tampered excel error
        }

        console.log(jsonData);

        jsonData.forEach((element: any) => {
          element["isBulk"] = true
        })

        let uploadEmployeeData = jsonData;

        console.log(uploadEmployeeData);

        uploadEmployeeData = uploadEmployeeData.map(function (obj: any) {
          obj['employeeId'] = obj['Employee ID']?.toString() || "";
          obj['firstName'] = obj['First Name'];
          obj['lastName'] = obj['Last Name'];
          obj['email'] = obj['Email'];
          obj['jobTitle'] = obj['Job Title'];
          obj['dateOfBirth'] = obj['Date of Birth'];
          obj['dateOfHire'] = obj['Date of Hire'];
          obj['gender'] = obj['Gender'];
          // obj['residentIn'] = obj['Resident in'];
          obj['country'] = obj['Country'];
          obj['province'] = obj['Province of Employment'];
          obj['maritalStatus'] = obj['Marital Status'];
          obj['phoneNum'] = obj['Phone'];
          obj['annualIncome'] = obj['Annual Income'];
          // obj['annualIncome'] = obj['Annaul Income'];
          // obj['provienceName'] = obj['Provience Name'];
          obj['classificationTier'] = obj['Classification Tier'];


          if (typeof obj.employeeId == 'number') {
            obj.employeeId = obj.employeeId.toString();
          }
          if (typeof obj.phoneNum == 'number') {
            obj.phoneNum = obj.phoneNum.toString();
          }
          if (obj.phoneNum == '') {
            obj.phoneNum = '';
          }
          if (obj.annualIncome == '') {
            obj.annualIncome = 0;
          }
          if (obj.classificationTier == '' || obj.classificationTier == undefined || obj.classificationTier == "All") {
            obj.classificationTier = 0; //assign default tier id
          }

          // obj.dateofBirth =  new Date((obj.dateofBirth - (25567 + 1))*86400*1000);
          delete obj['Employee ID'];
          delete obj['First Name'];
          delete obj['Last Name'];
          delete obj['Email'];
          delete obj['Job Title'];
          delete obj['Date of Birth'];
          delete obj['Date of Hire'];
          delete obj['Gender'];
          //delete obj['Resident in'];
          delete obj['Country'];
          delete obj['Province of Employment'];
          delete obj['Marital Status'];
          delete obj['Phone'];
          delete obj['Annual Income'];
          delete obj['Provience Name'];
          delete obj['Classification Tier'];
          delete obj['Provience Id'];
          // Assign new key
          return obj;

        });

        // assign province-id
        //asign tier-id

        console.log(this.employeeList);

        if (this.employeeList.length > 0) {
          for (let i = 0; i < uploadEmployeeData.length; i++) {
            this.employeeList.push(uploadEmployeeData[i]);
          }
        } else {
          this.employeeList = uploadEmployeeData;
        }

        //original-employee-list

        //already-emp-cust-id?

        for (let i = 0; i < this.employeeList.length; i++) {
          if (this.employeeList[i] && this.employeeList[i]['uId']) {

          }
          else {
            this.employeeList[i]['uId'] = 0
          }
          if (this.employeeList[i] && this.employeeList[i]['phoneNum']) {

          }
          else {
            this.employeeList[i]['phoneNum'] = ""
          }
        }

        this.lengthofemployee = this.employeeList.length;

        if (this.maxEmployeeCount && this.maxEmployeeCount > 0) {

        }
        else {
          // this.maxEmployeeCount = this.employeeList.length;
          let formData = JSON.parse(sessionStorage.getItem('formData') || '');

          this.maxEmployeeCount = formData.expectednoofEmployees;
        }

        console.log(this.employeeList);
        if (this.employeeList.length > 0) {
          this.myFileInput.nativeElement.value = '';
        }
      };
    }
    // reader.readAsBinaryString(file);
  }
  exportAsXLSXWaddel(): void {

    console.log(this.multiSelectProviancenames)
    if (!this.showEmployeeValue1) {
      this.headCountmiss1 = true
    }
    else {
      this.headCountmiss1 = false


      this.employeedata = [
        {
          "label": "firstName",
          "key": "firstName",
          "value": "First Name",
          "mandatory": true
        },
        {
          "label": "lastName",
          "key": "lastName",
          "value": "Last Name",
          "mandatory": true
        },
        {
          "label": "email",
          "key": "email",
          "value": "Email",
          "mandatory": true
        },
        {
          "label": "phoneNum",
          "key": "phoneNum",
          "value": "Phone Number",
          "mandatory": true
        },
        {
          "label": "streetAddress",
          "key": "streetAddress",
          "value": "Street Address",
          "mandatory": true
        },
        {
          "label": "country",
          "key": "country",
          "value": "Country",
          "mandatory": true
        },
        {
          "label": "city",
          "key": "city",
          "value": "City",
          "mandatory": true
        },
        {
          "label": "province",
          "key": "province",
          "value": "Province",
          "mandatory": true
        },
        {
          "label": "postalCode",
          "key": "postalCode",
          "value": "PostalCode",
          "mandatory": true
        }
      ]

      this.employeedata2 = [
        {
          "label": "firstName",
          "key": "firstName",
          "value": "First Name",
          "mandatory": true,
          display: true
        },
        {
          "label": "lastName",
          "key": "lastName",
          "value": "Last Name",
          "mandatory": true,
          display: true
        },
        {
          "label": "email",
          "key": "email",
          "value": "Email",
          "mandatory": true,
          display: true
        },
        {
          "label": "phoneNum",
          "key": "phoneNum",
          "value": "Phone Number",
          "mandatory": true,
          display: true
        },
        {
          "label": "streetAddress",
          "key": "streetAddress",
          "value": "Street Address",
          "mandatory": true,
          display: true
        },
        {
          "label": "country",
          "key": "country",
          "value": "Country",
          "mandatory": true,
          display: true
        },
        {
          "label": "city",
          "key": "city",
          "value": "City",
          "mandatory": true,
          display: true
        },
        {
          "label": "province",
          "key": "province",
          "value": "Province",
          "mandatory": true,
          display: true
        },
        {
          "label": "postalCode",
          "key": "postalCode",
          "value": "PostalCode",
          "mandatory": true,
          display: true
        }]



      var obj: any = {};
      for (let i = 0; i < this.employeedata.length; i++) {
        obj[this.employeedata[i].value] = '';
        this.excelempdata.push(obj);
      }

      var finalres = Object.values(
        this.excelempdata.reduce((c, e) => {
          if (!c[e.Gender]) c[e.Gender] = e;
          return c;
        }, {})
      );

      console.log(finalres)
      this.finalemployeekeys = finalres;
      let multiProviance = [];
      this.configprovincereslist.map((proviance) => {
        multiProviance.push(proviance.shortName);
      });
      console.log(this.finalemployeekeys);
      let formData = JSON.parse(sessionStorage.getItem('formData') || '');
      this.excelService.exportAsExcelFileBulkwaddell(
        this.finalemployeekeys,
        this.employeedata2,
        'CorporateBulksPlansWaddell',
        formData.tierConfig,
        formData.walletConfig,
        this.showEmployeeValue1,
        this.multiSelectProviancenames
      );
    }


  }
  onFileChangeExcelWaddel(ev: any) {
    console.log("calling1")
    console.log(this.showEmployeeValue1)
    if (!this.showEmployeeValue1) {
      this.headCountmiss1 = true
    }
    else {
      this.headCountmiss1 = false

      const file = ev.target.files[0];
      var fileExtension = '.' + ev.target.files[0].name.split('.').pop();
      const timestamp = new Date().getTime();


      var allowedMimes = [
        '.xlsx'
      ];

      let error = false;

      let message = '';

      const newFilename = `file_${timestamp}${fileExtension}`;
      console.log(newFilename)
      const newFile = new File([file], newFilename, { type: file.type });
      console.log(newFile)

      if (allowedMimes?.includes(fileExtension)) {
        let workBook: any = null;
        let jsonData = [];
        const reader = new FileReader();
        reader.readAsArrayBuffer(newFile)
        reader.onload = async (event) => {
          const data = reader.result;
          const wb = await this.excelService.readDataFromExcel(data);
          const employeeSheet = wb.getWorksheet(this.excelService.EXCEL_SHEETNAME);
          console.log(employeeSheet);
          if (employeeSheet) {
            let firstRow = employeeSheet.getRow(1);
            console.log(firstRow)
            if (!firstRow.cellCount) return;
            let keys = firstRow.values;
            console.log(keys)
            let seenEmployeeEmails = new Set();
            let ExceldataError = false
            let ExceldataErrorMessage = ''
            let ExceldataemailError = false
            let ExceldataPhonenumberError = false
            let ExceldataPhonenumberErrorMessage = ''
            let ExceldataEmailErrorMessage = ''
            let ExceldataFirstNameError = false
            let ExceldataFirstNameErrorMessage = ''
            let ExceldataLastNameError = false
            let ExceldataLastNameErrorMessage = ''
            let ExceldatapostalCodeError = false;
            let ExceldataPosatlCodeErrorMessage = ''
            let ExceldataProvinceError = false;
            let ExceldataProvinceErrorMessage = '';
            employeeSheet.eachRow((row, rowNumber) => {
              if (rowNumber == 1) return;
              let values = row.values;
              let obj = {};
              //@ts-ignore


              //@ts-ignore

              for (let i = 1; i < keys.length; i++) {
                if (ExceldataError) {
                  break;
                }
                if (keys[i]) {
                  let value = values[i]


                  // if(value==""){
                  //   this.myFileInput.nativeElement.value = '';

                  // }
                  switch (keys[i]) {
                    case "First Name":
                      if (value && value != '') {
                        console.log(value)
                        if (value.text && value.text.length) {
                          value = value.text.charAt(0).toUpperCase() + value.text.slice(1)
                        }
                        else {
                          value = value.charAt(0).toUpperCase() + value.slice(1)
                        }
                        if (value.length >= 1) {

                        }
                        else {
                          ExceldataFirstNameError = true
                          ExceldataFirstNameErrorMessage = "First Name must be minimum of 1 characters, please check"
                          break;
                        }
                      }
                      else {
                        console.log(value)
                        ExceldataError = true
                        ExceldataErrorMessage = this.lang.First_Name_can_t_be_empty
                        break;
                      }
                      break;
                    case "Last Name":
                      if (value && value != '') {
                        // console.log(value.length)
                        if (value.text && value.text.length) {
                          value = value.text.charAt(0).toUpperCase() + value.text.slice(1)
                        }
                        else {
                          value = value.charAt(0).toUpperCase() + value.slice(1)
                        }
                        if (value.length >= 1) {

                        }
                        else {
                          ExceldataLastNameError = true
                          ExceldataLastNameErrorMessage = "Last Name must be minimum of 1 characters, please check"
                          break;
                        }
                      }
                      else {
                        ExceldataError = true
                        ExceldataErrorMessage = this.lang.Last_Name_can_t_be_empty
                        break;
                      }
                      break;
                    case "Email":
                      if (value && value != '') {
                        // value=value.text
                        if (seenEmployeeEmails.has(value)) {
                          ExceldataemailError = true;
                          ExceldataEmailErrorMessage = this.lang.Duplicate_Employee_ID_exists_please_check;
                          ExceldataError = true;
                          break;
                        } else {
                          seenEmployeeEmails.add(value);
                        }
                        if (value.text && value.text.length) {
                          value = value.text.charAt(0).toLowerCase() + value.text.slice(1)
                        }
                        else {
                          value = value.charAt(0).toLowerCase() + value.slice(1)
                        }
                        var filter = this.commonPatternsService.emailTestPattern;
                        // if (!filter.test(value)) {
                        //     // alert('Please /provide a valid email address');

                        //     ExceldataemailError =true
                        // ExceldataEmailErrorMessage = "Some fields have invalid email, please check"
                        // break;
                        // }

                      }
                      else {
                        ExceldataError = true
                        ExceldataErrorMessage = this.lang.Email_can_t_be_empty
                        break;
                      }


                      break;
                    // case "Plan Enrollment Date":
                    //     if (value && value != '') {


                    //     }
                    //     else {
                    //       ExceldataError = true
                    //       ExceldataErrorMessage = "Plan Enrollment Date can't be empty"
                    //       break;
                    //     }
                    //     break;

                    case "Phone Number":
                      if (value && value != '') {
                        // console.log(value)
                        // console.log(value.length)
                        // if (value.length == 10) {

                        // }
                        // else {
                        //   ExceldataPhonenumberError = true
                        //   ExceldataPhonenumberErrorMessage = "Phone Number not equal to 10 digits, please check"
                        //   break;
                        // }

                      }
                      else {
                        ExceldataError = true
                        ExceldataErrorMessage = this.lang.Phone_Number_can_t_be_empty
                        break;
                      }
                      break;
                    case "Street Address":
                      if (value && value != '') {


                      }
                      else {
                        ExceldataError = true
                        ExceldataErrorMessage = this.lang.Street_Address_can_t_be_empty
                        break;
                      }
                      break;
                    case "Country":
                      if (value && value != '') {


                      }
                      else {
                        ExceldataError = true
                        ExceldataErrorMessage = this.lang.Country_can_t_be_empty
                        break;
                      }
                      break;
                    case "City":
                      if (value && value != '') {


                      }
                      else {
                        ExceldataError = true
                        ExceldataErrorMessage = this.lang.City_can_t_be_empty
                        break;
                      }
                      break;
                    case "Province":
                      if (value && value != '') {

                        this.configprovinceres.forEach((element: any) => {
                          if (element.shortName == this.postalvalue) {
                            this.provincialZipcodes = element.zipcodes.split(',');
                            this.provincelistid = element.id;
                            this.state_id = parseInt(element.fusebillId);
                            this.statename = element.name;
                          }
                        });


                        console.log(this.provincialZipcodes)
                        console.log(this.ExcelProvinceCode)
                        //   if (this.provincialZipcodes.indexOf(this.ExcelProvinceCode[0]) == -1) {

                        //     // alert("1")

                        // ExceldataProvinceError =true
                        // ExceldataProvinceErrorMessage = this.lang.Some_fields_have_invalid_postal_code_please_check
                        // break;

                        //   }

                      }
                      else {
                        ExceldataError = true
                        ExceldataErrorMessage = this.lang.Province_can_t_be_empty
                        break;
                      }
                      break;
                    case "PostalCode":

                      if (value && value != '') {
                        value = value.toUpperCase();

                        this.ExcelProvinceCode = this.postalvalue


                        var postalRegexp = /^(?!.*[DFIOQU])[A-VXY][0-9][A-Z] ?[0-9][A-Z][0-9]$/gm;

                        if (this.provincialZipcodes.indexOf(value[0]) == -1 || !postalRegexp.test(value)) {
                          //  alert("2")
                          ExceldatapostalCodeError = true
                          ExceldataPosatlCodeErrorMessage = this.lang.Some_fields_have_invalid_postal_code_please_check
                          break;

                        }




                      }
                      else {
                        ExceldataError = true
                        ExceldataErrorMessage = this.lang.PostalCode_can_t_be_empty
                        break;
                      }
                      break;

                  }

                  obj[keys[i]] = value;


                }

              }
              jsonData.push(obj);
            });
            if (ExceldataError) {

              Swal.fire({
                title: this.lang.Info
                , text: ExceldataErrorMessage
              }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                  this.myFileInputwaddel.nativeElement.value = '';
                }


              });
              jsonData = []
            }
            if (ExceldataFirstNameError) {

              Swal.fire({
                title: this.lang.Info,
                text: ExceldataFirstNameErrorMessage
              }).then((result) => {
                if (result.isConfirmed) {
                  this.myFileInputwaddel.nativeElement.value = '';
                }


              });
              jsonData = []
            }
            if (ExceldataLastNameError) {

              Swal.fire({
                title: this.lang.Info,
                text: ExceldataLastNameErrorMessage
              }).then((result) => {
                if (result.isConfirmed) {
                  this.myFileInputwaddel.nativeElement.value = '';
                }
              })
              jsonData = []
            }
            if (ExceldataemailError) {

              Swal.fire({
                title: this.lang.Info,
                text: ExceldataEmailErrorMessage
              }).then((result) => {
                if (result.isConfirmed) {
                  this.myFileInputwaddel.nativeElement.value = '';
                }

              });
              jsonData = []
            }
            if (ExceldataPhonenumberError) {

              Swal.fire({
                title: this.lang.Info,
                text: ExceldataPhonenumberErrorMessage
              }).then((result) => {
                if (result.isConfirmed) {
                  this.myFileInputwaddel.nativeElement.value = '';
                }

              });
              jsonData = []
            }
            if (ExceldatapostalCodeError) {

              Swal.fire({
                title: this.lang.Info,
                text: ExceldataPosatlCodeErrorMessage
              }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                  this.myFileInputwaddel.nativeElement.value = '';
                }


              });
              jsonData = []
            }
            if (ExceldataProvinceError) {

              Swal.fire({
                title: this.lang.Info,
                text: ExceldataProvinceErrorMessage
              }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                  this.myFileInputwaddel.nativeElement.value = '';
                }


              });
              jsonData = []
            }

            keys = []



            let uploadEmployeeData = jsonData;


            // this.showEmployeeValue = array.length+uploadEmployeeData.length
            // if (array.length+uploadEmployeeData.length != this.showEmployeeValue) {

            //   Swal.fire({ title: 'Info', text: "Head count and upload Employee/Entity List not match." });
            //   this.myFileInput.nativeElement.value = '';

            // }
            // else {



            this.multiSelectProviancenames.sort(function (a, b) {
              return (a.id - b.id);
            })

            let province = ""
            let provincearray = []

            this.multiSelectProviancenames.forEach(element => {
              provincearray.push(element.shortName)
            });


            if (this.multiSelectProviancenames.length == 1) {
              // for(let i=0;i<this.multiSelectProviancenames.length;i++){
              province = this.multiSelectProviancenames[0].shortName
              // }
            }
            else if (this.multiSelectProviancenames.length > 1) {
              if (provincearray?.includes(this.province)) {
                province = this.province

              }
              else {
                if (provincearray?.includes("ON")) {
                  province = "ON"
                }
                else {
                  province = this.multiSelectProviancenames[0].shortName
                }
              }

            }


            console.log(uploadEmployeeData)
            uploadEmployeeData = uploadEmployeeData.map(function (obj: any) {
              // obj['planEnrollmentDate'] = obj['Plan Enrollment Date'];
              obj['employeeId'] = obj['Employee ID']?.toString() || ""
              obj['firstName'] = obj['First Name'];
              obj['lastName'] = obj['Last Name'];
              obj['email'] = obj['Email'];
              // obj['residentIn'] = obj['Resident in'];
              obj['country'] = "Canada";
              // obj['province'] = obj['Province of Employment'];
              obj['province'] = obj['Province'];
              obj['phoneNum'] = obj['Phone Number'];

              obj['postalCode'] = obj['PostalCode'];

              obj['city'] = obj['City'];
              obj['streetAddress'] = obj['Street Address'];
              obj['uId'] = 0;
              obj['bulkPlanLevelId'] = 34
              obj['isBulk'] = true

              if (typeof obj.phoneNum == 'number') {
                obj.phoneNum = obj.phoneNum.toString();
              }

              if (typeof obj.planEnrollmentDate == 'number') {
                obj.planEnrollmentDate = obj.planEnrollmentDate.toString();
              }
              if (typeof obj.streetAddress == 'number') {
                obj.streetAddress = obj.streetAddress.toString();
              }


              console.log(obj)

              // obj.dateofBirth =  new Date((obj.dateofBirth - (25567 + 1))*86400*1000);
              delete obj['Employee ID']
              delete obj['First Name'];
              delete obj['Last Name'];
              delete obj['Email'];

              // delete obj['Plan Enrollment Date'];
              delete obj['Province'];
              //delete obj['Resident in'];
              delete obj['Country'];
              delete obj['City'];

              delete obj['Phone Number'];
              // delete obj['uId'];
              delete obj['Street Address'];
              delete obj['PostalCode'];
              // delete obj['Provience Id'];
              // Assign new key
              return obj;

            });

            // assign province-id
            //asign tier-id
            console.log(uploadEmployeeData);
            this.uploadEmployeeExcelData = uploadEmployeeData



            let array = []
            let array1 = []
            if (jsonData.length > 0) {
              console.log(this.employeeList)
              if (this.employeeList.length > 0) {
                for (let i = 0; i < this.employeeList.length; i++) {
                  if (this.employeeList[i].isBulk == true && this.employeeList[i].bulkPlanLevelId == 34) {
                    array.push(this.employeeList[i]);
                  } else {
                    array1.push(this.employeeList[i]);
                  }


                }
                console.log(array1, array, this.employeeList)

                if (array.length > 0) {
                  Swal.fire({
                    title: this.lang.Info,
                    html: '<div style="text-align: left;">' + this.lang.Do_you_want_to_replace_or_append_the_employee_list + ' <br> <div style="font-size: 10px;">Replace - Existing replaced with new file.<br>Append - File will be appended to the existing list.</div></div>', showCancelButton: true,
                    showDenyButton: true,
                    confirmButtonColor: '#10104d',
                    cancelButtonColor: '#10104d',
                    confirmButtonText: this.lang.Append,
                    denyButtonText: this.lang.Replace

                  }).then((result) => {
                    if (result.isConfirmed) {

                      console.log(this.employeeList) //old

                      console.log(uploadEmployeeData) //new

                      let temparray = []
                      let uploadEmployeeDataIndex = []
                      let existingRemoveEmployeeDataIndex = []
                      temparray = this.employeeList
                      let existingEmails = this.employeeList.map(a => a.email);


                      for (let j = 0; j < uploadEmployeeData.length; j++) {
                        if (existingEmails?.includes(uploadEmployeeData[j].email)) {
                          console.log(existingEmails.indexOf(uploadEmployeeData[j].email))
                          console.log(this.employeeList[existingEmails.indexOf(uploadEmployeeData[j].email)])
                          if (this.employeeList[existingEmails.indexOf(uploadEmployeeData[j].email)].uId && this.employeeList[existingEmails.indexOf(uploadEmployeeData[j].email)].uId > 0) {


                            existingRemoveEmployeeDataIndex.push(existingEmails.indexOf(uploadEmployeeData[j].email))

                          }
                          else {

                            temparray[existingEmails.indexOf(uploadEmployeeData[j].email)] = uploadEmployeeData[j]
                          }

                        }
                        else {
                          temparray.push(uploadEmployeeData[j]);
                        }
                      }



                      console.log(temparray)

                      let EmailError = []
                      if (existingRemoveEmployeeDataIndex.length > 0) {
                        for (let i = 0; i < existingRemoveEmployeeDataIndex.length; i++) {
                          EmailError.push(temparray[existingRemoveEmployeeDataIndex[i]].email)
                        }
                      }

                      console.log(EmailError)
                      console.log(temparray)

                      console.log(this.employeeList)

                      this.employeeList = temparray
                      console.log(this.employeeList)

                      let mergeArray = []
                      // let initialLength = this.employeeList.length;
                      for (let i = 0; i < this.employeeList.length; i++) {
                        console.log(this.employeeList[i].isBulk, this.employeeList.length, this.employeeList[i].isBulk == true)
                        if (this.employeeList[i].isBulk == true && this.employeeList[i].bulkPlanLevelId == 34) {
                          console.log(this.employeeList[i].isBulk == true)
                          mergeArray.push(this.employeeList[i]);
                          // this.bulkemployeeList.push(this.employeeList[i]);
                        }
                        // }
                      }
                      this.bulkemployeeList = [...this.bulkemployeeList, ...this.employeeList]

                      this.showEmployeeValue1 = mergeArray.length
                      console.log(this.showEmployeeValue1, this.bulkemployeeList)

                      for (let i = 0; i < this.employeeList.length; i++) {

                        if (this.employeeList[i] && this.employeeList[i]['uId']) {

                        }
                        else {
                          this.employeeList[i]['uId'] = 0
                        }
                        if (this.employeeList[i] && this.employeeList[i]['phoneNum']) {

                        }
                        else {
                          this.employeeList[i]['phoneNum'] = ""
                        }
                      }

                      this.lengthofemployee = this.employeeList.length;

                      if (this.maxEmployeeCount && this.maxEmployeeCount > 0) {

                      }
                      else {
                        // this.maxEmployeeCount = this.employeeList.length;
                        let formData = JSON.parse(sessionStorage.getItem('formData') || '');

                        this.maxEmployeeCount = formData.expectednoofEmployees;
                      }
                      this.addedEmployeelist = this.employeeList
                      // this.addedEmployeelist.forEach((element: any) => {
                      //   element["isBulk"] = true
                      // })

                      console.log(this.employeeList);
                      this.toastrService.success(this.showEmployeeValue1 + " " + this.lang.Employees_Added);
                      setTimeout(() => {
                        setTimeout(() => {
                          if (EmailError.length > 0) {
                            this.toastrService.warning(EmailError.toString() + " " + this.lang.Employees_Exists);
                          }
                        }, 1000);
                      }, 1000);


                    }
                    else if (result.isDenied) {
                      this.deletedId = []
                      for (let i = 0; i < uploadEmployeeData.length; i++) {
                        array1.push(uploadEmployeeData[i]);
                      }
                      console.log(uploadEmployeeData)

                      for (let i = 0; i < this.employeeList.length; i++) {
                        if (this.employeeList[i].isBulk == true && this.employeeList[i].bulkPlanLevelId == 34) {
                          if (this.employeeList[i].uId && this.employeeList[i].uId > 0) {
                            this.deletedId.push(this.employeeList[i].uId);
                          }
                        }
                      }
                      console.log(this.deletedId)
                      setTimeout(() => {
                        this.deleteEmployee(array1);
                      }, 2000);
                      this.employeeList = array1

                      console.log(this.employeeList)
                      let mergeArray = []
                      for (let i = 0; i < array1.length; i++) {
                        if (array1[i].isBulk == true && this.employeeList[i].bulkPlanLevelId == 34) {
                          mergeArray.push(array1[i]);
                          this.bulkemployeeList.push(array1[i]);

                        }
                      }
                      console.log()
                      this.showEmployeeValue1 = mergeArray.length
                      this.toastrService.success(this.showEmployeeValue1 + " " + this.lang.Employees_Added);


                    }
                  });
                }
                else {
                  for (let i = 0; i < uploadEmployeeData.length; i++) {
                    this.employeeList.push(uploadEmployeeData[i]);
                  }

                  let mergeArray = []
                  for (let i = 0; i < this.employeeList.length; i++) {
                    if (this.employeeList[i].isBulk == true && this.employeeList[i].bulkPlanLevelId == 34) {
                      mergeArray.push(this.employeeList[i]);
                    }
                  }

                  // this.showEmployeeValue = mergeArray.length

                  for (let i = 0; i < this.employeeList.length; i++) {
                    if (this.employeeList[i] && this.employeeList[i]['uId']) {

                    }
                    else {
                      this.employeeList[i]['uId'] = 0
                    }
                    if (this.employeeList[i] && this.employeeList[i]['phoneNum']) {

                    }
                    else {
                      this.employeeList[i]['phoneNum'] = ""
                    }
                  }

                  this.lengthofemployee = this.employeeList.length;

                  if (this.maxEmployeeCount && this.maxEmployeeCount > 0) {

                  }
                  else {
                    // this.maxEmployeeCount = this.employeeList.length;
                    let formData = JSON.parse(sessionStorage.getItem('formData') || '');

                    this.maxEmployeeCount = formData.expectednoofEmployees;
                  }
                  this.addedEmployeelist = this.employeeList
                  // this.addedEmployeelist.forEach((element: any) => {
                  //   element["isBulk"] = true
                  // })

                  console.log(uploadEmployeeData)
                  this.showEmployeeValue = uploadEmployeeData.length

                  this.bulkemployeeList = uploadEmployeeData

                  console.log(this.employeeList);
                  this.toastrService.success(uploadEmployeeData.length + " " + this.lang.Employees_Added);

                }
              }
              else {
                this.employeeList = uploadEmployeeData;
                for (let i = 0; i < this.employeeList.length; i++) {
                  if (this.employeeList[i] && this.employeeList[i]['uId']) {

                  }
                  else {
                    this.employeeList[i]['uId'] = 0
                  }
                  if (this.employeeList[i] && this.employeeList[i]['phoneNum']) {

                  }
                  else {
                    this.employeeList[i]['phoneNum'] = ""
                  }
                }

                this.lengthofemployee = this.employeeList.length;

                if (this.maxEmployeeCount && this.maxEmployeeCount > 0) {

                }
                else {
                  // this.maxEmployeeCount = this.employeeList.length;
                  let formData = JSON.parse(sessionStorage.getItem('formData') || '');

                  this.maxEmployeeCount = formData.expectednoofEmployees;
                }
                this.addedEmployeelist = this.employeeList
                // this.addedEmployeelist.forEach((element: any) => {
                //   element["isBulk"] = true
                // })
                console.log(this.employeeList);
                this.showEmployeeValue1 = uploadEmployeeData.length
                this.bulkemployeeList = uploadEmployeeData

                this.toastrService.success(uploadEmployeeData.length + " " + this.lang.Employees_Added);

              }
            }

            //original-employee-list

            //already-emp-cust-id?


            if (this.employeeList.length > 0) {
              this.myFileInputwaddel.nativeElement.value = '';
            }
          }
          else {
            //tampered excel error
          }




          // }
        };

      }
      else {
        error = true;

        message = this.lang.Invalid_file_type_Only_xlsx_files_are_allowed;
        // alert(message);
        Swal.fire({ title: 'Info', text: message });
      }
    }

    // reader.readAsBinaryString(file);
  }

  editEmployees(subgrpId) {
    this.selectedSubGrpId = subgrpId
    $('#showBulkEmployeelist').modal('show')

  }

  // onFileChangeExcel(ev: any, subgrpId: any, headers: any) {


  //   if (!this.showHeadCount[subgrpId] || this.showHeadCount[subgrpId] <= 0) {
  //     return
  //   }

  //   const file = ev.target.files[0];
  //   var fileExtension = '.' + ev.target.files[0].name.split('.').pop();


  //   var allowedMimes = [
  //     '.xlsx'
  //   ];

  //   let error = false;

  //   let message = '';

  //   if (allowedMimes?.includes(fileExtension)) {
  //     let workBook: any = null;
  //     let jsonData = [];
  //     const reader = new FileReader();
  //     reader.readAsArrayBuffer(file)
  //     reader.onload = async (event) => {
  //       const data = reader.result;
  //       const wb = await this.excelService.readDataFromExcel(data);
  //       const employeeSheet = wb.getWorksheet(this.excelService.EXCEL_SHEETNAME);
  //       console.log(employeeSheet);
  //       if (employeeSheet) {
  //         let firstRow = employeeSheet.getRow(1);
  //         console.log(firstRow)
  //         if (!firstRow.cellCount) return;
  //         let keys = firstRow.values;
  //         console.log(keys)
  //         let seenEmployeeEmails = new Set();
  //         let ExceldataError = false
  //         let ExceldataErrorMessage = ''
  //         let ExceldataemailError = false
  //         let ExceldataEmailErrorMessage = ''
  //         let ExceldataFirstNameError = false
  //         let ExceldataFirstNameErrorMessage = ''
  //         let ExceldataLastNameError = false
  //         let ExceldataLastNameErrorMessage = ''
  //         employeeSheet.eachRow((row, rowNumber) => {
  //           if (rowNumber == 1) return;
  //           let values = row.values;
  //           let obj = {};
  //           //@ts-ignore


  //           //@ts-ignore
  //           for (let i = 1; i < keys.length; i++) {
  //             if (ExceldataError) {
  //               break;
  //             }
  //             if (keys[i]) {
  //               let value = values[i]
  //               // if(value==""){
  //               //   this.myFileInput.nativeElement.value = '';

  //               // }
  //               switch (keys[i]) {
  //                 case "First Name":
  //                   if (value && value != '') {

  //                     if (value.text && value.text.length) {
  //                       value = value.text.charAt(0).toUpperCase() + value.text.slice(1)
  //                     }
  //                     else {
  //                       value = value.charAt(0).toUpperCase() + value.slice(1)
  //                     }
  //                     if (value.length >= 3) {

  //                     }
  //                     else {
  //                       ExceldataFirstNameError = true
  //                       ExceldataFirstNameErrorMessage = "First Name must be minimum of 3 characters, please check"
  //                       break;
  //                     }
  //                   }
  //                   else {
  //                     console.log(value)
  //                     ExceldataError = true
  //                     ExceldataErrorMessage = this.lang.First_Name_can_t_be_empty
  //                     break;
  //                   }
  //                   break;
  //                 case "Last Name":
  //                   if (value && value != '') {

  //                     if (value.text && value.text.length) {
  //                       value = value.text.charAt(0).toUpperCase() + value.text.slice(1)
  //                     }
  //                     else {
  //                       value = value.charAt(0).toUpperCase() + value.slice(1)
  //                     }
  //                     if (value.length >= 3) {

  //                     }
  //                     else {
  //                       ExceldataLastNameError = true
  //                       ExceldataLastNameErrorMessage = "Last Name must be minimum of 3 characters, please check"
  //                       break;
  //                     }
  //                   }
  //                   else {
  //                     ExceldataError = true
  //                     ExceldataErrorMessage = this.lang.Last_Name_can_t_be_empty
  //                     break;
  //                   }
  //                   break;

  //                 case "Email":
  //                   if (value && value != '') {
  //                     // value=value.text
  //                     if (seenEmployeeEmails.has(value)) {
  //                       ExceldataemailError = true;
  //                       ExceldataEmailErrorMessage = "this.lang.Duplicate_Employee_ID_exists_please_check";
  //                       ExceldataError = true;
  //                       break;
  //                     } else {
  //                       seenEmployeeEmails.add(value);
  //                     }
  //                     if (value.text && value.text.length) {
  //                       value = value.text.charAt(0).toLowerCase() + value.text.slice(1)
  //                     }
  //                     else {
  //                       value = value.charAt(0).toLowerCase() + value.slice(1)
  //                     }
  //                     var filter = this.commonPatternsService.emailTestPattern;
  //                     // if (!filter.test(value)) {
  //                     //     // alert('Please /provide a valid email address');

  //                     //     ExceldataemailError =true
  //                     // ExceldataEmailErrorMessage = "Some fields have invalid email, please check"
  //                     // break;
  //                     // }

  //                   }
  //                   else {
  //                     ExceldataError = true
  //                     ExceldataErrorMessage = this.lang.Email_can_t_be_empty
  //                     break;
  //                   }


  //                   break;
  //                 case "Date of Hire":
  //                   if (value && value != '') {
  //                     value = moments(value).format(this.dateFormat)
  //                   }
  //                   break;
  //                 case "Date of Birth":
  //                   if (value && value != '') {
  //                     value = moments(value).format(this.dateFormat);
  //                     let today = moment(new Date());
  //                     let maxDAte = moment(today.subtract('16', 'years').calendar()).format(this.dateFormat);

  //                     if (moment(value).isAfter(maxDAte)) {
  //                       ExceldataError = true;
  //                       ExceldataErrorMessage = "this.lang.Age_should_not_exceed_16_years";
  //                     }
  //                   }
  //                   break;

  //                 case "Country":


  //                   // if (value && value != '') {


  //                   // }
  //                   // else {
  //                   //   ExceldataError = true
  //                   //   ExceldataErrorMessage = this.lang.Country_can_t_be_empty
  //                   //   break;
  //                   // }


  //                   break;
  //                 case "Province of Employment":

  //                   // if(value && value !=''){


  //                   //   }
  //                   //   else{
  //                   //     ExceldataError =true
  //                   //     ExceldataErrorMessage = this.lang.Province_can_t_be_empty
  //                   //     break;
  //                   //   }
  //                   break;
  //                 case "Classification Tier":
  //                   // obj["classificationTier"] = this.gettierId(value)
  //                   break;
  //                 case "Job Title":
  //                   if (value && value != '') {

  //                     if (value.text && value.text.length) {
  //                       value = value.text.charAt(0).toUpperCase() + value.text.slice(1)
  //                     }
  //                     else {
  //                       value = value.charAt(0).toUpperCase() + value.slice(1)
  //                     }
  //                   }
  //                   break;
  //               }

  //               obj[keys[i]] = value;


  //             }

  //           }

  //           jsonData.push(obj);
  //         });
  //         if (ExceldataError) {

  //           Swal.fire({
  //             title: this.lang.Error
  //             , text: ExceldataErrorMessage
  //           }).then((result) => {
  //             /* Read more about isConfirmed, isDenied below */
  //             if (result.isConfirmed) {
  //               this.myFileInput.nativeElement.value = '';
  //             }


  //           });
  //           jsonData = []
  //         }
  //         if (ExceldataemailError) {

  //           Swal.fire({
  //             title: this.lang.Error??'Error',
  //             text: ExceldataEmailErrorMessage
  //           }).then((result) => {
  //             if (result.isConfirmed) {
  //               this.myFileInput.nativeElement.value = '';
  //             }

  //           });
  //           jsonData = []
  //         }
  //         if (ExceldataFirstNameError) {

  //           Swal.fire({
  //             title: this.lang.Error??'Error',
  //             text: ExceldataFirstNameErrorMessage
  //           }).then((result) => {
  //             if (result.isConfirmed) {
  //               this.myFileInput.nativeElement.value = '';
  //             }


  //           });
  //           jsonData = []
  //         }
  //         if (ExceldataLastNameError) {

  //           Swal.fire({
  //             title: this.lang.Error??'Error',
  //             text: ExceldataLastNameErrorMessage
  //           }).then((result) => {
  //             if (result.isConfirmed) {
  //               this.myFileInput.nativeElement.value = '';
  //             }
  //           })
  //           jsonData = []
  //         }
  //       } else {
  //         //tampered excel error
  //       }

  //       console.log(jsonData);

  //       // jsonData.forEach((element: any) => {
  //       //   element["isBulk"]=true
  //       // })



  //       // this.showEmployeeValue = array.length+uploadEmployeeData.length
  //       // if (array.length+uploadEmployeeData.length != this.showEmployeeValue) {

  //       //   Swal.fire({ title: 'Info', text: "Head count and upload Employee/Entity List not match." });
  //       //   this.myFileInput.nativeElement.value = '';

  //       // }
  //       // else {



  //       this.multiSelectProviancenames.sort(function (a, b) {
  //         return (a.id - b.id);
  //       })

  //       let province = ""
  //       let provincearray = []

  //       this.multiSelectProviancenames.forEach(element => {
  //         provincearray.push(element.shortName)
  //       });


  //       if (this.multiSelectProviancenames.length == 1) {
  //         // for(let i=0;i<this.multiSelectProviancenames.length;i++){
  //         province = this.multiSelectProviancenames[0].shortName
  //         // }
  //       }
  //       else if (this.multiSelectProviancenames.length > 1) {
  //         if (provincearray?.includes(this.province)) {
  //           province = this.province

  //         }
  //         else {
  //           if (provincearray?.includes("ON")) {
  //             province = "ON"
  //           }
  //           else {
  //             province = this.multiSelectProviancenames[0].shortName
  //           }
  //         }

  //       }


  //       console.log(jsonData)

  //       let uploadEmployeeData = [];
  //       for (let i = 0; i < jsonData.length; i++) {
  //         let data: any = {};

  //         headers.map((h) => {
  //           // console.log(h)

  //           let key = this.toCamelCase(h.value)

  //           data[key] = jsonData[i][h.value] ? jsonData[i][h.value] : ""
  //         })
  //         data['isBulk'] = true;
  //         data['uId'] = 0;
  //         data['bulkPlanLevelId'] = subgrpId
  //         if (typeof data?.employeeId == 'number') {
  //           data.employeeId = data.employeeId.toString();
  //         }
  //         if (typeof data?.phoneNumber == 'number') {
  //           data.phoneNumber = data.phoneNumber.toString();
  //         }
  //         if (data?.phoneNumber == '') {
  //           data.phoneNumber = '';
  //         }
  //         if (data?.annualIncome == '') {
  //           data.annualIncome = 0;
  //         }
  //         if (data?.classificationTier == '' || data?.classificationTier == undefined || data?.classificationTier == "All") {
  //           data.classificationTier = 0; //assign default tier id
  //         }
  //         uploadEmployeeData.push(data)
  //       }

  //       console.log(uploadEmployeeData)


  //       this.uploadEmployeeExcelData = [...uploadEmployeeData]

  //       // console.log(this.employeeList, subgrpId)
  //       let array = []
  //       let array1 = []
  //       if (this.employeeList.length > 0) {
  //         for (let i = 0; i < this.employeeList.length; i++) {
  //           if (this.employeeList[i].isBulk == true && this.employeeList[i].bulkPlanLevelId == subgrpId) {
  //             array.push(this.employeeList[i]);
  //           } else {
  //             array1.push(this.employeeList[i]);
  //           }


  //         }
  //         console.log(array1, array, this.employeeList)

  //         if (array.length > 0) {
  //           Swal.fire({
  //             title: 'Info',
  //             html: '<div style="text-align: left;">Do you want to replace or append the employee list? <br> <div style="font-size: 10px;">Replace - Existing replaced with new file.<br>Append - File will be appended to the existing list.</div></div>', showCancelButton: true,
  //             showDenyButton: true,
  //             confirmButtonColor: '#10104d',
  //             cancelButtonColor: '#10104d',
  //             confirmButtonText: this.lang.Append,
  //             denyButtonText: this.lang.Replace

  //           }).then(async (result) => {
  //             if (result.isConfirmed) {

  //               console.log(this.employeeList) //old

  //               console.log(uploadEmployeeData) //new

  //               let temparray = []
  //               let existingRemoveEmployeeDataIndex = []
  //               temparray = this.employeeList
  //               let existingEmails = this.employeeList.map(a => a.email);


  //               for (let j = 0; j < uploadEmployeeData.length; j++) {
  //                 if (existingEmails?.includes(uploadEmployeeData[j].email)) {
  //                   console.log(existingEmails.indexOf(uploadEmployeeData[j].email))
  //                   console.log(this.employeeList[existingEmails.indexOf(uploadEmployeeData[j].email)])
  //                   if (this.employeeList[existingEmails.indexOf(uploadEmployeeData[j].email)].uId && this.employeeList[existingEmails.indexOf(uploadEmployeeData[j].email)].uId > 0) {

  //                     existingRemoveEmployeeDataIndex.push(existingEmails.indexOf(uploadEmployeeData[j].email))

  //                   }
  //                   else {

  //                     temparray[existingEmails.indexOf(uploadEmployeeData[j].email)] = uploadEmployeeData[j]
  //                   }

  //                 }
  //                 else {
  //                   temparray.push(uploadEmployeeData[j]);
  //                 }
  //               }



  //               console.log(temparray)

  //               let EmailError = []
  //               if (existingRemoveEmployeeDataIndex.length > 0) {
  //                 for (let i = 0; i < existingRemoveEmployeeDataIndex.length; i++) {
  //                   EmailError.push(temparray[existingRemoveEmployeeDataIndex[i]].email)
  //                 }
  //               }

  //               console.log(EmailError)
  //               console.log(temparray)

  //               console.log(this.employeeList)

  //               this.employeeList = temparray
  //               console.log(this.employeeList)

  //               let mergeArray = []
  //               for (let i = 0; i < this.employeeList.length; i++) {
  //                 console.log(this.employeeList[i].isBulk, this.employeeList.length, this.employeeList[i].isBulk == true)
  //                 if (this.employeeList[i].isBulk == true && this.employeeList[i].bulkPlanLevelId == subgrpId) {
  //                   console.log(this.employeeList[i].isBulk == true && this.employeeList[i].bulkPlanLevelId == subgrpId)
  //                   mergeArray.push(this.employeeList[i]);
  //                 }

  //               }
  //               this.bulkemployeeList = [...this.bulkemployeeList, ...this.employeeList]

  //               this.showEmployeeValue = mergeArray.length
  //               console.log(this.showEmployeeValue, this.bulkemployeeList)



  //               this.lengthofemployee = this.employeeList.length;

  //               if (this.maxEmployeeCount && this.maxEmployeeCount > 0) {

  //               }
  //               else {
  //                 // this.maxEmployeeCount = this.employeeList.length;
  //                 let formData = JSON.parse(sessionStorage.getItem('formData') || '');

  //                 this.maxEmployeeCount = formData.expectednoofEmployees;
  //               }
  //               this.addedEmployeelist = this.employeeList


  //               console.log(this.employeeList);
  //               this.toastrService.success(this.showEmployeeValue + " " + this.lang.Employees_Added);
  //               setTimeout(() => {
  //                 setTimeout(() => {
  //                   if (EmailError.length > 0) {
  //                     this.toastrService.warning(EmailError.toString() + " " + this.lang.Employees_Exists);
  //                   }
  //                 }, 1000);
  //               }, 1000);


  //             }
  //             else if (result.isDenied) {
  //               this.deletedId = []
  //               for (let i = 0; i < uploadEmployeeData.length; i++) {
  //                 array1.push(uploadEmployeeData[i]);
  //               }
  //               console.log(uploadEmployeeData)

  //               for (let i = 0; i < this.employeeList.length; i++) {
  //                 if (this.employeeList[i].isBulk == true && this.employeeList[i].bulkPlanLevelId == subgrpId) {
  //                   if (this.employeeList[i].uId && this.employeeList[i].uId > 0) {
  //                     this.deletedId.push(this.employeeList[i].uId);
  //                   }
  //                 }
  //               }
  //               console.log(this.deletedId)
  //               setTimeout(() => {
  //                 this.deleteEmployee(array1);
  //               }, 2000);
  //               this.employeeList = array1

  //               console.log(this.employeeList)
  //               let mergeArray = []
  //               for (let i = 0; i < array1.length; i++) {
  //                 if (array1[i].isBulk == true) {
  //                   mergeArray.push(array1[i]);
  //                   this.bulkemployeeList.push(array1[i]);

  //                 }
  //               }
  //               console.log()
  //               this.showEmployeeValue = mergeArray.length
  //               this.toastrService.success(this.showEmployeeValue + " " + this.lang.Employees_Added);


  //             }
  //             await this.updateHeadCount(subgrpId)
  //           });
  //         }
  //         else {
  //           for (let i = 0; i < uploadEmployeeData.length; i++) {
  //             this.employeeList.push(uploadEmployeeData[i]);
  //           }

  //           let mergeArray = []
  //           for (let i = 0; i < this.employeeList.length; i++) {
  //             if (this.employeeList[i].isBulk == true && this.employeeList[i].bulkPlanLevelId == subgrpId) {
  //               mergeArray.push(this.employeeList[i]);
  //             }
  //           }



  //           this.lengthofemployee = this.employeeList.length;

  //           if (this.maxEmployeeCount && this.maxEmployeeCount > 0) {

  //           }
  //           else {
  //             // this.maxEmployeeCount = this.employeeList.length;
  //             let formData = JSON.parse(sessionStorage.getItem('formData') || '');

  //             this.maxEmployeeCount = formData.expectednoofEmployees;
  //           }
  //           this.addedEmployeelist = this.employeeList


  //           console.log(uploadEmployeeData)
  //           this.showEmployeeValue = uploadEmployeeData.length

  //           this.bulkemployeeList = uploadEmployeeData

  //           console.log(this.employeeList);
  //           this.toastrService.success(uploadEmployeeData.length + " " + this.lang.Employees_Added);

  //         }
  //       }
  //       else {
  //         this.employeeList = uploadEmployeeData;


  //         this.lengthofemployee = this.employeeList.length;

  //         if (this.maxEmployeeCount && this.maxEmployeeCount > 0) {

  //         }
  //         else {
  //           let formData = JSON.parse(sessionStorage.getItem('formData') || '');

  //           this.maxEmployeeCount = formData.expectednoofEmployees;
  //         }
  //         this.addedEmployeelist = this.employeeList

  //         console.log(this.employeeList);
  //         this.showEmployeeValue = uploadEmployeeData.length
  //         this.bulkemployeeList = uploadEmployeeData

  //         this.toastrService.success(uploadEmployeeData.length + " " + this.lang.Employees_Added);

  //       }



  //       if (this.employeeList.length > 0) {
  //         this.myFileInput.nativeElement.value = '';
  //       }

  //       await this.updateHeadCount(subgrpId)
  //     };
  //   }
  //   else {
  //     error = true;

  //     message = this.lang.Invalid_file_type_Only_xlsx_files_are_allowed;
  //     // alert(message);
  //     Swal.fire({ title: 'Info', text: message });
  //   }


  //   // reader.readAsBinaryString(file);
  // }
  async onFileChangeExcel(ev: any, subgrpId: any, headers: any) {


    if (!this.showHeadCount[subgrpId] || this.showHeadCount[subgrpId] <= 0) {
      return
    }

    const file = ev.target.files[0];
    var fileExtension = '.' + ev.target.files[0].name.split('.').pop();


    var allowedMimes = [
      '.xlsx'
    ];

    let error = false;

    let message = '';

    if (allowedMimes?.includes(fileExtension)) {
      let workBook: any = null;
      let jsonData = [];
      const reader = new FileReader();
      reader.readAsArrayBuffer(file)
      reader.onload = async (event) => {
        const data = reader.result;
        const wb = await this.excelService.readDataFromExcel(data);
        const employeeSheet = wb.getWorksheet(this.excelService.EXCEL_SHEETNAME);
        console.log(employeeSheet);
        if (employeeSheet) {
          let firstRow = employeeSheet.getRow(1);
          console.log(firstRow)
          if (!firstRow.cellCount) return;
          let keys = firstRow.values;
          console.log(keys)
          let seenEmployeeEmails = new Set();
          let ExceldataError = false
          let ExceldataErrorMessage = ''
          let ExceldataemailError = false
          let ExceldataEmailErrorMessage = ''
          let ExceldataFirstNameError = false
          let ExceldataFirstNameErrorMessage = ''
          let ExceldataLastNameError = false
          let ExceldataLastNameErrorMessage = ''
          employeeSheet.eachRow((row, rowNumber) => {
            if (rowNumber == 1) return;
            let values = row.values;
            let obj = {};
            //@ts-ignore


            //@ts-ignore
            for (let i = 1; i < keys.length; i++) {
              if (ExceldataError) {
                break;
              }
              if (keys[i]) {
                let value = values[i]
                // if(value==""){
                //   this.myFileInput.nativeElement.value = '';

                // }
                switch (keys[i]) {
                  case "First Name":
                    if (value && value != '') {

                      if (value.text && value.text.length) {
                        value = value.text.charAt(0).toUpperCase() + value.text.slice(1)
                      }
                      else {
                        value = value.charAt(0).toUpperCase() + value.slice(1)
                      }
                      if (value.length >= 1) {

                      }
                      else {
                        ExceldataFirstNameError = true
                        ExceldataFirstNameErrorMessage = "First Name must be minimum of 1 characters, please check"
                        break;
                      }
                    }
                    else {
                      console.log(value)
                      ExceldataError = true
                      ExceldataErrorMessage = this.lang.First_Name_can_t_be_empty
                      break;
                    }
                    break;
                  case "Last Name":
                    if (value && value != '') {

                      if (value.text && value.text.length) {
                        value = value.text.charAt(0).toUpperCase() + value.text.slice(1)
                      }
                      else {
                        value = value.charAt(0).toUpperCase() + value.slice(1)
                      }
                      if (value.length >= 1) {

                      }
                      else {
                        ExceldataLastNameError = true
                        ExceldataLastNameErrorMessage = "Last Name must be minimum of 1 characters, please check"
                        break;
                      }
                    }
                    else {
                      ExceldataError = true
                      ExceldataErrorMessage = this.lang.Last_Name_can_t_be_empty
                      break;
                    }
                    break;

                  case "Email":
                    if (value && value != '') {
                      // value=value.text
                      if (seenEmployeeEmails.has(value)) {
                        ExceldataemailError = true;
                        ExceldataEmailErrorMessage = this.lang.Duplicate_Employee_ID_exists_please_check;
                        ExceldataError = true;
                        break;
                      } else {
                        seenEmployeeEmails.add(value);
                      }
                      if (value.text && value.text.length) {
                        value = value.text.charAt(0).toLowerCase() + value.text.slice(1)
                      }
                      else {
                        value = value.charAt(0).toLowerCase() + value.slice(1)
                      }
                      var filter = this.commonPatternsService.emailTestPattern;
                      // if (!filter.test(value)) {
                      //     // alert('Please /provide a valid email address');

                      //     ExceldataemailError =true
                      // ExceldataEmailErrorMessage = "Some fields have invalid email, please check"
                      // break;
                      // }

                    }
                    else {
                      ExceldataError = true
                      ExceldataErrorMessage = this.lang.Email_can_t_be_empty
                      break;
                    }


                    break;
                  case "Date of Hire":
                    if (value && value != '') {
                      value = moments(value).format(this.dateFormat)
                    }
                    break;
                  case "Date of Birth":
                    if (value && value != '') {
                      value = moments(value).format(this.dateFormat);
                      let today = moment(new Date());
                      let maxDAte = moment(today.subtract('16', 'years').calendar()).format(this.dateFormat);

                      if (moment(value).isAfter(maxDAte)) {
                        ExceldataError = true;
                        ExceldataErrorMessage = "this.lang.Age_should_not_exceed_16_years";
                      }
                    }
                    break;

                  case "Country":


                    // if (value && value != '') {


                    // }
                    // else {
                    //   ExceldataError = true
                    //   ExceldataErrorMessage = this.lang.Country_can_t_be_empty
                    //   break;
                    // }


                    break;
                  case "Province of Employment":

                    // if(value && value !=''){


                    //   }
                    //   else{
                    //     ExceldataError =true
                    //     ExceldataErrorMessage = this.lang.Province_can_t_be_empty
                    //     break;
                    //   }
                    break;
                  case "Classification Tier":
                    // obj["classificationTier"] = this.gettierId(value)
                    break;
                  case "Job Title":
                    if (value && value != '') {

                      if (value.text && value.text.length) {
                        value = value.text.charAt(0).toUpperCase() + value.text.slice(1)
                      }
                      else {
                        value = value.charAt(0).toUpperCase() + value.slice(1)
                      }
                    }
                    break;
                }

                obj[keys[i]] = value;


              }

            }

            jsonData.push(obj);
          });
          if (ExceldataError) {

            Swal.fire({
              title: this.lang.Info,
              text: ExceldataErrorMessage
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                this.myFileInput.nativeElement.value = '';
              }


            });
            jsonData = []
          }
          if (ExceldataemailError) {

            Swal.fire({
              title: this.lang.Info,
              text: ExceldataEmailErrorMessage
            }).then((result) => {
              if (result.isConfirmed) {
                this.myFileInput.nativeElement.value = '';
              }

            });
            jsonData = []
          }
          if (ExceldataFirstNameError) {

            Swal.fire({
              title: this.lang.Info,
              text: ExceldataFirstNameErrorMessage
            }).then((result) => {
              if (result.isConfirmed) {
                this.myFileInput.nativeElement.value = '';
              }


            });
            jsonData = []
          }
          if (ExceldataLastNameError) {

            Swal.fire({
              title: this.lang.Info,
              text: ExceldataLastNameErrorMessage
            }).then((result) => {
              if (result.isConfirmed) {
                this.myFileInput.nativeElement.value = '';
              }
            })
            jsonData = []
          }
        } else {
          //tampered excel error
        }

        console.log(jsonData);

        // jsonData.forEach((element: any) => {
        //   element["isBulk"]=true
        // })



        // this.showEmployeeValue = array.length+uploadEmployeeData.length
        // if (array.length+uploadEmployeeData.length != this.showEmployeeValue) {

        //   Swal.fire({ title: 'Info', text: "Head count and upload Employee/Entity List not match." });
        //   this.myFileInput.nativeElement.value = '';

        // }
        // else {



        this.multiSelectProviancenames.sort(function (a, b) {
          return (a.id - b.id);
        })

        let province = ""
        let provincearray = []

        this.multiSelectProviancenames.forEach(element => {
          provincearray.push(element.shortName)
        });


        if (this.multiSelectProviancenames.length == 1) {
          // for(let i=0;i<this.multiSelectProviancenames.length;i++){
          province = this.multiSelectProviancenames[0].shortName
          // }
        }
        else if (this.multiSelectProviancenames.length > 1) {
          if (provincearray?.includes(this.province)) {
            province = this.province

          }
          else {
            if (provincearray?.includes("ON")) {
              province = "ON"
            }
            else {
              province = this.multiSelectProviancenames[0].shortName
            }
          }

        }


        console.log(jsonData)

        let uploadEmployeeData = [];
        for (let i = 0; i < jsonData.length; i++) {
          let data: any = {};

          headers.map((h) => {
            // console.log(h)

            let key = this.toCamelCase(h.value)

            data[key] = jsonData[i][h.value] ? jsonData[i][h.value] : ""
          })
          data['isBulk'] = true;
          data['uId'] = 0;
          data['bulkPlanLevelId'] = subgrpId
          if (typeof data?.employeeId == 'number') {
            data.employeeId = data.employeeId.toString();
          }
          if (typeof data?.phoneNumber == 'number') {
            data.phoneNumber = data.phoneNumber.toString();
          }
          if (data?.phoneNumber == '') {
            data.phoneNumber = '';
          }
          if (data?.annualIncome == '') {
            data.annualIncome = 0;
          }
          if (data?.classificationTier == '' || data?.classificationTier == undefined || data?.classificationTier == "All") {
            data.classificationTier = 0; //assign default tier id
          }
          uploadEmployeeData.push(data)
        }

        console.log(uploadEmployeeData)


        this.uploadEmployeeExcelData = [...uploadEmployeeData]

        // console.log(this.employeeList, subgrpId)
        let array = []
        let array1 = []
        if (this.employeeList.length > 0) {
          for (let i = 0; i < this.employeeList.length; i++) {
            if (this.employeeList[i].isBulk == true && this.employeeList[i].bulkPlanLevelId == subgrpId) {
              array.push(this.employeeList[i]);
            } else {
              array1.push(this.employeeList[i]);
            }


          }
          console.log(array1, array, this.employeeList)

          if (array.length > 0) {
            Swal.fire({
              title: 'Info',
              html: '<div style="text-align: left;">' + this.lang.Do_you_want_to_replace_or_append_the_employee_list + ' <br> <div style="font-size: 10px;">Replace - Existing replaced with new file.<br>Append - File will be appended to the existing list.</div></div>', showCancelButton: true,
              showDenyButton: true,
              confirmButtonColor: '#10104d',
              cancelButtonColor: '#10104d',
              confirmButtonText: this.lang.Append,
              denyButtonText: this.lang.Replace

            }).then(async (result) => {
              if (result.isConfirmed) {

                console.log(this.employeeList) //old
                console.log(uploadEmployeeData) //new

                let temparray = []
                let existingRemoveEmployeeDataIndex = []
                temparray = this.employeeList
                let existingEmails = this.employeeList.map(a => a.email);


                for (let j = 0; j < uploadEmployeeData.length; j++) {
                  if (existingEmails?.includes(uploadEmployeeData[j].email)) {
                    console.log(existingEmails.indexOf(uploadEmployeeData[j].email))
                    console.log(this.employeeList[existingEmails.indexOf(uploadEmployeeData[j].email)])
                    if (this.employeeList[existingEmails.indexOf(uploadEmployeeData[j].email)].uId && this.employeeList[existingEmails.indexOf(uploadEmployeeData[j].email)].uId > 0) {

                      existingRemoveEmployeeDataIndex.push(existingEmails.indexOf(uploadEmployeeData[j].email))

                    }
                    else {

                      temparray[existingEmails.indexOf(uploadEmployeeData[j].email)] = uploadEmployeeData[j]
                    }

                  }
                  else {
                    temparray.push(uploadEmployeeData[j]);
                  }
                }



                console.log(temparray)

                let EmailError = []
                if (existingRemoveEmployeeDataIndex.length > 0) {
                  for (let i = 0; i < existingRemoveEmployeeDataIndex.length; i++) {
                    EmailError.push(temparray[existingRemoveEmployeeDataIndex[i]].email)
                  }
                }

                console.log(EmailError)
                console.log(temparray)
                console.log(this.employeeList)
                this.employeeList = temparray
                console.log(this.employeeList)

                let mergeArray = []

                for (let i = 0; i < this.employeeList.length; i++) {
                  console.log(this.employeeList[i].isBulk, this.employeeList.length, this.employeeList[i].isBulk == true)
                  if (this.employeeList[i].isBulk == true && this.employeeList[i].bulkPlanLevelId == subgrpId) {
                    console.log(this.employeeList[i].isBulk == true && this.employeeList[i].bulkPlanLevelId == subgrpId)
                    mergeArray.push(this.employeeList[i]);
                  }
                }

                this.bulkemployeeList = [...this.bulkemployeeList, ...this.employeeList]

                this.showEmployeeValue = mergeArray.length
                console.log(this.showEmployeeValue, this.bulkemployeeList)

                this.lengthofemployee = this.employeeList.length;

                if (this.maxEmployeeCount && this.maxEmployeeCount > 0) {

                }
                else {
                  // this.maxEmployeeCount = this.employeeList.length;
                  let formData = JSON.parse(sessionStorage.getItem('formData') || '');

                  this.maxEmployeeCount = formData.expectednoofEmployees;
                }
                this.addedEmployeelist = this.employeeList


                console.log(this.employeeList);
                this.toastrService.success(this.showEmployeeValue + " " + this.lang.Employees_Added);
                setTimeout(() => {
                  setTimeout(() => {
                    if (EmailError.length > 0) {
                      this.toastrService.warning(EmailError.toString() + " " + this.lang.Employees_Exists);
                    }
                  }, 1000);
                }, 1000);


              }
              else if (result.isDenied) {
                this.deletedId = []
                for (let i = 0; i < uploadEmployeeData.length; i++) {
                  array1.push(uploadEmployeeData[i]);
                }
                console.log(uploadEmployeeData)

                for (let i = 0; i < this.employeeList.length; i++) {
                  if (this.employeeList[i].isBulk == true && this.employeeList[i].bulkPlanLevelId == subgrpId) {
                    if (this.employeeList[i].uId && this.employeeList[i].uId > 0) {
                      this.deletedId.push(this.employeeList[i].uId);
                    }
                  }
                }
                console.log(this.deletedId)
                setTimeout(() => {
                  this.deleteEmployee(array1);
                }, 2000);
                this.employeeList = array1

                console.log(this.employeeList)
                let mergeArray = []
                for (let i = 0; i < array1.length; i++) {
                  if (array1[i].isBulk == true) {
                    mergeArray.push(array1[i]);
                    this.bulkemployeeList.push(array1[i]);

                  }
                }
                console.log()
                this.showEmployeeValue = mergeArray.length
                this.toastrService.success(this.showEmployeeValue + " " + this.lang.Employees_Added);


              }
              await this.updateHeadCount(subgrpId)

            });
          }
          else {
            for (let i = 0; i < uploadEmployeeData.length; i++) {
              this.employeeList.push(uploadEmployeeData[i]);
            }

            let mergeArray = []
            for (let i = 0; i < this.employeeList.length; i++) {
              if (this.employeeList[i].isBulk == true && this.employeeList[i].bulkPlanLevelId == subgrpId) {
                mergeArray.push(this.employeeList[i]);
              }
            }



            this.lengthofemployee = this.employeeList.length;

            if (this.maxEmployeeCount && this.maxEmployeeCount > 0) {

            }
            else {
              // this.maxEmployeeCount = this.employeeList.length;
              let formData = JSON.parse(sessionStorage.getItem('formData') || '');

              this.maxEmployeeCount = formData.expectednoofEmployees;
            }
            this.addedEmployeelist = this.employeeList


            console.log(uploadEmployeeData)
            this.showEmployeeValue = uploadEmployeeData.length

            this.bulkemployeeList = uploadEmployeeData

            console.log(this.employeeList);
            this.toastrService.success(uploadEmployeeData.length + " " + this.lang.Employees_Added);

          }
        }
        else {
          this.employeeList = uploadEmployeeData;


          this.lengthofemployee = this.employeeList.length;

          if (this.maxEmployeeCount && this.maxEmployeeCount > 0) {

          }
          else {
            let formData = JSON.parse(sessionStorage.getItem('formData') || '');

            this.maxEmployeeCount = formData.expectednoofEmployees;
          }
          this.addedEmployeelist = this.employeeList

          console.log(this.employeeList);
          this.showEmployeeValue = uploadEmployeeData.length
          this.bulkemployeeList = uploadEmployeeData

          this.toastrService.success(uploadEmployeeData.length + " " + this.lang.Employees_Added);
        }

        if (this.employeeList.length > 0) {
          this.myFileInput.nativeElement.value = '';
        }
        await this.updateHeadCount(subgrpId)

      };
    }
    else {
      error = true;

      message = this.lang.Invalid_file_type_Only_xlsx_files_are_allowed;
      // alert(message);
      Swal.fire({ title: 'Info', text: message });
    }


    // reader.readAsBinaryString(file);
  }

  deleteemployeeexcel(admin, index, selectedSubGrpId) {
    if (admin.uId && admin.uId > 0) {
      Swal.fire({
        title: this.lang.Alert,
        text: this.lang.Do_you_want_to_delete_this_employee_and_update_head_count,
        showDenyButton: false,
        showCancelButton: true,
        confirmButtonText: this.lang.Proceed
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {



          const Data = this.employeeList;

          const removed = Data.splice(index, 1);
          this.showHeadCount[selectedSubGrpId] = this.showHeadCount[selectedSubGrpId] - 1

          // Mutates fruits and returns array of removed items

          this.employeeList = Data;
          let employeeBulkCheck = []

          for (let i = 0; i < this.employeeList.length; i++) {
            if (this.employeeList[i].isBulk == true && this.employeeList[i].bulkPlanLevelId == selectedSubGrpId) {
              employeeBulkCheck.push(this.employeeList[i])
            }
          }

          this.deletedId.push(admin.uId);

          let Obj = {
            employees: this.employeeList,
            deletedIds: this.deletedId || [],
          };

          var corporateId = sessionStorage.getItem('corporateId');
          var endPoint =
            '/api/ap/admin/corporate/' + corporateId + '/employeeNew';
          var accessToken = sessionStorage.getItem('accessToken');
          this.http
            .post(environment.apiUrl + endPoint, Obj, {
              headers: {
                Authorization: 'Bearer ' + accessToken,
                'Content-Type': 'application/json',
              },
            })
            .subscribe(
              (response: any) => {
                if (response['status'] == 200) {
                  let employeeBulkCheckfinal = []

                  for (let i = 0; i < response.data.length; i++) {
                    if (response.data[i].isBulk == true && this.employeeList[i].bulkPlanLevelId == selectedSubGrpId) {
                      employeeBulkCheckfinal.push(response.data[i])
                    }
                  }

                  this.showEmployeeValue = employeeBulkCheckfinal.length
                  if (this.showEmployeeValue == 0) {
                    $("#showBulkEmployeelist").modal('hide');
                  }

                } else {
                  Swal.fire({
                    title: 'Error#' + response.errorCode,
                    text: response.message,
                  });
                }
              },
              (error) => {
                if (
                  error.status == 400 ||
                  error.status == 401 ||
                  error.status == 402 ||
                  error.status == 403
                ) {
                  Swal.fire({
                    title: this.lang.Error ?? 'Error',
                    text: error.error.error.message,
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonText: 'Proceed',
                  }).then((result) => {
                    /* Read more about isConfirmed, isDenied below */
                    if (result.isConfirmed) {
                      sessionStorage.clear();
                      this.router.navigate(['/login']);
                    } else {
                      sessionStorage.clear();
                      this.router.navigate(['/login']);
                    }
                  });
                } else {
                  // Swal.fire(error.error.error.message)
                  Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
                }
                // this.toastrService.error("Invalid Credentials", 'Error!');
              }
            );

        }
      });
    }
    else {
      Swal.fire({
        title: this.lang.Alert,
        text: this.lang.Do_you_want_to_delete_this_employee_and_update_head_count,
        showDenyButton: false,
        showCancelButton: true,
        confirmButtonText: this.lang.Proceed
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {

          const Data = this.employeeList;
          const removed = Data.splice(index, 1); // Mutates fruits and returns array of removed items
          this.showHeadCount[selectedSubGrpId] = this.showHeadCount[selectedSubGrpId] - 1

          this.employeeList = Data;
          // console.log(this.bulkplans)

          let employeeBulkCheck = []
          for (let i = 0; i < this.employeeList.length; i++) {
            if (this.employeeList[i].isBulk == true) {
              employeeBulkCheck.push(this.employeeList[i])
            }
          }
          this.showEmployeeValue = employeeBulkCheck.length

          if (this.showEmployeeValue == 0) {
            $("#showBulkEmployeelist").modal('hide');
          }



        }
      });
    }


  }
  deleteemployeeexcelwaddell(admin, index) {
    if (admin.uId && admin.uId > 0) {
      Swal.fire({
        title: this.lang.Alert,
        text: this.lang.Do_you_want_to_delete_this_employee_and_update_head_count,
        showDenyButton: false,
        showCancelButton: true,
        confirmButtonText: this.lang.Proceed
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {



          const Data = this.employeeList;

          const removed = Data.splice(index, 1); // Mutates fruits and returns array of removed items

          this.employeeList = Data;
          let employeeBulkCheck = []

          for (let i = 0; i < this.employeeList.length; i++) {
            if (this.employeeList[i].isBulk == true && this.employeeList[i].bulkPlanLevelId == 34) {
              employeeBulkCheck.push(this.employeeList[i])
            }
          }

          this.deletedId.push(admin.uId);

          let Obj = {
            employees: this.employeeList,
            deletedIds: this.deletedId || [],
          };

          var corporateId = sessionStorage.getItem('corporateId');
          var endPoint =
            '/api/ap/admin/corporate/' + corporateId + '/employeeNew';
          var accessToken = sessionStorage.getItem('accessToken');
          this.http
            .post(environment.apiUrl + endPoint, Obj, {
              headers: {
                Authorization: 'Bearer ' + accessToken,
                'Content-Type': 'application/json',
              },
            })
            .subscribe(
              (response: any) => {
                if (response['status'] == 200) {
                  let employeeBulkCheckfinal = []

                  for (let i = 0; i < response.data.length; i++) {
                    if (response.data[i].isBulk == true && this.employeeList[i].bulkPlanLevelId == 34) {
                      employeeBulkCheckfinal.push(response.data[i])
                    }
                  }

                  this.showEmployeeValue1 = employeeBulkCheckfinal.length
                  if (this.showEmployeeValue1 == 0) {
                    $("#showBulkEmployeelistwaddell").modal('hide');
                  }

                } else {
                  Swal.fire({
                    title: 'Error#' + response.errorCode,
                    text: response.message,
                  });
                }
              },
              (error) => {
                if (
                  error.status == 400 ||
                  error.status == 401 ||
                  error.status == 402 ||
                  error.status == 403
                ) {
                  Swal.fire({
                    title: this.lang.Info,
                    text: error.error.error.message,
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonText: this.lang.Proceed
                  }).then((result) => {
                    /* Read more about isConfirmed, isDenied below */
                    if (result.isConfirmed) {
                      sessionStorage.clear();
                      this.router.navigate(['/login']);
                    } else {
                      sessionStorage.clear();
                      this.router.navigate(['/login']);
                    }
                  });
                } else {
                  // Swal.fire(error.error.error.message)
                  Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
                }
                // this.toastrService.error("Invalid Credentials", 'Error!');
              }
            );

        }
      });
    }
    else {
      Swal.fire({
        title: this.lang.Info,
        text: this.lang.Do_you_want_to_delete_this_employee_and_update_head_count,
        showDenyButton: false,
        showCancelButton: true,
        confirmButtonText: this.lang.Proceed
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {

          const Data = this.employeeList;
          const removed = Data.splice(index, 1); // Mutates fruits and returns array of removed items

          this.employeeList = Data;
          // console.log(this.bulkplans)

          let employeeBulkCheck = []
          for (let i = 0; i < this.employeeList.length; i++) {
            if (this.employeeList[i].isBulk == true) {
              employeeBulkCheck.push(this.employeeList[i])
            }
          }
          this.showEmployeeValue = employeeBulkCheck.length

          if (this.showEmployeeValue == 0) {
            $("#showBulkEmployeelist").modal('hide');
          }



        }
      });
    }


  }

  public selectedBulkPlanId = ""
  clearEmployeeData() {
    this.selectedBulkPlanId = "";
    this.presentMail = "";
    this.addemployeefrom = false;
    this.editemployeefrom = false;

    this.editEmployeeindex = null;

    this.editEmployeeId = "";
    this.editEmployeefirstname = "";
    this.editEmployeelastname = "";
    this.editEmployeeemail = "";
    this.editEmployeephone = "";
    this.editEmployeeStreeAddress = "";
    this.editEmployeeCity = "";
    this.editEmployeeProvicne = "";
    this.editEmployeeposatlCode = "";
    this.editemployeeCountry = null;
    this.editEmployeeResidenetIn = "";

    this.editEmployeeDateofbirth = "";
    this.editEmployeeDateofhire = "";
    this.editEmployeeOccupation = "";
    this.editEmployeesex = null;

    this.editEmployeefamilyStatus = null;

    this.editEmployeeeAnnualIncome = "";
    this.editEmployeeId = "";
    this.UId = "";
    this.isBulk = false;
  }

  editemployeeexcel(admin: any, index: any) {
    $('#editEmployee-modal').modal('show');
    this.clearEmployeeData()

    console.log(admin);
    this.selectedBulkPlanId = admin?.bulkPlanLevelId || ""
    this.presentMail = admin.email;
    this.addemployeefrom = false;
    this.editemployeefrom = true;

    this.editEmployeeindex = index;

    this.editEmployeeId = admin.employeeId;
    this.editEmployeefirstname = admin.firstName;
    this.editEmployeelastname = admin.lastName;
    this.editEmployeeemail = admin.email;
    this.editEmployeephone = admin.phoneNumber;
    this.editEmployeeemail = admin.email;
    this.editEmployeeStreeAddress = admin.streetAddress;
    this.editEmployeeCity = admin.city
    this.editEmployeeProvicne = admin.province;
    this.editEmployeeposatlCode = admin.postalcode;
    this.editemployeeCountry = admin.country ?? '' != '' ? admin.country : null;
    this.editEmployeeResidenetIn = admin.province;

    this.editEmployeeDateofbirth =
      admin.dateOfBirth == '' || admin.dateOfBirth == undefined
        ? ''
        : moment(admin.dateOfBirth).format('MM-DD-YYYY');
    this.editEmployeeDateofbirth =
      admin.dateOfHire == '' || admin.dateOfHire == undefined
        ? ''
        : moment(admin.dateOfHire).format('MM-DD-YYYY');
    this.editEmployeeDateofhire =
      admin.dateOfHire == '' || admin.dateOfHire == undefined
        ? ''
        : moment(admin.dateOfHire).format('MM-DD-YYYY');
    this.editEmployeeOccupation = admin.jobTitle;
    this.editEmployeesex = admin.gender ?? '' != '' ? admin.gender : null;

    this.editEmployeefamilyStatus =
      admin.maritalStatus ?? '' != ''
        ? this.commonPatternsService.textCaptalize(admin.maritalStatus)
        : null;

    this.editEmployeeeAnnualIncome = admin.annualIncome;
    this.editEmployeeId = admin.classificationTier;
    this.UId = admin.uId;
    this.isBulk = admin.isBulk ? true : false;

    this.getprovincelist1(admin.country);
  }
  editemployeetolist() {

    console.log(this.addEmployeeformList.controls)
    if (this.addEmployeeformList.invalid) {
      this.addEmployeeformList.markAllAsTouched();
      return;
    }
    for (let i = 0; i < this.employeeList.length; i++) {
      if (this.addEmployeeformList.value.employeeEmail == this.employeeList[i].email && i !== this.editEmployeeindex) {
        Swal.fire({
          title: this.lang.Error ?? 'Error',
          text: `Duplicate Email Id's Exist`,
          showCancelButton: false,
          showDenyButton: false,
          confirmButtonText: 'ok'
        })
        return
      }
    }

    let editEmailObj = {
      firstName: this.capitalize(
        this.addEmployeeformList.value.employeeFirstName
      ),
      customerId: this.UId,
      employeeId: parseInt(
        this.addEmployeeformList.value.employeeId
          ? this.addEmployeeformList.value.employeeId.toString()
          : ''
      ),
      newEmail: this.addEmployeeformList.value.employeeEmail,
      email: this.presentMail,
    };
    console.log('eddddddEmail', editEmailObj);


    let input = {
      employeeId: this.addEmployeeformList.value.employeeId
        ? this.addEmployeeformList.value.employeeId.toString()
        : '',
      firstName: this.capitalize(
        this.addEmployeeformList.value.employeeFirstName
      ),
      lastName: this.capitalize(
        this.addEmployeeformList.value.employeeLastName
      ),
      email: this.addEmployeeformList.value.employeeEmail,
      jobTitle:
        this.capitalize(this.addEmployeeformList.value.employeeOccupation) ||
        '',
      dateOfHire: this.addEmployeeformList.value.employeeDateofhire || '',
      dateOfBirth: this.addEmployeeformList.value.employeeDateofbirth || '',
      gender: this.addEmployeeformList.value.employeeGender || '',
      workingProvince: this.addEmployeeformList.value.employeeResidence || '',
      maritalStatus: this.addEmployeeformList.value.employeefamilyStatus || '',
      phoneNumber: this.addEmployeeformList.value.employeePhoneno || '',
      provinceId: this.provincelistid || 0,
      workingProvienceId: this.provincelistid || 0,
      country: this.addEmployeeformList.value.employeeCountry || '',
      province: this.addEmployeeformList.value.employeeProvince || '',
      postalCode: this.addEmployeeformList.value.employeePostalCode || '',
      streetAddress: this.addEmployeeformList.value.employeeStreetAddress || '',
      city: this.addEmployeeformList.value.employeeCity || '',
      provinceName: this.addEmployeeformList.value.province || '',
      annualIncome:
        parseInt(this.addEmployeeformList.value.empployeeAnnualIncome) || 0,
      classificationTier:
        parseInt(this.addEmployeeformList.value.employeeTier) || 0,
      uId: this.UId,
      isBulk: this.isBulk,
      bulkPlanLevelId: this.selectedBulkPlanId
      // fuseBillCustomerCreation: true,
    };


    console.log(this.employeeList);
    this.employeeList[this.editEmployeeindex] = input;
    this.addemployeefrom = false;
    this.editemployeefrom = false;
    this.addEmployeeformList.reset();
    console.log(this.addEmployeeformList.controls)
    this.lengthofemployee = this.employeeList.length;
    $('#editEmployee-modal').modal('hide');


  }
  editemployeeexcelwaddell(admin: any, index: any) {
    $('#editEmployeewaddel-modal').modal('show');

    console.log(admin);
    this.addemployeefrom = false;
    this.editemployeefrom = true;
    this.editEmployeeindex = index;
    this.editEmployeeId = admin.employeeId;
    this.editEmployeefirstname = admin.firstName;
    this.editEmployeelastname = admin.lastName;
    this.editEmployeephone = admin.phoneNum;
    this.editEmployeeemail = admin.email;
    this.presentMail = admin.email;
    this.editEmployeeStreeAddress = admin.streetAddress;
    this.editEmployeeCity = admin.city
    this.editEmployeeProvicne = admin.province;
    this.editEmployeeposatlCode = admin.postalCode;


    this.editemployeeCountry = admin.country ?? '' != '' ? admin.country : null;
    this.editEmployeeResidenetIn = admin.province;


    this.editEmployeeId = admin.classificationTier;
    this.UId = admin.uId;
    this.isBulk = admin.isBulk ? true : false;

    // this.getprovincelist1(admin.country);
  }
  editemployeetolistwaddell() {

    if (this.addEmployeeformListwaddell.invalid) {
      this.addEmployeeformListwaddell.markAllAsTouched();
      console.log(this.addEmployeeformListwaddell.controls)
      return;
    }

    for (let i = 0; i < this.employeeList.length; i++) {
      if (this.addEmployeeformList.value.employeeEmail == this.employeeList[i].email && i !== this.editEmployeeindex) {
        Swal.fire({
          title: this.lang.Error ?? 'Error',
          text: `Duplicate Email Id's Exist`,
          showCancelButton: false,
          showDenyButton: false,
          confirmButtonText: 'ok'
        })
        return
      }

    }

    let editEmailObj = {
      firstName: this.capitalize(
        this.addEmployeeformList.value.employeeFirstName
      ),
      customerId: this.UId,
      employeeId: parseInt(
        this.addEmployeeformList.value.employeeId
          ? this.addEmployeeformList.value.employeeId.toString()
          : ''
      ),
      newEmail: this.addEmployeeformList.value.employeeEmail,
      email: this.presentMail,
    };
    console.log('eddddddEmail', editEmailObj);


    let input = {
      employeeId: this.addEmployeeformList.value.employeeId
        ? this.addEmployeeformList.value.employeeId.toString()
        : '',
      firstName: this.capitalize(
        this.addEmployeeformList.value.employeeFirstName
      ),
      lastName: this.capitalize(
        this.addEmployeeformList.value.employeeLastName
      ),
      email: this.addEmployeeformList.value.employeeEmail,
      jobTitle:
        this.capitalize(this.addEmployeeformList.value.employeeOccupation) ||
        '',
      dateOfHire: this.addEmployeeformList.value.employeeDateofhire || '',
      dateOfBirth: this.addEmployeeformList.value.employeeDateofbirth || '',
      gender: this.addEmployeeformList.value.employeeGender || '',
      //residentIn: this.addEmployeeformList.value.employeeResidence || '',
      country: this.addEmployeeformList.value.employeeCountry || '',
      province: this.addEmployeeformList.value.employeeResidence || '',
      workingProvince: this.addEmployeeformList.value.employeeResidence || '',
      maritalStatus: this.addEmployeeformList.value.employeefamilyStatus || '',
      phoneNum: this.addEmployeeformList.value.employeePhoneno || '',
      provinceId: this.provincelistid || 0,
      workingProvienceId: this.provincelistid || 0,
      provinceName: this.addEmployeeformList.value.province || '',
      annualIncome:
        parseInt(this.addEmployeeformList.value.empployeeAnnualIncome) || 0,
      classificationTier:
        parseInt(this.addEmployeeformList.value.employeeTier) || 0,
      uId: this.UId,
      isBulk: this.isBulk,
      bulkPlanLevelId: 34
      // fuseBillCustomerCreation: true,
    };


    console.log(this.employeeList);
    this.employeeList[this.editEmployeeindex] = input;
    this.addemployeefrom = false;
    this.editemployeefrom = false;
    this.addEmployeeformList.reset();
    this.lengthofemployee = this.employeeList.length;
    $('#editEmployeewaddel-modal').modal('hide');


  }
  // onFileChangeExcel(ev: any) {

  //   console.log(ev)
  //   let workBook: any = null;
  //   let jsonData = [];
  //   const reader = new FileReader();

  //   const file = ev.target.files[0];
  //   reader.readAsArrayBuffer(file)
  //   reader.onload = async (event) => {
  //     const data = reader.result;
  //     const wb = await this.excelService.readDataFromExcel(data);
  //     const employeeSheet = wb.getWorksheet(this.excelService.EXCEL_SHEETNAME);
  //     console.log(employeeSheet);
  //     // read first row as data keys
  //     if (employeeSheet) {
  //       let firstRow = employeeSheet.getRow(1);
  //       console.log(firstRow)
  //       if (!firstRow.cellCount) return;
  //       let keys = firstRow.values;
  //       console.log(keys)
  //       let ExceldataError = false
  //       let ExceldataErrorMessage = ''
  //       employeeSheet.eachRow((row, rowNumber) => {
  //         if (rowNumber == 1) return;
  //         let values = row.values;
  //         let obj = {};
  //         //@ts-ignore
  //         //@ts-ignore
  //         for (let i = 1; i < keys.length; i++) {
  //           if(ExceldataError){
  //             break;
  //           }
  //           if(keys[i]){
  //             let value=values[i]
  //             // if(value==""){
  //               this.myFileInput.nativeElement.value = '';

  //             // }
  //             switch(keys[i]){
  //               case "First Name":
  //                 if(value && value !=''){

  //                   if(value.text && value.text.length){
  //                     value= value.text.charAt(0).toUpperCase() + value.text.slice(1)
  //                   }
  //                   else{
  //                     value= value.charAt(0).toUpperCase() + value.slice(1)
  //                   }
  //                 if(value.length <= 3){
  //                   ExceldataError=true;
  //                   ExceldataErrorMessage="First Name must be minimum of 3 characters, please check"
  //                   break;
  //                 }
  //                 }
  //                 else{
  //                   console.log(value)
  //                   ExceldataError =true
  //                   ExceldataErrorMessage = this.lang.First_Name_can_t_be_empty
  //                   break;
  //                 }
  //                 break;
  //                 case "Last Name":
  //                   if(value && value !=''){
  //                     if(value.text && value.text.length){
  //                       value= value.text.charAt(0).toUpperCase() + value.text.slice(1)
  //                     }
  //                     else{
  //                       value= value.charAt(0).toUpperCase() + value.slice(1)
  //                     }
  //                     if(value.length <= 3){
  //                       ExceldataError=true;
  //                       ExceldataErrorMessage="Last Name must be minimum of 3 characters, please check";
  //                       break;
  //                     }
  //                   }
  //                   else{
  //                     ExceldataError =true;
  //                     ExceldataErrorMessage = this.lang.Last_Name_can_t_be_empty
  //                     break;
  //                   }
  //                   break;

  //               case "Email":
  //                 if(value && value !=''){
  //                   // value=value.text
  //                 if(value.text && value.text.length){
  //                   value= value.text.charAt(0).toLowerCase() + value.text.slice(1)
  //                 }
  //                 else{
  //                   value= value.charAt(0).toLowerCase() + value.slice(1)
  //                 }
  //                 // var filter = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  //                 var filter=this.commonPatternsService.emailTestPattern;
  //                 if (!filter.test(value)) {
  //                     // ExceldataemailError =true;
  //                     ExceldataError=true;
  //                     ExceldataErrorMessage="Some fields have invalid email, please check"
  //                 break;
  //                 }

  //                 }
  //                 else{
  //                   ExceldataError =true;
  //                   ExceldataErrorMessage ="Email can't be empty."
  //                   break;
  //                 }
  //               break;
  //             }
  //             obj[keys[i]] = value;
  //           }

  //         }

  //         jsonData.push(obj);
  //       });
  //       if(ExceldataError){

  //         Swal.fire({title:this.lang.Error
  //         ,text:ExceldataErrorMessage
  //       }).then((result) => {
  //         if (result.isConfirmed) {
  //           this.myFileInput.nativeElement.value = '';
  //         }
  //       });
  //         jsonData =[]
  //       }
  //     } else {
  //       //tampered excel error
  //     }

  //     console.log(jsonData);

  //     let uploadEmployeeData = jsonData;

  //     console.log(uploadEmployeeData);
  //   };
  //  // reader.readAsBinaryString(file);
  // }


  deleteEmployee(data) {
    for (let i = 0; i < this.employeeList.length; i++) {
      if (this.employeeList[i].maritalStatus == 'Single') {
        this.employeeList[i].maritalStatus = 'Single';
      }
      if (this.employeeList[i].maritalStatus == 'Couple') {
        this.employeeList[i].maritalStatus = 'Couple';
      }
      if (this.employeeList[i].maritalStatus == 'Family') {
        this.employeeList[i].maritalStatus = 'Family';
      }
    }

    let Obj = {
      employees: data,
      deletedIds: this.deletedId || [],
    };

    var corporateId = sessionStorage.getItem('corporateId');
    var endPoint = '/api/ap/admin/corporate/' + corporateId + '/employeeNew';
    var accessToken = sessionStorage.getItem('accessToken');
    this.http
      .post(environment.apiUrl + endPoint, Obj, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (response: any) => {
          if (response['status'] == 200) {
            this.deletedId = []
            this.employeeList = response.data
            if (
              response.failedEmployeesList &&
              response.failedEmployeesList.length > 0
            ) {

              this.failedEmployeesList = response.failedEmployeesList

              for (let i = 0; i < this.employeeList.length; i++) {
                for (let j = 0; j < response.data.length; j++) {
                  if (this.employeeList[i].email == response.data[j].email) {
                    this.employeeList[i] = response.data[j]
                  }

                }
              }
              this.employeeList = this.employeeList

              // console.log(this.employeeList)

              let array = [];

              for (
                let i = 0;
                i < response.failedEmployeesList.length;
                i++
              ) {
                let obj = {
                  mail: response.failedEmployeesList[i].mailId,
                };
                array.push(response.failedEmployeesList[i].mailId);
                this.message = response.failedEmployeesList[i].message;
              }

              $('#existmail-modal').modal('show');

              console.log(array);
              // var hh = "<br>"+array+"</br>";
              // Swal.fire({
              //   title: 'Info',
              //   html: '' + this.message + ' :<br>' + array + '</br>',
              // });

            }
          } else {
            Swal.fire({
              title: 'Error#' + response.errorCode,
              text: response.message,
            });
          }
        },
        (error) => {
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: this.lang.Error ?? 'Error',
              text: error.error.error.message,
              showCancelButton: false,
              showDenyButton: false,
              confirmButtonText: 'Proceed',
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              } else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            // Swal.fire(error.error.error.message)
            Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
          }
          // this.toastrService.error("Invalid Credentials", 'Error!');
        }
      );
  }

  deleteEmployee1(deletedId) {

    for (let i = 0; i < this.employeeList.length; i++) {
      if (this.employeeList[i].maritalStatus == 'Single') {
        this.employeeList[i].maritalStatus = 'Single';
      }
      if (this.employeeList[i].maritalStatus == 'Couple') {
        this.employeeList[i].maritalStatus = 'Couple';
      }
      if (this.employeeList[i].maritalStatus == 'Family') {
        this.employeeList[i].maritalStatus = 'Family';
      }
    }

    let Obj = {
      employees: [],
      deletedIds: deletedId || [],
    };

    var corporateId = sessionStorage.getItem('corporateId');
    var endPoint = '/api/ap/admin/corporate/' + corporateId + '/employeeNew';
    var accessToken = sessionStorage.getItem('accessToken');
    this.http
      .post(environment.apiUrl + endPoint, Obj, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (response: any) => {
          if (response['status'] == 200) {
            this.deletedId = []
            this.employeeList = response.data
            if (
              response.failedEmployeesList &&
              response.failedEmployeesList.length > 0
            ) {

              this.failedEmployeesList = response.failedEmployeesList

              for (let i = 0; i < this.employeeList.length; i++) {
                for (let j = 0; j < response.data.length; j++) {
                  if (this.employeeList[i].email == response.data[j].email) {
                    this.employeeList[i] = response.data[j]
                  }

                }
              }
              this.employeeList = this.employeeList

              console.log(this.employeeList)

              let array = [];

              for (
                let i = 0;
                i < response.failedEmployeesList.length;
                i++
              ) {
                let obj = {
                  mail: response.failedEmployeesList[i].mailId,
                };
                array.push(response.failedEmployeesList[i].mailId);
                this.message = response.failedEmployeesList[i].message;
              }

              $('#existmail-modal').modal('show');
              this.http.get(environment.apiUrl + '/api/ap/global/set-adminCorporates').subscribe((newResponse) => {
                this.http.post(environment.reportApiUrl + '/websocket/corporate/notification-to-others', {
                  "message": "Corporates information has been updated. Please refresh screen."
                }, {
                  headers: {
                    Authorization: 'Bearer ' + accessToken,
                    'Content-Type': 'application/json',
                  }
                }).subscribe((res) => {
                  console.log({ res })
                })
              })
              console.log(array);
              // var hh = "<br>"+array+"</br>";
              // Swal.fire({
              //   title: this.lang.Info,
              //   html: '' + this.message + ' :<br>' + array + '</br>',
              // });

            }

          } else {
            Swal.fire({
              title: 'Error#' + response.errorCode,
              text: response.message,
            });
          }
        },
        (error) => {
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: this.lang.Error ?? 'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: 'Proceed',
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              } else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            // Swal.fire(error.error.error.message)
            Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
          }
          // this.toastrService.error("Invalid Credentials", 'Error!');
        }
      );
  }


  openPreview() {
    $('#viewPad').modal('show');
  }
  closepopup(id: any) {
    $(`#${id}`).modal('hide');
  }

  updateTotal(index: any, event: any, subgrp: any, count: number) {
    if (count) {
      if (event.target.value < count) {
        if (event.target.value < count) {
          Swal.fire({ title: "Error", text: `${subgrp.name}-required head-count ${count}` })
          this.showHeadCount[subgrp.id] = ""
        }
      }
    }
    this.uploadEmployeeExcelData = []

  }

  updateTotal1(index: any, event: any) {
    if (event.target.value) {
      this.showEmployeeValue1 = event.target.value
    }
    if (!this.showEmployeeValue1) {
      this.headCountmiss1 = true
    }
    else {
      this.headCountmiss1 = false
    }
    this.uploadEmployeeExcelData = []
    //    let val=event.target.value;
    //    let unnitPrice;
    //    if(index==0)
    //    unnitPrice=5
    //   else if(index==1)
    //   unnitPrice=10;
    // else if(index==2)
    // unnitPrice=15;

    //   let subTotal=val*unnitPrice;
    //   let tax=subTotal*0.13;
    //   let total=subTotal+tax;
    //   document.getElementById('tax_'+index).innerHTML="$"+tax.toFixed(2);
    //   document.getElementById('total_'+index).innerHTML="$"+total.toFixed(2);
    //   document.getElementById('subtotal_'+index).innerHTML="$"+subTotal.toFixed(2);
  }

  UploadPad(event1: any) {
    var fileExtension = '.' + event1.target.files[0].name.split('.').pop();
    this.uploadadminlogoimg = event1.target.files[0];
    let file = event1.target.files[0];

    var allowedMimes = [
      'application/pdf',
    ];

    let error = false;

    let message = '';

    if (allowedMimes.includes(file.type)) {
      if (file.size <= 300 * 1024) {
        //300KB

        error = false;
        var reader = new FileReader();
        reader.readAsDataURL(event1.target.files[0]);

        reader.onload = (_event) => {
          this.showdisplayPad = true;
          this.imagedisplayPad = reader.result;
        };
        console.log(this.imagedisplayPad)
      } else {
        error = true;
        message = this.lang.File_size_is_too_large_maximum_file_size_is_300kb;
        // alert(message);
        Swal.fire({ title: 'Info', text: message });
        this.imagedisplayPad = "";
        this.myFileInputPAd.nativeElement.value = '';
      }
    } else {
      error = true;

      message = this.lang.Invalid_file_type_Only_jpg_png_image_pdf_files_are_allowed
      // alert(message);
      Swal.fire({ title: 'Info', text: message });
      this.imagedisplayPad = "";
      this.myFileInputPAd.nativeElement.value = '';
    }
  }
  get emp() {
    return this.addEmployeeformList.controls;
  }

  get empwaddell() {
    return this.addEmployeeformListwaddell.controls;
  }

  public genRandonString(length: any) {
    var chars = "abcdefghijklmnopqrstuvwxyz0123456789";
    var charLength = chars.length;
    var result = "";
    for (var i = 0; i < length; i++) {
      result += chars.charAt(Math.floor(Math.random() * charLength));
    }
    return result;
  }
  alphaNumaricssWithHipen(event: any) {
    const charCode = event.which ? event.which : event.keyCode;

    if (event.currentTarget.value.length == 0) {
      if (
        (charCode >= 65 && charCode <= 90) ||
        (charCode >= 97 && charCode <= 122) ||
        (charCode >= 48 && charCode <= 57) ||
        charCode === 45
      )
        return true;
      else return false;
    } else {
      if (
        (charCode >= 65 && charCode <= 90) ||
        (charCode >= 97 && charCode <= 122) ||
        (charCode >= 48 && charCode <= 57) ||
        charCode === 32 ||
        charCode === 45
      )
        return true;
      else return false;
    }
  }
  textChangeToLowerCase1(formcontrolField: any) {
    this.emp[formcontrolField].setValue(
      this.emp[formcontrolField].value.toLowerCase()
    );
  }
  titleCase(str) {
    var splitStr = str.toLowerCase().split(' ');
    for (var i = 0; i < splitStr.length; i++) {
      // You do not need to check if i is larger than splitStr length, as your for does that for you       // Assign it back to the array       splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);        }   // Directly return the joined string
      return splitStr.join(' ');
    }
  }
}

export function moments(date: string | undefined): moment.Moment {




  if (date)

    return moment((new Date(date)).toJSON())

  else

    return moment();

}
export function postalcodeValidator(control: AbstractControl) {
  var postalRegexp = /^(?!.*[DFIOQU])[A-VXY][0-9][A-Z] ?[0-9][A-Z][0-9]$/gm;
  if (control.value && !postalRegexp.test(control.value)) {
    return { invalidPostalCode: true };
  }
  return null;
}
export function postalcodeValidatorwaddell(control: AbstractControl) {
  var postalRegexp = /^(?!.*[DFIOQU])[A-VXY][0-9][A-Z] ?[0-9][A-Z][0-9]$/gm;
  if (control.value && !postalRegexp.test(control.value)) {
    return { invalidPostalCodewaddell: true };
  }
  return null;
}

// export function postalcodeValidator1(value) {

//   if(value==true){
//     return { invalidpostalcodeprivince: true };
//   }else{
//     return { invalidpostalcodeprivince: false };
//   }

// }
